webpackJsonp([85],{

/***/ 105:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(265)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(214),
  /* template */
  __webpack_require__(287),
  /* scopeId */
  "data-v-f4ef2914",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1055:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fenxiao@3x.4bde715.png";

/***/ }),

/***/ 1056:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAlCAMAAAADS4u8AAAAPFBMVEUAAABFRUVERERGRkZHR0dERERERERERERERERGRkZERERERERERERERERMTExERERERERGRkZFRUVERERxkYSeAAAAE3RSTlMAteYmG9udk4o+9c2AcRDvqDJP6vqDuQAAAKFJREFUOMvd0MEOgjAQhOEpIBQFBeb931U2NIwxdtsj8T9/h53Fj55xg5vkg5yrpWxB3reFnOok0Mt6cgQqbHfIZKMnbyZTg6wjZfPydUjZwZcqyn7LFUrWlWoie1iqlSzYtiF36VpJIhPJ5VM2HjUr2Xp03q0kPAqzp/Sp2QD0JkUDz4Ko2RHr0KFMsUWkCgdY16OZWSV69Vl/9oGQpwFHb8DaE0YVOrQ/AAAAAElFTkSuQmCC"

/***/ }),

/***/ 1057:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAApCAMAAABjq9sOAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABCUExURUxpcRgYGBgYGBgYGCkpKRgYGBgYGBgYGBgYGJ2dnRgYGBgYGBgYGBgYGB4eHhgYGBkZGRkZGRgYGBoaGhoaGhgYGPBMSGIAAAAVdFJOUwDqXMUGifgp1QHfR3O5HJttUKowOpPWQsUAAADBSURBVDjL7ZPJDoMwDEQdsuGEHeb/f7WGSqgYArde2lEOZN6TlUiB6JDO2o5u0iUg3RhRuBixxGcDC1lmvuaLQesA18IsVzwHTI4AchNCPvMxoGdaBeIeYdS8CvDCN4HYI1RqPuC3j00g8kBWAxr6FKjRIxwdhb3Q2QX6plC1tcQroVrLupWrDNhSK6F/1xgooYkSfU1ey9ggScPlM7Bs1anO279wKVj7IDA/COfn8SOCQS7zDLP+6Hfx5LwpY+PdCyPEFd74KgoJAAAAAElFTkSuQmCC"

/***/ }),

/***/ 1063:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(894)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(554),
  /* template */
  __webpack_require__(1093),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 107:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(27);







if (!Function.prototype.bind) {
  Function.prototype.bind = function () {
    var fn = this,
        args = Array.prototype.slice.call(arguments),
        object = args.shift();
    return function () {
      return fn.apply(object, args.concat(Array.prototype.slice.call(arguments)));
    };
  };
}

var Utils = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(null);

Utils.encode = function (_map, _content) {
  _content = '' + _content;
  if (!_map || !_content) {
    return _content || '';
  }
  return _content.replace(_map.r, function ($1) {
    var _result = _map[!_map.i ? $1.toLowerCase() : $1];
    return _result != null ? _result : $1;
  });
};

Utils.escape = function () {
  var _reg = /<br\/?>$/;
  var _map = {
    r: /\<|\>|\&|\r|\n|\s|\'|\"/g,
    '<': '&lt;',
    '>': '&gt;',
    '&': '&amp;',
    ' ': '&nbsp;',
    '"': '&quot;',
    "'": '&#39;',
    '\n': '<br/>',
    '\r': ''
  };
  return function (_content) {
    _content = Utils.encode(_map, _content);
    return _content.replace(_reg, '<br/>');
  };
}();

Utils.object2query = function (obj) {
  var keys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(obj);
  var queryArray = keys.map(function (item) {
    return item + '=' + encodeURIComponent(obj[item]);
  });
  return queryArray.join('&');
};

Utils.mergeObject = function (dest, src) {
  if ((typeof dest === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(dest)) !== 'object' || dest === null) {
    dest = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(null);
  }
  dest = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(null), dest, src);
  return dest;
};

Utils.mergeVueObject = function (dest, src) {
  var keys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(src);
  keys.forEach(function (item) {
    if (typeof src[item] !== 'undefined') {
      __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(dest, item, src[item]);
    }
  });
  return dest;
};

Utils.mapMsgType = function (msg) {
  var map = {
    text: '文本消息',
    image: '图片消息',
    file: '文件消息',
    audio: '语音消息',
    video: '视频消息',
    geo: '地理位置消息',
    tip: '提醒消息',
    custom: '自定义消息',
    notification: '系统通知',
    robot: '机器人消息'
  };
  var type = msg.type;
  return map[type] || '未知消息类型';
};

Utils.stringifyDate = function (datetime) {
  var simple = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var weekMap = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
  datetime = new Date(datetime);
  var year = datetime.getFullYear();
  var simpleYear = datetime.getYear() - 100;
  var month = datetime.getMonth() + 1;
  month = month > 9 ? month : '0' + month;
  var day = datetime.getDate();
  day = day > 9 ? day : '0' + day;
  var hour = datetime.getHours();
  hour = hour > 9 ? hour : '0' + hour;
  var min = datetime.getMinutes();
  min = min > 9 ? min : '0' + min;
  var week = datetime.getDay();
  week = weekMap[week];
  var thatDay = new Date(year, month - 1, day, 0, 0, 0).getTime();

  if (simple) {
    return {
      withYear: day + '/' + month + '/' + simpleYear,
      withMonth: month + '-' + day,
      withDay: '' + week,
      withLastDay: '昨天',
      withHour: hour + ':' + min,
      thatDay: thatDay
    };
  }
  return {
    withYear: year + '-' + month + '-' + day + ' ' + hour + ':' + min,
    withMonth: month + '-' + day + ' ' + hour + ':' + min,
    withDay: week + ' ' + hour + ':' + min,
    withLastDay: '\u6628\u5929 ' + hour + ':' + min,
    withHour: hour + ':' + min,
    thatDay: thatDay
  };
};

Utils.formatDate = function (datetime) {
  var simple = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var tempDate = new Date().getTime();
  var result = this.stringifyDate(datetime, simple);
  var thatDay = result.thatDay;
  var deltaTime = (tempDate - thatDay) / 1000;

  if (deltaTime < 3600 * 24) {
    return result.withHour;
  } else if (deltaTime < 3600 * 24 * 2) {
    return result.withLastDay;
  } else if (deltaTime < 3600 * 24 * 7) {
    return result.withDay;
  } else if (deltaTime < 3600 * 24 * 30) {
    return result.withMonth;
  }
  return result.withYear;
};

Utils.parseSession = function (sessionId) {
  if (/^p2p-/.test(sessionId)) {
    return {
      scene: 'p2p',
      to: sessionId.replace(/^p2p-/, '')
    };
  } else if (/^team-/.test(sessionId)) {
    return {
      scene: 'team',
      to: sessionId.replace(/^team-/, '')
    };
  }
};

Utils.parseCustomMsg = function (msg) {
  if (msg.type === 'custom') {
    try {
      var cnt = JSON.parse(msg.content);
      switch (cnt.type) {
        case 1:
          return '[猜拳消息]';
        case 2:
          return '[阅后即焚]';
        case 3:
          return '[贴图表情]';
        case 4:
          return '[白板消息]';
      }
    } catch (e) {}
    return '[自定义消息]';
  }
  return '';
};

Utils.getFriendAlias = function (userInfo) {
  userInfo.alias = userInfo.alias ? userInfo.alias.trim() : '';
  return userInfo.alias || userInfo.nick || userInfo.account;
};

Utils.generateChatroomSysMsg = function (data) {
  var text = void 0;
  switch (data.attach.type) {
    case 'memberEnter':
      text = '\u6B22\u8FCE' + data.attach.fromNick + '\u8FDB\u5165\u76F4\u64AD\u95F4';
      break;
    case 'memberExit':
      text = data.attach.fromNick + '\u79BB\u5F00\u4E86\u76F4\u64AD\u95F4';
      break;
    case 'blackMember':
      text = (data.attach.toNick[0] || data.attach.to[0]) + '\u88AB\u7BA1\u7406\u5458\u62C9\u5165\u9ED1\u540D\u5355';
      break;
    case 'unblackMember':
      text = (data.attach.toNick[0] || data.attach.to[0]) + '\u88AB\u7BA1\u7406\u5458\u89E3\u9664\u62C9\u9ED1';
      break;
    case 'gagMember':
      text = (data.attach.toNick[0] || data.attach.to[0]) + '\u88AB\u7BA1\u7406\u5458\u7981\u8A00';
      break;
    case 'ungagMember':
      text = (data.attach.toNick[0] || data.attach.to[0]) + '\u88AB\u7BA1\u7406\u5458\u89E3\u9664\u7981\u8A00';
      break;
    case 'addManager':
      text = (data.attach.toNick[0] || data.attach.to[0]) + '\u88AB\u4EFB\u547D\u7BA1\u7406\u5458\u8EAB\u4EFD';
      break;
    case 'removeManager':
      text = (data.attach.toNick[0] || data.attach.to[0]) + '\u88AB\u89E3\u9664\u7BA1\u7406\u5458\u8EAB\u4EFD';
      break;
    case 'addTempMute':
      text = (data.attach.toNick[0] || data.attach.to[0]) + '\u88AB\u7BA1\u7406\u5458\u4E34\u65F6\u7981\u8A00';
      break;
    case 'removeTempMute':
      text = (data.attach.toNick[0] || data.attach.to[0]) + '\u88AB\u7BA1\u7406\u5458\u89E3\u9664\u4E34\u65F6\u7981\u8A00';
      break;
    case 'addCommon':
      text = '管理员添加普通成员';
      break;
    case 'removeCommon':
      text = '管理员删除普通成员';
      break;
    case 'kickMember':
      text = data.attach.toNick[0] + '\u88AB\u7BA1\u7406\u5458\u8E22\u51FA\u623F\u95F4';
      break;

    default:
      text = '通知消息';
      break;
  }
  return text;
};

Utils.generateTeamSysmMsg = function (data) {
  var text = void 0,
      nicks = this.getNickNames(data.attach.users);
  switch (data.attach.type) {
    case 'updateTeam':
      text = this.getTeamUpdateInfo(data);
      break;
    case 'addTeamMembers':
      {
        var op = nicks.pop();
        text = op + '\u9080\u8BF7' + nicks.join() + '\u52A0\u5165\u7FA4';
        break;
      }
    case 'removeTeamMembers':
      {
        var _op = nicks.pop();
        text = nicks.join() + '\u88AB' + _op + '\u79FB\u51FA\u7FA4';
        break;
      }
    case 'acceptTeamInvite':
      {
        var _op2 = nicks.pop();
        text = nicks.join() + '\u63A5\u53D7\u4E86' + _op2 + '\u5165\u7FA4\u9080\u8BF7';
        break;
      }
    case 'passTeamApply':
      {
        var _op3 = nicks.shift();
        if (nicks.length === 1 && _op3 === nicks[0]) {
          text = _op3 + '\u52A0\u5165\u7FA4';
        } else {
          text = _op3 + '\u901A\u8FC7\u4E86' + nicks + '\u5165\u7FA4\u9080\u8BF7';
        }
        break;
      }
    case 'addTeamManagers':
      {
        var _op4 = nicks.pop();
        text = _op4 + '\u65B0\u589E\u4E86' + nicks + '\u4E3A\u7BA1\u7406\u5458';
        break;
      }
    case 'removeTeamManagers':
      {
        var _op5 = nicks.pop();
        text = _op5 + '\u79FB\u9664\u4E86' + nicks + '\u7684\u7BA1\u7406\u5458\u6743\u9650';
        break;
      }
    case 'leaveTeam':
      {
        text = nicks.join() + '\u9000\u51FA\u4E86\u7FA4';
        break;
      }
    case 'dismissTeam':
      {
        text = nicks.join() + '\u89E3\u6563\u4E86\u7FA4';
        break;
      }
    case 'transferTeam':
      {
        var _nicks = this.getNickNames(data.attach.users);
        var _op6 = _nicks.shift();
        text = _op6 + '\u8F6C\u8BA9\u7FA4\u4E3B\u7ED9' + _nicks;
        break;
      }
    case 'updateTeamMute':
      {
        var _nicks2 = this.getNickNames(data.attach.users);
        var _op7 = _nicks2.shift();
        text = _nicks2 + '\u88AB\u7BA1\u7406\u5458' + (data.attach.mute ? '禁言' : '解除禁言');
        break;
      }
    default:
      break;
  }
  return text;
};

Utils.getNickNames = function (users) {
  return users.map(function (user) {
    return user.account === __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].state.userUID ? '你' : user.nick;
  });
};

Utils.getTeamUpdateInfo = function (msg) {
  var text = void 0,
      team = msg.attach.team;
  var op = this.getNickNames(msg.attach.users).pop();
  if (team.name) {
    text = op + '\u4FEE\u6539\u7FA4\u540D\u4E3A' + team.name;
  } else if (team.intro) {
    text = op + '\u4FEE\u6539\u7FA4\u4ECB\u7ECD\u4E3A' + team.intro;
  } else if (team.joinMode) {
      text = '\u7FA4\u8EAB\u4EFD\u9A8C\u8BC1\u6A21\u5F0F\u66F4\u65B0\u4E3A' + (team.joinMode === 'noVerify' ? '不需要验证' : team.joinMode === 'needVerify' ? '需要验证' : '禁止任何人加入');
    } else if (team.inviteMode) {
      text = '\u9080\u8BF7\u4ED6\u4EBA\u6743\u9650\u4E3A' + (team.inviteMode === 'all' ? '所有人' : '管理员');
    } else if (team.updateTeamMode) {
      text = '\u7FA4\u8D44\u6599\u4FEE\u6539\u6743\u9650\u4E3A' + (team.updateTeamMode === 'all' ? '所有人' : '管理员');
    } else if (team.beInviteMode) {
      text = '\u88AB\u9080\u8BF7\u4EBA\u8EAB\u4EFD' + (team.beInviteMode === 'noVerify' ? '不需要验证' : '需要验证');
    } else {
      text = '更新群信息';
    }
  return text;
};

Utils.teamConfigMap = {
  joinMode: {
    noVerify: '不需要验证',
    needVerify: '需要验证',
    rejectAll: '禁止任何人加入'
  },
  beInviteMode: {
    needVerify: '需要验证',
    noVerify: '不需要验证'
  },
  inviteMode: {
    manager: '管理员邀请',
    all: '所有人邀请'
  },
  updateTeamMode: {
    manager: '管理员修改',
    all: '所有人修改'
  },
  memberType: {
    manager: '管理员',
    normal: '普通成员'
  }
};

var MSG_TYPE_SYS = 0;
var MSG_TYPE_IMG = 1;
var MSG_TYPE_VIDEO = 2;
var MSG_TYPE_TIME = 4;
var MSG_TYPE_TEXT = 5;
var MSG_TYPE_TEXT_IMG = 6;

Utils.transNimMsgs = function (msgs) {
  if (!msgs) {
    return null;
  }
  var result = [];
  for (var i = 0; i < msgs.length; i++) {
    var msg = msgs[i];
    var resultObj = Utils.transNimMsg(msg);
    if (resultObj && resultObj.visibleType != 3) {
      result.push(resultObj);
    }
  }
  return result;
};

Utils.transNimMsg = function (msg) {
  if (!msg) {
    return null;
  }
  var result = {};

  var nimType = msg.type;
  result.from = msg.from;
  result.to = msg.to;
  result.time = msg.time;
  result.status = msg.status;
  result.readFlag = !msg.isUnreadable;
  result.idClient = msg.idClient;

  var custom = msg.custom;
  if (custom) {
    try {
      var customJSON = JSON.parse(custom);
      result.questionType = customJSON.questionType;
      result.questionId = customJSON.questionId;
      result.roleType = customJSON.roleType;
      result.expertId = customJSON.expertId;
      result.uid = customJSON.uid;
      result.visibleType = customJSON.visibleType;
    } catch (e) {
      console.log(e);
    }
  }

  if (nimType === 'text') {
    result = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(result, transTextMsg(msg));
  } else if (nimType === 'custom') {
    result = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(result, transCustomMsg(msg));
  } else if (nimType === 'image') {
    result = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(result, transImgMsg(msg));
  } else if (nimType === 'video') {
    result = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(result, transVideoMsg(msg));
  } else if (nimType === 'timeTag') {
    result.msgType = MSG_TYPE_TIME;
    result.text = msg.text;
  }

  if (result && result.visibleType != 3) {
    return result;
  } else {
    return {};
  }
};

function transTextMsg(msg) {
  var result = {};
  result.msgType = MSG_TYPE_TEXT;
  result.text = msg.text;
  return result;
}

function transCustomMsg(msg) {
  var result = {};
  var content = msg.content,
      custom = msg.custom;

  if (content) {
    try {
      var jsonContent = JSON.parse(content);
      var url = jsonContent.url,
          dur = jsonContent.dur;

      var _JSON$parse = JSON.parse(custom),
          msgType = _JSON$parse.msgType;

      if (msgType === 50 || msgType === '50') {
        result.msgType = MSG_TYPE_SYS;
        result.text = jsonContent.msg;
      } else if (msgType === 26 || msgType === '26') {
        result.msgType = MSG_TYPE_VIDEO;
        result.url = url;
        result.dur = dur;
      } else if (msgType === 20 || msgType === '20') {
        result.msgType = MSG_TYPE_TEXT_IMG;
        result.text = jsonContent.content;
        var attachments = jsonContent.attachments;
        var urls = [];
        if (attachments && attachments.length > 0) {
          for (var i = 0; i < attachments.length; i++) {
            urls.push(attachments[i].url);
          }
        }
        result.urls = urls;
      }
    } catch (e) {
      console.log(e);
    }
  }
  return result;
}

function transImgMsg(msg) {
  var result = {};
  result.msgType = MSG_TYPE_IMG;
  result.url = msg.file.url;
  return result;
}

function transVideoMsg(msg) {
  var result = {};
  result.msgType = MSG_TYPE_VIDEO;
  result.url = msg.file.url;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (Utils);

/***/ }),

/***/ 1081:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-page"
  }, [_c('HeaderTpl', {
    attrs: {
      "title": '开讲',
      "backTrack": 'djk-kj-home_back'
    }
  }), _vm._v(" "), (_vm.catagoryList && _vm.catagoryList.length > 0) ? [_c('div', {
    staticClass: "nav-wap"
  }, [_c('ul', {
    staticClass: "nav-list",
    attrs: {
      "data-track": "djk-kj-home_category_click"
    }
  }, _vm._l((_vm.catagoryList), function(item, index) {
    return _c('li', {
      staticClass: "nav-item",
      class: {
        'cur': (!_vm.currentCatagoryId && index === 0) || item.id == _vm.currentCatagoryId
      },
      on: {
        "click": function($event) {
          _vm.switchTab(item, index)
        }
      }
    }, [_vm._v(_vm._s(item.name) + "\n        ")])
  })), _vm._v(" "), _c('div', {
    staticClass: "navdown",
    attrs: {
      "data-track": "djk-kj-home_category_unfold"
    },
    on: {
      "click": function($event) {
        _vm.showNavBox = true
      }
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.showNavBox) ? [_c('div', {
    staticClass: "nav-box"
  }, [_c('div', {
    staticClass: "nav-box-head"
  }, [_c('p', [_vm._v("\n          全部分类\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "navhide",
    attrs: {
      "data-track": "djk-kj-home_category_fold"
    },
    on: {
      "click": function($event) {
        _vm.showNavBox = false
      }
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "nav-box-list",
    attrs: {
      "data-track": "djk-kj-home_category_click"
    }
  }, _vm._l((_vm.catagoryList), function(item, index) {
    return _c('li', [_c('a', {
      class: item.id == _vm.currentCatagoryId ? 'on' : '',
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.switchTab(item, index)
        }
      }
    }, [_vm._v(_vm._s(item.name))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "mask",
    on: {
      "touchend": function($event) {
        _vm.showNavBox = false
      }
    }
  })] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "course-wap"
  }, [(_vm.error) ? _c('div', {
    staticClass: "netError"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(478),
      "alt": "网络出错"
    }
  }), _vm._v(" "), _c('p', [_vm._v("网络出错")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:location.reload();"
    }
  }, [_vm._v("刷新重试")])]) : [(!_vm.courseList || _vm.courseList.length <= 0) ? _c('div', {
    staticClass: "empty_wrap"
  }, [_vm._m(0)]) : _vm._l((_vm.courseList), function(item) {
    return [(item) ? _c('div', {
      staticClass: "course"
    }, [
      [_c('div', {
        staticClass: "tit"
      }, [_vm._v("\n            " + _vm._s(item.statsDesc) + "\n            "), (item.startStatus == 2) ? _c('i', [_vm._v(" | 可以继续畅听")]) : _vm._e()]), _vm._v(" "), _c('ul', {
        staticClass: "course-list"
      }, _vm._l((item.list), function(classitem) {
        return _c('li', {
          attrs: {
            "data-id": classitem.id
          },
          on: {
            "click": function($event) {
              _vm.goToClass(classitem)
            }
          }
        }, [_c('div', {
          staticClass: "video-box"
        }, [_c('img', {
          attrs: {
            "src": classitem.picture
          }
        }), _vm._v(" "), (item.startStatus == 1) ? _c('p', {
          staticClass: "video-status processing"
        }, [_c('i'), _c('span', [_vm._v("进行中")])]) : (item.startStatus == 0) ? _c('p', {
          staticClass: "video-status start"
        }, [(classitem.time) ? [_c('span', [_vm._v(_vm._s(classitem.time))])] : [(classitem.countTime) ? _c('i') : _vm._e(), _c('span', [_vm._v(_vm._s(classitem.countTime ? classitem.countTime : ''))])]], 2) : (item.startStatus == 2) ? _c('p', {
          staticClass: "video-status"
        }, [_c('span', {
          staticClass: "go-on"
        }, [_vm._v("继续畅听")])]) : _vm._e()]), _vm._v(" "), _c('div', {
          staticClass: "info"
        }, [_c('p', {
          staticClass: "tit-info"
        }, [(classitem.type === 2) ? _c('span', {
          staticClass: "serial-icon"
        }) : _vm._e(), _vm._v(_vm._s(classitem.name))]), _vm._v(" "), _c('p', {
          staticClass: "expert"
        }, [_vm._v("\n                  " + _vm._s(classitem.expertName) + "  " + _vm._s(classitem.expertTitle) + "\n                ")]), _vm._v(" "), _c('p', {
          staticClass: "price-join"
        }, [(classitem.hasBuy) ? _c('span', {
          staticClass: "hasbug-icon"
        }) : _vm._e(), _vm._v(" "), (!classitem.hasBuy) ? _c('span', {
          staticClass: "price"
        }, [_vm._v("￥" + _vm._s(classitem.price))]) : _vm._e(), _vm._v(" "), (!classitem.hasBuy) ? _c('del', {
          staticClass: "old-price"
        }, [_vm._v("￥" + _vm._s(classitem.lastPrice))]) : _vm._e(), _vm._v(" "), _c('ScoreLabel', {
          attrs: {
            "data": classitem.pointDTO,
            "type": "list"
          }
        }), _vm._v(" "), (classitem.joinNum >= 10) ? _c('span', {
          staticClass: "join-cont"
        }, [_vm._v(_vm._s(classitem.joinNum) + "人参加")]) : _vm._e()], 1)])])
      }))]
    ], 2) : _vm._e()]
  }), _vm._v(" "), (_vm.courseList && _vm.courseList.length > 0) ? _c('div', {
    staticClass: "show-none"
  }, [_vm._v("\n        ── " + _vm._s(_vm.isBottom ? '已经到底啦' : '加载中') + " ──\n      ")]) : _vm._e()]], 2), _vm._v(" "), _c('loading', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('GoTop'), _vm._v(" "), _c('AdTip')], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "empty"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(475),
      "alt": "暂时没有课程"
    }
  }), _vm._v(" "), _c('p', [_vm._v("暂无课程~")])])
}]}

/***/ }),

/***/ 1085:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show && !_vm.isExpert && _vm.showAd) ? _c('div', {
    staticClass: "adtip"
  }, [_c('span', {
    staticClass: "close",
    attrs: {
      "data-track": "djk_kj_download_close"
    },
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "right",
    on: {
      "click": _vm.download
    }
  }, [_c('div', {
    staticClass: "go",
    attrs: {
      "data-track": "djk_kj_download_go"
    }
  }, [_c('h2', [_vm._v("宝宝树孕育")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.msg))])]), _vm._v(" "), _c('span', {
    staticClass: "download"
  }, [_vm._v("立即下载")])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 1087:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gotop",
    style: ({
      display: _vm.show ? 'block' : 'none'
    }),
    on: {
      "click": _vm.goTop
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 1092:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "header-wap"
  }, [(_vm.showBack) ? _c('div', {
    staticClass: "back-box",
    attrs: {
      "data-track": _vm.backTrack
    },
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  }, [_c('img', {
    staticClass: "back",
    attrs: {
      "src": __webpack_require__(476)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.showHome) ? _c('div', {
    staticClass: "home-box",
    attrs: {
      "data-track": _vm.homeTrack ? _vm.homeTrack : 'djk_kj_lessons_kjhomepage'
    },
    on: {
      "click": function($event) {
        _vm.goHome()
      }
    }
  }, [_c('img', {
    staticClass: "home",
    attrs: {
      "src": __webpack_require__(1056)
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    class: [_vm.showBack ? 'tit' : 'tit tit-w1'],
    style: (_vm.showHome ? 'width:52%' : '')
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.showUser) ? _c('div', {
    staticClass: "user-box",
    attrs: {
      "data-track": "djk-kj-home_personalcenter"
    },
    on: {
      "click": function($event) {
        _vm.goMy()
      }
    }
  }, [_c('img', {
    staticClass: "user",
    attrs: {
      "src": __webpack_require__(477)
    }
  })]) : (_vm.isFenXiao) ? _c('div', {
    staticClass: "broker-box",
    on: {
      "click": function($event) {
        _vm.goBroker()
      }
    }
  }, [_c('img', {
    staticClass: "broker",
    attrs: {
      "src": __webpack_require__(1055)
    }
  }), _vm._v(" "), (_vm.showPrice) ? _c('p', {
    staticClass: "explain"
  }, [_vm._v("分享赚￥" + _vm._s(_vm.course.distributionPrice))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showSubmitBtn) ? _c('div', {
    staticClass: "submit-box",
    on: {
      "click": _vm.bindSubmit
    }
  }, [_c('div', {
    staticClass: "submit-btn"
  }, [_vm._v("提交")])]) : _vm._e(), _vm._v(" "), (_vm.isFenXiao && _vm.shareMask && _vm.showMask) ? _c('div', {
    staticClass: "fenxiao-mask",
    on: {
      "click": _vm.hideMask
    }
  }, [_c('img', {
    staticClass: "fenxiao-image",
    attrs: {
      "src": _vm.shareMask
    }
  }), _vm._v(" "), _c('p', [_vm._v("长按保存图片并将图片发送给好友")])]) : _vm._e(), _vm._v(" "), (_vm.showShare) ? _c('div', {
    staticClass: "share-box",
    on: {
      "click": _vm.bindShare
    }
  }, [_c('img', {
    staticClass: "share",
    attrs: {
      "src": __webpack_require__(1057)
    }
  })]) : _vm._e()]), _vm._v(" "), _c('AdTip')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1093:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pswp",
    attrs: {
      "tabindex": "-1",
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "pswp__bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "pswp__scroll-wrap"
  }, [_c('div', {
    staticClass: "pswp__container"
  }, [_c('div', {
    staticClass: "pswp__item"
  }), _vm._v(" "), _c('div', {
    staticClass: "pswp__item"
  }), _vm._v(" "), _c('div', {
    staticClass: "pswp__item"
  })]), _vm._v(" "), _c('div', {
    staticClass: "pswp__ui pswp__ui--hidden"
  }, [_c('div', {
    staticClass: "pswp__top-bar"
  }, [_c('div', {
    staticClass: "pswp__counter"
  }), _vm._v(" "), _c('button', {
    staticClass: "pswp__button pswp__button--close",
    attrs: {
      "title": "Close (Esc)"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "pswp__button pswp__button--share",
    attrs: {
      "title": "Share"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "pswp__button pswp__button--fs",
    attrs: {
      "title": "Toggle fullscreen"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "pswp__button pswp__button--zoom",
    attrs: {
      "title": "Zoom in/out"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pswp__preloader"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(479)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "pswp__share-modal pswp__share-modal--hidden pswp__single-tap"
  }, [_c('div', {
    staticClass: "pswp__share-tooltip"
  })]), _vm._v(" "), _c('button', {
    staticClass: "pswp__button pswp__button--arrow--left",
    attrs: {
      "title": "Previous (arrow left)"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "pswp__button pswp__button--arrow--right",
    attrs: {
      "title": "Next (arrow right)"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pswp__caption"
  }, [_c('div', {
    staticClass: "pswp__caption__center"
  })])])])])
}]}

/***/ }),

/***/ 1096:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.data) ? _c('span', {
    staticClass: "score-label"
  }, [_vm._v("\n    " + _vm._s(_vm.desc) + "\n  ")]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 1100:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1104:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAABICAMAAAB2pt2UAAAAclBMVEUAAAAAeeMAhO4AeuUAeeMAeeMAeeMAeeMAeuQAe+QAfOUAeeMAeeMAeuMAe+QAeeIAeeMAeeMAeeMAfecAeeIAeeMAeuMAeeL///9KoOtYp+wji+bu9v0Nf+TL5PmQxfJ7ufBkre3c7Pu82/ep0fU6l+ha/dNBAAAAF3RSTlMAjw0417Fp5FNEIMO8Xiz0zKWcFet+dtyeRFQAAAJHSURBVFjDzZdZoqMgEEUBEedZU6QT8+b9b7HTCQZ9QCF+9fklh8CtEpQYDCeaEjt1FREPdd8AwMk6VgFAkWJ2FMODxDo6PsZ45bIZBUB8BorWvos0AYVj/TEsUGbGVsICd+yR9bCQRL9ze/15mREnOW1AIbZrbxa7JijDK6NutYcJnowV8VIX8KR4TbDM2TOyh6rZTnCybollp75sOW/Lbkrz7RK4KuRjAqHWHm2auIANnK6HWazS+hed+sHqL7IYLHCx2p4q5V1KnoODbuICHCRiPYHynyO52SQmqnV16J3qSq1HI+BMepe0ekTVJXG+6SOcnriZYAclc+m9X9alMqGwE87sx5PBfLuBjdii15bozlKewcbJ0BkHkz8uHzLzcAryx2GrZxDmA936PNSHeq2nEOx3a78N9yHXegSY70+gP+KP2h99Pt4DGWC+fwPTMZ8vfnHMh0H5Dep7AxjgoC909XEfDzD1+ngLV0G+eQwJzH9D/NLnX6SU37PPr8DJ+Srl7eJZfwpuLp9SXn/w/CJAmL+klB9o/QZAeZOuFIV+fDE+pJRfM/IAl4Dzc0/x05Ii23vtXm73FI1OavXx52P+llK+Ow/AEby8m2XIgm7u8/XXAhLj/Ma5nN03WAHh5Nj95acja9pgv9YyngDW+5ouTE8Y9v7iJzK/bZoAXWjvSA3642+v+rvDhO7UB+JA7NFjRpxkTVDhTerEmzwOQ0MoauKljl02r8guos4WQ6FtL0zEzVaechJIVNGuLNoypiJj5D/lL71iBaMDt+5cAAAAAElFTkSuQmCC"

/***/ }),

/***/ 1105:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAAA8CAMAAADlopxrAAAAWlBMVEUAAAD/UlL/UlL/UlL/UlL/UlL/U1P/UlL/UlL/UlL/UlL/VVX/UlL/UlL/V1f/U1P/UlL/UlL/////qan/l5f/bGz/8/P/4OD/Xl7/V1f/enr/zs7/u7v/iIg8QvS5AAAAEXRSTlMAWvDjy7o2hOmpbAz42RxjSw6ceAUAAAEQSURBVEjH7ddpboMwEIbhIWB2SD3eMIH7X7NCoBLyz/NVatXmPcAjWTBeaGusilonV6u2o6P2poXlH7tQaaBsE+4aqS+JupuGKohaDVaSQomKapRQpNGKf0FMbsKINTBzsFFOGN4Ls5RY+atlkhGBz7yVEDNferh0wvJLJqYShl8LDibYzzDBfoIJXnDC4wS7X0FEmHhomJhhwmiUsOiYBacTifUKeJs+7NFfPsUk2bXMCfhVtvHFcNk6JYSOy76GGTmKnDXW/fyB+CbSiRwlGsIvjd9xde1qTFBElEFCX6KPif54kGTitQwlHXWtGm7JDU1Gf7IyS2+8CHfpP3FWCCfsqUY4YU+NKk9uaDra+gTMoulUgbXdZgAAAABJRU5ErkJggg=="

/***/ }),

/***/ 1106:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMAAAABACAMAAAB7sojtAAAApVBMVEUAAAD/8eD/8+H/8+H/////8uD/8d//8uD/8eD/8uD/8d/6fQD9u3f9yI/8qVX6jiH+1qv/58v8rVr9v4D/69T9v33+yZL7lS39xor8sGH8pk3+0qL+27X6gQb/7tj/8Nz/6dD6iBT8pUz6jBv6hAz9tm37mDT/3rn/5cb/4b/+2bD9uXL7nj7+zpr8s2f7mzj6ihj9woX+0J77oUX7kif7o0j7n0GqFZ8dAAAACnRSTlMAlI8rBdXyvfPU7WaHDAAABIFJREFUaN7s1mtvokAYhmHUapPnEc9yWDkpW8Aa27qt/f8/bQcPLEwI7BpQSPb6NHyZzE3eISixXrc/QMsM+t2ecvbUQUt1nk7nf0ZrPccFrX3/sY6Yf7RaT+mi1bpKH63WV1r3/cwaKGi5/wH/qI0BDupzlwDTHi9Rk6oDplaGh5hPqqhNeUA0KnFAYskMDUJIMkIOTy2zrSQgZIkfxQFDcnzbxjQeEeAHF/4lICDNGwO0SgKmwyKBHDDHxfB8AI/kPn/jWZERyWkFAWXMsgCV5PcmbYm/sSLfIblXgOs4bhJwpGyDNBcpURRdnzfxVrI7Bajk6hpgFd4ZYaZrSYPzZ2w8O2+CHhAQkON5ylEKWJEcGw7kgEP+BN0YsDeM7W0BYslfSFlKAdY3BX8vB+jkvLoAnTRuClh8kAEKAoTXTwrHKBPgfYlVAwLeSE6QNpQDBEsn+fOQChCiPR4fsLPJIwBVW6QCRpC5Q5tcZgKEBgSYNtceAJ+2lRfwMgpxFuq628AAbR4vYJFrF2e7VMCE5OcrTtwp6g04LPLNCgOwh/BCmsgJ0HwK7yFO6g0oUBhw8pW6ySJmhivHGFMwPZxNSS6aF7AlfWQDEq72QXKtJjO1RvMCduQOCCeIvck/196MyVQdyABA7ZdYVhLwu12zW1IUBsLo7Wx/CujAoGIEhjCKIuDP+P6PthISEZRlLygZqubcGS3IaewmSbUObOgTtkr6OVVxAt+7rwg/TcAAYqIYWMo5JlTD3FJBDIRE/QvMKgKa2NB8yP/+9F9zzMR9+hcYAetyR8YR5O8oDr6qCCyNOg4AqzYW9SEwByY3gRCwZOjHxfPYkUDH/zDtQ2ABuErA4+CitG+BmMR3o58nsDErAil8UgJJEfHVclZssU63df5Fr+EDCOqDu5cIhCw+3gnoOCuBPcD2o8UZggNR3Hgp9+vpAdJLBKZAUgp4QKwEYtyTEqWNpz3vkHfpQWAhE5WWlrWkj6LQbC0rogQCP04+ogCYkN10SrThAPjOI+pB4KsSVg3YkmtSzj7VdmNjot6zB9IBh54Q6RDw0OtBIMunfMOHT+5nuqIajm+tyJc/rWFwAOFFKCSTVwuYlVXwDJiSBsR1AzcfYED0eIGQQVSrrcgZNt90L7CjZo736+U1A475EL5desAD4JGksrFheYhKBa9TgQtgUzOfwDdJVmfAdsVzgEYP7AFOFVZjG1d8hyRGiiv83e1QYA5AO06espnFAA4qwieAR3QlFKN1TsClUntCHzlTj0qML1w5O90JGGiBybxzsrKYawDbVk9wzQSARYrlzobAruf1WGidoq4ESGuZ/6F8UtBUZupA5qkk4n4WBLiimypzMhScDHrAnDMALDE7EqBxmqEBZk+j8o3M3ssAMyxk6BMo/FuwzUx8njeEeZ0CYE5HAu3IOZ3XVDLSVCIaeuBzzrI0NO8TWk9qwa8XpzG10LEArau1v6WQRG3xaI//b6tB/wxfYPANTwNvOfsz/Ka/wbddDr7xdfitx4Nv/i7a799oYLzJ9vu/IWoitPnsKJQAAAAASUVORK5CYII="

/***/ }),

/***/ 1107:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAAAtBAMAAADcoWFIAAAAFVBMVEUAAACMjIyIiIiIiIiJiYmIiIiIiIjeJZqWAAAABnRSTlMAJeX0PdWouqMGAAAApUlEQVRIx43MsQkCARTA0C84wOkGWriAh7WgMziA4u0/gmUaIUmZ4s3utU7r8V1md/ncp7S/vZeZ47Y2ejvNgBcaPNDgiQZ3GrzS4E6DOw1eaXCnwZ12HNpx6IpDOw7tOLTj0BWHdhzacWjHoSsO7Ti049COQ1cc2nFox6Edh644tOPQjkM7Dh1xaMehEw5dcOiCP6EDfoUO+AYdcOiCn6FDh//7B96wPUy+83YwAAAAAElFTkSuQmCC"

/***/ }),

/***/ 1108:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 112:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return healthSign; });
/* unused harmony export noop */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_auth__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__comm_middleware_callApi__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__comm_api_apis__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__comm_middleware_reportLog__ = __webpack_require__(62);








var healthSign = function healthSign(_ref, _ref2) {
  var state = _ref.state,
      commit = _ref.commit;
  var _ref2$userType = _ref2.userType,
      userType = _ref2$userType === undefined ? 'expert' : _ref2$userType,
      token = _ref2.token;

  console.log('用户信息');
  console.log(userType === 'expert' ? state.expertInfo : state.userInfo);
  if (!token) {
    token = userType === 'expert' ? state.expertInfo.token : state.userInfo.token;
  }
  var param = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
    oem: window.navigator.userAgent,
    osversion: '9.0',
    screenwidth: window.screen.width,
    screenheight: window.screen.height,
    apptype: '1',
    appversion: '2.0.0',
    nettype: 'unknown',
    regcode: '250',
    provcode: '264',
    partner: 'babytree',
    isHttps: document.location.protocol === 'https:' ? '1' : '0',
    token: token
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__comm_middleware_callApi__["b" /* postApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_4__comm_api_apis__["a" /* default */].healthSign, param).then(function (body) {
    if (body && body.rescode && body.rescode.code === '-100') {
      __WEBPACK_IMPORTED_MODULE_2__lib_auth__["a" /* default */].clear();
      __WEBPACK_IMPORTED_MODULE_2__lib_auth__["a" /* default */].login(userType);
    }
    commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["_11" /* AJAX_GET_SIGNDATA */], { signData: body });
  })['catch'](function (err) {
    var msg = {
      name: '大健康签名失败',
      protocol: document.location.protocol === 'https:' ? 'https' : 'http',
      info: err,
      time: Date.parse(new Date()),
      user: userType === 'expert' ? state.expertInfo : state.userInfo,
      url: location.href
    };
    if (err.message === 'SERVER_ERROR') {
      __WEBPACK_IMPORTED_MODULE_2__lib_auth__["a" /* default */].clear();
      __WEBPACK_IMPORTED_MODULE_2__lib_auth__["a" /* default */].login(userType, null);
    }
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__comm_middleware_reportLog__["a" /* default */])(msg).then(function () {
      console.log('日志-大健康签名失败');
    });
  });
};

var noop = function noop() {};

/***/ }),

/***/ 113:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export formatMsg */
/* harmony export (immutable) */ __webpack_exports__["a"] = onRoamingMsgs;
/* harmony export (immutable) */ __webpack_exports__["b"] = onOfflineMsgs;
/* harmony export (immutable) */ __webpack_exports__["c"] = onMsg;
/* unused harmony export onRevocateMsg */
/* harmony export (immutable) */ __webpack_exports__["h"] = revocateMsg;
/* harmony export (immutable) */ __webpack_exports__["i"] = updateLocalMsg;
/* harmony export (immutable) */ __webpack_exports__["f"] = sendFormatMsg;
/* harmony export (immutable) */ __webpack_exports__["d"] = sendMsg;
/* unused harmony export resendMsg */
/* harmony export (immutable) */ __webpack_exports__["e"] = sendFileMsg;
/* unused harmony export sendRobotMsg */
/* harmony export (immutable) */ __webpack_exports__["g"] = sendMsgReceipt;
/* harmony export (immutable) */ __webpack_exports__["j"] = getHistoryMsgs;
/* unused harmony export resetNoMoreHistoryMsgs */
/* unused harmony export continueRobotMsg */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3____ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mutation_types__ = __webpack_require__(23);








function formatMsg(msg) {
  var nim = __WEBPACK_IMPORTED_MODULE_3____["a" /* default */].state.nim;
  if (msg.type === 'robot') {
    if (msg.content && msg.content.flag === 'bot') {
      if (msg.content.message) {
        msg.content.message = msg.content.message.map(function (item) {
          switch (item.type) {
            case 'template':
              item.content = nim.parseRobotTemplate(item.content);
              break;
            case 'text':
            case 'image':
            case 'answer':
              break;
          }
          return item;
        });
      }
    }
  }
  return msg;
}

function onRoamingMsgs(obj) {
  var msgs = obj.msgs.map(function (msg) {
    return formatMsg(msg);
  });
  __WEBPACK_IMPORTED_MODULE_3____["a" /* default */].commit('updateMsgs', msgs);
}

function onOfflineMsgs(obj) {
  var msgs = obj.msgs.map(function (msg) {
    return formatMsg(msg);
  });
  __WEBPACK_IMPORTED_MODULE_3____["a" /* default */].commit('updateMsgs', msgs);
}

function onMsg(msg) {
  msg = formatMsg(msg);
  __WEBPACK_IMPORTED_MODULE_3____["a" /* default */].commit('putMsg', msg);
  if (msg.sessionId === __WEBPACK_IMPORTED_MODULE_3____["a" /* default */].state.currSessionId) {
    __WEBPACK_IMPORTED_MODULE_3____["a" /* default */].commit('updateCurrSessionMsgs', {
      type: 'put',
      msg: msg
    });

    __WEBPACK_IMPORTED_MODULE_3____["a" /* default */].dispatch('sendMsgReceipt');
  }
  if (msg.scene === 'team' && msg.type === 'notification') {
    __WEBPACK_IMPORTED_MODULE_3____["a" /* default */].dispatch('onTeamNotificationMsg', msg);
  }
}

function onSendMsgDone(error, msg) {
  if (error) {
    if (error.code === 7101) {
      msg.status = 'success';
      alert(error.message);
    } else {
      alert(error.message);
    }
  }
  onMsg(msg);
}

function onRevocateMsg(error, msg) {
  var nim = __WEBPACK_IMPORTED_MODULE_3____["a" /* default */].state.nim;
  if (error) {
    if (error.code === 508) {
      alert('发送时间超过2分钟的消息，不能被撤回');
    } else {
      alert(error);
    }
    return;
  }
  var tip = '';
  if (msg.from === __WEBPACK_IMPORTED_MODULE_3____["a" /* default */].state.userUID) {
    tip = '你撤回了一条消息';
  } else {
    var userInfo = __WEBPACK_IMPORTED_MODULE_3____["a" /* default */].state.userInfos[msg.from];
    if (userInfo) {
      tip = __WEBPACK_IMPORTED_MODULE_5__utils__["a" /* default */].getFriendAlias(userInfo) + '\u64A4\u56DE\u4E86\u4E00\u6761\u6D88\u606F';
    } else {
      tip = '对方撤回了一条消息';
    }
  }
  nim.sendTipMsg({
    isLocal: true,
    scene: msg.scene,
    to: msg.to,
    tip: tip,
    time: msg.time,
    done: function sendTipMsgDone(error, tipMsg) {
      var idClient = msg.deletedIdClient || msg.idClient;
      __WEBPACK_IMPORTED_MODULE_3____["a" /* default */].commit('replaceMsg', {
        sessionId: msg.sessionId,
        idClient: idClient,
        msg: tipMsg
      });
      if (msg.sessionId === __WEBPACK_IMPORTED_MODULE_3____["a" /* default */].state.currSessionId) {
        __WEBPACK_IMPORTED_MODULE_3____["a" /* default */].commit('updateCurrSessionMsgs', {
          type: 'replace',
          idClient: idClient,
          msg: tipMsg
        });
      }
    }
  });
}

function revocateMsg(_ref, msg) {
  var state = _ref.state,
      commit = _ref.commit;

  var nim = state.nim;
  var _msg = msg,
      idClient = _msg.idClient;

  msg = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(msg, state.msgsMap[idClient]);
  nim.deleteMsg({
    msg: msg,
    done: function deleteMsgDone(error) {
      onRevocateMsg(error, msg);
    }
  });
}
function updateLocalMsg(_ref2, msg) {
  var state = _ref2.state,
      commit = _ref2.commit;

  __WEBPACK_IMPORTED_MODULE_3____["a" /* default */].commit('updateCurrSessionMsgs', {
    type: 'replace',
    idClient: msg.idClient,
    msg: msg
  });
  state.nim.updateLocalMsg({
    idClient: msg.idClient,
    localCustom: msg.localCustom
  });
  __WEBPACK_IMPORTED_MODULE_3____["a" /* default */].commit('replaceMsg', {
    sessionId: msg.sessionId,
    idClient: msg.idClient,
    msg: msg
  });
}

function sendFormatMsg(_ref3, formatMsg) {
  var state = _ref3.state,
      commit = _ref3.commit;
  var msgType = formatMsg.msgType,
      to = formatMsg.to,
      text = formatMsg.text,
      url = formatMsg.url,
      dur = formatMsg.dur,
      fileInput = formatMsg.fileInput,
      questionId = formatMsg.questionId,
      scene = formatMsg.scene,
      expertId = formatMsg.expertId,
      uid = formatMsg.uid;

  var obj = {};
  obj.scene = scene;
  obj.custom = {
    questionType: 1,
    objectType: 1,
    roleType: 1,
    questionId: parseInt(questionId),
    expertId: parseInt(expertId),
    uid: uid,
    visibleType: 1
  };
  obj.pushContent = '您咨询的专家有新回复啦';
  obj.pushPayload = {
    v2u: 'bbtsp://com.stardoctor.patient/xx_platform/message_list?questionId=' + questionId
  };
  obj.to = to;
  if (msgType === 1) {
    obj.fileInput = fileInput;
    obj.custom.msgType = 2;
    return sendFileMsg({ state: state, commit: commit }, obj);
  } else if (msgType === 2) {
    obj.type = 'custom';
    obj.content = { url: url, dur: parseInt(dur), msgType: 26 };
    obj.custom.msgType = 26;
    return sendMsg({ state: state, commit: commit }, obj);
  } else if (msgType === 5) {
    obj.type = 'text';
    obj.text = text;
    obj.custom.msgType = 1;
    return sendMsg({ state: state, commit: commit }, obj);
  }
}

function sendMsg(_ref4, obj) {
  var state = _ref4.state,
      commit = _ref4.commit;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var nim = state.nim;
    obj = obj || {};
    var type = obj.type || '';

    switch (type) {
      case 'text':
        nim.sendText({
          scene: obj.scene,
          to: obj.to,
          text: obj.text,
          pushContent: obj.pushContent,
          pushPayload: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj.pushPayload),
          done: function done(error, msg) {
            onSendMsgDone(error, msg);
            if (error) {
              reject(error);
            } else {
              resolve(msg);
            }
          },
          custom: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj.custom),
          needMsgReceipt: obj.needMsgReceipt || false
        });
        break;
      case 'custom':
        nim.sendCustomMsg({
          scene: obj.scene,
          to: obj.to,
          pushContent: obj.pushContent,
          pushPayload: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj.pushPayload),
          custom: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj.custom),
          content: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj.content),
          done: function done(error, msg) {
            onSendMsgDone(error, msg);
            if (error) {
              reject(error);
            } else {
              resolve(msg);
            }
          }
        });
    }
  });
}

function resendMsg(_ref5, msg) {
  var state = _ref5.state,
      commit = _ref5.commit;

  var nim = state.nim;
  nim.resendMsg({
    msg: msg,
    done: onSendMsgDone
  });
}

function sendFileMsg(_ref6, obj) {
  var state = _ref6.state,
      commit = _ref6.commit;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var nim = state.nim;
    commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["t" /* AJAX_LOADING */], { loadingStatus: true });
    var type = obj.type,
        fileInput = obj.fileInput,
        custom = obj.custom,
        pushPayload = obj.pushPayload;

    if (!type) {
      type = 'file';
      if (/\.(png|jpg|bmp|jpeg|gif)$/i.test(fileInput.value)) {
        type = 'image';
      } else if (/\.(mov|mp4|ogg|webm)$/i.test(fileInput.value)) {
        type = 'video';
      }
    }
    if (custom) {
      obj.custom = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj.custom);
    }
    if (pushPayload) {
      obj.pushPayload = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj.pushPayload);
    }

    var data = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({
      type: type,
      uploadprogress: function uploadprogress(data) {},
      uploaderror: function uploaderror() {
        fileInput.value = '';
        console && console.log('上传失败');
        commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["t" /* AJAX_LOADING */], { loadingStatus: false });
        commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["a" /* AJAX_ERROR */], new Error('上传失败'));
      },
      uploaddone: function uploaddone(error, file) {
        fileInput.value = '';
        commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["t" /* AJAX_LOADING */], { loadingStatus: false });
      },
      beforesend: function beforesend(msg) {},
      done: function done(error, msg) {
        onSendMsgDone(error, msg);
        if (error) {
          reject(error);
        } else {
          resolve(msg);
        }
        commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["t" /* AJAX_LOADING */], { loadingStatus: false });
      }
    }, obj);
    nim.sendFile(data);
  });
}

function sendRobotMsg(_ref7, obj) {
  var state = _ref7.state,
      commit = _ref7.commit;

  var nim = state.nim;
  var type = obj.type,
      scene = obj.scene,
      to = obj.to,
      robotAccid = obj.robotAccid,
      content = obj.content,
      params = obj.params,
      target = obj.target,
      body = obj.body;

  scene = scene || 'p2p';
  if (type === 'text') {
    nim.sendRobotMsg({
      scene: scene,
      to: to,
      robotAccid: robotAccid || to,
      content: {
        type: 'text',
        content: content
      },
      body: body,
      done: onSendMsgDone
    });
  } else if (type === 'welcome') {
    nim.sendRobotMsg({
      scene: scene,
      to: to,
      robotAccid: robotAccid || to,
      content: {
        type: 'welcome'
      },
      body: body,
      done: onSendMsgDone
    });
  } else if (type === 'link') {
    nim.sendRobotMsg({
      scene: scene,
      to: to,
      robotAccid: robotAccid || to,
      content: {
        type: 'link',
        params: params,
        target: target
      },
      body: body,
      done: onSendMsgDone
    });
  }
}

function sendMsgReceipt(_ref8) {
  var state = _ref8.state,
      commit = _ref8.commit;

  var currSessionId = __WEBPACK_IMPORTED_MODULE_3____["a" /* default */].state.currSessionId;
  if (currSessionId) {
    if (__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* default */].parseSession(currSessionId).scene === 'p2p') {
      var msgs = __WEBPACK_IMPORTED_MODULE_3____["a" /* default */].state.currSessionMsgs;
      var nim = state.nim;
      if (state.sessionMap[currSessionId]) {
        nim.sendMsgReceipt({
          msg: state.sessionMap[currSessionId].lastMsg,
          done: function sendMsgReceiptDone(error, obj) {}
        });
      }
    }
  }
}

function sendMsgReceiptDone(error, obj) {
  console.log('\u53D1\u9001\u6D88\u606F\u5DF2\u8BFB\u56DE\u6267' + (!error ? '成功' : '失败'), error, obj);
}

function getHistoryMsgs(_ref9, obj) {
  var state = _ref9.state,
      commit = _ref9.commit;

  var nim = state.nim;
  if (nim) {
    var scene = obj.scene,
        to = obj.to;

    var options = {
      scene: scene,
      to: to,
      reverse: false,
      asc: true,
      limit: __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].localMsglimit || 20,
      done: function getHistoryMsgsDone(error, obj) {
        if (obj.msgs) {
          if (obj.msgs.length === 0) {
            commit('setNoMoreHistoryMsgs');
          } else {
            var msgs = obj.msgs.map(function (msg) {
              return formatMsg(msg);
            });
            commit('updateCurrSessionMsgs', {
              type: 'concat',
              msgs: msgs
            });
          }
        }
      }
    };
    if (state.currSessionLastMsg) {
      options = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(options, {
        lastMsgId: state.currSessionLastMsg.idServer,
        endTime: state.currSessionLastMsg.time
      });
    }

    nim.getHistoryMsgs(options);
  }
}

function resetNoMoreHistoryMsgs(_ref10) {
  var commit = _ref10.commit;

  commit('resetNoMoreHistoryMsgs');
}

function continueRobotMsg(_ref11, robotAccid) {
  var commit = _ref11.commit;

  commit('continueRobotMsg', robotAccid);
}

/***/ }),

/***/ 130:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 131:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 14:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scholarships__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dayima__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__freeClinic__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__knowing__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__nim__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__expertAnswer__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lighthouse__ = __webpack_require__(183);













/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
  courseRecommend: '/newapi/router/health-recommend/recommend',
  recommendFree: '/newapi/bigHealth/course/recommendFree',
  freeTinyCourseList: '/newapi/bigHealth/bbt/freeTinyCourseList',
  courseList: '/newapi/bigHealth/expert/courses',
  historyMessage: '/newapi/bigHealth/message/poll',
  pictureList: '/newapi/bigHealth/expert/materiallist',
  deletePicture: '/newapi/bigHealth/expert/deletemateriallist',
  movePicture: '/newapi/bigHealth/expert/movematerial',
  uploadImage: '/newapi/bigHealth/expert/addmaterials',
  wxSign: '/mobile/weixin/ticket.htm',
  expertAuth: '/mobile/weixin/healthLogin.htm',
  queryUserMemberInfo: '/newapi/router/memberInfo/queryUserMemberInfo',
  courseInfo: '/newapi/bigHealth/course/detail',
  newCourseInfo: '/newapi/router/health-courseDetail/detailBaseInfo',
  courseDetail: '/newapi/router/health-courseDetail/detail',
  courseClose: '/newapi/bigHealth/course2/endCourse',
  addComment: '/newapi/router/health-comment/addCommentGenApi',
  issues: '/newapi/bigHealth/message/questionlist',
  buy: '/newapi/bigHealth/order/buy',
  pay: '/newapi/bigHealth/order/pay',
  order: '/newapi/bigHealth/order/getpreorderinfo',
  jxjOrder: '/newapi/router/healthOrder/getJXJPreOrderInfo',
  wxAuth: '/mobile/weixin/authorization.htm',
  wxAuthFx: '/newapi/passport/weixin/getWeixinUserOpenId',
  healthSign: '/mobile/user/getHealthSignByToken.htm',
  getCatagoryUrl: '/newapi/bigHealth/course/catagory',
  indexListUrl: '/newapi/bigHealth/course/list',
  courseLike: '/newapi/bigHealth/course2/like',
  xwCourseLike: '/newapi/bigHealth/course/tinyCourseLike',
  messageLike: '/newapi/bigHealth/message/like',
  UserCourses: '/newapi/bigHealth/my/courses',
  myCourse: '/newapi/router/health-myCourse/myCourseList',
  combinecourses: '/newapi/bigHealth/my/combinecourses',
  userIssues: '/newapi/bigHealth/message/myquestion',
  verifycode: '/mobile/user/smsverifycode.htm',
  bindMobile: '/mobile/weixin/binding.htm',
  expertSlides: '/newapi/bigHealth/course2/materials',
  postLog: '/newapi/bigHealth/log',
  hotLabel: '/newapi/bigHealth/course/hotLabeList',
  treeCoin: '/newapi/bigHealth/my/shubi',
  treeCoinList: '/newapi/bigHealth/my/shubilist',
  queryBalance: '/newapi/router/shubi/queryShubiBalance',
  queryBalanceDetail: '/newapi/router/shubi/queryShubiSchedule',
  tags: '/newapi/bigHealth/course/labelpage',
  tagsSubject: '/newapi/bigHealth/course/labelsubject',
  myTinyCourses: '/newapi/bigHealth/my/tinycourses',
  serialList: '/newapi/router/health-courseList/serialList',
  serialdetail: '/newapi/bigHealth/course/serialdetail',
  combineList: '/newapi/router/health-courseList/combineList',
  querybycode: '/newapi/bigHealth/order/querybycode',
  getStatus: '/mobile/account/querypayidres.htm',
  freeList: '/newapi/router/health-expertFree/freeList',
  courseRemind: '/newapi/router/health-homePageV2/courseRemind',
  homePage: '/newapi/router/health-homePageV2/homePageV2',
  recommend: '/newapi/router/health-homePageV2/recommendForUser',
  indexModuleList: '/newapi/router/health-module/getModuleList',
  auditionList: '/newapi/router/health-serialCourse/subCourseList',
  columndetail: '/newapi/router/health-courseForApp/serialDetailGenApi',
  subCourseList: '/newapi/router/health-serialCourse/subCourseList',
  childDetail: '/newapi/router/health-courseForApp/subscriptionLeafCourseDetail',
  columnList: '/newapi/router/health-courseForApp/tinyCourseListGenApi',
  setLeaveMessage: '/newapi/router/health-userguestbook/insert',
  myGuestBooks: '/newapi/router/health-userguestbook/myGuestBooks',
  delGuest: '/newapi/router/health-userguestbook/delete',
  messageList: '/newapi/router/health-guestbook/list',
  giveThumbsup: '/newapi/bigHealth/fitness/giveTheThumbsup',
  courseExperts: '/newapi/router/health-courseExperts/courseExperts',
  expertsLabel: '/newapi/router/health-courseExperts/courseExperts',
  classifyLabel: '/newapi/router/health-courseLabel/courseLabelList',
  myIncome: '/newapi/router/health-distribution/myDistributionProfit',
  courseShareImage: '/newapi/router/health-courseShare/courseShareImage',
  expertCourseList: '/newapi/router/health-expertCourse/expertCourseList',
  delMsgReply: '/newapi/router/health-gbreply/delete',
  replyMsg: '/newapi/router/health-gbreply/reply',
  constantData: '/newapi/router/memberData/getConstantData',
  memberFreeCourse: '/newapi/router/health-memberCourse/freeCourseForMember',
  queryCertificateType: '/newapi/router/passport/config/queryCertificateType',
  commentTags: '/newapi/router/health-comment/getCourseCommentTags',
  getCourseComments: '/newapi/router/health-comment/getCourseComments',
  getCourseAudioUrl: '/newapi/router/health-audios/getCourseAudioUrl',
  channelModule: '/newapi/router/health-channel/getChannelModuleList',
  channelRecommend: '/newapi/router/health-channel/getChannelRecommendList',
  getCategoryList: '/newapi/router/health-channel/getFrontCategoryList',
  adByCodes: '/newapi/router/cms/advertise/findAdvertiseByCodes',
  courseRankList: '/newapi/router/courseRank/getCourseRankList',
  wyethCourse: '/newapi/router/course/vip/getCourseListForVip',
  wyethLogin: '/newapi/router/ua/account/login',
  getAuthToken: '/openapi/getTokenByLoginString'
}, __WEBPACK_IMPORTED_MODULE_1__scholarships__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__dayima__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__freeClinic__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__knowing__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__nim__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__expertAnswer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__lighthouse__["a" /* default */]));

/***/ }),

/***/ 15:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = updateLoginInfo2;
/* harmony export (immutable) */ __webpack_exports__["a"] = getApi;
/* harmony export (immutable) */ __webpack_exports__["b"] = postApi;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isBoolean__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isBoolean___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isBoolean__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_merge__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_merge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_auth__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api__ = __webpack_require__(46);








window.ajaxHeader = { token: null };

function updateLoginInfo2(_ref) {
  var _ref$token = _ref.token,
      token = _ref$token === undefined ? null : _ref$token,
      userInfo = _ref.userInfo;

  if (token) {
    if (window.ajaxHeader) {
      window.ajaxHeader.token = token;
      window.ajaxHeader.encUserId = userInfo ? userInfo.encUserId : null;
    } else {
      window.ajaxHeader = {
        token: token,
        encUserId: userInfo ? userInfo.encUserId : null
      };
    }
  }
  if (window.localStorage) {
    window.localStorage.setItem('token', token);
    if (userInfo) {
      window.localStorage.setItem('userinfo', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(userInfo));
    }
  }
}

function callApi() {
  var post = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var _ref2 = arguments[1];
  var commit = _ref2.commit;
  var api = arguments[2];
  var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var showLoading = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
  var showError = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : true;

  if (__WEBPACK_IMPORTED_MODULE_2_lodash_isBoolean___default()(params)) {
    showLoading = params;
    params = {};
  } else if (__WEBPACK_IMPORTED_MODULE_2_lodash_isBoolean___default()(options)) {
    showLoading = options;
    options = {};
  }
  if (showLoading) {
    commit(__WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["t" /* AJAX_LOADING */], { loadingStatus: true });
  }

  options = __WEBPACK_IMPORTED_MODULE_3_lodash_merge___default()({}, options, { headers: { token: window.ajaxHeader.token } });
  var respPromise = null;

  if (post) {
    respPromise = __WEBPACK_IMPORTED_MODULE_6__api__["a" /* instance */].post(api, params, options);
  } else {
    respPromise = __WEBPACK_IMPORTED_MODULE_6__api__["a" /* instance */].get(api, params, options);
  }

  return respPromise.then(function (resp) {
    if (showLoading) {
      commit(__WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["t" /* AJAX_LOADING */], { loadingStatus: false });
    }
    var ok = resp.ok,
        problem = resp.problem,
        url = resp.config.url,
        data = resp.data;

    var ajaxMobile = url.indexOf('/mobile') !== -1;

    if (ok) {
      if (ajaxMobile) {
        if (data.rescode && data.rescode.code !== '0') {
          if (showError) {
            commit(__WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["a" /* AJAX_ERROR */], new Error(data.rescode.info));
          }
          if (data.rescode.code === '-100') {
            __WEBPACK_IMPORTED_MODULE_4__lib_auth__["a" /* default */].clear();
          }
          if (data.rescode.info == '该手机号已绑定' || data.rescode.info == '微信已绑定过其他手机') {
            __WEBPACK_IMPORTED_MODULE_4__lib_auth__["a" /* default */].clear();
            setTimeout(function () {
              location.href = '//m.meitun.com/live/';
            }, 3000);
          }
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(data);
        } else if (data.resultInfo && data.resultInfo.code !== 0) {
          if (showError) {
            commit(__WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["a" /* AJAX_ERROR */], new Error(data.resultInfo.message));
          }
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(data);
        }
      } else if (data.rtn_code !== '0') {
        if (showError) {
          commit(__WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["a" /* AJAX_ERROR */], new Error(data.rtn_msg));
        }
        if (data.rtn_code === '0000002') {}
        console.error(data, api, params);
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(data);
      }
    } else {
      if (showError) {
        commit(__WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["a" /* AJAX_ERROR */], new Error(problem));
      }

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error(problem));
    }

    return data;
  });
}
function getApi() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return callApi.apply(undefined, [false].concat(args));
}

function postApi() {
  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  return callApi.apply(undefined, [true].concat(args));
}

/* unused harmony default export */ var _unused_webpack_default_export = ({
  get: getApi,
  post: postApi
});

/***/ }),

/***/ 179:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  bindExpert: '/newapi/router/health-expert-bind/bindV2',
  checkExpert: '/newapi/router/health-expert-check/checkV2',
  proList: '/mobile/home/getprovlist.htm',
  areaList: '/mobile/home/getarealist.htm',
  authentication: '/newapi/router/user/authentication',
  mtUploadPic: '/mobile/system/uploadpictures.htm?imagewidth=120&imageheight=120',
  getCountryInfo: '/newapi/router/base-district/getCountryInfo' });

/***/ }),

/***/ 180:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  getQuestionList: '/newapi/router/expert-qa-question/getQuestionsForExpert',
  expertJobSetting: '/newapi/router/expert-jobSetting/expertJobSetting',
  updateExpertModify: '/newapi/router/expert-weiixin/expertModify',
  qusetionDialog: '/newapi/router/question/dialog/findDialogMsgPage',
  questionInfo: '/newapi/router/question/dialog/findBusinessQuestionInfo',
  bindDialog: '/newapi/router/question/dialog/saveBusinessPreMsg',
  saveQuestionStatus: '/newapi/router/question/order/saveQuestionStatus',
  expertInfo: '/newapi/router/health-experth5/queryExpertInfo',
  settleInfo: '/newapi/router/health-experth5/settleInfo',
  yearParam: '/newapi/router/health-experth5/getSettleYearParam',
  settleList: '/newapi/router/health-experth5/settleList',
  orderDetail: '/newapi/router/health-experth5/fetchSettleBillOrderDetail' });

/***/ }),

/***/ 181:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  getIndexInfo: '/mapi/dayima-zjyz-banner/queryActivityInfo',
  getFreeClinicExpert: '/mapi/dayima-zjyz-banner/queryExpertInfo',
  getVoteRankInfo: '/mapi/dayima-zjyz-banner/queryQuestionVoteRankingInfo',
  getUserActivityInfo: '/mapi/dayima-zjyz-banner/queryUserActivityInfo',
  canFreeAuditQues: '/mapi/dayima-questions/canFreeAuditQues',
  questionSubmit: '/mapi/dayima-zjyz-question/voluntaryQuestionSubmit',
  getConsultDetail: '/mapi/dayima-zjyz-question/voluntaryQuestionDetailInfo',
  vote: '/mapi/dayima-zjyz-vote/questionVote',
  myConsultList: '/mapi/dayima-user/myQuestionList',
  getBaseInfo: '/mapi/dayima-expert/getBaseInfo',
  babayTreeUploadImg: '/mobile/up/img',
  babayTreeUploadImgbase64: '/mobile/up/base64/img',
  getUserLoginStr: '/newapi/router/user/getUserLoginStr' });

/***/ }),

/***/ 182:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  weeklyDetail: '/newapi/router/weekly/detail',
  weeklyList: '/newapi/router/health-weeklylist/getWeeklyList',
  shareDetail: '/newapi/router/weekly/sharedetail',
  getShareWeekly: '/newapi/router/health-weekly/getShareWeekly',
  getWeeklyCombos: '/newapi/router/healthCombo/getWeeklyCombos',
  getWeeklyAudioUrl: '/newapi/router/health-zkaudio/getAudioUrl',
  updateMediaPlayLog: '/newapi/router/health-zkaudio/updateMediaPlayLog',
  buyNow: '/newapi/router/cart/buyNow',
  submitorder: '/newapi/shopping/morder/submitorder',
  detail4payment: '/newapi/order/detail4payment',
  getPayWayList: '/newapi/pay/account/paywaylist',
  getSDKInfo: '/newapi/pay/account/getSDKInfo',
  getCanBuyList: '/newapi/router/health-weeklylist/getCanBuyList',
  getWeeklyRight: '/newapi/router/health-wy-genWeekly/genWeeklyApi',
  geIndexInfo: '/newapi/router/health-wy-home/homePage',
  sign: '/newapi/router/weekly/sign',
  confirmExchange: '/newapi/router/health-exchange/confirmExchange',
  getItemMsg: '/newapi/router/health-exchange/getItemMsg',
  prePayWayList: '/newapi/router/payment/prePayWayList'
});

/***/ }),

/***/ 183:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  getIncome: '/newapi/router/ecommerce/lighthouse/earnIncomeList',
  getMyIncome: '/newapi/router/ecommerce/lighthouse/homeCenter',
  getInvite: '/newapi/router/ecommerce/invite/distributionInvitations',
  lightForPreOrder: '/newapi/router/ecommerce/csorder/getPreOrderInfo',
  lightSubmitOrder: '/newapi/router/ecommerce/csorder/submitOrder',
  getMyOrders: '/newapi/router/ecommerce/lighthouse/myOrders',
  getExamInfo: '/newapi/router/ecommerce/mylisten/getExamInfo',
  submitExam: '/newapi/router/ecommerce/mylisten/submitExam',
  adByCodes: '/newapi/router/cms/advertise/findAdvertiseByCodes',
  getHomePage: '/newapi/router/vipcom/light/homePage',
  getMyCourse: '/newapi/router/ecommerce/mylisten/getMyCourses',
  getHomeCoupon: '/newapi/router/ecommerce/lighthouse/grantVoucher',
  getShareMaterial: '/newapi/router/ecommerce/invite/shareMaterial',
  lightCourseDetail: '/newapi/router/health-lighthouse/courseDetail',
  simpleSubCourse: '/newapi/router/health-commonDetail/simpleSubCourse',
  getLighthouseCourseDetail: '/newapi/router/health-lighthouse/courseDetail',
  getLighthouseCourseList: '/newapi/router/health-lighthouse/subCourseList',
  topicCountInfo: '/newapi/router/ecommerce/lighthouse/activityCountInfo',
  topicGroupInfo: '/newapi/router/ecommerce/lighthouse/activityInstanceInfo',
  orderTipList: '/newapi/router/ecommerce/lighthouse/activityOrderTipList',
  coursePrice: '/newapi/router/ecommerce/lighthouse/coursePrice',
  myCoupon: '/newapi/router/ecommerce/coupon/myCoupon',
  skuList: '/newapi/router/ecommerce/coupon/skuList',
  saveOpenId: '/newapi/router/vipcom/light/saveOpenId' });

/***/ }),

/***/ 184:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  getNimToken: '//m.meitun.com/newapi/router/expert-weiixin/getExpertBaseInfo',
  getRecord: '/newapi/router/expert-media/getMediaPath' });

/***/ }),

/***/ 185:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  getAdverts: '/newapi/router/health-heathAd/getAdverForVip',
  getScholarshipDetail: '/newapi/router/jxj/getDetail',
  updateRemind: '/newapi/router/jxj/updateRemind',
  getAdvertsGeneral: '/newapi/router/health-heathAd/getAdverts',
  getScholarshipsList: '/newapi/router/jxj/listJxjActivity',
  getcertificate: '/newapi/wallet/account/authentication/getcertificate',
  getVerifySend: '/newapi/wallet/account/verify/send',
  getVerifyValid: '/newapi/wallet/account/verify/valid',
  getVerified: '/newapi/wallet/account/authentication/identityauthentication',
  sendPlayDuration: '/newapi/bigHealth/course/play',
  getMyListJxjActivity: '/newapi/router/jxj/myListJxjActivity',
  getUserPhone: '/newapi/router/user/getUserInfo',
  getIconList: '/newapi/router/health-jxjPunch/getPunchCards',
  getJxjCollectLikes: 'newapi/router/health-jxjLikes/getJxjCollectLikes',
  getJxjStartLikes: 'newapi/router/health-jxjLikes/startJxjCollectLikes',
  getJxjDoLikes: 'newapi/router/health-jxjLikes/doJxjCollectLikes',
  getPunchCardShare: 'newapi/router/health-jxjPunch/punchCardShare',
  getPunchCard: 'newapi/router/health-jxjPunch/punchCard',
  secretToken: '/newapi/router/health-jxjPunch/jxjUserToken' });

/***/ }),

/***/ 186:
/***/ (function(module, exports) {

module.exports = {
  ajaxPrefix: '//m.meitun.com',
  otherAjaxPrefix: '//msit.meitun.com',
  babytreeAjaxPrefix: '//9.babytree-test.com',
  babytreeLoginPrefix: '//m.9.babytree-test.com',
  IMappKey: '0c30bfdb0776ebf6d554dfb27b44a478',
  IMAjaxPrefix: '//mapiweb.babytree-test.com',
  IMDebug: true,
  localMsglimit: 36
};

/***/ }),

/***/ 187:
/***/ (function(module, exports) {

module.exports = {
  ajaxPrefix: '//m.meitun.com',
  otherAjaxPrefix: '//babytree.citv.cn',
  babytreeAjaxPrefix: '//www.babytree.com',
  babytreeLoginPrefix: '//m.babytree.com',
  IMappKey: 'e853a0c3dcbf69f6c320d60bb072f6e3',
  IMAjaxPrefix: '//mapiweb.babytree.com',
  IMDebug: false,
  localMsglimit: 36
};

/***/ }),

/***/ 188:
/***/ (function(module, exports) {

module.exports = {
  ajaxPrefix: '//m.meitun.com',
  otherAjaxPrefix: '//msit.meitun.com',
  babytreeAjaxPrefix: '//9.babytree-test.com',
  babytreeLoginPrefix: '//m.9.babytree-test.com',
  IMappKey: '0c30bfdb0776ebf6d554dfb27b44a478',
  IMAjaxPrefix: '//mapiweb.babytree-test.com',
  IMDebug: true,
  localMsglimit: 36
};

/***/ }),

/***/ 189:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_properties__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_properties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_properties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_prevent_extensions__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_prevent_extensions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_prevent_extensions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_is_extensible__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_is_extensible___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_is_extensible__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_symbol__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_get_own_property_names__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_get_own_property_names___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_get_own_property_names__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_get_own_property_symbols__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_get_own_property_symbols___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_get_own_property_symbols__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_create__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_json_stringify__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_keys__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_define_property__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_babel_runtime_helpers_typeof__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_babel_runtime_helpers_typeof__);
















!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_15_babel_runtime_helpers_typeof___default()(exports)) && "object" == ( false ? "undefined" : __WEBPACK_IMPORTED_MODULE_15_babel_runtime_helpers_typeof___default()(module)) ? module.exports = t() : "function" == typeof define && __webpack_require__(453) ? define([], t) : "object" == (typeof exports === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_15_babel_runtime_helpers_typeof___default()(exports)) ? exports.NIM = t() : e.NIM = t();
}(window, function () {
  return function (e) {
    var t = {};function n(r) {
      if (t[r]) return t[r].exports;var s = t[r] = { i: r, l: !1, exports: {} };return e[r].call(s.exports, s, s.exports, n), s.l = !0, s.exports;
    }return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_define_property___default()(e, t, { configurable: !1, enumerable: !0, get: r });
    }, n.r = function (e) {
      Object.defineProperty(e, "__esModule", { value: !0 });
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e["default"];
      } : function () {
        return e;
      };return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 449);
  }([function (e, t, n) {
    "use strict";
    var r,
        s = n(9),
        i = (r = s) && r.__esModule ? r : { default: r };var o = n(73),
        a = n(68);n(87);var c,
        u,
        l = n(12),
        m = l.getGlobal(),
        d = /\s+/;l.deduplicate = function (e) {
      var t = [];return e.forEach(function (e) {
        -1 === t.indexOf(e) && t.push(e);
      }), t;
    }, l.capFirstLetter = function (e) {
      return e ? (e = "" + e).slice(0, 1).toUpperCase() + e.slice(1) : "";
    }, l.guid = (c = function c() {
      return (65536 * (1 + Math.random()) | 0).toString(16).substring(1);
    }, function () {
      return c() + c() + c() + c() + c() + c() + c() + c();
    }), l.extend = function (e, t, n) {
      for (var r in t) {
        void 0 !== e[r] && !0 !== n || (e[r] = t[r]);
      }
    }, l.filterObj = function (e, t) {
      var n = {};return l.isString(t) && (t = t.split(d)), t.forEach(function (t) {
        e.hasOwnProperty(t) && (n[t] = e[t]);
      }), n;
    }, l.copy = function (e, t) {
      return t = t || {}, e ? (__WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_keys___default()(e).forEach(function (n) {
        l.exist(e[n]) && (t[n] = e[n]);
      }), t) : t;
    }, l.copyWithNull = function (e, t) {
      return t = t || {}, e ? (__WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_keys___default()(e).forEach(function (n) {
        (l.exist(e[n]) || l.isnull(e[n])) && (t[n] = e[n]);
      }), t) : t;
    }, l.findObjIndexInArray = function (e, t) {
      e = e || [];var n = t.keyPath || "id",
          r = -1;return e.some(function (e, s) {
        if (a(e, n) === t.value) return r = s, !0;
      }), r;
    }, l.findObjInArray = function (e, t) {
      var n = l.findObjIndexInArray(e, t);return -1 === n ? null : e[n];
    }, l.mergeObjArray = function () {
      var e = [],
          t = [].slice.call(arguments, 0, -1),
          n = arguments[arguments.length - 1];l.isArray(n) && (t.push(n), n = {});var r,
          s = n.keyPath = n.keyPath || "id";for (n.sortPath = n.sortPath || s; !e.length && t.length;) {
        e = (e = t.shift() || []).slice(0);
      }return t.forEach(function (t) {
        t && t.forEach(function (t) {
          -1 !== (r = l.findObjIndexInArray(e, { keyPath: s, value: a(t, s) })) ? e[r] = l.merge({}, e[r], t) : e.push(t);
        });
      }), n.notSort || (e = l.sortObjArray(e, n)), e;
    }, l.cutObjArray = function (e) {
      var t = e.slice(0),
          n = arguments.length,
          r = [].slice.call(arguments, 1, n - 1),
          s = arguments[n - 1];l.isObject(s) || (r.push(s), s = {});var i,
          o = s.keyPath = s.keyPath || "id";return r.forEach(function (e) {
        l.isArray(e) || (e = [e]), e.forEach(function (e) {
          e && (s.value = a(e, o), -1 !== (i = l.findObjIndexInArray(t, s)) && t.splice(i, 1));
        });
      }), t;
    }, l.sortObjArray = function (e, t) {
      var n = (t = t || {}).sortPath || "id";o.insensitive = !!t.insensitive;var r,
          s,
          i,
          c = !!t.desc;return i = l.isFunction(t.compare) ? t.compare : function (e, t) {
        return r = a(e, n), s = a(t, n), c ? o(s, r) : o(r, s);
      }, e.sort(i);
    }, l.emptyFunc = function () {}, l.isEmptyFunc = function (e) {
      return e === l.emptyFunc;
    }, l.notEmptyFunc = function (e) {
      return e !== l.emptyFunc;
    }, l.splice = function (e, t, n) {
      return [].splice.call(e, t, n);
    }, l.reshape2d = function (e, t) {
      if (Array.isArray(e)) {
        l.verifyParamType("type", t, "number", "util::reshape2d");var n = e.length;if (n <= t) return [e];for (var r = Math.ceil(n / t), s = [], i = 0; i < r; i++) {
          s.push(e.slice(i * t, (i + 1) * t));
        }return s;
      }return e;
    }, l.flatten2d = function (e) {
      if (Array.isArray(e)) {
        var t = [];return e.forEach(function (e) {
          t = t.concat(e);
        }), t;
      }return e;
    }, l.dropArrayDuplicates = function (e) {
      if (Array.isArray(e)) {
        for (var t = {}, n = []; e.length > 0;) {
          t[e.shift()] = !0;
        }for (var r in t) {
          !0 === t[r] && n.push(r);
        }return n;
      }return e;
    }, l.onError = function (e) {
      throw new function (e) {
        "object" === (void 0 === e ? "undefined" : (0, i["default"])(e)) ? (this.callFunc = e.callFunc || null, this.message = e.message || "UNKNOW ERROR") : this.message = e, this.time = new Date(), this.timetag = +this.time;
      }(e);
    }, l.verifyParamPresent = function (e, t, n, r) {
      n = n || "";var s = !1;switch (l.typeOf(t)) {case "undefined":case "null":
          s = !0;break;case "string":
          "" === t && (s = !0);break;case "StrStrMap":case "object":
          __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_keys___default()(t).length || (s = !0);break;case "array":
          t.length ? t.some(function (e) {
            if (l.notexist(e)) return s = !0, !0;
          }) : s = !0;}s && l.onParamAbsent(n + e, r);
    }, l.onParamAbsent = function (e, t) {
      l.onParamError("缺少参数 " + e + ", 请确保参数不是 空字符串、空对象、空数组、null或undefined, 或数组的内容不是 null/undefined", t);
    }, l.verifyParamAbsent = function (e, t, n, r) {
      n = n || "", void 0 !== t && l.onParamPresent(n + e, r);
    }, l.onParamPresent = function (e, t) {
      l.onParamError("多余的参数 " + e, t);
    }, l.verifyParamType = function (e, t, n, r) {
      var s = l.typeOf(t).toLowerCase();l.isArray(n) || (n = [n]);var i = !0;switch (-1 === (n = n.map(function (e) {
        return e.toLowerCase();
      })).indexOf(s) && (i = !1), s) {case "number":
          isNaN(t) && (i = !1);break;case "string":
          "numeric or numeric string" === n.join("") && (i = !!/^[0-9]+$/.test(t));}i || l.onParamInvalidType(e, n, "", r);
    }, l.onParamInvalidType = function (e, t, n, r) {
      n = n || "", t = l.isArray(t) ? (t = t.map(function (e) {
        return '"' + e + '"';
      })).join(", ") : '"' + t + '"', l.onParamError('参数"' + n + e + '"类型错误, 合法的类型包括: [' + t + "]", r);
    }, l.verifyParamValid = function (e, t, n, r) {
      l.isArray(n) || (n = [n]), -1 === n.indexOf(t) && l.onParamInvalidValue(e, n, r);
    }, l.onParamInvalidValue = function (e, t, n) {
      l.isArray(t) || (t = [t]), t = t.map(function (e) {
        return '"' + e + '"';
      }), l.isArray(t) && (t = t.join(", ")), l.onParamError("参数 " + e + "值错误, 合法的值包括: [" + __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_json_stringify___default()(t) + "]", n);
    }, l.verifyParamMin = function (e, t, n, r) {
      t < n && l.onParamError("参数" + e + "的值不能小于" + n, r);
    }, l.verifyParamMax = function (e, t, n, r) {
      t > n && l.onParamError("参数" + e + "的值不能大于" + n, r);
    }, l.verifyArrayMax = function (e, t, n, r) {
      t.length > n && l.onParamError("参数" + e + "的长度不能大于" + n, r);
    }, l.verifyEmail = (u = /^\S+@\S+$/, function (e, t, n) {
      u.test(t) || l.onParamError("参数" + e + "邮箱格式错误, 合法格式必须包含@符号, @符号前后至少要各有一个字符", n);
    }), l.verifyTel = function () {
      var e = /^[+\-()\d]+$/;return function (t, n, r) {
        e.test(n) || l.onParamError("参数" + t + "电话号码格式错误, 合法字符包括+、-、英文括号和数字", r);
      };
    }(), l.verifyBirth = function () {
      var e = /^(\d{4})-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/;return function (t, n, r) {
        e.test(n) || l.onParamError("参数" + t + '生日格式错误, 合法为"yyyy-MM-dd"', r);
      };
    }(), l.onParamError = function (e, t) {
      l.onError({ message: e, callFunc: t });
    }, l.verifyOptions = function (e, t, n, r, s) {
      if (e = e || {}, t && (l.isString(t) && (t = t.split(d)), l.isArray(t))) {
        "boolean" != typeof n && (s = n || null, n = !0, r = "");var i = n ? l.verifyParamPresent : l.verifyParamAbsent;t.forEach(function (t) {
          i.call(l, t, e[t], r, s);
        });
      }return e;
    }, l.verifyParamAtLeastPresentOne = function (e, t, n) {
      t && (l.isString(t) && (t = t.split(d)), l.isArray(t) && (t.some(function (t) {
        return l.exist(e[t]);
      }) || l.onParamError("以下参数[" + t.join(", ") + "]至少需要传入一个", n)));
    }, l.verifyParamPresentJustOne = function (e, t, n) {
      t && (l.isString(t) && (t = t.split(d)), l.isArray(t) && 1 !== t.reduce(function (t, n) {
        return l.exist(e[n]) && t++, t;
      }, 0) && l.onParamError("以下参数[" + t.join(", ") + "]必须且只能传入一个", n));
    }, l.verifyBooleanWithDefault = function (e, t, n, r, s) {
      l.undef(n) && (n = !0), d.test(t) && (t = t.split(d)), l.isArray(t) ? t.forEach(function (t) {
        l.verifyBooleanWithDefault(e, t, n, r, s);
      }) : void 0 === e[t] ? e[t] = n : l.isBoolean(e[t]) || l.onParamInvalidType(t, "boolean", r, s);
    }, l.verifyFileInput = function (e, t) {
      return l.verifyParamPresent("fileInput", e, "", t), l.isString(e) && ((e = document.getElementById(e)) || l.onParamError("找不到要上传的文件对应的input, 请检查fileInput id " + e, t)), e.tagName && "input" === e.tagName.toLowerCase() && "file" === e.type.toLowerCase() || l.onParamError("请提供正确的 fileInput, 必须为 file 类型的 input 节点 tagname:" + e.tagName + ", filetype:" + e.type, t), e;
    }, l.verifyFileType = function (e, t) {
      l.verifyParamValid("type", e, l.validFileTypes, t);
    }, l.verifyCallback = function (e, t, n) {
      d.test(t) && (t = t.split(d)), l.isArray(t) ? t.forEach(function (t) {
        l.verifyCallback(e, t, n);
      }) : e[t] ? l.isFunction(e[t]) || l.onParamInvalidType(t, "function", "", n) : e[t] = l.emptyFunc;
    }, l.verifyFileUploadCallback = function (e, t) {
      l.verifyCallback(e, "uploadprogress uploaddone uploaderror uploadcancel", t);
    }, l.validFileTypes = ["image", "audio", "video", "file"], l.validFileExts = { image: ["bmp", "gif", "jpg", "jpeg", "jng", "png", "webp"], audio: ["mp3", "wav", "aac", "wma", "wmv", "amr", "mp2", "flac", "vorbis", "ac3"], video: ["mp4", "rm", "rmvb", "wmv", "avi", "mpg", "mpeg"] }, l.filterFiles = function (e, t) {
      var n,
          r,
          s = "file" === (t = t.toLowerCase()),
          i = [];return [].forEach.call(e, function (e) {
        if (s) i.push(e);else if (n = e.name.slice(e.name.lastIndexOf(".") + 1), (r = e.type.split("/"))[0] && r[1]) {
          (r[0].toLowerCase() === t || -1 !== l.validFileExts[t].indexOf(n)) && i.push(e);
        }
      }), i;
    };var f,
        p,
        g = l.supportFormData = l.notundef(m.FormData);l.getFileName = function (e) {
      return e = l.verifyFileInput(e), g ? e.files[0].name : e.value.slice(e.value.lastIndexOf("\\") + 1);
    }, l.getFileInfo = (f = { ppt: 1, pptx: 2, pdf: 3 }, function (e) {
      var t = {};if (!(e = l.verifyFileInput(e)).files) return t;var n = e.files[0];return g && (t.name = n.name, t.size = n.size, t.type = n.name.match(/\.(\w+)$/), t.type = t.type && t.type[1].toLowerCase(), t.transcodeType = f[t.type] || 0), t;
    }), l.sizeText = (p = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "BB"], function (e) {
      var t,
          n = 0;do {
        t = (e = Math.floor(100 * e) / 100) + p[n], e /= 1024, n++;
      } while (e > 1);return t;
    }), l.promises2cmds = function (e) {
      return e.map(function (e) {
        return e.cmd;
      });
    }, l.objs2accounts = function (e) {
      return e.map(function (e) {
        return e.account;
      });
    }, l.teams2ids = function (e) {
      return e.map(function (e) {
        return e.teamId;
      });
    }, l.objs2ids = function (e) {
      return e.map(function (e) {
        return e.id;
      });
    }, l.getMaxUpdateTime = function (e) {
      var t = e.map(function (e) {
        return +e.updateTime;
      });return Math.max.apply(Math, t);
    }, l.genCheckUniqueFunc = function (e, t) {
      return e = e || "id", t = t || 1e3, function (t) {
        this.uniqueSet = this.uniqueSet || {}, this.uniqueSet[e] = this.uniqueSet[e] || {};var n = this.uniqueSet[e],
            r = t[e];return !n[r] && (n[r] = !0, !0);
      };
    }, l.fillPropertyWithDefault = function (e, t, n) {
      return !!l.undef(e[t]) && (e[t] = n, !0);
    }, e.exports = l;
  },, function (e, t, n) {
    "use strict";
    var r = { info: { hash: "9a1344976e4e77060d4124635d9a8a872239c6cb", shortHash: "9a1344976", version: "6.2.0", sdkVersion: "52", nrtcVersion: "4.5.0", nrtcSdkVersion: "1", protocolVersion: 1 }, agentVersion: "2.8.0.906", lbsUrl: "https://lbs.netease.im/lbs/webconf.jsp", roomserver: "roomserver.netease.im", connectTimeout: 8e3, xhrTimeout: 8e3, socketTimeout: 8e3, reconnectionDelay: 1600, reconnectionDelayMax: 8e3, reconnectionJitter: .01, reconnectiontimer: null, heartbeatInterval: 8e3, cmdTimeout: 8e3, defaultReportUrl: "https://dr.netease.im/1.gif", isWeixinApp: !1, isNodejs: !1, isRN: !1, PUSHTOKEN: "", PUSHCONFIG: {}, CLIENTTYPE: 16, PushPermissionAsked: !1, iosPushConfig: null, androidPushConfig: null, netDetectAddr: "https://roomserver-dev.netease.im/v1/sdk/detect/local" };r.weixinNetcall = r.nrtcNetcall = { checkSumUrl: "https://nrtc.netease.im/demo/getChecksum.action", getChannelInfoUrl: "https://nrtc.netease.im/nrtc/getChannelInfos.action" }, r.formatSocketUrl = function (e) {
      var t = e.url,
          n = e.secure ? "https" : "http";return -1 === t.indexOf("http") ? n + "://" + t : t;
    }, r.uploadUrl = "https://nos.netease.com", r.chunkUploadUrl = null, r.commonMaxSize = 104857600, r.chunkSize = 4194304, r.chunkMaxSize = 4194304e4, r.replaceUrl = "https://{bucket}-nosdn.netease.im/{object}", r.downloadHost = "nos.netease.com", r.downloadUrl = "https://{bucket}-nosdn.netease.im/{object}", r.httpsEnabled = !1, r.threshold = 0, r.genUploadUrl = function (e) {
      return r.uploadUrl + "/" + e;
    }, r.genChunkUploadUrl = function (e) {
      return r.chunkUploadUrl ? r.chunkUploadUrl + "/" + e.bucket + "/" + e.objectName : "";
    }, r.genDownloadUrl = function (e, t) {
      var n = e.bucket,
          s = (e.tag, e.expireSec),
          i = +new Date(),
          o = s ? "&survivalTime=" + s : "",
          a = r.replaceUrl + "?createTime=" + i + o;return (a = r.genNosProtocolUrl(a)).replace("{bucket}", n).replace("{object}", t);
    }, r.genFileUrl = function (e) {
      var t = e.bucket,
          n = e.objectName;return r.genNosProtocolUrl(r.replaceUrl).replace("{bucket}", t).replace("{object}", n);
    }, r.genNosProtocolUrl = function (e) {
      return (/^http/.test(e) ? r.httpsEnabled && (e = e.replace("http", "https")) : e = r.httpsEnabled ? "https://" + e : "http://" + e, e
      );
    }, e.exports = r;
  },,,, function (e, t, n) {
    var r = n(42)("wks"),
        s = n(29),
        i = n(8).Symbol,
        o = "function" == typeof i;(e.exports = function (e) {
      return r[e] || (r[e] = o && i[e] || (o ? i : s)("Symbol." + e));
    }).store = r;
  }, function (e, t) {
    var n = e.exports = { version: "2.5.5" };"number" == typeof __e && (__e = n);
  }, function (e, t) {
    var n = e.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();"number" == typeof __g && (__g = n);
  }, function (e, t, n) {
    "use strict";
    t.__esModule = !0;var r = o(n(106)),
        s = o(n(96)),
        i = "function" == typeof s["default"] && "symbol" == __WEBPACK_IMPORTED_MODULE_15_babel_runtime_helpers_typeof___default()(r["default"]) ? function (e) {
      return typeof e === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_15_babel_runtime_helpers_typeof___default()(e);
    } : function (e) {
      return e && "function" == typeof s["default"] && e.constructor === s["default"] && e !== s["default"].prototype ? "symbol" : typeof e === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_15_babel_runtime_helpers_typeof___default()(e);
    };function o(e) {
      return e && e.__esModule ? e : { default: e };
    }t["default"] = "function" == typeof s["default"] && "symbol" === i(r["default"]) ? function (e) {
      return void 0 === e ? "undefined" : i(e);
    } : function (e) {
      return e && "function" == typeof s["default"] && e.constructor === s["default"] && e !== s["default"].prototype ? "symbol" : void 0 === e ? "undefined" : i(e);
    };
  }, function (e, t, n) {
    "use strict";
    var r = Object.prototype.hasOwnProperty,
        s = "~";function i() {}function o(e, t, n) {
      this.fn = e, this.context = t, this.once = n || !1;
    }function a() {
      this._events = new i(), this._eventsCount = 0;
    }__WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_create___default.a && (i.prototype = __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_create___default()(null), new i().__proto__ || (s = !1)), a.prototype.eventNames = function () {
      var e,
          t,
          n = [];if (0 === this._eventsCount) return n;for (t in e = this._events) {
        r.call(e, t) && n.push(s ? t.slice(1) : t);
      }return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_get_own_property_symbols___default.a ? n.concat(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_get_own_property_symbols___default()(e)) : n;
    }, a.prototype.listeners = function (e, t) {
      var n = s ? s + e : e,
          r = this._events[n];if (t) return !!r;if (!r) return [];if (r.fn) return [r.fn];for (var i = 0, o = r.length, a = new Array(o); i < o; i++) {
        a[i] = r[i].fn;
      }return a;
    }, a.prototype.emit = function (e, t, n, r, i, o) {
      var a = s ? s + e : e;if (!this._events[a]) return !1;var c,
          u,
          l = this._events[a],
          m = arguments.length;if (l.fn) {
        switch (l.once && this.removeListener(e, l.fn, void 0, !0), m) {case 1:
            return l.fn.call(l.context), !0;case 2:
            return l.fn.call(l.context, t), !0;case 3:
            return l.fn.call(l.context, t, n), !0;case 4:
            return l.fn.call(l.context, t, n, r), !0;case 5:
            return l.fn.call(l.context, t, n, r, i), !0;case 6:
            return l.fn.call(l.context, t, n, r, i, o), !0;}for (u = 1, c = new Array(m - 1); u < m; u++) {
          c[u - 1] = arguments[u];
        }l.fn.apply(l.context, c);
      } else {
        var d,
            f = l.length;for (u = 0; u < f; u++) {
          switch (l[u].once && this.removeListener(e, l[u].fn, void 0, !0), m) {case 1:
              l[u].fn.call(l[u].context);break;case 2:
              l[u].fn.call(l[u].context, t);break;case 3:
              l[u].fn.call(l[u].context, t, n);break;case 4:
              l[u].fn.call(l[u].context, t, n, r);break;default:
              if (!c) for (d = 1, c = new Array(m - 1); d < m; d++) {
                c[d - 1] = arguments[d];
              }l[u].fn.apply(l[u].context, c);}
        }
      }return !0;
    }, a.prototype.on = function (e, t, n) {
      var r = new o(t, n || this),
          i = s ? s + e : e;return this._events[i] ? this._events[i].fn ? this._events[i] = [this._events[i], r] : this._events[i].push(r) : (this._events[i] = r, this._eventsCount++), this;
    }, a.prototype.once = function (e, t, n) {
      var r = new o(t, n || this, !0),
          i = s ? s + e : e;return this._events[i] ? this._events[i].fn ? this._events[i] = [this._events[i], r] : this._events[i].push(r) : (this._events[i] = r, this._eventsCount++), this;
    }, a.prototype.removeListener = function (e, t, n, r) {
      var o = s ? s + e : e;if (!this._events[o]) return this;if (!t) return 0 == --this._eventsCount ? this._events = new i() : delete this._events[o], this;var a = this._events[o];if (a.fn) a.fn !== t || r && !a.once || n && a.context !== n || (0 == --this._eventsCount ? this._events = new i() : delete this._events[o]);else {
        for (var c = 0, u = [], l = a.length; c < l; c++) {
          (a[c].fn !== t || r && !a[c].once || n && a[c].context !== n) && u.push(a[c]);
        }u.length ? this._events[o] = 1 === u.length ? u[0] : u : 0 == --this._eventsCount ? this._events = new i() : delete this._events[o];
      }return this;
    }, a.prototype.removeAllListeners = function (e) {
      var t;return e ? (t = s ? s + e : e, this._events[t] && (0 == --this._eventsCount ? this._events = new i() : delete this._events[t])) : (this._events = new i(), this._eventsCount = 0), this;
    }, a.prototype.off = a.prototype.removeListener, a.prototype.addListener = a.prototype.on, a.prototype.setMaxListeners = function () {
      return this;
    }, a.prefixed = s, a.EventEmitter = a, e.exports = a;
  },, function (e, t, n) {
    "use strict";
    (function (e) {
      Object.defineProperty(t, "__esModule", { value: !0 }), t.url2origin = t.uniqueID = t.off = t.removeEventListener = t.on = t.addEventListener = t.format = t.regWhiteSpace = t.regBlank = t.emptyFunc = t.f = t.emptyObj = t.o = void 0;var r,
          s = n(9),
          i = (r = s) && r.__esModule ? r : { default: r };t.getGlobal = o, t.detectCSSFeature = function (e) {
        var t = !1,
            n = "Webkit Moz ms O".split(" "),
            r = document.createElement("div"),
            s = null;e = e.toLowerCase(), void 0 !== r.style[e] && (t = !0);if (!1 === t) {
          s = e.charAt(0).toUpperCase() + e.substr(1);for (var i = 0; i < n.length; i++) {
            if (void 0 !== r.style[n[i] + s]) {
              t = !0;break;
            }
          }
        }return t;
      }, t.fix = a, t.getYearStr = c, t.getMonthStr = u, t.getDayStr = l, t.getHourStr = m, t.getMinuteStr = d, t.getSecondStr = f, t.getMillisecondStr = p, t.dateFromDateTimeLocal = function (e) {
        return e = "" + e, new Date(e.replace(/-/g, "/").replace("T", " "));
      }, t.getClass = y, t.typeOf = v, t.isString = b, t.isNumber = function (e) {
        return "number" === v(e);
      }, t.isBoolean = function (e) {
        return "boolean" === v(e);
      }, t.isArray = M, t.isFunction = T, t.isDate = S, t.isRegExp = function (e) {
        return "regexp" === v(e);
      }, t.isError = function (e) {
        return "error" === v(e);
      }, t.isnull = k, t.notnull = P, t.undef = I, t.notundef = C, t.exist = O, t.notexist = w, t.isObject = x, t.isEmpty = function (e) {
        return w(e) || (b(e) || M(e)) && 0 === e.length;
      }, t.containsNode = function (e, t) {
        if (e === t) return !0;for (; t.parentNode;) {
          if (t.parentNode === e) return !0;t = t.parentNode;
        }return !1;
      }, t.calcHeight = function (e) {
        var t = e.parentNode || document.body;(e = e.cloneNode(!0)).style.display = "block", e.style.opacity = 0, e.style.height = "auto", t.appendChild(e);var n = e.offsetHeight;return t.removeChild(e), n;
      }, t.remove = function (e) {
        e.parentNode && e.parentNode.removeChild(e);
      }, t.dataset = function (e, t, n) {
        if (!O(n)) return e.getAttribute("data-" + t);e.setAttribute("data-" + t, n);
      }, t.target = function (e) {
        return e.target || e.srcElement;
      }, t.createIframe = function (e) {
        var t;if ((e = e || {}).name) try {
          (t = document.createElement('<iframe name="' + e.name + '"></iframe>')).frameBorder = 0;
        } catch (n) {
          (t = document.createElement("iframe")).name = e.name;
        } else t = document.createElement("iframe");e.visible || (t.style.display = "none");T(e.onload) && _(t, "load", function n(r) {
          if (!t.src) return;e.multi || R(t, "load", n);e.onload(r);
        });(e.parent || document.body).appendChild(t);var n = e.src || "about:blank";return setTimeout(function () {
          t.src = n;
        }, 0), t;
      }, t.html2node = function (e) {
        var t = document.createElement("div");t.innerHTML = e;var n = [],
            r = void 0,
            s = void 0;if (t.children) for (r = 0, s = t.children.length; r < s; r++) {
          n.push(t.children[r]);
        } else for (r = 0, s = t.childNodes.length; r < s; r++) {
          var i = t.childNodes[r];1 === i.nodeType && n.push(i);
        }return n.length > 1 ? t : n[0];
      }, t.scrollTop = function (e) {
        O(e) && (document.documentElement.scrollTop = document.body.scrollTop = e);return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      }, t.forOwn = U, t.mixin = j, t.isJSON = N, t.parseJSON = function e(t) {
        try {
          N(t) && (t = JSON.parse(t)), x(t) && U(t, function (n, r) {
            switch (v(r)) {case "string":case "object":
                t[n] = e(r);}
          });
        } catch (e) {
          console.log("error:", e);
        }return t;
      }, t.simpleClone = function (e) {
        var t = [],
            n = __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_json_stringify___default()(e, function (e, n) {
          if ("object" === (void 0 === n ? "undefined" : (0, i["default"])(n)) && null !== n) {
            if (-1 !== t.indexOf(n)) return;t.push(n);
          }return n;
        });return JSON.parse(n);
      }, t.merge = function () {
        for (var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = arguments.length, n = Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) {
          n[r - 1] = arguments[r];
        }return n.forEach(function (t) {
          j(e, t);
        }), e;
      }, t.fillUndef = function (e, t) {
        return U(t, function (t, n) {
          I(e[t]) && (e[t] = n);
        }), e;
      }, t.checkWithDefault = function (e, t, n) {
        var r = e[t] || e[t.toLowerCase()];w(r) && (r = n, e[t] = r);return r;
      }, t.fetch = function (e, t) {
        return U(e, function (n, r) {
          O(t[n]) && (e[n] = t[n]);
        }), e;
      }, t.string2object = function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
            t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ",",
            n = {};return e.split(t).forEach(function (e) {
          var t = e.split("="),
              r = t.shift();r && (n[decodeURIComponent(r)] = decodeURIComponent(t.join("=")));
        }), n;
      }, t.object2string = D, t.genUrlSep = function (e) {
        return e.indexOf("?") < 0 ? "?" : "&";
      }, t.object2query = function (e) {
        return D(e, "&", !0);
      }, t.isFileInput = L, t.getKeys = function (e, t) {
        var n = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_keys___default()(e);t && n.sort(function (t, n) {
          var r = L(e[t]),
              s = L(e[n]);return r === s ? 0 : r ? 1 : -1;
        });return n;
      };t.o = {}, t.emptyObj = {}, t.f = function () {}, t.emptyFunc = function () {}, t.regBlank = /\s+/gi, t.regWhiteSpace = /\s+/gi;function o() {
        return "undefined" != typeof window ? window : void 0 !== e ? e : {};
      }function a(e, t) {
        t = t || 2;for (var n = "" + e; n.length < t;) {
          n = "0" + n;
        }return n;
      }function c(e) {
        return "" + e.getFullYear();
      }function u(e) {
        return a(e.getMonth() + 1);
      }function l(e) {
        return a(e.getDate());
      }function m(e) {
        return a(e.getHours());
      }function d(e) {
        return a(e.getMinutes());
      }function f(e) {
        return a(e.getSeconds());
      }function p(e) {
        return a(e.getMilliseconds(), 3);
      }var g, h;t.format = (g = /yyyy|MM|dd|hh|mm|ss|SSS/g, h = { yyyy: c, MM: u, dd: l, hh: m, mm: d, ss: f, SSS: p }, function (e, t) {
        return e = new Date(e), isNaN(+e) ? "invalid date" : (t = t || "yyyy-MM-dd").replace(g, function (t) {
          return h[t](e);
        });
      });function y(e) {
        return Object.prototype.toString.call(e).slice(8, -1);
      }function v(e) {
        return y(e).toLowerCase();
      }function b(e) {
        return "string" === v(e);
      }function M(e) {
        return "array" === v(e);
      }function T(e) {
        return "function" === v(e);
      }function S(e) {
        return "date" === v(e);
      }function k(e) {
        return null === e;
      }function P(e) {
        return null !== e;
      }function I(e) {
        return void 0 === e;
      }function C(e) {
        return void 0 !== e;
      }function O(e) {
        return C(e) && P(e);
      }function w(e) {
        return I(e) || k(e);
      }function x(e) {
        return O(e) && "object" === v(e);
      }var A = t.addEventListener = function (e, t, n) {
        e.addEventListener ? e.addEventListener(t, n, !1) : e.attachEvent && e.attachEvent("on" + t, n);
      },
          _ = t.on = A,
          E = t.removeEventListener = function (e, t, n) {
        e.removeEventListener ? e.removeEventListener(t, n, !1) : e.detachEvent && e.detachEvent("on" + t, n);
      },
          R = t.off = E;function U() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : function () {},
            n = arguments[2];for (var r in e) {
          e.hasOwnProperty(r) && t.call(n, r, e[r]);
        }
      }function j(e, t) {
        U(t, function (t, n) {
          e[t] = n;
        });
      }var F;t.uniqueID = (F = 0, function () {
        return "" + F++;
      });function N(e) {
        return b(e) && 0 === e.indexOf("{") && e.lastIndexOf("}") === e.length - 1;
      }function D(e, t, n) {
        if (!e) return "";var r = [];return U(e, function (e, t) {
          T(t) || (S(t) ? t = t.getTime() : M(t) ? t = t.join(",") : x(t) && (t = __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_json_stringify___default()(t)), n && (t = encodeURIComponent(t)), r.push(encodeURIComponent(e) + "=" + t));
        }), r.join(t || ",");
      }t.url2origin = function () {
        var e = /^([\w]+?:\/\/.*?(?=\/|$))/i;return function (t) {
          return e.test(t || "") ? RegExp.$1.toLowerCase() : "";
        };
      }();function L(e) {
        var t = o();return e.tagName && "INPUT" === e.tagName.toUpperCase() || t.Blob && e instanceof t.Blob;
      }
    }).call(this, n(31));
  }, function (e, t, n) {
    var r = n(16),
        s = n(64),
        i = n(44),
        o = __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_define_property___default.a;t.f = n(15) ? __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_define_property___default.a : function (e, t, n) {
      if (r(e), t = i(t, !0), r(n), s) try {
        return o(e, t, n);
      } catch (e) {}if ("get" in n || "set" in n) throw TypeError("Accessors not supported!");return "value" in n && (e[t] = n.value), e;
    };
  }, function (e, t) {
    var n = {}.hasOwnProperty;e.exports = function (e, t) {
      return n.call(e, t);
    };
  }, function (e, t, n) {
    e.exports = !n(21)(function () {
      return 7 != Object.defineProperty({}, "a", { get: function get() {
          return 7;
        } }).a;
    });
  }, function (e, t, n) {
    var r = n(19);e.exports = function (e) {
      if (!r(e)) throw TypeError(e + " is not an object!");return e;
    };
  }, function (e, t, n) {
    var r = n(8),
        s = n(7),
        i = n(37),
        o = n(20),
        a = n(14),
        c = function c(e, t, n) {
      var u,
          l,
          m,
          d = e & c.F,
          f = e & c.G,
          p = e & c.S,
          g = e & c.P,
          h = e & c.B,
          y = e & c.W,
          v = f ? s : s[t] || (s[t] = {}),
          b = v.prototype,
          M = f ? r : p ? r[t] : (r[t] || {}).prototype;for (u in f && (n = t), n) {
        (l = !d && M && void 0 !== M[u]) && a(v, u) || (m = l ? M[u] : n[u], v[u] = f && "function" != typeof M[u] ? n[u] : h && l ? i(m, r) : y && M[u] == m ? function (e) {
          var t = function t(_t, n, r) {
            if (this instanceof e) {
              switch (arguments.length) {case 0:
                  return new e();case 1:
                  return new e(_t);case 2:
                  return new e(_t, n);}return new e(_t, n, r);
            }return e.apply(this, arguments);
          };return t.prototype = e.prototype, t;
        }(m) : g && "function" == typeof m ? i(Function.call, m) : m, g && ((v.virtual || (v.virtual = {}))[u] = m, e & c.R && b && !b[u] && o(b, u, m)));
      }
    };c.F = 1, c.G = 2, c.S = 4, c.P = 8, c.B = 16, c.W = 32, c.U = 64, c.R = 128, e.exports = c;
  }, function (e, t, n) {
    var r = n(61),
        s = n(45);e.exports = function (e) {
      return r(s(e));
    };
  }, function (e, t) {
    e.exports = function (e) {
      return "object" == (typeof e === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_15_babel_runtime_helpers_typeof___default()(e)) ? null !== e : "function" == typeof e;
    };
  }, function (e, t, n) {
    var r = n(13),
        s = n(27);e.exports = n(15) ? function (e, t, n) {
      return r.f(e, t, s(1, n));
    } : function (e, t, n) {
      return e[t] = n, e;
    };
  }, function (e, t) {
    e.exports = function (e) {
      try {
        return !!e();
      } catch (e) {
        return !0;
      }
    };
  }, function (e, t, n) {
    "use strict";
    (function (t) {
      var r,
          s = n(9),
          i = (r = s) && r.__esModule ? r : { default: r };var o = function () {
        var e = "object" === (void 0 === t ? "undefined" : (0, i["default"])(t)) ? t : window,
            n = Math.pow(2, 53) - 1,
            r = /\bOpera/,
            s = Object.prototype,
            o = s.hasOwnProperty,
            a = s.toString;function c(e) {
          return (e = String(e)).charAt(0).toUpperCase() + e.slice(1);
        }function u(e) {
          return e = p(e), /^(?:webOS|i(?:OS|P))/.test(e) ? e : c(e);
        }function l(e, t) {
          for (var n in e) {
            o.call(e, n) && t(e[n], n, e);
          }
        }function m(e) {
          return null == e ? c(e) : a.call(e).slice(8, -1);
        }function d(e) {
          return String(e).replace(/([ -])(?!$)/g, "$1?");
        }function f(e, t) {
          var r = null;return function (e, t) {
            var r = -1,
                s = e ? e.length : 0;if ("number" == typeof s && s > -1 && s <= n) for (; ++r < s;) {
              t(e[r], r, e);
            } else l(e, t);
          }(e, function (n, s) {
            r = t(r, n, s, e);
          }), r;
        }function p(e) {
          return String(e).replace(/^ +| +$/g, "");
        }return function t(n) {
          var s = e,
              o = n && "object" === (void 0 === n ? "undefined" : (0, i["default"])(n)) && "String" != m(n);o && (s = n, n = null);var c = s.navigator || {},
              g = c.userAgent || "";n || (n = g);var h,
              y,
              v,
              b,
              M,
              T = o ? !!c.likeChrome : /\bChrome\b/.test(n) && !/internal|\n/i.test(a.toString()),
              S = o ? "Object" : "ScriptBridgingProxyObject",
              k = o ? "Object" : "Environment",
              P = o && s.java ? "JavaPackage" : m(s.java),
              I = o ? "Object" : "RuntimeObject",
              C = /\bJava/.test(P) && s.java,
              O = C && m(s.environment) == k,
              w = C ? "a" : "α",
              x = C ? "b" : "β",
              A = s.document || {},
              _ = s.operamini || s.opera,
              E = r.test(E = o && _ ? _["[[Class]]"] : m(_)) ? E : _ = null,
              R = n,
              U = [],
              j = null,
              F = n == g,
              N = F && _ && "function" == typeof _.version && _.version(),
              D = f([{ label: "EdgeHTML", pattern: "Edge" }, "Trident", { label: "WebKit", pattern: "AppleWebKit" }, "iCab", "Presto", "NetFront", "Tasman", "KHTML", "Gecko"], function (e, t) {
            return e || RegExp("\\b" + (t.pattern || d(t)) + "\\b", "i").exec(n) && (t.label || t);
          }),
              L = function (e) {
            return f(e, function (e, t) {
              return e || RegExp("\\b" + (t.pattern || d(t)) + "\\b", "i").exec(n) && (t.label || t);
            });
          }(["Adobe AIR", "Arora", "Avant Browser", "Breach", "Camino", "Electron", "Epiphany", "Fennec", "Flock", "Galeon", "GreenBrowser", "iCab", "Iceweasel", "K-Meleon", "Konqueror", "Lunascape", "Maxthon", { label: "Microsoft Edge", pattern: "Edge" }, "Midori", "Nook Browser", "PaleMoon", "PhantomJS", "Raven", "Rekonq", "RockMelt", { label: "Samsung Internet", pattern: "SamsungBrowser" }, "SeaMonkey", { label: "Silk", pattern: "(?:Cloud9|Silk-Accelerated)" }, "Sleipnir", "SlimBrowser", { label: "SRWare Iron", pattern: "Iron" }, "Sunrise", "Swiftfox", "Waterfox", "WebPositive", "Opera Mini", { label: "Opera Mini", pattern: "OPiOS" }, "Opera", { label: "Opera", pattern: "OPR" }, "Chrome", { label: "Chrome Mobile", pattern: "(?:CriOS|CrMo)" }, { label: "Firefox", pattern: "(?:Firefox|Minefield)" }, { label: "Firefox for iOS", pattern: "FxiOS" }, { label: "IE", pattern: "IEMobile" }, { label: "IE", pattern: "MSIE" }, "Safari"]),
              B = W([{ label: "BlackBerry", pattern: "BB10" }, "BlackBerry", { label: "Galaxy S", pattern: "GT-I9000" }, { label: "Galaxy S2", pattern: "GT-I9100" }, { label: "Galaxy S3", pattern: "GT-I9300" }, { label: "Galaxy S4", pattern: "GT-I9500" }, { label: "Galaxy S5", pattern: "SM-G900" }, { label: "Galaxy S6", pattern: "SM-G920" }, { label: "Galaxy S6 Edge", pattern: "SM-G925" }, { label: "Galaxy S7", pattern: "SM-G930" }, { label: "Galaxy S7 Edge", pattern: "SM-G935" }, "Google TV", "Lumia", "iPad", "iPod", "iPhone", "Kindle", { label: "Kindle Fire", pattern: "(?:Cloud9|Silk-Accelerated)" }, "Nexus", "Nook", "PlayBook", "PlayStation Vita", "PlayStation", "TouchPad", "Transformer", { label: "Wii U", pattern: "WiiU" }, "Wii", "Xbox One", { label: "Xbox 360", pattern: "Xbox" }, "Xoom"]),
              q = function (e) {
            return f(e, function (e, t, r) {
              return e || (t[B] || t[/^[a-z]+(?: +[a-z]+\b)*/i.exec(B)] || RegExp("\\b" + d(r) + "(?:\\b|\\w*\\d)", "i").exec(n)) && r;
            });
          }({ Apple: { iPad: 1, iPhone: 1, iPod: 1 }, Archos: {}, Amazon: { Kindle: 1, "Kindle Fire": 1 }, Asus: { Transformer: 1 }, "Barnes & Noble": { Nook: 1 }, BlackBerry: { PlayBook: 1 }, Google: { "Google TV": 1, Nexus: 1 }, HP: { TouchPad: 1 }, HTC: {}, LG: {}, Microsoft: { Xbox: 1, "Xbox One": 1 }, Motorola: { Xoom: 1 }, Nintendo: { "Wii U": 1, Wii: 1 }, Nokia: { Lumia: 1 }, Samsung: { "Galaxy S": 1, "Galaxy S2": 1, "Galaxy S3": 1, "Galaxy S4": 1 }, Sony: { PlayStation: 1, "PlayStation Vita": 1 } }),
              H = function (e) {
            return f(e, function (e, t) {
              var r = t.pattern || d(t);return !e && (e = RegExp("\\b" + r + "(?:/[\\d.]+|[ \\w.]*)", "i").exec(n)) && (e = function (e, t, n) {
                var r = { "10.0": "10", 6.4: "10 Technical Preview", 6.3: "8.1", 6.2: "8", 6.1: "Server 2008 R2 / 7", "6.0": "Server 2008 / Vista", 5.2: "Server 2003 / XP 64-bit", 5.1: "XP", 5.01: "2000 SP1", "5.0": "2000", "4.0": "NT", "4.90": "ME" };return t && n && /^Win/i.test(e) && !/^Windows Phone /i.test(e) && (r = r[/[\d.]+$/.exec(e)]) && (e = "Windows " + r), e = String(e), t && n && (e = e.replace(RegExp(t, "i"), n)), e = u(e.replace(/ ce$/i, " CE").replace(/\bhpw/i, "web").replace(/\bMacintosh\b/, "Mac OS").replace(/_PowerPC\b/i, " OS").replace(/\b(OS X) [^ \d]+/i, "$1").replace(/\bMac (OS X)\b/, "$1").replace(/\/(\d)/, " $1").replace(/_/g, ".").replace(/(?: BePC|[ .]*fc[ \d.]+)$/i, "").replace(/\bx86\.64\b/gi, "x86_64").replace(/\b(Windows Phone) OS\b/, "$1").replace(/\b(Chrome OS \w+) [\d.]+\b/, "$1").split(" on ")[0]);
              }(e, r, t.label || t)), e;
            });
          }(["Windows Phone", "Android", "CentOS", { label: "Chrome OS", pattern: "CrOS" }, "Debian", "Fedora", "FreeBSD", "Gentoo", "Haiku", "Kubuntu", "Linux Mint", "OpenBSD", "Red Hat", "SuSE", "Ubuntu", "Xubuntu", "Cygwin", "Symbian OS", "hpwOS", "webOS ", "webOS", "Tablet OS", "Tizen", "Linux", "Mac OS X", "Macintosh", "Mac", "Windows 98;", "Windows "]);function W(e) {
            return f(e, function (e, t) {
              var r = t.pattern || d(t);return !e && (e = RegExp("\\b" + r + " *\\d+[.\\w_]*", "i").exec(n) || RegExp("\\b" + r + " *\\w+-[\\w]*", "i").exec(n) || RegExp("\\b" + r + "(?:; *(?:[a-z]+[_-])?[a-z]+\\d+|[^ ();-]*)", "i").exec(n)) && ((e = String(t.label && !RegExp(r, "i").test(t.label) ? t.label : e).split("/"))[1] && !/[\d.]+/.test(e[0]) && (e[0] += " " + e[1]), t = t.label || t, e = u(e[0].replace(RegExp(r, "i"), t).replace(RegExp("; *(?:" + t + "[_-])?", "i"), " ").replace(RegExp("(" + t + ")[-_.]?(\\w)", "i"), "$1 $2"))), e;
            });
          }if (D && (D = [D]), q && !B && (B = W([q])), (h = /\bGoogle TV\b/.exec(B)) && (B = h[0]), /\bSimulator\b/i.test(n) && (B = (B ? B + " " : "") + "Simulator"), "Opera Mini" == L && /\bOPiOS\b/.test(n) && U.push("running in Turbo/Uncompressed mode"), "IE" == L && /\blike iPhone OS\b/.test(n) ? (q = (h = t(n.replace(/like iPhone OS/, ""))).manufacturer, B = h.product) : /^iP/.test(B) ? (L || (L = "Safari"), H = "iOS" + ((h = / OS ([\d_]+)/i.exec(n)) ? " " + h[1].replace(/_/g, ".") : "")) : "Konqueror" != L || /buntu/i.test(H) ? q && "Google" != q && (/Chrome/.test(L) && !/\bMobile Safari\b/i.test(n) || /\bVita\b/.test(B)) || /\bAndroid\b/.test(H) && /^Chrome/.test(L) && /\bVersion\//i.test(n) ? (L = "Android Browser", H = /\bAndroid\b/.test(H) ? H : "Android") : "Silk" == L ? (/\bMobi/i.test(n) || (H = "Android", U.unshift("desktop mode")), /Accelerated *= *true/i.test(n) && U.unshift("accelerated")) : "PaleMoon" == L && (h = /\bFirefox\/([\d.]+)\b/.exec(n)) ? U.push("identifying as Firefox " + h[1]) : "Firefox" == L && (h = /\b(Mobile|Tablet|TV)\b/i.exec(n)) ? (H || (H = "Firefox OS"), B || (B = h[1])) : !L || (h = !/\bMinefield\b/i.test(n) && /\b(?:Firefox|Safari)\b/.exec(L)) ? (L && !B && /[\/,]|^[^(]+?\)/.test(n.slice(n.indexOf(h + "/") + 8)) && (L = null), (h = B || q || H) && (B || q || /\b(?:Android|Symbian OS|Tablet OS|webOS)\b/.test(H)) && (L = /[a-z]+(?: Hat)?/i.exec(/\bAndroid\b/.test(H) ? H : h) + " Browser")) : "Electron" == L && (h = (/\bChrome\/([\d.]+)\b/.exec(n) || 0)[1]) && U.push("Chromium " + h) : H = "Kubuntu", N || (N = f(["(?:Cloud9|CriOS|CrMo|Edge|FxiOS|IEMobile|Iron|Opera ?Mini|OPiOS|OPR|Raven|SamsungBrowser|Silk(?!/[\\d.]+$))", "Version", d(L), "(?:Firefox|Minefield|NetFront)"], function (e, t) {
            return e || (RegExp(t + "(?:-[\\d.]+/|(?: for [\\w-]+)?[ /-])([\\d.]+[^ ();/_-]*)", "i").exec(n) || 0)[1] || null;
          })), (h = ("iCab" == D && parseFloat(N) > 3 ? "WebKit" : /\bOpera\b/.test(L) && (/\bOPR\b/.test(n) ? "Blink" : "Presto")) || /\b(?:Midori|Nook|Safari)\b/i.test(n) && !/^(?:Trident|EdgeHTML)$/.test(D) && "WebKit" || !D && /\bMSIE\b/i.test(n) && ("Mac OS" == H ? "Tasman" : "Trident") || "WebKit" == D && /\bPlayStation\b(?! Vita\b)/i.test(L) && "NetFront") && (D = [h]), "IE" == L && (h = (/; *(?:XBLWP|ZuneWP)(\d+)/i.exec(n) || 0)[1]) ? (L += " Mobile", H = "Windows Phone " + (/\+$/.test(h) ? h : h + ".x"), U.unshift("desktop mode")) : /\bWPDesktop\b/i.test(n) ? (L = "IE Mobile", H = "Windows Phone 8.x", U.unshift("desktop mode"), N || (N = (/\brv:([\d.]+)/.exec(n) || 0)[1])) : "IE" != L && "Trident" == D && (h = /\brv:([\d.]+)/.exec(n)) && (L && U.push("identifying as " + L + (N ? " " + N : "")), L = "IE", N = h[1]), F) {
            if (b = "global", M = null != (v = s) ? (0, i["default"])(v[b]) : "number", /^(?:boolean|number|string|undefined)$/.test(M) || "object" == M && !v[b]) m(h = s.runtime) == S ? (L = "Adobe AIR", H = h.flash.system.Capabilities.os) : m(h = s.phantom) == I ? (L = "PhantomJS", N = (h = h.version || null) && h.major + "." + h.minor + "." + h.patch) : "number" == typeof A.documentMode && (h = /\bTrident\/(\d+)/i.exec(n)) ? (N = [N, A.documentMode], (h = +h[1] + 4) != N[1] && (U.push("IE " + N[1] + " mode"), D && (D[1] = ""), N[1] = h), N = "IE" == L ? String(N[1].toFixed(1)) : N[0]) : "number" == typeof A.documentMode && /^(?:Chrome|Firefox)\b/.test(L) && (U.push("masking as " + L + " " + N), L = "IE", N = "11.0", D = ["Trident"], H = "Windows");else if (C && (R = (h = C.lang.System).getProperty("os.arch"), H = H || h.getProperty("os.name") + " " + h.getProperty("os.version")), O) {
              try {
                N = s.require("ringo/engine").version.join("."), L = "RingoJS";
              } catch (e) {
                (h = s.system) && h.global.system == s.system && (L = "Narwhal", H || (H = h[0].os || null));
              }L || (L = "Rhino");
            } else "object" === (0, i["default"])(s.process) && !s.process.browser && (h = s.process) && ("object" === (0, i["default"])(h.versions) && ("string" == typeof h.versions.electron ? (U.push("Node " + h.versions.node), L = "Electron", N = h.versions.electron) : "string" == typeof h.versions.nw && (U.push("Chromium " + N, "Node " + h.versions.node), L = "NW.js", N = h.versions.nw)), L || (L = "Node.js", R = h.arch, H = h.platform, N = (N = /[\d.]+/.exec(h.version)) ? N[0] : null));H = H && u(H);
          }if (N && (h = /(?:[ab]|dp|pre|[ab]\d+pre)(?:\d+\+?)?$/i.exec(N) || /(?:alpha|beta)(?: ?\d)?/i.exec(n + ";" + (F && c.appMinorVersion)) || /\bMinefield\b/i.test(n) && "a") && (j = /b/i.test(h) ? "beta" : "alpha", N = N.replace(RegExp(h + "\\+?$"), "") + ("beta" == j ? x : w) + (/\d+\+?/.exec(h) || "")), "Fennec" == L || "Firefox" == L && /\b(?:Android|Firefox OS)\b/.test(H)) L = "Firefox Mobile";else if ("Maxthon" == L && N) N = N.replace(/\.[\d.]+/, ".x");else if (/\bXbox\b/i.test(B)) "Xbox 360" == B && (H = null), "Xbox 360" == B && /\bIEMobile\b/.test(n) && U.unshift("mobile mode");else if (!/^(?:Chrome|IE|Opera)$/.test(L) && (!L || B || /Browser|Mobi/.test(L)) || "Windows CE" != H && !/Mobi/i.test(n)) {
            if ("IE" == L && F) try {
              null === s.external && U.unshift("platform preview");
            } catch (e) {
              U.unshift("embedded");
            } else (/\bBlackBerry\b/.test(B) || /\bBB10\b/.test(n)) && (h = (RegExp(B.replace(/ +/g, " *") + "/([.\\d]+)", "i").exec(n) || 0)[1] || N) ? (H = ((h = [h, /BB10/.test(n)])[1] ? (B = null, q = "BlackBerry") : "Device Software") + " " + h[0], N = null) : this != l && "Wii" != B && (F && _ || /Opera/.test(L) && /\b(?:MSIE|Firefox)\b/i.test(n) || "Firefox" == L && /\bOS X (?:\d+\.){2,}/.test(H) || "IE" == L && (H && !/^Win/.test(H) && N > 5.5 || /\bWindows XP\b/.test(H) && N > 8 || 8 == N && !/\bTrident\b/.test(n))) && !r.test(h = t.call(l, n.replace(r, "") + ";")) && h.name && (h = "ing as " + h.name + ((h = h.version) ? " " + h : ""), r.test(L) ? (/\bIE\b/.test(h) && "Mac OS" == H && (H = null), h = "identify" + h) : (h = "mask" + h, L = E ? u(E.replace(/([a-z])([A-Z])/g, "$1 $2")) : "Opera", /\bIE\b/.test(h) && (H = null), F || (N = null)), D = ["Presto"], U.push(h));
          } else L += " Mobile";(h = (/\bAppleWebKit\/([\d.]+\+?)/i.exec(n) || 0)[1]) && (h = [parseFloat(h.replace(/\.(\d)$/, ".0$1")), h], "Safari" == L && "+" == h[1].slice(-1) ? (L = "WebKit Nightly", j = "alpha", N = h[1].slice(0, -1)) : N != h[1] && N != (h[2] = (/\bSafari\/([\d.]+\+?)/i.exec(n) || 0)[1]) || (N = null), h[1] = (/\bChrome\/([\d.]+)/i.exec(n) || 0)[1], 537.36 == h[0] && 537.36 == h[2] && parseFloat(h[1]) >= 28 && "WebKit" == D && (D = ["Blink"]), F && (T || h[1]) ? (D && (D[1] = "like Chrome"), h = h[1] || ((h = h[0]) < 530 ? 1 : h < 532 ? 2 : h < 532.05 ? 3 : h < 533 ? 4 : h < 534.03 ? 5 : h < 534.07 ? 6 : h < 534.1 ? 7 : h < 534.13 ? 8 : h < 534.16 ? 9 : h < 534.24 ? 10 : h < 534.3 ? 11 : h < 535.01 ? 12 : h < 535.02 ? "13+" : h < 535.07 ? 15 : h < 535.11 ? 16 : h < 535.19 ? 17 : h < 536.05 ? 18 : h < 536.1 ? 19 : h < 537.01 ? 20 : h < 537.11 ? "21+" : h < 537.13 ? 23 : h < 537.18 ? 24 : h < 537.24 ? 25 : h < 537.36 ? 26 : "Blink" != D ? "27" : "28")) : (D && (D[1] = "like Safari"), h = (h = h[0]) < 400 ? 1 : h < 500 ? 2 : h < 526 ? 3 : h < 533 ? 4 : h < 534 ? "4+" : h < 535 ? 5 : h < 537 ? 6 : h < 538 ? 7 : h < 601 ? 8 : "8"), D && (D[1] += " " + (h += "number" == typeof h ? ".x" : /[.+]/.test(h) ? "" : "+")), "Safari" == L && (!N || parseInt(N) > 45) && (N = h)), "Opera" == L && (h = /\bzbov|zvav$/.exec(H)) ? (L += " ", U.unshift("desktop mode"), "zvav" == h ? (L += "Mini", N = null) : L += "Mobile", H = H.replace(RegExp(" *" + h + "$"), "")) : "Safari" == L && /\bChrome\b/.exec(D && D[1]) && (U.unshift("desktop mode"), L = "Chrome Mobile", N = null, /\bOS X\b/.test(H) ? (q = "Apple", H = "iOS 4.3+") : H = null), N && 0 == N.indexOf(h = /[\d.]+$/.exec(H)) && n.indexOf("/" + h + "-") > -1 && (H = p(H.replace(h, ""))), D && !/\b(?:Avant|Nook)\b/.test(L) && (/Browser|Lunascape|Maxthon/.test(L) || "Safari" != L && /^iOS/.test(H) && /\bSafari\b/.test(D[1]) || /^(?:Adobe|Arora|Breach|Midori|Opera|Phantom|Rekonq|Rock|Samsung Internet|Sleipnir|Web)/.test(L) && D[1]) && (h = D[D.length - 1]) && U.push(h), U.length && (U = ["(" + U.join("; ") + ")"]), q && B && B.indexOf(q) < 0 && U.push("on " + q), B && U.push((/^on /.test(U[U.length - 1]) ? "" : "on ") + B), H && (h = / ([\d.+]+)$/.exec(H), y = h && "/" == H.charAt(H.length - h[0].length - 1), H = { architecture: 32, family: h && !y ? H.replace(h[0], "") : H, version: h ? h[1] : null, toString: function toString() {
              var e = this.version;return this.family + (e && !y ? " " + e : "") + (64 == this.architecture ? " 64-bit" : "");
            } }), (h = /\b(?:AMD|IA|Win|WOW|x86_|x)64\b/i.exec(R)) && !/\bi686\b/i.test(R) ? (H && (H.architecture = 64, H.family = H.family.replace(RegExp(" *" + h), "")), L && (/\bWOW64\b/i.test(n) || F && /\w(?:86|32)$/.test(c.cpuClass || c.platform) && !/\bWin64; x64\b/i.test(n)) && U.unshift("32-bit")) : H && /^OS X/.test(H.family) && "Chrome" == L && parseFloat(N) >= 39 && (H.architecture = 64), n || (n = null);var z = {};return z.description = n, z.layout = D && D[0], z.manufacturer = q, z.name = L, z.prerelease = j, z.product = B, z.ua = n, z.version = L && N, z.os = H || { architecture: null, family: null, version: null, toString: function toString() {
              return "null";
            } }, z.parse = t, z.toString = function () {
            return this.description || "";
          }, z.version && U.unshift(N), z.name && U.unshift(L), H && L && (H != String(H).split(" ")[0] || H != L.split(" ")[0] && !B) && U.push(B ? "(" + H + ")" : "on " + H), U.length && (z.description = U.join(" ")), z;
        }();
      }();e.exports = o;
    }).call(this, n(31));
  }, function (e, t) {
    e.exports = {};
  },, function (e, t, n) {
    "use strict";
    var r = n(52),
        s = n(57),
        i = (n(26), n(2)),
        o = n(0),
        a = o.undef,
        c = n(170),
        u = n(80),
        l = n(117);function m(e) {
      o.verifyOptions(e, "appKey account token", "protocol::IMProtocol"), o.verifyCallback(e, ["onconnect", "onerror", "onwillreconnect", "ondisconnect", "onloginportschange", "onmyinfo", "onblacklist", "onmutelist", "onfriends", "onusers", "onrobots", "onteams", "onsessions", "onroamingmsgs", "onofflinemsgs", "onofflinefiltermsgs", "onroamingsysmsgs", "onofflinesysmsgs", "onofflinefiltersysmsgs", "onofflinecustomsysmsgs", "onofflinefiltercustomsysmsgs", "onbroadcastmsg", "onbroadcastmsgs", "onsysmsgunread", "onsyncdone", "onteammembers", "onsyncteammembersdone", "onmsg", "onsysmsg", "oncustomsysmsg", "onupdatemyinfo", "onupdateuser", "onupdateteammember", "onCreateTeam", "onUpdateTeam", "onAddTeamMembers", "onRemoveTeamMembers", "onUpdateTeamManagers", "onDismissTeam", "onTransferTeam", "onUpdateTeamMembersMute", "onTeamMsgReceipt", "onupdatesession", "onupdatesysmsgunread", "onupdatesysmsg", "onsynccreateteam", "onsyncmarkinblacklist", "onsyncmarkinmutelist", "onsyncfriendaction", "shouldIgnoreNotification", "shouldCountNotifyUnread", "onPushNotificationMultiportConfig", "onPushNotificationMultiportConfigUpdate", "onpushevents"], "protocol::IMProtocol"), this.db = e.api.db = new r({ logger: e.logger }), s.call(this, e);
    }var d = s.fn,
        f = m.fn = m.prototype = __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_create___default()(d);f.init = function () {
      d.init.call(this), u.IM.__proto__.protocol = this, this.parser = u.IM, this.sendCmd.bind(this), this.socketUrls = [], this.syncing = !0, this.hasSynced = !1, this.hasSyncedTeamMembers = !1, this.syncPromiseArray = [], this.syncResult = {}, this.syncTeamMembersPromiseArray = [], this.syncTeamMembersResult = {}, this.timetags = {}, this.sysMsgUnread = l.completeUnread({}), this.resetUnsettledMsgs(), this.resetUnsettledSysMsgs(), this.msgPromise = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve(), this.sysMsgPromise = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve(), this.sessionSet = {}, this.msgReceiptTasks = {}, this.userSet = {}, this.pushNotificationMultiportConfig = c.getDefaultConfig();
    }, f.reset = function () {
      d.reset.call(this);var e = this.options;this.db.reset(e.db), a(e.lbsUrl) && (e.lbsUrl = i.lbsUrl), this.resetAutoMarkRead();
    }, f.resetAutoMarkRead = function () {
      var e = this.options;o.verifyBooleanWithDefault(e, "autoMarkRead", !0, "", "protocol::resetAutoMarkRead");
    }, f.resetUnsettledMsgs = function () {
      this.unhandledMsgs = [], this.unupdatedMsgs = [];
    }, f.resetUnsettledSysMsgs = function () {
      this.unhandledSysMsgs = [], this.unupdatedSysMsgs = [];
    }, f.packetFromSync = function (e) {
      return !e.obj || !!e.obj.sync;
    }, e.exports = m, n(435), n(434), n(433), n(427), n(425), n(424), n(423), n(422), n(421), n(420), n(419), n(418), n(417), n(416), n(415), n(414), n(413);
  }, function (e, t, n) {
    "use strict";
    var r,
        s = n(9),
        i = (r = s) && r.__esModule ? r : { default: r };function o(e, t) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};this.message = e || n.message || "", "object" === (void 0 === t ? "undefined" : (0, i["default"])(t)) ? (this.event = t, this.code = "Other_Error") : void 0 !== t && (this.code = t), this.timetag = +new Date(), void 0 !== n && (this.event = n), this.event && (this.callFunc = this.event.callFunc || null, delete this.event.callFunc);
    }o.prototype = __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_create___default()(Error.prototype), o.prototype.name = "NIMError";var a = { 201: "客户端版本不对, 需升级sdk", 302: "用户名或密码错误, 请检查appKey和token是否有效, account和token是否匹配", 403: "非法操作或没有权限", 404: "对象(用户/群/聊天室)不存在", 405: "参数长度过长", 408: "客户端请求超时", 414: "参数错误", 415: "服务不可用/没有聊天室服务器可分配", 416: "频率控制", 417: "重复操作", 422: "帐号被禁用", 500: "服务器内部错误", 501: "数据库操作失败", 503: "服务器繁忙", 508: "删除有效期过了", 509: "已失效", 7101: "被拉黑", 801: "群人数达到上限", 802: "没有权限", 803: "群不存在或未发生变化", 804: "用户不在群里面", 805: "群类型不匹配", 806: "创建群数量达到限制", 807: "群成员状态不对", 809: "已经在群里", 811: "强推列表中帐号数量超限", 812: "群被禁言", 813: "因群数量限制，部分拉人成功", 814: "禁止使用群组消息已读服务", 815: "群管理员人数上限", 997: "协议已失效", 998: "解包错误", 999: "打包错误", 9102: "通道失效", 9103: "已经在其他端接听/拒绝过这通电话", 11001: "对方离线, 通话不可送达", 13002: "聊天室状态异常", 13003: "在黑名单中", 13004: "在禁言名单中", 13006: "聊天室处于整体禁言状态,只有管理员能发言", Connect_Failed: "无法建立连接, 请确保能 ping/telnet 到云信服务器; 如果是IE8/9, 请确保项目部署在 HTTPS 环境下", Error_Internet_Disconnected: "网断了", Error_Connection_is_not_Established: "连接未建立", Error_Connection_Socket_State_not_Match: "socket状态不对", Error_Timeout: "超时", Param_Error: "参数错误", No_File_Selected: "请选择文件", Wrong_File_Type: "文件类型错误", File_Too_Large: "文件过大", Cross_Origin_Iframe: "不能获取跨域Iframe的内容", Not_Support: "不支持", NO_DB: "无数据库", DB: "数据库错误", Still_In_Team: "还在群里", Session_Exist: "会话已存在", Session_Not_Exist: "会话不存在", Error_Unknown: "未知错误", Operation_Canceled: "操作取消" };[200, 406, 808, 810].forEach(function (e) {
      a[e] = null;
    }), o.genError = function (e) {
      var t = a[e];return void 0 === t && (t = "操作失败"), null === t ? null : new o(t, e);
    }, o.multiInstance = function (e) {
      return new o("不允许初始化多个实例", "Not_Allow_Multi_Instance", e);
    }, o.newNetworkError = function (e) {
      var t = "Error_Internet_Disconnected";return new o(a[t], t, e);
    }, o.newConnectError = function (e) {
      var t = "Connect_Failed";return new o(a[t] || null, t, e);
    }, o.newConnectionError = function (e) {
      var t = "Error_Connection_is_not_Established";return new o(a[t], t, e);
    }, o.newSocketStateError = function (e) {
      var t = "Error_Connection_Socket_State_not_Match";return new o(a[t], t, e);
    }, o.newTimeoutError = function (e) {
      var t = "Error_Timeout";return new o(a[t], t, e);
    }, o.newFrequencyControlError = function (e) {
      var t = new o(a[416], 416, e);return t.from = "local", t;
    }, o.newParamError = function (e, t) {
      return new o(e || a.Param_Error, "Param_Error", t);
    }, o.newNoFileError = function (e, t) {
      var n = "No_File_Selected";return new o(e || a[n], n, t);
    }, o.newWrongFileTypeError = function (e, t) {
      var n = "Wrong_File_Type";return new o(e || a[n], n, t);
    }, o.newFileTooLargeError = function (e, t) {
      var n = "File_Too_Large";return new o(e || a[n], n, t);
    }, o.newCORSIframeError = function (e) {
      var t = "Cross_Origin_Iframe";return new o(a[t], t, e);
    }, o.newSupportError = function (e, t, n) {
      return new o("不支持" + e, "Not_Support_" + t, n);
    }, o.newSupportDBError = function (e) {
      return o.newSupportError("数据库", "DB", e);
    }, o.noDBError = function (e) {
      return new o(a.NO_DB, "NO_DB", e);
    }, o.newDBError = function (e) {
      return new o(a.DB, "DB", e);
    }, o.newUnknownError = function (e) {
      var t = "Error_Unknown";return new o(a[t], t, e);
    }, o.stillInTeamError = function (e) {
      var t = "Still_In_Team";return new o(a[t], t, e);
    }, o.sessionExist = function (e) {
      var t = "Session_Exist";return new o(a[t], t, e);
    }, o.sessionNotExist = function (e) {
      var t = "Session_Not_Exist";return new o(a[t], t, e);
    }, o.cancel = function (e) {
      var t = "Operation_Canceled";return new o(a[t], t, e);
    }, o.customError = function (e, t) {
      e = e || "Other_Error";var n = "";return (t = t || {}).message || (n = a[e] || e), "object" !== (void 0 === e ? "undefined" : (0, i["default"])(e)) ? new o(n, e, t) : new o(n, "Other_Error", void 0 === t ? e : t);
    }, e.exports = o;
  }, function (e, t) {
    e.exports = function (e, t) {
      return { enumerable: !(1 & e), configurable: !(2 & e), writable: !(4 & e), value: t };
    };
  }, function (e, t) {
    t.f = {}.propertyIsEnumerable;
  }, function (e, t) {
    var n = 0,
        r = Math.random();e.exports = function (e) {
      return "Symbol(".concat(void 0 === e ? "" : e, ")_", (++n + r).toString(36));
    };
  }, function (e, t, n) {
    var r = n(62),
        s = n(41);e.exports = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_keys___default.a || function (e) {
      return r(e, s);
    };
  }, function (e, t) {
    var n;n = function () {
      return this;
    }();try {
      n = n || Function("return this")() || (0, eval)("this");
    } catch (e) {
      "object" == (typeof window === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_15_babel_runtime_helpers_typeof___default()(window)) && (n = window);
    }e.exports = n;
  }, function (e, t, n) {
    "use strict";
    var r = n(47),
        s = n(25),
        i = n(2),
        o = n(412),
        a = n(80).IM;function c(e) {
      return this.subType = "im", this.nosScene = e.nosScene || "im", this.nosSurvivalTime = e.nosSurvivalTime, e.Protocol = s, e.Message = o, e.constructor = c, this.init(e);
    }c.Protocol = s, c.parser = a, c.use = r.use, c.getInstance = r.getInstance, c.rmAllInstances = r.rmAllInstances, c.genInstanceName = function (e) {
      return "NIM-account-" + e.account;
    };var u = c.fn = c.prototype = __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_create___default()(r.prototype);c.info = u.info = i.info, e.exports = c, n(402), n(401), n(400), n(399), n(398), n(397), n(396), n(395), n(394), n(393), n(392), n(391), n(390), n(389), n(388), n(387), n(386);
  }, function (e, t) {
    var n = {}.toString;e.exports = function (e) {
      return n.call(e).slice(8, -1);
    };
  }, function (e, t, n) {
    var r = n(13).f,
        s = n(14),
        i = n(6)("toStringTag");e.exports = function (e, t, n) {
      e && !s(e = n ? e : e.prototype, i) && r(e, i, { configurable: !0, value: t });
    };
  }, function (e, t) {
    e.exports = !0;
  }, function (e, t, n) {
    "use strict";
    var r = n(49),
        s = n(135),
        i = n(134),
        o = n(133);r.json = s, r.upload = i, r.chunkUpload = o, e.exports = r;
  }, function (e, t, n) {
    var r = n(56);e.exports = function (e, t, n) {
      if (r(e), void 0 === t) return e;switch (n) {case 1:
          return function (n) {
            return e.call(t, n);
          };case 2:
          return function (n, r) {
            return e.call(t, n, r);
          };case 3:
          return function (n, r, s) {
            return e.call(t, n, r, s);
          };}return function () {
        return e.apply(t, arguments);
      };
    };
  }, function (e, t) {
    t.f = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_get_own_property_symbols___default.a;
  }, function (e, t, n) {
    var r = n(8),
        s = n(7),
        i = n(35),
        o = n(40),
        a = n(13).f;e.exports = function (e) {
      var t = s.Symbol || (s.Symbol = i ? {} : r.Symbol || {});"_" == e.charAt(0) || e in t || a(t, e, { value: o.f(e) });
    };
  }, function (e, t, n) {
    t.f = n(6);
  }, function (e, t) {
    e.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
  }, function (e, t, n) {
    var r = n(8),
        s = r["__core-js_shared__"] || (r["__core-js_shared__"] = {});e.exports = function (e) {
      return s[e] || (s[e] = {});
    };
  }, function (e, t, n) {
    var r = n(42)("keys"),
        s = n(29);e.exports = function (e) {
      return r[e] || (r[e] = s(e));
    };
  }, function (e, t, n) {
    var r = n(19);e.exports = function (e, t) {
      if (!r(e)) return e;var n, s;if (t && "function" == typeof (n = e.toString) && !r(s = n.call(e))) return s;if ("function" == typeof (n = e.valueOf) && !r(s = n.call(e))) return s;if (!t && "function" == typeof (n = e.toString) && !r(s = n.call(e))) return s;throw TypeError("Can't convert object to primitive value");
    };
  }, function (e, t) {
    e.exports = function (e) {
      if (null == e) throw TypeError("Can't call method on  " + e);return e;
    };
  }, function (e, t) {
    var n = Math.ceil,
        r = Math.floor;e.exports = function (e) {
      return isNaN(e = +e) ? 0 : (e > 0 ? r : n)(e);
    };
  }, function (e, t, n) {
    "use strict";
    var r,
        s = n(9),
        i = (r = s) && r.__esModule ? r : { default: r };var o = n(10),
        a = n(0),
        c = a.notundef,
        u = n(304),
        l = n(2);function m() {}var d = {};m.getInstance = function (e) {
      e = p(e), a.verifyOptions(e, "account", "api::Base.getInstance");var t = this.genInstanceName(e),
          n = d[t];return n ? m.updateInstance(n, e) : n = d[t] = new this(e), n;
    }, m.updateInstance = function (e, t) {
      e.setOptions(t), e.connect();
    };var f = m.fn = m.prototype = __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_create___default()(new o()),
        p = function p(e) {
      return e.nosSurvivalTime ? (a.verifyParamType("nosSurvivalTime", e.nosSurvivalTime, "number", "api::Base.getInstance"), a.verifyParamMin("nosSurvivalTime", e.nosSurvivalTime, 86400, "api::Base.getInstance")) : e.nosSurvivalTime = 1 / 0, e;
    };f.updatePrivateConf = function (e) {
      if (e && "object" === (0, i["default"])(e.privateConf)) {
        var t = e.privateConf;"string" == typeof t.lbs_web && (e.lbsUrl = t.lbs_web), "boolean" == typeof t.link_ssl_web && (e.secure = t.link_ssl_web), "boolean" == typeof t.https_enabled && (e.httpsEnabled = t.https_enabled), e.uploadUrl = t.nos_uploader_web ? t.nos_uploader_web : null, e.chunkUploadUrl = t.nos_uploader_web ? t.nos_uploader_web : null, e.replaceUrl = t.nos_downloader ? t.nos_downloader : null, e.downloadUrl = t.nos_accelerate ? t.nos_accelerate : null, e.downloadHost = t.nos_accelerate_host ? t.nos_accelerate_host : null, e.ntServerAddress = t.nt_server;
      }return null === e.ntServerAddress || "" === e.ntServerAddress ? l.ntServerAddress = null : l.ntServerAddress = e.ntServerAddress || l.defaultReportUrl, l.uploadUrl = e.uploadUrl || l.uploadUrl, l.downloadUrl = e.downloadUrl || l.downloadUrl, l.downloadHost = e.downloadHost || l.downloadHost, l.replaceUrl = e.replaceUrl || l.replaceUrl, l.httpsEnabled = e.httpsEnabled || l.httpsEnabled, e;
    }, f.init = function (e) {
      a.verifyOptions(e, "account", "api::Base.init"), e = this.updatePrivateConf(e);var t = this.account = e.account = e.account + "",
          n = e.constructor.genInstanceName(e),
          r = d[n];if (e._disableSingleton && (r = null), r) return m.updateInstance(r, e), r;this.name = n, d[n] = this, this.logger = e.logger = new u({ debug: e.debug, logFunc: e.logFunc, prefix: this.subType }), e.api = this;var s = this.protocol = new e.Protocol(e);return s.name = "Protocol-" + n, s.account = t, s.api = this, s.message = this.message = new e.Message({ account: t }), this.options = a.copy(e), this.reset(), this;
    }, f.destroy = function (e) {
      e = e || {};var t = this.name;this.protocol && this.protocol.resetPush && this.protocol.resetPush();var n = this;this.disconnect({ done: function done(r) {
          n.logger.warn("ApiBase::destroy: instance destroyed ..."), __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_get_own_property_names___default()(n).forEach(function (e) {
            delete n[e];
          }), d && (delete d[t], d[t] = null), e.done instanceof Function && e.done(r);
        } });
    }, f.reset = function () {
      var e = this.updatePrivateConf(this.options);a.verifyBooleanWithDefault(e, "exifOrientation", !0, "", "api::Base.reset");
    }, f.setOptions = function (e) {
      this.reset(), this.protocol.setOptions(e);
    }, f.processCallback = function (e, t) {
      g(e, t);
    }, f.processCallbackPromise = function (e, t) {
      return new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a(function (n, r) {
        g(e, t, !0, n, r);
      });
    };var g = function g(e, t, n, r, s) {
      var i = "api::processCallback";n && (i = "api::processCallbackPromise"), a.verifyCallback(e, "done", i), e.callback = function (o, u, l) {
        var m = e.callback.options;if (u = u || m, t && (u = m), a.isFunction(e.cbaop)) {
          var d = e.cbaop(o, u);c(d) && (u = d);
        }var f = e.done;a.isObject(u) && (delete u.done, delete u.cb, delete u.callback), n ? o ? s({ message: "生成接口回调错误", callFunc: i, event: o }) : r(u) : f(o, u, l);
      }, e.callback.options = a.copy(e);
    };f.processPs = function (e) {
      a.notexist(e.ps) && (e.ps = "");
    }, f.processCustom = function (e) {
      a.notexist(e.custom) && (e.custom = "");
    }, f.sendCmd = function () {
      this.protocol.sendCmd.apply(this.protocol, arguments);
    }, f.sendCmdWithResp = function (e, t, n) {
      this.sendCmd(e, t, function (e, t, r) {
        a.isFunction(n) && (e ? n(e, t) : n(null, r));
      });
    }, f.cbAndSendCmd = function (e, t) {
      var n = this.processCallbackPromise(t);return this.sendCmd(e, t), n;
    }, f.sendCmdUsePromise = function (e, t) {
      var n = this;return new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a(function (r, s) {
        n.sendCmd(e, t, function (e, t, n) {
          if (e) s(e);else {
            var i = a.merge({}, t, n);r(i);
          }
        });
      });
    }, m.use = function (e, t) {
      e && e.install && a.isFunction(e.install) && e.install(this, t);
    }, m.rmAllInstances = function () {
      for (var e in d) {
        d[e].destroy();
      }d = {};
    }, f.logout = function (e) {
      this.protocol.shouldReconnect = !1, this.protocol.doLogout = !0, this.processCallback(e), this.sendCmd("logout", e, e.callback);
    }, e.exports = m, n(303), n(302), n(299), n(298), n(297), n(296), n(295);
  }, function (e, t, n) {
    var r = n(45);e.exports = function (e) {
      return Object(r(e));
    };
  }, function (e, t, n) {
    "use strict";
    var r = n(12),
        s = n(139),
        i = n(137),
        o = n(136),
        a = {},
        c = r.f;function u(e) {
      var t = e.upload = "multipart/form-data" === (e.headers || r.o)["Content-Type"],
          n = !1;try {
        n = (location.protocol + "//" + location.host).toLowerCase() !== r.url2origin(e.url);
      } catch (e) {}return e.cors = n, t || n || e.mode ? function (e) {
        var t = e.mode,
            n = s,
            a = r.getGlobal();return !a.FormData && a.document && (t = "iframe"), "iframe" === t && (n = e.upload ? i : o), new n(e);
      }(e) : new s(e);
    }function l(e, t, n) {
      var r = a[e];if (r) {
        "onload" === t && r.result && (n = function (e, t) {
          t = { data: t };var n = e.result.headers;return n && (t.headers = e.req.header(n)), t;
        }(r, n)), function (e) {
          var t = a[e];t && (t.req.destroy(), delete a[e]);
        }(e);var s = { type: t, result: n };c(s), s.stopped || r[t](s.result);
      }
    }function m(e, t) {
      var n = r.genUrlSep(e);return t = t || "", r.isObject(t) && (t = r.object2query(t)), t && (e += n + t), e;
    }function d(e, t) {
      t = t || {};var n = r.uniqueID(),
          s = { result: t.result, onload: t.onload || r.f, onerror: t.onerror || r.f };a[n] = s, t.onload = function (e, t) {
        l(e, "onload", t);
      }.bind(null, n), t.onerror = function (e, t) {
        l(e, "onerror", t);
      }.bind(null, n), t.query && (e = m(e, t.query));var i = t.method || "";return i && !/get/i.test(i) || !t.data || (e = m(e, t.data), t.data = null), t.url = e, s.req = u(t), n;
    }d.filter = function (e) {
      r.isFunction(e) && (c = e);
    }, d.abort = function (e) {
      var t = a[e];t && t.req && t.req.abort();
    }, e.exports = d;
  }, function (e, t, n) {
    var r = n(16),
        s = n(102),
        i = n(41),
        o = n(43)("IE_PROTO"),
        a = function a() {},
        _c = function c() {
      var e,
          t = n(53)("iframe"),
          r = i.length;for (t.style.display = "none", n(76).appendChild(t), t.src = "javascript:", (e = t.contentWindow.document).open(), e.write("<script>document.F=Object<\/script>"), e.close(), _c = e.F; r--;) {
        delete _c.prototype[i[r]];
      }return _c();
    };e.exports = __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_create___default.a || function (e, t) {
      var n;return null !== e ? (a.prototype = r(e), n = new a(), a.prototype = null, n[o] = e) : n = _c(), void 0 === t ? n : s(n, t);
    };
  }, function (e, t, n) {
    "use strict";
    var r = n(104)(!0);n(65)(String, "String", function (e) {
      this._t = String(e), this._i = 0;
    }, function () {
      var e,
          t = this._t,
          n = this._i;return n >= t.length ? { value: void 0, done: !0 } : (e = r(t, n), this._i += e.length, { value: e, done: !1 });
    });
  }, function (e, t, n) {
    "use strict";
    var r = n(448);r.fn = r.prototype, e.exports = r, n(445), n(444), n(443), n(442), n(441), n(440), n(439), n(438), n(437), n(436);
  }, function (e, t, n) {
    var r = n(19),
        s = n(8).document,
        i = r(s) && r(s.createElement);e.exports = function (e) {
      return i ? s.createElement(e) : {};
    };
  }, function (e, t, n) {
    "use strict";
    var r = n(0),
        s = { init: function init() {
        s.deviceId = r.guid();
      } };s.init(), s.clientTypeMap = { 1: "Android", 2: "iOS", 4: "PC", 8: "WindowsPhone", 16: "Web", 32: "Server", 64: "Mac" }, s.db = { open: function open() {} }, e.exports = s;
  }, function (e, t, n) {
    n(99);for (var r = n(8), s = n(20), i = n(23), o = n(6)("toStringTag"), a = "CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(","), c = 0; c < a.length; c++) {
      var u = a[c],
          l = r[u],
          m = l && l.prototype;m && !m[o] && s(m, o, u), i[u] = i.Array;
    }
  }, function (e, t) {
    e.exports = function (e) {
      if ("function" != typeof e) throw TypeError(e + " is not a function!");return e;
    };
  }, function (e, t, n) {
    "use strict";
    var r = n(0),
        s = n(2),
        i = n(26);function o(e) {
      r.undef(e.secure) && (e.secure = !0), this.options = r.copy(e), this.keepNosSafeUrl = this.options.keepNosSafeUrl || !1, this.init(), this.connect(), this.initConnecting = !0;
    }var a = o.fn = o.prototype;a.init = function () {
      this.logger = this.options.logger, this.getNosOriginUrlReqNum = 0, this.checkNosReqNum = 0, this.cmdTaskArray = [], this.timerMap = {}, this.cmdCallbackMap = {}, this.cmdContentMap = {}, this.initConnect(), this.reset();
    }, a.reset = function () {
      this.resetConnect();
    }, a.setOptions = function (e) {
      var t = this.options,
          n = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_keys___default()(t),
          s = n.indexOf("account");-1 !== s && n.splice(s, 1), e = r.filterObj(e, n), this.options = r.merge(t, e), this.reset();
    }, a.sendCmd = function (e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
          n = arguments[2];this.heartbeat(), "heartbeat" !== e && this.logger.warn("protocol::sendCmd: " + e, t);var r,
          s = e,
          i = (e = this.parser.createCmd(e, t)).SER;t = t || {}, this.cmdContentMap[i] = t, t.single && (delete t.single, 1 === (r = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_keys___default()(t)).length && (this.cmdContentMap[i] = t[r[0]])), t.NOTSTORE && ((r = t.NOTSTORE.split(" ")).forEach(function (e) {
        delete t[e];
      }), delete t.NOTSTORE), (n = n || t.callback) && (this.cmdCallbackMap[i] = n), this.cmdTaskArray.push({ cmdName: s, cmd: __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_json_stringify___default()(e) }), this.startCmdTaskTimer();
    }, a.startCmdTaskTimer = function () {
      var e = this;e.cmdTaskTimer || (e.cmdTaskTimer = setTimeout(function () {
        var t = e.cmdTaskArray.shift();e.cmdTaskTimer = null, t && e.executeCmdTask(t), e.cmdTaskArray.length && e.startCmdTaskTimer();
      }, 0));
    }, a.executeCmdTask = function (e) {
      var t = e.cmdName,
          n = e.cmd,
          r = (n = JSON.parse(n)).SER;this.isFrequencyControlled(t) ? (this.logger.warn("protocol::executeCmdTask: " + t + " hit freq control"), this.markCallbackInvalid(r, i.newFrequencyControlError({ callFunc: "protocol::executeCmdTask", message: t + " hit freq control" }))) : this.isConnected() ? ("heartbeat" !== t && this.logger.log("protocol::sendCmd: " + t + " " + __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_json_stringify___default()(n)), this.doSendCmd(n)) : (this.logger.warn("protocol::executeCmdTask: " + t + " not connected"), this.markCallbackInvalid(r, i.newSocketStateError({ callFunc: "protocol::executeCmdTask", message: t + " not connected" })));
    }, a.isFrequencyControlled = function (e) {
      var t = this.frequencyControlMap && this.frequencyControlMap[e];if (t) {
        if (Date.now() < t.from + t.duration) return !0;delete this.frequencyControlMap[e];
      }
    }, a.doSendCmd = function (e) {
      var t = this,
          n = e.SER;function r() {
        t.markCallbackInvalid(n, i.newSocketStateError({ callFunc: "protocol::doSendCmd", message: "ser " + n + " socketSendJson Error" })), t.onDisconnect(!0, "protocol::doSendCmd:socketSendJson");
      }t.timerMap[n] = setTimeout(function () {
        t.markCallbackInvalid(n, i.newTimeoutError({ callFunc: "protocol::doSendCmd", message: "ser " + n + " Timeout Error" }));
      }, s.cmdTimeout);try {
        t.socket && t.socket.send ? t.socket.send(__WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_json_stringify___default()(e)) : r();
      } catch (e) {
        r();
      }
    }, a.getObjWithSer = function (e) {
      var t = this.cmdContentMap[e];return delete this.cmdContentMap[e], t && r.copy(t);
    }, a.getCallbackWithSer = function (e) {
      var t = this.cmdCallbackMap[e];return t && !t.isImSyncDataCb && delete this.cmdCallbackMap[e], t;
    }, a.getTimerWithSer = function (e) {
      var t = this.timerMap[e];return delete this.timerMap[e], t;
    }, a.clearTimerWithSer = function (e) {
      var t = this.getTimerWithSer(e);t && clearTimeout(t);
    }, a.markCallbackInvalid = function (e, t) {
      this.getObjWithSer(e), this.clearTimerWithSer(e);var n = this.getCallbackWithSer(e);if (n) {
        var r = n.options;setTimeout(function () {
          n(t || i.newUnknownError({ ser: e }), r);
        }, 0);
      }
    }, a.markAllCallbackInvalid = function (e) {
      var t = this;__WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_keys___default()(this.cmdCallbackMap).forEach(function (n) {
        t.markCallbackInvalid(n, e);
      });
    }, a.getPacketObj = function (e) {
      var t = null;if (e && e.raw) {
        var n = e.raw.ser;r.notundef(n) && (t = this.getObjWithSer(n));
      }return t;
    }, a.callPacketAckCallback = function (e) {
      var t = this;if (e && e.raw) {
        var n = e.raw.ser;if (r.notundef(n)) {
          t.clearTimerWithSer(n);var s = t.getCallbackWithSer(n);s && (s.originUrl && e.obj && e.obj.file && (e.obj.file._url_safe = e.obj.file.url, e.obj.file.url = s.originUrl, "audio" === e.obj.type && (e.obj.file.mp3Url = s.originUrl + (~s.originUrl.indexOf("?") ? "&" : "?") + "audioTrans&type=mp3")), e.promise ? e.promise.then(function () {
            s(e.error, e.obj);
          }, function (r) {
            r.callFunc = "protocol::callPacketAckCallback", r.message = "Resp Promoise Error: cmd: " + e.cmd + ", ser: " + n;var o = i.customError("CALLBACK_ACK_ERR", r);t.logger.error("protocol::callPacketAckCallback: promise error " + __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_json_stringify___default()(r)), s(o, e.obj, e.content);
          }) : s(e.error, e.obj, e.content));
        }
      }
    }, a.onMessage = function (e) {
      var t = this;t.heartbeat(), t.parser.parseResponse(e).then(function (e) {
        e.notFound && t.logger.warn("protocol::onMessage: packet not found " + __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_json_stringify___default()(e)), e.error ? (e.error.message = e.cmd + " error: " + e.error.message, t.logger.error("protocol::onMessage: packet error " + __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_json_stringify___default()(e.error))) : e.content || "heartbeat" === e.cmd || t.logger.warn("protocol::onMessage: packet.content undefined " + __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_json_stringify___default()(e)), e.frequencyControlDuration && (t.logger.error("protocol::onMessage: server freq control " + __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_json_stringify___default()(e.cmd)), t.frequencyControlMap = t.frequencyControlMap || {}, t.frequencyControlMap[e.cmd] = { from: +new Date(), duration: e.frequencyControlDuration }), e.obj = t.getPacketObj(e), "heartbeat" !== e.cmd && "getClientAntispam" !== e.cmd && t.logger.log("protocol::recvCmd: " + e.cmd + " " + e.rawStr);var n = "process" + r.capFirstLetter(e.service);if (t[n]) {
          if ("heartbeat" !== e.cmd && t.logger.warn("protocol::recvCmd: " + e.cmd + " " + n, e.content), "syncDone" === e.cmd) {
            if (t.cmdCallbackMap[e.raw.ser] && t.cmdCallbackMap[e.raw.ser].isImSyncDataCb) {
              t.cmdCallbackMap[e.raw.ser].isImSyncDataCb = !1;var s = function (e, t) {
                this.checkNosReqNum++, this.getNosOriginUrlReqNum <= 0 || this.checkNosReqNum >= 10 ? this[e](t) : setTimeout(s, 300);
              }.bind(t, n, e);s.call(t, n, e);
            }
          } else t[n](e);
        } else t.logger.warn("protocol::onMessage: " + n + " not found");t.callPacketAckCallback(e);
      });
    }, a.onMiscError = function (e, t, n) {
      t && this.notifyError(e, t, n);
    }, a.onCustomError = function (e, t) {
      var n = i.customError(e, t),
          r = t.message || "未知错误";this.onMiscError(r, n);
    }, a.notifyError = function (e, t, n) {
      this.isConnected() && (this.logger.error((e || "") + " " + this.name, t, n), this.options.onerror(t, n));
    }, a.emitAPI = function (e) {
      var t = e.type,
          n = e.obj;this.api.emit(t, n);
    }, e.exports = o, n(294), n(292), n(291), n(290), n(289);
  }, function (e, t, n) {
    "use strict";
    t.__esModule = !0;var r,
        s = n(85),
        i = (r = s) && r.__esModule ? r : { default: r };t["default"] = i["default"] || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }return e;
    };
  }, function (e, t, n) {
    var r = n(28),
        s = n(27),
        i = n(18),
        o = n(44),
        a = n(14),
        c = n(64),
        u = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_own_property_descriptor___default.a;t.f = n(15) ? u : function (e, t) {
      if (e = i(e), t = o(t, !0), c) try {
        return u(e, t);
      } catch (e) {}if (a(e, t)) return s(!r.f.call(e, t), e[t]);
    };
  }, function (e, t, n) {
    var r = n(62),
        s = n(41).concat("length", "prototype");t.f = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_get_own_property_names___default.a || function (e) {
      return r(e, s);
    };
  }, function (e, t, n) {
    var r = n(33);e.exports = Object("z").propertyIsEnumerable(0) ? Object : function (e) {
      return "String" == r(e) ? e.split("") : Object(e);
    };
  }, function (e, t, n) {
    var r = n(14),
        s = n(18),
        i = n(101)(!1),
        o = n(43)("IE_PROTO");e.exports = function (e, t) {
      var n,
          a = s(e),
          c = 0,
          u = [];for (n in a) {
        n != o && r(a, n) && u.push(n);
      }for (; t.length > c;) {
        r(a, n = t[c++]) && (~i(u, n) || u.push(n));
      }return u;
    };
  }, function (e, t, n) {
    e.exports = n(20);
  }, function (e, t, n) {
    e.exports = !n(15) && !n(21)(function () {
      return 7 != Object.defineProperty(n(53)("div"), "a", { get: function get() {
          return 7;
        } }).a;
    });
  }, function (e, t, n) {
    "use strict";
    var r = n(35),
        s = n(17),
        i = n(63),
        o = n(20),
        a = n(23),
        c = n(103),
        u = n(34),
        l = n(75),
        m = n(6)("iterator"),
        d = !([].keys && "next" in [].keys()),
        f = function f() {
      return this;
    };e.exports = function (e, t, n, p, g, h, y) {
      c(n, t, p);var v,
          b,
          M,
          T = function T(e) {
        if (!d && e in I) return I[e];switch (e) {case "keys":case "values":
            return function () {
              return new n(this, e);
            };}return function () {
          return new n(this, e);
        };
      },
          S = t + " Iterator",
          k = "values" == g,
          P = !1,
          I = e.prototype,
          C = I[m] || I["@@iterator"] || g && I[g],
          O = C || T(g),
          w = g ? k ? T("entries") : O : void 0,
          x = "Array" == t && I.entries || C;if (x && (M = l(x.call(new e()))) !== Object.prototype && M.next && (u(M, S, !0), r || "function" == typeof M[m] || o(M, m, f)), k && C && "values" !== C.name && (P = !0, O = function O() {
        return C.call(this);
      }), r && !y || !d && !P && I[m] || o(I, m, O), a[t] = O, a[S] = f, g) if (v = { values: k ? O : T("values"), keys: h ? O : T("keys"), entries: w }, y) for (b in v) {
        b in I || i(I, b, v[b]);
      } else s(s.P + s.F * (d || P), t, v);return v;
    };
  }, function (e, t, n) {
    "use strict";
    var r = n(12),
        s = r.f,
        i = n(138);function o(e) {
      e.onload && this.once("load", e.onload), e.onerror && this.once("error", e.onerror), e.onbeforesend && this.once("beforesend", e.onbeforesend), e.onaftersend && this.once("aftersend", e.onaftersend);var t = (e = this.options = r.fetch({ method: "GET", url: "", sync: !1, data: null, headers: {}, cookie: !1, timeout: 6e4, type: "text", form: null, input: null, putFileAtEnd: !1, proxyUrl: "" }, e)).headers;r.notexist(t["Content-Type"]) && (t["Content-Type"] = "application/x-www-form-urlencoded"), this.send();
    }var a = o.prototype = __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_create___default()(i.prototype);a.send = function () {
      var e = this,
          t = e.options;setTimeout(function () {
        try {
          try {
            e.emit("beforesend", t);
          } catch (e) {
            console.log("error:", "ignore error ajax beforesend,", e);
          }e.doSend();
        } catch (t) {
          console.log("error:", "ignore error server error,", t), e.onError("serverError", "请求失败:" + t.message);
        }
      }, 0);
    }, a.doSend = s, a.afterSend = function () {
      var e = this;setTimeout(function () {
        e.emit("aftersend", e.options);
      }, 0);
    }, a.onLoad = function (e) {
      var t = this.options,
          n = e.status,
          r = e.result;if (0 === ("" + n).indexOf("2")) {
        if ("json" === t.type) try {
          r = JSON.parse(r);
        } catch (e) {
          return console.log("error:", "ignore error parse json,", e), void this.onError("parseError", r);
        }this.emit("load", r);
      } else this.onError("serverError", "服务器返回异常状态", { status: n, result: r });
    }, a.onError = function (e, t, n) {
      var s = r.isObject(n) ? n : {};s.code = e || "error", s.message = t || "发生错误", this.emit("error", s);
    }, a.onTimeout = function () {
      this.onError("timeout", "请求超时");
    }, a.abort = function () {
      this.onError("abort", "客户端中止");
    }, a.header = function (e) {
      var t = this;if (!r.isArray(e)) return t.getResponseHeader(e || "");var n = {};return e.forEach(function (e) {
        n[e] = t.header(e);
      }), n;
    }, a.getResponseHeader = s, a.destroy = s, e.exports = o;
  }, function (e, t, n) {
    "use strict";
    var r = n(2),
        s = { genUrlSep: function genUrlSep(e) {
        return -1 === (e = "" + e).indexOf("?") ? "?imageView&" : "&";
      }, urlQuery2Object: function urlQuery2Object(e) {
        if ("[object String]" !== Object.prototype.toString.call(e) || "" === e) return {};var t = e.indexOf("?");if (-1 !== t) {
          var n = e.slice(t + 1).split("&"),
              r = {};return n.forEach(function (e) {
            if (~e.indexOf("=")) {
              var t = e.split("=");r[t[0]] = decodeURIComponent(t[1]);
            } else r[e] = "";
          }), r;
        }
      }, url2object: function url2object(e) {
        "[object String]" !== Object.prototype.toString.call(e) && (e = "");var t = (e = e || "").indexOf("https") >= 0 ? "https://" : "http://",
            n = e.replace(t, "");n.indexOf("?") >= 0 && (n = n.substring(0, n.indexOf("?")));var r = n.split("/");n = r[0];var s = "";if (r.length > 0 && (s = r.slice(1).join("/")), -1 === e.indexOf("?")) return { protocol: t, hostname: n, path: s, query: {} };var i = e.substr(e.indexOf("?") + 1).split("&"),
            o = {};return i.forEach(function (e) {
          if (e.indexOf("=") > 0) {
            var t = e.split("=");o[t[0]] = decodeURIComponent(t[1]);
          } else o[e] = "";
        }), { protocol: t, hostname: n, path: s, query: o };
      }, object2url: function object2url(e) {
        var t = e.protocol,
            n = e.hostname,
            r = e.path,
            s = e.query;t = t || "http://", n = n || "", r && (n = n + "/" + r), s = s || {};var i = [];for (var o in s) {
          "imageView" !== o && i.push(o + "=" + encodeURIComponent(s[o]));
        }return i.length > 0 ? "" + t + n + "?imageView&" + i.join("&") : "" + t + n;
      }, genPrivateUrl: function genPrivateUrl(e) {
        var t = s.url2object(e),
            n = t.hostname,
            i = t.path,
            o = r.downloadHost,
            a = r.downloadUrl;if (n === o) {
          var c = i.indexOf("/");if (-1 !== c) {
            var u = i.substring(0, c),
                l = i.substring(c + 1);return a.replace("{bucket}", u).replace("{object}", l);
          }
        } else if (n && "[object String]" == Object.prototype.toString.call(n) && ~n.indexOf(o)) {
          var m = t.path,
              d = m.indexOf(".");if (-1 !== d) {
            var f = m.substring(0, d),
                p = m;return a.replace("{bucket}", f).replace("{object}", p);
          }
        }return e;
      } };e.exports = s;
  }, function (e, t) {
    e.exports = function (e, t) {
      var n = t.split(".");for (; n.length;) {
        var r = n.shift(),
            s = !1;if ("?" == r[r.length - 1] && (r = r.slice(0, -1), s = !0), !(e = e[r]) && s) return e;
      }return e;
    };
  }, function (e, t, n) {
    var r = n(46),
        s = Math.min;e.exports = function (e) {
      return e > 0 ? s(r(e), 9007199254740991) : 0;
    };
  },,, function (e, t, n) {
    "use strict";
    var r,
        s = n(9),
        i = (r = s) && r.__esModule ? r : { default: r };var o = n(0),
        a = o.undef,
        c = o.notundef,
        u = o.exist,
        l = n(118),
        m = n(176),
        d = "#%@all@%#",
        f = { p2p: 0, team: 1 },
        p = { 0: "p2p", 1: "team" },
        g = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_keys___default()(f),
        h = m.typeMap,
        y = m.validTypes;function v(e) {
      o.verifyOptions(e, "scene to type", "msg::Message"), o.verifyParamValid("scene", e.scene, g, "msg::Message");this.scene = f[e.scene], this.to = "" + e.to, this.type = h[e.type], this.resend = e.resend ? 1 : 0, e.resend ? (o.verifyOptions(e, "idClient", "msg::Message"), this.idClient = e.idClient) : this.idClient = o.guid(), c(e.text) && (this.body = "" + e.text), c(e.custom) && ("object" === (0, i["default"])(e.custom) ? (this.logger.warn("model::Message: custom should be JsonString, auto transfer"), this.custom = __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_json_stringify___default()(e.custom)) : this.custom = "" + e.custom), c(e.body) && (this.body = "" + e.body), c(e.pushContent) && (this.pushContent = "" + e.pushContent), c(e.pushPayload) && (this.pushPayload = "" + e.pushPayload);var t = e.apns;if (c(t) && "team" === e.scene) {
        var n = t.accounts;c(n) && o.verifyParamType("apns.accounts", n, "array", "msg::Message"), this.apnsAccounts = n ? __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_json_stringify___default()(n) : d, this.apnsContent = t.content || e.pushContent || "", o.verifyBooleanWithDefault(t, "forcePush", !0, "options.apns", "msg::Message"), this.apnsForcePush = t.forcePush ? 1 : 0;
      }c(e.isHistoryable) && (this.isHistoryable = e.isHistoryable ? 1 : 0), c(e.isRoamingable) && (this.isRoamingable = e.isRoamingable ? 1 : 0), c(e.isSyncable) && (this.isSyncable = e.isSyncable ? 1 : 0), c(e.cc) && (this.cc = e.cc ? 1 : 0), c(e.isPushable) && (this.isPushable = e.isPushable ? 1 : 0), c(e.isOfflinable) && (this.isOfflinable = e.isOfflinable ? 1 : 0), c(e.isUnreadable) && (this.isUnreadable = e.isUnreadable ? 1 : 0), c(e.needPushNick) && (this.needPushNick = e.needPushNick ? 1 : 0), c(e.needMsgReceipt) && (this.needMsgReceipt = e.needMsgReceipt ? 1 : 0), c(e.yidunEnable) && (this.yidunEnable = e.yidunEnable ? 1 : 0), c(e.antiSpamUsingYidun) && (this.antiSpamUsingYidun = e.antiSpamUsingYidun ? 1 : 0), c(e.clientAntiSpam) && (this.clientAntiSpam = e.clientAntiSpam ? 1 : 0), c(e.antiSpamContent) && ("object" === (0, i["default"])(e.antiSpamContent) ? (this.logger.warn("model::Message: antiSpamContent should be JsonString, auto transfer"), this.antiSpamContent = __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_json_stringify___default()(e.antiSpamContent)) : this.antiSpamContent = "" + e.antiSpamContent), c(e.antiSpamBusinessId) && ("object" === (0, i["default"])(e.antiSpamBusinessId) ? (this.logger.warn("model::Message: antiSpamBusinessId should be JsonString, auto transfer"), this.antiSpamBusinessId = __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_json_stringify___default()(e.antiSpamBusinessId)) : this.antiSpamBusinessId = "" + e.antiSpamBusinessId);
    }o.merge(v.prototype, m.prototype), v.prototype.getScene = function () {
      return p[this.scene];
    }, v.getType = m.getType, v.reverse = function (e) {
      var t = { scene: p[e.scene] || e.scene, from: e.from, fromNick: e.fromNick, fromClientType: l.reverseType(e.fromClientType), fromDeviceId: e.fromDeviceId, to: "" + e.to, time: +e.time, type: v.getType(e), text: u(e.body) ? e.body : "", isHistoryable: a(e.isHistoryable) || 1 == +e.isHistoryable, isRoamingable: a(e.isRoamingable) || 1 == +e.isRoamingable, isSyncable: a(e.isSyncable) || 1 == +e.isSyncable, cc: a(e.cc) || 1 == +e.cc, isPushable: a(e.isPushable) || 1 == +e.isPushable, isOfflinable: a(e.isOfflinable) || 1 == +e.isOfflinable, isUnreadable: a(e.isUnreadable) || 1 == +e.isUnreadable, isReplyMsg: a(e.isReplyMsg) || 1 == +e.isReplyMsg, needPushNick: a(e.needPushNick) || 1 == +e.needPushNick, needMsgReceipt: 1 == +e.needMsgReceipt, isLocal: !1 };if (e.isInBlackList && (t.isInBlackList = 1 == +e.isInBlackList), c(e.isMuted) && (t.isMuted = 1 == +e.isMuted), c(e.resend) && (t.resend = 1 == +e.resend), c(e.idClient) && (t.idClient = e.idClient), c(e.idServer) && (t.idServer = "" + e.idServer), c(e.userUpdateTime) && (t.userUpdateTime = +e.userUpdateTime), c(e.custom) && (t.custom = e.custom), c(e.pushContent) && (t.pushContent = e.pushContent), c(e.pushPayload) && (t.pushPayload = e.pushPayload), c(e.tempTeamMemberCount) && (t.tempTeamMemberCount = +e.tempTeamMemberCount), c(e.apnsAccounts)) {
        if (t.apns = {}, e.apnsAccounts !== d) {
          var n = e.apnsAccounts;try {
            t.apns.accounts = JSON.parse(n);
          } catch (e) {
            t.apns.accounts = [];
          }
        }t.apns.content = e.apnsContent || "", t.apns.forcePush = 1 == +e.apnsForcePush;
      }return t.status = e.status || "success", c(e.filter) && (t.filter = e.filter), t;
    }, v.setExtra = function (e, t) {
      e.target = v.getMsgTarget(e, t), e.sessionId = e.scene + "-" + e.target, m.setFlow(e, t);
    }, v.getMsgTarget = function (e, t) {
      return "p2p" === e.scene ? e.to === t ? e.from : e.to : "team" === e.scene ? e.to : void 0;
    }, v.deduplication = function (e) {
      var t,
          n = {},
          r = [];return e.forEach(function (e) {
        t = e.idClient, n[t] || (n[t] = !0, r.push(e));
      }), r;
    }, v.sortMsgs = function (e) {
      return e = e.slice(0), o.sortObjArray(e, { sortPath: "time" }), e;
    }, v.getLastMsg = function (e) {
      return (e = v.sortMsgs(e))[e.length - 1];
    }, v.getLastNotIgnoredMsg = function (e) {
      for (var t = null, n = (e = v.sortMsgs(e)).length - 1; n >= 0; n--) {
        if (!(t = e[n]).ignore) return t;
      }return null;
    }, v.getMaxTimetag = function (e) {
      return v.getLastMsg(e).time;
    }, v.validScenes = g, v.validTypes = y, e.exports = v;
  }, function (e, t) {
    e.exports = function e(t, n) {
      "use strict";
      var r,
          s,
          i = /(^([+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?)?$|^0x[0-9a-f]+$|\d+)/gi,
          o = /(^[ ]*|[ ]*$)/g,
          a = /(^([\w ]+,?[\w ]+)?[\w ]+,?[\w ]+\d+:\d+(:\d+)?[\w ]?|^\d{1,4}[\/\-]\d{1,4}[\/\-]\d{1,4}|^\w+, \w+ \d+, \d{4})/,
          c = /^0x[0-9a-f]+$/i,
          u = /^0/,
          l = function l(t) {
        return e.insensitive && ("" + t).toLowerCase() || "" + t;
      },
          m = l(t).replace(o, "") || "",
          d = l(n).replace(o, "") || "",
          f = m.replace(i, "\0$1\0").replace(/\0$/, "").replace(/^\0/, "").split("\0"),
          p = d.replace(i, "\0$1\0").replace(/\0$/, "").replace(/^\0/, "").split("\0"),
          g = parseInt(m.match(c), 16) || 1 !== f.length && m.match(a) && Date.parse(m),
          h = parseInt(d.match(c), 16) || g && d.match(a) && Date.parse(d) || null;if (h) {
        if (g < h) return -1;if (g > h) return 1;
      }for (var y = 0, v = Math.max(f.length, p.length); y < v; y++) {
        if (r = !(f[y] || "").match(u) && parseFloat(f[y]) || f[y] || 0, s = !(p[y] || "").match(u) && parseFloat(p[y]) || p[y] || 0, isNaN(r) !== isNaN(s)) return isNaN(r) ? 1 : -1;if ((typeof r === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_15_babel_runtime_helpers_typeof___default()(r)) != (typeof s === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_15_babel_runtime_helpers_typeof___default()(s)) && (r += "", s += ""), r < s) return -1;if (r > s) return 1;
      }return 0;
    };
  }, function (e, t) {}, function (e, t, n) {
    var r = n(14),
        s = n(48),
        i = n(43)("IE_PROTO"),
        o = Object.prototype;e.exports = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of___default.a || function (e) {
      return e = s(e), r(e, i) ? e[i] : "function" == typeof e.constructor && e instanceof e.constructor ? e.constructor.prototype : e instanceof Object ? o : null;
    };
  }, function (e, t, n) {
    var r = n(8).document;e.exports = r && r.documentElement;
  },, function (e, t, n) {
    var r = n(33),
        s = n(6)("toStringTag"),
        i = "Arguments" == r(function () {
      return arguments;
    }());e.exports = function (e) {
      var t, n, o;return void 0 === e ? "Undefined" : null === e ? "Null" : "string" == typeof (n = function (e, t) {
        try {
          return e[t];
        } catch (e) {}
      }(t = Object(e), s)) ? n : i ? r(t) : "Object" == (o = r(t)) && "function" == typeof t.callee ? "Arguments" : o;
    };
  }, function (e, t, n) {
    "use strict";
    var r = { link: { id: 1, heartbeat: 2 }, sync: { id: 5, sync: 1, syncTeamMembers: 2 }, misc: { id: 6, getSimpleNosToken: 1, getNosToken: 2, notifyUploadLog: 3, uploadSdkLogUrl: 4, audioToText: 5, processImage: 6, getNosTokenTrans: 7, notifyTransLog: 8, fetchFile: 9, fetchFileList: 10, removeFile: 11, getClientAntispam: 17, fileQuickTransfer: 18, getNosOriginUrl: 22 }, avSignal: { id: 15, signalingCreate: 1, signalingDelay: 2, signalingClose: 3, signalingJoin: 4, signalingLeave: 5, signalingInvite: 6, signalingCancel: 7, signalingReject: 8, signalingAccept: 9, signalingControl: 10, signalingNotify: 11, signalingMutilClientSyncNotify: 12, signalingUnreadMessageSyncNotify: 13, signalingChannelsSyncNotify: 14, signalingGetChannelInfo: 15 } },
        s = { heartbeat: { sid: r.link.id, cid: r.link.heartbeat }, getSimpleNosToken: { sid: r.misc.id, cid: r.misc.getSimpleNosToken, params: [{ type: "int", name: "num" }] }, getNosToken: { sid: r.misc.id, cid: r.misc.getNosToken, params: [{ type: "String", name: "responseBody" }, { type: "Property", name: "nosToken", entity: "nosToken" }] }, uploadSdkLogUrl: { sid: r.misc.id, cid: r.misc.uploadSdkLogUrl, params: [{ type: "string", name: "url" }] }, audioToText: { sid: r.misc.id, cid: r.misc.audioToText, params: [{ type: "Property", name: "audioToText" }] }, processImage: { sid: r.misc.id, cid: r.misc.processImage, params: [{ type: "String", name: "url" }, { type: "PropertyArray", name: "imageOps", entity: "imageOp" }] }, getClientAntispam: { sid: r.misc.id, cid: r.misc.getClientAntispam, params: [{ type: "Property", name: "clientAntispam" }] }, fileQuickTransfer: { sid: r.misc.id, cid: r.misc.fileQuickTransfer, params: [{ type: "Property", name: "fileQuickTransfer" }] }, getNosOriginUrl: { sid: r.misc.id, cid: r.misc.getNosOriginUrl, params: [{ type: "Property", name: "nosFileUrlTag" }] }, getNosTokenTrans: { sid: r.misc.id, cid: r.misc.getNosTokenTrans, params: [{ type: "Property", name: "transToken" }] }, fetchFile: { sid: r.misc.id, cid: r.misc.fetchFile, params: [{ type: "String", name: "docId" }] }, fetchFileList: { sid: r.misc.id, cid: r.misc.fetchFileList, params: [{ type: "Property", name: "fileListParam" }] }, removeFile: { sid: r.misc.id, cid: r.misc.removeFile, params: [{ type: "String", name: "docId" }] }, signalingCreate: { sid: r.avSignal.id, cid: r.avSignal.signalingCreate, params: [{ type: "Property", name: "avSignalTag" }] }, signalingDelay: { sid: r.avSignal.id, cid: r.avSignal.signalingDelay, params: [{ type: "Property", name: "avSignalTag" }] }, signalingClose: { sid: r.avSignal.id, cid: r.avSignal.signalingClose, params: [{ type: "Property", name: "avSignalTag" }] }, signalingJoin: { sid: r.avSignal.id, cid: r.avSignal.signalingJoin, params: [{ type: "Property", name: "avSignalTag" }] }, signalingLeave: { sid: r.avSignal.id, cid: r.avSignal.signalingLeave, params: [{ type: "Property", name: "avSignalTag" }] }, signalingInvite: { sid: r.avSignal.id, cid: r.avSignal.signalingInvite, params: [{ type: "Property", name: "avSignalTag" }] }, signalingCancel: { sid: r.avSignal.id, cid: r.avSignal.signalingCancel, params: [{ type: "Property", name: "avSignalTag" }] }, signalingReject: { sid: r.avSignal.id, cid: r.avSignal.signalingReject, params: [{ type: "Property", name: "avSignalTag" }] }, signalingAccept: { sid: r.avSignal.id, cid: r.avSignal.signalingAccept, params: [{ type: "Property", name: "avSignalTag" }] }, signalingControl: { sid: r.avSignal.id, cid: r.avSignal.signalingControl, params: [{ type: "Property", name: "avSignalTag" }] }, signalingGetChannelInfo: { sid: r.avSignal.id, cid: r.avSignal.signalingGetChannelInfo, params: [{ type: "Property", name: "avSignalTag" }] } };e.exports = { idMap: r, cmdConfig: s, packetConfig: { "1_2": { service: "link", cmd: "heartbeat" }, "6_1": { service: "misc", cmd: "getSimpleNosToken", response: [{ type: "PropertyArray", name: "nosTokens", entity: "nosToken" }] }, "6_2": { service: "misc", cmd: "getNosToken", response: [{ type: "Property", name: "nosToken" }] }, "6_3": { service: "misc", cmd: "notifyUploadLog" }, "6_5": { service: "misc", cmd: "audioToText", response: [{ type: "String", name: "text" }] }, "6_6": { service: "misc", cmd: "processImage", response: [{ type: "String", name: "url" }] }, "6_7": { service: "misc", cmd: "getNosTokenTrans", response: [{ type: "Property", name: "nosToken" }, { type: "String", name: "docId" }] }, "6_8": { service: "misc", cmd: "notifyTransLog", response: [{ type: "Property", name: "transInfo" }] }, "6_9": { service: "misc", cmd: "fetchFile", response: [{ type: "Property", name: "info", entity: "transInfo" }] }, "6_10": { service: "misc", cmd: "fetchFileList", response: [{ type: "PropertyArray", name: "list", entity: "transInfo" }, { type: "Number", name: "totalCount" }] }, "6_11": { service: "misc", cmd: "removeFile", response: [{ type: "String", name: "res" }] }, "6_17": { service: "misc", cmd: "getClientAntispam", response: [{ type: "Property", name: "clientAntispam" }] }, "6_18": { service: "misc", cmd: "fileQuickTransfer", response: [{ type: "Property", name: "fileQuickTransfer" }] }, "6_22": { service: "misc", cmd: "getNosOriginUrl", response: [{ type: "Property", name: "nosFileUrlTag" }] }, "15_1": { service: "avSignal", cmd: "signalingCreate", response: [{ type: "Property", name: "avSignalTag" }] }, "15_2": { service: "avSignal", cmd: "signalingDelay", response: [{ type: "Property", name: "avSignalTag" }] }, "15_3": { service: "avSignal", cmd: "signalingClose", response: [{ type: "Property", name: "avSignalTag" }] }, "15_4": { service: "avSignal", cmd: "signalingJoin", response: [{ type: "Property", name: "avSignalTag" }] }, "15_5": { service: "avSignal", cmd: "signalingLeave", response: [] }, "15_6": { service: "avSignal", cmd: "signalingInvite", response: [] }, "15_7": { service: "avSignal", cmd: "signalingCancel", response: [] }, "15_8": { service: "avSignal", cmd: "signalingReject", response: [] }, "15_9": { service: "avSignal", cmd: "signalingAccept", response: [] }, "15_10": { service: "avSignal", cmd: "signalingControl", response: [] }, "15_11": { service: "avSignal", cmd: "signalingNotify", response: [{ type: "Property", name: "avSignalTag" }] }, "15_12": { service: "avSignal", cmd: "signalingMutilClientSyncNotify", response: [{ type: "Property", name: "avSignalTag" }] }, "15_13": { service: "avSignal", cmd: "signalingUnreadMessageSyncNotify", response: [{ type: "PropertyArray", name: "avSignalTag" }] }, "15_14": { service: "avSignal", cmd: "signalingChannelsSyncNotify", response: [{ type: "PropertyArray", name: "avSignalTag" }] }, "15_15": { service: "avSignal", cmd: "signalingGetChannelInfo", response: [{ type: "Property", name: "avSignalTag" }] } } };
  }, function (e, t, n) {
    "use strict";
    var r,
        s = n(67),
        i = n(0),
        o = n(26),
        a = n(169),
        c = n(288),
        u = n(287),
        l = n(286),
        m = n(285),
        d = n(284);function f(e) {
      this.mixin(e);
    }f.prototype = function () {}, f.prototype.mixin = function (e) {
      var t = this;this.configMap = this.configMap || {}, ["idMap", "cmdConfig", "packetConfig"].forEach(function (n) {
        t.configMap[n] = i.merge({}, t.configMap[n], e.configMap && e.configMap[n]);
      }), ["serializeMap", "unserializeMap"].forEach(function (n) {
        t[n] = i.merge({}, t[n], e[n]);
      });
    }, f.prototype.createCmd = (r = 1, function (e, t) {
      var n = this,
          s = this.configMap.cmdConfig[e],
          o = "heartbeat" === e ? 0 : r++;return o > 32767 && (o = 1, r = 2), e = { SID: s.sid, CID: s.cid, SER: o }, s.params && (e.Q = [], s.params.forEach(function (r) {
        var s = r.type,
            o = r.name,
            a = r.entity,
            c = t[o];if (!i.undef(c)) {
          switch (s) {case "PropertyArray":
              s = "ArrayMable", c = c.map(function (e) {
                return { t: "Property", v: n.serialize(e, a) };
              });break;case "Property":
              c = n.serialize(c, o);break;case "bool":
              c = c ? "true" : "false";}e.Q.push({ t: s, v: c });
        }
      })), e;
    }), f.prototype.parseResponse = function (e) {
      var t = this;return new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a(function (n, r) {
        var s = JSON.parse(e),
            a = { raw: s, rawStr: e, error: o.genError(s.code) },
            c = t.configMap.packetConfig[s.sid + "_" + s.cid];if (!c) return a.notFound = { sid: s.sid, cid: s.cid }, void n(a);var u = s.r,
            l = "notify" === c.service && !c.cmd;if (a.isNotify = l, l) {
          var m = s.r[1].headerPacket;if (c = t.configMap.packetConfig[m.sid + "_" + m.cid], u = s.r[1].body, !c) return a.notFound = { sid: m.sid, cid: m.cid }, void n(a);
        }if (a.service = c.service, a.cmd = c.cmd, a.error) {
          var d = s.sid + "_" + s.cid;if (l && (d = m.sid + "_" + m.cid), a.error.cmd = a.cmd, a.error.callFunc = "protocol::parseResponse: " + d, 416 === a.error.code) {
            var f = u[0];f && (a.frequencyControlDuration = 1e3 * f);
          }
        }var p = !1;a.error && c.trivialErrorCodes && (p = -1 !== c.trivialErrorCodes.indexOf(a.error.code));var g = [];if ((!a.error || p) && c.response) {
          a.content = {};var h = function h(e, t, n, r) {
            if (e && "msg" === r || "sysMsg" === r) {
              var s = n.content[r];i.isObject(s) && !s.idServer && (s.idServer = "" + t.r[0], s.type && "8" === s.type && s.deletedIdClient && (s.idServer = s.deletedIdClient));
            }
          };c.response.forEach(function (e, n) {
            var r = u[n];if (!i.undef(r)) {
              var o = e.type,
                  c = e.name,
                  m = e.entity || c;switch (o) {case "Property":
                  g.push(t.unserialize(r, m).then(function (e, t, n, r, s) {
                    n.content[r] = s, h(e, t, n, r);
                  }.bind(this, l, s, a, c)));break;case "PropertyArray":
                  a.content[c] = [], r.forEach(function (e) {
                    g.push(t.unserialize(e, m).then(function (e, t, n) {
                      e.content[t].push(n);
                    }.bind(this, a, c)));
                  });break;case "KVArray":
                  a.content[c] = r, h(l, s, a, c);break;case "long":case "Long":case "byte":case "Byte":case "Number":
                  a.content[c] = +r;break;default:
                  a.content[c] = r, h(l, s, a, c);}
            }
          });
        }__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.all(g).then(function () {
          n(a);
        });
      });
    }, f.prototype.serialize = function (e, t) {
      var n = this.serializeMap[t],
          r = {};for (var s in n) {
        e.hasOwnProperty(s) && (r[n[s]] = e[s]);
      }return r;
    }, f.prototype.matchNosSafeUrl = function (e) {
      if (!i.isString(e) || !~e.indexOf("_im_url=1")) return !1;var t = (0, s.urlQuery2Object)(e);return !(!t || !t._im_url || 1 != t._im_url);
    }, f.prototype.getOneNosOriginUrl = function (e, t, n) {
      var r = this;return new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a(function (s, i) {
        r.__proto__.protocol.getNosOriginUrlReqNum++, r.__proto__.protocol.sendCmd("getNosOriginUrl", { nosFileUrlTag: { safeUrl: e } }, function (e, r, i) {
          e ? console.warn("error: get nos originUrl failed", e) : (t["_" + n + "_safe"] = t[n], t[n] = i.nosFileUrlTag && i.nosFileUrlTag.originUrl), s();
        });
      });
    }, f.prototype.checkObjSafeUrl = function (e, t, n) {
      var r = this;for (var s in e) {
        if (e.hasOwnProperty(s)) {
          var o = e[s];if (i.isString(o)) {
            if (this.matchNosSafeUrl(o)) {
              var a = this.getOneNosOriginUrl(o, e, s);t.push(a), n.push(a);
            }
          } else i.isObject(o) ? this.checkObjSafeUrl(o, t, n) : i.isArray(o) && o.forEach(function (e) {
            i.isObject(e) && r.checkObjSafeUrl(e, t, n);
          });
        }
      }
    };var p = ["url", "avatar", "fromAvatar", "chatroomAvatar"];f.prototype.unserialize = function (e, t) {
      var n = this;return new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a(function (r, s) {
        var i = n.unserializeMap[t],
            o = {},
            a = [];if (e) for (var c in i) {
          var u = [];if (e.hasOwnProperty(c) && (o[i[c]] = e[c], !n.protocol.keepNosSafeUrl)) if ("attach" === i[c] && e[c] && e[c].indexOf && ~e[c].indexOf("_im_url=1")) try {
            var l = JSON.parse(e[c]);n.checkObjSafeUrl(l, u, a), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.all(u).then(function (e, t) {
              e.attach = __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_json_stringify___default()(t);
            }.bind(n, o, l));
          } catch (e) {
            console.warn(e);
          } else ~p.indexOf(i[c]) && e[c] && n.matchNosSafeUrl(e[c]) && a.push(n.getOneNosOriginUrl(e[c], o, i[c]));
        }__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.all(a).then(function (e) {
          r(o);
        });
      });
    }, f.prototype.syncUnserialize = function (e, t) {
      var n = this.unserializeMap[t],
          r = {};if (e) for (var s in n) {
        e.hasOwnProperty(s) && (r[n[s]] = e[s]);
      }return r;
    };var g = new f({ configMap: a, serializeMap: c, unserializeMap: u }),
        h = new f({ configMap: l, serializeMap: m, unserializeMap: d });e.exports = { IM: g, Chatroom: h };
  }, function (e, t, n) {
    "use strict";
    var r = n(12),
        s = r.getGlobal(),
        i = {},
        o = s.name || "_parent",
        a = [],
        c = [];i.addMsgListener = function (e) {
      a.push(e);
    };var u,
        l,
        m,
        d,
        f = (u = /^([\w]+?:\/\/.*?(?=\/|$))/i, function (e) {
      return e = e || "", u.test(e) ? RegExp.$1 : "*";
    }),
        p = function p() {
      var e = unescape(s.name || "").trim();if (e && 0 === e.indexOf("MSG|")) {
        s.name = "";var t = r.string2object(e.replace("MSG|", ""), "|"),
            n = (t.origin || "").toLowerCase();n && "*" !== n && 0 !== location.href.toLowerCase().indexOf(n) || function (e) {
          for (var t = 0, n = a.length; t < n; t++) {
            try {
              a[t].call(null, e);
            } catch (e) {}
          }
        }({ data: JSON.parse(t.data || "null"), source: s.frames[t.self] || t.self, origin: f(t.ref || document.referrer) });
      }
    },
        g = (m = function m(e, t) {
      for (var n = 0, r = e.length; n < r; n++) {
        if (e[n] === t) return !0;
      }return !1;
    }, function () {
      if (c.length) {
        l = [];for (var e, t = c.length - 1; t >= 0; t--) {
          e = c[t], m(l, e.w) || (l.push(e.w), c.splice(t, 1), e.w.name = e.d);
        }l = null;
      }
    }),
        h = i.startTimer = (d = !1, function () {
      d || (d = !0, s.postMessage || (setInterval(g, 100), setInterval(p, 20)));
    });i.postMessage = function (e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};if (r.fillUndef(t, { origin: "*", source: o }), s.postMessage) {
        var n = t.data;s.FormData || (n = __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_json_stringify___default()(n)), e.postMessage(n, t.origin);
      } else {
        if (h(), r.isObject(t)) {
          var i = {};i.origin = t.origin || "", i.ref = location.href, i.self = t.source, i.data = __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_json_stringify___default()(t.data), t = "MSG|" + r.object2string(i, "|", !0);
        }c.unshift({ w: e, d: escape(t) });
      }
    }, e.exports = i;
  }, function (e, t, n) {
    "use strict";
    var r = n(30),
        s = n(38),
        i = n(28),
        o = n(48),
        a = n(61),
        c = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default.a;e.exports = !c || n(21)(function () {
      var e = {},
          t = {},
          n = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_symbol___default()(),
          r = "abcdefghijklmnopqrst";return e[n] = 7, r.split("").forEach(function (e) {
        t[e] = e;
      }), 7 != c({}, e)[n] || __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_keys___default()(c({}, t)).join("") != r;
    }) ? function (e, t) {
      for (var n = o(e), c = arguments.length, u = 1, l = s.f, m = i.f; c > u;) {
        for (var d, f = a(arguments[u++]), p = l ? r(f).concat(l(f)) : r(f), g = p.length, h = 0; g > h;) {
          m.call(f, d = p[h++]) && (n[d] = f[d]);
        }
      }return n;
    } : c;
  }, function (e, t, n) {
    var r = n(17);r(r.S + r.F, "Object", { assign: n(82) });
  }, function (e, t, n) {
    n(83), e.exports = n(7).Object.assign;
  }, function (e, t, n) {
    e.exports = { default: n(84), __esModule: !0 };
  }, function (e, t, n) {
    "use strict";
    var r = n(0),
        s = r.notundef,
        i = r.fillPropertyWithDefault,
        o = { 0: "normal", 1: "owner", 2: "manager" };function a(e) {
      r.verifyOptions(e, "teamId", "team::TeamMember"), r.verifyParamAtLeastPresentOne(e, "nickInTeam muteTeam muteNotiType custom", "team::TeamMember"), this.teamId = e.teamId, s(e.account) && (this.account = e.account), s(e.nickInTeam) && (this.nickInTeam = e.nickInTeam), s(e.muteNotiType) ? this.bits = e.muteNotiType : s(e.muteTeam) && (this.bits = 0, e.muteTeam && (this.bits += 1)), s(e.mute) && (this.mute = e.mute ? 1 : 0), s(e.custom) && (this.custom = "" + e.custom);
    }a.reverse = function (e) {
      var t = r.copy(e);if (s(t.teamId) && (t.teamId = "" + t.teamId), s(t.type) && (t.type = o[t.type]), s(t.active) && (t.active = 1 == +t.active), s(t.valid) && (t.valid = 1 == +t.valid), s(t.mute) && (t.mute = 1 == +t.mute), s(t.joinTime) && (t.joinTime = +t.joinTime), s(t.updateTime) && (t.updateTime = +t.updateTime), s(t.bits)) {
        var n = t.bits;delete t.bits, t.muteTeam = !!(1 & n), t.muteNotiType = n;
      }return s(t.teamId) && s(t.account) && (t.id = a.genId(t.teamId, t.account)), t;
    }, a.reverseMembers = function (e) {
      return e.map(function (e) {
        return a.reverse(e);
      });
    }, a.fillProperties = function (e) {
      var t = i(e, "mute", !1),
          n = i(e, "custom", "");return t || n;
    }, a.genId = function (e, t) {
      return e + "-" + t;
    }, a.accounts2ids = function (e, t) {
      return t.map(function (t) {
        return a.genId(e, t);
      });
    }, a.assembleMembers = function (e, t) {
      return r.isArray(t) || (t = [t]), t.map(function (t) {
        return a.assembleMember(e, t);
      });
    }, a.assembleMember = function (e, t) {
      return { id: a.genId(e.teamId, t), account: t, teamId: e.teamId, type: "normal", nickInTeam: "", muteTeam: !1, mute: !1, joinTime: e.memberUpdateTime, updateTime: e.memberUpdateTime, active: !0, valid: !0 };
    }, a.assembleOwner = function (e) {
      var t = a.assembleMember(e, e.owner);return t.type = "owner", t;
    }, e.exports = a;
  }, function (e, t, n) {
    "use strict";
    var r = n(2);"undefined" != typeof window && (window.console || r.isWeixinApp || (window.console = { log: function log() {}, info: function info() {}, warn: function warn() {}, error: function error() {} }));
  }, function (e, t, n) {
    n(39)("observable");
  }, function (e, t, n) {
    n(39)("asyncIterator");
  }, function (e, t, n) {
    var r = n(18),
        s = n(60).f,
        i = {}.toString,
        o = "object" == (typeof window === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_15_babel_runtime_helpers_typeof___default()(window)) && window && __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_get_own_property_names___default.a ? __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_get_own_property_names___default()(window) : [];e.exports.f = function (e) {
      return o && "[object Window]" == i.call(e) ? function (e) {
        try {
          return s(e);
        } catch (e) {
          return o.slice();
        }
      }(e) : s(r(e));
    };
  }, function (e, t, n) {
    var r = n(33);e.exports = Array.isArray || function (e) {
      return "Array" == r(e);
    };
  }, function (e, t, n) {
    var r = n(30),
        s = n(38),
        i = n(28);e.exports = function (e) {
      var t = r(e),
          n = s.f;if (n) for (var o, a = n(e), c = i.f, u = 0; a.length > u;) {
        c.call(e, o = a[u++]) && t.push(o);
      }return t;
    };
  }, function (e, t, n) {
    var r = n(29)("meta"),
        s = n(19),
        i = n(14),
        o = n(13).f,
        a = 0,
        c = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_is_extensible___default.a || function () {
      return !0;
    },
        u = !n(21)(function () {
      return c(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_prevent_extensions___default()({}));
    }),
        l = function l(e) {
      o(e, r, { value: { i: "O" + ++a, w: {} } });
    },
        m = e.exports = { KEY: r, NEED: !1, fastKey: function fastKey(e, t) {
        if (!s(e)) return "symbol" == (typeof e === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_15_babel_runtime_helpers_typeof___default()(e)) ? e : ("string" == typeof e ? "S" : "P") + e;if (!i(e, r)) {
          if (!c(e)) return "F";if (!t) return "E";l(e);
        }return e[r].i;
      }, getWeak: function getWeak(e, t) {
        if (!i(e, r)) {
          if (!c(e)) return !0;if (!t) return !1;l(e);
        }return e[r].w;
      }, onFreeze: function onFreeze(e) {
        return u && m.NEED && c(e) && !i(e, r) && l(e), e;
      } };
  }, function (e, t, n) {
    "use strict";
    var r = n(8),
        s = n(14),
        i = n(15),
        o = n(17),
        a = n(63),
        c = n(93).KEY,
        u = n(21),
        l = n(42),
        m = n(34),
        d = n(29),
        f = n(6),
        p = n(40),
        g = n(39),
        h = n(92),
        y = n(91),
        v = n(16),
        b = n(19),
        M = n(18),
        T = n(44),
        S = n(27),
        k = n(50),
        P = n(90),
        I = n(59),
        C = n(13),
        O = n(30),
        w = I.f,
        x = C.f,
        A = P.f,
        _2 = r.Symbol,
        E = r.JSON,
        R = E && E.stringify,
        U = f("_hidden"),
        j = f("toPrimitive"),
        F = {}.propertyIsEnumerable,
        N = l("symbol-registry"),
        D = l("symbols"),
        L = l("op-symbols"),
        B = Object.prototype,
        q = "function" == typeof _2,
        H = r.QObject,
        W = !H || !H.prototype || !H.prototype.findChild,
        z = i && u(function () {
      return 7 != k(x({}, "a", { get: function get() {
          return x(this, "a", { value: 7 }).a;
        } })).a;
    }) ? function (e, t, n) {
      var r = w(B, t);r && delete B[t], x(e, t, n), r && e !== B && x(B, t, r);
    } : x,
        J = function J(e) {
      var t = D[e] = k(_2.prototype);return t._k = e, t;
    },
        V = q && "symbol" == __WEBPACK_IMPORTED_MODULE_15_babel_runtime_helpers_typeof___default()(_2.iterator) ? function (e) {
      return "symbol" == (typeof e === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_15_babel_runtime_helpers_typeof___default()(e));
    } : function (e) {
      return e instanceof _2;
    },
        X = function X(e, t, n) {
      return e === B && X(L, t, n), v(e), t = T(t, !0), v(n), s(D, t) ? (n.enumerable ? (s(e, U) && e[U][t] && (e[U][t] = !1), n = k(n, { enumerable: S(0, !1) })) : (s(e, U) || x(e, U, S(1, {})), e[U][t] = !0), z(e, t, n)) : x(e, t, n);
    },
        $ = function $(e, t) {
      v(e);for (var n, r = h(t = M(t)), s = 0, i = r.length; i > s;) {
        X(e, n = r[s++], t[n]);
      }return e;
    },
        G = function G(e) {
      var t = F.call(this, e = T(e, !0));return !(this === B && s(D, e) && !s(L, e)) && (!(t || !s(this, e) || !s(D, e) || s(this, U) && this[U][e]) || t);
    },
        K = function K(e, t) {
      if (e = M(e), t = T(t, !0), e !== B || !s(D, t) || s(L, t)) {
        var n = w(e, t);return !n || !s(D, t) || s(e, U) && e[U][t] || (n.enumerable = !0), n;
      }
    },
        Q = function Q(e) {
      for (var t, n = A(M(e)), r = [], i = 0; n.length > i;) {
        s(D, t = n[i++]) || t == U || t == c || r.push(t);
      }return r;
    },
        Y = function Y(e) {
      for (var t, n = e === B, r = A(n ? L : M(e)), i = [], o = 0; r.length > o;) {
        !s(D, t = r[o++]) || n && !s(B, t) || i.push(D[t]);
      }return i;
    };q || (a((_2 = function _() {
      if (this instanceof _2) throw TypeError("Symbol is not a constructor!");var e = d(arguments.length > 0 ? arguments[0] : void 0),
          t = function t(n) {
        this === B && t.call(L, n), s(this, U) && s(this[U], e) && (this[U][e] = !1), z(this, e, S(1, n));
      };return i && W && z(B, e, { configurable: !0, set: t }), J(e);
    }).prototype, "toString", function () {
      return this._k;
    }), I.f = K, C.f = X, n(60).f = P.f = Q, n(28).f = G, n(38).f = Y, i && !n(35) && a(B, "propertyIsEnumerable", G, !0), p.f = function (e) {
      return J(f(e));
    }), o(o.G + o.W + o.F * !q, { Symbol: _2 });for (var Z = "hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","), ee = 0; Z.length > ee;) {
      f(Z[ee++]);
    }for (var te = O(f.store), ne = 0; te.length > ne;) {
      g(te[ne++]);
    }o(o.S + o.F * !q, "Symbol", { for: function _for(e) {
        return s(N, e += "") ? N[e] : N[e] = _2(e);
      }, keyFor: function keyFor(e) {
        if (!V(e)) throw TypeError(e + " is not a symbol!");for (var t in N) {
          if (N[t] === e) return t;
        }
      }, useSetter: function useSetter() {
        W = !0;
      }, useSimple: function useSimple() {
        W = !1;
      } }), o(o.S + o.F * !q, "Object", { create: function create(e, t) {
        return void 0 === t ? k(e) : $(k(e), t);
      }, defineProperty: X, defineProperties: $, getOwnPropertyDescriptor: K, getOwnPropertyNames: Q, getOwnPropertySymbols: Y }), E && o(o.S + o.F * (!q || u(function () {
      var e = _2();return "[null]" != R([e]) || "{}" != R({ a: e }) || "{}" != R(Object(e));
    })), "JSON", { stringify: function stringify(e) {
        for (var t, n, r = [e], s = 1; arguments.length > s;) {
          r.push(arguments[s++]);
        }if (n = t = r[1], (b(t) || void 0 !== e) && !V(e)) return y(t) || (t = function t(e, _t2) {
          if ("function" == typeof n && (_t2 = n.call(this, e, _t2)), !V(_t2)) return _t2;
        }), r[1] = t, R.apply(E, r);
      } }), _2.prototype[j] || n(20)(_2.prototype, j, _2.prototype.valueOf), m(_2, "Symbol"), m(Math, "Math", !0), m(r.JSON, "JSON", !0);
  }, function (e, t, n) {
    n(94), n(74), n(89), n(88), e.exports = n(7).Symbol;
  }, function (e, t, n) {
    e.exports = { default: n(95), __esModule: !0 };
  }, function (e, t) {
    e.exports = function (e, t) {
      return { value: t, done: !!e };
    };
  }, function (e, t) {
    e.exports = function () {};
  }, function (e, t, n) {
    "use strict";
    var r = n(98),
        s = n(97),
        i = n(23),
        o = n(18);e.exports = n(65)(Array, "Array", function (e, t) {
      this._t = o(e), this._i = 0, this._k = t;
    }, function () {
      var e = this._t,
          t = this._k,
          n = this._i++;return !e || n >= e.length ? (this._t = void 0, s(1)) : s(0, "keys" == t ? n : "values" == t ? e[n] : [n, e[n]]);
    }, "values"), i.Arguments = i.Array, r("keys"), r("values"), r("entries");
  }, function (e, t, n) {
    var r = n(46),
        s = Math.max,
        i = Math.min;e.exports = function (e, t) {
      return (e = r(e)) < 0 ? s(e + t, 0) : i(e, t);
    };
  }, function (e, t, n) {
    var r = n(18),
        s = n(69),
        i = n(100);e.exports = function (e) {
      return function (t, n, o) {
        var a,
            c = r(t),
            u = s(c.length),
            l = i(o, u);if (e && n != n) {
          for (; u > l;) {
            if ((a = c[l++]) != a) return !0;
          }
        } else for (; u > l; l++) {
          if ((e || l in c) && c[l] === n) return e || l || 0;
        }return !e && -1;
      };
    };
  }, function (e, t, n) {
    var r = n(13),
        s = n(16),
        i = n(30);e.exports = n(15) ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_properties___default.a : function (e, t) {
      s(e);for (var n, o = i(t), a = o.length, c = 0; a > c;) {
        r.f(e, n = o[c++], t[n]);
      }return e;
    };
  }, function (e, t, n) {
    "use strict";
    var r = n(50),
        s = n(27),
        i = n(34),
        o = {};n(20)(o, n(6)("iterator"), function () {
      return this;
    }), e.exports = function (e, t, n) {
      e.prototype = r(o, { next: s(1, n) }), i(e, t + " Iterator");
    };
  }, function (e, t, n) {
    var r = n(46),
        s = n(45);e.exports = function (e) {
      return function (t, n) {
        var i,
            o,
            a = String(s(t)),
            c = r(n),
            u = a.length;return c < 0 || c >= u ? e ? "" : void 0 : (i = a.charCodeAt(c)) < 55296 || i > 56319 || c + 1 === u || (o = a.charCodeAt(c + 1)) < 56320 || o > 57343 ? e ? a.charAt(c) : i : e ? a.slice(c, c + 2) : o - 56320 + (i - 55296 << 10) + 65536;
      };
    };
  }, function (e, t, n) {
    n(51), n(55), e.exports = n(40).f("iterator");
  }, function (e, t, n) {
    e.exports = { default: n(105), __esModule: !0 };
  },, function (e, t, n) {
    var r = n(78),
        s = n(6)("iterator"),
        i = n(23);e.exports = n(7).getIteratorMethod = function (e) {
      if (null != e) return e[s] || e["@@iterator"] || i[r(e)];
    };
  },,,,,,,, function (e, t, n) {
    "use strict";
    var r = n(0);function s() {}s.parse = function (e) {
      var t = e.split("|");return { scene: t[0], to: t[1] };
    }, s.genSessionByMsg = function (e) {
      return { id: e.sessionId, scene: e.scene, to: e.target, updateTime: e.time, lastMsg: e };
    }, s.appendLastMsg = function (e) {
      var t = e.lastMsg;e["last" + r.capFirstLetter(t.type) + "Msg"] = t, e["last" + r.capFirstLetter(t.flow) + "Msg"] = t;
    }, s.genSessionByMsgs = function (e, t) {
      var n = e.getLastNotIgnoredMsg(t);return n ? s.genSessionByMsg(n) : null;
    }, s.trim = function (e) {
      delete e.msgReceiptSendTime, delete e.msgReceiptServerTime, delete e.ack, delete e.unreadMsgs;
    }, s.isComplete = function (e) {
      return e.id && e.scene && e.to;
    }, e.exports = s;
  }, function (e, t, n) {
    "use strict";
    var r,
        s = n(9),
        i = (r = s) && r.__esModule ? r : { default: r };var o = n(0),
        a = o.undef,
        c = o.notundef,
        u = n(80).IM,
        l = n(119),
        m = n(86),
        d = { customP2p: 100, customTeam: 101, deleteMsgP2p: 7, deleteMsgTeam: 8 },
        f = { 0: "applyTeam", 1: "rejectTeamApply", 2: "teamInvite", 3: "rejectTeamInvite", 5: "friendRequest", 6: "deleteFriend", 7: "deleteMsgP2p", 8: "deleteMsgTeam", 100: "customP2p", 101: "customTeam", 102: "customP2p" },
        p = { 1: "addFriend", 2: "applyFriend", 3: "passFriendApply", 4: "rejectFriendApply" },
        g = ["team", "friend", "msg"],
        h = { applyTeam: "team", rejectTeamApply: "team", teamInvite: "team", rejectTeamInvite: "team", addFriend: "friend", applyFriend: "friend", passFriendApply: "friend", rejectFriendApply: "friend", deleteFriend: "friend", deleteMsg: "msg" };function y(e) {
      o.verifyOptions(e, "type to", "sysmsg::SystemMessage"), o.verifyParamValid("type", e.type, y.validTypes, "sysmsg::SystemMessage"), -1 !== e.type.indexOf("custom") && (o.verifyOptions(e, "content", "sysmsg::SystemMessage"), this.attach = e.content, c(e.apnsText) && (this.apnsText = "" + e.apnsText), c(e.pushPayload) && ("object" === (0, i["default"])(e.pushPayload) ? (this.logger.warn("model::Message: pushPayload should be JsonString, auto transfer"), this.pushPayload = __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_json_stringify___default()(e.pushPayload)) : this.pushPayload = "" + e.pushPayload), c(e.sendToOnlineUsersOnly) && (this.sendToOnlineUsersOnly = e.sendToOnlineUsersOnly ? 0 : 1), c(e.cc) && (this.cc = e.cc ? 1 : 0), c(e.isPushable) && (this.isPushable = e.isPushable ? 1 : 0), c(e.isUnreadable) && (this.isUnreadable = e.isUnreadable ? 1 : 0), c(e.needPushNick) && (this.needPushNick = e.needPushNick ? 1 : 0)), this.time = e.time || +new Date(), this.type = d[e.type], this.to = e.to, c(e.from) && (this.from = e.from), c(e.ps) && (this.ps = e.ps), c(e.deletedIdClient) && (this.deletedIdClient = e.deletedIdClient), c(e.deletedIdServer) && (this.deletedIdServer = e.deletedIdServer), c(e.opeAccount) && (this.opeAccount = e.opeAccount), c(e.yidunEnable) && (this.yidunEnable = e.yidunEnable ? 1 : 0), c(e.antiSpamContent) && ("object" === (0, i["default"])(e.antiSpamContent) ? (this.logger.warn("model::Message: antiSpamContent should be JsonString, auto transfer"), this.antiSpamContent = __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_json_stringify___default()(e.antiSpamContent)) : this.antiSpamContent = "" + e.antiSpamContent), c(e.antiSpamBusinessId) && ("object" === (0, i["default"])(e.antiSpamBusinessId) ? (this.logger.warn("model::Message: antiSpamBusinessId should be JsonString, auto transfer"), this.antiSpamBusinessId = __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_json_stringify___default()(e.antiSpamBusinessId)) : this.antiSpamBusinessId = "" + e.antiSpamBusinessId), this.idClient = e.idClient || o.guid();
    }y.validTypes = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_keys___default()(d).concat(__WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_keys___default()(h)), y.validCategories = ["team", "friend"], y.isCustom = function (e) {
      return "custom" === e.type;
    }, y.reverse = function (e) {
      var t = { time: +e.time, to: e.to, type: f[e.type] };if (c(e.from) && (t.from = e.from), c(e.idServer) && (t.idServer = "" + e.idServer), c(e.deletedIdClient) && (t.deletedIdClient = e.deletedIdClient), c(e.deletedIdServer) && (t.deletedIdServer = "" + e.deletedIdServer), c(e.deletedMsgTime) && (t.deletedMsgTime = +e.deletedMsgTime), c(e.deletedMsgFromNick) && (t.deletedMsgFromNick = "" + e.deletedMsgFromNick), c(e.opeAccount) && (t.opeAccount = e.opeAccount), c(e.ps) && (t.ps = e.ps), e.attach = e.attach ? "" + e.attach : "", "customP2p" === t.type || "customTeam" === t.type) t.content = e.attach, c(e.apnsText) && (t.apnsText = e.apnsText), c(e.pushPayload) && (t.pushPayload = e.pushPayload), o.merge(t, { sendToOnlineUsersOnly: a(e.sendToOnlineUsersOnly) || 0 == +e.sendToOnlineUsersOnly, cc: a(e.cc) || 1 == +e.cc, isPushable: a(e.isPushable) || 1 == +e.isPushable, isUnreadable: a(e.isUnreadable) || 1 == +e.isUnreadable, needPushNick: c(e.needPushNick) && 1 == +e.needPushNick }), t.scene = t.type.slice(6).toLowerCase(), t.type = "custom";else if ("deleteMsgP2p" === t.type || "deleteMsgTeam" === t.type) t.scene = t.type.slice(9).toLowerCase(), t.type = "deleteMsg";else {
        if (e.attach) {
          t.attach = {};var n = JSON.parse(e.attach);c(n.vt) ? (t.type = p[n.vt], delete t.attach) : (c(n.tinfo) && (t.attach.team = l.reverse(u.syncUnserialize(n.tinfo, "team"))), c(n.tlist) && (t.attach.member = m.reverse(u.syncUnserialize(n.tlist, "teamMember"))), c(n.attach) && (t.attach.custom = n.attach));
        }t.category = h[t.type], t.read = !1, t.state = "init";
      }return c(e.cc) && (t.cc = 1 == +e.cc), t.status = e.status || "success", c(e.filter) && (t.filter = e.filter), t;
    }, y.reverseSysMsgs = function (e, t) {
      var n = (t = t || {}).mapper,
          r = o.isFunction(n);return e.map(function (e) {
        return e = y.reverse(e), r && (e = n(e)), e;
      });
    }, y.completeUnread = function (e) {
      var t;return e = e || {}, g.forEach(function (t) {
        delete e[t];
      }), __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_keys___default()(h).forEach(function (n) {
        e[n] = e[n] || 0, e[n] < 0 && (e[n] = 0), e[t = h[n]] = e[t] || 0, e[t] = e[t] + e[n];
      }), e.total = 0, g.forEach(function (t) {
        e.total += e[t];
      }), e;
    }, e.exports = y;
  }, function (e, t, n) {
    "use strict";
    var r,
        s = n(54);var i = ((r = s) && r.__esModule ? r : { default: r })["default"].clientTypeMap;function o() {}o.reverse = function (e) {
      var t = e;return t.type = i[t.type], t;
    }, o.reverseType = function (e) {
      return i[e] || e;
    }, e.exports = o;
  }, function (e, t, n) {
    "use strict";
    var r = n(0),
        s = r.notundef,
        i = r.fillPropertyWithDefault,
        o = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_keys___default.a,
        a = {},
        c = {},
        u = [],
        l = {},
        m = { normal: 0, advanced: 1 },
        d = { 0: "normal", 1: "advanced" },
        f = o(m),
        p = a.joinMode = { noVerify: 0, needVerify: 1, rejectAll: 2 };c.joinMode = { 0: "noVerify", 1: "needVerify", 2: "rejectAll" }, u.push("join"), l.joinMode = o(p);var g = a.beInviteMode = { needVerify: 0, noVerify: 1 };c.beInviteMode = { 0: "needVerify", 1: "noVerify" }, u.push("beInvite"), l.beInviteMode = o(g);var h = a.inviteMode = { manager: 0, all: 1 };c.inviteMode = { 0: "manager", 1: "all" }, u.push("invite"), l.inviteMode = o(h);var y = a.updateTeamMode = { manager: 0, all: 1 };c.updateTeamMode = { 0: "manager", 1: "all" }, u.push("updateTeam"), l.updateTeamMode = o(y);var v = a.updateCustomMode = { manager: 0, all: 1 };function b(e) {
      switch (r.verifyOptions(e, "action", "team::Team"), e.action) {case "create":
          r.verifyOptions(e, "teamId", !1, "team::Team"), r.verifyOptions(e, "type name", "team::Team"), r.verifyParamValid("type", e.type, f, "team::Team"), s(e.level) && (r.verifyParamType("level", e.level, "number", "team::Team"), this.level = e.level);break;case "update":
          r.verifyOptions(e, "teamId", "team::Team"), r.verifyOptions(e, "type", !1, "team::Team");}s(e.teamId) && (this.teamId = e.teamId), s(e.type) && (this.type = m[e.type]), s(e.avatar) && (this.avatar = "" + e.avatar), s(e.name) && (this.name = "" + e.name), s(e.intro) && (this.intro = "" + e.intro), s(e.announcement) && (this.announcement = "" + e.announcement), u.forEach(this.setMode.bind(this, e)), s(e.custom) && (this.custom = "" + e.custom);
    }c.updateCustomMode = { 0: "manager", 1: "all" }, u.push("updateCustom"), l.updateCustomMode = o(v), b.prototype.setMode = function (e, t) {
      s(e[t += "Mode"]) && (r.verifyParamValid(t, e[t], l[t], "team::Team"), this[t] = a[t][e[t]]);
    }, b.reverse = function (e, t) {
      var n = r.copy(e);if (s(n.teamId) && (n.teamId = "" + n.teamId), s(n.type) && (n.type = d[n.type]), s(n.level) && (n.level = +n.level), s(n.valid) && (n.valid = 1 == +n.valid), s(n.memberNum) && (n.memberNum = +n.memberNum), s(n.memberUpdateTime) && (n.memberUpdateTime = +n.memberUpdateTime), s(n.createTime) && (n.createTime = +n.createTime), s(n.updateTime) && (n.updateTime = +n.updateTime), s(n.validToCurrentUser) && (n.validToCurrentUser = "1" === n.validToCurrentUser), s(n.mute) && (n.mute = "1" === n.mute), s(n.muteType)) switch (n.muteType) {case "0":
          n.mute = !1, n.muteType = "none";break;case "1":
          n.mute = !0, n.muteType = "normal";break;case "2":
          n.mute = !0, n.muteType = "all";} else s(n.mute) && (1 === n.mute ? (n.mute = !0, n.muteType = "normal") : (n.mute = !1, n.muteType = "none"));return u.forEach(function (e, t) {
        s(e[t += "Mode"]) && (e[t] = c[t][e[t]]);
      }.bind(null, n)), delete n.bits, t || b.fillProperties(n), n;
    }, b.fillProperties = function (e) {
      var t = i(e, "beInviteMode", "needVerify"),
          n = i(e, "inviteMode", "manager"),
          r = i(e, "updateTeamMode", "manager"),
          s = i(e, "updateCustomMode", "manager"),
          o = i(e, "avatar", "");return t || n || r || s || o;
    }, e.exports = b;
  },,,,,,,,, function (e, t, n) {
    "use strict";
    var r = n(67),
        s = n(72),
        i = n(0),
        o = n(2);function a(e) {
      switch (i.notundef(e.type) ? i.verifyFileType(e.type, "msg::FileMessage") : e.type = "file", i.verifyOptions(e, "file", "msg::FileMessage"), i.verifyOptions(e.file, "url ext size", !0, "file.", "msg::FileMessage"), e.type) {case "image":
          c.verifyFile(e.file, "msg::FileMessage");break;case "audio":
          u.verifyFile(e.file, "msg::FileMessage");break;case "video":
          l.verifyFile(e.file, "msg::FileMessage");}s.call(this, e), this.attach = __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_json_stringify___default()(e.file);
    }a.prototype = __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_create___default()(s.prototype), a.reverse = function (e) {
      var t = s.reverse(e);return e.attach = e.attach ? "" + e.attach : "", t.file = e.attach ? JSON.parse(e.attach) : {}, t.file.url = (0, r.genPrivateUrl)(t.file.url), "audio" !== t.type || t.file.mp3Url || (t.file.mp3Url = t.file.url + (~t.file.url.indexOf("?") ? "&" : "?") + "audioTrans&type=mp3"), o.httpsEnabled && (t.file.url = t.file.url.replace("http", "https")), t;
    }, e.exports = a;var c = n(410),
        u = n(409),
        l = n(408);
  }, function (e, t, n) {
    "use strict";
    var r = n(67),
        s = n(0),
        i = { unknown: 0, male: 1, female: 2 },
        o = { 0: "unknown", 1: "male", 2: "female" };function a(e) {
      s.merge(this, e), s.notundef(this.gender) && (s.verifyParamValid("gender", this.gender, a.validGenders, "user::User"), this.gender = i[this.gender]), s.notundef(this.email) && "" !== this.email && s.verifyEmail("email", this.email, "user::User"), s.notundef(this.birth) && "" !== this.birth && s.verifyBirth("birth", this.birth, "user::User"), s.notundef(this.tel) && "" !== this.tel && s.verifyTel("tel", this.tel, "user::User");
    }a.reverse = function (e) {
      var t = s.filterObj(e, "account nick avatar _avatar_safe sign gender email birth tel custom createTime updateTime");return s.notundef(t.avatar) && (t.avatar = (0, r.genPrivateUrl)(t.avatar)), s.notundef(t.gender) && (t.gender = o[t.gender]), s.notundef(t.createTime) && (t.createTime = +t.createTime), s.notundef(t.updateTime) && (t.updateTime = +t.updateTime), t;
    }, a.reverseUsers = function (e) {
      return e.map(function (e) {
        return a.reverse(e);
      });
    }, a.validGenders = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_keys___default()(i), e.exports = a;
  }, function (e, t, n) {
    var r = n(6)("iterator"),
        s = !1;try {
      var i = [7][r]();i["return"] = function () {
        s = !0;
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(i, function () {
        throw 2;
      });
    } catch (e) {}e.exports = function (e, t) {
      if (!t && !s) return !1;var n = !1;try {
        var i = [7],
            o = i[r]();o.next = function () {
          return { done: n = !0 };
        }, i[r] = function () {
          return o;
        }, e(i);
      } catch (e) {}return n;
    };
  }, function (e, t, n) {
    var r = n(23),
        s = n(6)("iterator"),
        i = Array.prototype;e.exports = function (e) {
      return void 0 !== e && (r.Array === e || i[s] === e);
    };
  }, function (e, t, n) {
    var r = n(16);e.exports = function (e, t, n, s) {
      try {
        return s ? t(r(n)[0], n[1]) : t(n);
      } catch (t) {
        var i = e["return"];throw void 0 !== i && r(i.call(e)), t;
      }
    };
  }, function (e, t, n) {
    "use strict";
    var r = n(2),
        s = r.chunkSize,
        i = (n(0), n(49));e.exports = function (e, t, n) {
      var o = { file: e.data[t], fileSize: e.data[t].size, fileUoloadedSize: 0, percentage: 0 };function a(t) {
        var n = o.fileUoloadedSize + t.loaded,
            r = Math.floor(1e4 * n / o.fileSize) / 100;if (parseInt(r) >= 100 && (r = 100, a = function a() {}), o.percentage !== r) {
          o.percentage = r;var s = { docId: e.docId, total: o.fileSize, loaded: n, percentage: r, percentageText: r + "%" };e.fileInput && (s.fileInput = e.fileInput), e.uploadprogress(s);
        }
      }function c(t) {
        try {
          t = JSON.parse(t);
        } catch (e) {
          return void n.onError(e);
        }if (t.errMsg || t.errCode) n.onError(t);else if (t.offset < o.fileSize) delete l.onaftersend, o.fileUoloadedSize = t.offset, n.sn = function (e, t, n, r, o) {
          var l = t.offset,
              m = t.offset + s;return n.data = o.file.slice(l, m), n.query.offset = t.offset, n.query.complete = m >= o.fileSize, n.query.context = t.context, n.onuploading = a, n.onload = c, n.onerror = u, i(e, n);
        }(e.url, t, l, 0, o);else {
          var m = function m(e) {
            n.onError(e);
          },
              d = r.genFileUrl(e.nosToken);"image" === e.type ? i(d + "?imageInfo", { onload: function onload(n) {
              try {
                n = JSON.parse(n), e.uploaddone(null, { docId: t.docId, w: n.Width, h: n.Height, orientation: n.Orientation || "", type: n.Type, size: n.Size || o.fileSize });
              } catch (e) {
                m(e);
              }
            }, onerror: m }) : "video" === e.type || "audio" === e.type ? i(d + "?vinfo", { onload: function onload(n) {
              try {
                (n = JSON.parse(n)).GetVideoInfo && n.GetVideoInfo.VideoInfo && (n = n.GetVideoInfo.VideoInfo), e.uploaddone(null, { docId: t.docId, w: n.Width, h: n.Height, dur: n.Duration, orientation: n.Rotate, audioCodec: n.AudioCodec, videoCodec: n.VideoCodec, container: n.Container, size: n.Size || o.fileSize });
              } catch (e) {
                m(e);
              }
            }, onerror: m }) : e.uploaddone(null, { docId: t.docId, size: o.fileSize });
        }
      }function u(e) {
        try {
          if (e.result) var t = JSON.parse(e.result);else t = e;n.onError(t);
        } catch (e) {
          n.onError(e);
        }
      }var l = { query: { offset: 0, complete: s >= o.fileSize, version: "1.0" }, headers: { "Content-Type": "application/x-www-form-urlencoded", "x-nos-token": e.nosToken.token }, method: "POST", timeout: 0, onaftersend: function onaftersend() {
          e.beginupload(n);
        }, onuploading: a, onload: c, onerror: u };return l.data = o.file.slice(0, s), i(e.url, l);
    };
  }, function (e, t, n) {
    "use strict";
    var r = n(49);e.exports = function (e, t) {
      return t.method = "POST", t.headers = t.headers || {}, t.headers["Content-Type"] = "multipart/form-data", t.timeout = 0, t.type = t.type || "json", r(e, t);
    };
  }, function (e, t, n) {
    "use strict";
    var r,
        s,
        i = n(12),
        o = n(49),
        a = (r = /json/i, s = /post/i, function (e, t) {
      var n = (t = t || {}).data = t.data || {},
          a = t.headers = t.headers || {},
          c = i.checkWithDefault(a, "Accept", "application/json"),
          u = i.checkWithDefault(a, "Content-Type", "application/json");return r.test(c) && (t.type = "json"), s.test(t.method) && r.test(u) && (t.data = __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_json_stringify___default()(n)), o(e, t);
    });e.exports = a;
  }, function (e, t, n) {
    "use strict";
    var r = n(12),
        s = n(81),
        i = n(66),
        o = {};function a(e) {
      this.init(), i.call(this, e);
    }var c = i.prototype,
        u = a.prototype = __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_create___default()(c);u.init = function () {
      var e = "NEJ-AJAX-DATA:",
          t = !1;function n(t) {
        var n = t.data;if (0 === n.indexOf(e)) {
          var r = (n = JSON.parse(n.replace(e, ""))).key,
              s = o[r];s && (delete o[r], n.result = decodeURIComponent(n.result || ""), s.onLoad(n));
        }
      }return function () {
        !function () {
          if (!t) {
            t = !0;var e = r.getGlobal();e.postMessage ? r.on(e, "message", n) : s.addMsgListener(n);
          }
        }();
      };
    }(), u.doSend = function () {
      var e = this.options,
          t = r.url2origin(e.url),
          n = e.proxyUrl || t + "/res/nej_proxy_frame.html",
          i = o[n];if (r.isArray(i)) i.push(this.doSend.bind(this, e));else {
        if (!i) return o[n] = [this.doSend.bind(this, e)], void r.createIframe({ src: n, onload: function onload(e) {
            var t = o[n];o[n] = r.target(e).contentWindow, t.forEach(function (e) {
              try {
                e();
              } catch (e) {
                console.log("error:", e);
              }
            });
          } });if (!this.aborted) {
          var a = this.key = r.uniqueID();o[a] = this;var c = r.fetch({ method: "GET", url: "", data: null, headers: {}, timeout: 0 }, e);c.key = a, s.postMessage(i, { data: c }), this.afterSend();
        }
      }
    }, u.abort = function () {
      this.aborted = !0, delete o[this.key], c.abort.call(this);
    }, e.exports = a;
  }, function (e, t, n) {
    "use strict";
    var r = n(12),
        s = n(66),
        i = n(81),
        o = "NEJ-UPLOAD-RESULT:",
        a = {};function c(e) {
      this.init(), s.call(this, e);
    }var u = s.prototype,
        l = c.prototype = __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_create___default()(u);l.init = function () {
      var e = !1;function t(e) {
        var t = e.data;if (0 === t.indexOf(o)) {
          var n = (t = JSON.parse(t.replace(o, ""))).key,
              r = a[n];r && (delete a[n], t.result = decodeURIComponent(t.result || ""), r.onLoad(t.result));
        }
      }return function () {
        !function () {
          if (!e) {
            e = !0;var n = r.getGlobal();n.postMessage ? r.on(n, "message", t) : (i.addMsgListener(t), i.startTimer());
          }
        }();
      };
    }(), l.doSend = function () {
      var e = this,
          t = e.options,
          n = e.key = "zoro-ajax-upload-iframe-" + r.uniqueID();a[n] = e;var s = e.form = r.html2node('<form style="display:none;"></form>');document.body.appendChild(s), s.target = n, s.method = "POST", s.enctype = "multipart/form-data", s.encoding = "multipart/form-data";var i = t.url,
          o = r.genUrlSep(i);s.action = i + o + "_proxy_=form";var c = t.data,
          u = [],
          l = [];function m() {
        u.forEach(function (e, t) {
          var n = l[t];n.parentNode && (e.name = n.name, r.isFunction(e.setAttribute) && e.setAttribute("form", n.getAttribute("form")), n.parentNode.replaceChild(e, n));
        });
      }c && r.getKeys(c, t.putFileAtEnd).forEach(function (e) {
        var t = c[e];if (t.tagName && "INPUT" === t.tagName.toUpperCase()) {
          if ("file" === t.type) {
            var n = t,
                i = n.cloneNode(!0);n.parentNode.insertBefore(i, n);var o = r.dataset(n, "name");o && (n.name = o), s.appendChild(n), r.isFunction(n.setAttribute) && (n.setAttribute("form", ""), n.removeAttribute("form")), u.push(t), l.push(i);
          }
        } else {
          var a = r.html2node('<input type="hidden"/>');a.name = e, a.value = t, s.appendChild(a);
        }
      });var d = e.iframe = r.createIframe({ name: n, onload: function onload() {
          e.aborted ? m() : (r.on(d, "load", e.checkResult.bind(e)), s.submit(), m(), e.afterSend());
        } });
    }, l.checkResult = function () {
      var e, t;try {
        if ((t = ((e = this.iframe.contentWindow.document.body).innerText || e.textContent || "").trim()).indexOf(o) >= 0 || e.innerHTML.indexOf(o) >= 0) return;
      } catch (e) {
        return void console.log("error:", "ignore error if not same domain,", e);
      }this.onLoad(t);
    }, l.onLoad = function (e) {
      u.onLoad.call(this, { status: 200, result: e }), r.remove(this.form), r.remove(this.iframe), u.destroy.call(this);
    }, l.destroy = function () {
      r.remove(this.iframe), r.remove(this.form);
    }, l.abort = function () {
      this.aborted = !0, delete a[this.key], u.abort.call(this);
    }, e.exports = c;
  }, function (e, t, n) {
    var r;
    /*!
     * EventEmitter v5.2.4 - git.io/ee
     * Unlicense - http://unlicense.org/
     * Oliver Caldwell - http://oli.me.uk/
     * @preserve
     */!function (t) {
      "use strict";
      function s() {}var i = s.prototype,
          o = t.EventEmitter;function a(e, t) {
        for (var n = e.length; n--;) {
          if (e[n].listener === t) return n;
        }return -1;
      }function c(e) {
        return function () {
          return this[e].apply(this, arguments);
        };
      }i.getListeners = function (e) {
        var t,
            n,
            r = this._getEvents();if (e instanceof RegExp) for (n in t = {}, r) {
          r.hasOwnProperty(n) && e.test(n) && (t[n] = r[n]);
        } else t = r[e] || (r[e] = []);return t;
      }, i.flattenListeners = function (e) {
        var t,
            n = [];for (t = 0; t < e.length; t += 1) {
          n.push(e[t].listener);
        }return n;
      }, i.getListenersAsObject = function (e) {
        var t,
            n = this.getListeners(e);return n instanceof Array && ((t = {})[e] = n), t || n;
      }, i.addListener = function (e, t) {
        if (!function e(t) {
          return "function" == typeof t || t instanceof RegExp || !(!t || "object" != (typeof t === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_15_babel_runtime_helpers_typeof___default()(t))) && e(t.listener);
        }(t)) throw new TypeError("listener must be a function");var n,
            r = this.getListenersAsObject(e),
            s = "object" == (typeof t === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_15_babel_runtime_helpers_typeof___default()(t));for (n in r) {
          r.hasOwnProperty(n) && -1 === a(r[n], t) && r[n].push(s ? t : { listener: t, once: !1 });
        }return this;
      }, i.on = c("addListener"), i.addOnceListener = function (e, t) {
        return this.addListener(e, { listener: t, once: !0 });
      }, i.once = c("addOnceListener"), i.defineEvent = function (e) {
        return this.getListeners(e), this;
      }, i.defineEvents = function (e) {
        for (var t = 0; t < e.length; t += 1) {
          this.defineEvent(e[t]);
        }return this;
      }, i.removeListener = function (e, t) {
        var n,
            r,
            s = this.getListenersAsObject(e);for (r in s) {
          s.hasOwnProperty(r) && -1 !== (n = a(s[r], t)) && s[r].splice(n, 1);
        }return this;
      }, i.off = c("removeListener"), i.addListeners = function (e, t) {
        return this.manipulateListeners(!1, e, t);
      }, i.removeListeners = function (e, t) {
        return this.manipulateListeners(!0, e, t);
      }, i.manipulateListeners = function (e, t, n) {
        var r,
            s,
            i = e ? this.removeListener : this.addListener,
            o = e ? this.removeListeners : this.addListeners;if ("object" != (typeof t === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_15_babel_runtime_helpers_typeof___default()(t)) || t instanceof RegExp) for (r = n.length; r--;) {
          i.call(this, t, n[r]);
        } else for (r in t) {
          t.hasOwnProperty(r) && (s = t[r]) && ("function" == typeof s ? i.call(this, r, s) : o.call(this, r, s));
        }return this;
      }, i.removeEvent = function (e) {
        var t,
            n = typeof e === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_15_babel_runtime_helpers_typeof___default()(e),
            r = this._getEvents();if ("string" === n) delete r[e];else if (e instanceof RegExp) for (t in r) {
          r.hasOwnProperty(t) && e.test(t) && delete r[t];
        } else delete this._events;return this;
      }, i.removeAllListeners = c("removeEvent"), i.emitEvent = function (e, t) {
        var n,
            r,
            s,
            i,
            o = this.getListenersAsObject(e);for (i in o) {
          if (o.hasOwnProperty(i)) for (n = o[i].slice(0), s = 0; s < n.length; s++) {
            !0 === (r = n[s]).once && this.removeListener(e, r.listener), r.listener.apply(this, t || []) === this._getOnceReturnValue() && this.removeListener(e, r.listener);
          }
        }return this;
      }, i.trigger = c("emitEvent"), i.emit = function (e) {
        var t = Array.prototype.slice.call(arguments, 1);return this.emitEvent(e, t);
      }, i.setOnceReturnValue = function (e) {
        return this._onceReturnValue = e, this;
      }, i._getOnceReturnValue = function () {
        return !this.hasOwnProperty("_onceReturnValue") || this._onceReturnValue;
      }, i._getEvents = function () {
        return this._events || (this._events = {});
      }, s.noConflict = function () {
        return t.EventEmitter = o, s;
      }, void 0 === (r = function () {
        return s;
      }.call(t, n, t, e)) || (e.exports = r);
    }(this || {});
  }, function (e, t, n) {
    "use strict";
    var r = n(12),
        s = n(66);function i(e) {
      e.onuploading && this.on("uploading", e.onuploading), s.call(this, e);
    }var o = s.prototype,
        a = i.prototype = __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_create___default()(o);a.doSend = function () {
      var e = this.options,
          t = e.headers,
          n = this.xhr = new XMLHttpRequest();if ("multipart/form-data" === t["Content-Type"]) {
        delete t["Content-Type"], n.upload.onprogress = this.onProgress.bind(this), n.upload.onload = this.onProgress.bind(this);var s = e.data;e.data = new window.FormData(), s && r.getKeys(s, e.putFileAtEnd).forEach(function (t) {
          var n = s[t];n.tagName && "INPUT" === n.tagName.toUpperCase() ? "file" === n.type && [].forEach.call(n.files, function (t) {
            e.data.append(r.dataset(n, "name") || n.name || t.name || "file-" + r.uniqueID(), t);
          }) : e.data.append(t, n);
        });
      } else t["x-nos-token"] && (n.upload.onprogress = this.onProgress.bind(this), n.upload.onload = this.onProgress.bind(this));n.onreadystatechange = this.onStateChange.bind(this), 0 !== e.timeout && (this.timer = setTimeout(this.onTimeout.bind(this), e.timeout)), n.open(e.method, e.url, !e.sync), __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_keys___default()(t).forEach(function (e) {
        n.setRequestHeader(e, t[e]);
      }), e.cookie && "withCredentials" in n && (n.withCredentials = !0), n.send(e.data), this.afterSend();
    }, a.onProgress = function (e) {
      e.lengthComputable && e.loaded <= e.total && this.emit("uploading", e);
    }, a.onStateChange = function () {
      var e = this.xhr;4 === e.readyState && this.onLoad({ status: e.status, result: e.responseText || "" });
    }, a.getResponseHeader = function (e) {
      var t = this.xhr;return t ? t.getResponseHeader(e) : "";
    }, a.destroy = function () {
      clearTimeout(this.timer);try {
        this.xhr.onreadystatechange = r.f, this.xhr.abort();
      } catch (e) {
        console.log("error:", "ignore error ajax destroy,", e);
      }o.destroy.call(this);
    }, e.exports = i;
  }, function (e, t, n) {
    "use strict";
    n(174).polyfill(), n(2).isBrowser = !0;
  },,,,,,,,,,, function (e, t) {
    e.exports = function (e) {
      var t = n.call(e);return "[object Function]" === t || "function" == typeof e && "[object RegExp]" !== t || "undefined" != typeof window && (e === window.setTimeout || e === window.alert || e === window.confirm || e === window.prompt);
    };var n = Object.prototype.toString;
  }, function (module, exports, __webpack_require__) {
    (function (global, module) {
      var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;function getGlobal() {
        return "undefined" != typeof window ? window : "undefined" != typeof self ? self : void 0 !== global ? global : {};
      }var root = getGlobal(),
          io = module.exports;void 0 === root.location && (root.location = null), root.io ? module && (module.exports = io = root.io) : root.io = io, function () {
        !function (e, t) {
          var n = e;n.version = "0.9.11", n.protocol = 1, n.transports = [], n.j = [], n.sockets = {}, n.connect = function (e, r) {
            var s,
                i,
                o = n.util.parseUri(e);t && t.location && (o.protocol = o.protocol || t.location.protocol.slice(0, -1), o.host = o.host || (t.document ? t.document.domain : t.location.hostname), o.port = o.port || t.location.port), s = n.util.uniqueUri(o);var a = { host: o.host, secure: "https" === o.protocol, port: o.port || ("https" === o.protocol ? 443 : 80), query: o.query || "" };return n.util.merge(a, r), !a["force new connection"] && n.sockets[s] || (i = new n.Socket(a)), !a["force new connection"] && i && (n.sockets[s] = i), (i = i || n.sockets[s]).of(o.path.length > 1 ? o.path : "");
          };
        }(module.exports, root), function (e, t) {
          var n = e.util = {},
              r = /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/,
              s = ["source", "protocol", "authority", "userInfo", "user", "password", "host", "port", "relative", "path", "directory", "file", "query", "anchor"];n.parseUri = function (e) {
            for (var t = r.exec(e || ""), n = {}, i = 14; i--;) {
              n[s[i]] = t[i] || "";
            }return n;
          }, n.uniqueUri = function (e) {
            var n = e.protocol,
                r = e.host,
                s = e.port;return "document" in t ? (r = r || document.domain, s = s || ("https" == n && "https:" !== document.location.protocol ? 443 : document.location.port)) : (r = r || "localhost", s || "https" != n || (s = 443)), (n || "http") + "://" + r + ":" + (s || 80);
          }, n.query = function (e, t) {
            var r = n.chunkQuery(e || ""),
                s = [];for (var i in n.merge(r, n.chunkQuery(t || "")), r) {
              r.hasOwnProperty(i) && s.push(i + "=" + r[i]);
            }return s.length ? "?" + s.join("&") : "";
          }, n.chunkQuery = function (e) {
            for (var t, n = {}, r = e.split("&"), s = 0, i = r.length; s < i; ++s) {
              (t = r[s].split("="))[0] && (n[t[0]] = t[1]);
            }return n;
          };var i = !1;n.load = function (e) {
            if (document && "complete" === document.readyState || i) return e();n.on(t, "load", e, !1);
          }, n.on = function (e, t, n, r) {
            e.attachEvent ? e.attachEvent("on" + t, n) : e.addEventListener && e.addEventListener(t, n, r);
          }, n.request = function (e) {
            if (e && "undefined" != typeof XDomainRequest && !n.ua.hasCORS) return new XDomainRequest();if ("undefined" != typeof XMLHttpRequest && (!e || n.ua.hasCORS)) return new XMLHttpRequest();if (!e) try {
              return new root[["Active"].concat("Object").join("X")]("Microsoft.XMLHTTP");
            } catch (e) {}return null;
          }, void 0 !== root && n.load(function () {
            i = !0;
          }), n.defer = function (e) {
            if (!n.ua.webkit || "undefined" != typeof importScripts) return e();n.load(function () {
              setTimeout(e, 100);
            });
          }, n.merge = function (e, t, r, s) {
            var i,
                o = s || [],
                a = void 0 === r ? 2 : r;for (i in t) {
              t.hasOwnProperty(i) && n.indexOf(o, i) < 0 && ("object" == __WEBPACK_IMPORTED_MODULE_15_babel_runtime_helpers_typeof___default()(e[i]) && a ? n.merge(e[i], t[i], a - 1, o) : (e[i] = t[i], o.push(t[i])));
            }return e;
          }, n.mixin = function (e, t) {
            n.merge(e.prototype, t.prototype);
          }, n.inherit = function (e, t) {
            function n() {}n.prototype = t.prototype, e.prototype = new n();
          }, n.isArray = Array.isArray || function (e) {
            return "[object Array]" === Object.prototype.toString.call(e);
          }, n.intersect = function (e, t) {
            for (var r = [], s = e.length > t.length ? e : t, i = e.length > t.length ? t : e, o = 0, a = i.length; o < a; o++) {
              ~n.indexOf(s, i[o]) && r.push(i[o]);
            }return r;
          }, n.indexOf = function (e, t, n) {
            var r = e.length;for (n = n < 0 ? n + r < 0 ? 0 : n + r : n || 0; n < r && e[n] !== t; n++) {}return r <= n ? -1 : n;
          }, n.toArray = function (e) {
            for (var t = [], n = 0, r = e.length; n < r; n++) {
              t.push(e[n]);
            }return t;
          }, n.ua = {}, n.ua.hasCORS = "undefined" != typeof XMLHttpRequest && function () {
            try {
              var e = new XMLHttpRequest();
            } catch (e) {
              return !1;
            }return null != e.withCredentials;
          }(), n.ua.webkit = "undefined" != typeof navigator && /webkit/i.test(navigator.userAgent), n.ua.iDevice = "undefined" != typeof navigator && /iPad|iPhone|iPod/i.test(navigator.userAgent);
        }(void 0 !== io ? io : module.exports, root), function (e, t) {
          function n() {}e.EventEmitter = n, n.prototype.on = function (e, n) {
            return this.$events || (this.$events = {}), this.$events[e] ? t.util.isArray(this.$events[e]) ? this.$events[e].push(n) : this.$events[e] = [this.$events[e], n] : this.$events[e] = n, this;
          }, n.prototype.addListener = n.prototype.on, n.prototype.once = function (e, t) {
            var n = this;function r() {
              n.removeListener(e, r), t.apply(this, arguments);
            }return r.listener = t, this.on(e, r), this;
          }, n.prototype.removeListener = function (e, n) {
            if (this.$events && this.$events[e]) {
              var r = this.$events[e];if (t.util.isArray(r)) {
                for (var s = -1, i = 0, o = r.length; i < o; i++) {
                  if (r[i] === n || r[i].listener && r[i].listener === n) {
                    s = i;break;
                  }
                }if (s < 0) return this;r.splice(s, 1), r.length || delete this.$events[e];
              } else (r === n || r.listener && r.listener === n) && delete this.$events[e];
            }return this;
          }, n.prototype.removeAllListeners = function (e) {
            return void 0 === e ? (this.$events = {}, this) : (this.$events && this.$events[e] && (this.$events[e] = null), this);
          }, n.prototype.listeners = function (e) {
            return this.$events || (this.$events = {}), this.$events[e] || (this.$events[e] = []), t.util.isArray(this.$events[e]) || (this.$events[e] = [this.$events[e]]), this.$events[e];
          }, n.prototype.emit = function (e) {
            if (!this.$events) return !1;var n = this.$events[e];if (!n) return !1;var r = Array.prototype.slice.call(arguments, 1);if ("function" == typeof n) n.apply(this, r);else {
              if (!t.util.isArray(n)) return !1;for (var s = n.slice(), i = 0, o = s.length; i < o; i++) {
                s[i].apply(this, r);
              }
            }return !0;
          };
        }(void 0 !== io ? io : module.exports, void 0 !== io ? io : module.parent.exports), function (exports, nativeJSON) {
          "use strict";
          if (nativeJSON && nativeJSON.parse) return exports.JSON = { parse: nativeJSON.parse, stringify: nativeJSON.stringify };var JSON = exports.JSON = {};function f(e) {
            return e < 10 ? "0" + e : e;
          }function date(e, t) {
            return isFinite(e.valueOf()) ? e.getUTCFullYear() + "-" + f(e.getUTCMonth() + 1) + "-" + f(e.getUTCDate()) + "T" + f(e.getUTCHours()) + ":" + f(e.getUTCMinutes()) + ":" + f(e.getUTCSeconds()) + "Z" : null;
          }var cx = /[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
              escapable = /[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
              gap,
              indent,
              meta = { "\b": "\\b", "\t": "\\t", "\n": "\\n", "\f": "\\f", "\r": "\\r", '"': '\\"', "\\": "\\\\" },
              rep;function quote(e) {
            return escapable.lastIndex = 0, escapable.test(e) ? '"' + e.replace(escapable, function (e) {
              var t = meta[e];return "string" == typeof t ? t : "\\u" + ("0000" + e.charCodeAt(0).toString(16)).slice(-4);
            }) + '"' : '"' + e + '"';
          }function str(e, t) {
            var n,
                r,
                s,
                i,
                o,
                a = gap,
                c = t[e];switch (c instanceof Date && (c = date(e)), "function" == typeof rep && (c = rep.call(t, e, c)), typeof c === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_15_babel_runtime_helpers_typeof___default()(c)) {case "string":
                return quote(c);case "number":
                return isFinite(c) ? String(c) : "null";case "boolean":case "null":
                return String(c);case "object":
                if (!c) return "null";if (gap += indent, o = [], "[object Array]" === Object.prototype.toString.apply(c)) {
                  for (i = c.length, n = 0; n < i; n += 1) {
                    o[n] = str(n, c) || "null";
                  }return s = 0 === o.length ? "[]" : gap ? "[\n" + gap + o.join(",\n" + gap) + "\n" + a + "]" : "[" + o.join(",") + "]", gap = a, s;
                }if (rep && "object" == (typeof rep === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_15_babel_runtime_helpers_typeof___default()(rep))) for (i = rep.length, n = 0; n < i; n += 1) {
                  "string" == typeof rep[n] && (s = str(r = rep[n], c)) && o.push(quote(r) + (gap ? ": " : ":") + s);
                } else for (r in c) {
                  Object.prototype.hasOwnProperty.call(c, r) && (s = str(r, c)) && o.push(quote(r) + (gap ? ": " : ":") + s);
                }return s = 0 === o.length ? "{}" : gap ? "{\n" + gap + o.join(",\n" + gap) + "\n" + a + "}" : "{" + o.join(",") + "}", gap = a, s;}
          }JSON.stringify = function (e, t, n) {
            var r;if (gap = "", indent = "", "number" == typeof n) for (r = 0; r < n; r += 1) {
              indent += " ";
            } else "string" == typeof n && (indent = n);if (rep = t, t && "function" != typeof t && ("object" != (typeof t === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_15_babel_runtime_helpers_typeof___default()(t)) || "number" != typeof t.length)) throw new Error("socket.io:: replacer cannot JSON.stringify");return str("", { "": e });
          }, JSON.parse = function (text, reviver) {
            var j;function walk(e, t) {
              var n,
                  r,
                  s = e[t];if (s && "object" == (typeof s === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_15_babel_runtime_helpers_typeof___default()(s))) for (n in s) {
                Object.prototype.hasOwnProperty.call(s, n) && (void 0 !== (r = walk(s, n)) ? s[n] = r : delete s[n]);
              }return reviver.call(e, t, s);
            }if (text = String(text), cx.lastIndex = 0, cx.test(text) && (text = text.replace(cx, function (e) {
              return "\\u" + ("0000" + e.charCodeAt(0).toString(16)).slice(-4);
            })), /^[\],:{}\s]*$/.test(text.replace(/\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g, "@").replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, "]").replace(/(?:^|:|,)(?:\s*\[)+/g, ""))) return j = eval("(" + text + ")"), "function" == typeof reviver ? walk({ "": j }, "") : j;throw new SyntaxError("socket.io:: reviver cannot JSON.parse");
          };
        }(void 0 !== io ? io : module.exports, "undefined" != typeof JSON ? JSON : void 0), function (e, t) {
          var n = e.parser = {},
              r = n.packets = ["disconnect", "connect", "heartbeat", "message", "json", "event", "ack", "error", "noop"],
              s = n.reasons = ["transport not supported", "client not handshaken", "unauthorized"],
              i = n.advice = ["reconnect"],
              o = t.JSON,
              a = t.util.indexOf;n.encodePacket = function (e) {
            var t = a(r, e.type),
                n = e.id || "",
                c = e.endpoint || "",
                u = e.ack,
                l = null;switch (e.type) {case "error":
                var m = e.reason ? a(s, e.reason) : "",
                    d = e.advice ? a(i, e.advice) : "";"" === m && "" === d || (l = m + ("" !== d ? "+" + d : ""));break;case "message":
                "" !== e.data && (l = e.data);break;case "event":
                var f = { name: e.name };e.args && e.args.length && (f.args = e.args), l = o.stringify(f);break;case "json":
                l = o.stringify(e.data);break;case "connect":
                e.qs && (l = e.qs);break;case "ack":
                l = e.ackId + (e.args && e.args.length ? "+" + o.stringify(e.args) : "");}var p = [t, n + ("data" == u ? "+" : ""), c];return null != l && p.push(l), p.join(":");
          }, n.encodePayload = function (e) {
            var t = "";if (1 == e.length) return e[0];for (var n = 0, r = e.length; n < r; n++) {
              t += "�" + e[n].length + "�" + e[n];
            }return t;
          };var c = /([^:]+):([0-9]+)?(\+)?:([^:]+)?:?([\s\S]*)?/;n.decodePacket = function (e) {
            if (!(a = e.match(c))) return {};var t = a[2] || "",
                n = (e = a[5] || "", { type: r[a[1]], endpoint: a[4] || "" });switch (t && (n.id = t, a[3] ? n.ack = "data" : n.ack = !0), n.type) {case "error":
                var a = e.split("+");n.reason = s[a[0]] || "", n.advice = i[a[1]] || "";break;case "message":
                n.data = e || "";break;case "event":
                try {
                  var u = o.parse(e);n.name = u.name, n.args = u.args;
                } catch (e) {}n.args = n.args || [];break;case "json":
                try {
                  n.data = o.parse(e);
                } catch (e) {}break;case "connect":
                n.qs = e || "";break;case "ack":
                if ((a = e.match(/^([0-9]+)(\+)?(.*)/)) && (n.ackId = a[1], n.args = [], a[3])) try {
                  n.args = a[3] ? o.parse(a[3]) : [];
                } catch (e) {}}return n;
          }, n.decodePayload = function (e) {
            var t = function t(e, _t3) {
              for (var n = 0, r = e; r < _t3.length; r++) {
                if ("�" == _t3.charAt(r)) return n;n++;
              }return n;
            };if ("�" == e.charAt(0)) {
              for (var r = [], s = 1, i = ""; s < e.length; s++) {
                if ("�" == e.charAt(s)) {
                  var o = e.substr(s + 1).substr(0, i);if ("�" != e.charAt(s + 1 + Number(i)) && s + 1 + Number(i) != e.length) {
                    var a = Number(i);l = t(s + a + 1, e), o = e.substr(s + 1).substr(0, a + l), s += l;
                  }r.push(n.decodePacket(o)), s += Number(i) + 1, i = "";
                } else i += e.charAt(s);
              }return r;
            }return [n.decodePacket(e)];
          };
        }(void 0 !== io ? io : module.exports, void 0 !== io ? io : module.parent.exports), function (e, t) {
          function n(e, t) {
            this.socket = e, this.sessid = t;
          }e.Transport = n, t.util.mixin(n, t.EventEmitter), n.prototype.heartbeats = function () {
            return !0;
          }, n.prototype.onData = function (e) {
            if (this !== this.socket.transport) return this;if (this.clearCloseTimeout(), (this.socket.connected || this.socket.connecting || this.socket.reconnecting) && this.setCloseTimeout(), "" !== e) {
              var n = t.parser.decodePayload(e);if (n && n.length) for (var r = 0, s = n.length; r < s; r++) {
                this.onPacket(n[r]);
              }
            }return this;
          }, n.prototype.onPacket = function (e) {
            return this.socket.setHeartbeatTimeout(), "heartbeat" == e.type ? this.onHeartbeat() : ("connect" == e.type && "" == e.endpoint && this.onConnect(), "error" == e.type && "reconnect" == e.advice && (this.isOpen = !1), this.socket.onPacket(e), this);
          }, n.prototype.setCloseTimeout = function () {
            if (!this.closeTimeout) {
              var e = this;this.closeTimeout = setTimeout(function () {
                e.onDisconnect();
              }, this.socket.closeTimeout);
            }
          }, n.prototype.onDisconnect = function () {
            return this.isOpen && this.close(), this.clearTimeouts(), this.socket ? (this.socket.transport === this ? this.socket.onDisconnect() : this.socket.setBuffer(!1), this) : this;
          }, n.prototype.onConnect = function () {
            return this.socket.onConnect(), this;
          }, n.prototype.clearCloseTimeout = function () {
            this.closeTimeout && (clearTimeout(this.closeTimeout), this.closeTimeout = null);
          }, n.prototype.clearTimeouts = function () {
            this.clearCloseTimeout(), this.reopenTimeout && clearTimeout(this.reopenTimeout);
          }, n.prototype.packet = function (e) {
            this.send(t.parser.encodePacket(e));
          }, n.prototype.onHeartbeat = function (e) {
            this.packet({ type: "heartbeat" });
          }, n.prototype.onOpen = function () {
            this.isOpen = !0, this.clearCloseTimeout(), this.socket.onOpen();
          }, n.prototype.onClose = function () {
            this.isOpen = !1, this.socket.transport === this ? this.socket.onClose() : this.socket.setBuffer(!1), this.onDisconnect(), this.onDisconnectDone instanceof Function && this.onDisconnectDone(null), this.onConnectionOver instanceof Function && this.onConnectionOver(null);
          }, n.prototype.onDisconnectDone = function () {}, n.prototype.onConnectionOver = function () {}, n.prototype.prepareUrl = function () {
            var e = this.socket.options;return this.scheme() + "://" + e.host + ":" + e.port + "/" + e.resource + "/" + t.protocol + "/" + this.name + "/" + this.sessid;
          }, n.prototype.ready = function (e, t) {
            t.call(this);
          };
        }(void 0 !== io ? io : module.exports, void 0 !== io ? io : module.parent.exports), function (e, t, n) {
          function r(e) {
            if (this.options = { port: 80, secure: !1, document: "document" in n && document, resource: "socket.io", transports: e.transports || t.transports, "connect timeout": 1e4, "try multiple transports": !0, reconnect: !0, "reconnection delay": 500, "reconnection limit": 1 / 0, "reopen delay": 3e3, "max reconnection attempts": 10, "sync disconnect on unload": !1, "auto connect": !0, "flash policy port": 10843, manualFlush: !1 }, t.util.merge(this.options, e), this.connected = !1, this.open = !1, this.connecting = !1, this.reconnecting = !1, this.namespaces = {}, this.buffer = [], this.doBuffer = !1, this.options["sync disconnect on unload"] && (!this.isXDomain() || t.util.ua.hasCORS)) {
              var r = this;t.util.on(n, "beforeunload", function () {
                r.disconnectSync();
              }, !1);
            }this.options["auto connect"] && this.connect();
          }function s() {}e.Socket = r, t.util.mixin(r, t.EventEmitter), r.prototype.of = function (e) {
            return this.namespaces[e] || (this.namespaces[e] = new t.SocketNamespace(this, e), "" !== e && this.namespaces[e].packet({ type: "connect" })), this.namespaces[e];
          }, r.prototype.publish = function () {
            var e;for (var t in this.emit.apply(this, arguments), this.namespaces) {
              this.namespaces.hasOwnProperty(t) && (e = this.of(t)).$emit.apply(e, arguments);
            }
          }, r.prototype.handshake = function (e) {
            var n = this,
                r = this.options;function i(t) {
              t instanceof Error ? (n.connecting = !1, n.onError(t.message)) : (console.log("SocketIO handshake success " + t), e.apply(null, t.split(":")));
            }var o = ["http" + (r.secure ? "s" : "") + ":/", r.host + ":" + r.port, r.resource, t.protocol, t.util.query(this.options.query, "t=" + +new Date())].join("/");if (this.isXDomain() && !t.util.ua.hasCORS && document && document.getElementsByTagName) {
              var a = document.getElementsByTagName("script")[0],
                  c = document.createElement("script");c.src = o + "&jsonp=" + t.j.length, c.onreadystatechange = function () {
                "loaded" == this.readyState && c.parentNode && (c.parentNode.removeChild(c), n.connecting = !1, !n.reconnecting && n.onError("Server down or port not open"), n.publish("handshake_failed"));
              }, a.parentNode.insertBefore(c, a), t.j.push(function (e) {
                i(e), c.parentNode.removeChild(c);
              });
            } else {
              var u = t.util.request();u.open("GET", o, !0), u.timeout = 1e4, this.isXDomain() && (u.withCredentials = !0), u.onreadystatechange = function () {
                4 == u.readyState && (u.onreadystatechange = s, 200 == u.status ? i(u.responseText) : 403 == u.status ? (n.connecting = !1, n.onError(u.responseText), n.publish("handshake_failed")) : (n.connecting = !1, !n.reconnecting && n.onError(u.responseText), n.publish("handshake_failed")));
              }, u.ontimeout = function (e) {
                n.connecting = !1, !n.reconnecting && n.onError(u.responseText), n.publish("handshake_failed");
              }, u.send(null);
            }
          }, r.prototype.connect = function (e) {
            if (this.connecting) return this;var n = this;return n.connecting = !0, this.handshake(function (r, s, i, o) {
              n.sessionid = r, n.closeTimeout = 1e3 * i, n.heartbeatTimeout = 1e3 * s, n.transports || (n.transports = n.origTransports = o ? t.util.intersect(o.split(","), n.options.transports) : n.options.transports), console.log("SocketIO transports: " + n.transports + " opt:" + n.options.transports), n.setHeartbeatTimeout(), n.once("connect", function () {
                clearTimeout(n.connectTimeoutTimer), n.connectTimeoutTimer = null, e && "function" == typeof e && e();
              }), n.doConnect();
            }), this;
          }, r.prototype.doConnect = function () {
            var e = this;if (e.transport && e.transport.clearTimeouts(), e.transport = e.getTransport(e.transports), !e.transport) return e.publish("connect_failed");e.transport.ready(e, function () {
              e.connecting = !0, e.publish("connecting", e.transport.name), e.transport.open(), e.options["connect timeout"] && (e.connectTimeoutTimer && clearTimeout(e.connectTimeoutTimer), e.connectTimeoutTimer = setTimeout(e.tryNextTransport.bind(e), e.options["connect timeout"]));
            });
          }, r.prototype.getTransport = function (e) {
            for (var n, r = e || this.transports, s = 0; n = r[s]; s++) {
              if (console.log("SocketIO check " + n + " " + t.Transport[n].check(this) + " , cors " + t.Transport[n].xdomainCheck(this)), t.Transport[n] && t.Transport[n].check(this) && (!this.isXDomain() || t.Transport[n].xdomainCheck(this))) return new t.Transport[n](this, this.sessionid);
            }return null;
          }, r.prototype.tryNextTransport = function () {
            console.log("SocketIO try next transport");if (!this.connected && (this.connecting = !1, this.options["try multiple transports"])) {
              for (var e = this.transports; e.length > 0 && e.splice(0, 1)[0] != this.transport.name;) {}e.length ? this.doConnect() : this.publish("connect_failed");
            }
          }, r.prototype.setHeartbeatTimeout = function () {
            if (clearTimeout(this.heartbeatTimeoutTimer), !this.transport || this.transport.heartbeats()) {
              var e = this;this.heartbeatTimeoutTimer = setTimeout(function () {
                e.transport && e.transport.onClose();
              }, this.heartbeatTimeout);
            }
          }, r.prototype.packet = function (e) {
            return this.connected && !this.doBuffer ? this.transport.packet(e) : this.buffer.push(e), this;
          }, r.prototype.setBuffer = function (e) {
            this.doBuffer = e, !e && this.connected && this.buffer.length && (this.options.manualFlush || this.flushBuffer());
          }, r.prototype.flushBuffer = function () {
            this.transport.payload(this.buffer), this.buffer = [];
          }, r.prototype.disconnect = function () {
            return (this.connected || this.connecting) && (this.open && this.of("").packet({ type: "disconnect" }), this.onDisconnect("booted")), this;
          }, r.prototype.disconnectSync = function () {
            var e = t.util.request(),
                n = ["http" + (this.options.secure ? "s" : "") + ":/", this.options.host + ":" + this.options.port, this.options.resource, t.protocol, "", this.sessionid].join("/") + "/?disconnect=1";e.open("GET", n, !1), e.send(null), this.onDisconnect("booted");
          }, r.prototype.isXDomain = function () {
            var e = n.location.port || ("https:" == n.location.protocol ? 443 : 80);return this.options.host !== n.location.hostname || this.options.port != e;
          }, r.prototype.onConnect = function () {
            this.connected || (this.connected = !0, this.connecting = !1, this.doBuffer || this.setBuffer(!1), this.emit("connect"));
          }, r.prototype.onOpen = function () {
            this.open = !0;
          }, r.prototype.onClose = function () {
            this.open = !1, clearTimeout(this.heartbeatTimeoutTimer);
          }, r.prototype.onPacket = function (e) {
            this.of(e.endpoint).onPacket(e);
          }, r.prototype.onError = function (e) {
            e && e.advice && "reconnect" === e.advice && (this.connected || this.connecting) && (this.disconnect(), this.options.reconnect && this.reconnect()), this.publish("error", e && e.reason ? e.reason : e);
          }, r.prototype.onDisconnect = function (e) {
            var t = this.connected,
                n = this.connecting;this.connected = !1, this.connecting = !1, this.open = !1, (t || n) && (this.transport.close(), this.transport.clearTimeouts(), t && (this.publish("disconnect", e), "booted" != e && this.options.reconnect && !this.reconnecting && this.reconnect()), n && (this.connectTimeoutTimer && clearTimeout(this.connectTimeoutTimer), this.tryNextTransport()));
          }, r.prototype.reconnect = function () {
            this.reconnecting = !0, this.reconnectionAttempts = 0, this.reconnectionDelay = this.options["reconnection delay"];var e = this,
                t = this.options["max reconnection attempts"],
                n = this.options["try multiple transports"],
                r = this.options["reconnection limit"];function s() {
              if (e.connected) {
                for (var t in e.namespaces) {
                  e.namespaces.hasOwnProperty(t) && "" !== t && e.namespaces[t].packet({ type: "connect" });
                }e.publish("reconnect", e.transport.name, e.reconnectionAttempts);
              }clearTimeout(e.reconnectionTimer), e.removeListener("connect_failed", i), e.removeListener("connect", i), e.reconnecting = !1, delete e.reconnectionAttempts, delete e.reconnectionDelay, delete e.reconnectionTimer, delete e.redoTransports, e.options["try multiple transports"] = n;
            }function i() {
              if (e.reconnecting) return e.connected ? s() : e.connecting && e.reconnecting ? e.reconnectionTimer = setTimeout(i, 1e3) : void (e.reconnectionAttempts++ >= t ? e.redoTransports ? (e.publish("reconnect_failed"), s()) : (e.on("connect_failed", i), e.options["try multiple transports"] = !0, e.transports = e.origTransports, e.transport = e.getTransport(), e.redoTransports = !0, e.connect()) : (e.reconnectionDelay < r && (e.reconnectionDelay *= 2), e.connect(), e.publish("reconnecting", e.reconnectionDelay, e.reconnectionAttempts), e.reconnectionTimer = setTimeout(i, e.reconnectionDelay)));
            }this.options["try multiple transports"] = !1, this.reconnectionTimer = setTimeout(i, this.reconnectionDelay), this.on("connect", i);
          };
        }(void 0 !== io ? io : module.exports, void 0 !== io ? io : module.parent.exports, root), function (e, t) {
          function n(e, t) {
            this.socket = e, this.name = t || "", this.flags = {}, this.json = new r(this, "json"), this.ackPackets = 0, this.acks = {};
          }function r(e, t) {
            this.namespace = e, this.name = t;
          }e.SocketNamespace = n, t.util.mixin(n, t.EventEmitter), n.prototype.$emit = t.EventEmitter.prototype.emit, n.prototype.of = function () {
            return this.socket.of.apply(this.socket, arguments);
          }, n.prototype.packet = function (e) {
            return e.endpoint = this.name, this.socket.packet(e), this.flags = {}, this;
          }, n.prototype.send = function (e, t) {
            var n = { type: this.flags.json ? "json" : "message", data: e };return "function" == typeof t && (n.id = ++this.ackPackets, n.ack = !0, this.acks[n.id] = t), this.packet(n);
          }, n.prototype.emit = function (e) {
            var t = Array.prototype.slice.call(arguments, 1),
                n = t[t.length - 1],
                r = { type: "event", name: e };return "function" == typeof n && (r.id = ++this.ackPackets, r.ack = "data", this.acks[r.id] = n, t = t.slice(0, t.length - 1)), r.args = t, this.packet(r);
          }, n.prototype.disconnect = function () {
            return "" === this.name ? this.socket.disconnect() : (this.packet({ type: "disconnect" }), this.$emit("disconnect")), this;
          }, n.prototype.onPacket = function (e) {
            var n = this;function r() {
              n.packet({ type: "ack", args: t.util.toArray(arguments), ackId: e.id });
            }switch (e.type) {case "connect":
                this.$emit("connect");break;case "disconnect":
                "" === this.name ? this.socket.onDisconnect(e.reason || "booted") : this.$emit("disconnect", e.reason);break;case "message":case "json":
                var s = ["message", e.data];"data" == e.ack ? s.push(r) : e.ack && this.packet({ type: "ack", ackId: e.id }), this.$emit.apply(this, s);break;case "event":
                s = [e.name].concat(e.args);"data" == e.ack && s.push(r), this.$emit.apply(this, s);break;case "ack":
                this.acks[e.ackId] && (this.acks[e.ackId].apply(this, e.args), delete this.acks[e.ackId]);break;case "error":
                console.error("SocketIO on packet error: ", e), e.advice ? this.socket.onError(e) : "unauthorized" === e.reason ? this.$emit("connect_failed", e.reason) : this.$emit("error", e.reason);}
          }, r.prototype.send = function () {
            this.namespace.flags[this.name] = !0, this.namespace.send.apply(this.namespace, arguments);
          }, r.prototype.emit = function () {
            this.namespace.flags[this.name] = !0, this.namespace.emit.apply(this.namespace, arguments);
          };
        }(void 0 !== io ? io : module.exports, void 0 !== io ? io : module.parent.exports), function (e, t, n) {
          function r(e) {
            t.Transport.apply(this, arguments);
          }e.websocket = r, t.util.inherit(r, t.Transport), r.prototype.name = "websocket", r.prototype.open = function () {
            var e,
                r = t.util.query(this.socket.options.query),
                s = this;return e || (e = n.MozWebSocket || n.WebSocket), this.websocket = new e(this.prepareUrl() + r), this.websocket.onopen = function () {
              s.onOpen(), s.socket.setBuffer(!1);
            }, this.websocket.onmessage = function (e) {
              s.onData(e.data);
            }, this.websocket.onclose = function () {
              s.socket.setBuffer(!0), s.onClose();
            }, this.websocket.onerror = function (e) {
              s.onError(e);
            }, this;
          }, t.util.ua.iDevice ? r.prototype.send = function (e) {
            var t = this;return setTimeout(function () {
              t.websocket.send(e);
            }, 0), this;
          } : r.prototype.send = function (e) {
            return this.websocket.send(e), this;
          }, r.prototype.payload = function (e) {
            for (var t = 0, n = e.length; t < n; t++) {
              this.packet(e[t]);
            }return this;
          }, r.prototype.close = function () {
            return this.websocket.close(), this;
          }, r.prototype.onError = function (e) {
            this.socket.onError(e);
          }, r.prototype.scheme = function () {
            return this.socket.options.secure ? "wss" : "ws";
          }, r.check = function () {
            return "WebSocket" in n && !("__addTask" in WebSocket) || "MozWebSocket" in n;
          }, r.xdomainCheck = function () {
            return !0;
          }, t.transports.push("websocket");
        }(void 0 !== io ? io.Transport : module.exports, void 0 !== io ? io : module.parent.exports, root), function (e, t, n) {
          function r(e) {
            e && (t.Transport.apply(this, arguments), this.sendBuffer = []);
          }function s() {}e.XHR = r, t.util.inherit(r, t.Transport), r.prototype.open = function () {
            return this.socket.setBuffer(!1), this.onOpen(), this.get(), this.setCloseTimeout(), this;
          }, r.prototype.payload = function (e) {
            for (var n = [], r = 0, s = e.length; r < s; r++) {
              n.push(t.parser.encodePacket(e[r]));
            }this.send(t.parser.encodePayload(n));
          }, r.prototype.send = function (e) {
            return this.post(e), this;
          }, r.prototype.post = function (e) {
            var t = this;this.socket.setBuffer(!0), this.sendXHR = this.request("POST"), n.XDomainRequest && this.sendXHR instanceof XDomainRequest ? this.sendXHR.onload = this.sendXHR.onerror = function () {
              this.onload = s, t.socket.setBuffer(!1);
            } : this.sendXHR.onreadystatechange = function () {
              4 == this.readyState && (this.onreadystatechange = s, t.posting = !1, 200 == this.status ? t.socket.setBuffer(!1) : t.onClose());
            }, this.sendXHR.send(e);
          }, r.prototype.close = function () {
            return this.onClose(), this;
          }, r.prototype.request = function (e) {
            var n = t.util.request(this.socket.isXDomain()),
                r = t.util.query(this.socket.options.query, "t=" + +new Date());if (n.open(e || "GET", this.prepareUrl() + r, !0), "POST" == e) try {
              n.setRequestHeader ? n.setRequestHeader("Content-type", "text/plain;charset=UTF-8") : n.contentType = "text/plain";
            } catch (e) {}return n;
          }, r.prototype.scheme = function () {
            return this.socket.options.secure ? "https" : "http";
          }, r.check = function (e, r) {
            try {
              var s = t.util.request(r),
                  i = n.XDomainRequest && s instanceof XDomainRequest,
                  o = e && e.options && e.options.secure ? "https:" : "http:",
                  a = n.location && o != n.location.protocol;if (s && (!i || !a)) return !0;
            } catch (e) {}return !1;
          }, r.xdomainCheck = function (e) {
            return r.check(e, !0);
          };
        }(void 0 !== io ? io.Transport : module.exports, void 0 !== io ? io : module.parent.exports, root), function (e, t, n) {
          function r() {
            t.Transport.XHR.apply(this, arguments);
          }function s() {}e["xhr-polling"] = r, t.util.inherit(r, t.Transport.XHR), t.util.merge(r, t.Transport.XHR), r.prototype.name = "xhr-polling", r.prototype.heartbeats = function () {
            return !1;
          }, r.prototype.open = function () {
            return t.Transport.XHR.prototype.open.call(this), !1;
          }, r.prototype.get = function () {
            if (this.isOpen) {
              var e = this;this.xhr = this.request(), n.XDomainRequest && this.xhr instanceof XDomainRequest ? (this.xhr.onload = function () {
                this.onload = s, this.onerror = s, e.retryCounter = 1, e.onData(this.responseText), e.get();
              }, this.xhr.onerror = function () {
                e.retryCounter++, !e.retryCounter || e.retryCounter > 3 ? e.onClose() : e.get();
              }) : this.xhr.onreadystatechange = function () {
                4 == this.readyState && (this.onreadystatechange = s, 200 == this.status ? (e.onData(this.responseText), e.get()) : e.onClose());
              }, this.xhr.send(null);
            }
          }, r.prototype.onClose = function () {
            if (t.Transport.XHR.prototype.onClose.call(this), this.xhr) {
              this.xhr.onreadystatechange = this.xhr.onload = this.xhr.onerror = s;try {
                this.xhr.abort();
              } catch (e) {}this.xhr = null;
            }
          }, r.prototype.ready = function (e, n) {
            var r = this;t.util.defer(function () {
              n.call(r);
            });
          }, t.transports.push("xhr-polling");
        }(void 0 !== io ? io.Transport : module.exports, void 0 !== io ? io : module.parent.exports, root), __WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
          return io;
        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), void 0 === __WEBPACK_AMD_DEFINE_RESULT__ || (module.exports = __WEBPACK_AMD_DEFINE_RESULT__);
      }();
    }).call(this, __webpack_require__(31), __webpack_require__(293)(module));
  }, function (e, t, n) {
    "use strict";
    var r = { 1: "ROOM_CLOSE", 2: "ROOM_JOIN", 3: "INVITE", 4: "CANCEL_INVITE", 5: "REJECT", 6: "ACCEPT", 7: "LEAVE", 8: "CONTROL" },
        s = { 1: "accid", 2: "uid", 3: "createTime", 4: "expireTime", 5: "web_uid" },
        i = { 10404: "ROOM_NOT_EXISTS", 10405: "ROOM_HAS_EXISTS", 10406: "ROOM_MEMBER_NOT_EXISTS", 10407: "ROOM_MEMBER_HAS_EXISTS", 10408: "INVITE_NOT_EXISTS", 10409: "INVITE_HAS_REJECT", 10410: "INVITE_HAS_ACCEPT", 10201: "PEER_NIM_OFFLINE", 10202: "PEER_PUSH_OFFLINE", 10419: "ROOM_MEMBER_EXCEED", 10420: "ROOM_MEMBER_HAS_EXISTS_OTHER_CLIENT", 10417: "UID_CONFLICT" };e.exports = { parseAvSignalType: function parseAvSignalType(e) {
        return r[e] || e;
      }, parseAvSignalMember: function parseAvSignalMember(e) {
        var t = {};return __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_keys___default()(e).forEach(function (n) {
          t[s[n]] = e[n];
        }), t;
      }, parseAvSignalError: function parseAvSignalError(e) {
        return e.message = i[e.code] || e.message || e, e;
      } };
  }, function (e, t, n) {
    "use strict";
    var r = n(0),
        s = { stripmeta: 0, blur: 2, quality: 3, crop: 4, rotate: 5, thumbnail: 7, interlace: 9 },
        i = { 0: "stripmeta", 1: "type", 2: "blur", 3: "quality", 4: "crop", 5: "rotate", 6: "pixel", 7: "thumbnail", 8: "watermark", 9: "interlace", 10: "tmp" };function o(e) {
      r.verifyOptions(e, "type", "image::ImageOp"), r.verifyParamValid("type", e.type, o.validTypes, "image::ImageOp"), r.merge(this, e), this.type = s[e.type];
    }o.validTypes = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_keys___default()(s), o.reverse = function (e) {
      var t = r.copy(e);return t.type = i[t.type], t;
    }, o.reverseImageOps = function (e) {
      return e.map(function (e) {
        return o.reverse(e);
      });
    }, e.exports = o;
  }, function (e, t, n) {
    "use strict";
    var r = n(0),
        s = { fromDataURL: function fromDataURL(e) {
        var t = r.getGlobal(),
            n = void 0;n = e.split(",")[0].indexOf("base64") >= 0 ? t.atob(e.split(",")[1]) : t.decodeURIComponent(e.split(",")[1]);for (var s = e.split(",")[0].split(":")[1].split(";")[0], i = new Uint8Array(n.length), o = 0; o < n.length; o++) {
          i[o] = n.charCodeAt(o);
        }return new t.Blob([i], { type: s });
      } };e.exports = s;
  }, function (e, t, n) {
    "use strict";
    var r = n(0),
        s = { file: { md5: "$(Etag)", size: "$(ObjectSize)" }, image: { md5: "$(Etag)", size: "$(ObjectSize)", w: "$(ImageInfo.Width)", h: "$(ImageInfo.Height)", orientation: "$(ImageInfo.Orientation)" }, audio: { md5: "$(Etag)", size: "$(ObjectSize)", dur: "$(AVinfo.Audio.Duration)" }, video: { md5: "$(Etag)", size: "$(ObjectSize)", dur: "$(AVinfo.Video.Duration)", w: "$(AVinfo.Video.Width)", h: "$(AVinfo.Video.Height)" } },
        i = { genResponseBody: function genResponseBody(e) {
        return s[e = e || "file"];
      }, parseResponse: function parseResponse(e, t) {
        r.notundef(e.size) && (e.size = +e.size), r.notundef(e.w) && (e.w = +e.w), r.notundef(e.h) && (e.h = +e.h), r.notundef(e.dur) && (e.dur = +e.dur);var n = e.orientation;if (r.notundef(n) && (delete e.orientation, t && ("right, top" === n || "left, bottom" === n))) {
          var s = e.w;e.w = e.h, e.h = s;
        }return e;
      } };e.exports = i;
  },,,,,,,,,,,, function (e, t, n) {
    "use strict";
    var r = n(22),
        s = n(282),
        i = n(152),
        o = n(73),
        a = n(68),
        c = n(0),
        u = n(172),
        l = n(155),
        m = n(36),
        d = n(276),
        f = n(275);e.exports = function (e) {
      c.merge(e, { platform: r, xhr: s, io: i, naturalSort: o, deepAccess: a, util: c, support: u, blob: l, ajax: m, LoggerPlugin: d, usePlugin: f });
    };
  }, function (e, t, n) {
    "use strict";
    var r = n(0),
        s = n(79),
        i = r.merge({}, s.idMap, { auth: { id: 2, login: 3, kicked: 5, logout: 6, multiPortLogin: 7, kick: 8 }, user: { id: 3, updatePushToken: 1, appBackground: 2, markInBlacklist: 3, getBlacklist: 4, markInMutelist: 5, getMutelist: 6, getRelations: 8, getUsers: 7, updateMyInfo: 10, updateDonnop: 15, syncMyInfo: 109, syncUpdateMyInfo: 110 }, notify: { id: 4, markRead: 3, syncOfflineMsgs: 4, batchMarkRead: 5, syncOfflineSysMsgs: 6, syncRoamingMsgs: 9, syncMsgReceipts: 12, syncRobots: 15, syncBroadcastMsgs: 16 }, sync: { id: 5, sync: 1, syncTeamMembers: 2 }, msg: { id: 7, sendMsg: 1, msg: 2, sysMsg: 3, getHistoryMsgs: 6, sendCustomSysMsg: 7, searchHistoryMsgs: 8, deleteSessions: 9, getSessions: 10, syncSendMsg: 101, sendMsgReceipt: 11, msgReceipt: 12, deleteMsg: 13, msgDeleted: 14, markSessionAck: 16, broadcastMsg: 17 }, team: { id: 8, createTeam: 1, sendTeamMsg: 2, teamMsg: 3, teamMsgs: 4, addTeamMembers: 5, removeTeamMembers: 6, updateTeam: 7, leaveTeam: 8, getTeam: 9, getTeams: 10, getTeamMembers: 11, dismissTeam: 12, applyTeam: 13, passTeamApply: 14, rejectTeamApply: 15, addTeamManagers: 16, removeTeamManagers: 17, transferTeam: 18, updateInfoInTeam: 19, updateNickInTeam: 20, acceptTeamInvite: 21, rejectTeamInvite: 22, getTeamHistoryMsgs: 23, searchTeamHistoryMsgs: 24, updateMuteStateInTeam: 25, getMyTeamMembers: 26, getMutedTeamMembers: 27, sendTeamMsgReceipt: 28, getTeamMsgReads: 29, getTeamMsgReadAccounts: 30, notifyTeamMsgReads: 31, muteTeamAll: 32, syncMyTeamMembers: 126, syncTeams: 109, syncTeamMembers: 111, syncCreateTeam: 101, syncSendTeamMsg: 102, syncUpdateTeamMember: 119 }, friend: { id: 12, friendRequest: 1, syncFriendRequest: 101, deleteFriend: 2, syncDeleteFriend: 102, updateFriend: 3, syncUpdateFriend: 103, getFriends: 4 }, chatroom: { id: 13, getChatroomAddress: 1 }, filter: { id: 101, sendFilterMsg: 1, filterMsg: 2, filterSysMsg: 3, sendFilterCustomSysMsg: 7 }, eventService: { id: 14, publishEvent: 1, pushEvent: 2, subscribeEvent: 3, unSubscribeEventsByAccounts: 4, unSubscribeEventsByType: 5, querySubscribeEventsByAccounts: 6, querySubscribeEventsByType: 7, pushEvents: 9 } }),
        o = r.merge({}, s.cmdConfig, { login: { sid: i.auth.id, cid: i.auth.login, params: [{ type: "Property", name: "login" }] }, logout: { sid: i.auth.id, cid: i.auth.logout }, kick: { sid: i.auth.id, cid: i.auth.kick, params: [{ type: "StrArray", name: "deviceIds" }] }, updatePushToken: { sid: i.user.id, cid: i.user.updatePushToken, params: [{ type: "String", name: "tokenName" }, { type: "String", name: "token" }, { type: "int", name: "pushkit" }] }, appBackground: { sid: i.user.id, cid: i.user.appBackground, params: [{ type: "bool", name: "isBackground" }, { type: "Int", name: "badge" }] }, markInBlacklist: { sid: i.user.id, cid: i.user.markInBlacklist, params: [{ type: "String", name: "account" }, { type: "bool", name: "isAdd" }] }, getBlacklist: { sid: i.user.id, cid: i.user.getBlacklist, params: [{ type: "long", name: "time" }] }, markInMutelist: { sid: i.user.id, cid: i.user.markInMutelist, params: [{ type: "String", name: "account" }, { type: "bool", name: "isAdd" }] }, getMutelist: { sid: i.user.id, cid: i.user.getMutelist, params: [{ type: "long", name: "time" }] }, getRelations: { sid: i.user.id, cid: i.user.getRelations, params: [{ type: "long", name: "timetag" }] }, getUsers: { sid: i.user.id, cid: i.user.getUsers, params: [{ type: "StrArray", name: "accounts" }] }, updateMyInfo: { sid: i.user.id, cid: i.user.updateMyInfo, params: [{ type: "Property", name: "user" }] }, updateDonnop: { sid: i.user.id, cid: i.user.updateDonnop, params: [{ type: "Property", name: "donnop" }] }, markRead: { sid: i.notify.id, cid: i.notify.markRead, params: [{ type: "long", name: "id" }, { type: "ph", name: "ph" }] }, batchMarkRead: { sid: i.notify.id, cid: i.notify.batchMarkRead, params: [{ type: "byte", name: "sid" }, { type: "byte", name: "cid" }, { type: "LongArray", name: "ids" }] }, sync: { sid: i.sync.id, cid: i.sync.sync, params: [{ type: "Property", name: "sync" }] }, syncTeamMembers: { sid: i.sync.id, cid: i.sync.syncTeamMembers, params: [{ type: "LongLongMap", name: "sync" }] }, sendMsg: { sid: i.msg.id, cid: i.msg.sendMsg, params: [{ type: "Property", name: "msg" }] }, getHistoryMsgs: { sid: i.msg.id, cid: i.msg.getHistoryMsgs, params: [{ type: "String", name: "to" }, { type: "long", name: "beginTime" }, { type: "long", name: "endTime" }, { type: "long", name: "lastMsgId" }, { type: "int", name: "limit" }, { type: "bool", name: "reverse" }, { type: "LongArray", name: "msgTypes" }] }, sendCustomSysMsg: { sid: i.msg.id, cid: i.msg.sendCustomSysMsg, params: [{ type: "Property", name: "sysMsg" }] }, searchHistoryMsgs: { sid: i.msg.id, cid: i.msg.searchHistoryMsgs, params: [{ type: "String", name: "to" }, { type: "long", name: "beginTime" }, { type: "long", name: "endTime" }, { type: "String", name: "keyword" }, { type: "int", name: "limit" }, { type: "bool", name: "reverse" }] }, getSessions: { sid: i.msg.id, cid: i.msg.getSessions, params: [{ type: "long", name: "time" }] }, deleteSessions: { sid: i.msg.id, cid: i.msg.deleteSessions, params: [{ type: "StrArray", name: "sessions" }] }, sendMsgReceipt: { sid: i.msg.id, cid: i.msg.sendMsgReceipt, params: [{ type: "Property", name: "msgReceipt" }] }, deleteMsg: { sid: i.msg.id, cid: i.msg.deleteMsg, params: [{ type: "Property", name: "sysMsg" }] }, markSessionAck: { sid: i.msg.id, cid: i.msg.markSessionAck, params: [{ type: "byte", name: "scene" }, { type: "String", name: "to" }, { type: "long", name: "timetag" }] }, createTeam: { sid: i.team.id, cid: i.team.createTeam, params: [{ type: "Property", name: "team" }, { type: "StrArray", name: "accounts" }, { type: "String", name: "ps" }] }, sendTeamMsg: { sid: i.team.id, cid: i.team.sendTeamMsg, params: [{ type: "Property", name: "msg" }] }, addTeamMembers: { sid: i.team.id, cid: i.team.addTeamMembers, params: [{ type: "long", name: "teamId" }, { type: "StrArray", name: "accounts" }, { type: "String", name: "ps" }, { type: "String", name: "attach" }] }, removeTeamMembers: { sid: i.team.id, cid: i.team.removeTeamMembers, params: [{ type: "long", name: "teamId" }, { type: "StrArray", name: "accounts" }] }, updateTeam: { sid: i.team.id, cid: i.team.updateTeam, params: [{ type: "Property", name: "team" }] }, leaveTeam: { sid: i.team.id, cid: i.team.leaveTeam, params: [{ type: "long", name: "teamId" }] }, getTeam: { sid: i.team.id, cid: i.team.getTeam, params: [{ type: "long", name: "teamId" }] }, getTeams: { sid: i.team.id, cid: i.team.getTeams, params: [{ type: "long", name: "timetag" }] }, getTeamMembers: { sid: i.team.id, cid: i.team.getTeamMembers, params: [{ type: "long", name: "teamId" }, { type: "long", name: "timetag" }] }, dismissTeam: { sid: i.team.id, cid: i.team.dismissTeam, params: [{ type: "long", name: "teamId" }] }, applyTeam: { sid: i.team.id, cid: i.team.applyTeam, params: [{ type: "long", name: "teamId" }, { type: "String", name: "ps" }] }, passTeamApply: { sid: i.team.id, cid: i.team.passTeamApply, params: [{ type: "long", name: "teamId" }, { type: "String", name: "from" }] }, rejectTeamApply: { sid: i.team.id, cid: i.team.rejectTeamApply, params: [{ type: "long", name: "teamId" }, { type: "String", name: "from" }, { type: "String", name: "ps" }] }, addTeamManagers: { sid: i.team.id, cid: i.team.addTeamManagers, params: [{ type: "long", name: "teamId" }, { type: "StrArray", name: "accounts" }] }, removeTeamManagers: { sid: i.team.id, cid: i.team.removeTeamManagers, params: [{ type: "long", name: "teamId" }, { type: "StrArray", name: "accounts" }] }, transferTeam: { sid: i.team.id, cid: i.team.transferTeam, params: [{ type: "long", name: "teamId" }, { type: "String", name: "account" }, { type: "bool", name: "leave" }] }, updateInfoInTeam: { sid: i.team.id, cid: i.team.updateInfoInTeam, params: [{ type: "Property", name: "teamMember" }] }, updateNickInTeam: { sid: i.team.id, cid: i.team.updateNickInTeam, params: [{ type: "Property", name: "teamMember" }] }, acceptTeamInvite: { sid: i.team.id, cid: i.team.acceptTeamInvite, params: [{ type: "long", name: "teamId" }, { type: "String", name: "from" }] }, rejectTeamInvite: { sid: i.team.id, cid: i.team.rejectTeamInvite, params: [{ type: "long", name: "teamId" }, { type: "String", name: "from" }, { type: "String", name: "ps" }] }, getTeamHistoryMsgs: { sid: i.team.id, cid: i.team.getTeamHistoryMsgs, params: [{ type: "long", name: "to" }, { type: "long", name: "beginTime" }, { type: "long", name: "endTime" }, { type: "long", name: "lastMsgId" }, { type: "int", name: "limit" }, { type: "bool", name: "reverse" }, { type: "LongArray", name: "msgTypes" }] }, searchTeamHistoryMsgs: { sid: i.team.id, cid: i.team.searchTeamHistoryMsgs, params: [{ type: "long", name: "to" }, { type: "long", name: "beginTime" }, { type: "long", name: "endTime" }, { type: "String", name: "keyword" }, { type: "int", name: "limit" }, { type: "bool", name: "reverse" }] }, updateMuteStateInTeam: { sid: i.team.id, cid: i.team.updateMuteStateInTeam, params: [{ type: "long", name: "teamId" }, { type: "String", name: "account" }, { type: "int", name: "mute" }] }, getMyTeamMembers: { sid: i.team.id, cid: i.team.getMyTeamMembers, params: [{ type: "LongArray", name: "teamIds" }] }, getMutedTeamMembers: { sid: i.team.id, cid: i.team.getMutedTeamMembers, params: [{ type: "long", name: "teamId" }] }, sendTeamMsgReceipt: { sid: i.team.id, cid: i.team.sendTeamMsgReceipt, params: [{ type: "PropertyArray", name: "teamMsgReceipts", entity: "teamMsgReceipt" }] }, getTeamMsgReads: { sid: i.team.id, cid: i.team.getTeamMsgReads, params: [{ type: "PropertyArray", name: "teamMsgReceipts", entity: "teamMsgReceipt" }] }, getTeamMsgReadAccounts: { sid: i.team.id, cid: i.team.getTeamMsgReadAccounts, params: [{ type: "Property", name: "teamMsgReceipt" }] }, muteTeamAll: { sid: i.team.id, cid: i.team.muteTeamAll, params: [{ type: "long", name: "teamId" }, { type: "int", name: "muteType" }] }, friendRequest: { sid: i.friend.id, cid: i.friend.friendRequest, params: [{ type: "String", name: "account" }, { type: "byte", name: "type" }, { type: "String", name: "ps" }] }, deleteFriend: { sid: i.friend.id, cid: i.friend.deleteFriend, params: [{ type: "String", name: "account" }] }, updateFriend: { sid: i.friend.id, cid: i.friend.updateFriend, params: [{ type: "Property", name: "friend" }] }, getFriends: { sid: i.friend.id, cid: i.friend.getFriends, params: [{ type: "long", name: "timetag" }] }, getChatroomAddress: { sid: i.chatroom.id, cid: i.chatroom.getChatroomAddress, params: [{ type: "long", name: "chatroomId" }, { type: "bool", name: "isWeixinApp" }] }, sendFilterMsg: { sid: i.filter.id, cid: i.filter.sendFilterMsg, params: [{ type: "Property", name: "msg" }] }, sendFilterCustomSysMsg: { sid: i.filter.id, cid: i.filter.sendFilterCustomSysMsg, params: [{ type: "Property", name: "sysMsg" }] }, publishEvent: { sid: i.eventService.id, cid: i.eventService.publishEvent, params: [{ type: "Property", name: "msgEvent" }] }, pushEvent: { sid: i.eventService.id, cid: i.eventService.pushEvent }, subscribeEvent: { sid: i.eventService.id, cid: i.eventService.subscribeEvent, params: [{ type: "Property", name: "msgEventSubscribe" }, { type: "StrArray", name: "accounts" }] }, unSubscribeEventsByAccounts: { sid: i.eventService.id, cid: i.eventService.unSubscribeEventsByAccounts, params: [{ type: "Property", name: "msgEventSubscribe" }, { type: "StrArray", name: "accounts" }] }, unSubscribeEventsByType: { sid: i.eventService.id, cid: i.eventService.unSubscribeEventsByType, params: [{ type: "Property", name: "msgEventSubscribe" }] }, querySubscribeEventsByAccounts: { sid: i.eventService.id, cid: i.eventService.querySubscribeEventsByAccounts, params: [{ type: "Property", name: "msgEventSubscribe" }, { type: "StrArray", name: "accounts" }] }, querySubscribeEventsByType: { sid: i.eventService.id, cid: i.eventService.querySubscribeEventsByType, params: [{ type: "Property", name: "msgEventSubscribe" }] }, pushEvents: { sid: i.eventService.id, cid: i.eventService.pushEvents } }),
        a = r.merge({}, s.packetConfig, { "2_3": { service: "auth", cmd: "login", response: [{ type: "Property", name: "loginRes" }, { type: "PropertyArray", name: "loginPorts", entity: "loginPort" }, { type: "Property", name: "aosPushInfo" }] }, "2_5": { service: "auth", cmd: "kicked", response: [{ type: "Number", name: "from" }, { type: "Number", name: "reason" }] }, "2_6": { service: "auth", cmd: "logout" }, "2_7": { service: "auth", cmd: "multiPortLogin", response: [{ type: "Number", name: "state" }, { type: "PropertyArray", name: "loginPorts", entity: "loginPort" }] }, "2_8": { service: "auth", cmd: "kick", response: [{ type: "StrArray", name: "deviceIds" }] }, "3_1": { service: "user", cmd: "updatePushToken" }, "3_2": { service: "user", cmd: "appBackground" }, "3_3": { service: "user", cmd: "markInBlacklist" }, "3_103": { service: "user", cmd: "syncMarkInBlacklist", response: [{ type: "String", name: "account" }, { type: "Boolean", name: "isAdd" }] }, "3_4": { service: "user", cmd: "getBlacklist", response: [{ type: "StrArray", name: "blacklist" }] }, "3_5": { service: "user", cmd: "markInMutelist" }, "3_105": { service: "user", cmd: "syncMarkInMutelist", response: [{ type: "String", name: "account" }, { type: "Boolean", name: "isAdd" }] }, "3_6": { service: "user", cmd: "getMutelist", response: [{ type: "StrArray", name: "mutelist" }] }, "3_8": { service: "user", cmd: "getRelations", response: [{ type: "PropertyArray", name: "specialRelations", entity: "specialRelation" }, { type: "Number", name: "timetag" }] }, "3_7": { service: "user", cmd: "getUsers", response: [{ type: "PropertyArray", name: "users", entity: "user" }] }, "3_10": { service: "user", cmd: "updateMyInfo", response: [{ type: "Number", name: "timetag" }] }, "3_15": { service: "user", cmd: "updateDonnop", response: [{ type: "Number", name: "timetag" }] }, "3_115": { service: "user", cmd: "syncUpdateDonnop", response: [{ type: "Property", name: "donnop" }, { type: "Number", name: "timetag" }] }, "3_109": { service: "user", cmd: "syncMyInfo", response: [{ type: "Property", name: "user" }, { type: "Number", name: "timetag" }] }, "3_110": { service: "user", cmd: "syncUpdateMyInfo", response: [{ type: "Property", name: "user" }] }, "4_1": { service: "notify" }, "4_2": { service: "notify" }, "4_3": { service: "notify", cmd: "markRead" }, "4_4": { service: "notify", cmd: "syncOfflineMsgs", response: [{ type: "PropertyArray", name: "msgs", entity: "msg" }] }, "4_5": { service: "notify", cmd: "batchMarkRead" }, "4_6": { service: "notify", cmd: "syncOfflineSysMsgs", response: [{ type: "PropertyArray", name: "sysMsgs", entity: "sysMsg" }] }, "4_9": { service: "notify", cmd: "syncRoamingMsgs", response: [{ type: "PropertyArray", name: "msgs", entity: "msg" }] }, "4_12": { service: "notify", cmd: "syncMsgReceipts", response: [{ type: "PropertyArray", name: "msgReceipts", entity: "msgReceipt" }, { type: "Number", name: "timetag" }] }, "4_13": { service: "notify", cmd: "syncDonnop", response: [{ type: "Property", name: "donnop" }, { type: "Number", name: "timetag" }] }, "4_14": { service: "notify", cmd: "syncSessionAck", response: [{ type: "StrLongMap", name: "p2p" }, { type: "LongLongMap", name: "team" }, { type: "Number", name: "timetag" }] }, "4_15": { service: "notify", cmd: "syncRobots", response: [{ type: "PropertyArray", name: "robots", entity: "robot" }] }, "4_16": { service: "notify", cmd: "syncBroadcastMsgs", response: [{ type: "PropertyArray", name: "broadcastMsgs", entity: "broadcastMsg" }] }, "4_100": { service: "notify", cmd: "syncOfflineFilterMsgs", response: [{ type: "PropertyArray", name: "msgs", entity: "msg" }] }, "4_101": { service: "notify", cmd: "syncOfflineFilterSysMsgs", response: [{ type: "PropertyArray", name: "sysMsgs", entity: "sysMsg" }] }, "5_1": { service: "sync", cmd: "syncDone", response: [{ type: "Number", name: "timetag" }] }, "5_2": { service: "sync", cmd: "syncTeamMembersDone", response: [{ type: "Number", name: "timetag" }] }, "7_1": { service: "msg", cmd: "sendMsg", response: [{ type: "Property", name: "msg" }], trivialErrorCodes: [7101] }, "7_2": { service: "msg", cmd: "msg", response: [{ type: "Property", name: "msg" }] }, "7_3": { service: "msg", cmd: "sysMsg", response: [{ type: "Property", name: "sysMsg" }] }, "7_6": { service: "msg", cmd: "getHistoryMsgs", response: [{ type: "PropertyArray", name: "msgs", entity: "msg" }] }, "7_7": { service: "msg", cmd: "sendCustomSysMsg", trivialErrorCodes: [7101] }, "7_8": { service: "msg", cmd: "searchHistoryMsgs", response: [{ type: "PropertyArray", name: "msgs", entity: "msg" }] }, "7_9": { service: "msg", cmd: "deleteSessions" }, "7_10": { service: "msg", cmd: "getSessions", response: [{ type: "StrArray", name: "sessions" }] }, "7_101": { service: "msg", cmd: "syncSendMsg", response: [{ type: "Property", name: "msg" }] }, "7_11": { service: "msg", cmd: "sendMsgReceipt", response: [{ type: "Property", name: "msgReceipt" }] }, "7_12": { service: "msg", cmd: "msgReceipt", response: [{ type: "Property", name: "msgReceipt" }] }, "7_13": { service: "msg", cmd: "onDeleteMsg" }, "7_14": { service: "msg", cmd: "onMsgDeleted", response: [{ type: "Property", name: "sysMsg" }] }, "7_15": { service: "msg", cmd: "onDeleteMsgOfflineRoaming", response: [{ type: "PropertyArray", name: "sysMsgs", entity: "sysMsg" }, { type: "Number", name: "timetag" }, { type: "Number", name: "type" }] }, "7_16": { service: "msg", cmd: "onMarkSessionAck" }, "7_17": { service: "msg", cmd: "broadcastMsg", response: [{ type: "Property", name: "broadcastMsg" }] }, "7_116": { service: "msg", cmd: "syncMarkSessionAck", response: [{ type: "Number", name: "scene" }, { type: "String", name: "to" }, { type: "Number", name: "timetag" }] }, "8_1": { service: "team", cmd: "createTeam", response: [{ type: "Property", name: "team" }, { type: "StrArray", name: "abortedAccidList" }] }, "8_2": { service: "team", cmd: "sendTeamMsg", response: [{ type: "Property", name: "msg" }] }, "8_3": { service: "team", cmd: "teamMsg", response: [{ type: "Property", name: "msg" }] }, "8_4": { service: "team", cmd: "teamMsgs", response: [{ type: "PropertyArray", name: "msgs", entity: "msg" }] }, "8_5": { service: "team", cmd: "addTeamMembers", response: [{ type: "long", name: "time" }, { type: "StrArray", name: "abortedAccidList" }] }, "8_6": { service: "team", cmd: "removeTeamMembers" }, "8_7": { service: "team", cmd: "updateTeam", response: [{ type: "Number", name: "id" }, { type: "Number", name: "time" }] }, "8_8": { service: "team", cmd: "leaveTeam" }, "8_9": { service: "team", cmd: "getTeam", response: [{ type: "Property", name: "team" }] }, "8_10": { service: "team", cmd: "getTeams", response: [{ type: "PropertyArray", name: "teams", entity: "team" }, { type: "Number", name: "timetag" }] }, "8_11": { service: "team", cmd: "getTeamMembers", response: [{ type: "Number", name: "teamId" }, { type: "PropertyArray", name: "members", entity: "teamMember" }, { type: "Number", name: "timetag" }] }, "8_12": { service: "team", cmd: "dismissTeam" }, "8_13": { service: "team", cmd: "applyTeam", response: [{ type: "Property", name: "team" }] }, "8_14": { service: "team", cmd: "passTeamApply" }, "8_15": { service: "team", cmd: "rejectTeamApply" }, "8_16": { service: "team", cmd: "addTeamManagers" }, "8_17": { service: "team", cmd: "removeTeamManagers" }, "8_18": { service: "team", cmd: "transferTeam" }, "8_19": { service: "team", cmd: "updateInfoInTeam" }, "8_20": { service: "team", cmd: "updateNickInTeam" }, "8_21": { service: "team", cmd: "acceptTeamInvite", response: [{ type: "Property", name: "team" }] }, "8_22": { service: "team", cmd: "rejectTeamInvite" }, "8_23": { service: "team", cmd: "getTeamHistoryMsgs", response: [{ type: "PropertyArray", name: "msgs", entity: "msg" }] }, "8_24": { service: "team", cmd: "searchTeamHistoryMsgs", response: [{ type: "PropertyArray", name: "msgs", entity: "msg" }] }, "8_25": { service: "team", cmd: "updateMuteStateInTeam" }, "8_26": { service: "team", cmd: "getMyTeamMembers", response: [{ type: "PropertyArray", name: "teamMembers", entity: "teamMember" }] }, "8_27": { service: "team", cmd: "getMutedTeamMembers", response: [{ type: "Number", name: "teamId" }, { type: "PropertyArray", name: "teamMembers", entity: "teamMember" }] }, "8_28": { service: "team", cmd: "sendTeamMsgReceipt", response: [{ type: "PropertyArray", name: "teamMsgReceipts", entity: "teamMsgReceipt" }] }, "8_29": { service: "team", cmd: "getTeamMsgReads", response: [{ type: "PropertyArray", name: "teamMsgReceipts", entity: "teamMsgReceipt" }] }, "8_30": { service: "team", cmd: "getTeamMsgReadAccounts", response: [{ type: "String", name: "idClient" }, { type: "StrArray", name: "readAccounts" }, { type: "StrArray", name: "unreadAccounts" }] }, "8_31": { service: "team", cmd: "notifyTeamMsgReads", response: [{ type: "PropertyArray", name: "teamMsgReceipts", entity: "teamMsgReceipt" }] }, "8_32": { service: "team", cmd: "muteTeamAll", response: [] }, "8_126": { service: "team", cmd: "syncMyTeamMembers", response: [{ type: "PropertyArray", name: "teamMembers", entity: "teamMember" }, { type: "Number", name: "timetag" }] }, "8_109": { service: "team", cmd: "syncTeams", response: [{ type: "Number", name: "timetag" }, { type: "PropertyArray", name: "teams", entity: "team" }] }, "8_111": { service: "team", cmd: "syncTeamMembers", response: [{ type: "Number", name: "teamId" }, { type: "PropertyArray", name: "members", entity: "teamMember" }, { type: "Number", name: "timetag" }] }, "8_101": { service: "team", cmd: "syncCreateTeam", response: [{ type: "Property", name: "team" }] }, "8_102": { service: "team", cmd: "syncSendTeamMsg", response: [{ type: "Property", name: "msg" }] }, "8_119": { service: "team", cmd: "syncUpdateTeamMember", response: [{ type: "Property", name: "teamMember" }] }, "12_1": { service: "friend", cmd: "friendRequest" }, "12_101": { service: "friend", cmd: "syncFriendRequest", response: [{ type: "String", name: "account" }, { type: "Number", name: "type" }, { type: "String", name: "ps" }] }, "12_2": { service: "friend", cmd: "deleteFriend" }, "12_102": { service: "friend", cmd: "syncDeleteFriend", response: [{ type: "String", name: "account" }] }, "12_3": { service: "friend", cmd: "updateFriend" }, "12_103": { service: "friend", cmd: "syncUpdateFriend", response: [{ type: "Property", name: "friend" }] }, "12_4": { service: "friend", cmd: "getFriends", response: [{ type: "PropertyArray", name: "friends", entity: "friend" }, { type: "Number", name: "timetag" }] }, "12_5": { service: "friend", cmd: "syncFriends", response: [{ type: "PropertyArray", name: "friends", entity: "friend" }, { type: "Number", name: "timetag" }] }, "12_6": { service: "friend", cmd: "syncFriendUsers", response: [{ type: "PropertyArray", name: "users", entity: "user" }, { type: "Number", name: "timetag" }] }, "13_1": { service: "chatroom", cmd: "getChatroomAddress", response: [{ type: "StrArray", name: "address" }] }, "14_1": { service: "eventService", cmd: "publishEvent", response: [{ type: "Property", name: "msgEvent" }] }, "14_2": { service: "eventService", cmd: "pushEvent", response: [{ type: "Property", name: "msgEvent" }] }, "14_3": { service: "eventService", cmd: "subscribeEvent", response: [{ type: "StrArray", name: "accounts" }] }, "14_4": { service: "eventService", cmd: "unSubscribeEventsByAccounts", response: [{ type: "StrArray", name: "accounts" }] }, "14_5": { service: "eventService", cmd: "unSubscribeEventsByType" }, "14_6": { service: "eventService", cmd: "querySubscribeEventsByAccounts", response: [{ type: "PropertyArray", name: "msgEventSubscribes", entity: "msgEventSubscribe" }] }, "14_7": { service: "eventService", cmd: "querySubscribeEventsByType", response: [{ type: "PropertyArray", name: "msgEventSubscribes", entity: "msgEventSubscribe" }] }, "14_9": { service: "eventService", cmd: "pushEvents", response: [{ type: "PropertyArray", name: "msgEvents", entity: "msgEvent" }] }, "101_1": { service: "filter", cmd: "sendFilterMsg", response: [{ type: "Property", name: "msg" }] }, "101_2": { service: "filter", cmd: "filterMsg", response: [{ type: "Property", name: "msg" }] }, "101_3": { service: "filter", cmd: "filterSysMsg", response: [{ type: "Property", name: "sysMsg" }] }, "101_7": { service: "filter", cmd: "sendFilterCustomSysMsg" } });e.exports = { idMap: i, cmdConfig: o, packetConfig: a };
  }, function (e, t, n) {
    "use strict";
    var r = n(0).notundef;function s(e) {
      r(e.shouldPushNotificationWhenPCOnline) && (this.open = e.shouldPushNotificationWhenPCOnline ? 2 : 1);
    }s.getDefaultConfig = function () {
      return { shouldPushNotificationWhenPCOnline: !0 };
    }, s.reverse = function (e) {
      return { shouldPushNotificationWhenPCOnline: 1 != +e.open };
    }, e.exports = s;
  }, function (e, t) {
    function n(e) {
      e = e || {}, this.ms = e.min || 100, this.max = e.max || 1e4, this.factor = e.factor || 2, this.jitter = e.jitter > 0 && e.jitter <= 1 ? e.jitter : 0, this.attempts = 0;
    }e.exports = n, n.prototype.duration = function () {
      var e = this.ms * Math.pow(this.factor, this.attempts++);if (this.jitter) {
        var t = Math.random(),
            n = Math.floor(t * this.jitter * e);e = 0 == (1 & Math.floor(10 * t)) ? e - n : e + n;
      }return 0 | Math.min(e, this.max);
    }, n.prototype.reset = function () {
      this.attempts = 0;
    }, n.prototype.setMin = function (e) {
      this.ms = e;
    }, n.prototype.setMax = function (e) {
      this.max = e;
    }, n.prototype.setJitter = function (e) {
      this.jitter = e;
    };
  }, function (e, t, n) {
    "use strict";
    var r = { set: function set(e, t, n) {
        r[e] = t, n && (n.support = t);
      } };e.exports = r;
  }, function (e, t) {
    var n,
        r,
        s = e.exports = {};function i() {
      throw new Error("setTimeout has not been defined");
    }function o() {
      throw new Error("clearTimeout has not been defined");
    }function a(e) {
      if (n === setTimeout) return setTimeout(e, 0);if ((n === i || !n) && setTimeout) return n = setTimeout, setTimeout(e, 0);try {
        return n(e, 0);
      } catch (t) {
        try {
          return n.call(null, e, 0);
        } catch (t) {
          return n.call(this, e, 0);
        }
      }
    }!function () {
      try {
        n = "function" == typeof setTimeout ? setTimeout : i;
      } catch (e) {
        n = i;
      }try {
        r = "function" == typeof clearTimeout ? clearTimeout : o;
      } catch (e) {
        r = o;
      }
    }();var c,
        u = [],
        l = !1,
        m = -1;function d() {
      l && c && (l = !1, c.length ? u = c.concat(u) : m = -1, u.length && f());
    }function f() {
      if (!l) {
        var e = a(d);l = !0;for (var t = u.length; t;) {
          for (c = u, u = []; ++m < t;) {
            c && c[m].run();
          }m = -1, t = u.length;
        }c = null, l = !1, function (e) {
          if (r === clearTimeout) return clearTimeout(e);if ((r === o || !r) && clearTimeout) return r = clearTimeout, clearTimeout(e);try {
            r(e);
          } catch (t) {
            try {
              return r.call(null, e);
            } catch (t) {
              return r.call(this, e);
            }
          }
        }(e);
      }
    }function p(e, t) {
      this.fun = e, this.array = t;
    }function g() {}s.nextTick = function (e) {
      var t = new Array(arguments.length - 1);if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) {
        t[n - 1] = arguments[n];
      }u.push(new p(e, t)), 1 !== u.length || l || a(f);
    }, p.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, s.title = "browser", s.browser = !0, s.env = {}, s.argv = [], s.version = "", s.versions = {}, s.on = g, s.addListener = g, s.once = g, s.off = g, s.removeListener = g, s.removeAllListeners = g, s.emit = g, s.prependListener = g, s.prependOnceListener = g, s.listeners = function (e) {
      return [];
    }, s.binding = function (e) {
      throw new Error("process.binding is not supported");
    }, s.cwd = function () {
      return "/";
    }, s.chdir = function (e) {
      throw new Error("process.chdir is not supported");
    }, s.umask = function () {
      return 0;
    };
  }, function (e, t, n) {
    (function (t, n) {
      /*!
       * @overview es6-promise - a tiny implementation of Promises/A+.
       * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
       * @license   Licensed under MIT license
       *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
       * @version   v4.2.4+314e4831
       */var r;r = function r() {
        "use strict";
        function e(e) {
          return "function" == typeof e;
        }var r = Array.isArray ? Array.isArray : function (e) {
          return "[object Array]" === Object.prototype.toString.call(e);
        },
            s = 0,
            i = void 0,
            o = void 0,
            a = function a(e, t) {
          p[s] = e, p[s + 1] = t, 2 === (s += 2) && (o ? o(g) : M());
        };var c = "undefined" != typeof window ? window : void 0,
            u = c || {},
            l = u.MutationObserver || u.WebKitMutationObserver,
            m = "undefined" == typeof self && void 0 !== t && "[object process]" === {}.toString.call(t),
            d = "undefined" != typeof Uint8ClampedArray && "undefined" != typeof importScripts && "undefined" != typeof MessageChannel;function f() {
          var e = setTimeout;return function () {
            return e(g, 1);
          };
        }var p = new Array(1e3);function g() {
          for (var e = 0; e < s; e += 2) {
            (0, p[e])(p[e + 1]), p[e] = void 0, p[e + 1] = void 0;
          }s = 0;
        }var h,
            y,
            v,
            b,
            M = void 0;function T(e, t) {
          var n = this,
              r = new this.constructor(P);void 0 === r[k] && L(r);var s = n._state;if (s) {
            var i = arguments[s - 1];a(function () {
              return N(s, r, i, n._result);
            });
          } else j(n, r, e, t);return r;
        }function S(e) {
          if (e && "object" == (typeof e === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_15_babel_runtime_helpers_typeof___default()(e)) && e.constructor === this) return e;var t = new this(P);return _(t, e), t;
        }m ? M = function M() {
          return t.nextTick(g);
        } : l ? (y = 0, v = new l(g), b = document.createTextNode(""), v.observe(b, { characterData: !0 }), M = function M() {
          b.data = y = ++y % 2;
        }) : d ? ((h = new MessageChannel()).port1.onmessage = g, M = function M() {
          return h.port2.postMessage(0);
        }) : M = void 0 === c ? function () {
          try {
            var e = Function("return this")().require("vertx");return void 0 !== (i = e.runOnLoop || e.runOnContext) ? function () {
              i(g);
            } : f();
          } catch (e) {
            return f();
          }
        }() : f();var k = Math.random().toString(36).substring(2);function P() {}var I = void 0,
            C = 1,
            O = 2,
            w = { error: null };function x(e) {
          try {
            return e.then;
          } catch (e) {
            return w.error = e, w;
          }
        }function A(t, n, r) {
          n.constructor === t.constructor && r === T && n.constructor.resolve === S ? function (e, t) {
            t._state === C ? R(e, t._result) : t._state === O ? U(e, t._result) : j(t, void 0, function (t) {
              return _(e, t);
            }, function (t) {
              return U(e, t);
            });
          }(t, n) : r === w ? (U(t, w.error), w.error = null) : void 0 === r ? R(t, n) : e(r) ? function (e, t, n) {
            a(function (e) {
              var r = !1,
                  s = function (e, t, n, r) {
                try {
                  e.call(t, n, r);
                } catch (e) {
                  return e;
                }
              }(n, t, function (n) {
                r || (r = !0, t !== n ? _(e, n) : R(e, n));
              }, function (t) {
                r || (r = !0, U(e, t));
              }, e._label);!r && s && (r = !0, U(e, s));
            }, e);
          }(t, n, r) : R(t, n);
        }function _(e, t) {
          var n, r;e === t ? U(e, new TypeError("You cannot resolve a promise with itself")) : (r = __WEBPACK_IMPORTED_MODULE_15_babel_runtime_helpers_typeof___default()(n = t), null === n || "object" !== r && "function" !== r ? R(e, t) : A(e, t, x(t)));
        }function E(e) {
          e._onerror && e._onerror(e._result), F(e);
        }function R(e, t) {
          e._state === I && (e._result = t, e._state = C, 0 !== e._subscribers.length && a(F, e));
        }function U(e, t) {
          e._state === I && (e._state = O, e._result = t, a(E, e));
        }function j(e, t, n, r) {
          var s = e._subscribers,
              i = s.length;e._onerror = null, s[i] = t, s[i + C] = n, s[i + O] = r, 0 === i && e._state && a(F, e);
        }function F(e) {
          var t = e._subscribers,
              n = e._state;if (0 !== t.length) {
            for (var r = void 0, s = void 0, i = e._result, o = 0; o < t.length; o += 3) {
              r = t[o], s = t[o + n], r ? N(n, r, s, i) : s(i);
            }e._subscribers.length = 0;
          }
        }function N(t, n, r, s) {
          var i = e(r),
              o = void 0,
              a = void 0,
              c = void 0,
              u = void 0;if (i) {
            if ((o = function (e, t) {
              try {
                return e(t);
              } catch (e) {
                return w.error = e, w;
              }
            }(r, s)) === w ? (u = !0, a = o.error, o.error = null) : c = !0, n === o) return void U(n, new TypeError("A promises callback cannot return that same promise."));
          } else o = s, c = !0;n._state !== I || (i && c ? _(n, o) : u ? U(n, a) : t === C ? R(n, o) : t === O && U(n, o));
        }var D = 0;function L(e) {
          e[k] = D++, e._state = void 0, e._result = void 0, e._subscribers = [];
        }var B = function () {
          function e(e, t) {
            this._instanceConstructor = e, this.promise = new e(P), this.promise[k] || L(this.promise), r(t) ? (this.length = t.length, this._remaining = t.length, this._result = new Array(this.length), 0 === this.length ? R(this.promise, this._result) : (this.length = this.length || 0, this._enumerate(t), 0 === this._remaining && R(this.promise, this._result))) : U(this.promise, new Error("Array Methods must be provided an Array"));
          }return e.prototype._enumerate = function (e) {
            for (var t = 0; this._state === I && t < e.length; t++) {
              this._eachEntry(e[t], t);
            }
          }, e.prototype._eachEntry = function (e, t) {
            var n = this._instanceConstructor,
                r = n.resolve;if (r === S) {
              var s = x(e);if (s === T && e._state !== I) this._settledAt(e._state, t, e._result);else if ("function" != typeof s) this._remaining--, this._result[t] = e;else if (n === q) {
                var i = new n(P);A(i, e, s), this._willSettleAt(i, t);
              } else this._willSettleAt(new n(function (t) {
                return t(e);
              }), t);
            } else this._willSettleAt(r(e), t);
          }, e.prototype._settledAt = function (e, t, n) {
            var r = this.promise;r._state === I && (this._remaining--, e === O ? U(r, n) : this._result[t] = n), 0 === this._remaining && R(r, this._result);
          }, e.prototype._willSettleAt = function (e, t) {
            var n = this;j(e, void 0, function (e) {
              return n._settledAt(C, t, e);
            }, function (e) {
              return n._settledAt(O, t, e);
            });
          }, e;
        }();var q = function () {
          function e(t) {
            this[k] = D++, this._result = this._state = void 0, this._subscribers = [], P !== t && ("function" != typeof t && function () {
              throw new TypeError("You must pass a resolver function as the first argument to the promise constructor");
            }(), this instanceof e ? function (e, t) {
              try {
                t(function (t) {
                  _(e, t);
                }, function (t) {
                  U(e, t);
                });
              } catch (t) {
                U(e, t);
              }
            }(this, t) : function () {
              throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
            }());
          }return e.prototype["catch"] = function (e) {
            return this.then(null, e);
          }, e.prototype["finally"] = function (e) {
            var t = this.constructor;return this.then(function (n) {
              return t.resolve(e()).then(function () {
                return n;
              });
            }, function (n) {
              return t.resolve(e()).then(function () {
                throw n;
              });
            });
          }, e;
        }();return q.prototype.then = T, q.all = function (e) {
          return new B(this, e).promise;
        }, q.race = function (e) {
          var t = this;return r(e) ? new t(function (n, r) {
            for (var s = e.length, i = 0; i < s; i++) {
              t.resolve(e[i]).then(n, r);
            }
          }) : new t(function (e, t) {
            return t(new TypeError("You must pass an array to race."));
          });
        }, q.resolve = S, q.reject = function (e) {
          var t = new this(P);return U(t, e), t;
        }, q._setScheduler = function (e) {
          o = e;
        }, q._setAsap = function (e) {
          a = e;
        }, q._asap = a, q.polyfill = function () {
          var e = void 0;if (void 0 !== n) e = n;else if ("undefined" != typeof self) e = self;else try {
            e = Function("return this")();
          } catch (e) {
            throw new Error("polyfill failed because global object is unavailable in this environment");
          }var t = e.Promise;if (t) {
            var r = null;try {
              r = Object.prototype.toString.call(t.resolve());
            } catch (e) {}if ("[object Promise]" === r && !t.cast) return;
          }e.Promise = q;
        }, q.Promise = q, q;
      }, e.exports = r();
    }).call(this, n(173), n(31));
  },, function (e, t, n) {
    "use strict";
    var r = n(54);function s() {}s.typeMap = { text: 0, image: 1, audio: 2, video: 3, geo: 4, notification: 5, file: 6, tip: 10, robot: 11, custom: 100 };var i = s.typeReverseMap = { 0: "text", 1: "image", 2: "audio", 3: "video", 4: "geo", 5: "notification", 6: "file", 10: "tip", 11: "robot", 100: "custom" };s.validTypes = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_keys___default()(s.typeMap), s.setFlow = function (e, t) {
      var n = t === e.from;n && t === e.to && (n = r.deviceId === e.fromDeviceId), e.flow = n ? "out" : "in", "robot" === e.type && e.content && e.content.msgOut && (e.flow = "in");
    }, s.getType = function (e) {
      var t = e.type;return i[t] || t;
    }, e.exports = s;
  },,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,, function (e, t, n) {
    "use strict";
    var r = n(54);e.exports = function (e) {
      e.db && (r.db = e.db);
    };
  }, function (e, t, n) {
    "use strict";
    var r,
        s = n(9),
        i = (r = s) && r.__esModule ? r : { default: r };function o(e) {
      var t = this,
          n = e.url || null;t.level = { debug: 0, log: 1, info: 2, warn: 3, error: 4 }[e.level] || 0, t.logCache = [], t.logNum = 1, t.timeInterval = 5e3, window.onerror = function (e, n, r, s, i) {
        t.error(i);
      }, setInterval(function () {
        t.logCache.length > 0 && n && t.postLogs(n, t.logCache);
      }, t.timeInterval);
    }o.prototype.debug = function () {
      this.level > 0 || (console.debug.apply(this, arguments), this.cacheLogs.apply(this, ["[degbug]"].concat(arguments)));
    }, o.prototype.log = function () {
      this.level > 1 || (console.log.apply(this, arguments), this.cacheLogs.apply(this, ["[log]"].concat(arguments)));
    }, o.prototype.info = function () {
      this.level > 2 || (console.info.apply(this, arguments), this.cacheLogs.apply(this, ["[info]"].concat(arguments)));
    }, o.prototype.warn = function () {
      this.level > 3 || (console.warn.apply(this, arguments), this.cacheLogs.apply(this, ["[warn]"].concat(arguments)));
    }, o.prototype.error = function () {
      this.level > 4 || (console.error.apply(this, arguments), this.cacheLogs.apply(this, ["[error]"].concat(arguments)));
    }, o.prototype.cacheLogs = function (e, t) {
      for (var n = [], r = 0; r < t.length; r++) {
        var s = t[r];"object" === (void 0 === s ? "undefined" : (0, i["default"])(s)) ? n.push(__WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_json_stringify___default()(s)) : n.push(s);
      }var o = this.logNum++ + " " + e + " " + n.join("; ");this.logCache.push(o.replace("%c", ""));
    }, o.prototype.postLogs = function (e, t) {
      var n = this,
          r = new XMLHttpRequest();r.onreadystatechange = function () {
        4 === r.readyState && (200 === r.status ? (console.info("LoggerPlugin::日志上报完成"), n.logCache = [], n.timeInterval = 5e3) : n.timeInterval += 5e3);
      }, r.open("POST", e), r.setRequestHeader("Content-Type", "plain/text;charset=utf-8"), r.timeout = 360, r.send(t.join("\n"));
    }, e.exports = o;
  }, function (e, t) {
    e.exports = function () {
      for (var e = {}, t = 0; t < arguments.length; t++) {
        var r = arguments[t];for (var s in r) {
          n.call(r, s) && (e[s] = r[s]);
        }
      }return e;
    };var n = Object.prototype.hasOwnProperty;
  }, function (e, t, n) {
    var r = n(151);e.exports = function (e, t, n) {
      if (!r(t)) throw new TypeError("iterator must be a function");arguments.length < 3 && (n = this);"[object Array]" === s.call(e) ? function (e, t, n) {
        for (var r = 0, s = e.length; r < s; r++) {
          i.call(e, r) && t.call(n, e[r], r, e);
        }
      }(e, t, n) : "string" == typeof e ? function (e, t, n) {
        for (var r = 0, s = e.length; r < s; r++) {
          t.call(n, e.charAt(r), r, e);
        }
      }(e, t, n) : function (e, t, n) {
        for (var r in e) {
          i.call(e, r) && t.call(n, e[r], r, e);
        }
      }(e, t, n);
    };var s = Object.prototype.toString,
        i = Object.prototype.hasOwnProperty;
  }, function (e, t) {
    (t = e.exports = function (e) {
      return e.replace(/^\s*|\s*$/g, "");
    }).left = function (e) {
      return e.replace(/^\s*/, "");
    }, t.right = function (e) {
      return e.replace(/\s*$/, "");
    };
  }, function (e, t, n) {
    var r = n(279),
        s = n(278);e.exports = function (e) {
      if (!e) return {};var t = {};return s(r(e).split("\n"), function (e) {
        var n,
            s = e.indexOf(":"),
            i = r(e.slice(0, s)).toLowerCase(),
            o = r(e.slice(s + 1));void 0 === t[i] ? t[i] = o : (n = t[i], "[object Array]" === Object.prototype.toString.call(n) ? t[i].push(o) : t[i] = [t[i], o]);
      }), t;
    };
  }, function (e, t, n) {
    (function (t) {
      var n;n = "undefined" != typeof window ? window : void 0 !== t ? t : "undefined" != typeof self ? self : {}, e.exports = n;
    }).call(this, n(31));
  }, function (e, t, n) {
    "use strict";
    var r = n(281),
        s = n(151),
        i = n(280),
        o = n(277);function a(e, t, n) {
      var r = e;return s(t) ? (n = t, "string" == typeof e && (r = { uri: e })) : r = o(t, { uri: e }), r.callback = n, r;
    }function c(e, t, n) {
      return u(t = a(e, t, n));
    }function u(e) {
      if (void 0 === e.callback) throw new Error("callback argument missing");var t = !1,
          n = function n(_n, r, s) {
        t || (t = !0, e.callback(_n, r, s));
      };function r(e) {
        return clearTimeout(l), e instanceof Error || (e = new Error("" + (e || "Unknown XMLHttpRequest Error"))), e.statusCode = 0, n(e, y);
      }function s() {
        if (!a) {
          var t;clearTimeout(l), t = e.useXDR && void 0 === u.status ? 200 : 1223 === u.status ? 204 : u.status;var r = y,
              s = null;return 0 !== t ? (r = { body: function () {
              var e = void 0;if (e = u.response ? u.response : u.responseText || function (e) {
                try {
                  if ("document" === e.responseType) return e.responseXML;var t = e.responseXML && "parsererror" === e.responseXML.documentElement.nodeName;if ("" === e.responseType && !t) return e.responseXML;
                } catch (e) {}return null;
              }(u), h) try {
                e = JSON.parse(e);
              } catch (e) {}return e;
            }(), statusCode: t, method: d, headers: {}, url: m, rawRequest: u }, u.getAllResponseHeaders && (r.headers = i(u.getAllResponseHeaders()))) : s = new Error("Internal XMLHttpRequest Error"), n(s, r, r.body);
        }
      }var o,
          a,
          u = e.xhr || null;u || (u = e.cors || e.useXDR ? new c.XDomainRequest() : new c.XMLHttpRequest());var l,
          m = u.url = e.uri || e.url,
          d = u.method = e.method || "GET",
          f = e.body || e.data,
          p = u.headers = e.headers || {},
          g = !!e.sync,
          h = !1,
          y = { body: void 0, headers: {}, statusCode: 0, method: d, url: m, rawRequest: u };if ("json" in e && !1 !== e.json && (h = !0, p.accept || p.Accept || (p.Accept = "application/json"), "GET" !== d && "HEAD" !== d && (p["content-type"] || p["Content-Type"] || (p["Content-Type"] = "application/json"), f = __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_json_stringify___default()(!0 === e.json ? f : e.json))), u.onreadystatechange = function () {
        4 === u.readyState && setTimeout(s, 0);
      }, u.onload = s, u.onerror = r, u.onprogress = function () {}, u.onabort = function () {
        a = !0;
      }, u.ontimeout = r, u.open(d, m, !g, e.username, e.password), g || (u.withCredentials = !!e.withCredentials), !g && e.timeout > 0 && (l = setTimeout(function () {
        if (!a) {
          a = !0, u.abort("timeout");var e = new Error("XMLHttpRequest timeout");e.code = "ETIMEDOUT", r(e);
        }
      }, e.timeout)), u.setRequestHeader) for (o in p) {
        p.hasOwnProperty(o) && u.setRequestHeader(o, p[o]);
      } else if (e.headers && !function (e) {
        for (var t in e) {
          if (e.hasOwnProperty(t)) return !1;
        }return !0;
      }(e.headers)) throw new Error("Headers cannot be set on an XDomainRequest object");return "responseType" in e && (u.responseType = e.responseType), "beforeSend" in e && "function" == typeof e.beforeSend && e.beforeSend(u), u.send(f || null), u;
    }e.exports = c, c.XMLHttpRequest = r.XMLHttpRequest || function () {}, c.XDomainRequest = "withCredentials" in new c.XMLHttpRequest() ? c.XMLHttpRequest : r.XDomainRequest, function (e, t) {
      for (var n = 0; n < e.length; n++) {
        t(e[n]);
      }
    }(["get", "put", "post", "patch", "head", "delete"], function (e) {
      c["delete" === e ? "del" : e] = function (t, n, r) {
        return (n = a(t, n, r)).method = e.toUpperCase(), u(n);
      };
    });
  }, function (e, t, n) {
    "use strict";
    var r = n(0),
        s = r.notundef,
        i = { addFriend: 1, applyFriend: 2, passFriendApply: 3, rejectFriendApply: 4 },
        o = { 1: "addFriend", 2: "applyFriend", 3: "passFriendApply", 4: "rejectFriendApply" };function a(e) {
      r.verifyOptions(e, "account", "friend::Friend"), r.verifyParamAtLeastPresentOne(e, "alias custom", "friend::Friend"), this.account = e.account, s(e.alias) && (this.alias = e.alias), s(e.custom) && (this.custom = e.custom);
    }a.reverse = function (e) {
      var t = r.filterObj(e, "account alias custom createTime updateTime serverex");return s(e.flag) && (t.valid = "1" === e.flag), s(t.createTime) && (t.createTime = +t.createTime), s(t.updateTime) && (t.updateTime = +t.updateTime), t;
    }, a.validTypes = function () {
      return __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_keys___default()(i);
    }, a.getByteFromType = function (e) {
      return i[e];
    }, a.getTypeFromByte = function (e) {
      return o[e];
    }, a.assembleFriend = function (e) {
      var t = +new Date();return { account: e, alias: "", createTime: t, custom: "", updateTime: t, valid: !0 };
    }, e.exports = a;
  }, function (e, t, n) {
    "use strict";
    e.exports = { imLogin: { 3: "clientType", 4: "os", 6: "sdkVersion", 8: "appLogin", 9: "protocolVersion", 10: "pushTokenName", 11: "pushToken", 13: "deviceId", 18: "appKey", 19: "account", 24: "browser", 26: "session", 32: "deviceInfo", 38: "customTag", 112: "isReactNative", 1000: "token" }, nosToken: { 1: "objectName", 2: "token", 3: "bucket", 4: "expireTime", 7: "expireSec", 8: "tag", 9: "shortUrl" }, audioToText: { 2: "url" }, imageOp: { 0: "type", 1: "stripmeta", 2: "typeType", 3: "blurRadius", 4: "blurSigma", 5: "qualityQuality", 6: "cropX", 7: "cropY", 8: "cropWidth", 9: "cropHeight", 10: "rotateAngle", 11: "pixelPixel", 12: "thumbnailMode", 13: "thumbnailWidth", 14: "thumbnailHeight", 15: "thumbnailAxisX", 16: "thumbnailAxisY", 17: "thumbnailCenterX", 18: "thumbnailCenterY", 19: "thumbnailEnlarge", 20: "thumbnailToStatic", 21: "watermarkType", 22: "watermarkGravity", 23: "watermarkDissolve", 24: "watermarkDx", 25: "watermarkDy", 26: "watermarkImage", 27: "watermarkText", 28: "watermarkFont", 29: "watermarkFontSize", 30: "watermarkFontColor", 31: "interlace" }, robot: { 4: "account", 5: "nick", 6: "avatar", 7: "intro", 8: "config", 9: "valid", 10: "createTime", 11: "updateTime", 12: "custid", 13: "botid", 14: "bindTime", _6_safe: "_avatar_safe" }, clientAntispam: { 1: "version", 2: "md5", 3: "nosurl", 4: "thesaurus" }, fileQuickTransfer: { 1: "md5", 2: "url", 3: "size", 4: "threshold", _2_safe: "_url_safe" }, transToken: { 1: "name", 2: "type", 3: "transType", 4: "size", 5: "extra", 6: "body" }, transInfo: { 1: "docId", 2: "name", 3: "prefix", 4: "size", 5: "type", 6: "state", 7: "transType", 8: "transSize", 9: "pageCount", 10: "picInfo", 11: "extra", 12: "flag" }, nosFileUrlTag: { 0: "safeUrl", 1: "originUrl" }, fileListParam: { 1: "fromDocId", 2: "limit" }, avSignalTag: { 1: "type", 2: "channelName", 3: "channelId", 4: "channelCreateTime", 5: "channelExpireTime", 6: "creator", 7: "ext", 8: "channelInValid", 10: "from", 11: "to", 12: "requestId", 13: "needPush", 14: "pushTitle", 15: "pushContent", 16: "pushPayload", 17: "needBadge", 18: "members", 19: "attach", 20: "attachExt", 21: "offlineEnabled", 22: "msgid", 23: "uid", 24: "time" }, login: { 1: "appKey", 2: "account", 3: "deviceId", 5: "chatroomId", 8: "appLogin", 20: "chatroomNick", 21: "chatroomAvatar", 22: "chatroomCustom", 23: "chatroomEnterCustom", 26: "session", 38: "isAnonymous", _21_safe: "_chatroomAvatar_safe" }, chatroom: { 1: "id", 3: "name", 4: "announcement", 5: "broadcastUrl", 12: "custom", 14: "createTime", 15: "updateTime", 16: "queuelevel", 100: "creator", 101: "onlineMemberNum", 102: "mute" }, msg: { 1: "idClient", 2: "type", 3: "attach", 4: "custom", 5: "resend", 6: "userUpdateTime", 7: "fromNick", 8: "fromAvatar", 9: "fromCustom", 10: "yidunEnable", 11: "antiSpamContent", 12: "skipHistory", 13: "body", 14: "antiSpamBusinessId", 15: "clientAntiSpam", 16: "antiSpamUsingYidun", 20: "time", 21: "from", 22: "chatroomId", 23: "fromClientType", 25: "highPriority", _8_safe: "_fromAvatar_safe" }, chatroomMember: { 1: "chatroomId", 2: "account", 3: "type", 4: "level", 5: "nick", 6: "avatar", 7: "custom", 8: "online", 9: "guest", 10: "enterTime", 12: "blacked", 13: "gaged", 14: "valid", 15: "updateTime", 16: "tempMuted", 17: "tempMuteDuration", _6_safe: "_avatar_safe" } };
  }, function (e, t, n) {
    "use strict";
    e.exports = { imLogin: { clientType: 3, os: 4, sdkVersion: 6, appLogin: 8, protocolVersion: 9, pushTokenName: 10, pushToken: 11, deviceId: 13, appKey: 18, account: 19, browser: 24, session: 26, deviceInfo: 32, isReactNative: 112, token: 1e3, customTag: 38 }, nosToken: { objectName: 1, token: 2, bucket: 3, expireTime: 4, expireSec: 7, tag: 8, shortUrl: 9 }, audioToText: { url: 2 }, imageOp: { type: 0, stripmeta: 1, typeType: 2, blurRadius: 3, blurSigma: 4, qualityQuality: 5, cropX: 6, cropY: 7, cropWidth: 8, cropHeight: 9, rotateAngle: 10, pixelPixel: 11, thumbnailMode: 12, thumbnailWidth: 13, thumbnailHeight: 14, thumbnailAxisX: 15, thumbnailAxisY: 16, thumbnailCenterX: 17, thumbnailCenterY: 18, thumbnailEnlarge: 19, thumbnailToStatic: 20, watermarkType: 21, watermarkGravity: 22, watermarkDissolve: 23, watermarkDx: 24, watermarkDy: 25, watermarkImage: 26, watermarkText: 27, watermarkFont: 28, watermarkFontSize: 29, watermarkFontColor: 30, interlace: 31 }, robot: { account: 4, nick: 5, avatar: 6, intro: 7, config: 8, valid: 9, createTime: 10, updateTime: 11, custid: 12, botid: 13, bindTime: 14 }, clientAntispam: { version: 1, md5: 2, nosurl: 3, thesaurus: 4 }, fileQuickTransfer: { md5: 1, url: 2, size: 3, threshold: 4 }, transToken: { name: 1, type: 2, transType: 3, size: 4, extra: 5, body: 6 }, transInfo: { docId: 1, name: 2, prefix: 3, size: 4, type: 5, state: 6, transType: 7, transSize: 8, pageCount: 9, picInfo: 10, extra: 11, flag: 12 }, nosFileUrlTag: { safeUrl: 0, originUrl: 1 }, fileListParam: { fromDocId: 1, limit: 2 }, avSignalTag: { type: 1, channelName: 2, channelId: 3, channelCreateTime: 4, channelExpireTime: 5, creator: 6, ext: 7, channelInValid: 8, from: 10, to: 11, requestId: 12, needPush: 13, pushTitle: 14, pushContent: 15, pushPayload: 16, needBadge: 17, members: 18, attach: 19, attachExt: 20, offlineEnabled: 21, msgid: 22, uid: 23, time: 24 }, login: { appKey: 1, account: 2, deviceId: 3, chatroomId: 5, appLogin: 8, chatroomNick: 20, chatroomAvatar: 21, chatroomCustom: 22, chatroomEnterCustom: 23, session: 26, isAnonymous: 38 }, chatroom: { id: 1, name: 3, announcement: 4, broadcastUrl: 5, custom: 12, createTime: 14, updateTime: 15, queuelevel: 16, creator: 100, onlineMemberNum: 101, mute: 102 }, msg: { idClient: 1, type: 2, attach: 3, custom: 4, resend: 5, userUpdateTime: 6, fromNick: 7, fromAvatar: 8, fromCustom: 9, yidunEnable: 10, antiSpamContent: 11, skipHistory: 12, body: 13, antiSpamBusinessId: 14, clientAntiSpam: 15, antiSpamUsingYidun: 16, time: 20, from: 21, chatroomId: 22, fromClientType: 23, highPriority: 25 }, chatroomMember: { chatroomId: 1, account: 2, type: 3, level: 4, nick: 5, avatar: 6, custom: 7, online: 8, guest: 9, enterTime: 10, blacked: 12, gaged: 13, valid: 14, updateTime: 15, tempMuted: 16, tempMuteDuration: 17 } };
  }, function (e, t, n) {
    "use strict";
    var r = n(0),
        s = n(79),
        i = r.merge({}, s.idMap, { chatroom: { id: 13, login: 2, kicked: 3, logout: 4, sendMsg: 6, msg: 7, getChatroomMembers: 8, getHistoryMsgs: 9, markChatroomMember: 11, closeChatroom: 12, getChatroom: 13, updateChatroom: 14, updateMyChatroomMemberInfo: 15, getChatroomMembersInfo: 16, kickChatroomMember: 17, updateChatroomMemberTempMute: 19, queueOffer: 20, queuePoll: 21, queueList: 22, peak: 23, queueDrop: 24, queueInit: 25, queueChange: 26 }, user: { id: 3, syncRobot: 16 } }),
        o = r.merge({}, s.cmdConfig, { login: { sid: i.chatroom.id, cid: i.chatroom.login, params: [{ type: "byte", name: "type" }, { type: "Property", name: "login" }, { type: "Property", name: "imLogin" }] }, logout: { sid: i.chatroom.id, cid: i.chatroom.logout }, sendMsg: { sid: i.chatroom.id, cid: i.chatroom.sendMsg, params: [{ type: "Property", name: "msg" }] }, getChatroomMembers: { sid: i.chatroom.id, cid: i.chatroom.getChatroomMembers, params: [{ type: "byte", name: "type" }, { type: "long", name: "time" }, { type: "int", name: "limit" }] }, getHistoryMsgs: { sid: i.chatroom.id, cid: i.chatroom.getHistoryMsgs, params: [{ type: "long", name: "timetag" }, { type: "int", name: "limit" }, { type: "bool", name: "reverse" }, { type: "LongArray", name: "msgTypes" }] }, markChatroomMember: { sid: i.chatroom.id, cid: i.chatroom.markChatroomMember, params: [{ type: "string", name: "account" }, { type: "int", name: "type" }, { type: "bool", name: "isAdd" }, { type: "int", name: "level" }, { type: "string", name: "custom" }] }, closeChatroom: { sid: i.chatroom.id, cid: i.chatroom.closeChatroom, params: [{ type: "string", name: "custom" }] }, getChatroom: { sid: i.chatroom.id, cid: i.chatroom.getChatroom }, updateChatroom: { sid: i.chatroom.id, cid: i.chatroom.updateChatroom, params: [{ type: "Property", name: "chatroom" }, { type: "bool", name: "needNotify" }, { type: "String", name: "custom" }] }, updateMyChatroomMemberInfo: { sid: i.chatroom.id, cid: i.chatroom.updateMyChatroomMemberInfo, params: [{ type: "Property", name: "chatroomMember" }, { type: "bool", name: "needNotify" }, { type: "String", name: "custom" }, { type: "bool", name: "needSave" }] }, getChatroomMembersInfo: { sid: i.chatroom.id, cid: i.chatroom.getChatroomMembersInfo, params: [{ type: "StrArray", name: "accounts" }] }, kickChatroomMember: { sid: i.chatroom.id, cid: i.chatroom.kickChatroomMember, params: [{ type: "string", name: "account" }, { type: "string", name: "custom" }] }, updateChatroomMemberTempMute: { sid: i.chatroom.id, cid: i.chatroom.updateChatroomMemberTempMute, params: [{ type: "String", name: "account" }, { type: "long", name: "duration" }, { type: "bool", name: "needNotify" }, { type: "String", name: "custom" }] }, queueOffer: { sid: i.chatroom.id, cid: i.chatroom.queueOffer, params: [{ type: "string", name: "elementKey" }, { type: "string", name: "elementValue" }, { type: "bool", name: "transient" }] }, queuePoll: { sid: i.chatroom.id, cid: i.chatroom.queuePoll, params: [{ type: "string", name: "elementKey" }] }, queueList: { sid: i.chatroom.id, cid: i.chatroom.queueList }, peak: { sid: i.chatroom.id, cid: i.chatroom.peak }, queueDrop: { sid: i.chatroom.id, cid: i.chatroom.queueDrop }, queueInit: { sid: i.chatroom.id, cid: i.chatroom.queueInit, params: [{ type: "int", name: "limit" }] }, queueChange: { sid: i.chatroom.id, cid: i.chatroom.queueChange, params: [{ type: "StrStrMap", name: "elementMap" }, { type: "bool", name: "needNotify" }, { type: "string", name: "notifyExt" }] }, syncRobot: { sid: i.user.id, cid: i.user.syncRobot, params: [{ type: "long", name: "timetag" }] } }),
        a = r.merge({}, s.packetConfig, { "4_10": { service: "notify" }, "4_11": { service: "notify" }, "3_16": { service: "chatroom", cmd: "syncRobot", response: [{ type: "PropertyArray", name: "robots", entity: "robot" }] }, "13_2": { service: "chatroom", cmd: "login", response: [{ type: "Property", name: "chatroom" }, { type: "Property", name: "chatroomMember" }] }, "13_3": { service: "chatroom", cmd: "kicked", response: [{ type: "Number", name: "reason" }, { type: "String", name: "custom" }] }, "13_4": { service: "chatroom", cmd: "logout" }, "13_6": { service: "chatroom", cmd: "sendMsg", response: [{ type: "Property", name: "msg" }] }, "13_7": { service: "chatroom", cmd: "msg", response: [{ type: "Property", name: "msg" }] }, "13_8": { service: "chatroom", cmd: "getChatroomMembers", response: [{ type: "PropertyArray", name: "members", entity: "chatroomMember" }] }, "13_9": { service: "chatroom", cmd: "getHistoryMsgs", response: [{ type: "PropertyArray", name: "msgs", entity: "msg" }] }, "13_11": { service: "chatroom", cmd: "markChatroomMember", response: [{ type: "Property", name: "chatroomMember" }] }, "13_12": { service: "chatroom", cmd: "closeChatroom" }, "13_13": { service: "chatroom", cmd: "getChatroom", response: [{ type: "Property", name: "chatroom" }] }, "13_14": { service: "chatroom", cmd: "updateChatroom" }, "13_15": { service: "chatroom", cmd: "updateMyChatroomMemberInfo" }, "13_16": { service: "chatroom", cmd: "getChatroomMembersInfo", response: [{ type: "PropertyArray", name: "members", entity: "chatroomMember" }] }, "13_17": { service: "chatroom", cmd: "kickChatroomMember" }, "13_19": { service: "chatroom", cmd: "updateChatroomMemberTempMute" }, "13_20": { service: "chatroom", cmd: "queueOffer" }, "13_21": { service: "chatroom", cmd: "queuePoll", response: [{ type: "String", name: "elementKey" }, { type: "String", name: "elementValue" }] }, "13_22": { service: "chatroom", cmd: "queueList", response: [{ type: "KVArray", name: "queueList" }] }, "13_23": { service: "chatroom", cmd: "peak", response: [{ type: "String", name: "elementKey" }, { type: "String", name: "elementValue" }] }, "13_24": { service: "chatroom", cmd: "queueDrop" }, "13_25": { service: "chatroom", cmd: "queueInit" }, "13_26": { service: "chatroom", cmd: "queueChange", response: [{ type: "StrArray", name: "elementKeyArray" }] } });e.exports = { idMap: i, cmdConfig: o, packetConfig: a };
  }, function (e, t, n) {
    "use strict";
    e.exports = { nosToken: { 1: "objectName", 2: "token", 3: "bucket", 4: "expireTime", 7: "expireSec", 8: "tag", 9: "shortUrl" }, audioToText: { 2: "url" }, imageOp: { 0: "type", 1: "stripmeta", 2: "typeType", 3: "blurRadius", 4: "blurSigma", 5: "qualityQuality", 6: "cropX", 7: "cropY", 8: "cropWidth", 9: "cropHeight", 10: "rotateAngle", 11: "pixelPixel", 12: "thumbnailMode", 13: "thumbnailWidth", 14: "thumbnailHeight", 15: "thumbnailAxisX", 16: "thumbnailAxisY", 17: "thumbnailCenterX", 18: "thumbnailCenterY", 19: "thumbnailEnlarge", 20: "thumbnailToStatic", 21: "watermarkType", 22: "watermarkGravity", 23: "watermarkDissolve", 24: "watermarkDx", 25: "watermarkDy", 26: "watermarkImage", 27: "watermarkText", 28: "watermarkFont", 29: "watermarkFontSize", 30: "watermarkFontColor", 31: "interlace" }, robot: { 4: "account", 5: "nick", 6: "avatar", 7: "intro", 8: "config", 9: "valid", 10: "createTime", 11: "updateTime", 12: "custid", 13: "botid", 14: "bindTime", _6_safe: "_avatar_safe" }, clientAntispam: { 1: "version", 2: "md5", 3: "nosurl", 4: "thesaurus" }, fileQuickTransfer: { 1: "md5", 2: "url", 3: "size", 4: "threshold", _2_safe: "_url_safe" }, transToken: { 1: "name", 2: "type", 3: "transType", 4: "size", 5: "extra", 6: "body" }, transInfo: { 1: "docId", 2: "name", 3: "prefix", 4: "size", 5: "type", 6: "state", 7: "transType", 8: "transSize", 9: "pageCount", 10: "picInfo", 11: "extra", 12: "flag" }, nosFileUrlTag: { 0: "safeUrl", 1: "originUrl" }, fileListParam: { 1: "fromDocId", 2: "limit" }, avSignalTag: { 1: "type", 2: "channelName", 3: "channelId", 4: "channelCreateTime", 5: "channelExpireTime", 6: "creator", 7: "ext", 8: "channelInValid", 10: "from", 11: "to", 12: "requestId", 13: "needPush", 14: "pushTitle", 15: "pushContent", 16: "pushPayload", 17: "needBadge", 18: "members", 19: "attach", 20: "attachExt", 21: "offlineEnabled", 22: "msgid", 23: "uid", 24: "time" }, login: { 3: "clientType", 4: "os", 6: "sdkVersion", 8: "appLogin", 9: "protocolVersion", 10: "pushTokenName", 11: "pushToken", 13: "deviceId", 18: "appKey", 19: "account", 24: "browser", 26: "session", 32: "deviceInfo", 38: "customTag", 112: "isReactNative", 1000: "token" }, loginRes: { 17: "lastLoginDeviceId", 38: "customTag", 102: "connectionId", 103: "ip", 104: "port", 106: "country", 111: "hasXMPush" }, loginPort: { 3: "type", 4: "os", 5: "mac", 13: "deviceId", 19: "account", 32: "deviceInfo", 38: "customTag", 102: "connectionId", 103: "ip", 109: "time" }, aosPushInfo: { 110: "pushType", 111: "hasTokenPreviously" }, sync: { 1: "myInfo", 2: "offlineMsgs", 3: "teams", 6: "netcallMsgs", 7: "roamingMsgs", 9: "relations", 11: "friends", 12: "sessions", 13: "friendUsers", 14: "msgReceipts", 15: "myTeamMembers", 16: "donnop", 17: "deleteMsg", 18: "sessionAck", 19: "robots", 20: "broadcastMsgs", 21: "avSignal", 100: "filterMsgs" }, donnop: { 1: "open" }, team: { 1: "teamId", 3: "name", 4: "type", 5: "owner", 6: "level", 7: "selfCustom", 8: "valid", 9: "memberNum", 10: "memberUpdateTime", 11: "createTime", 12: "updateTime", 13: "validToCurrentUser", 14: "intro", 15: "announcement", 16: "joinMode", 17: "bits", 18: "custom", 19: "serverCustom", 20: "avatar", 21: "beInviteMode", 22: "inviteMode", 23: "updateTeamMode", 24: "updateCustomMode", 100: "mute", 101: "muteType", _20_safe: "_avatar_safe" }, teamMember: { 1: "teamId", 3: "account", 4: "type", 5: "nickInTeam", 7: "bits", 8: "active", 9: "valid", 10: "joinTime", 11: "updateTime", 12: "custom", 13: "mute" }, msg: { 0: "scene", 1: "to", 2: "from", 4: "fromClientType", 5: "fromDeviceId", 6: "fromNick", 7: "time", 8: "type", 9: "body", 10: "attach", 11: "idClient", 12: "idServer", 13: "resend", 14: "userUpdateTime", 15: "custom", 16: "pushPayload", 17: "pushContent", 18: "apnsAccounts", 19: "apnsContent", 20: "apnsForcePush", 21: "yidunEnable", 22: "antiSpamContent", 23: "antiSpamBusinessId", 24: "clientAntiSpam", 25: "antiSpamUsingYidun", 26: "needMsgReceipt", 100: "isHistoryable", 101: "isRoamingable", 102: "isSyncable", 104: "isMuted", 105: "cc", 106: "isInBlackList", 107: "isPushable", 108: "isOfflinable", 109: "isUnreadable", 110: "needPushNick", 111: "isReplyMsg", 112: "tempTeamMemberCount" }, msgReceipt: { 1: "to", 2: "from", 7: "time", 11: "idClient" }, teamMsgReceipt: { 0: "teamId", 1: "idServer", 100: "read", 101: "unread", 102: "idClient", 103: "account" }, sysMsg: { 0: "time", 1: "type", 2: "to", 3: "from", 4: "ps", 5: "attach", 6: "idServer", 7: "sendToOnlineUsersOnly", 8: "apnsText", 9: "pushPayload", 10: "deletedIdClient", 11: "deletedIdServer", 12: "yidunEnable", 13: "antiSpamContent", 14: "deletedMsgTime", 15: "deletedMsgFromNick", 16: "opeAccount", 105: "cc", 107: "isPushable", 109: "isUnreadable", 110: "needPushNick" }, broadcastMsg: { 1: "broadcastId", 2: "fromAccid", 3: "fromUid", 4: "timestamp", 5: "body" }, friend: { 4: "account", 5: "flag", 6: "beflag", 7: "source", 8: "alias", 9: "bits", 10: "custom", 11: "createTime", 12: "updateTime", 13: "serverex" }, user: { 1: "account", 3: "nick", 4: "avatar", 5: "sign", 6: "gender", 7: "email", 8: "birth", 9: "tel", 10: "custom", 12: "createTime", 13: "updateTime", _4_safe: "_avatar_safe" }, specialRelation: { 0: "account", 1: "isMuted", 2: "isBlacked", 3: "createTime", 4: "updateTime" }, msgType: { 0: "text", 1: "picture", 2: "audio", 3: "video", 4: "location", 5: "notification", 6: "file", 7: "netcall_audio", 8: "netcall_vedio", 9: "datatunnel_new", 10: "tips", 11: "robot", 100: "custom" }, msgEvent: { 1: "type", 2: "value", 3: "idClient", 4: "custom", 5: "validTime", 6: "broadcastType", 7: "sync", 8: "validTimeType", 9: "durable", 10: "time", 11: "idServer", 12: "clientType", 13: "serverConfig", 14: "serverCustom", 101: "appid", 103: "account", 104: "enableMultiClient", 106: "consid" }, msgEventSubscribe: { 1: "type", 2: "subscribeTime", 3: "sync", 102: "to", 104: "from", 105: "time" } };
  }, function (e, t, n) {
    "use strict";
    e.exports = { nosToken: { objectName: 1, token: 2, bucket: 3, expireTime: 4, expireSec: 7, tag: 8, shortUrl: 9 }, audioToText: { url: 2 }, imageOp: { type: 0, stripmeta: 1, typeType: 2, blurRadius: 3, blurSigma: 4, qualityQuality: 5, cropX: 6, cropY: 7, cropWidth: 8, cropHeight: 9, rotateAngle: 10, pixelPixel: 11, thumbnailMode: 12, thumbnailWidth: 13, thumbnailHeight: 14, thumbnailAxisX: 15, thumbnailAxisY: 16, thumbnailCenterX: 17, thumbnailCenterY: 18, thumbnailEnlarge: 19, thumbnailToStatic: 20, watermarkType: 21, watermarkGravity: 22, watermarkDissolve: 23, watermarkDx: 24, watermarkDy: 25, watermarkImage: 26, watermarkText: 27, watermarkFont: 28, watermarkFontSize: 29, watermarkFontColor: 30, interlace: 31 }, robot: { account: 4, nick: 5, avatar: 6, intro: 7, config: 8, valid: 9, createTime: 10, updateTime: 11, custid: 12, botid: 13, bindTime: 14 }, clientAntispam: { version: 1, md5: 2, nosurl: 3, thesaurus: 4 }, fileQuickTransfer: { md5: 1, url: 2, size: 3, threshold: 4 }, transToken: { name: 1, type: 2, transType: 3, size: 4, extra: 5, body: 6 }, transInfo: { docId: 1, name: 2, prefix: 3, size: 4, type: 5, state: 6, transType: 7, transSize: 8, pageCount: 9, picInfo: 10, extra: 11, flag: 12 }, nosFileUrlTag: { safeUrl: 0, originUrl: 1 }, fileListParam: { fromDocId: 1, limit: 2 }, avSignalTag: { type: 1, channelName: 2, channelId: 3, channelCreateTime: 4, channelExpireTime: 5, creator: 6, ext: 7, channelInValid: 8, from: 10, to: 11, requestId: 12, needPush: 13, pushTitle: 14, pushContent: 15, pushPayload: 16, needBadge: 17, members: 18, attach: 19, attachExt: 20, offlineEnabled: 21, msgid: 22, uid: 23, time: 24 }, login: { clientType: 3, os: 4, sdkVersion: 6, appLogin: 8, protocolVersion: 9, pushTokenName: 10, pushToken: 11, deviceId: 13, appKey: 18, account: 19, browser: 24, session: 26, deviceInfo: 32, isReactNative: 112, token: 1e3, customTag: 38 }, loginRes: { lastLoginDeviceId: 17, customTag: 38, connectionId: 102, ip: 103, port: 104, country: 106, hasXMPush: 111 }, loginPort: { type: 3, os: 4, mac: 5, deviceId: 13, account: 19, deviceInfo: 32, connectionId: 102, ip: 103, time: 109, customTag: 38 }, aosPushInfo: { pushType: 110, hasTokenPreviously: 111 }, sync: { myInfo: 1, offlineMsgs: 2, teams: 3, netcallMsgs: 6, roamingMsgs: 7, relations: 9, friends: 11, sessions: 12, friendUsers: 13, msgReceipts: 14, myTeamMembers: 15, donnop: 16, deleteMsg: 17, sessionAck: 18, robots: 19, broadcastMsgs: 20, avSignal: 21, filterMsgs: 100 }, donnop: { open: 1 }, team: { teamId: 1, name: 3, type: 4, owner: 5, level: 6, selfCustom: 7, valid: 8, memberNum: 9, memberUpdateTime: 10, createTime: 11, updateTime: 12, validToCurrentUser: 13, intro: 14, announcement: 15, joinMode: 16, bits: 17, custom: 18, serverCustom: 19, avatar: 20, beInviteMode: 21, inviteMode: 22, updateTeamMode: 23, updateCustomMode: 24, mute: 100, muteType: 101 }, teamMember: { teamId: 1, account: 3, type: 4, nickInTeam: 5, bits: 7, active: 8, valid: 9, joinTime: 10, updateTime: 11, custom: 12, mute: 13 }, msg: { scene: 0, to: 1, from: 2, fromClientType: 4, fromDeviceId: 5, fromNick: 6, time: 7, type: 8, body: 9, attach: 10, idClient: 11, idServer: 12, resend: 13, userUpdateTime: 14, custom: 15, pushPayload: 16, pushContent: 17, apnsAccounts: 18, apnsContent: 19, apnsForcePush: 20, yidunEnable: 21, antiSpamContent: 22, antiSpamBusinessId: 23, clientAntiSpam: 24, antiSpamUsingYidun: 25, needMsgReceipt: 26, isHistoryable: 100, isRoamingable: 101, isSyncable: 102, isMuted: 104, cc: 105, isInBlackList: 106, isPushable: 107, isOfflinable: 108, isUnreadable: 109, needPushNick: 110, isReplyMsg: 111, tempTeamMemberCount: 112 }, msgReceipt: { to: 1, from: 2, time: 7, idClient: 11 }, teamMsgReceipt: { teamId: 0, idServer: 1, read: 100, unread: 101, idClient: 102, account: 103 }, sysMsg: { time: 0, type: 1, to: 2, from: 3, ps: 4, attach: 5, idServer: 6, sendToOnlineUsersOnly: 7, apnsText: 8, pushPayload: 9, deletedIdClient: 10, deletedIdServer: 11, yidunEnable: 12, antiSpamContent: 13, deletedMsgTime: 14, deletedMsgFromNick: 15, opeAccount: 16, cc: 105, isPushable: 107, isUnreadable: 109, needPushNick: 110 }, broadcastMsg: { broadcastId: 1, fromAccid: 2, fromUid: 3, timestamp: 4, body: 5 }, friend: { account: 4, flag: 5, beflag: 6, source: 7, alias: 8, bits: 9, custom: 10, createTime: 11, updateTime: 12, serverex: 13 }, user: { account: 1, nick: 3, avatar: 4, sign: 5, gender: 6, email: 7, birth: 8, tel: 9, custom: 10, createTime: 12, updateTime: 13 }, specialRelation: { account: 0, isMuted: 1, isBlacked: 2, createTime: 3, updateTime: 4 }, msgType: { text: 0, picture: 1, audio: 2, video: 3, location: 4, notification: 5, file: 6, netcall_audio: 7, netcall_vedio: 8, datatunnel_new: 9, tips: 10, robot: 11, custom: 100 }, msgEvent: { type: 1, value: 2, idClient: 3, custom: 4, validTime: 5, broadcastType: 6, sync: 7, validTimeType: 8, durable: 9, time: 10, idServer: 11, clientType: 12, serverConfig: 13, serverCustom: 14, appid: 101, account: 103, enableMultiClient: 104, consid: 106 }, msgEventSubscribe: { type: 1, subscribeTime: 2, sync: 3, to: 102, from: 104, time: 105 } };
  }, function (e, t, n) {
    "use strict";
    var r = n(57).fn,
        s = n(0),
        i = n(153);r.processAvSignal = function (e) {
      switch (console.log(e, "avSignal..."), e.cmd) {case "signalingCreate":case "signalingDelay":case "signalingClose":case "signalingJoin":case "signalingLeave":case "signalingInvite":case "signalingCancel":case "signalingReject":case "signalingAccept":case "signalingControl":case "signalingSyncMsgRead":case "signalingGetChannelInfo":
          break;case "signalingNotify":
          this.onSignalingNotify(e);break;case "signalingMutilClientSyncNotify":
          this.onSignalingMutilClientSyncNotify(e);break;case "signalingUnreadMessageSyncNotify":
          this.onSignalingUnreadMessageSyncNotify(e);break;case "signalingChannelsSyncNotify":
          this.onSignalingMembersSyncNotify(e);break;default:
          this.logger.log("avSignal::unhandled cmd:", e.cmd);}
    };var o = function o() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};if (e.needPush && (e.needPush = "1" === e.needPush), e.needBadge && (e.needBadge = "1" === e.needBadge), e.channelInValid && (e.channelInValid = "1" === e.channelInValid), e.attach) {
        var t = JSON.parse(e.attach);e.eventType = i.parseAvSignalType(t.type);
      }if (e.members) {
        var n = JSON.parse(e.members);e.members = n.map(function (e) {
          return i.parseAvSignalMember(e);
        });
      }return e;
    };r.onSignalingNotify = function (e) {
      if (e.error) {
        var t = e.error;this.logger.error("protocal::avSignal:onSignalingNotify error", t), this.emitAPI({ type: "error", error: t }), this.options.onerror(t);
      } else {
        e.raw && e.raw.r && e.raw.r.length && e.content && e.content.avSignalTag && (e.content.avSignalTag.msgid = e.raw.r[0]);var n = e.content;n = Array.isArray(n) ? n.map(function (e) {
          return o(e);
        }) : o(n), this.emitAPI({ type: "signalingNotify", obj: n }), s.isFunction(this.options.onSignalingNotify) && this.options.onSignalingNotify(n);
      }
    }, r.onSignalingMutilClientSyncNotify = function (e) {
      if (e.error) {
        var t = e.error;this.logger.error("protocal::avSignal:onSignalingMutilClientSyncNotify error", t), this.emitAPI({ type: "error", error: t }), this.options.onerror(t);
      } else this.emitAPI({ type: "signalingMutilClientSyncNotify", obj: e.content }), s.isFunction(this.options.onSignalingMutilClientSyncNotify) && this.options.onSignalingMutilClientSyncNotify(e.content);
    }, r.onSignalingUnreadMessageSyncNotify = function (e) {
      if (e.error) {
        var t = e.error;this.logger.error("protocal::avSignal:onSignalingUnreadMessageSyncNotify error", t), this.emitAPI({ type: "error", error: t }), this.options.onerror(t);
      } else {
        var n = e.content.avSignalTag;Array.isArray(n) && (n = n.map(function (e) {
          return o(e);
        })), this.emitAPI({ type: "signalingUnreadMessageSyncNotify", obj: n }), s.isFunction(this.options.onSignalingUnreadMessageSyncNotify) && this.options.onSignalingUnreadMessageSyncNotify(n);
      }
    }, r.onSignalingMembersSyncNotify = function (e) {
      if (e.error) {
        var t = e.error;this.logger.error("protocal::avSignal:onSignalingMembersSyncNotify error", t), this.emitAPI({ type: "error", error: t }), this.options.onerror(t);
      } else {
        var n = e.content.avSignalTag;Array.isArray(n) || (n = [n]), n = n.map(function (e) {
          return o(e);
        }), this.emitAPI({ type: "signalingChannelsSyncNotify", obj: n }), s.isFunction(this.options.onSignalingMembersSyncNotify) && this.options.onSignalingMembersSyncNotify(n);
      }
    };
  }, function (e, t, n) {
    "use strict";
    var r = n(57).fn,
        s = n(154);r.processMisc = function (e) {
      switch (e.cmd) {case "getSimpleNosToken":
          e.error || (e.obj = e.content.nosTokens[0]);break;case "getNosToken":
          e.error || (e.obj = e.content.nosToken);break;case "notifyUploadLog":
          e.error || this.emitAPI({ type: "notifyUploadLog" });break;case "audioToText":
          e.error || (e.obj.text = e.content.text);break;case "processImage":
          e.obj.imageOps = s.reverseImageOps(e.obj.imageOps), e.error || (e.obj = { url: e.content.url });break;case "getNosTokenTrans":
          e.error || (e.obj = { nosToken: e.content.nosToken, docId: e.content.docId });break;case "getNosOriginUrl":
          this.getNosOriginUrlReqNum--, e.error || (e.obj = e.content.nosFileUrlTag.originUrl);break;case "notifyTransLog":
          e.error || this.emitAPI({ type: "notifyTransLog", obj: e.content.transInfo });break;case "fetchFile":case "fetchFileList":case "removeFile":
          e.error || (e.obj = e.content);}
    };
  }, function (e, t, n) {
    "use strict";
    var r = n(57).fn,
        s = n(2);r.processLink = function (e) {
      e.cmd;
    }, r.startHeartbeat = function () {
      var e = this;e.stopHeartbeat(), e.heartbeatTimer = setTimeout(function () {
        e.sendCmd("heartbeat", null, e.onHeartbeat.bind(e));
      }, s.heartbeatInterval);
    }, r.stopHeartbeat = function () {
      this.heartbeatTimer && (clearTimeout(this.heartbeatTimer), this.heartbeatTimer = null);
    }, r.onHeartbeat = function (e, t) {
      e ? (e.callFunc = "link::onHeartbeat", this.api.reportLogs({ event: "ping_timeout" }), this.onCustomError("heartbeat error", "HEARTBEAT_ERROR", e)) : this.startHeartbeat();
    }, r.heartbeat = function () {};
  }, function (e, t, n) {
    "use strict";
    var r,
        s = n(58),
        i = (r = s) && r.__esModule ? r : { default: r };var o,
        a = n(57).fn,
        c = n(26),
        u = n(22),
        l = n(118),
        m = n(54),
        d = n(2),
        f = n(0),
        p = f.notundef;a.login = function () {
      var e = this;__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve().then(function () {
        return e.assembleLogin();
      }).then(function (t) {
        e.sendCmd("login", (0, i["default"])({}, t), e.onLogin.bind(e));
      }), e.autoconnect = !1;
    }, a.genSessionKey = (o = {}, function () {
      var e = this.name;return o[e] = o[e] || f.guid();
    }), a.assembleIMLogin = function () {
      var e = this.options,
          t = e.account,
          n = this.autoconnect ? 0 : 1;return this.sdkSession = this.genSessionKey(), { appLogin: n, appKey: e.appKey, account: t, token: e.token, sdkVersion: d.info.sdkVersion, protocolVersion: d.info.protocolVersion, os: u.os.toString(), browser: u.name + " " + u.version, clientType: d.CLIENTTYPE || 16, session: this.sdkSession, deviceId: m.deviceId, isReactNative: d.isRN ? 1 : 0, customTag: e.customTag || "" };
    }, a.onLogin = function (e, t) {
      this.loginResult = t, e ? this.onAuthError(e, "link::onLogin") : (this.startHeartbeat(), this.afterLogin(t));
    }, a.afterLogin = f.emptyFunc, a.notifyLogin = function () {
      var e = this.loginResult;this.logger.info("link::notifyLogin: on connect", e), this.options.onconnect(e);
    }, a.logout = function () {
      var e = "done disconnect";if (this.doLogout) return this.doLogout = !1, e = "done logout", void this.onAuthError(new c(e, "logout"), "link::logout");if (this.isConnected()) {
        var t = new c(e, "logout");this.onAuthError(t, "link::logout");
      }
    }, a.onKicked = function (e) {
      var t = e.content,
          n = t.from,
          r = t.reason,
          s = t.custom,
          i = { reason: this.kickedReasons[r] || "unknown", message: this.kickedMessages[r] || "未知原因" };if (p(n) && (i.from = l.reverseType(n)), p(s) && (i.custom = s), this.shouldNotifyKicked(i)) {
        var o = new c("被踢了", "kicked");f.merge(o, i), this.onAuthError(o, "link::onKicked");
      } else this.logger.warn("link::onKicked: silentlyKick"), this.shouldReconnect = !0, this.hasNotifyDisconnected = !0, this.disconnectSocket();
    }, a.shouldNotifyKicked = function (e) {
      return "silentlyKick" !== e.reason;
    }, a.onAuthError = function (e, t) {
      this.shouldReconnect = !1, (e = e || c.newConnectionError({ callFunc: t })).callFunc = e.callFunc || t || null, this.markAllCallbackInvalid(e), this.notifyDisconnect(e);
    };
  }, function (e, t) {
    e.exports = function (e) {
      return e.webpackPolyfill || (e.deprecate = function () {}, e.paths = [], e.children || (e.children = []), Object.defineProperty(e, "loaded", { enumerable: !0, get: function get() {
          return e.l;
        } }), Object.defineProperty(e, "id", { enumerable: !0, get: function get() {
          return e.i;
        } }), e.webpackPolyfill = 1), e;
    };
  }, function (e, t, n) {
    "use strict";
    var r = n(57).fn,
        s = n(26),
        i = n(171),
        o = n(152),
        a = n(2),
        c = n(0);r.initConnect = function () {
      this.socket = null, this.retryCount = 0, this.connecting = !1, this.initConnecting = !1, this.shouldReconnect = !0, this.hasNotifyDisconnected = !1, this.doLogout = !1;
    }, r.resetConnect = function () {
      var e = this.options;c.notundef(e.needReconnect) ? (c.verifyParamType("needReconnect", e.needReconnect, "boolean", "link::resetConnect"), this.needReconnect = e.needReconnect) : this.needReconnect = !0, this.logger.log("link::resetConnect: needReconnect " + this.needReconnect), c.notundef(e.reconnectionAttempts) && c.verifyParamType("reconnectionAttempts", e.reconnectionAttempts, "number", "link::resetConnect"), this.reconnectionAttempts = "number" == typeof e.reconnectionAttempts ? e.reconnectionAttempts : 1 / 0, this.backoff = new i({ min: a.reconnectionDelay, max: a.reconnectionDelayMax, jitter: a.reconnectionJitter });
    }, r.connect = function (e) {
      if (e) {
        if (this.initConnecting) return void this.logger.warn("link::connect: already init connecting");clearTimeout(this.reconnectTimer);
      }if (this.isConnected()) this.logger.warn("link::connect: already connected");else if (this.connecting) this.logger.warn("link::connect: already connecting");else if (this.connecting = !0, this.hasNotifyDisconnected = !1, this.socket && this.socket && this.socket.socket) this.logger.info("link::connect: try connecting..."), this.socket.socket.connect();else if (this.options.socketUrl && "string" == typeof this.options.socketUrl) this.connectToUrl(this.options.socketUrl);else {
        var t = this.getNextSocketUrl();t ? this.connectToUrl(t) : this.refreshSocketUrl();
      }
    }, r.getNextSocketUrl = function () {
      return this.socketUrls.shift();
    }, r.isConnected = function () {
      return !!this.socket && !!this.socket.socket && this.socket.socket.connected;
    }, r.connectToUrl = function (e) {
      var t = this;if (e = e || "", t.logger.log("link::connectToUrl: " + e), "undefined" == typeof window) {
        var n = c.getGlobal(),
            r = e.split(":");n && !n.location && r.length > 1 && (n.location = { protocol: r[0], hostname: r[1].slice(2), port: r[2] }), this.options.transports = ["websocket"];
      }var s = this.options.transports || ["websocket", "xhr-polling"];t.socket = o.connect(e, { transports: s, reconnect: !1, "force new connection": !0, "connect timeout": a.connectTimeout }), t.logger.info("link::connectToUrl: socket url: " + e + ", transports: " + __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_json_stringify___default()(s)), t.socket.on("connect", t.onConnect.bind(t)), t.socket.on("handshake_failed", t.onHandshakeFailed.bind(t)), t.socket.on("connect_failed", t.onConnectFailed.bind(t)), t.socket.on("error", t.onError.bind(t)), t.socket.on("message", t.onMessage.bind(t)), t.socket.on("disconnect", function (n) {
        t.logger.warn("link::connectToUrl: socket url: " + e + ", disconnected"), t.doLogout ? t.logout() : t.onDisconnect(!0, "link::socketDisconnect");
      });
    }, r.disconnect = function (e) {
      var t = this;function n(n) {
        t.logger.info("link::disconnect: socket finally closed, ", n), clearTimeout(t.disconnectCallbackTimer), e(n);
      }e instanceof Function || (e = function e() {}), clearTimeout(t.connectTimer), t.disconnectCallbackTimer = setTimeout(function () {
        e.call(t, "mark disconnected due to timeout");
      }, 1e4), t.socket && t.socket.socket && t.socket.socket.transport ? t.socket.socket.transport.onDisconnectDone = function (e) {
        n(e);
      } : n(null), t.isConnected() ? (t.logger.log("link::disconnect: start disconnecting"), t.logout()) : t.connecting ? (t.logger.log("link::disconnect: abort connecting"), t.disconnectSocket()) : (t.logger.log("link::disconnect: start otherwise"), t.connecting = !1, t.shouldReconnect = !1, t.needReconnect = !1, t.options.ondisconnect({ callFunc: "link::disconnect", message: "manually disconnect status" }));
    }, r.onConnect = function () {
      this.backoff && this.backoff.reset(), this.reconnectStatus = this.retryCount > 0 ? 1 : 0, this.retryCount = 0, this.connecting = !1, this.initConnecting = !1, this.shouldReconnect = !0, this.hasNotifyDisconnected = !1, this.logger.log("link::onConnect: socket onconnected, start login"), this.login(), this.api.reportLogs({ event: "ws_connected" });
    }, r.onHandshakeFailed = function () {
      this.api.reportLogs({ event: "ws_handshake_failed" }), this.onDisconnect(!1, "link::onHandshakeFailed");
    }, r.onConnectFailed = function () {
      this.api.reportLogs({ event: "ws_connect_failed" }), this.onDisconnect(!1, "link::onConnectFailed");
    }, r.onError = function () {
      var e = arguments[0];if (e) {
        if (this.api.reportLogs({ event: "connect_timeout" }), void 0 !== e.x5ImgDecodeStatus) return;if ("[object Object]" === Object.prototype.toString.call(e) && __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_keys___default()(e).length <= 0) return;this.onMiscError("连接错误", new s(e, "LINK_ERROR", { callFunc: "link::onError" }));
      }this.connecting = !1;
    }, r.onDisconnect = function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
          t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;this.connected = e, this.connecting = !1, this.markAllCallbackInvalid(s.newNetworkError({ callFunc: t })), this.stopHeartbeat(), this.reconnect();
    }, r.willReconnect = function () {
      return this.shouldReconnect && this.needReconnect && this.retryCount < this.reconnectionAttempts;
    }, r.reconnect = function () {
      var e = this;if (e.willReconnect()) {
        if (e.socket && e.socket.socket && e.socket.socket.transport && e.socket.socket.transport.websocket) {
          e.logger.info("link::reconnect: on socket closed"), e.socket.socket.transport.onConnectionOver = function () {
            e.logger.log("link::reconnect: on connectionOver"), clearTimeout(e.reconnectTimer), e.doReconnect();
          };try {
            e.socket.socket.transport.websocket.close();
          } catch (t) {
            e.logger.warn("link::reconnect: force disconnect error:", t);
          }
        } else clearTimeout(e.reconnectTimer), e.reconnectTimer = setTimeout(function () {
          e.logger.info("link::reconnect: on socket timeout"), e.doReconnect();
        }, 3e4);
      } else e.notifyDisconnect();
    }, r.doReconnect = function () {
      var e = this;e.socket = null, e.connected && (e.autoconnect = !0), e.retryCount++, e.appLogin = 1;var t = e.backoff.duration();e.logger.info("link::reconnect: will retry after " + t + "ms, retryCount " + e.retryCount), e.options.onwillreconnect({ retryCount: e.retryCount, duration: t }), clearTimeout(e.connectTimer), e.connectTimer = setTimeout(function () {
        e.connect();
      }, t);
    }, r.notifyConnectError = function (e) {
      var t = s.newConnectError({ message: e, callFunc: "link::notifyConnectError" });this.logger.error("link::notifyConnectError:", t), this.options.onerror(t);
    }, r.notifyDisconnect = function (e) {
      var t = this;t.hasNotifyDisconnected || (t.hasNotifyDisconnected = !0, t.disconnectSocket(), (e = e || new s()).retryCount = t.retryCount, e.willReconnect = t.willReconnect(), t.backoff && t.backoff.reset(), t.retryCount = 0, t.socket && t.socket.socket && t.socket.socket.transport && t.socket.socket.transport.websocket ? (t.logger.info("link::notifyDisconnect: ondisconnected", e), t.socket.socket.transport.onConnectionOver = function () {
        t.socket = null, t.options.ondisconnect(e);
      }) : (t.logger.info("link::notifyDisconnect: ondisconnected/no transport ws", e), t.options.ondisconnect(e)), t.onWbNotifyHangup instanceof Function && t.onWbNotifyHangup({ content: { account: t.account, channelId: null, timetag: +Date() } }));
    }, r.disconnectSocket = function () {
      if (this.isConnected() || this.connecting) try {
        this.connecting = !1, this.shouldReconnect = !1, this.needReconnect = !1, this.socket.disconnect();
      } catch (e) {
        this.logger.info("link::disconnectSocket: disconnect failed, error ", e);
      }
    };
  }, function (e, t, n) {
    "use strict";
    var r,
        s = n(9),
        i = (r = s) && r.__esModule ? r : { default: r };var o = n(47).fn,
        a = n(0),
        c = n(79),
        u = n(153);o.signalingCreate = function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          t = e.type,
          n = e.channelName,
          r = e.ext;return a.verifyOptions(e, "type", "api::signalling"), this.sendCmdUsePromise("signalingCreate", { avSignalTag: { type: t, channelName: n, ext: r } }).then(function (e) {
        var t = e.avSignalTag;return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve(t);
      })["catch"](function (e) {
        return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.reject(u.parseAvSignalError(e));
      });
    }, o.signalingDelay = function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};return a.verifyOptions(e, "channelId", "api::signalling"), this.sendCmdUsePromise("signalingDelay", { avSignalTag: e }).then(function (e) {
        var t = e.avSignalTag;return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve(t);
      })["catch"](function (e) {
        return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.reject(u.parseAvSignalError(e));
      });
    }, o.signalingClose = function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          t = e.offlineEnabled;return a.verifyOptions(e, "channelId", "api::signalling"), this.sendCmdUsePromise("signalingClose", { avSignalTag: a.merge(e, { isSave: !0 === t ? 1 : 0 }) }).then(function (e) {
        var t = e.avSignalTag;return t.offlineEnabled = 1 === t.isSave, delete t.isSave, __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve(t);
      })["catch"](function (e) {
        return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.reject(u.parseAvSignalError(e));
      });
    }, o.signalingJoin = function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          t = e.offlineEnabled;return a.verifyOptions(e, "channelId", "api::signalling"), this.sendCmdUsePromise("signalingJoin", { avSignalTag: a.merge(e, { isSave: !0 === t ? 1 : 0 }) }).then(function (e) {
        var t = e.avSignalTag,
            n = t.members;return "string" == typeof t.members && (n = JSON.parse(t.members).map(function (e) {
          return u.parseAvSignalMember(e);
        })), t.members = n, __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve(t);
      })["catch"](function (e) {
        return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.reject(u.parseAvSignalError(e));
      });
    }, o.signalingLeave = function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          t = e.offlineEnabled;return a.verifyOptions(e, "channelId", "api::signalling"), this.sendCmdUsePromise("signalingLeave", { avSignalTag: a.merge(e, { isSave: !0 === t ? 1 : 0 }) }).then(function (e) {
        var t = e.avSignalTag;return t.offlineEnabled = 1 === t.isSave, delete t.isSave, __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve(t);
      })["catch"](function (e) {
        return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.reject(u.parseAvSignalError(e));
      });
    }, o.signalingGetChannelInfo = function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          t = e.channelName;return a.verifyOptions(e, "channelName", "api::signalling"), this.sendCmdUsePromise("signalingGetChannelInfo", { avSignalTag: { channelName: t } }).then(function (e) {
        var t = e.avSignalTag;return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve(t);
      })["catch"](function (e) {
        return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.reject(u.parseAvSignalError(e));
      });
    }, o.signalingInvite = function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          t = e.account,
          n = e.offlineEnabled,
          r = e.pushInfo,
          s = void 0 === r ? {} : r;a.verifyOptions(e, "channelId requestId account", "api::signalling"), "object" === (0, i["default"])(s.pushPayload) && (s.pushPayload = __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_json_stringify___default()(s.pushPayload));var o = a.merge(e, s, { to: t, isSave: !0 === n ? 1 : 0, needPush: !0 === s.needPush ? 1 : 0, needBadge: !1 === s.needBadge ? 0 : 1 });return this.sendCmdUsePromise("signalingInvite", { avSignalTag: o }).then(function (e) {
        var t = e.avSignalTag;return t.offlineEnabled = 1 === t.isSave, t.needBadge = 1 === t.needBadge, t.needPush = 1 === t.needPush, delete t.isSave, __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve(t);
      })["catch"](function (e) {
        return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.reject(u.parseAvSignalError(e));
      });
    }, o.signalingCancel = function (e) {
      var t = e.account,
          n = e.offlineEnabled;return a.verifyOptions(e, "channelId requestId account", "api::signalling"), this.sendCmdUsePromise("signalingCancel", { avSignalTag: a.merge(e, { to: t, isSave: !0 === n ? 1 : 0 }) }).then(function (e) {
        var t = e.avSignalTag;return t.offlineEnabled = 1 === t.isSave, delete t.isSave, __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve(t);
      })["catch"](function (e) {
        return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.reject(u.parseAvSignalError(e));
      });
    }, o.signalingCreateAndJoin = function (e) {
      var t = this,
          n = e.channelName,
          r = e.uid,
          s = void 0 === r ? 0 : r,
          i = e.offlineEnabled,
          o = void 0 === i || i,
          c = e.attachExt,
          u = void 0 === c ? "" : c;return this.signalingCreate(e)["catch"](function (e) {
        return 10405 === e.code ? (t.logger.warn("api::avSignal:signalingCall room already exists:", e), t.signalingGetChannelInfo({ channelName: n })) : __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.reject(e);
      }).then(function (e) {
        var n = { channelId: e.channelId, offlineEnabled: o, attachExt: u };return s && a.merge(n, { uid: s }), t.signalingJoin(n);
      });
    }, o.signalingCall = function (e) {
      var t = this,
          n = e.account,
          r = e.offlineEnabled,
          s = e.requestId;a.verifyOptions(e, "type requestId account", "api::signalling");var i = "";return this.signalingCreateAndJoin(e).then(function (o) {
        t.logger.log("api::avSignal:signalingCall join:", o);var a = { channelId: i = o.channelId || i, account: n, requestId: s, offlineEnabled: r, attachExt: e.attachExt || "", pushInfo: e.pushInfo || {} };return t.signalingInvite(a);
      });
    }, o.signalingReject = function (e) {
      var t = e.account,
          n = e.offlineEnabled;return a.verifyOptions(e, "channelId requestId account", "api::signalling"), this.sendCmdUsePromise("signalingReject", { avSignalTag: a.merge(e, { to: t, isSave: !0 === n ? 1 : 0 }) }).then(function (e) {
        var t = e.avSignalTag;return t.offlineEnabled = 1 === t.isSave, delete t.isSave, __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve(t);
      })["catch"](function (e) {
        return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.reject(u.parseAvSignalError(e));
      });
    }, o.signalingAccept = function (e) {
      var t = e.account,
          n = e.offlineEnabled;return a.verifyOptions(e, "channelId requestId account", "api::signalling"), this.sendCmdUsePromise("signalingAccept", { avSignalTag: a.merge(e, { to: t, isSave: !0 === n ? 1 : 0 }) }).then(function (e) {
        var t = e.avSignalTag;return t.offlineEnabled = 1 === t.isSave, delete t.isSave, __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve(t);
      })["catch"](function (e) {
        return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.reject(u.parseAvSignalError(e));
      });
    }, o.signalingControl = function (e) {
      var t = e.account;return a.verifyOptions(e, "channelId", "api::signalling"), this.sendCmdUsePromise("signalingControl", { avSignalTag: a.merge(e, t ? { to: t } : {}) }).then(function (e) {
        var t = e.avSignalTag;return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve(t);
      })["catch"](function (e) {
        return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.reject(u.parseAvSignalError(e));
      });
    }, o.signalingSync = function () {
      return this.sendCmdUsePromise("sync", { sync: { avSignal: 0 } }).then(function (e) {
        var t = e.avSignalTag;return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve(t);
      })["catch"](function (e) {
        return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.reject(u.parseAvSignalError(e));
      });
    }, o.signalingMarkMsgRead = function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};a.verifyOptions(e, "msgid", "api::signalling");var t = c.idMap.avSignal;return this.sendCmdUsePromise("batchMarkRead", { sid: t.id, cid: t.signalingNotify, ids: e.msgid });
    };
  }, function (e, t, n) {
    "use strict";
    var r = n(47).fn,
        s = n(0),
        i = n(36),
        o = n(2),
        a = n(22);(a = a || {}).name = a.name || "", a.version = a.version || "", r.reportLogs = function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          t = this,
          n = t.options,
          r = o.ntServerAddress;if (r) {
        var c = o.info;e = s.merge(e, { appkey: n.appKey, uid: n.account, os: "web", session: t.protocol.sdkSession || "", ver: c.sdkVersion, type: t.subType, platform: "" + a.name.toLowerCase() + a.version.replace(/(\.\d+)+$/, "") });var u = r + s.genUrlSep(r),
            l = [];for (var m in e) {
          l.push(m + "=" + e[m]);
        }u += l.join("&"), i(u, { proxyUrl: s.url2origin(u) + "/lbs/res/cors/nej_proxy_frame.html", timeout: o.xhrTimeout, onload: function onload() {}, onerror: function onerror(e) {
            t.logger.info("report::ajax report error", e);
          } });
      }
    };
  }, function (e, t, n) {
    "use strict";
    var r,
        s = n(9),
        i = (r = s) && r.__esModule ? r : { default: r };var o = n(0),
        a = n(47).fn;function c(e, t, n, r) {
      var s = !1,
          i = "";if (1 === n ? e.indexOf(t) >= 0 && (s = !0, i = t) : 2 === n && (i = new RegExp(t, "g")).test(e) && (s = !0), s && "" !== i) switch (r) {case 1:
          return e.replace(i, "**");case 2:
          return { code: 2 };case 3:
          return { code: 3 };}return e;
    }function u(e, t) {
      for (var n = t.match, r = t.operate, s = e, o = 0; o < t.keys.length; o++) {
        var a = t.keys[o],
            u = a.match || n,
            l = a.operate || r;try {
          if ("object" === (void 0 === (s = c(s, a.key, u, l)) ? "undefined" : (0, i["default"])(s))) return s;
        } catch (e) {
          this.logger.warn("misc::filterContent: js cannot parse this regexp ", e);
        }
      }return s;
    }a.uploadSdkLogUrl = function (e) {
      return o.verifyOptions(e, "url", "misc::uploadSdkLogUrl"), this.cbAndSendCmd("uploadSdkLogUrl", e);
    }, a.getClientAntispamLexicon = function (e) {
      var t = this,
          n = (e = e || {}).done;n instanceof Function || (n = function n() {}), e = { clientAntispam: { version: 0 } };var r = this;return this.protocol.sendCmd("getClientAntispam", e, function (e, s, i) {
        e ? (r.protocol.logger.error("misc::getClientAntispamLexicon:", e), n.call(t, e, {})) : (n.call(t, null, i), r.antispamLexicon = i.clientAntispam || {});
      });
    }, a.filterClientAntispam = function (e) {
      var t = e.content,
          n = e.antispamLexicon;if (!t) return { code: 404, errmsg: "待反垃圾文本content不存在" };n = n || this.antispamLexicon || {};var r = this.antispamLexicon && this.antispamLexicon.thesaurus;if (!r) return { code: 404, errmsg: "没有反垃圾词库或者词库格式不合法" };try {
        r = JSON.parse(r).thesaurus;
      } catch (e) {
        return this.protocol.logger.error("misc::filterClientAntispam: parse thesaurus error"), { code: 500, errmsg: "反垃圾词库格式不合法" };
      }for (var s = t, o = 0; o < r.length; o++) {
        if ("object" === (void 0 === (s = u.call(this, s, r[o])) ? "undefined" : (0, i["default"])(s))) {
          if (2 === s.code) return { code: 200, type: 2, errmsg: "建议拒绝发送", content: t, result: "" };if (3 === s.code) return { code: 200, type: 3, errmsg: "建议服务器处理反垃圾，发消息带上字段clientAntiSpam", content: t, result: t };
        }
      }return s === t ? { code: 200, type: 0, errmsg: "", content: t, result: s } : { code: 200, type: 1, errmsg: "已对特殊字符做了过滤", content: t, result: s };
    };
  }, function (e, t, n) {
    "use strict";
    var r,
        s = n(9),
        i = (r = s) && r.__esModule ? r : { default: r },
        o = n(67);var a,
        c = n(0),
        u = n(47).fn;u.viewImageSync = function (e) {
      var t = this.options;c.verifyOptions(e, "url", "nos::viewImageSync");var n = e.url,
          r = (0, o.url2object)(n),
          s = r.protocol,
          a = r.hostname,
          u = r.path,
          l = r.query;if ("boolean" == typeof e.strip && (l.stripmeta = e.strip ? 1 : 0), "number" == typeof e.quality && (c.verifyParamMin("quality", e.quality, 0, "nos::viewImageSync"), c.verifyParamMax("quality", e.quality, 100, "nos::viewImageSync"), l.quality = Math.round(e.quality)), "boolean" == typeof e.interlace && (l.interlace = e.interlace ? 1 : 0), "number" == typeof e.rotate && (l.rotate = Math.round(e.rotate)), "object" === (0, i["default"])(e.thumbnail)) {
        var m = e.thumbnail.mode || "crop",
            d = e.thumbnail.width,
            f = e.thumbnail.height;if (d >= 0 && f >= 0 && d < 4096 && f < 4096 && (d > 0 || f > 0)) {
          switch (m) {case "crop":
              m = "y";break;case "contain":
              m = "x";break;case "cover":
              m = "z";break;default:
              m = "x";}l.thumbnail = "" + d + m + f;
        }
      }if (t.downloadUrl) {
        var p = (0, o.url2object)(e.url),
            g = t.downloadUrl,
            h = p.path,
            y = h.indexOf("/");if (-1 !== y) {
          var v = h.substring(0, y),
              b = h.substring(y + 1);g = g.replace("{bucket}", v).replace("{object}", b);
        }var M = (0, o.url2object)(g);return (0, o.object2url)({ protocol: M.protocol, hostname: M.hostname, path: M.path, query: c.merge(M.query, l) });
      }return (0, o.object2url)({ protocol: s, hostname: a, path: u, query: l });
    }, u.viewImageStripMeta = function (e) {
      c.verifyOptions(e, "url strip", "nos::viewImageStripMeta"), c.verifyParamType("strip", e.strip, "boolean", "nos::viewImageStripMeta");var t = "stripmeta=" + (e.strip ? 1 : 0),
          n = (0, o.genUrlSep)(e.url);return e.url + n + t;
    }, u.viewImageQuality = function (e) {
      c.verifyOptions(e, "url quality", "nos::viewImageQuality"), c.verifyParamType("quality", e.quality, "number", "nos::viewImageQuality"), c.verifyParamMin("quality", e.quality, 0, "nos::viewImageQuality"), c.verifyParamMax("quality", e.quality, 100, "nos::viewImageQuality");var t = "quality=" + Math.round(e.quality),
          n = (0, o.genUrlSep)(e.url);return e.url + n + t;
    }, u.viewImageInterlace = function (e) {
      c.verifyOptions(e, "url", "nos::viewImageInterlace");var t = (0, o.genUrlSep)(e.url);return e.url + t + "interlace=1";
    }, u.viewImageRotate = function (e) {
      for (c.verifyOptions(e, "url angle", "nos::viewImageRotate"), c.verifyParamType("angle", e.angle, "number", "nos::viewImageRotate"); e.angle < 0;) {
        e.angle = e.angle + 360;
      }e.angle = e.angle % 360;var t = "rotate=" + Math.round(e.angle),
          n = (0, o.genUrlSep)(e.url);return e.url + n + t;
    }, u.viewImageBlur = function (e) {
      c.verifyOptions(e, "url radius sigma", "nos::viewImageBlur"), c.verifyParamType("radius", e.radius, "number", "nos::viewImageBlur"), c.verifyParamMin("radius", e.radius, 1, "nos::viewImageBlur"), c.verifyParamMax("radius", e.radius, 50, "nos::viewImageBlur"), c.verifyParamType("sigma", e.sigma, "number", "nos::viewImageBlur"), c.verifyParamMin("sigma", e.sigma, 0, "nos::viewImageBlur");var t = "blur=" + Math.round(e.radius) + "x" + Math.round(e.sigma),
          n = (0, o.genUrlSep)(e.url);return e.url + n + t;
    }, u.viewImageCrop = function (e) {
      c.verifyOptions(e, "url x y width height", "nos::viewImageCrop"), c.verifyParamType("x", e.x, "number", "nos::viewImageCrop"), c.verifyParamMin("x", e.x, 0, "nos::viewImageCrop"), c.verifyParamType("y", e.y, "number", "nos::viewImageCrop"), c.verifyParamMin("y", e.y, 0, "nos::viewImageCrop"), c.verifyParamType("width", e.width, "number", "nos::viewImageCrop"), c.verifyParamMin("width", e.width, 0, "nos::viewImageCrop"), c.verifyParamType("height", e.height, "number", "nos::viewImageCrop"), c.verifyParamMin("height", e.height, 0, "nos::viewImageCrop");var t = "crop=" + Math.round(e.x) + "_" + Math.round(e.y) + "_" + Math.round(e.width) + "_" + Math.round(e.height),
          n = (0, o.genUrlSep)(e.url);return e.url + n + t;
    }, u.viewImageThumbnail = (a = { cover: "z", contain: "x", crop: "y" }, function (e) {
      c.verifyOptions(e, "url mode", "nos::viewImageThumbnail"), c.verifyParamValid("mode", e.mode, __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_keys___default()(a), "nos::viewImageThumbnail"), "contain" === e.mode ? c.verifyParamAtLeastPresentOne(e, "width height", "nos::viewImageThumbnail") : c.verifyOptions(e, "width height", "nos::viewImageThumbnail"), c.undef(e.width) && (e.width = 0), c.undef(e.height) && (e.height = 0), c.verifyParamType("width", e.width, "number", "nos::viewImageThumbnail"), c.verifyParamMin("width", e.width, 0, "nos::viewImageThumbnail"), c.verifyParamType("height", e.height, "number", "nos::viewImageThumbnail"), c.verifyParamMin("height", e.height, 0, "nos::viewImageThumbnail");var t = Math.round(e.width),
          n = Math.round(e.height),
          r = "thumbnail=" + t + a[e.mode] + n;"crop" === e.mode && c.notundef(e.axis) && (c.undef(e.axis.x) && (e.axis.x = 5), c.undef(e.axis.y) && (e.axis.y = 5), c.verifyParamMin("axis.x", e.axis.x, 0, "nos::viewImageThumbnail"), c.verifyParamMax("axis.x", e.axis.x, 10, "nos::viewImageThumbnail"), c.verifyParamMin("axis.y", e.axis.y, 0, "nos::viewImageThumbnail"), c.verifyParamMax("axis.y", e.axis.y, 10, "nos::viewImageThumbnail"), r = r + "&axis=" + Math.round(e.axis.x) + "_" + Math.round(e.axis.y)), c.notundef(e.enlarge) && (c.verifyParamType("enlarge", e.enlarge, "boolean", "nos::viewImageThumbnail"), e.enlarge && (r += "&enlarge=1"));var s = (0, o.genUrlSep)(e.url);return e.url + s + r;
    });
  }, function (e, t, n) {
    "use strict";
    var r,
        s = n(0),
        i = n(47).fn,
        o = n(154),
        a = n(156),
        c = n(26);i.transDoc = function (e) {
      s.verifyOptions(e, "fileInput done", "nos::transDoc");try {
        var t = e.fileInput.files[0],
            n = e.fileInputName = t.name,
            r = { ppt: 1, pptx: 2, pdf: 3 },
            i = n.substring(n.lastIndexOf(".") + 1);if (["ppt", "pdf", "pptx"].indexOf(i) < 0) return void e.done(c.newNoFileError("请上传正确格式的文件【ppt, pptx, pdf】", { callFunc: "nos: transDoc", fileInput: e.fileInput }), e);
      } catch (t) {
        return void e.done(c.newNoFileError("请上传正确的文件节点", { callFunc: "msg::previewFile", fileInput: e.fileInput }), e);
      }var o = __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_json_stringify___default()(a.genResponseBody("file") || {}).replace(/"/gi, '\\"'),
          u = { transToken: { name: n, type: r[i], transType: "png" === e.transcode ? 11 : 10, size: t.size, body: o } };this.getNosTokenTrans({ responseBody: u, nosToken: { nosScene: e.nosScene || this.nosScene, nosSurvivalTime: e.nosSurvivalTime }, callback: function (t, n) {
          t ? e.done(t) : (e.nosToken = n.nosToken, e.docId = n.docId, this._doPreviewFile(e));
        }.bind(this) });
    }, i.getSimpleNosToken = function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};return e.num = 1, s.verifyOptions(e), this.cbAndSendCmd("getSimpleNosToken", e);
    }, i.getNosToken = function (e) {
      var t = e.callback,
          n = e.nosToken,
          r = e.responseBody,
          s = { tag: n.nosScene };n.nosSurvivalTime && n.nosSurvivalTime !== 1 / 0 && (s.expireSec = n.nosSurvivalTime), this.sendCmd("getNosToken", { responseBody: r, nosToken: s }, t);
    }, i.getNosTokenTrans = function (e) {
      this.sendCmd("getNosTokenTrans", e.responseBody, e.callback);
    }, i.packFileDownloadName = function (e) {
      s.verifyOptions(e, "url name", !0, "", "nos::packFileDownloadName");var t = e.url;return t + s.genUrlSep(t) + "download=" + encodeURIComponent(e.name);
    }, i.audioToMp3 = function (e) {
      s.verifyOptions(e, "url", "nos::audioToMp3");var t = e.url;return t + s.genUrlSep(t) + "audioTrans&type=mp3";
    }, i.removeFile = function (e) {
      this.sendCmd("removeFile", e, e.callback);
    }, i.fetchFile = function (e) {
      this.sendCmd("fetchFile", e, e.callback);
    }, i.fetchFileList = function (e) {
      this.sendCmd("fetchFileList", e, e.callback);
    }, i.stripImageMeta = function (e) {
      return this.beforeProcessImage(e, "stripmeta");
    }, i.qualityImage = function (e) {
      return this.beforeProcessImage(e, "quality");
    }, i.interlaceImage = function (e) {
      return this.beforeProcessImage(e, "interlace");
    }, i.rotateImage = function (e) {
      return this.beforeProcessImage(e, "rotate");
    }, i.blurImage = function (e) {
      return this.beforeProcessImage(e, "blur");
    }, i.cropImage = function (e) {
      return this.beforeProcessImage(e, "crop");
    }, i.thumbnailImage = function (e) {
      return this.beforeProcessImage(e, "thumbnail");
    }, i.beforeProcessImage = function (e, t) {
      var n = s.copy(e);return n.type = t, e.ops = [n], this.processImage(e);
    }, i.processImage = function (e) {
      var t = this;s.verifyOptions(e, "url ops", !0, "", "nos::processImage"), s.verifyParamType("ops", e.ops, "array", "nos::processImage");var n = e.ops.map(function (e) {
        return s.verifyOptions(e, "type", !0, "", "nos::processImage"), s.verifyParamValid("type", e.type, o.validTypes, "nos::processImage"), t["gen" + e.type.slice(0, 1).toUpperCase() + e.type.slice(1) + "Op"](e);
      });t.processCallback(e), t.sendCmd("processImage", { url: e.url, imageOps: n }, e.callback);
    }, i.genStripmetaOp = function (e) {
      return new o({ type: e.type, stripmeta: e.strip ? 1 : 0 });
    }, i.genQualityOp = function (e) {
      s.verifyOptions(e, "quality", !0, "", "nos::genQualityOp"), s.verifyParamType("quality", e.quality, "number", "nos::genQualityOp"), s.verifyParamMin("quality", e.quality, 0, "nos::genQualityOp"), s.verifyParamMax("quality", e.quality, 100, "nos::genQualityOp");var t = Math.round(e.quality);return new o({ type: e.type, qualityQuality: t });
    }, i.genInterlaceOp = function (e) {
      return new o({ type: e.type });
    }, i.genRotateOp = function (e) {
      for (s.verifyOptions(e, "angle", !0, "", "nos::genRotateOp"), s.verifyParamType("angle", e.angle, "number", "nos::genRotateOp"); e.angle < 0;) {
        e.angle = e.angle + 360;
      }e.angle = e.angle % 360;var t = Math.round(e.angle);return new o({ type: e.type, rotateAngle: t });
    }, i.genBlurOp = function (e) {
      s.verifyOptions(e, "radius sigma", "nos::genBlurOp"), s.verifyParamType("radius", e.radius, "number", "nos::genBlurOp"), s.verifyParamMin("radius", e.radius, 1, "nos::genBlurOp"), s.verifyParamMax("radius", e.radius, 50, "nos::genBlurOp"), s.verifyParamType("sigma", e.sigma, "number", "nos::genBlurOp"), s.verifyParamMin("sigma", e.sigma, 0, "nos::genBlurOp");var t = Math.round(e.radius),
          n = Math.round(e.sigma);return new o({ type: e.type, blurRadius: t, blurSigma: n });
    }, i.genCropOp = function (e) {
      s.verifyOptions(e, "x y width height", "nos::genCropOp"), s.verifyParamType("x", e.x, "number", "nos::genCropOp"), s.verifyParamMin("x", e.x, 0, "nos::genCropOp"), s.verifyParamType("y", e.y, "number", "nos::genCropOp"), s.verifyParamMin("y", e.y, 0, "nos::genCropOp"), s.verifyParamType("width", e.width, "number", "nos::genCropOp"), s.verifyParamMin("width", e.width, 0, "nos::genCropOp"), s.verifyParamType("height", e.height, "number", "nos::genCropOp"), s.verifyParamMin("height", e.height, 0, "nos::genCropOp");var t = Math.round(e.x),
          n = Math.round(e.y),
          r = Math.round(e.width),
          i = Math.round(e.height);return new o({ type: e.type, cropX: t, cropY: n, cropWidth: r, cropHeight: i });
    }, i.genThumbnailOp = (r = { cover: "z", contain: "x", crop: "y" }, function (e) {
      s.verifyOptions(e, "mode", "nos::genThumbnailOp"), s.verifyParamValid("mode", e.mode, __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_keys___default()(r), "nos::genThumbnailOp"), "contain" === e.mode ? s.verifyParamAtLeastPresentOne(e, "width height", "nos::genThumbnailOp") : s.verifyOptions(e, "width height", "nos::genThumbnailOp"), s.undef(e.width) && (e.width = 0), s.undef(e.height) && (e.height = 0), s.verifyParamType("width", e.width, "number", "nos::genThumbnailOp"), s.verifyParamMin("width", e.width, 0, "nos::genThumbnailOp"), s.verifyParamType("height", e.height, "number", "nos::genThumbnailOp"), s.verifyParamMin("height", e.height, 0, "nos::genThumbnailOp");var t = Math.round(e.width),
          n = Math.round(e.height),
          i = new o({ type: e.type, thumbnailMode: r[e.mode], thumbnailWidth: t, thumbnailHeight: n });if ("crop" === e.mode && s.notundef(e.axis)) {
        s.undef(e.axis.x) && (e.axis.x = 5), s.undef(e.axis.y) && (e.axis.y = 5), s.verifyParamMin("axis.x", e.axis.x, 0, "nos::genThumbnailOp"), s.verifyParamMax("axis.x", e.axis.x, 10, "nos::genThumbnailOp"), s.verifyParamMin("axis.y", e.axis.y, 0, "nos::genThumbnailOp"), s.verifyParamMax("axis.y", e.axis.y, 10, "nos::genThumbnailOp");var a = Math.round(e.axis.x),
            c = Math.round(e.axis.y);i.thumbnailAxisX = a, i.thumbnailAxisY = c;
      }return s.notundef(e.enlarge) && (s.verifyParamType("enlarge", e.enlarge, "boolean", "nos::genThumbnailOp"), e.enlarge && (i.thumbnailEnlarge = 1)), i;
    }), i.getNosOriginUrl = function (e) {
      s.verifyOptions(e, "safeShortUrl", !0, "", "nos::getNosOriginUrl"), s.verifyParamType("safeShortUrl", e.safeShortUrl, "string", "nos::getNosOriginUrl"), /^http(s)?:/.test(e.safeShortUrl) && ~e.safeShortUrl.indexOf("im_url=1") ? (this.processCallback(e), this.sendCmd("getNosOriginUrl", { nosFileUrlTag: { safeUrl: e.safeShortUrl } }, e.callback)) : e.done(new c("参数 “safeShortUrl” 内容非文件安全短链", { callFunc: "nos: getNosOriginUrl" }), e);
    };
  }, function (e, t, n) {
    "use strict";
    var r = n(2),
        s = n(0),
        i = n(26),
        o = n(36).upload,
        a = n(36).chunkUpload,
        c = n(36).abort,
        u = s.supportFormData;function l(e) {
      var t = this;t.options = s.copy(e), s.verifyOptions(e, "url fileName"), s.verifyParamPresentJustOne(e, "blob fileInput"), s.verifyCallback(e, "beginupload uploadprogress uploaddone"), e.fileInput && (e.fileInput = s.verifyFileInput(e.fileInput)), e.type && s.verifyFileType(e.type), e.timeout ? s.verifyParamType("timeout", e.timeout, "number") : e.timeout = 6e5, s.verifyFileUploadCallback(e), e.data = {}, e.params && s.merge(e.data, e.params);var n = e.fileName,
          c = e.fileInput;if (u) {
        if (c) {
          var l = e.type ? s.filterFiles(c.files, e.type) : [].slice.call(c.files, 0);if (!l || !l.length) return void e.uploaddone(i.newWrongFileTypeError("未读取到" + e.type + "类型的文件, 请确保文件选择节点的文件不为空, 并且请确保选择了" + e.type + "类型的文件"));e.data[n] = l[0];var m = c.files[0].size;if (e.fileInputMaxSize && m > e.fileInputMaxSize) return void e.uploaddone(i.newFileTooLargeError("上传文件大小超过" + e.fileInputMaxSize + "限制"));if (!e.fileInputCommonUpload) return m > r.chunkMaxSize ? void e.uploaddone(i.newFileTooLargeError("直传文件大小超过" + r.chunkMaxSize + "限制")) : void (t.sn = a(e, n, t));if (m > r.commonMaxSize) return void e.uploaddone(i.newFileTooLargeError("普通上传文件大小超过" + r.commonMaxSize + "限制"));
        } else e.blob && (e.data[n] = e.blob);
      } else s.dataset(c, "name", n), e.data.input = c;var d = { data: e.data, onaftersend: function onaftersend() {
          e.beginupload(t);
        }, onuploading: function onuploading(t) {
          var n = Math.floor(1e4 * t.loaded / t.total) / 100,
              r = { docId: e.docId, total: t.total, loaded: t.loaded, percentage: n, percentageText: n + "%" };e.fileInput && (r.fileInput = e.fileInput), e.blob && (r.blob = e.blob), e.uploadprogress(r);
        }, onload: function onload(n) {
          n.docId = e.docId, n.Error ? t.onError(n) : e.uploaddone(null, n);
        }, onerror: function onerror(n) {
          try {
            if (n.result) var r = JSON.parse(n.result);else r = n;t.onError(r);
          } catch (r) {
            console.log("error: ignore error if could not parse obj.result", r), e.uploaddone(new i(n.message, n.code), t.options);
          }
        } };u || (d.mode = "iframe"), d.putFileAtEnd = !0, t.sn = o(e.url, d);
    }l.prototype.onError = function (e) {
      var t,
          n,
          r,
          s = this.options;n = (t = (e = e || {}).Error || e || {}).Code || t.code || "unknown", r = t.Message || t.message || "未知错误", s.uploaddone(new i(n + "(" + r + ")", n));
    }, l.prototype.abort = function () {
      c(this.sn);
    }, e.exports = l;
  }, function (e, t, n) {
    var r, s, i;!function (n, o) {
      "use strict";
      s = [], void 0 === (i = "function" == typeof (r = function r(e) {
        return function (t) {
          t = t || {}, function () {
            t.arrayAccessForm = t.arrayAccessForm || "none", t.emptyNodeForm = t.emptyNodeForm || "text", t.jsAttributeFilter = t.jsAttributeFilter, t.jsAttributeConverter = t.jsAttributeConverter, t.attributeConverters = t.attributeConverters || [], t.datetimeAccessFormPaths = t.datetimeAccessFormPaths || [], t.arrayAccessFormPaths = t.arrayAccessFormPaths || [], void 0 === t.enableToStringFunc && (t.enableToStringFunc = !0);void 0 === t.skipEmptyTextNodesForObj && (t.skipEmptyTextNodesForObj = !0);void 0 === t.stripWhitespaces && (t.stripWhitespaces = !0);void 0 === t.useDoubleQuotes && (t.useDoubleQuotes = !0);void 0 === t.ignoreRoot && (t.ignoreRoot = !1);void 0 === t.escapeMode && (t.escapeMode = !0);void 0 === t.attributePrefix && (t.attributePrefix = "_");void 0 === t.selfClosingElements && (t.selfClosingElements = !0);void 0 === t.keepCData && (t.keepCData = !1);void 0 === t.jsDateUTC && (t.jsDateUTC = !1);
          }(), function () {
            function e(e) {
              var t = String(e);return 1 === t.length && (t = "0" + t), t;
            }"function" != typeof String.prototype.trim && (String.prototype.trim = function () {
              return this.replace(/^\s+|^\n+|(\s|\n)+$/g, "");
            });"function" != typeof Date.prototype.toISOString && (Date.prototype.toISOString = function () {
              return this.getUTCFullYear() + "-" + e(this.getUTCMonth() + 1) + "-" + e(this.getUTCDate()) + "T" + e(this.getUTCHours()) + ":" + e(this.getUTCMinutes()) + ":" + e(this.getUTCSeconds()) + "." + String((this.getUTCMilliseconds() / 1e3).toFixed(3)).slice(2, 5) + "Z";
            });
          }();var n = { ELEMENT_NODE: 1, TEXT_NODE: 3, CDATA_SECTION_NODE: 4, COMMENT_NODE: 8, DOCUMENT_NODE: 9 };function r(e) {
            var t = e.localName;return null == t && (t = e.baseName), null != t && "" !== t || (t = e.nodeName), t;
          }function s(e) {
            return "string" == typeof e ? e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;") : e;
          }function i(e, n, r) {
            switch (t.arrayAccessForm) {case "property":
                e[n] instanceof Array ? e[n + "_asArray"] = e[n] : e[n + "_asArray"] = [e[n]];}if (!(e[n] instanceof Array) && t.arrayAccessFormPaths.length > 0) {
              for (var s = !1, i = 0; i < t.arrayAccessFormPaths.length; i++) {
                var o = t.arrayAccessFormPaths[i];if ("string" == typeof o) {
                  if (o === r) {
                    s = !0;break;
                  }
                } else if (o instanceof RegExp) {
                  if (o.test(r)) {
                    s = !0;break;
                  }
                } else if ("function" == typeof o && o(n, r)) {
                  s = !0;break;
                }
              }s && (e[n] = [e[n]]);
            }
          }function o(e) {
            var t = e.split(/[-T:+Z]/g),
                n = new Date(t[0], t[1] - 1, t[2]),
                r = t[5].split(".");if (n.setHours(t[3], t[4], r[0]), r.length > 1 && n.setMilliseconds(r[1]), t[6] && t[7]) {
              var s = 60 * t[6] + Number(t[7]),
                  i = /\d\d-\d\d:\d\d$/.test(e) ? "-" : "+";s = 0 + ("-" === i ? -1 * s : s), n.setMinutes(n.getMinutes() - s - n.getTimezoneOffset());
            } else -1 !== e.indexOf("Z", e.length - 1) && (n = new Date(Date.UTC(n.getFullYear(), n.getMonth(), n.getDate(), n.getHours(), n.getMinutes(), n.getSeconds(), n.getMilliseconds())));return n;
          }function a(e, s) {
            for (var a = { __cnt: 0 }, u = e.childNodes, l = 0; l < u.length; l++) {
              var m = u.item(l),
                  d = r(m);m.nodeType !== n.COMMENT_NODE && (a.__cnt++, null == a[d] ? (a[d] = c(m, s + "." + d), i(a, d, s + "." + d)) : (a[d] instanceof Array || (a[d] = [a[d]], i(a, d, s + "." + d)), a[d][a[d].length] = c(m, s + "." + d)));
            }for (var f = 0; f < e.attributes.length; f++) {
              var p = e.attributes.item(f);a.__cnt++;for (var g = p.value, h = 0; h < t.attributeConverters.length; h++) {
                var y = t.attributeConverters[h];y.test.call(null, p.name, p.value) && (g = y.convert.call(null, p.name, p.value));
              }a[t.attributePrefix + p.name] = g;
            }var v = e.prefix;return v && (a.__cnt++, a.__prefix = v), a["#text"] && (a.__text = a["#text"], a.__text instanceof Array && (a.__text = a.__text.join("\n")), t.escapeMode && (a.__text = a.__text.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, '"').replace(/&#x27;/g, "'").replace(/&amp;/g, "&")), t.stripWhitespaces && (a.__text = a.__text.trim()), delete a["#text"], "property" === t.arrayAccessForm && delete a["#text_asArray"], a.__text = function (e, n, r) {
              if (t.datetimeAccessFormPaths.length > 0) for (var s = r.split(".#")[0], i = 0; i < t.datetimeAccessFormPaths.length; i++) {
                var a = t.datetimeAccessFormPaths[i];if ("string" == typeof a) {
                  if (a === s) return o(e);
                } else if (a instanceof RegExp) {
                  if (a.test(s)) return o(e);
                } else if ("function" == typeof a && a(s)) return o(e);
              }return e;
            }(a.__text, 0, s + ".#text")), a.hasOwnProperty("#cdata-section") && (a.__cdata = a["#cdata-section"], delete a["#cdata-section"], "property" === t.arrayAccessForm && delete a["#cdata-section_asArray"]), 1 === a.__cnt && a.__text ? a = a.__text : 0 === a.__cnt && "text" === t.emptyNodeForm ? a = "" : a.__cnt > 1 && void 0 !== a.__text && t.skipEmptyTextNodesForObj && (t.stripWhitespaces && "" === a.__text || "" === a.__text.trim()) && delete a.__text, delete a.__cnt, t.keepCData || a.hasOwnProperty("__text") || !a.hasOwnProperty("__cdata") ? (t.enableToStringFunc && (a.__text || a.__cdata) && (a.toString = function () {
              return (this.__text ? this.__text : "") + (this.__cdata ? this.__cdata : "");
            }), a) : a.__cdata ? a.__cdata : "";
          }function c(e, s) {
            return e.nodeType === n.DOCUMENT_NODE ? function (e) {
              for (var s = {}, i = e.childNodes, o = 0; o < i.length; o++) {
                var a = i.item(o);if (a.nodeType === n.ELEMENT_NODE) {
                  var u = r(a);t.ignoreRoot ? s = c(a, u) : s[u] = c(a, u);
                }
              }return s;
            }(e) : e.nodeType === n.ELEMENT_NODE ? a(e, s) : e.nodeType === n.TEXT_NODE || e.nodeType === n.CDATA_SECTION_NODE ? e.nodeValue : null;
          }function u(e, n, r, i) {
            var o = "<" + (e && e.__prefix ? e.__prefix + ":" : "") + n;if (r) for (var a = 0; a < r.length; a++) {
              var c = r[a],
                  u = e[c];t.escapeMode && (u = s(u)), o += " " + c.substr(t.attributePrefix.length) + "=", t.useDoubleQuotes ? o += '"' + u + '"' : o += "'" + u + "'";
            }return o += i ? " />" : ">";
          }function l(e, t) {
            return "</" + (e && e.__prefix ? e.__prefix + ":" : "") + t + ">";
          }function m(e, n) {
            return "property" === t.arrayAccessForm && (r = n.toString(), s = "_asArray", -1 !== r.indexOf(s, r.length - s.length)) || 0 === n.toString().indexOf(t.attributePrefix) || 0 === n.toString().indexOf("__") || e[n] instanceof Function;var r, s;
          }function d(e) {
            var t = 0;if (e instanceof Object) for (var n in e) {
              m(e, n) || t++;
            }return t;
          }function f(e) {
            var n = [];if (e instanceof Object) for (var r in e) {
              -1 === r.toString().indexOf("__") && 0 === r.toString().indexOf(t.attributePrefix) && n.push(r);
            }return n;
          }function p(e) {
            var n = "";return e instanceof Object ? n += function (e) {
              var n = "";e.__cdata && (n += "<![CDATA[" + e.__cdata + "]]>");e.__text && (t.escapeMode ? n += s(e.__text) : n += e.__text);return n;
            }(e) : null !== e && (t.escapeMode ? n += s(e) : n += e), n;
          }function g(e, n, r) {
            var s = "";if (t.jsAttributeFilter && t.jsAttributeFilter.call(null, n, e)) return s;if (t.jsAttributeConverter && (e = t.jsAttributeConverter.call(null, n, e)), null != e && "" !== e || !t.selfClosingElements) {
              if ("object" == (typeof e === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_15_babel_runtime_helpers_typeof___default()(e))) {
                if ("[object Array]" === Object.prototype.toString.call(e)) s += function (e, t, n) {
                  var r = "";if (0 === e.length) r += u(e, t, n, !0);else for (var s = 0; s < e.length; s++) {
                    r += g(e[s], t, f(e[s]));
                  }return r;
                }(e, n, r);else if (e instanceof Date) s += u(e, n, r, !1), s += t.jsDateUTC ? e.toUTCString() : e.toISOString(), s += l(e, n);else {
                  var i = d(e);i > 0 || e.__text || e.__cdata ? (s += u(e, n, r, !1), s += h(e), s += l(e, n)) : t.selfClosingElements ? s += u(e, n, r, !0) : (s += u(e, n, r, !1), s += l(e, n));
                }
              } else s += u(e, n, r, !1), s += p(e), s += l(e, n);
            } else s += u(e, n, r, !0);return s;
          }function h(e) {
            var t = "",
                n = d(e);if (n > 0) for (var r in e) {
              if (!m(e, r)) {
                var s = e[r],
                    i = f(s);t += g(s, r, i);
              }
            }return t += p(e);
          }function y(t) {
            if (void 0 === t) return null;if ("string" != typeof t) return null;var n = null,
                r = null;if (e) n = new e(), r = n.parseFromString(t, "text/xml");else if (window && window.DOMParser) {
              n = new window.DOMParser();var s = null,
                  i = window.ActiveXObject || "ActiveXObject" in window;if (!i) try {
                s = n.parseFromString("INVALID", "text/xml").childNodes[0].namespaceURI;
              } catch (e) {
                s = null;
              }try {
                r = n.parseFromString(t, "text/xml"), null !== s && r.getElementsByTagNameNS(s, "parsererror").length > 0 && (r = null);
              } catch (e) {
                r = null;
              }
            } else 0 === t.indexOf("<?") && (t = t.substr(t.indexOf("?>") + 2)), (r = new ActiveXObject("Microsoft.XMLDOM")).async = "false", r.loadXML(t);return r;
          }this.asArray = function (e) {
            return null == e ? [] : e instanceof Array ? e : [e];
          }, this.toXmlDateTime = function (e) {
            return e instanceof Date ? e.toISOString() : "number" == typeof e ? new Date(e).toISOString() : null;
          }, this.asDateTime = function (e) {
            return "string" == typeof e ? o(e) : e;
          }, this.xml2dom = function (e) {
            return y(e);
          }, this.dom2js = function (e) {
            return c(e, null);
          }, this.js2dom = function (e) {
            var t = this.js2xml(e);return y(t);
          }, this.xml2js = function (e) {
            var t = y(e);return null != t ? this.dom2js(t) : null;
          }, this.js2xml = function (e) {
            return h(e);
          }, this.getVersion = function () {
            return "3.1.1";
          };
        };
      }) ? r.apply(t, s) : r) || (e.exports = i);
    }();
  }, function (e, t, n) {
    "use strict";
    var r,
        s = n(9),
        i = (r = s) && r.__esModule ? r : { default: r };var o = n(47).fn,
        a = n(0),
        c = n(301),
        u = n(26),
        l = n(2),
        m = n(156),
        d = n(300),
        f = n(155);o.sendText = function (e) {
      return this.processCallback(e), e.msg = new this.message.TextMessage(e), this.sendMsg(e);
    }, o.previewFile = function (e) {
      if (a.verifyOptions(e, "done", "msg::previewFile"), e.type || (e.type = "file"), a.verifyParamPresentJustOne(e, "dataURL blob fileInput filePath wxFilePath fileObject", "msg::previewFile"), a.exist(e.fileInputMaxSize) && a.verifyParamType("fileInputMaxSize", e.fileInputMaxSize, "number", "api::previewFile"), a.exist(e.fileInputCommonUpload) && a.verifyParamType("fileInputCommonUpload", e.fileInputCommonUpload, "boolean", "api::previewFile"), e.nosSurvivalTime ? (a.verifyParamType("nosSurvivalTime", e.nosSurvivalTime, "number", "api::Base.getInstance"), a.verifyParamMin("nosSurvivalTime", e.nosSurvivalTime, 86400, "api::Base.getInstance")) : e.nosSurvivalTime = this.nosSurvivalTime, e.filePath = e.filePath || e.wxFilePath, delete e.wxFilePath, e.dataURL) e.blob = f.fromDataURL(e.dataURL);else if (e.blob) ;else if (e.fileInput) {
        if (e.fileInput = a.verifyFileInput(e.fileInput, "msg::previewFile"), e.fileInput.files) {
          if (!e.fileInput.files.length) return void e.done(u.newNoFileError("请选择" + e.type + "文件", { callFunc: "msg::previewFile", fileInput: e.fileInput }), e);e.fileSize = e.fileInput.files[0].size;
        }e.fileInputName = a.getFileName(e.fileInput);
      }this.processCallback(e);var t = __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_json_stringify___default()(m.genResponseBody(e.type) || {}).replace(/"/gi, '\\"'),
          n = null,
          r = e.transcode ? "getNosTokenTrans" : "getNosToken";if (e.transcode) {
        a.verifyOptions(e, "fileInput", "msg::previewFile");var s = a.getFileInfo(e.fileInput);n = { transToken: { name: s.name, type: s.transcodeType, transType: "png" === e.transcode ? 11 : 10, size: s.size, body: t } };
      } else n = t;this[r]({ responseBody: n, nosToken: { nosScene: e.nosScene || this.nosScene, nosSurvivalTime: e.nosSurvivalTime }, callback: function (t, n) {
          t ? e.done(t) : (e.transcode ? (e.nosToken = n.nosToken, e.docId = n.docId) : e.nosToken = n, this._doPreviewFile(e));
        }.bind(this) });
    }, o._doPreviewFile = function (e) {
      var t,
          n = this,
          r = e.uploaddone,
          s = l.genUploadUrl(e.nosToken.bucket),
          o = l.genChunkUploadUrl(e.nosToken);e.fileInputCommonUpload || e.dataURL || e.blob || !o || l.isWeixinApp || l.isNodejs || l.isRN ? (e.fileInputCommonUpload = !0, t = s) : t = o;var c = this.assembleUploadParams(e.nosToken);function f(t, s, i) {
        if (e.uploaddone = r, t) e.done(t, e.callback.options);else {
          if (s = m.parseResponse(s, n.options.exifOrientation), i || (s.url = l.genDownloadUrl(e.nosToken, c.Object), e.nosToken.shortUrl && (s._url_safe = e.nosToken.shortUrl)), a.exist(e.fileInputName)) s.name = e.fileInputName;else if (e.blob) {
            var o = e.blob.name;if (s.name = o || "blob-" + s.md5, !o) {
              var u = e.blob.type;s.ext = u.slice(u.lastIndexOf("/") + 1);
            }
          } else e.filePath ? s.name = e.filePath : e.fileObject && (s.name = e.fileObject.fileName);if (!s.ext) {
            var d = s.name.lastIndexOf(".");s.ext = -1 === d ? "unknown" : s.name.slice(d + 1);
          }s.size = s.size || 0, e.done(null, a.copy(s));
        }
      }if (l.isWeixinApp) a.verifyOptions(e, "filePath", "msg::_doPreviewFile"), n.fileQuickTransfer(e, f, function () {
        wx.uploadFile({ url: t, filePath: e.filePath, name: "file", formData: c, fail: function fail(e) {
            console.log("error:", "api::msg:upload file failed", e);
          }, success: function success(e) {
            if (200 === e.statusCode) try {
              f(null, JSON.parse(e.data));
            } catch (t) {
              console.log("error:", "parse wx upload file res error", t), f({ code: "PARSE_WX_UPLOAD_FILE_RES_ERROR", str: e.data, msg: e.errMsg });
            } else f({ code: e.statusCode, msg: e.errMsg });
          } });
      });else if (l.isNodejs) {
        var p = { url: t, name: "file", formData: c, success: function success(e) {
            if (200 === e.statusCode) try {
              f(null, JSON.parse(e.data));
            } catch (t) {
              console.log("error:", "parse nodejs upload file res error", t), f({ code: "PARSE_NODEJS_UPLOAD_FILE_RES_ERROR", str: e.data, msg: e.errMsg });
            } else f({ code: e.statusCode, msg: e.errMsg });
          }, fail: function fail(e) {
            console.log("error:", "api::msg:upload file failed", e);
          } };if (e.filePath) p.filePath = e.filePath;else {
          if ("object" !== (0, i["default"])(e.fileObject)) throw new u("Nodejs上传fileObject参数类型应如 {fileName:..,fileData:..} ");p.fileData = e.fileObject.fileData;
        }n.fileQuickTransfer(e, f, function () {
          d.uploadFile(p);
        });
      } else if (l.isRN) {
        var g = { url: t, name: "file", formData: c, filePath: e.filePath, success: function success(e) {
            if (e.ok && 200 === e.status) try {
              e.md5 = e.headers.map && e.headers.map.etag && e.headers.map.etag[0] || "UNKNOWN", f(null, e);
            } catch (t) {
              console.log("error:", "parse React Native upload file res error", t), f({ code: "PARSE_React_Native_UPLOAD_FILE_RES_ERROR", res: e });
            } else f({ code: e.status, msg: e.statusText });
          }, fail: function fail(e) {
            console.log("error:", "api::msg:upload file failed", e);
          } };n.fileQuickTransfer(e, f, function () {
          d.uploadFile(g);
        });
      } else e.uploaddone = f, e.url = t, e.params = c, e.fileName = "file", n.fileQuickTransfer(e, f, function () {
        return new d(e);
      });
    }, o.fileQuickTransfer = function (e, t, n) {
      var r = this;e = e || {}, t instanceof Function || (t = function t() {}), n instanceof Function || (n = function n() {});var s = e.fastPass;if (s) try {
        s = JSON.parse(s), e.fastPass = s;
      } catch (e) {
        r.protocol.logger.error("快传参数解析失败");
      }var i = e.fileInputName || e.name || e.blob && e.blob.name || "",
          o = e.fileSize || e.size || e.blob && e.blob.size || 0,
          a = s ? ((s.md5 || e.digest || "") + "").trim() : "",
          c = e.type || e.blob && e.blob.type;if (a && o >= l.threshold) {
        var u = !0,
            m = { name: i, md5: a, ext: i.slice(i.lastIndexOf(".") + 1), type: c };switch (c) {case "image":
            s && s.w && s.h ? (m.w = s.w, m.h = s.h) : (u = !1, r.protocol.logger.error("快传 image 文件缺少参数 w 或 h"));break;case "video":
            s && s.w && s.h && s.dur ? (m.w = s.w, m.h = s.h, m.dur = s.dur) : (u = !1, r.protocol.logger.error("快传 video 文件缺少参数 w 或 h 或 dur"));break;case "audio":
            s && s.dur ? m.dur = s.dur : (u = !1, r.protocol.logger.error("快传 audio 文件缺少参数 dur"));}if (!u) return void n();var d = { fileQuickTransfer: { md5: a } };return o && (d.fileQuickTransfer.size = o), this.protocol.sendCmd("fileQuickTransfer", d, function (e, s, i) {
          !e && i && i.fileQuickTransfer && i.fileQuickTransfer.url || (r.protocol.logger.error("misc::fileQuickTransfer: not found", e, s, i), n()), i && i.fileQuickTransfer && i.fileQuickTransfer.threshold && (l.threshold = i.fileQuickTransfer.threshold || 0), i && i.fileQuickTransfer && i.fileQuickTransfer.url && (m.size = o || i.fileQuickTransfer.size, m.url = i.fileQuickTransfer.url, i.fileQuickTransfer._url_safe && (m._url_safe = i.fileQuickTransfer._url_safe), t(e, m, !0));
        });
      }n();
    }, o.sendFile = function (e) {
      if (e.type || (e.type = "file"), a.verifyParamPresentJustOne(e, "dataURL blob fileInput file filePath wxFilePath fileObject", "msg::sendFile"), a.exist(e.fileInputMaxSize) && a.verifyParamType("fileInputMaxSize", e.fileInputMaxSize, "number", "api::previewFile"), a.exist(e.fileInputCommonUpload) && a.verifyParamType("fileInputCommonUpload", e.fileInputCommonUpload, "boolean", "api::previewFile"), this.processCallback(e), e.filePath = e.filePath || e.wxFilePath, delete e.wxFilePath, e.dataURL) this._previewAndSendFile(e);else if (e.blob) this._previewAndSendFile(e);else if (e.fileInput) {
        if (e.fileInput = a.verifyFileInput(e.fileInput, "msg::sendFile"), e.fileInput.files && !e.fileInput.files.length) return void e.done(u.newNoFileError("请选择" + e.type + "文件", { callFunc: "msg::sendFile", fileInput: e.fileInput }), e.callback.options);this._previewAndSendFile(e);
      } else if (e.filePath || e.fileObject) this._previewAndSendFile(e);else if (e.file) {
        var t,
            n = e.file._url_safe;return n && (t = e.file.url, e.file.url = n, delete e.file._url_safe), e.msg = new this.message.FileMessage(e), this.sendMsg(e, t);
      }
    }, o._previewAndSendFile = function (e) {
      var t = this;a.verifyCallback(e, "uploaddone beforesend", "msg::_previewAndSendFile");var n = e.done;e.done = function (r, s) {
        if (e.done = n, r) e.uploaddone(r, e.callback.options);else {
          if (/chatroom/.test(e.scene)) return;var i;e.uploaddone(null, a.copy(s));var o = s._url_safe;o && (i = s.url, s.url = o, delete s._url_safe), e.file = s, e.msg = new t.message.FileMessage(e), e.beforesend(t.sendMsg(e, i));
        }
      }, t.previewFile(e);
    }, o.assembleUploadParams = function (e) {
      return e ? { Object: decodeURIComponent(e.objectName), "x-nos-token": e.token, "x-nos-entity-type": "json" } : null;
    }, o.deleteFile = function (e) {
      a.verifyParamPresentJustOne(e, "docId", "msg::deleteFile"), this.removeFile({ docId: e.docId, callback: function callback(t, n) {
          t ? e.error && e.error(t, n) : e.success && e.success(n);
        } });
    }, o.getFile = function (e) {
      a.verifyParamPresentJustOne(e, "docId", "msg::getFile"), this.fetchFile({ docId: e.docId, callback: function callback(t, n) {
          t ? e.error && e.error(t, n) : e.success && e.success(n.info);
        } });
    }, o.getFileList = function (e) {
      var t = e.fromDocId,
          n = void 0 === t ? "" : t,
          r = e.limit,
          s = void 0 === r ? 10 : r,
          i = { limit: s };n && (i.fromDocId = n), this.fetchFileList({ fileListParam: i, callback: function callback(t, n) {
          t ? (s > 30 && (t.message = t.message + "::文档条数超过限制:30"), e.error && e.error(t, n)) : e.success && e.success(n);
        } });
    }, o.sendGeo = function (e) {
      return this.processCallback(e), e.msg = new this.message.GeoMessage(e), this.sendMsg(e);
    }, o.sendTipMsg = function (e) {
      return this.processCallback(e), e.msg = new this.message.TipMessage(e), this.sendMsg(e);
    }, o.sendCustomMsg = function (e) {
      return this.processCallback(e), e.msg = new this.message.CustomMessage(e), this.sendMsg(e);
    }, o.sendRobotMsg = function (e) {
      return this.processCallback(e), e.msg = new this.message.RobotMessage(e), this.sendMsg(e);
    }, o.sendMsg = function (e, t) {
      var n = this.protocol,
          r = e.msg,
          s = {},
          i = !!e.isLocal;if (i && (e.time && (r.time = e.time), e.idClient && (r.idClient = e.idClient)), e.resend && ("out" !== e.flow || "fail" !== e.status)) return a.onError("只能重发发送失败的消息");e.callback.options.idClient = r.idClient, this.beforeSendMsg(e, s);var o = e.rtnMsg = this.formatReturnMsg(r);return t && !this.options.keepNosSafeUrl && o.file && (o.file._url_safe = o.file.url, o.file.url = t, "audio" === o.type && (o.file.mp3Url = t + (~t.indexOf("?") ? "&" : "?") + "audioTrans&type=mp3")), o.hasOwnProperty("chatroomId") && !o.chatroomId ? a.onError("聊天室未连接") : (i && (o.status = "success", o.isLocal = !0), n.storeSendMsg && (s.promise = n.storeSendMsg(o)), e.cbaop = function (e) {
        if (e && "server" !== e.from) return o.status = "fail", n.updateSendMsgError && n.updateSendMsgError(o), o;
      }, i || (t && !this.options.keepNosSafeUrl && e.callback && (e.callback.originUrl = t), s.msg = r, this.sendCmd(e.cmd, s, e.callback)), this.afterSendMsg(e), i && setTimeout(function () {
        o = a.simpleClone(o), e.done(null, o);
      }, 0), a.copy(o));
    }, o.beforeSendMsg = function () {}, o.afterSendMsg = function () {}, o.formatReturnMsg = function (e) {
      return e = a.copy(e), this.protocol.completeMsg(e), e.status = "sending", e = this.message.reverse(e);
    }, o.resendMsg = function (e) {
      return a.verifyOptions(e, "msg", "msg::resendMsg"), this.trimMsgFlag(e), e.resend = !0, this._sendMsgByType(e);
    }, o.forwardMsg = function (e) {
      return a.verifyOptions(e, "msg", "msg::forwardMsg"), this.trimMsgFlag(e), this.beforeForwardMsg(e), e.forward = !0, e.msg.idClient = a.guid(), this._sendMsgByType(e);
    }, o.trimMsgFlag = function (e) {
      e && e.msg && (e.msg = a.copy(e.msg), delete e.msg.resend, delete e.msg.forward);
    }, o.beforeForwardMsg = function () {}, o._sendMsgByType = function (e) {
      switch (a.verifyOptions(e, "msg", "msg::_sendMsgByType"), a.verifyParamValid("msg.type", e.msg.type, this.message.validTypes, "msg::_sendMsgByType"), a.merge(e, e.msg), e.type) {case "text":
          return this.sendText(e);case "image":case "audio":case "video":case "file":
          return this.sendFile(e);case "geo":
          return this.sendGeo(e);case "custom":
          return this.sendCustomMsg(e);case "tip":
          return this.sendTipMsg(e);default:
          throw new u("不能发送类型为 " + e.type + " 的消息");}
    }, o.parseRobotTemplate = function (e) {
      if (/<template[^>\/]+\/>/.test(e)) return { raw: e, json: [{ type: "text", name: "", text: "" }] };if (!/<template[^>\/]+>/.test(e)) return { raw: e, json: [{ type: "text", name: "", text: e }] };var t = new c({ escapeMode: !1 });e = e.replace(/<template [^>]+>/, "<template>");var n = t.xml2js(e);n = n.template.LinearLayout, Array.isArray(n) || (n = [n]);var r = [];return n = n.forEach(function (e) {
        e.image && (r = r.concat(i(e))), e.text && (r = r.concat(s(e))), e.link && (r = r.concat(function (e) {
          if (e.link) {
            var t = e.link;Array.isArray(t) || (t = [t]), t = t.map(function (e) {
              return e.image && (e.image = i(e)), e.text && (e.text = s(e)), "url" === e._type ? (e.type = "url", e.style = e._style || "", e.target = e._target, delete e._target, delete e._style) : "block" === e._type && (e.type = "block", e.style = e._style || "", e.params = e._params || "", e.target = e._target, delete e._params, delete e._target, delete e._style), delete e._type, e;
            }), e.link = t;
          }return e.link;
        }(e)));
      }), { raw: e, json: r };function s(e) {
        return Array.isArray(e.text) || (e.text = [e.text]), e.text = e.text.map(function (e) {
          return { type: "text", name: e._name, text: e.__text };
        }), e.text;
      }function i(e) {
        return Array.isArray(e.image) || (e.image = [e.image]), e.image = e.image.map(function (e) {
          return { type: "image", name: e._name, url: e._url };
        }), e.image;
      }
    };
  }, function (e, t, n) {
    "use strict";
    var r = n(47).fn;r.isConnected = function () {
      return !!this.protocol && this.protocol.isConnected();
    }, r.connect = function () {
      this.protocol.appLogin = 0, this.protocol.connect(!0);
    }, r.disconnect = function (e) {
      e = e || {}, this.protocol.disconnect(e.done);
    };
  }, function (e, t, n) {
    "use strict";
    var r = n(22),
        s = n(0);n(36);function i() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};s.merge(this, { options: e, debug: !1, api: "log", style: "color:blue;", log: s.emptyFunc, info: s.emptyFunc, warn: s.emptyFunc, error: s.emptyFunc }), this.prefix = e.prefix || "", this.setDebug(e.debug);
    }var o = i.prototype,
        a = ["Chrome", "Safari", "Firefox"];o.setDebug = function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
          t = this;if (t.debug = e, e.style && (t.style = e.style), t.debug && s.exist(console)) {
        var n = console;t.debug = function () {
          var e = t.formatArgs(arguments);-1 !== a.indexOf(r.name) && s.isString(e[0]) && (e[0] = "%c" + e[0], e.splice(1, 0, t.style)), t._log("debug", e);
        }, t.log = function () {
          var e = t.formatArgs(arguments);-1 !== a.indexOf(r.name) && s.isString(e[0]) && (e[0] = "%c" + e[0], e.splice(1, 0, t.style)), t._log("log", e);
        }, t.info = function () {
          var e = t.formatArgs(arguments);-1 !== a.indexOf(r.name) && s.isString(e[0]) && (e[0] = "%c" + e[0], e.splice(1, 0, t.style)), t._log("info", e);
        }, t.warn = function () {
          var e = t.formatArgs(arguments);-1 !== a.indexOf(r.name) && s.isString(e[0]) && (e[0] = "%c" + e[0], e.splice(1, 0, t.style)), t._log("warn", e);
        }, t.error = function () {
          var e = t.formatArgs(arguments);-1 !== a.indexOf(r.name) && s.isString(e[0]) && (e[0] = "%c" + e[0], e.splice(1, 0, t.style)), t._log("error", e);
        }, t._log = function (e, r) {
          var i = t.options.logFunc,
              o = null;if (i && (i[e] && (o = i[e]), s.isFunction(o))) o.apply(i, r);else if (n[e]) try {
            n[e].apply ? t.chrome(e, r) : t.ie(e, r);
          } catch (e) {}
        }, t.chrome = function (e, s) {
          -1 !== a.indexOf(r.name) ? n[e].apply(n, s) : t.ie(e, s);
        }, t.ie = function (e, t) {
          t.forEach(function (t) {
            n[e](__WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_json_stringify___default()(t, null, 4));
          });
        };
      }
    }, o.formatArgs = function (e) {
      e = [].slice.call(e, 0);var t = new Date(),
          n = "[NIM LOG " + (c(t.getMonth() + 1) + "-" + c(t.getDate()) + " " + c(t.getHours()) + ":" + c(t.getMinutes()) + ":" + c(t.getSeconds()) + ":" + c(t.getMilliseconds(), 3)) + " " + this.prefix.toUpperCase() + "]  ";return s.isString(e[0]) ? e[0] = n + e[0] : e.splice(0, 0, n), e.forEach(function (t, n) {
        (s.isArray(t) || s.isObject(t)) && (e[n] = s.simpleClone(t));
      }), e;
    };var c = function c(e, t) {
      t = t || 2;for (var n = "" + e; n.length < t;) {
        n = "0" + n;
      }return n;
    };e.exports = i;
  },,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,, function (e, t, n) {
    "use strict";
    var r = n(0),
        s = r.notundef;function i(e) {
      r.verifyOptions(e, "type", "event::MsgEventSubscribe"), r.verifyParamType("type", e.type, "number", "event::MsgEventSubscribe"), r.findObjIndexInArray([1, 2, 3], e.type) < 0 && r.verifyParamMin("type", e.type, 1e5, "event::MsgEventSubscribe"), this.type = e.type, s(e.subscribeTime) ? (r.verifyParamType("subscribeTime", e.subscribeTime, "number", "event::MsgEventSubscribe"), r.verifyParamMin("subscribeTime", e.subscribeTime, 60, "event::MsgEventSubscribe"), r.verifyParamMax("subscribeTime", e.subscribeTime, 2592e3, "event::MsgEventSubscribe"), this.subscribeTime = e.subscribeTime) : this.subscribeTime = 2592e3, s(e.sync) ? (r.verifyParamType("sync", e.sync, "boolean", "event::MsgEventSubscribe"), this.sync = e.sync) : this.sync = !0;
    }i.prototype.assembleEvent = function (e) {
      return { type: this.type, subscribeTime: this.subscribeTime, sync: !0 === this.sync ? 1 : 0 };
    }, e.exports = i;
  }, function (e, t, n) {
    "use strict";
    var r = n(0),
        s = r.notundef,
        i = n(26);function o(e) {
      if (r.verifyOptions(e, "type value", "event::MsgEvent"), r.verifyParamType("type", e.type, "number", "event::MsgEvent"), r.verifyParamType("value", e.value, "number", "event::MsgEvent"), this.type = e.type, this.value = e.value, this.idClient = r.guid(), s(e.custom) && (this.custom = "" + e.custom), this.validTime = e.validTime || 604800, r.verifyParamType("validTime", this.validTime, "number", "event::MsgEvent"), r.verifyParamMin("validTime", this.validTime, 60, "event::MsgEvent"), r.verifyParamMax("validTime", this.validTime, 604800, "event::MsgEvent"), s(e.broadcastType)) {
        if (r.verifyParamType("broadcastType", e.broadcastType, "number", "event::MsgEvent"), [1, 2].indexOf(e.broadcastType) < 0) throw new i('参数错误"broadcastType":只能为1或2');this.broadcastType = e.broadcastType;
      } else this.broadcastType = 2;s(e.sync) ? (r.verifyParamType("sync", e.sync, "boolean", "event::MsgEvent"), this.sync = e.sync) : this.sync = !1;
    }o.prototype.assembleEvent = function () {
      return { type: this.type, value: this.value, idClient: this.idClient, custom: this.custom || "", validTime: this.validTime, broadcastType: this.broadcastType, sync: !0 === this.sync ? 1 : 0 };
    }, e.exports = o;
  }, function (e, t, n) {
    "use strict";
    var r,
        s = n(9),
        i = (r = s) && r.__esModule ? r : { default: r };var o = n(32).fn,
        a = n(0),
        c = n(385),
        u = n(384);function l(e) {
      return "object" === (void 0 === e ? "undefined" : (0, i["default"])(e)) && (e.msgEventSubscribes ? e = e.msgEventSubscribes : e.msgEventSubscribe ? e = e.msgEventSubscribe : e.accounts ? e = e.accounts : e.msgEvent && (e = e.msgEvent).time && (e.time = +e.time), 1 === e.sync ? e.sync = !0 : 0 === e.sync && (e.sync = !1)), e;
    }o.batchSendEventsCmds = function (e, t, n) {
      var r = this,
          s = a.dropArrayDuplicates(t.accounts);s = a.reshape2d(s, 100);var i = [];s.forEach(function (n) {
        i.push(new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a(function (s, i) {
          var o = a.simpleClone(t);o.accounts = n, r.sendCmdWithResp(e, o, function (e, t) {
            e ? i(e) : s(l(t));
          });
        }));
      }), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.all(i).then(function (e) {
        var t = null;if (e.length > 0) if (e[0].msgEventSubscribe) {
          var r = e[0].msgEventSubscribe;r = l(r);var s = [];e.forEach(function (e) {
            s = s.concat(e.accounts);
          }), t = { accounts: s, msgEventSubscribe: r };
        } else t = [], e.forEach(function (e) {
          t = t.concat(e);
        });n(null, t);
      }, function (e) {
        n(e, null);
      });
    }, o.publishEvent = function (e) {
      var t = new c(e);t = t.assembleEvent(), this.processCallback(e), this.sendCmdWithResp("publishEvent", { msgEvent: t }, function (t, n) {
        t || (n = l(n)), e.callback(t, n);
      });
    }, o.subscribeEvent = function (e) {
      a.verifyOptions(e, "accounts", "event::subscribeEvent");var t = new u(e);a.verifyParamType("accounts", e.accounts, "array", "event::subscribeEvent"), this.processCallback(e), t = t.assembleEvent(), this.batchSendEventsCmds("subscribeEvent", { msgEventSubscribe: t, accounts: e.accounts }, function (t, n) {
        !t && n && (n = { failedAccounts: n }), e.callback(t, n);
      });
    }, o.unSubscribeEventsByAccounts = function (e) {
      a.verifyOptions(e, "accounts", "event::unSubscribeEventsByAccounts"), a.verifyParamType("accounts", e.accounts, "array", "event::unSubscribeEventsByAccounts");var t = new u(e);t = t.assembleEvent(), this.processCallback(e), this.batchSendEventsCmds("unSubscribeEventsByAccounts", { msgEventSubscribe: t, accounts: e.accounts }, function (t, n) {
        !t && n && (n = { failedAccounts: n }), e.callback(t, n);
      });
    }, o.unSubscribeEventsByType = function (e) {
      var t = new u(e);t = t.assembleEvent(), this.processCallback(e), this.sendCmdWithResp("unSubscribeEventsByType", { msgEventSubscribe: t }, function (t, n) {
        e.callback(t);
      });
    }, o.querySubscribeEventsByAccounts = function (e) {
      a.verifyOptions(e, "accounts", "event::querySubscribeEventsByAccounts"), a.verifyParamType("accounts", e.accounts, "array", "event::querySubscribeEventsByAccounts");var t = new u(e);t = t.assembleEvent(), this.processCallback(e), this.batchSendEventsCmds("querySubscribeEventsByAccounts", { msgEventSubscribe: t, accounts: e.accounts }, function (t, n) {
        !t && n && (n = { msgEventSubscribes: n }), e.callback(t, n);
      });
    }, o.querySubscribeEventsByType = function (e) {
      var t = new u(e);t = t.assembleEvent(), this.processCallback(e), this.sendCmdWithResp("querySubscribeEventsByType", { msgEventSubscribe: t }, function (t, n) {
        t || (n = { msgEventSubscribes: l(n) }), e.callback(t, n);
      });
    };
  }, function (e, t, n) {
    "use strict";
    var r = n(32).fn,
        s = n(170),
        i = n(0),
        o = i.undef;r.getPushNotificationMultiportConfig = function () {
      return this.protocol.getPushNotificationMultiportConfig();
    }, r.updatePushNotificationMultiportConfig = function (e) {
      i.verifyOptions(e), o(e.shouldPushNotificationWhenPCOnline) && (e.shouldPushNotificationWhenPCOnline = !0), e.donnop = new s(e), this.processCallback(e), this.sendCmd("updateDonnop", e);
    };
  }, function (e, t, n) {
    "use strict";
    var r = n(32).fn;r.clearDB = function (e) {
      var t = this.db;this.processCallback(e);var n = e.done;t.enable ? t.clear().then(n, n) : n();
    }, r.removeDB = function (e) {
      var t = this.db;this.processCallback(e);var n = e.done;t.enable ? t.destroy().then(n, n) : n();
    }, r.closeDB = function (e) {
      var t = this.db;this.processCallback(e);var n = e.done;t.enable ? t.close().then(n, n) : n();
    };
  }, function (e, t, n) {
    "use strict";
    var r = n(32).fn,
        s = n(0);r.audioToText = function (e) {
      s.verifyOptions(e, "url", "audio::audioToText"), e.audioToText = s.filterObj(e, "url");this.processCallback(e), this.sendCmd("audioToText", e);
    };
  }, function (e, t, n) {
    "use strict";
  }, function (e, t, n) {
    "use strict";
  }, function (e, t, n) {
    "use strict";
    var r = n(32).fn,
        s = n(0),
        i = n(2);r.getChatroomAddress = function (e) {
      s.verifyOptions(e, "chatroomId", "chatroom::getChatroomAddress");e.isWeixinApp = i.isWeixinApp, this.processCallback(e), this.sendCmd("getChatroomAddress", e);
    };
  }, function (e, t, n) {
    "use strict";
    var r = n(32).fn,
        s = n(0),
        i = s.undef,
        o = s.notundef,
        a = n(117);r.markSysMsgRead = function (e) {
      var t,
          n = this.db,
          r = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve(),
          i = this.protocol;s.verifyOptions(e, "sysMsgs", "sysmsg::markSysMsgRead");var o = e.sysMsgs;function a() {
        e.done(t, e);
      }s.isArray(o) || (o = [o]), n.enable ? r = n.markSysMsgRead(o).then(function (e) {
        o = e, i.onUpdateSysMsg(e);
      }) : (o = o.filter(function (e) {
        return !e.read;
      })).length && (i.options.autoMarkRead || i.markSysMsgRead(o, !0), o.forEach(function (e) {
        e.read = !0;
      }), i.onUpdateSysMsg(o)), r.then(function () {
        return i.reduceSysMsgUnread(o);
      }).then(a, function (e) {
        t = e, a();
      });
    }, r.sendCustomSysMsg = function (e) {
      s.verifyOptions(e, "scene to content", "sysmsg::sendCustomSysMsg"), s.verifyParamValid("scene", e.scene, this.message.validScenes, "sysmsg::sendCustomSysMsg"), this.processCallback(e), "p2p" === e.scene ? e.type = "customP2p" : e.type = "customTeam", e.sysMsg = new a(e);var t = "sendCustomSysMsg";return e.filter && (t = "sendFilterCustomSysMsg"), this.sendCmd(t, { sysMsg: e.sysMsg, single: !0 }, e.callback), this.formatReturnSysMsg(e.sysMsg);
    }, r.formatReturnSysMsg = function (e) {
      return e = s.copy(e), this.protocol.completeSysMsg(e), e.status = "sending", e = a.reverse(e);
    }, r.getLocalSysMsgs = function (e) {
      var t,
          n = this.db,
          r = [];function c() {
        e.sysMsgs = r, e.done(t, e);
      }s.verifyOptions(e), e.category && s.verifyParamValid("category", e.category, a.validCategories, "sysmsg::getLocalSysMsgs"), e.type && s.verifyParamValid("type", e.type, a.validTypes, "sysmsg::getLocalSysMsgs"), i(e.limit) && (e.limit = 100), s.verifyParamType("limit", e.limit, "number", "sysmsg::getLocalSysMsgs"), s.verifyParamMax("limit", e.limit, 100, "sysmsg::getLocalSysMsgs"), o(e.reverse) ? s.verifyParamType("reverse", e.reverse, "boolean", "sysmsg::getLocalSysMsgs") : e.reverse = !1, this.processCallback(e), n.enable ? n.getSysMsgs(e).then(function (e) {
        r = e, c();
      }, function (e) {
        t = e, c();
      }) : c();
    }, r.updateLocalSysMsg = function (e) {
      var t,
          n = this.db,
          r = null;if (s.verifyOptions(e, "idServer", "sysmsg::updateLocalSysMsg"), this.processCallback(e), n.enable) {
        var i = s.filterObj(e, "idServer state localCustom");n.updateSysMsg(i).then(function (e) {
          r = e, o();
        }, function (e) {
          t = e, o();
        });
      } else o();function o() {
        e.sysMsg = r, e.done(t, e);
      }
    }, r.deleteLocalSysMsg = function (e) {
      var t,
          n = this.db;function r() {
        e.done(t, e);
      }s.verifyOptions(e, "idServer", "sysmsg::deleteLocalSysMsg"), this.processCallback(e), n.enable ? n.deleteSysMsg(e.idServer).then(function () {
        r();
      }, function (e) {
        t = e, r();
      }) : r();
    }, r.deleteAllLocalSysMsgs = function (e) {
      var t,
          n = this,
          r = n.db;function s() {
        n.protocol.onUpdateSysMsgUnread({}), e.done(t, e);
      }n.processCallback(e), r.enable && r.deleteAllSysMsgs().then(function () {
        s();
      }, function (e) {
        t = e, s();
      });
    };
  }, function (e, t, n) {
    "use strict";
    var r = n(32).fn,
        s = n(0),
        i = s.undef,
        o = s.notundef,
        a = n(54),
        c = n(116),
        u = n(117),
        l = n(26);r.beforeSendMsg = function (e) {
      var t,
          n = this.protocol,
          r = e.msg;switch (r.to === this.account && (r.fromDeviceId = a.deviceId), r.userUpdateTime = n.myInfo && n.myInfo.updateTime, r.getScene()) {case "p2p":
          t = "sendMsg";break;case "team":
          t = "sendTeamMsg";}e.filter && (t = "sendFilterMsg", r.filter = !0), e.cmd = t;
    }, r.afterSendMsg = function (e) {
      var t = e.rtnMsg,
          n = c.genSessionByMsg(t);this.protocol.onUpdateSession(n);
    }, r.beforeForwardMsg = function (e) {
      s.verifyOptions(e, "msg scene to", "msg::beforeForwardMsg"), e.msg.scene = e.scene, e.msg.to = e.to;
    }, r.markMsgRead = function (e) {
      var t = this.protocol;!e || this.db.enable || t.options.autoMarkRead ? this.logger.warn("api::markMsgRead: 不需要标记消息为已收到 (没有消息, 或者启用了数据库, 或者启用了自动标记已收到)") : t.markMsgRead(e, !0);
    }, r.sendMsgReceipt = function (e) {
      if (s.verifyOptions(e), this.processCallback(e), e.msg) {
        s.verifyOptions(e, "msg", "msg::sendMsgReceipt");var t = e.msg;s.verifyOptions(t, "target idClient time", !0, "msg.", "msg::sendMsgReceipt"), this.protocol.shouldSendMsgReceipt(t) ? this.sendCmd("sendMsgReceipt", { msgReceipt: { to: t.target, idClient: t.idClient, time: t.time } }, e.callback) : e.done();
      } else e.done();
    }, r.isMsgRemoteRead = function (e) {
      return this.protocol.isMsgRemoteRead(e);
    }, r.deleteMsg = function (e) {
      s.verifyOptions(e, "msg", "msg::deleteMsg");var t = e.msg;if ("team" !== t.scene && "out" !== t.flow || "success" !== t.status || t.from === t.to || t.isLocal) return e.done(l.newParamError("只能删除自己发送给别人的, 并且发送成功的非本地消息", { callFunc: "msg::deleteMsg" }), e);s.verifyOptions(t, ["scene", "to", "from", "time", "idClient", "idServer"], !0, "msg.", "msg::deleteMsg"), s.verifyParamValid("msg.scene", t.scene, this.message.validScenes, "msg::deleteMsg");var n = s.simpleClone(t);this.processPs(n), this.processCallback(e), o(e.opeAccount) ? n.opeAccount = e.opeAccount : i(n.opeAccount) && (n.opeAccount = n.from), "p2p" === n.scene ? n.type = "deleteMsgP2p" : n.type = "deleteMsgTeam", n.deletedIdClient = n.idClient, n.deletedIdServer = n.idServer, n = new u(n), this.sendCmd("deleteMsg", { sysMsg: n, msg: t }, e.callback);
    };var m = { text: 0, image: 1, audio: 2, video: 3, geo: 4, notification: 5, file: 6, tip: 10, robot: 11, custom: 100 };r.getHistoryMsgs = function (e) {
      var t;switch (s.verifyOptions(e, "scene to", "msg::getHistoryMsgs"), s.verifyParamValid("scene", e.scene, this.message.validScenes, "msg::getHistoryMsgs"), void 0 === e.beginTime && (e.beginTime = 0), s.verifyParamType("beginTime", e.beginTime, "number", "msg::getHistoryMsgs"), void 0 === e.endTime && (e.endTime = 0), s.verifyParamType("endTime", e.endTime, "number", "msg::getHistoryMsgs"), void 0 !== e.lastMsgId && null !== e.lastMsgId || (e.lastMsgId = "0"), void 0 === e.limit && (e.limit = 100), s.verifyParamType("limit", e.limit, "number", "msg::getHistoryMsgs"), s.verifyParamMax("limit", e.limit, 100, "msg::getHistoryMsgs"), o(e.reverse) ? s.verifyParamType("reverse", e.reverse, "boolean", "msg::getHistoryMsgs") : e.reverse = !1, o(e.asc) ? s.verifyParamType("asc", e.asc, "boolean", "msg::getHistoryMsgs") : e.asc = !1, i(e.msgTypes) ? e.msgTypes = [] : Array.isArray(e.msgTypes) ? (e.msgTypes = e.msgTypes.map(function (e) {
        return m[e];
      }), e.msgTypes = e.msgTypes.filter(function (e) {
        return "number" == typeof e;
      })) : "number" == typeof m[e.msgTypes] ? e.msgTypes = [m[e.msgTypes]] : e.msgTypes = [], this.processCallback(e), e.asc && (e.cbaop = function (e, t) {
        e || (t.msgs = t.msgs.reverse());
      }), e.scene) {case "p2p":
          t = "getHistoryMsgs";break;case "team":
          t = "getTeamHistoryMsgs";}var n = { scene: e.scene, to: e.to, beginTime: e.beginTime, endTime: e.endTime, lastMsgId: e.lastMsgId, limit: e.limit, reverse: e.reverse, msgTypes: e.msgTypes };this.sendCmd(t, n, e.callback);
    }, r.searchHistoryMsgs = function (e) {
      var t;switch (s.verifyOptions(e, "scene to keyword", "msg::searchHistoryMsgs"), s.verifyParamValid("scene", e.scene, this.message.validScenes, "msg::searchHistoryMsgs"), void 0 === e.beginTime && (e.beginTime = 0), s.verifyParamType("beginTime", e.beginTime, "number", "msg::searchHistoryMsgs"), void 0 === e.endTime && (e.endTime = 0), s.verifyParamType("endTime", e.endTime, "number", "msg::searchHistoryMsgs"), void 0 === e.limit && (e.limit = 100), s.verifyParamType("limit", e.limit, "number", "msg::searchHistoryMsgs"), s.verifyParamMax("limit", e.limit, 100, "msg::searchHistoryMsgs"), o(e.reverse) ? s.verifyParamType("reverse", e.reverse, "boolean", "msg::searchHistoryMsgs") : e.reverse = !1, o(e.asc) ? s.verifyParamType("asc", e.asc, "boolean", "msg::searchHistoryMsgs") : e.asc = !1, this.processCallback(e), e.asc && (e.cbaop = function (e, t) {
        e || (t.msgs = t.msgs.reverse());
      }), e.scene) {case "p2p":
          t = "searchHistoryMsgs";break;case "team":
          t = "searchTeamHistoryMsgs";}var n = s.filterObj(e, "scene to beginTime endTime keyword limit reverse");this.sendCmd(t, n, e.callback);
    }, r.getLocalMsgs = function (e) {
      var t = this.db,
          n = null,
          r = [];s.verifyOptions(e);var a = !1;o(e.start) && (a = !0, s.verifyParamType("start", e.start, "number", "msg::getLocalMsgs"));var c = !1;function u() {
        var t = s.simpleClone(e);t.msgs = r, delete t.callback, delete t.done, e.done(n, t);
      }o(e.end) && (c = !0, s.verifyParamType("end", e.end, "number", "msg::getLocalMsgs")), a && c && e.end <= e.start && s.onParamError("参数 end 必须晚于 start"), i(e.limit) && (e.limit = 100), s.verifyParamType("limit", e.limit, "number", "msg::getLocalMsgs"), s.verifyParamMin("limit", e.limit, 1, "msg::getLocalMsgs"), this.processCallback(e), t.enable ? t.getMsgs(e).then(function (e) {
        r = e, u();
      }, function (e) {
        (e = e || {}).message = e.message || "msg::getLocalMsgs:db error", u();
      }) : u();
    }, r.getLocalMsgByIdClient = function (e) {
      var t,
          n = this.db,
          r = null;function i() {
        e.msg = r, e.done(t, e);
      }s.verifyOptions(e, "idClient", "msg::getLocalMsgByIdClient"), this.processCallback(e), n.enable ? n.getMsgByIdClient(e.idClient).then(function (e) {
        e && (r = e), i();
      }, function (e) {
        t = e, i();
      }) : i();
    }, r.getLocalMsgsByIdClients = function (e) {
      var t,
          n = this.db,
          r = [];function i() {
        e.msgs = r, e.done(t, e);
      }s.verifyOptions(e, "idClients", "msg::getLocalMsgByIdClient"), s.verifyParamType("idClients", e.idClients, "array", "msg::getLocalMsgByIdClient"), this.processCallback(e), n.enable ? n.getMsgsByIdClients(e.idClients).then(function (e) {
        r = e.filter(function (e) {
          return !!e;
        }), i();
      }, function (e) {
        t = e, i();
      }) : i();
    }, r.updateLocalMsg = function (e) {
      var t,
          n = this.db,
          r = null;if (s.verifyOptions(e, "idClient", "msg::updateLocalMsg"), this.processCallback(e), n.enable) {
        var i = s.filterObj(e, "idClient localCustom");n.updateMsg(i).then(function (e) {
          r = e, o();
        }, function (e) {
          t = e, o();
        });
      } else o();function o() {
        e.msg = r, e.done(t, e);
      }
    }, r.deleteLocalMsg = function (e) {
      var t;s.verifyOptions(e, "msg", "msg::deleteLocalMsg");var n = e.msg;function r() {
        e.done(t, e);
      }s.verifyOptions(n, "idClient sessionId", !0, "msg.", "msg::deleteLocalMsg"), this.processCallback(e), this.protocol.deleteLocalMsg(n).then(r, function (e) {
        t = e, r();
      });
    }, r.deleteLocalMsgsBySession = function (e) {
      var t,
          n = this.db;function r() {
        e.done(t, e);
      }s.verifyOptions(e, "scene to", "msg::deleteLocalMsgsBySession"), s.verifyParamValid("scene", e.scene, this.message.validScenes, "msg::deleteLocalMsgsBySession"), e.sessionId = e.scene + "-" + e.to, this.processCallback(e), n.enable ? n.deleteMsgsBySessionId(e.sessionId).then(function () {
        r();
      }, function (e) {
        t = e, r();
      }) : r();
    }, r.deleteAllLocalMsgs = function (e) {
      var t,
          n = this.db;function r() {
        e.done(t, e);
      }this.processCallback(e), n.enable && n.deleteAllMsgs().then(function () {
        r();
      }, function (e) {
        t = e, r();
      });
    };
  }, function (e, t, n) {
    "use strict";
    var r = n(32).fn,
        s = n(0),
        i = s.undef,
        o = s.notundef;r.setCurrSession = function (e) {
      this.resetSessionUnread(e), this.protocol.setCurrSession(e);
    }, r.resetAllSessionUnread = function () {
      for (var e in this.protocol.sessionSet) {
        this.protocol.sessionSet[e].unread > 0 && this.resetSessionUnread(e);
      }
    }, r.resetSessionUnread = function (e) {
      if (this.protocol.resetSessionUnread(e), this.options.syncSessionUnread) {
        var t = this.protocol.findSession(e);if (t) {
          if (t.lastMsg) {
            if (t.scene && t.to) {
              var n = t.lastMsg.time;if (t && t.ack && t.ack >= n) this.logger.warn("api::resetSessionUnread: session ack not needs " + e);else {
                var r = { scene: "p2p" === t.scene ? 0 : 1, to: t.to, timetag: n };this.sendCmd("markSessionAck", r);
              }
            } else this.logger.warn("api::resetSessionUnread: session.scene|to undefined " + e);
          } else this.logger.warn("api::resetSessionUnread: session.lastMsg undefined " + e);
        } else this.logger.warn("api::resetSessionUnread: session undefined " + e);
      }
    }, r.resetCurrSession = function () {
      this.protocol.setCurrSession("");
    }, r.insertLocalSession = function (e) {
      var t, n;function r() {
        e.session = n, e.done(t, e);
      }s.verifyOptions(e, "scene to", "scene::insertLocalSession"), s.verifyParamValid("scene", e.scene, this.message.validScenes, "scene::insertLocalSession"), this.processCallback(e), this.protocol.insertLocalSession(e).then(function (e) {
        n = e, r();
      }, function (e) {
        t = e, r();
      });
    }, r.getLocalSessions = function (e) {
      var t,
          n = this,
          r = n.db,
          a = [];function c() {
        e.sessions = a, e.done(t, e);
      }s.verifyOptions(e), i(e.limit) && (e.limit = 100), s.verifyParamType("limit", e.limit, "number", "scene::getLocalSessions"), s.verifyParamMax("limit", e.limit, 100, "scene::getLocalSessions"), o(e.reverse) ? s.verifyParamType("reverse", e.reverse, "boolean", "scene::getLocalSessions") : e.reverse = !1, n.processCallback(e), r.enable ? r.getSessions(e).then(function (e) {
        a = e, n.protocol.mergeSessions(a), c();
      }, function (e) {
        t = e, c();
      }) : c();
    }, r.getLocalSession = function (e) {
      var t,
          n = this.db,
          r = null;if (s.verifyOptions(e, "sessionId", "scene::getLocalSession"), s.verifyParamType("sessionId", e.sessionId, "string", "scene::getLocalSession"), n.enable) return this.processCallback(e), void n.getSession(e.sessionId).then(function (e) {
        e && (r = e), i();
      }, function (e) {
        t = e, i();
      });function i() {
        e.done(t, r);
      }this.protocol.sessionSet && this.protocol.sessionSet[e.sessionId] && (r = this.protocol.sessionSet[e.sessionId]), i();
    }, r.updateLocalSession = function (e) {
      var t,
          n = this,
          r = n.db;s.verifyOptions(e, "id", "scene::updateLocalSession"), n.processCallback(e);var i = s.filterObj(e, "id localCustom");function o() {
        n.protocol.onUpdateSession(i), e.session = i, e.done(t, e);
      }r.enable ? r.updateSession(i).then(function (e) {
        i = e, o();
      }, function (e) {
        t = e, o();
      }) : o();
    }, r.deleteLocalSession = function (e) {
      var t,
          n = this,
          r = n.db;function i() {
        e.done(t, e);
      }s.verifyOptions(e, "id", "session::deleteLocalSession"), n.processCallback(e), r.enable ? r.deleteSession(e.id).then(function () {
        n.protocol.deleteLocalSession(e.id), i();
      }, function (e) {
        t = e, i();
      }) : i();
    }, r.deleteSession = function (e) {
      s.verifyOptions(e, "scene to", "session::deleteSession"), this.processCallback(e), e.sessions = [{ scene: e.scene, to: e.to }], this.deleteSessions(e);
    }, r.deleteSessions = function (e) {
      s.verifyOptions(e, "sessions", "session::deleteSessions"), s.verifyParamType("sessions", e.sessions, "array", "session::deleteSessions"), e.sessions.forEach(function (e, t) {
        s.verifyOptions(e, "scene to", !0, "sessions[" + t + "].", "session::deleteSessions");
      }), this.processCallback(e), this.sendCmd("deleteSessions", { sessions: e.sessions.map(function (e) {
          return e.scene + "|" + e.to;
        }) }, e.callback);
    };
  }, function (e, t, n) {
    "use strict";
    var r = n(32).fn,
        s = n(0),
        i = s.undef,
        o = n(119),
        a = n(86);r.createTeam = function (e) {
      s.verifyOptions(e, "type name", "team::createTeam"), i(e.accounts) ? e.accounts = [] : s.verifyParamType("accounts", e.accounts, "array", "team::createTeam"), e.action = "create", this.processPs(e), this.processCallback(e), e.team = new o(e);var t = { team: e.team, accounts: e.accounts.slice(0), ps: e.ps };this.sendCmd("createTeam", t, e.callback);
    }, r.updateTeam = function (e) {
      s.verifyOptions(e, "teamId", "team::updateTeam"), e.action = "update", this.processCallback(e), e.team = new o(e), this.sendCmd("updateTeam", { team: e.team, single: !0 }, e.callback);
    }, r.addTeamMembers = function (e) {
      s.verifyOptions(e, "teamId accounts", "team::addTeamMembers"), s.verifyParamType("accounts", e.accounts, "array", "team::addTeamMembers"), this.processPs(e), s.notexist(e.custom) && (e.custom = ""), this.processCallback(e);var t = { teamId: e.teamId, accounts: e.accounts.slice(0), ps: e.ps, attach: e.custom };this.sendCmd("addTeamMembers", t, e.callback);
    }, r.removeTeamMembers = function (e) {
      s.verifyOptions(e, "teamId accounts", "team::removeTeamMembers"), s.verifyParamType("accounts", e.accounts, "array", "team::removeTeamMembers"), this.processCallback(e);var t = { teamId: e.teamId, accounts: e.accounts.slice(0) };this.sendCmd("removeTeamMembers", t, e.callback);
    }, r.acceptTeamInvite = function (e) {
      s.verifyOptions(e, "idServer teamId from", "team::acceptTeamInvite"), this.processCallback(e);var t = { idServer: e.idServer, teamId: e.teamId, from: e.from };this.sendCmd("acceptTeamInvite", t, e.callback);
    }, r.rejectTeamInvite = function (e) {
      s.verifyOptions(e, "idServer teamId from", "team::rejectTeamInvite"), this.processPs(e), this.processCallback(e);var t = { idServer: e.idServer, teamId: e.teamId, from: e.from, ps: e.ps };this.sendCmd("rejectTeamInvite", t, e.callback);
    }, r.applyTeam = function (e) {
      s.verifyOptions(e, "teamId", "team::applyTeam"), this.processPs(e), this.processCallback(e);var t = { teamId: e.teamId, ps: e.ps };this.sendCmd("applyTeam", t, e.callback);
    }, r.passTeamApply = function (e) {
      s.verifyOptions(e, "idServer teamId from", "team::passTeamApply"), this.processCallback(e);var t = { idServer: e.idServer, teamId: e.teamId, from: e.from };this.sendCmd("passTeamApply", t, e.callback);
    }, r.rejectTeamApply = function (e) {
      s.verifyOptions(e, "idServer teamId from", "team::rejectTeamApply"), this.processPs(e), this.processCallback(e);var t = { idServer: e.idServer, teamId: e.teamId, from: e.from, ps: e.ps };this.sendCmd("rejectTeamApply", t, e.callback);
    }, r.addTeamManagers = function (e) {
      s.verifyOptions(e, "teamId accounts", "team::addTeamManagers"), s.verifyParamType("accounts", e.accounts, "array", "team::addTeamManagers"), this.processCallback(e);var t = { teamId: e.teamId, accounts: e.accounts.slice(0) };this.sendCmd("addTeamManagers", t, e.callback);
    }, r.removeTeamManagers = function (e) {
      s.verifyOptions(e, "teamId accounts", "team::removeTeamManagers"), s.verifyParamType("accounts", e.accounts, "array", "team::removeTeamManagers"), this.processCallback(e);var t = { teamId: e.teamId, accounts: e.accounts.slice(0) };this.sendCmd("removeTeamManagers", t, e.callback);
    }, r.updateInfoInTeam = function (e) {
      s.verifyOptions(e, "teamId", "team::updateInfoInTeam"), this.processCallback(e), this.sendCmd("updateInfoInTeam", { teamMember: new a(e), single: !0 }, e.callback);
    }, r.updateNickInTeam = function (e) {
      s.verifyOptions(e, "teamId account", "team::updateNickInTeam"), this.processCallback(e), this.sendCmd("updateNickInTeam", { teamMember: new a(e), single: !0 }, e.callback);
    }, r.updateMuteStateInTeam = function (e) {
      s.verifyOptions(e, "teamId account mute", "team::updateMuteStateInTeam"), this.processCallback(e), e.mute = e.mute ? 1 : 0, this.sendCmd("updateMuteStateInTeam", e);
    }, r.getMutedTeamMembers = function (e) {
      s.verifyOptions(e, "teamId", "team::getMutedTeamMembers"), this.processCallback(e), this.sendCmd("getMutedTeamMembers", e);
    }, r.leaveTeam = function (e) {
      s.verifyOptions(e, "teamId", "team::leaveTeam"), this.processCallback(e);var t = { teamId: e.teamId };this.sendCmd("leaveTeam", t, e.callback);
    }, r.transferTeam = function (e) {
      s.verifyOptions(e, "teamId account leave", "team::transferTeam"), s.verifyParamType("leave", e.leave, "boolean", "team::transferTeam"), this.processCallback(e);var t = { teamId: e.teamId, account: e.account, leave: e.leave };this.sendCmd("transferTeam", t, e.callback);
    }, r.dismissTeam = function (e) {
      s.verifyOptions(e, "teamId", "team::dismissTeam"), this.processCallback(e);var t = { teamId: e.teamId };this.sendCmd("dismissTeam", t, e.callback);
    }, r.getTeam = function (e) {
      var t,
          n = this,
          r = n.db;function i() {
        n.sendCmd("getTeam", { teamId: e.teamId }, e.callback);
      }s.verifyOptions(e, "teamId", "team::getTeam"), n.processCallback(e), e.cbaop = function (e, r) {
        e || n.logger.log("api::getTeam: cbaop " + t, r);
      }, t = e.teamId, r.enable && !e.sync ? r.getTeam(t).then(function (r) {
        r ? (n.logger.log("api::getTeam: db.getTeam " + t, r), e.done(null, r)) : i();
      }, i) : i();
    }, r.getTeams = function (e) {
      var t = this,
          n = t.db,
          r = 0;function i() {
        t.sendCmd("getTeams", { timetag: r, NOTSTORE: "timetag" }, e.callback);
      }s.verifyOptions(e), t.processCallback(e), n.enable ? n.getTeamsTimetag().then(function (e) {
        r = e, i();
      }, i) : i();
    }, r.getTeamMembers = function (e) {
      var t = this,
          n = 0;s.verifyOptions(e, "teamId", "team::getTeamMembers"), t.processCallback(e), t.sendCmd("getTeamMembers", { teamId: e.teamId, timetag: n, NOTSTORE: "timetag" }, e.callback);
    }, r.getTeamMemberByTeamIdAndAccount = function (e) {
      var t = this,
          n = 0;s.verifyParamType("teamId", e.teamId, "numeric or numeric string", "team::getTeamMemberByTeamIdAndAccount"), s.verifyOptions(e, "account", "team::getTeamMemberByTeamIdAndAccount"), t.processCallback(e), t.sendCmd("getTeamMembers", { teamId: e.teamId, timetag: n, NOTSTORE: "timetag" }, function (t, n, r) {
        var s = {};if (n && n.members && n.members.length) for (var i = 0; i < n.members.length; i++) {
          if (n.members[i].account === e.account) {
            s[e.account] = n.members[i];break;
          }
        }e.callback(t, s, r);
      });
    }, r.notifyForNewTeamMsg = function (e) {
      s.verifyOptions(e, "teamIds", "team::notifyForNewTeamMsg"), this.protocol.notifyForNewTeamMsg(e.teamIds).then(function (t) {
        e.done(null, t);
      }, function (t) {
        e.done(t);
      });
    }, r.getMyTeamMembers = function (e) {
      s.verifyOptions(e, "teamIds", "team::getMyTeamMembers");var t = this.processCallbackPromise(e);return this.sendCmd("getMyTeamMembers", e), t;
    }, r.getLocalTeams = function (e) {
      var t,
          n = this.db,
          r = [];function i() {
        e.teams = r, e.done(t, e);
      }s.verifyOptions(e, "teamIds", "team::getLocalTeams"), s.verifyParamType("teamIds", e.teamIds, "array", "team::getLocalTeams"), this.processCallback(e), n.enable ? n.getTeamsByTeamIds(e.teamIds).then(function (e) {
        r = e.filter(function (e) {
          return !!e;
        }), i();
      }, function (e) {
        t = e, i();
      }) : i();
    }, r.getLocalTeamMembers = function (e) {
      var t,
          n = this.db,
          r = [];function i() {
        e.members = r, e.done(t, e);
      }s.verifyOptions(e, "teamId accounts", "team::getLocalTeamMembers"), s.verifyParamType("accounts", e.accounts, "array", "team::getLocalTeamMembers"), this.processCallback(e), n.enable ? n.getInvalidTeamMembers(e.teamId, e.accounts).then(function (e) {
        r = e.filter(function (e) {
          return !!e;
        }), i();
      }, function (e) {
        t = e, i();
      }) : i();
    }, r.deleteLocalTeam = function (e) {
      var t,
          n = this.db;function r() {
        e.done(t, e);
      }s.verifyOptions(e, "teamId", "team::deleteLocalTeam"), this.processCallback(e), n.enable ? n.deleteTeam(e.teamId).then(function () {
        r();
      }, function (e) {
        t = e, r();
      }) : r();
    }, r.muteTeamAll = function (e) {
      switch (s.verifyOptions(e, "teamId type", "team::muteTeamAll"), e.type) {case "none":
          e.muteType = 0;break;case "normal":
          e.muteType = 1;break;case "all":
          e.muteType = 2;break;default:
          e.muteType = 1;}this.processCallback(e), this.sendCmd("muteTeamAll", e);
    }, r.sendTeamMsgReceipt = function (e) {
      s.verifyOptions(e, "teamMsgReceipts", "team::sendTeamMsgReceipt"), this.processCallback(e), this.sendCmd("sendTeamMsgReceipt", e);
    }, r.getTeamMsgReads = function (e) {
      s.verifyOptions(e, "teamMsgReceipts", "team::getTeamMsgReads"), this.processCallback(e), this.sendCmd("getTeamMsgReads", e);
    }, r.getTeamMsgReadAccounts = function (e) {
      s.verifyOptions(e, "teamMsgReceipt", "team::getTeamMsgReadAccounts"), this.processCallback(e), this.sendCmd("getTeamMsgReadAccounts", e);
    };
  }, function (e, t, n) {
    "use strict";
    n(32).fn.getRobots = function (e) {
      (e = e || {}).type = "getRobots", this.processCallback(e), this.sendCmd("sync", { sync: { robots: 0 } }, e.callback);
    };
  }, function (e, t, n) {
    "use strict";
    var r = n(32).fn,
        s = n(0),
        i = s.notundef,
        o = n(283);r.friendRequest = function (e) {
      s.verifyOptions(e, "type account", "friend::friendRequest"), s.verifyParamValid("type", e.type, o.validTypes(), "friend::friendRequest"), this.processPs(e), this.processCallback(e);var t = { account: e.account, type: o.getByteFromType(e.type), ps: e.ps };i(e.idServer) && (t.idServer = e.idServer), this.sendCmd("friendRequest", t, e.callback);
    }, r.addFriend = function (e) {
      e.type = "addFriend", this.friendRequest(e);
    }, r.applyFriend = function (e) {
      e.type = "applyFriend", this.friendRequest(e);
    }, r.passFriendApply = function (e) {
      s.verifyOptions(e, "idServer", "friend::passFriendApply"), e.type = "passFriendApply", this.friendRequest(e);
    }, r.rejectFriendApply = function (e) {
      s.verifyOptions(e, "idServer", "friend::rejectFriendApply"), e.type = "rejectFriendApply", this.friendRequest(e);
    }, r.deleteFriend = function (e) {
      s.verifyOptions(e, "account", "friend::deleteFriend"), this.processCallback(e), this.sendCmd("deleteFriend", { account: e.account }, e.callback);
    }, r.updateFriend = function (e) {
      this.processCallback(e);var t = new o(e);this.sendCmd("updateFriend", { friend: t, single: !0 }, e.callback);
    }, r.getFriends = function (e) {
      var t = this,
          n = t.db,
          r = 0;function i() {
        t.sendCmd("getFriends", { timetag: r, NOTSTORE: "timetag" }, e.callback);
      }s.verifyOptions(e), t.processCallback(e), n.enable ? n.getFriendsTimetag().then(function (e) {
        r = e, i();
      }, i) : i();
    };
  }, function (e, t, n) {
    "use strict";
    var r = n(32).fn,
        s = n(0),
        i = s.objs2accounts,
        o = n(129);r.updateMyInfo = function (e) {
      s.verifyOptions(e), this.processCallback(e), e.user = new o(e), delete e.user.account, this.sendCmd("updateMyInfo", { user: e.user, single: !0 }, e.callback);
    }, r.getMyInfo = function (e) {
      return (e = e || {}).account = this.account, this.getUser(e);
    }, r.getUser = function (e) {
      var t,
          n = this,
          r = n.db;function i() {
        n.sendCmd("getUsers", { accounts: [t], single: !0 }, e.callback);
      }s.verifyOptions(e, "account", "user::getUser"), n.processCallback(e), e.cbaop = function (e, r) {
        if (!e) return r = r[0] || null, n.logger.log("api::getUser: cbaop " + t, r), r;
      }, t = e.account, e.sync ? i() : r.enable ? r.getUser(t).then(function (r) {
        r ? (n.logger.log("api::getUser: db.getUser " + t, r), e.done(null, r)) : i();
      }, i) : i();
    }, r.getUsers = function (e) {
      var t,
          n = this,
          r = n.db,
          o = [];function a() {
        n.sendCmd("getUsers", { accounts: t, single: !0 }, e.callback);
      }s.verifyOptions(e, "accounts", "user::getUsers"), s.verifyParamType("accounts", e.accounts, "array", "user::getUsers"), n.processCallback(e), e.cbaop = function (e, r) {
        if (!e) return r = r.concat(o), n.logger.log("api::getUsers: cbaop " + t, r), r;
      }, t = s.deduplicate(e.accounts), s.verifyArrayMax("accounts", e.accounts, 150, "user::getUsers"), e.sync ? a() : r.enable ? r.getUsers(t).then(function (r) {
        if (r && r.length === t.length) n.logger.log("api::getUsers: db.getUsers", r), e.done(null, r);else {
          o = r;var s = i(r),
              c = [];t.forEach(function (e) {
            -1 === s.indexOf(e) && c.push(e);
          }), t = c, a();
        }
      }, a) : a();
    };
  }, function (e, t, n) {
    "use strict";
    var r = n(32).fn,
        s = n(0);r.markInBlacklist = function (e) {
      s.verifyOptions(e, "account isAdd", "relation::markInBlacklist"), s.verifyParamType("isAdd", e.isAdd, "boolean", "relation::markInBlacklist"), this.processCallback(e), this.sendCmd("markInBlacklist", { account: e.account, isAdd: e.isAdd }, e.callback);
    }, r.addToBlacklist = function (e) {
      return e.isAdd = !0, this.markInBlacklist(e);
    }, r.removeFromBlacklist = function (e) {
      return e.isAdd = !1, this.markInBlacklist(e);
    }, r.markInMutelist = function (e) {
      s.verifyOptions(e, "account", "relation::markInMutelist"), s.verifyParamType("isAdd", e.isAdd, "boolean", "relation::markInMutelist"), this.processCallback(e), this.sendCmd("markInMutelist", { account: e.account, isAdd: e.isAdd }, e.callback);
    }, r.addToMutelist = function (e) {
      return e.isAdd = !0, this.markInMutelist(e);
    }, r.removeFromMutelist = function (e) {
      return e.isAdd = !1, this.markInMutelist(e);
    }, r.getRelations = function (e) {
      var t = this,
          n = t.db,
          r = 0;function i() {
        t.sendCmd("getRelations", { timetag: r, NOTSTORE: "timetag" }, e.callback);
      }e = s.verifyOptions(e), t.processCallback(e), n.enable ? n.getRelationsTimetag().then(function (e) {
        r = e, i();
      }, i) : i();
    };
  }, function (e, t, n) {
    "use strict";
    var r = n(32).fn,
        s = n(0);r.kick = function (e) {
      s.verifyOptions(e, "deviceIds", "link::kick"), this.processCallback(e), this.sendCmd("kick", { deviceIds: e.deviceIds.slice(0) }, e.callback);
    };
  }, function (e, t, n) {
    "use strict";
    var r = n(32).fn,
        s = n(0),
        i = s.isArray,
        o = n(86);r.mergeObjArray = function (e, t, n) {
      return e || (e = []), t ? (i(t) || (t = [t]), t.length ? (n = n || {}, s.mergeObjArray(e, t, n)) : e) : e;
    }, r.cutObjArray = function (e, t, n) {
      return e && t ? (i(t) || (t = [t]), t.length ? (n = n || {}, s.cutObjArray(e, t, n)) : e) : e;
    }, r.mergeLoginPorts = function (e, t) {
      return this.mergeObjArray(e, t, { keyPath: "deviceId" });
    }, r.cutLoginPorts = function (e, t) {
      return this.cutObjArray(e, t, { keyPath: "deviceId", sortPath: "type" });
    }, r.mergeRelations = function (e, t) {
      return this.mergeObjArray(e, t, { keyPath: "account" });
    }, r.cutRelations = function (e, t) {
      return this.cutObjArray(e, t, { keyPath: "account" });
    }, r.findRelation = function (e, t) {
      return s.findObjInArray(e, { keyPath: "account", value: t });
    }, r.mergeFriends = function (e, t) {
      return this.mergeObjArray(e, t, { keyPath: "account" });
    }, r.cutFriends = function (e, t) {
      return this.cutObjArray(e, t, { keyPath: "account" });
    }, r.cutFriendsByAccounts = function (e, t) {
      i(t) || (t = [t]);var n = t.map(function (e) {
        return { account: e };
      });return this.cutFriends(e, n);
    }, r.findFriend = function (e, t) {
      return s.findObjInArray(e, { keyPath: "account", value: t });
    }, r.mergeUsers = function (e, t) {
      return this.mergeObjArray(e, t, { keyPath: "account" });
    }, r.findUser = function (e, t) {
      return s.findObjInArray(e, { keyPath: "account", value: t });
    }, r.mergeTeams = function (e, t) {
      return this.mergeObjArray(e, t, { keyPath: "teamId" });
    }, r.cutTeams = function (e, t) {
      return this.cutObjArray(e, t, { keyPath: "teamId" });
    }, r.findTeam = function (e, t) {
      return s.findObjInArray(e, { keyPath: "teamId", value: t });
    }, r.assembleTeamOwner = o.assembleOwner, r.assembleTeamMembers = o.assembleMembers, r.genTeamMemberId = o.genId, r.mergeTeamMembers = function (e, t) {
      return this.mergeObjArray(e, t);
    }, r.cutTeamMembers = function (e, t) {
      return this.cutObjArray(e, t);
    }, r.cutTeamMembersByAccounts = function (e, t, n) {
      i(n) || (n = [n]);var r = o.assembleMembers({ teamId: t }, n);return this.cutTeamMembers(e, r);
    }, r.findTeamMember = function (e, t) {
      return s.findObjInArray(e, { keyPath: "id", value: t });
    }, r.mergeSessions = function (e, t) {
      return this.mergeObjArray(e, t, { sortPath: "updateTime", desc: !0 });
    }, r.cutSessions = function (e, t) {
      return this.cutObjArray(e, t);
    }, r.cutSessionsByIds = function (e, t) {
      i(t) || (t = [t]);var n = t.map(function (e) {
        return { id: e };
      });return this.cutSessions(e, n);
    }, r.findSession = function (e, t) {
      return s.findObjInArray(e, { keyPath: "id", value: t });
    }, r.mergeMsgs = function (e, t) {
      return this.mergeObjArray(e, t, { keyPath: "idClient", sortPath: "time" });
    }, r.cutMsgs = function (e, t) {
      return this.cutObjArray(e, t, { keyPath: "idClient" });
    }, r.cutMsgsByIdClients = function (e, t) {
      i(t) || (t = [t]);var n = t.map(function (e) {
        return { idClient: e };
      });return this.cutMsgs(e, n);
    }, r.findMsg = function (e, t) {
      return s.findObjInArray(e, { keyPath: "idClient", value: t });
    }, r.mergeSysMsgs = function (e, t) {
      return this.mergeObjArray(e, t, { keyPath: "idServer", desc: !0 });
    }, r.cutSysMsgs = function (e, t) {
      return this.cutObjArray(e, t, { keyPath: "idServer" });
    }, r.cutSysMsgsByIdServers = function (e, t) {
      i(t) || (t = [t]);var n = t.map(function (e) {
        return { idServer: e };
      });return this.cutSysMsgs(e, n);
    }, r.findSysMsg = function (e, t) {
      return s.findObjInArray(e, { keyPath: "idServer", value: t });
    };
  }, function (e, t, n) {
    "use strict";
    var r = n(72),
        s = n(0),
        i = { welcome: "00", text: "01", link: "03" },
        o = { "01": "text", "02": "image", "03": "answer", 11: "template" };function a(e) {
      s.verifyOptions(e, "content", "msg::RobotMessage"), s.undef(e.robotAccid) && (e.robotAccid = e.to);var t = e.content;switch (t.type) {case "welcome":
          s.undef(e.body) && (this.body = "欢迎消息");break;case "text":
          s.verifyOptions(t, "content", "msg::RobotMessage"), s.undef(e.body) && (this.body = t.content);break;case "link":
          s.verifyOptions(t, "target", "msg::RobotMessage");}t.type && (t.type = i[t.type]), t = { param: t, robotAccid: e.robotAccid }, this.attach = __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_json_stringify___default()(t), e.type = "robot", r.call(this, e);
    }a.prototype = __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_create___default()(r.prototype), a.reverse = function (e) {
      var t = r.reverse(e);if ("robot" === t.type) {
        var n = JSON.parse(e.attach);if (n.param && (n.param.type = o[n.param.type] || "unknown"), n.robotMsg) {
          var i = (n = s.merge(n, n.robotMsg)).message;"bot" === n.flag ? n.message = i.map(function (e) {
            return e.type = o[e.type] || "unknown", e;
          }) : n.flag, delete n.robotMsg;
        }t.content = n;
      }return t;
    }, e.exports = a;
  }, function (e, t, n) {
    "use strict";
    var r = n(72),
        s = n(0);function i(e) {
      s.verifyOptions(e, "tip", "msg::TipMessage"), e.type = "tip", r.call(this, e), this.body = e.tip;
    }i.prototype = __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_create___default()(r.prototype), i.reverse = function (e) {
      var t = r.reverse(e);return t.text = "", t.tip = e.body, e.attach && (t.attach = e.attach), t;
    }, e.exports = i;
  }, function (e, t, n) {
    "use strict";
    var r = n(72),
        s = n(0);function i(e) {
      s.verifyOptions(e, "content", "msg::CustomMessage"), e.type = "custom", r.call(this, e), this.attach = e.content;
    }i.prototype = __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_create___default()(r.prototype), i.reverse = function (e) {
      var t = r.reverse(e);return t.content = e.attach, t;
    }, e.exports = i;
  }, function (e, t, n) {
    "use strict";
    var r = n(0).notundef,
        s = n(72),
        i = n(80).IM,
        o = n(119),
        a = n(129),
        c = { 0: "addTeamMembers", 1: "removeTeamMembers", 2: "leaveTeam", 3: "updateTeam", 4: "dismissTeam", 5: "passTeamApply", 6: "transferTeam", 7: "addTeamManagers", 8: "removeTeamManagers", 9: "acceptTeamInvite", 10: "updateTeamMute", 101: "netcallMiss", 102: "netcallBill" };function u() {}u.prototype = __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_create___default()(s.prototype), u.reverse = function (e) {
      var t = s.reverse(e);if (e.attach = e.attach ? "" + e.attach : "", e.attach) {
        var n = JSON.parse(e.attach);if (t.attach = { type: c[n.id] || n.id }, r(n.data)) {
          var u = n.data;r(u.tinfo) && (t.attach.team = o.reverse(i.syncUnserialize(u.tinfo, "team"), !0)), r(u.ids) && (t.attach.accounts = u.ids), r(u.id) && (t.attach.account = u.id), r(u.uinfos) && (t.attach.users = u.uinfos.map(function (e) {
            return a.reverse(i.syncUnserialize(e, "user"));
          })), r(u.mute) && (t.attach.mute = 1 == +u.mute), r(u.attach) && (t.attach.custom = u.attach), r(u.channel) && (t.attach.channelId = u.channel), r(u.calltype) && (t.attach.netcallType = u.calltype), r(u.duration) && (t.attach.duration = u.duration), r(u.time) && (t.attach.time = u.time), r(u.from) && (t.attach.from = u.from), r(u.ext) && (t.attach.ext = u.ext), t.attach.accounts && t.attach.accounts.length <= 2 && t.from === t.to && t.attach.accounts.some(function (e) {
            if (e !== t.to) return t.to = e, !0;
          });
        }
      } else t.attach = {};return t;
    }, e.exports = u;
  }, function (e, t, n) {
    "use strict";
    var r = n(72),
        s = n(0);function i(e) {
      e.type = "geo", s.verifyOptions(e, "geo", "msg::GeoMessage"), s.verifyOptions(e.geo, "lng lat title", !0, "geo.", "msg::GeoMessage"), s.verifyParamType("geo.lng", e.geo.lng, "number", "msg::GeoMessage"), s.verifyParamType("geo.lat", e.geo.lat, "number", "msg::GeoMessage"), s.verifyParamType("geo.title", e.geo.title, "string", "msg::GeoMessage"), r.call(this, e), this.attach = __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_json_stringify___default()(e.geo);
    }i.prototype = __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_create___default()(r.prototype), i.reverse = function (e) {
      var t = r.reverse(e);return e.attach = e.attach ? "" + e.attach : "", t.geo = e.attach ? JSON.parse(e.attach) : {}, t;
    }, e.exports = i;
  }, function (e, t, n) {
    "use strict";
    var r = n(128),
        s = n(0);function i() {}i.prototype = __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_create___default()(r.prototype), i.verifyFile = function (e, t) {
      s.verifyOptions(e, "dur w h", !0, "file.", t);
    }, e.exports = i;
  }, function (e, t, n) {
    "use strict";
    var r = n(128),
        s = n(0);function i() {}i.prototype = __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_create___default()(r.prototype), i.verifyFile = function (e, t) {
      s.verifyOptions(e, "dur", !0, "file.", t);
    }, e.exports = i;
  }, function (e, t, n) {
    "use strict";
    var r = n(0),
        s = n(128);function i() {}i.prototype = __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_create___default()(s.prototype), i.verifyFile = function (e, t) {
      r.verifyOptions(e, "w h", !0, "file.", t);
    }, e.exports = i;
  }, function (e, t, n) {
    "use strict";
    var r = n(72),
        s = n(0);function i(e) {
      s.verifyOptions(e, "text", "msg::TextMessage"), e.type = "text", r.call(this, e);
    }i.prototype = __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_create___default()(r.prototype), i.reverse = function (e) {
      return r.reverse(e);
    }, e.exports = i;
  }, function (e, t, n) {
    "use strict";
    var r = n(0),
        s = function s(e) {
      this.account = e.account;
    },
        i = s.prototype,
        o = i.Message = n(72),
        a = i.TextMessage = n(411),
        c = i.FileMessage = n(128),
        u = i.GeoMessage = n(407),
        l = i.NotificationMessage = n(406),
        m = i.CustomMessage = n(405),
        d = i.TipMessage = n(404),
        f = i.RobotMessage = n(403);i.validScenes = o.validScenes, i.validTypes = o.validTypes, i.reverse = function (e) {
      var t;switch (o.getType(e)) {case "text":
          t = a.reverse(e);break;case "image":case "audio":case "video":case "file":
          t = c.reverse(e);break;case "geo":
          t = u.reverse(e);break;case "notification":
          t = l.reverse(e);break;case "custom":
          t = m.reverse(e);break;case "tip":
          t = d.reverse(e);break;case "robot":
          t = f.reverse(e);break;default:
          t = o.reverse(e);}return o.setExtra(t, this.account), t;
    }, i.reverseMsgs = function (e, t) {
      var n,
          s,
          i = this;return e.map(function (e) {
        return e = i.reverse(e), t && ((n = t.modifyObj) && (e = r.merge(e, n)), s = t.mapper, r.isFunction(s) && (e = s(e))), e;
      });
    }, e.exports = s;
  }, function (e, t, n) {
    "use strict";
    var r,
        s = n(54),
        i = (r = s) && r.__esModule ? r : { default: r };var o = n(25).fn,
        a = n(0),
        c = i["default"].clientTypeMap;function u(e) {
      e = e || {};var t = a.copy(e);return t.clientType && (t.clientType = c[t.clientType] || ""), t.serverCustom && (t.custom = JSON.parse(t.serverCustom), "string" == typeof t.custom[0] && (t.custom = t.custom[0]), delete t.serverCustom), t;
    }o.processEventService = function (e) {
      var t = e.content,
          n = e.error,
          r = this.options || {};switch (n && (n.callFunc = "events::processEventService", this.onCustomError("事件服务解包失败", "EVENT_SERVICE_ERROR", n)), e.cmd) {case "pushEvent":
          if (a.isFunction(r.onpushevents)) {
            var s = { msgEvents: [u(t.msgEvent)] };r.onpushevents(s);
          }break;case "pushEvents":
          if (a.isFunction(r.onpushevents)) {
            var i = t.msgEvents;i = { msgEvents: i.map(function (e) {
                return u(e);
              }) }, r.onpushevents(i);
          }}
    };
  }, function (e, t, n) {
    "use strict";
    n(25).fn.processFilter = function (e) {
      switch (e.cmd) {case "sendFilterMsg":
          this.onSendMsg(e, !0);break;case "filterMsg":
          this.onMsg(e, !0);break;case "filterSysMsg":
          this.onSysMsg(e, !0);break;case "sendFilterCustomSysMsg":
          this.onSendSysMsg(e, !0);}
    };
  }, function (e, t, n) {
    "use strict";
    var r = n(25).fn;r.processChatroom = function (e) {
      switch (e.cmd) {case "getChatroomAddress":
          this.onChatroomAddress(e);}
    }, r.onChatroomAddress = function (e) {
      e.error || (e.obj.address = e.content.address);
    };
  }, function (e, t, n) {
    "use strict";
    var r = n(25).fn;r.syncSessionAck = function (e) {
      var t = this,
          n = t.db,
          r = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve();[[e.content.p2p, "p2p"], [e.content.team.m_map, "team"]].forEach(function (e) {
        var s = e[0],
            i = e[1];__WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_keys___default()(s).forEach(function (e) {
          var o = i + "-" + e,
              a = { id: o, ack: s[e] };n.enable && (r = r.then(function () {
            return n.putSession(a);
          }).then(function () {
            t.markUnreadBySessionAck({ sessionId: o, ack: s[e] });
          })), t.mergeSession(a);
        });
      }), t.logger.warn("session::syncSessionAck: parse offline session ack", t.sessionSet);var s = e.content.timetag;n.enable && (r = r.then(function () {
        return t.db.updateSessionAck(s);
      })["catch"](function (e) {
        return t.logger.error("sessionAck::syncSessionAck: ", e), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.reject(e);
      })), r.cmd = "sessionAck", t.syncPromiseArray.push(r);
    }, r.onMarkSessionAck = function (e) {
      e.error || this.storeSessionAck(e.obj);
    }, r.syncMarkSessionAck = function (e) {
      this.storeSessionAck(e.content);
    }, r.storeSessionAck = function (e) {
      if (this.options.syncSessionUnread) {
        var t = this.db,
            n = (0 === e.scene ? "p2p" : "team") + "-" + e.to,
            r = e.timetag;if (r <= ((this.findSession(n) || {}).ack || 0)) this.logger.warn("session::storeSessionAck: ack <= ackInMemory", r);else {
          var s = { id: n, ack: r };this.mergeSession(s), t.enable && t.updateSession(s), this.logger.info("session::storeSessionAck:", s), this.markUnreadBySessionAck({ sessionId: n, ack: s.ack });
        }
      }
    }, r.markUnreadBySessionAck = function (e) {
      var t = e.sessionId,
          n = e.ack,
          r = this,
          s = r.db;if (s.enable) r.pushMsgTask(function () {
        return s.getMsgCountAfterAck({ shouldCountNotifyUnread: r.options.shouldCountNotifyUnread, sessionId: t, ack: n }).then(function (e) {
          var n = { id: t, unread: e };return r.logger.log("session::markUnreadBySessionAck: db.getMsgCountAfterAck done"), r.syncing && r.cacheSyncedSession(n), r.onUpdateSession(n), s.updateSession(n);
        });
      });else {
        var i = r.findSession(t);if (i) {
          var o = i.unreadMsgs;if (o && o.length) {
            for (var a = 0, c = [], u = o.length - 1; u >= 0; u--) {
              var l = o[u];if (!(l.time > n)) break;a++, c.push(l);
            }i.unreadMsgs = c, i.unread = a, r.logger.info("session::markUnreadBySessionAck: unread " + a), r.onUpdateSession(i);
          }
        }
      }
    };
  }, function (e, t, n) {
    "use strict";
    var r = n(25).fn,
        s = n(0),
        i = n(116),
        o = n(26);r.mergeSession = function (e) {
      e = s.copyWithNull(e);var t = this.sessionSet,
          n = e.id,
          r = t[n];if (r && r.lastMsg && e && e.lastMsg && e.lastMsg.isLocal) {
        var i = r.lastMsg.time || 0;if ((e.lastMsg.time || 0) < i) return r;
      }return t[n] = s.merge(r, e), e = t[n], s.undef(e.unread) && (e.unread = 0), e;
    }, r.mergeSessions = function (e) {
      var t = this;e.forEach(function (e) {
        t.mergeSession(e);
      });
    }, r.deleteLocalSession = function (e) {
      var t = this;s.isArray(e) || (e = [e]), e.forEach(function (e) {
        delete t.sessionSet[e];
      });
    }, r.onDeleteSessions = function (e) {
      e.obj = e.obj.sessions.map(function (e) {
        return i.parse(e);
      });
    }, r.onUpdateSession = function (e) {
      var t = this;return new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a(function (n) {
        e ? (e = t.mergeSession(e), e = s.simpleClone(e), i.trim(e), i.isComplete(e) && (t.logger.info("session::onUpdateSession:", e.id, s.simpleClone(e)), t.options.onupdatesession(e), n(e))) : n(e);
      });
    }, r.setCurrSession = function (e) {
      e = "" + e, this.currSessionId = e, this.logger.info("session::setCurrSession:", e);
    }, r.findSession = function (e) {
      return this.sessionSet[e];
    }, r.resetSessionUnread = function (e) {
      e = "" + e;var t,
          n = this,
          r = n.db;if (n.findSession(e)) {
        if (r.enable && r.resetSessionUnread(e), !n.options.autoMarkRead && n.sessionUnreadMsgs && n.sessionUnreadMsgs[e]) {
          var s = n.sessionUnreadMsgs[e];n.markMsgRead(s, !0), n.sessionUnreadMsgs[e] = [];
        }t = { id: e, unread: 0 }, n.onUpdateSession(t);
      } else n.logger.warn("session::resetSessionUnread: no session " + e);
    }, r.insertLocalSession = function (e) {
      var t = this,
          n = t.db,
          r = t.sessionSet;return new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a(function (a, c) {
        var u = e.scene,
            l = e.to,
            m = u + "-" + l,
            d = t.findSession(m);if (d) c(o.sessionExist({ callFunc: "session::insertLocalSession", session: d }));else {
          var f;if (s.isNumber(e.updateTime)) f = e.updateTime;else {
            var p,
                g = [];for (var h in r) {
              r.hasOwnProperty(h) && (p = r[h], s.isNumber(p.updateTime) && g.push(p.updateTime));
            }f = Math.max.apply(Math, g) + 1, f = Math.max(f, +new Date());
          }var y = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve();n.enable && (y = n.getMsgs({ sessionId: m, limit: 1 })), y.then(function (e) {
            if (s.isArray(e) && 1 === e.length) {
              var r = e[0];(d = i.genSessionByMsg(r)).updateTime = f;
            } else d = { id: m, scene: u, to: l, updateTime: f, lastMsg: null };n.enable ? n.putSession(d).then(a, c) : a(d), t.onUpdateSession(d);
          });
        }
      });
    }, r.updateLocalSession = function (e, t) {
      var n = this;return new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a(function (r, i) {
        var a = n.db;if (n.findSession(e.id)) {
          var c = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve(),
              u = s.filterObj(e, "id lastMsg localCustom");a.enable && (c = a.updateSession(u)), c.then(function (e) {
            return n.onUpdateSession(e, t);
          }).then(r, function (e) {
            i({ callFunc: "session::updateLocalSession", event: e });
          });
        } else i(o.sessionNotExist({ sessionId: e.id, callFunc: "session::updateLocalSession" }));
      });
    };
  }, function (e, t, n) {
    "use strict";
    var r = n(25).fn,
        s = n(0),
        i = n(117);r.splitSysMsgs = function (e, t) {
      for (var n, r = e.length - 1; r >= 0; r--) {
        n = e[r], i.isCustom(n) && (e.splice(r, 1), t.push(n));
      }
    }, r.onOfflineSysMsgs = function (e, t) {
      var n = this,
          r = e.content.sysMsgs.map(function (e) {
        return e = i.reverse(e), t && (e.filter = !0), e;
      });r = r.reverse(), n.markSysMsgRead(r);var s = [];n.splitSysMsgs(r, s);var o = t ? "offlineFilterSysMsgs" : "offlineSysMsgs",
          a = t ? "offlineFilterCustomSysMsgs" : "offlineCustomSysMsgs";if (r.length) {
        var c = n.putSysMsg(r, "offlineSysMsgs").then(function (e) {
          (r = e).length && (n.logger.info("sysmsg::onOfflineSysMsgs: ", o, r.length, r), n.syncResult[o] = n.syncResult[o] || [], n.syncResult[o] = n.syncResult[o].concat(r));
        })["catch"](function (e) {
          return n.logger.error("sysMsg::onOfflineSysMsgs: ", e), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.reject(e);
        });c.cmd = "sysMsgs", n.syncPromiseArray.push(c);
      }s.length && (n.logger.info("sysmsg::onOfflineSysMsgs: ", a, s), n.syncResult[a] = n.syncResult[a] || [], n.syncResult[a] = n.syncResult[a].concat(s));
    }, r.onSendSysMsg = function (e, t) {
      var n = e.obj;this.completeSysMsg(n), e.error ? n.status = "fail" : n.status = "success", n = i.reverse(n), t && (e.obj.filter = !0), e.obj = n;
    }, r.completeSysMsg = function (e) {
      return e.from = this.account, e;
    }, r.onSysMsg = function (e, t) {
      var n = i.reverse(e.content.sysMsg);this.markSysMsgRead(n), t && (n.filter = !0), i.isCustom(n) ? (this.logger.info("sysmsg::onSysMsg: on customSysMsg", n), this.options.oncustomsysmsg(n)) : this.syncing ? this.unhandledSysMsgs.push(n) : this.handleSysMsg(n);
    }, r.handleSysMsg = function (e) {
      var t = this,
          n = e.type,
          r = e.from;t.sysMsgPromise = t.sysMsgPromise.then(function () {
        return t.putSysMsg(e, "onSysMsg");
      }).then(function (t) {
        e = t[0];
      }).then(function () {
        if (e) {
          var s,
              i = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve();switch (n) {case "addFriend":
              s = { type: "addFriend", account: r }, i = t.onFriendRequest(s);break;case "passFriendApply":
              s = { type: "passFriendApply", account: r }, i = t.onFriendRequest(s);break;case "deleteFriend":
              i = t.onDeleteFriend({ account: r });}return s && s.friend && (e.friend = s.friend), i;
        }
      }).then(function () {
        e && (t.logger.info("sysmsg::handleSysMsg: ", n, e), setTimeout(function () {
          t.options.onsysmsg(e);
        }, 0));
      });
    }, r.putSysMsg = function (e, t) {
      if (s.isArray(e) || (e = [e]), e[0].filter) return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve(e);var n = this,
          r = n.db,
          i = r.enable,
          o = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve(),
          a = [];return (o = (o = o.then(function () {
        return i ? r.putSysMsg(e) : e;
      }).then(function (t) {
        var r = [];e.forEach(function (e) {
          n.checkSysMsgUnique(e) && r.push(e);
        }), e = r, a = i ? t : e;
      })).then(function () {
        return n.getSysMsgUnread().then(function (r) {
          return a.length || ((a = e).backward = !0), n.updateSysMsgUnread(a, r, 1).then(function (e) {
            "offlineSysMsgs" === t && (n.syncResult.sysMsgUnread = e), "onSysMsg" === t && n.onUpdateSysMsgUnread(e);
          });
        });
      })).then(function () {
        return e;
      });
    }, r.checkSysMsgUnique = s.genCheckUniqueFunc("idServer"), r.getSysMsgUnread = function () {
      var e = this,
          t = e.db;return new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a(function (n) {
        t.enable ? t.getSysMsgUnread().then(function (e) {
          n(e);
        }, function () {
          n(e.sysMsgUnread);
        }) : n(e.sysMsgUnread);
      });
    }, r.updateSysMsgUnread = function (e, t, n) {
      if (s.isArray(e) || (e = [e]), !e.length) return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve(t);t = t || {};var r,
          o = this.db;return e.forEach(function (e) {
        (n > 0 && !e.read || n < 0 && e.read) && (r = e.type, t[r] = (t[r] || 0) + n);
      }), t = i.completeUnread(t), this.sysMsgUnread = t, o.enable && !e.backward ? o.updateSysMsgUnread(t) : __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve(t);
    }, r.reduceSysMsgUnread = function (e) {
      var t = this;return t.getSysMsgUnread().then(function (n) {
        return t.updateSysMsgUnread(e, n, -1);
      }).then(function (e) {
        t.onUpdateSysMsgUnread(e);
      });
    }, r.onUpdateSysMsgUnread = function (e) {
      var t = this;setTimeout(function () {
        t.logger.info("sysmsg::onUpdateSysMsgUnread:", e), t.options.onupdatesysmsgunread(e);
      }, 0);
    }, r.updateSysMsg = function (e) {
      var t = this,
          n = t.db;(n.enable ? n.updateSysMsg(e) : __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve(e)).then(function (e) {
        t.onUpdateSysMsg(e);
      });
    }, r.onUpdateSysMsg = function (e) {
      var t = this;setTimeout(function () {
        s.isArray(e) || (e = [e]), e.forEach(function (e) {
          t.logger.info("sysmsg::onUpdateSysMsg:", e), t.options.onupdatesysmsg(e);
        });
      }, 0);
    }, r.processUnsettledSysMsgs = function () {
      var e = this;e.unhandledSysMsgs.forEach(function (t) {
        e.handleSysMsg(t);
      }), e.resetUnsettledSysMsgs();
    };
  }, function (e, t, n) {
    "use strict";
    var r = n(25).fn,
        s = n(117),
        i = n(116),
        o = n(0);r.onDeleteMsg = function (e) {
      var t = this.db;delete e.obj.sysMsg, e.error || (e.promise = this.deleteLocalMsg(e.obj.msg).then(function () {
        var n = e.obj.msg;t.enable && t.getTimetag("deleteMsg").then(function (e) {
          e = e || 0, n.time >= e && t.updateDeleteMsgTimetag(new Date().getTime());
        });
      }));
    }, r.onMsgDeleted = function (e) {
      if (!e.error) {
        var t = this,
            n = t.db,
            r = s.reverse(e.content.sysMsg);r = t.processDeleteMsgSysMsg(r), t.markSysMsgRead(r), t.deleteLocalMsg(r.msg).then(function () {
          n.enable && n.updateDeleteMsgTimetag(r.time + 1), t.handleSysMsg(r);
        });
      }
    }, r.processDeleteMsgSysMsg = function (e) {
      return e.msg = {}, ["scene", "from", "to"].forEach(function (t) {
        e.msg[t] = e[t];
      }), e.msg.idClient = e.deletedIdClient, e.msg.idServer = e.deletedIdServer, e.msg.time = e.deletedMsgTime, e.msg.fromNick = e.deletedMsgFromNick, e.opeAccount = e.opeAccount || e.from, e.msg.opeAccount = e.opeAccount, this.message.Message.setExtra(e.msg, this.account), e;
    }, r.onDeleteMsgOfflineRoaming = function (e) {
      if (!e.error) {
        var t = this,
            n = 1 == +e.content.type ? "offline" : "roaming",
            r = s.reverseSysMsgs(e.content.sysMsgs, { mapper: function mapper(e) {
            return t.processDeleteMsgSysMsg(e);
          } });t.logger.info("msg::onDeleteMsgOfflineRoaming: on delete " + n, r), "offline" === n && t.markSysMsgRead(r);var i = e.content.timetag;t.timetags.deleteMsg = i, t.syncResult.deleteMsgTimetag = i;var o = t.putSysMsg(r, "offlineSysMsgs")["catch"](function (e) {
          return t.logger.error("msgDelete::onDeleteMsgOfflineRoaming: ", e), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.reject(e);
        });o.cmd = "deleteMsgSysMsgs " + n, t.syncPromiseArray.push(o), t.syncResult.deleteMsgSysMsgs = t.syncResult.deleteMsgSysMsgs || [], t.syncResult.deleteMsgSysMsgs.push({ type: n, sysMsgs: r });
      }
    }, r.deleteMsgOfflineRoaming = function (e, t) {
      if (!e) return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve();var n = this;n.logger.info("msg::deleteMsgOfflineRoaming: ", e, t);var r = n.db,
          s = [];return e.forEach(function (e) {
        e.sysMsgs.forEach(function (e) {
          var a = n.deleteLocalMsg(e.msg, { cbUpdateSession: function cbUpdateSession(e) {
              e = n.mergeSession(e), e = o.simpleClone(e), i.trim(e);var s = o.findObjIndexInArray(t, { value: e.id });if (-1 !== s && (t[s] = o.merge({}, t[s], e)), r.enable) return r.updateSession(e);
            } });s.push(a);
        });
      }), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.all(s).then(function () {
        if (r.enable) return r.updateDeleteMsgTimetag(n.syncResult.deleteMsgTimetag);
      });
    }, r.deleteLocalMsg = function (e, t) {
      var n = this.db,
          r = (t = t || {}).cbUpdateSession || this.updateLocalSession.bind(this);if (n.enable && e) {
        var s = !1,
            i = null,
            o = e.sessionId;return n.getMsgs({ sessionId: o, limit: 1 }).then(function (t) {
          t && t[0] && t[0].idClient === e.idClient && (s = !0);
        }).then(function () {
          return n.deleteMsg(e.idClient);
        }).then(function () {
          if (s) return n.getMsgs({ sessionId: o, limit: 1 });
        }).then(function (e) {
          if (s) return e && e[0] && (i = e[0]), r({ id: o, lastMsg: i });
        });
      }return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve();
    };
  }, function (e, t, n) {
    "use strict";
    var r = n(25).fn,
        s = n(0);r.onOfflineMsgReceipts = function (e) {
      var t,
          n = this,
          r = n.db,
          s = e.content.msgReceipts,
          i = n.syncResult.msgReceipts = [],
          o = [],
          a = "msgReceipts",
          c = n.syncResult.sessions || {};s.forEach(function (e) {
        e.time = +e.time;var s = e.sessionId = "p2p-" + e.from;a += "-" + s, t = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve();var u = c[s];r.enable ? t = r.getSession(s).then(function (t) {
          if ((t = t || u) && n.shouldUpdateSessionFromMsgReceipt(t, e)) {
            var i = n.genSessionFromMsgReceipt(t, e),
                o = n.syncResult.sessions;return o && o[s] && (o = o[s]).lastMsg && i.lastMsg && o.lastMsg.time > i.lastMsg.time && (i.lastMsg = o.lastMsg), r.putSession(i).then(function (e) {
              e && n.cacheSyncedSession(e);
            });
          }
        })["catch"](function (e) {
          return n.logger.error("msgReceipt::onOfflineMsgReceipt: ", e), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.reject(e);
        }) : u && i.push(e), o.push(t);
      }), (t = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.all(o).then(function () {
        if (r.enable) return r.updateMsgReceiptsTimetag(e.content.timetag);
      })).cmd = a, n.syncPromiseArray.push(t);
    }, r.mergeSessionAndMsgReceipts = function (e, t) {
      var n = this,
          r = {};return t = t || [], (e = e || []).forEach(function (e) {
        r[e.id] = e;
      }), t.forEach(function (t) {
        var s = r[t.sessionId];if (n.shouldUpdateSessionFromMsgReceipt(s, t)) {
          var i = n.genSessionFromMsgReceipt(s, t);e = n.api.mergeSessions(e, i);
        }
      }), e;
    }, r.shouldUpdateSessionFromMsgReceipt = function (e, t) {
      return !e || !e.msgReceiptServerTime || t.time > e.msgReceiptServerTime;
    }, r.genSessionFromMsgReceipt = function (e, t) {
      var n = t.time,
          r = { id: t.sessionId, msgReceiptTime: n, msgReceiptServerTime: n };return e && e.id === t.sessionId && (r = s.merge({}, e, r)), e && e.updateTime || (r.updateTime = n), r;
    }, r.onMsgReceipt = function (e) {
      var t = this,
          n = t.db,
          r = e.content.msgReceipt;r.time = +r.time;var s = r.idClient,
          i = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve();n.enable && s && (i = n.getMsgByIdClient(s)), i.then(function (e) {
        var n;if (e) {
          if (!e.idServer) return void (t.msgReceiptTasks[s] = r);n = e.time;
        } else n = r.time;r.msgReceiptTime = n, t.updateSessionMsgReceiptTime(r);
      });
    }, r.resolveMsgReceiptTask = function (e) {
      var t = this.msgReceiptTasks[e.idClient];t && (t.msgReceiptTime = e.time, this.updateSessionMsgReceiptTime(t));
    }, r.updateSessionMsgReceiptTime = function (e) {
      var t = this.db,
          n = { id: "p2p-" + e.from, msgReceiptTime: e.msgReceiptTime, msgReceiptServerTime: e.time };t.enable && t.putSession(n), this.onUpdateSession(n);
    }, r.onSendMsgReceipt = function (e) {
      if (!e.error) {
        var t = e.obj.msgReceipt,
            n = +t.time,
            r = +e.content.msgReceipt.time;this.sessionSet["p2p-" + t.to].msgReceiptSendTime = Math.min(n, r);
      }
    }, r.shouldSendMsgReceipt = function (e) {
      if (e && "p2p" === e.scene && "success" === e.status) {
        var t = this.sessionSet[e.sessionId];if (t) {
          var n = t.msgReceiptSendTime;return !n || n < e.time;
        }
      }return !1;
    }, r.isMsgRemoteRead = function (e) {
      if (e && "p2p" === e.scene && "out" === e.flow && "success" === e.status) {
        var t = this.sessionSet[e.sessionId];if (t && t.msgReceiptTime) return e.time <= t.msgReceiptTime;
      }return !1;
    };
  }, function (e, t, n) {
    "use strict";
    var r = n(25).fn,
        s = n(0),
        i = s.undef,
        o = n(54),
        a = n(86),
        c = n(116),
        u = n(169);r.processMsg = function (e) {
      switch (e.cmd) {case "sendMsg":
          this.onSendMsg(e);break;case "msg":
          this.onMsg(e);break;case "sysMsg":
          this.onSysMsg(e);break;case "broadcastMsg":
          this.onBroadcastMsg(e);break;case "sendCustomSysMsg":
          this.onSendSysMsg(e);break;case "getHistoryMsgs":case "searchHistoryMsgs":
          this.onHistoryMsgs(e);break;case "syncSendMsg":
          this.onMsg(e);break;case "deleteSessions":
          this.onDeleteSessions(e);break;case "sendMsgReceipt":
          this.onSendMsgReceipt(e);break;case "msgReceipt":
          this.onMsgReceipt(e);break;case "onDeleteMsg":
          this.onDeleteMsg(e);break;case "onMsgDeleted":
          this.onMsgDeleted(e);break;case "onDeleteMsgOfflineRoaming":
          this.onDeleteMsgOfflineRoaming(e);break;case "onMarkSessionAck":
          this.onMarkSessionAck(e);break;case "syncMarkSessionAck":
          this.syncMarkSessionAck(e);}
    }, r.checkIgnore = function (e) {
      var t = this;e.forEach(function (e) {
        "notification" === e.type && !e.ignore && t.options.shouldIgnoreNotification(e) && (e.ignore = !0);
      });
    }, r.filterIgnore = function (e) {
      return e.filter(function (e) {
        return !e.ignore;
      });
    }, r.genSessionByMsgs = function (e) {
      return this.checkIgnore(e), c.genSessionByMsgs(this.message.Message, e);
    }, r.onRoamingMsgs = function (e) {
      var t = this,
          n = t.message,
          r = n.Message,
          s = r.getMaxTimetag,
          i = n.reverseMsgs(e.content.msgs),
          o = s(i);i = r.sortMsgs(i);var a = (i = r.deduplication(i))[0],
          c = a.sessionId,
          u = t.genSessionByMsgs(i);t.cacheSyncedSession(u);var l = t.putMsg(i, "roamingMsgs").then(function (e) {
        i = e, (i = t.filterIgnore(i)).length && (t.logger.info("msg::onRoamingMsgs: putRoamingMsgs", c, i.length, i), t.syncResult.roamingMsgs = t.syncResult.roamingMsgs || [], t.syncResult.roamingMsgs.push({ sessionId: c, scene: a.scene, to: a.target, msgs: i, timetag: o }));
      })["catch"](function (e) {
        return t.logger.error("msg::onRoamingMsgs: ", e), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.reject(e);
      });l.cmd = "roamingMsgs-" + c, t.syncPromiseArray.push(l);
    }, r.onOfflineMsgs = function (e, t) {
      var n = this,
          r = n.message,
          s = r.Message,
          i = null;t && (i = { filter: !0 });var o,
          a,
          c = r.reverseMsgs(e.content.msgs, { modifyObj: i }),
          u = [],
          l = "",
          m = t ? "offlineFilterMsgs" : "offlineMsgs";function d(e) {
        if (u.length) {
          var t = s.getMaxTimetag(u),
              r = u[0].scene,
              i = u[0].target;n.markMsgRead(u), u = s.sortMsgs(u), u = s.deduplication(u);var o = n.genSessionByMsgs(u);n.cacheSyncedSession(o), (a = n.putMsg(u, "offlineMsgs").then(function (s) {
            u = s, (u = n.filterIgnore(u)).length && (n.logger.info("msg::onOfflineMsgs： toreLastSession", m, e, u.length, u), n.syncResult[m] = n.syncResult[m] || [], n.syncResult[m].push({ sessionId: e, scene: r, to: i, msgs: u, timetag: t }));
          })["catch"](function (e) {
            return n.logger.error("msg::onOfflineMsgs: ", e), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.reject(e);
          })).cmd = "offlineMsgs-" + e, n.syncPromiseArray.push(a);
        }
      }c.forEach(function (e) {
        (o = e.sessionId) !== l ? (d(l), (u = []).push(e), l = o) : u.push(e);
      }), d(l);
    }, r.markUnreadByMsgsPromise = function (e) {
      var t = this,
          n = t.db;n.enable && n.getSession(e).then(function (n) {
        n.ack && t.markUnreadBySessionAck({ sessionId: e, ack: n.ack });
      });
    }, r.completeMsg = function (e) {
      return e.from = this.account, e.fromNick = this.myInfo && this.myInfo.nick, e.fromClientType = "Web", e.fromDeviceId = o.deviceId, e.time || (e.time = +new Date()), e;
    }, r.onMsgs = function (e) {
      var t = this;t.message.reverseMsgs(e.content.msgs, { mapper: function mapper(e) {
          t.handleMsg(e);
        } });
    }, r.onMsg = function (e, t) {
      var n = this.message.reverse(e.content.msg);t && (n.filter = !0), this.syncing ? (this.logger.log("msg::onMsg:is in syncing ..."), this.unhandledMsgs.push({ type: "onMsg", msg: n })) : this.handleMsg(n);
    }, r.onBroadcastMsgs = function (e) {
      var t = e.content.broadcastMsgs;t = t.sort(function (e, t) {
        return e.broadcastId - t.broadcastId;
      }), this.putBroadcastMsgs(t);
    }, r.onBroadcastMsg = function (e) {
      var t = e.content.broadcastMsg;t.time = t.timestamp, this.syncing ? this.unhandledMsgs.push({ type: "onBroadcastMsg", msg: t }) : t && this.putBroadcastMsg(t);
    }, r.pushMsgTask = function (e) {
      this.msgPromise = this.msgPromise.then(function () {
        return e();
      });
    }, r.handleMsg = function (e) {
      var t = this,
          n = e.time;t.markMsgRead(e), t.msgPromise = t.msgPromise.then(function () {
        return t.putMsg(e, "onMsg");
      }).then(function (r) {
        return t.logger.log("msg::handleMsg:putMsg: ", e), e = r[0], t.updateRoamingMsgTimetag(n);
      }).then(function () {
        if (t.logger.log("msg::handleMsg:updateRoamingMsgTimetag: ", n, e), e) return t.checkUserUpdate(e);
      }).then(function () {
        if (e) {
          var n = e.type;switch (t.logger.log("msg::handleMsg:checkUserUpdate: " + e.scene + " " + n + " msg" + ("notification" === n ? " " + e.attach.type : ""), e), n) {case "notification":
              return t.onTeamNotificationMsg(e);}
        }
      }).then(function () {
        e && !e.ignore && (t.logger.info("msg::handleMsg:onmsg: ", e), setTimeout(function () {
          t.options.onmsg(s.copy(e));
        }, 0));
      }).then(void 0, function (e) {
        e.callFunc = "msg::handleMsg", t.onCustomError("消息处理错误", e);
      });
    }, r.putMsg = function (e, t) {
      if (s.isArray(e) || (e = [e]), e[0].filter) return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve(e);var n = this,
          r = n.db,
          o = r.enable,
          a = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve(),
          c = n.message.Message.getLastMsg(e),
          u = c.flow,
          l = c.sessionId !== n.currSessionId,
          m = n.genSessionByMsgs(e);p(m);var d = !1,
          f = [];function p(e) {
        "roamingMsgs" !== t && "offlineMsgs" !== t || n.cacheSyncedSession(e);
      }return n.checkIgnore(e), n.logger.log("start"), a = (a = (a = a.then(function () {
        return o || n.options.autoMarkRead || "roamingMsgs" === t || !m || (n.sessionUnreadMsgs = n.sessionUnreadMsgs || {}, n.sessionUnreadMsgs[m.id] = n.sessionUnreadMsgs[m.id] || [], n.sessionUnreadMsgs[m.id] = n.sessionUnreadMsgs[m.id].concat(e.filter(function (e) {
          return n.options.shouldCountNotifyUnread(e);
        }))), o && "roamingMsgs" !== t && "offlineMsgs" !== t ? (n.logger.log("msg::putMsg:db.putMsg: ", m), r.putMsg(e)) : e;
      }).then(function (t) {
        var r = [];return e.forEach(function (e) {
          n.checkMsgUnique(e) && r.push(e);
        }), e = r, f = o ? t : e, __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve(e);
      })).then(function (e) {
        return e.length && (p(m = n.genSessionByMsgs(e)), o && m) ? new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a(function (t, s) {
          r.getSessions({ sessionId: m.id }).then(function (s) {
            if (s && s.lastMsg) {
              var i = s.lastMsg;m.lastMsg && m.lastMsg.time < i.time && (m.lastMsg = i);
            }n.logger.log("msg::putMsg:db.getSessions: ", m), f.length ? m ? r.putSession(m).then(function (e) {
              t(e);
            }) : t(s) : (d = !0, f = e, t(s));
          });
        }) : __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve(m);
      })).then(function (e) {
        if (m && f.length) {
          var s = "roamingMsgs" === t,
              a = n.options.syncSessionUnread,
              c = m.id,
              g = n.findSession(c) || {},
              h = g.ack || 0;if ("offlineMsgs" === t || s && a || "onMsg" === t && "in" === u && l) {
            o && e ? (m = e, h = h || m.ack || 0) : (e = g) && (m.unread = e.unread || 0), p(m), m.unread = m.unread || 0;var y = 0;if (f.forEach(function (e) {
              var t = n.options.shouldCountNotifyUnread(e),
                  r = ("notification" !== e.type || "notification" === e.type && t) && (i(e.isUnreadable) || e.isUnreadable);if (r && a && (r = e.time > h && "out" !== e.flow), r && (y++, a && !o)) {
                var s = g.unreadMsgs || [];s.push(e), m.unreadMsgs = s;
              }
            }), console.log(m), m.unread += y, n.logger.log("msg::putMsg:updateSession: ", m), p(m), o && !d) return r.updateSession({ id: m.id, unread: m.unread });
          }
        }
      }), "onMsg" === t ? a = a.then(function () {
        e.length && m && (n.onUpdateSession(m), n.options.syncSessionUnread && !l && n.api.resetSessionUnread(n.currSessionId));
      }) : "sendMsg" === t && !l && m && m.lastMsg && m.lastMsg.isLocal && (n.onUpdateSession(m), n.api.resetSessionUnread(n.currSessionId)), a.then(function () {
        return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve(e);
      });
    }, r.putBroadcastMsgs = function (e) {
      var t = this,
          n = t.db,
          r = e.length;if (r > 0) {
        if (t.doMarkBroadcastMsgsRead(e), n.enable) {
          var i = e[r - 1].broadcastId;return n.updateBroadcastMsgTimetag(i), n.putBroadcastMsg(e).then(function () {
            return setTimeout(function () {
              t.doMarkMsgsRead(), t.options.onbroadcastmsgs(s.copy(e));
            }, 0), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve(e);
          });
        }setTimeout(function () {
          t.options.onbroadcastmsgs(s.copy(e));
        }, 0);
      }return e;
    }, r.putBroadcastMsg = function (e) {
      var t = this,
          n = t.db;return t.doMarkBroadcastMsgsRead([e]), n.enable ? (e.broadcastId && n.updateBroadcastMsgTimetag(e.broadcastId), n.putBroadcastMsg(e).then(function () {
        return setTimeout(function () {
          t.options.onbroadcastmsg(s.copy(e));
        }, 0), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve(e);
      })) : (setTimeout(function () {
        t.options.onbroadcastmsg(s.copy(e));
      }, 0), e);
    }, r.doMarkBroadcastMsgsRead = function (e) {
      e = e.map(function (e) {
        return e.broadcastId;
      }), this.sendCmd("batchMarkRead", { sid: 7, cid: 17, ids: e });
    }, r.cacheSyncedSession = function (e) {
      if (e && this.syncResult) {
        e = s.merge({}, e), this.syncResult.sessions = this.syncResult.sessions || {};var t = e.id;this.syncResult.sessions[t] = s.merge(this.syncResult.sessions[t], e), i(this.syncResult.sessions[t].unread) && (this.syncResult.sessions[t].unread = 0), this.mergeSession(this.syncResult.sessions[t]);
      }
    }, r.checkMsgUnique = s.genCheckUniqueFunc("idClient"), r.storeSendMsg = function (e) {
      if (!this.syncing) {
        var t = this.putMsg(e, "sendMsg");return this.msgPromise = this.msgPromise.then(function () {
          return t;
        }), t;
      }this.unhandledMsgs.push({ type: "sendMsg", msg: e });
    }, r.updateSendMsgError = function (e) {
      if (!this.syncing) {
        var t = this.updateMsg(e);return this.msgPromise = this.msgPromise.then(function () {
          return t;
        }), t;
      }this.unupdatedMsgs.push(e);
    }, r.onSendMsg = function (e, t) {
      var n = this,
          r = e.obj && e.obj.msg || e.content.msg;if (e.obj) i();else {
        var s = n.db;s && s.enable && s.getMsgByIdClient(r.idClient).then(function (e) {
          e && (r = e, i());
        }, function (e) {
          i();
        });
      }function i() {
        n.completeMsg(r);var s = e.error && 7101 === e.error.code;e.error && !s || (r.idServer = e.content.msg.idServer, r.time = +e.content.msg.time), e.error ? r.status = "fail" : r.status = "success", r = n.message.reverse(r), t && (r.filter = !0), e.obj = r, n.syncing ? n.unupdatedMsgs.push(r) : n.msgPromise = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.all([n.msgPromise, e.obj.promise]).then(function (e) {
          return e.length || (r.resend = !0), n.updateMsg(r).then(function () {
            return n.options.syncSessionUnread && n.currSessionId === r.sessionId && n.api.resetSessionUnread(n.currSessionId), n.resolveMsgReceiptTask(r), r;
          });
        });
      }
    }, r.updateLocalMsg = function (e) {
      var t = this.updateMsg(e);return this.msgPromise = this.msgPromise.then(function () {
        return t;
      }), t;
    }, r.updateMsg = function (e) {
      if (e.filter) return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve(e);var t = this,
          n = t.db,
          r = "success" === e.status,
          s = c.genSessionByMsg(e),
          i = !!e.isLocal;return n.enable ? n.updateMsg(e).then(function (e) {
        var o = n.updateSession(s),
            a = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve();return r && e && !i && (a = n.updateRoamingMsgTimetag(e.time)), t.onUpdateSession(s), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.all([o, a]);
      }) : (r && !i && (t.timetags.roamingMsgs = e.time), t.onUpdateSession(s), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve(e));
    }, r.updateRoamingMsgTimetag = function (e) {
      var t = this.db;return t.enable ? t.updateRoamingMsgTimetag(e) : (this.timetags.roamingMsgs = e, __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve(e));
    }, r.checkUserUpdate = function (e) {
      var t = this,
          n = e.from;return n === t.account ? __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve() : new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a(function (r) {
        var i = t.userSet[n];if (i) {
          var o = +i.updateTime,
              a = +e.userUpdateTime;!isNaN(o) && !isNaN(a) && s.isNumber(o) && s.isNumber(a) && o < a ? c() : r();
        } else c();function c() {
          t.api.getUser({ account: n, sync: !0, done: function done(e, n) {
              e || setTimeout(function () {
                t.logger.log("user::checkUserUpdate: onupdateuser", n.account, n), t.options.onupdateuser(n);
              }, 0), r();
            } });
        }
      });
    }, r.processUnsettledMsgs = function () {
      var e = this;e.unhandledMsgs.forEach(function (t) {
        var n = t.msg;switch (t.type) {case "onMsg":
            e.handleMsg(n);break;case "sendMsg":
            e.msgPromise = e.msgPromise.then(function () {
              return e.putMsg(n);
            });break;case "onBroadcastMsg":
            e.msgPromise = e.msgPromise.then(function () {
              return e.putBroadcastMsg(n);
            });}
      }), e.unupdatedMsgs.forEach(function (t) {
        e.msgPromise = e.msgPromise.then(function () {
          return e.updateMsg(t);
        });
      }), e.resetUnsettledMsgs();
    }, r.onTeamNotificationMsg = function (e) {
      this.db;var t = e.attach,
          n = t.type,
          r = e.from,
          s = e.to,
          i = e.time,
          o = t.team,
          a = t.account,
          c = t.accounts;switch (n) {case "updateTeam":
          return o.updateTime = i, this.onUpdateTeam(o);case "addTeamMembers":
          return this.onAddTeamMembers(e, o, c);case "removeTeamMembers":
          return this.onRemoveTeamMembers(o, s, c);case "acceptTeamInvite":
          return this.onAddTeamMembers(e, o, [r]);case "passTeamApply":
          return this.onAddTeamMembers(e, o, [a]);case "addTeamManagers":
          return this.updateTeamManagers(e, s, c, !0, i);case "removeTeamManagers":
          return this.updateTeamManagers(e, s, c, !1, i);case "leaveTeam":
          return this.onRemoveTeamMembers(o, s, [r]);case "dismissTeam":
          return this.onDismissTeam(s, i);case "transferTeam":
          return this.transferTeam(e, o, r, a);case "updateTeamMute":
          return this.onUpdateTeamMembersMute(e, o, [a], t.mute);}
    }, r.onAddTeamMembers = function (e, t, n) {
      var r = this,
          i = r.db,
          o = t.teamId,
          c = a.assembleMembers(t, n);e.attach.members = c;var u = { team: t, accounts: n, members: c };if (r.logger.info("team::onAddTeamMembers: ", u), r.options.onAddTeamMembers(s.simpleClone(u)), i.enable) {
        var l,
            m = i.putTeam(t);return -1 === n.indexOf(r.account) ? l = i.putTeamMembers(c) : (r.logger.warn("team::onAddTeamMembers: user join team", o), m = new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a(function (e) {
          r.api.getTeamMembers({ teamId: o, sync: !0, done: function done() {
              e();
            } });
        })), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.all([l, m]);
      }
    }, r.onRemoveTeamMembers = function (e, t, n) {
      var r = this.db,
          i = { team: e, accounts: n };if (this.logger.info("team::onRemoveTeamMembers:", i), this.options.onRemoveTeamMembers(s.simpleClone(i)), r.enable) {
        if (-1 === n.indexOf(this.account)) {
          var o = r.removeTeamMembersByAccounts(t, n),
              a = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve();return e && (a = r.putTeam(e)), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.all([o, a]);
        }return r.leaveTeam(t);
      }
    }, r.updateTeamManagers = function (e, t, n, r, i) {
      var o = this.db,
          c = e.attach.members = n.map(function (e) {
        return { id: a.genId(t, e), type: r ? "manager" : "normal", updateTime: i };
      }),
          u = { teamId: "" + t, memberUpdateTime: i };e.attach.team = u;var l = { team: u, accounts: n, isManager: r, members: c };if (this.logger.info("team::updateTeamManagers:", l), this.options.onUpdateTeamManagers(s.simpleClone(l)), o.enable) {
        var m = o.updateTeam(u),
            d = o.updateTeamManagers(t, n, r, i);return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.all([m, d]);
      }
    }, r.onDismissTeam = function (e, t) {
      var n = this.db,
          r = { teamId: e };if (this.logger.info("team::onDismissTeam:", r), this.options.onDismissTeam(r), n.enable) return n.dismissTeam(e, t);
    }, r.transferTeam = function (e, t, n, r) {
      var i = this.db,
          o = t.teamId,
          c = t.memberUpdateTime,
          u = { id: a.genId(o, n), type: "normal", updateTime: c },
          l = { id: a.genId(o, r), type: "owner", updateTime: c };e.attach.members = [u, l];var m = { team: t, from: u, to: l };if (this.logger.info("team::transferTeam:", m), this.options.onTransferTeam(s.simpleClone(m)), i.enable) return i.transferTeam(t, n, r);
    }, r.onUpdateTeamMembersMute = function (e, t, n, r) {
      var i = this.db,
          o = n.map(function (e) {
        return { id: a.genId(t.teamId, e), account: e, teamId: t.teamId, mute: r, updateTime: t.memberUpdateTime };
      });e.attach.members = o;var c = { team: t, accounts: n, members: o, mute: r };if (this.logger.info("team::onUpdateTeamMembersMute:", c), this.options.onUpdateTeamMembersMute(s.simpleClone(c)), i.enable) {
        var u = i.updateTeamMembers(o),
            l = i.putTeam(t);return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.all([u, l]);
      }
    }, r.onHistoryMsgs = function (e) {
      e.error || (e.obj.msgs = this.message.reverseMsgs(e.content.msgs));
    }, r.isFilterMsgs = function (e) {
      return !!e[0].filter;
    }, r.splitMsgs = function (e, t, n, r) {
      e.forEach(function (e) {
        if (e.filter) r.push(e);else switch (e.scene) {case "p2p":
            t.push(e);break;case "team":
            n.push(e);}
      });
    }, r.markMsgRead = function (e, t) {
      s.isArray(e) || (e = [e]);if (this.db.enable || this.options.autoMarkRead || t) {
        var n = [],
            r = [],
            i = [];this.splitMsgs(e, n, r, i), this.markP2pMsgsRead(n), this.markTeamMsgsRead(r), this.markFilterMsgsRead(i);
      }
    }, r.markP2pMsgsRead = function (e) {
      if (e.length) {
        var t = u.idMap.msg.id,
            n = u.idMap.msg.msg;this.doMarkMsgsRead(t, n, e);
      }
    }, r.markTeamMsgsRead = function (e) {
      if (e.length) {
        var t = u.idMap.team.id,
            n = u.idMap.team.teamMsg;this.doMarkMsgsRead(t, n, e);
      }
    }, r.markFilterMsgsRead = function (e) {
      if (e.length) {
        var t = u.idMap.filter.id,
            n = u.idMap.filter.filterMsg;this.doMarkMsgsRead(t, n, e);
      }
    }, r.markSysMsgRead = function (e, t) {
      s.isArray(e) || (e = [e]);var n, r;(this.db.enable || this.options.autoMarkRead || t) && (this.isFilterMsgs(e) ? (n = u.idMap.filter.id, r = u.idMap.filter.filterSysMsg) : (n = u.idMap.msg.id, r = u.idMap.msg.sysMsg), this.doMarkMsgsRead(n, r, e));
    }, r.doMarkMsgsRead = function (e, t, n) {
      n && n.length && (!n[0].attach || "netcallBill" !== n[0].attach.type && "netcallMiss" !== n[0].attach.type || (e = 9, t = 11), this.sendCmd("batchMarkRead", { sid: e, cid: t, ids: n.map(function (e) {
          return e.idServer;
        }) }));
    };
  }, function (e, t, n) {
    "use strict";
    var r = n(25).fn,
        s = n(0),
        i = n(170);r.processNotify = function (e) {
      switch (e.cmd) {case "syncOfflineMsgs":
          this.onOfflineMsgs(e);break;case "batchMarkRead":
          break;case "syncOfflineSysMsgs":
          this.onOfflineSysMsgs(e);break;case "syncRoamingMsgs":
          this.onRoamingMsgs(e);break;case "syncOfflineFilterMsgs":
          this.onOfflineMsgs(e, !0);break;case "syncOfflineFilterSysMsgs":
          this.onOfflineSysMsgs(e, !0);break;case "syncMsgReceipts":
          this.onOfflineMsgReceipts(e);break;case "syncDonnop":
          this.onDonnop(e, !0);break;case "syncSessionAck":
          this.syncSessionAck(e);break;case "syncRobots":
          this.onRobots(e);break;case "syncBroadcastMsgs":
          this.onBroadcastMsgs(e);}
    }, r.onDonnop = function (e, t) {
      if (!e.error) {
        var n = this,
            r = n.db,
            s = i.reverse(e.content.donnop);n.mergeDonnop(s);var o = n.dbDonnop();if (t) {
          var a = e.content.timetag;n.timetags.donnop = a, r.enable && (o = o.then(function () {
            return n.db.updateDonnopTimetag(a);
          })["catch"](function (e) {
            return n.logger.error("notify::onDonnop: ", e), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.reject(e);
          })), o.cmd = "donnop", n.syncPromiseArray.push(o);
        } else n.onPushNotificationMultiportConfigUpdate();
      }
    }, r.onUpdateDonnop = function (e) {
      if (!e.error) {
        var t = e.obj;t && (this.mergeDonnop(s.filterObj(t, ["shouldPushNotificationWhenPCOnline"])), this.dbDonnop(), this.onPushNotificationMultiportConfigUpdate());
      }
    }, r.getPushNotificationMultiportConfig = function () {
      return s.merge({}, this.pushNotificationMultiportConfig);
    }, r.mergeDonnop = function (e) {
      this.pushNotificationMultiportConfig = s.merge({}, this.pushNotificationMultiportConfig, e);
    }, r.dbDonnop = function () {
      return this.db.enable ? this.db.setDonnop(this.pushNotificationMultiportConfig) : __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve();
    }, r.onPushNotificationMultiportConfigUpdate = function () {
      var e = this;setTimeout(function () {
        var t = e.getPushNotificationMultiportConfig();e.logger.info("link::onPushNotificationMultiportConfigUpdate:", t), e.options.onPushNotificationMultiportConfigUpdate(t);
      });
    };
  }, function (e, t, n) {
    "use strict";
    var r = n(25).fn,
        s = n(0),
        i = s.objs2accounts,
        o = s.teams2ids,
        a = n(119),
        c = n(86);r.processTeam = function (e) {
      var t = e.error,
          n = void 0,
          r = void 0,
          s = void 0;switch (e.cmd) {case "createTeam":
          if (n = e.obj.team, t || (n = e.content.team), n = a.reverse(n), e.obj.team = n, s = c.assembleOwner(n), e.obj.owner = s, !t) {
            var i = { team: n, owner: s };this.logger.info("team::processTeam: create team", i), this.onCreateTeam(n, s);
          }break;case "syncCreateTeam":
          n = a.reverse(e.content.team), s = c.assembleOwner(n), this.logger.info("team::processTeam: sync createTeam", n, s), this.options.onsynccreateteam(n, s), this.onCreateTeam(n, s);break;case "sendTeamMsg":
          this.onSendMsg(e);break;case "teamMsg":
          this.onMsg(e);break;case "teamMsgs":
          this.onMsgs(e);break;case "addTeamMembers":case "removeTeamMembers":case "leaveTeam":case "dismissTeam":case "addTeamManagers":case "removeTeamManagers":case "transferTeam":
          break;case "updateInfoInTeam":
          t || ((r = e.obj).account = this.account, r.id = c.genId(r.teamId, r.account), r = c.reverse(r), e.obj = r, this.mergeMyTeamMembers(r), this.onUpdateTeamMember(r));break;case "updateNickInTeam":
          e.obj = c.reverse(e.obj);break;case "updateTeam":
          e.obj = a.reverse(e.obj, !0);break;case "applyTeam":
          e.error || (e.obj = a.reverse(e.content.team));break;case "passTeamApply":
          this.updateTeamSysMsgState(e, "passed");break;case "rejectTeamApply":
          this.updateTeamSysMsgState(e, "rejected");break;case "acceptTeamInvite":
          this.updateTeamSysMsgState(e, "passed"), e.error || (e.obj = a.reverse(e.content.team));break;case "rejectTeamInvite":
          this.updateTeamSysMsgState(e, "rejected");break;case "getTeam":
          e.error || (e.obj = a.reverse(e.content.team));break;case "getTeams":
          this.onTeams(e);break;case "getTeamMembers":
          this.onTeamMembers(e);break;case "syncTeams":
          this.onTeams(e);break;case "syncTeamMembers":
          this.onTeamMembers(e);break;case "getTeamHistoryMsgs":case "searchTeamHistoryMsgs":
          this.onHistoryMsgs(e);break;case "syncSendTeamMsg":
          this.onMsg(e);break;case "notifyTeamMsgReads":
          this.onTeamMsgReceipt(e);break;case "syncUpdateTeamMember":
          r = c.reverse(e.content.teamMember), this.onUpdateTeamMember(r), r.account === this.account && this.mergeMyTeamMembers(r);break;case "updateMuteStateInTeam":
          break;case "getMyTeamMembers":
          e.error || (e.obj = c.reverseMembers(e.content.teamMembers));break;case "getMutedTeamMembers":
          e.error || (e.obj = { teamId: e.obj.teamId, members: c.reverseMembers(e.content.teamMembers) });break;case "syncMyTeamMembers":
          this.onSyncMyTeamMembers(e);}
    }, r.onCreateTeam = function (e, t) {
      var n = this.db;n.enable && (n.putTeam(e), n.putTeamMembers(t)), this.options.onCreateTeam(e, t);
    }, r.onTeams = function (e) {
      e.content = e.content || {};var t,
          n = this,
          r = n.db,
          s = n.packetFromSync(e),
          i = e.content.teams || [],
          c = !0,
          u = [],
          l = [];if (e.error) switch (e.error.code) {case 803:
          e.error = null, c = !1;}var m = new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a(function (m, f) {
        var p, g;e.error ? s && f(e.error) : (!function () {
          c && i.forEach(function (e) {
            (e = a.reverse(e)).validToCurrentUser ? u.push(e) : l.push(e);
          });n.logger.info("team::onTeams: parseData", o(u), u, "invalid", o(l), l), i.length ? (c = !0, t = e.content.timetag) : c = !1;
        }(), r.enable ? (p = m, g = f, e.promise = new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a(function (e, i) {
          function o() {
            s ? (d(), e(), p()) : r.getTeams().then(function (t) {
              u = t, d(), e(), p();
            }).then(void 0, function (e) {
              e.message = "db.getTeams error", e.callFunc = "team::afterMergeData", i(e), g(e);
            });
          }c ? r.mergeTeams(u, l, t).then(function () {
            o();
          }).then(void 0, function (e) {
            var t = { callFunc: "team::onTeams:mergeData", message: "db.mergeTeams error", event: e };i(t), g(t);
          }) : (n.logger.warn("team::onTeams:mergeData: no teams need merge"), o());
        }).then(void 0, function (e) {
          throw e.message = "merge teams data error", e.callFunc = "team::mergeData", g(e), e;
        })) : (d(), m()));
      })["catch"](function (e) {
        return n.logger.error("team::onTeams: ", e), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.reject(e);
      });function d() {
        n.timetags.teams = t, u.invalid = l, s ? (n.syncResult.teams = u, n.syncResult.invalidTeams = l) : (n.logger.info("team::onTeams: not in syncing, get teams", o(u), u), e.obj = u);
      }s && (m.cmd = "teams", n.syncPromiseArray.push(m));
    }, r.onTeamMembers = function (e) {
      e.content = e.content || {};var t,
          n,
          r = this,
          s = (r.db, r.packetFromSync(e)),
          o = e.content.members || [],
          a = !0,
          u = [],
          l = [];if (e.obj && (n = e.obj.teamId), n || (n = e.content.teamId), n = "" + n, e.error) switch (e.error.code) {case 406:
          e.error = null, a = !1;}var m = new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a(function (m, d) {
        e.error ? s && (r.logger.error("team::onTeamMember: team error:", n, e.error), d({ callFunc: "team::onTeamMembers", event: e.error, message: "teamId-" + n + " 获取群成员错误" })) : (!function () {
          a && o.forEach(function (e) {
            (e = c.reverse(e)).valid ? u.push(e) : l.push(e);
          });r.logger.warn("team::onTeamMembers: parseData", n, i(u), u, "invalid", i(l), l), o.length ? (a = !0, t = e.content.timetag) : a = !1;
        }(), u.invalid = l, s ? (r.syncTeamMembersResult[n] = u, r.syncTeamMembersResult[n + "-invalid"] = l, r.timetags["team-" + n] = t) : (r.logger.info("team::onTeamMembers: not syncing, get members", n, i(u), u), e.obj = { teamId: n, members: u }), m());
      });s && (m.cmd = n, r.syncTeamMembersPromiseArray.push(m));
    }, r.onUpdateTeamMember = function (e) {
      e.updateTime || (e.updateTime = +new Date()), this.logger.info("team::onUpdateTeamMember: ", e), this.options.onupdateteammember(s.simpleClone(e));var t = { teamId: e.teamId, memberUpdateTime: e.updateTime };this.onUpdateTeam(t);var n = this.db;n.enable && n.updateTeamMember(e);
    }, r.onUpdateTeam = function (e) {
      this.logger.info("team::onUpdateTeam:", e), this.options.onUpdateTeam(s.simpleClone(e));var t = this.db;t.enable && t.updateTeam(e);
    }, r.onSyncMyTeamMembers = function (e) {
      var t = this,
          n = t.db,
          r = c.reverseMembers(e.content.teamMembers);if (t.logger.info("team::onSyncMyTeamMembers:", r), n.enable) {
        var s = n.putTeamMembers(r).then(function () {
          return n.updateMyTeamMembersTimetag(e.content.timetag);
        })["catch"](function (e) {
          return t.logger.error("team::syncMyTeamMember: ", e), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.reject(e);
        });s.cmd = "myTeamMembers", t.syncTeamMembersPromiseArray.push(s);
      }t.mergeMyTeamMembers(r);
    }, r.mergeMyTeamMembers = function (e) {
      s.isArray(e) || (e = [e]);var t = this.myTeamMembersMap = this.myTeamMembersMap || {};e.forEach(function (e) {
        var n = e.teamId;t[n] = s.merge(t[n], e);
      }), this.logger.info("team::mergeMyTeamMembers:", t);
    }, r.notifyForNewTeamMsg = function (e) {
      s.isArray(e) || (e = [e]);var t = this,
          n = this.myTeamMembersMap || {},
          r = {},
          i = [];e.forEach(function (e) {
        s.exist(n[e]) ? r[e] = n[e].muteNotiType : i.push(e);
      });var o = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve(r);return i.length && (o = t.api.getMyTeamMembers({ teamIds: i, promise: !0 }).then(function (e) {
        return t.mergeMyTeamMembers(e), e.forEach(function (e) {
          r[e.teamId] = e.muteNotiType;
        }), r;
      })), o;
    }, r.updateTeamSysMsgState = function (e, t) {
      var n,
          r = e.error;r && (t = "error", r = s.filterObj(r, "code message")), n = { idServer: e.obj.idServer, state: t }, r && (n.error = r), this.updateSysMsg(n);
    }, r.onTeamMsgReceipt = function (e) {
      var t = e.content,
          n = e.error;n && this.logger.error("team::onTeamMsgReceipt:", n), t && t.teamMsgReceipts && this.options.onTeamMsgReceipt(t);
    };
  }, function (e, t, n) {
    "use strict";
    var r = n(25).fn,
        s = n(0);r.onRobots = function (e) {
      var t = e.content;if (s.isFunction(this.options.onrobots) && Array.isArray(t.robots)) {
        var n = t.robots.filter(function (e) {
          return !!e.botid;
        });n.length > 0 && this.options.onrobots(n || []);
      }
    };
  }, function (e, t, n) {
    "use strict";
    var r = n(25).fn,
        s = n(0),
        i = s.objs2accounts,
        o = n(283),
        a = n(129);r.processFriend = function (e) {
      var t = e.obj,
          n = e.content,
          r = e.error;switch (e.cmd) {case "friendRequest":
          this.updateFriendSysMsg(e), r || this.onFriendRequest(t);break;case "syncFriendRequest":
          this.onFriendRequest(n, !0);break;case "deleteFriend":
          r || this.onDeleteFriend(t);break;case "syncDeleteFriend":
          this.onDeleteFriend(n, !0);break;case "updateFriend":
          r || this.onUpdateFriend(t);break;case "syncUpdateFriend":
          this.onUpdateFriend(n.friend, !0);break;case "getFriends":case "syncFriends":
          this.onFriends(e);break;case "syncFriendUsers":
          this.onFriendUsers(e);}
    }, r.onFriends = function (e) {
      var t,
          n = this,
          r = n.db,
          s = e.error,
          a = n.packetFromSync(e),
          c = e.content.friends,
          u = !0,
          l = [],
          m = [],
          d = new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a(function (d, p) {
        var g, h;s ? a && p(s) : (!function () {
          u && c.forEach(function (e) {
            (e = o.reverse(e)).valid ? l.push(e) : m.push(e);
          });n.logger.info("friend::onFriends: parse friends", i(l), l, "delete", i(m), m), c.length ? (u = !0, t = e.content.timetag) : u = !1;
        }(), r.enable ? (g = d, h = p, e.promise = new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a(function (e, s) {
          function i() {
            a ? (f(), e(), g()) : r.getFriends().then(function (t) {
              l = t, f(), e(), g();
            }).then(void 0, function (e) {
              e._msg = "get friends error", s(e), h(e);
            });
          }u ? r.mergeFriends(l, m, t).then(function () {
            i();
          }).then(void 0, function (e) {
            e._msg = "merge friends error", s(e), h(e);
          }) : (n.logger.info("friend::onFriends: no merge friends"), i());
        }).then(void 0, function (e) {
          throw e._msg = "merge friends data error", h(e), e;
        })) : (f(), d()));
      })["catch"](function (e) {
        return n.logger.error("friend::onFriends: ", e), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.reject(e);
      });function f() {
        n.timetags.friends = t, l.invalid = m, a ? (n.syncResult.friends = l, n.syncResult.invalidFriends = m) : (n.logger.info("friend::onFriends: get friends bingo", i(l), l), e.obj = l);
      }a && (d.cmd = "friends", n.syncPromiseArray.push(d));
    }, r.onFriendRequest = function (e, t) {
      var n = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve(),
          r = this.db,
          s = e.type;if ("addFriend" === (s = e.type = o.getTypeFromByte(s) || s) || "passFriendApply" === s) {
        var i = e.friend = o.assembleFriend(e.account);r.enable && (n = r.putFriend(i));
      }return t && this.onSyncFriendAction(e), n;
    }, r.onSyncFriendAction = function (e) {
      this.logger.info("friend::onSyncFriendActionon:", e), this.options.onsyncfriendaction(e);
    }, r.onDeleteFriend = function (e, t) {
      var n = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve(),
          r = this.db;return r.enable && (n = r.deleteFriend(e.account)), t && (e.type = "deleteFriend", this.onSyncFriendAction(e)), n;
    }, r.onUpdateFriend = function (e, t) {
      var n = this.db,
          r = o.reverse(e);n.enable && n.updateFriend(r), t && this.onSyncFriendAction({ type: "updateFriend", friend: r });
    }, r.onFriendUsers = function (e) {
      var t = this.db,
          n = e.content,
          r = n.users.map(function (e) {
        return a.reverse(e);
      });this.logger.warn("friend::onFriendUsers: parse users", i(r), r);var s = n.timetag,
          o = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve();t.enable && (o = t.mergeFriendUsers(r, s)), this.timetags.friendUsers = s, o.cmd = "friendUsers", this.syncPromiseArray.push(o), this.syncResult.users = r;
    }, r.updateFriendSysMsg = function (e) {
      var t,
          n,
          r = e.obj,
          i = e.error;if (e.obj.idServer) {
        if (i) t = "error", i = s.filterObj(i, "code message");else {
          var a = r.type;switch (a = o.getTypeFromByte(a) || a) {case "passFriendApply":
              t = "passed";break;case "rejectFriendApply":
              t = "rejected";}
        }n = { idServer: r.idServer, state: t }, i && (n.error = i), this.updateSysMsg(n);
      }
    };
  }, function (e, t, n) {
    "use strict";
    var r = n(0);function s() {}s.parse = function (e) {
      var t = r.copy(e);return t.isBlacked = "1" === t.isBlacked, t.isMuted = "1" === t.isMuted, t.createTime = +t.createTime, t.updateTime = +t.updateTime, t;
    }, e.exports = s;
  }, function (e, t, n) {
    "use strict";
    var r = n(25).fn,
        s = n(0),
        i = s.objs2accounts,
        o = n(426),
        a = n(129);r.processUser = function (e) {
      var t,
          n = this,
          r = n.db,
          s = e.obj,
          i = e.error,
          o = e.content;switch (e.cmd) {case "markInBlacklist":
          i || n.markInBlacklist(s);break;case "syncMarkInBlacklist":
          n.markInBlacklist(o, !0);break;case "markInMutelist":
          i || n.markInMutelist(s);break;case "syncMarkInMutelist":
          n.markInMutelist(o, !0);break;case "getRelations":
          i || n.onRelations(e);break;case "syncMyInfo":
          n.onMyInfo(e, !0);break;case "updateMyInfo":
          i || (s.updateTime = o.timetag, n.onUpdateMyInfo(e, s));break;case "syncUpdateMyInfo":
          n.onUpdateMyInfo(e, o.user, !0);break;case "getUsers":
          i || (t = o.users.map(function (e) {
            return e = a.reverse(e), n.mergeUser(e), e;
          }), e.obj = t, r.enable && r.putUsers(t));break;case "updateDonnop":
          n.onUpdateDonnop(e);break;case "syncUpdateDonnop":
          n.onDonnop(e, !1);}
    }, r.onMyInfo = function (e) {
      var t = this,
          n = t.db,
          r = e.error,
          s = e.content,
          i = !0,
          o = void 0,
          c = new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a(function (e, c) {
        var l, m;r ? i && (r && (r.callFunc = "user::onMyInfo"), e(r), t.syncData()) : (o = a.reverse(s.user), t.logger.info("user::onMyInfo: parseData", o), n.enable ? (l = e, m = c, n.mergeMyInfo(o, i).then(function () {
          u(), l();
        }).then(void 0, function (e) {
          e.message = "db.mergeMyInfo error", e.callFunc = "user::onMyInfo", m(e);
        })) : (u(), e()));
      })["catch"](function (e) {
        return t.logger.error("user::onMyInfo: ", e), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.reject(e);
      });function u() {
        t.timetags.myInfo = o.updateTime, i && (t.syncResult.myInfo = o);
      }i && (c.cmd = "myInfo", t.syncPromiseArray.push(c));
    }, r.onUpdateMyInfo = function (e, t, n) {
      var r = this.db,
          i = a.reverse(t),
          o = s.merge(this.myInfo, i);this.myInfo = o, n ? (this.logger.info("user::onUpdateMyInfo:", o), this.options.onupdatemyinfo(o)) : e.obj = o, r.enable && (i.account = this.account, r.updateUser(i));
    }, r.onRelations = function (e) {
      var t = this,
          n = t.db,
          r = e.error,
          s = t.packetFromSync(e),
          a = e.content.specialRelations,
          c = !0,
          u = void 0,
          l = [],
          m = [],
          d = [],
          f = [],
          p = new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a(function (p, h) {
        var y, v;r ? s && (p(r), t.syncData()) : (a.forEach(function (e) {
          var t = { account: (e = o.parse(e)).account, createTime: e.createTime, updateTime: e.updateTime };e.isBlacked ? l.push(t) : m.push(t), e.isMuted ? d.push(t) : f.push(t);
        }), t.logger.info("user::onRelations: parse blacklist", i(l), l, "delete", i(m), m), t.logger.info("user::onRelations: parse mutelist", i(d), d, "delete", i(f), f), a.length ? (c = !0, u = e.content.timetag) : c = !1, n.enable ? (y = p, v = h, e.promise = new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a(function (e, r) {
          function i() {
            s ? (g(), e(), y()) : n.getRelations().then(function (t) {
              l = t[0], d = t[1], g(), e(), y();
            }).then(void 0, function (e) {
              e.message = "db.getRelations error", e.callFunc = "user::onRelations", r(e), v(e);
            });
          }c ? n.mergeRelations(l, m, d, f, u).then(function () {
            i();
          }).then(void 0, function (e) {
            e.message = "db.mergeRelations error", e.callFunc = "user::onRelations", r(e), v(e);
          }) : (t.logger.warn("user::onRelations: no relations need merge"), i());
        }).then(void 0, function (e) {
          throw e.message = "merge relations data error", e.callFunc = "user::onRelations", v(e), e;
        })) : (g(), p()));
      })["catch"](function (e) {
        return t.logger.error("user::onRelations: ", e), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.reject(e);
      });function g() {
        t.timetags.relations = u, l.invalid = m, d.invalid = f, s ? (t.syncResult.blacklist = l, t.syncResult.mutelist = d, t.syncResult.invalidBlacklist = m, t.syncResult.invalidMutelist = f) : (t.logger.info("user::onRelations: get relations", l, d), e.obj.blacklist = l, e.obj.mutelist = d);
      }s && (p.cmd = "relations", t.syncPromiseArray.push(p));
    }, r.markInBlacklist = function (e, t) {
      var n = this.db;e.record = { account: e.account, updateTime: +new Date() }, n.enable && n.markInBlacklist(e), t && (this.logger.info("user::markInBlacklist:", e), this.options.onsyncmarkinblacklist(e));
    }, r.markInMutelist = function (e, t) {
      var n = this.db;e.record = { account: e.account, updateTime: +new Date() }, n.enable && n.markInMutelist(e), t && (this.logger.info("user::markInMutelist:", e), this.options.onsyncmarkinmutelist(e));
    }, r.mergeUser = function (e) {
      this.userSet[e.account] = e;
    };
  }, function (e, t, n) {
    "use strict";
    var r = n(13),
        s = n(27);e.exports = function (e, t, n) {
      t in e ? r.f(e, t, s(0, n)) : e[t] = n;
    };
  }, function (e, t, n) {
    "use strict";
    var r = n(37),
        s = n(17),
        i = n(48),
        o = n(132),
        a = n(131),
        c = n(69),
        u = n(428),
        l = n(108);s(s.S + s.F * !n(130)(function (e) {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(e);
    }), "Array", { from: function from(e) {
        var t,
            n,
            s,
            m,
            d = i(e),
            f = "function" == typeof this ? this : Array,
            p = arguments.length,
            g = p > 1 ? arguments[1] : void 0,
            h = void 0 !== g,
            y = 0,
            v = l(d);if (h && (g = r(g, p > 2 ? arguments[2] : void 0, 2)), null == v || f == Array && a(v)) for (n = new f(t = c(d.length)); t > y; y++) {
          u(n, y, h ? g(d[y], y) : d[y]);
        } else for (m = v.call(d), n = new f(); !(s = m.next()).done; y++) {
          u(n, y, h ? o(m, g, [s.value, y], !0) : s.value);
        }return n.length = y, n;
      } });
  }, function (e, t, n) {
    n(51), n(429), e.exports = n(7).Array.from;
  }, function (e, t, n) {
    e.exports = { default: n(430), __esModule: !0 };
  }, function (e, t, n) {
    "use strict";
    t.__esModule = !0;var r,
        s = n(431),
        i = (r = s) && r.__esModule ? r : { default: r };t["default"] = function (e) {
      if (Array.isArray(e)) {
        for (var t = 0, n = Array(e.length); t < e.length; t++) {
          n[t] = e[t];
        }return n;
      }return (0, i["default"])(e);
    };
  }, function (e, t, n) {
    "use strict";
    var r,
        s = n(432),
        i = (r = s) && r.__esModule ? r : { default: r };var o = n(25).fn,
        a = n(0),
        c = n(26),
        u = a.undef,
        l = a.objs2ids,
        m = a.objs2accounts,
        d = a.teams2ids,
        f = n(116),
        p = a.getGlobal();o.beforeSync = function () {
      var e = this.db;return e.enable ? e.clearSendingMsgs() : __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve();
    }, o.syncData = function () {
      var e = this,
          t = e.db,
          n = e.options,
          r = t.enable;function s(t) {
        e.syncPromiseArray = [], e.syncResult = {}, e.syncTeamMembersPromiseArray = [], e.syncTeamMembersResult = {}, e.checkNosReqNum = 0, e.getNosOriginUrlReqNum = 0, a.verifyBooleanWithDefault(n, "syncRelations syncFriends syncFriendUsers syncTeams syncRoamingMsgs syncMsgReceipts syncExtraTeamInfo", !0, "", "sync::syncData"), a.verifyBooleanWithDefault(n, "syncFilter syncTeamMembers", !1, "", "sync::syncData");var r = {};t = t || {}, p._nimForceSyncIM && (e.logger.warn("sync::syncData: nimForceSyncIM"), delete t.teams, p._nimForceSyncIM = !1), r.myInfo = t.myInfo || 0, r.offlineMsgs = 0, n.syncRelations && (r.relations = t.relations || 0), n.syncFriends && (r.friends = t.friends || 0), n.syncFriendUsers && (r.friendUsers = t.friendUsers || 0), n.syncRobots && (r.robots = t.robots || 0), n.syncTeams && (r.teams = t.teams || 0), n.syncRoamingMsgs && (r.roamingMsgs = t.roamingMsgs || 0), n.syncMsgReceipts && (r.msgReceipts = t.msgReceipts || 0), n.syncExtraTeamInfo && (r.myTeamMembers = t.myTeamMembers || 0), n.syncSessionUnread && (r.sessionAck = t.sessionAck || 0), n.syncBroadcastMsgs && (r.broadcastMsgs = t.broadcastMsg || 0), r.donnop = t.donnop || 0, r.deleteMsg = t.deleteMsg || 0, n.syncFilter && (r.filterMsgs = 0);var s = e.onSyncData.bind(e);s.isImSyncDataCb = !0, e.sendCmd("sync", { sync: r }, s);
      }e.syncing = !0, r ? e.beforeSync().then(function () {
        return e.db.getTimetags();
      }).then(function (e) {
        s(e);
      }, function () {
        s();
      }) : s(e.timetags);
    }, o.onSyncData = function (e, t) {
      e && this.syncRetryTimes > 3 && (this.syncRetryTimes = 0, e.callFunc = "sync::onSyncData", this.onCustomError("SYNC_DATA_ERROR", e));
    }, o.processSync = function (e) {
      switch (this.syncRetryTimes = this.syncRetryTimes || 0, this.syncRetryTimes++, e.cmd) {case "syncDone":
          e.error ? this.syncRetryTimes > 3 || this.syncData() : (this.timetags.sync = e.content.timetag, this.onSyncDone());break;case "syncTeamMembersDone":
          this.onSyncTeamMembersDone();}
    }, o.onSyncDone = function (e) {
      var t,
          n,
          r,
          s,
          o,
          p,
          g,
          h,
          y,
          v,
          b,
          M,
          T,
          S,
          k,
          P,
          I,
          C,
          O,
          w,
          x,
          A,
          _ = this,
          E = _.db,
          R = E.enable,
          U = _.options,
          j = _.syncPromiseArray,
          F = _.syncResult;if (j && j.length) {
        var N = j.filter(function (e) {
          return "sessionAck" === e.cmd;
        });0 === N.length && N.push(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve());var D = j.filter(function (e) {
          return "sessionAck" !== e.cmd;
        });0 === D.length && D.push(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve()), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.all(D).then(function () {
          return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.all(N);
        }, function (e) {
          e.callFunc = "sync::onSyncDone", e.message = "afterSync syncNormalPromise 出错", _.onCustomError("SYNC_NORMAL_ERROR", e);
        }).then(L, function (e) {
          e.callFunc = "sync::onSyncDone", e.message = "afterSync syncSessionAckPromise 出错", _.onCustomError("SYNC_SESSION_ACK_ERROR", e);
        })["catch"](function (e) {
          _.syncData();
        });
      } else L();function L() {
        if (j) {
          if (_.logger.info("sync::onSyncDone: after sync", a.promises2cmds(j)), j = [], n = F.blacklist || [], r = F.invalidBlacklist || [], s = F.mutelist || [], o = F.invalidMutelist || [], p = F.friends, g = F.invalidFriends || [], h = F.myInfo, y = F.users, v = F.teams, b = F.invalidTeams || [], M = F.sessions, T = F.msgReceipts, S = F.roamingMsgs, k = F.offlineMsgs, P = F.offlineFilterMsgs, C = F.offlineSysMsgs, O = F.offlineCustomSysMsgs, w = F.offlineFilterSysMsgs, x = F.offlineFilterCustomSysMsgs, F.broadcastMsgs, A = F.sysMsgUnread, M) {
            var e = [];__WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_keys___default()(M).forEach(function (t) {
              e.push(M[t]);
            }), M = e.sort(function (e, t) {
              return t.updateTime - e.updateTime;
            });
          }var c = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve();R && (c = function () {
            var e,
                t = [],
                n = [];S && S.forEach(function (e) {
              n = [].concat((0, i["default"])(n), (0, i["default"])(e.msgs));
            });k && k.forEach(function (e) {
              n = [].concat((0, i["default"])(n), (0, i["default"])(e.msgs));
            });return e = E.putMsg(n), t.push(e), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.all(t).then(function () {
              return n;
            });
          }().then(function (e) {
            var t = {};e.forEach(function (e) {
              var n = e.sessionId;t[n] || (t[n] = !0, _.markUnreadByMsgsPromise(n));
            });
          })), c.then(function () {
            R && !_.hasSynced && (_.hasSynced = !0, function () {
              U.syncRelations && (t = E.getRelations().then(function (e) {
                n = e[0], s = e[1], n.invalid = r, s.invalid = o;
              }, function (e) {
                return e._msg = "on relations error", e;
              })["catch"](function (e) {
                return _.logger.error("sync::syncRelation: ", e), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.reject(e);
              }), j.push(t));U.syncFriends && (t = E.getFriends().then(function (e) {
                (p = e).invalid = g;
              }, function (e) {
                return e._msg = "on friends error", e;
              })["catch"](function (e) {
                return _.logger.error("sync::syncFriends: ", e), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.reject(e);
              }), j.push(t));u(h) && (t = E.getUser(_.account).then(function (e) {
                h = e;
              }, function (e) {
                return e._msg = "on myInfo error", e;
              })["catch"](function (e) {
                return _.logger.error("sync::syncMyInfo: ", e), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.reject(e);
              }), j.push(t));U.syncFriendUsers && (t = E.getFriends().then(function (e) {
                return e.map(function (e) {
                  return e.account;
                });
              }).then(function (e) {
                return E.getUsers(e);
              }).then(function (e) {
                y = e;
              }, function (e) {
                return e._msg = "on users error", e;
              })["catch"](function (e) {
                return _.logger.error("sync::syncFriendUser: ", e), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.reject(e);
              }), j.push(t));U.syncTeams && (t = E.getTeams().then(function (e) {
                (v = e).invalid = b;
              }, function (e) {
                return e._msg = "on teams error", e;
              })["catch"](function (e) {
                return _.logger.error("sync::syncTeams: ", e), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.reject(e);
              }), j.push(t));t = E.getTeamMembersByAccount(_.account).then(function (e) {
                _.mergeMyTeamMembers(e);
              })["catch"](function (e) {
                return _.logger.error("sync::getTeamMembersByAccount: ", e), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.reject(e);
              }), j.push(t), t = E.getDonnop().then(function (e) {
                _.mergeDonnop(e);
              })["catch"](function (e) {
                return _.logger.error("sync::donnop: ", e), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.reject(e);
              }), j.push(t), t = E.getSessions().then(function (e) {
                M = e;
              }, function (e) {
                return e._msg = "on sessions error", e;
              })["catch"](function (e) {
                return _.logger.error("sync::getSession: ", e), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.reject(e);
              }), j.push(t), t = E.getSysMsgUnread().then(function (e) {
                A = e;
              }, function (e) {
                return e._msg = "on sysMsgUnread error", e;
              })["catch"](function (e) {
                return _.logger.error("sync::getSysMsgUnread: ", e), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.reject(e);
              }), j.push(t);
            }());var e = j.filter(function (e) {
              return "sessionAck" === e.cmd;
            });0 === e.length && e.push(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve());var i = j.filter(function (e) {
              return "sessionAck" !== e.cmd;
            });0 === i.length && i.push(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve()), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.all(i).then(function () {
              return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.all(e);
            }).then(B).then(q, function (e) {
              e.callFunc = "sync::onSyncDone", e.message = "taskAfterSync syncSessionAckPromise 出错", _.onCustomError("SYNC_SESSION_ACK_ERROR", e);
            });
          });
        } else _.logger.warn("sync::onSyncDone: after sync --no promiseArray");
      }function B() {
        _.logger.info("sync::onSyncDone: taskAfterSync"), function () {
          if (F.deleteMsgSysMsgs) {
            var e = {};S && S.forEach(function (t) {
              e[t.sessionId] = t;
            });var t = {};k && k.forEach(function (e) {
              t[e.sessionId] = e;
            });var n = _.api;F.deleteMsgSysMsgs.forEach(function (r) {
              r.sysMsgs.forEach(function (r) {
                var s = r.msg,
                    i = s.sessionId;[e, t].forEach(function (e) {
                  e[i] && (e[i].msgs = n.cutMsgs(e[i].msgs, s));
                });
              });
            }), E.enable || [S, k].forEach(function (e) {
              e && e.forEach(function (e) {
                if (e.msgs.length) {
                  var t = _.genSessionByMsgs(e.msgs);_.cacheSyncedSession(t), M = n.mergeSessions(M, t);
                } else M = n.cutSessions(M, { id: e.sessionId });
              });
            });
          }
        }();var e = [];return e.push(_.deleteMsgOfflineRoaming(F.deleteMsgSysMsgs, M)), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.all(e);
      }function q() {
        setTimeout(H, 0);
      }function H() {
        var e,
            t,
            r = [];n && (_.logger.info("sync::notifyDataAsync: on blacklist", m(n), n), U.onblacklist(n)), s && (_.logger.info("sync::notifyDataAsync: on mutelist", m(s), s), U.onmutelist(s)), p && (_.logger.info("sync::notifyDataAsync: on friends", m(p), p), U.onfriends(p)), h && (_.logger.info("sync::notifyDataAsync: on myInfo", h), _.myInfo = h, U.onmyinfo(a.copy(h))), y && (y.forEach(function (e) {
          _.mergeUser(e);
        }), _.logger.info("sync::notifyDataAsync: on users", m(y), y), U.onusers(y)), v && (_.logger.info("sync::notifyDataAsync: on teams", d(v), v), U.onteams(v)), T && (!_.hasSynced && M && M.length || _.hasSynced) && (M = _.mergeSessionAndMsgReceipts(M, T)), M && M.length && (M.forEach(function (e) {
          _.syncResult.sessions && _.syncResult.sessions[e.id] && "number" == typeof _.syncResult.sessions[e.id].unread && (e.unread = _.syncResult.sessions[e.id].unread), _.mergeSession(e), f.trim(e);
        }), _.logger.info("sync::notifyDataAsync: on sessions", l(M), M), U.onsessions(M)), S && S.forEach(function (e) {
          r.push(e.timetag), (t = e.msgs).length && (_.logger.info("sync::notifyDataAsync: on roaming msgs", e.sessionId, t.length, t), U.onroamingmsgs(e));
        }), k && k.forEach(function (e) {
          r.push(e.timetag), (t = e.msgs).length && (_.logger.info("sync::notifyDataAsync: on offline msgs", e.sessionId, t.length, t), U.onofflinemsgs(e));
        }), P && P.forEach(function (e) {
          r.push(e.timetag), (t = e.msgs).length && (_.logger.info("sync::notifyDataAsync: on offline filter msgs", e.sessionId, t.length, t), U.onofflinefiltermsgs(t));
        });var i = [],
            o = [];F.deleteMsgSysMsgs && F.deleteMsgSysMsgs.forEach(function (e) {
          "roaming" === e.type ? i = i.concat(e.sysMsgs) : o = o.concat(e.sysMsgs);
        }), i.length && (I = (I = I || []).concat(i)), o.length && (C = (C = C || []).concat(o)), I && (_.logger.info("sync::notifyDataAsync: on roaming sys msgs", I.length, I), U.onroamingsysmsgs(I)), C && (_.logger.info("sync::notifyDataAsync: on offline sys msgs", C.length, C), U.onofflinesysmsgs(C)), w && (_.logger.info("sync::notifyDataAsync: on offline filter sys msgs", w.length, w), U.onofflinefiltersysmsgs(w)), O && (_.logger.info("sync::notifyDataAsync: on offline custom sys msgs", O.length, O), U.onofflinecustomsysmsgs(O)), x && (_.logger.info("sync::notifyDataAsync: on offline filter custom sys msgs", x.length, x), U.onofflinefiltercustomsysmsgs(x)), A && (A = a.merge({}, _.sysMsgUnread, A), _.sysMsgUnread = a.merge({}, A), _.logger.info("sync::notifyDataAsync: on sysMsgUnread", A), U.onsysmsgunread(A));var c = _.getPushNotificationMultiportConfig();_.logger.info("sync::notifyDataAsync: on pushNotificationMultiportConfig", c), U.onPushNotificationMultiportConfig(c), r.length ? (e = Math.max.apply(Math, r), _.updateRoamingMsgTimetag(e).then(W, W)) : W(), _.syncPromiseArray = null, _.syncResult = null;
      }function W() {
        if (_.processUnsettledMsgs(), _.processUnsettledSysMsgs(), _.syncing = !1, U.onsyncdone(), U.syncTeamMembers && v && v.length) throw new c("sync team members api deprecated!");
      }
    }, o.syncTeamMembers = function (e) {
      var t,
          n,
          r = this;t = r.timetags, n = {}, t = t || {}, e.forEach(function (e) {
        n[e.teamId] = 0;
      }, r), r.sendCmd("syncTeamMembers", { sync: n }, r.onSyncTeamMembers.bind(r));
    }, o.onSyncTeamMembers = function (e, t) {
      e.callFunc = "sync::onSyncTeamMembers", e.message = "同步群成员错误", this.onCustomError("SYNC_TEAM_MEMBERS_ERROR", e);
    }, o.onSyncTeamMembersDone = function () {
      var e,
          t = this,
          n = t.db,
          r = t.options,
          s = t.syncTeamMembersResult,
          i = t.syncTeamMembersPromiseArray;function o() {
        t.logger.log("sync::onSyncTeamMembersDone: afterSync", a.promises2cmds(i)), i = [], n.enable && !t.hasSyncedTeamMembers ? (t.hasSyncedTeamMembers = !0, function () {
          if (!r.syncTeams || !r.syncTeamMembers) return l();n.getTeams().then(function (n) {
            n.forEach(function (n) {
              var r = n.teamId;e = new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a(function (e, n) {
                t.api.getTeamMembers({ teamId: r, done: function done(t, i) {
                    t && n({ callFunc: "sync::getTeamMembers: teamId-" + r, message: "sync team members error" }), s[r] = i.members || [], e();
                  } });
              }), i.push(e);
            }), i.length ? __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.all(i).then(c, function (e) {
              e.callFunc = "sync::onSyncTeamMembersDone", e.message = "pullFullData promiseArray notifyData 错误", t.onCustomError("SYNC_TEAM_MEMBERS_ERROR", e);
            }) : c();
          }, function (e) {
            e.callFunc = "sync::onSyncTeamMembersDone", e.message = "pullFullData getTeams 错误", t.onCustomError("SYNC_TEAM_MEMBERS_ERROR", e);
          });
        }()) : c();
      }function c() {
        setTimeout(u, 0);
      }function u() {
        var e, n;__WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_keys___default()(s).forEach(function (i) {
          -1 === i.indexOf("invalid") && (e = s[i], n = s[i + "-invalid"] || [], e.invalid = n, function (e, n) {
            t.logger.info("sync::onSyncTeamMembersDone: onTeamMembers", e, m(n), n), r.onteammembers({ teamId: e, members: n });
          }(i, e));
        }), l();
      }function l() {
        t.logger.info("sync::onSyncTeamMembersDone: bingo"), r.onsyncteammembersdone(), t.syncTeamMembersResult = null, t.syncTeamMembersPromiseArray = null;
      }i.length ? __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.all(i).then(o, function (e) {
        e.callFunc = "sync::onSyncTeamMembersDone", e.message = "同步群成员 syncTeamMembersPromiseArray 错误", t.onCustomError("SYNC_TEAM_MEMBERS_ERROR", e);
      })["catch"](function (e) {
        t.logger.log("sync::onSyncTeamMembersDone: syncTeamMembersPromiseArray promise ", e), o();
      }) : o();
    };
  }, function (e, t, n) {
    "use strict";
    var r = n(25).fn,
        s = n(118);r.assembleLogin = function () {
      var e = this.assembleIMLogin();return this.addPushInfo instanceof Function ? this.addPushInfo(e) : __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve({ login: e });
    }, r.afterLogin = function () {
      var e = this;this.initPush instanceof Function && this.initPush();var t = this.db;if (t.enable) {
        var n = this.account;this.options.appendAppKeyForDBName && (n += "-" + this.options.appKey), this.db.init(n).then(function () {
          e.notifyLogin(), e.syncData();
        }, function (n) {
          e.logger.warn("link::afterLogin: no db", n), t.reset(!1), e.notifyLogin(), e.syncData();
        });
      } else this.logger.info("link::afterLogin: no db"), this.notifyLogin(), this.syncData();
    }, r.processAuth = function (e) {
      switch (e.cmd) {case "login":
          e.error || (e.content = e.content || {}, this.loginAndroidPush && this.loginAndroidPush(e.content.aosPushInfo || {}), e.obj = e.content.loginRes, this.connectionId = e.content.loginRes.connectionId, this.onLoginPortsChange(e, 2));break;case "kicked":
          return void this.onKicked(e);case "multiPortLogin":
          this.onLoginPortsChange(e, e.content.state);break;case "kick":
          e.error || (e.obj.deviceIds = e.content.deviceIds);}
    }, r.onLoginPortsChange = function (e, t) {
      var n = this,
          r = e.content.loginPorts;if (r && r.length) {
        var i = !0;switch (t) {case 2:
            i = !0;break;case 3:
            i = !1;}r.forEach(function (e) {
          e.type = s.reverseType(e.type), e.time = +e.time, e.online = i;
        }), (r = r.filter(function (e) {
          return e.connectionId !== n.connectionId;
        })).length && (n.logger.info("link::onLoginPortsChange:", r), n.options.onloginportschange(r));
      }
    }, r.kickedReasons = ["", "samePlatformKick", "serverKick", "otherPlatformKick", "silentlyKick"], r.kickedMessages = ["", "不允许同一个帐号在多个地方同时登录", "被服务器踢了", "被其它端踢了", "悄悄被踢"];
  }, function (e, t, n) {
    "use strict";
    var r = n(25).fn,
        s = n(2),
        i = n(0),
        o = n(36);r.refreshSocketUrl = function () {
      var e = this,
          t = e.options,
          n = s.info,
          r = t.lbsUrl;function a(t) {
        e.socketUrls = [], (t = s.isWeixinApp ? t.data : JSON.parse(t)).common.link.forEach(function (t) {
          e.socketUrls.push(s.formatSocketUrl({ url: t, secure: e.options.secure }));
        }), t.common["link.default"].forEach(function (t) {
          t = s.formatSocketUrl({ url: t, secure: e.options.secure }), -1 === e.socketUrls.indexOf(t) && e.socketUrls.push(t);
        });try {
          s.uploadUrl = t.nosup[0];
        } catch (e) {}s.chunkUploadUrl = t["nos-chunk"] || "", e.logger.info("link::refreshSocketUrl: ajax load, got socket urls ", e.socketUrls), e.connectToUrl(e.getNextSocketUrl());
      }function c(t) {
        e.logger.error("link::refreshSocketUrl: ajax lbs error", t), e.api.reportLogs({ event: "nimlb", code: 3001 }), e.onDisconnect(!1, "link::refreshSocketUrl");
      }r = r + i.genUrlSep(r) + "k=" + t.appKey + "&id=" + t.account + "&sv=" + n.sdkVersion + "&pv=" + n.protocolVersion, e.logger.info("link::refreshSocketUrl: ajax " + r), s.isWeixinApp ? (r = r.replace(/:\d+/, ""), wx.request({ url: r, success: a, fail: c })) : o(r, { proxyUrl: i.url2origin(r) + "/lbs/res/cors/nej_proxy_frame.html", timeout: s.xhrTimeout, onload: a, onerror: c });
    };
  }, function (e, t, n) {
    "use strict";
    var r = n(52).fn,
        s = n(0),
        i = s.notundef;r.putSession = function (e) {
      return void 0 === (e = s.merge({}, e)).updateTime && e.lastMsg && e.lastMsg.time && (e.updateTime = e.lastMsg.time), delete e.unread, this.modifyOrPut({ table: "session", obj: e, key: "id", modifyObjWhenPut: { unread: 0 } });
    }, r.getSessions = function (e) {
      var t,
          n = !(e = e || {}).reverse,
          r = e.limit || 100,
          s = e.lastSessionId,
          o = e.sessionId,
          a = !1;if (i(s)) t = function t(e) {
        return !!a || (e.id === s && (a = !0), !1);
      };else if (i(o)) return this.get("session", o);return this.getAll("session", { index: "updateTime", desc: n, limit: r, filter: t });
    }, r.getSession = function (e) {
      return this.get("session", e);
    }, r.updateSession = function (e) {
      var t = this,
          n = e.id,
          r = s.filterObj(e, "ack unread lastMsg localCustom msgReceiptTime msgReceiptServerTime");return __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_keys___default()(e).forEach(function (t) {
        0 === t.indexOf("last") && (r[t] = e[t]);
      }), this.getOne("session", null, n, { modifyObj: r }).then(function (e) {
        return e ? t.logger.log("db::updateSession: " + n, r) : t.logger.warn("db::updateSession: no record " + n), e;
      });
    }, r.resetSessionUnread = function (e) {
      return this.updateSession({ id: e, unread: 0 });
    }, r.deleteSession = function (e) {
      return this.remove("session", e);
    };
  }, function (e, t, n) {
    "use strict";
    var r = n(52).fn,
        s = n(0);s.notundef;r.putBroadcastMsg = function (e) {
      var t = this;return new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a(function (n) {
        s.isArray(e) || (e = [e]);var r = [],
            i = e.length;function o() {
          0 === --i && n(r);
        }e.forEach(function (e) {
          e = s.copy(e), t.put("broadcastMsg", e).then(function (e) {
            r.push(e[0]), o();
          }, o);
        });
      });
    }, r.getBroadcastMsgs = function (e) {
      return e = e || {}, this.getAll("broadcastMsg", e);
    };
  }, function (e, t, n) {
    "use strict";
    var r = n(52).fn,
        s = n(0),
        i = s.notundef;r.putSysMsg = function (e) {
      var t = this;return new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a(function (n) {
        if (s.isArray(e) || (e = [e]), !e[0].filter) {
          var r = [],
              i = e.length;e.forEach(function (e) {
            e = s.copy(e), t.put("sysMsg", e).then(function (e) {
              r.push(e[0]), o();
            }, o);
          });
        }function o() {
          0 === --i && n(r);
        }
      });
    }, r.getSysMsgs = function (e) {
      var t = !(e = e || {}).reverse,
          n = e.limit || 100,
          r = null,
          s = null;e.category && (r = "category", s = e.category), e.type && (r = "type", s = e.type);var o,
          a = e.lastIdServer,
          c = !1,
          u = e.read;return (i(a) || i(u)) && (o = function o(e) {
        return i(a) ? (a = "" + a, c ? t() : (e.idServer === a && (c = !0), !1)) : t();function t() {
          return !i(u) || e.read === u;
        }
      }), e = { filter: o, desc: t, limit: n }, r ? this.getOnly("sysMsg", r, s, e) : this.getAll("sysMsg", e);
    }, r.getSysMsgByIdServer = function (e) {
      return this.getOne("sysMsg", "idServer", e);
    }, r.updateSysMsg = function (e) {
      var t = this;if (!e.filter) {
        var n = "" + e.idServer,
            r = s.filterObj(e, "read state error localCustom");return this.getOne("sysMsg", "idServer", n, { modifyObj: r }).then(function (e) {
          return e ? t.logger.log("db::updateSysMsg: " + n, r) : t.logger.warn("db::updateSession: " + n), e;
        });
      }
    }, r.markSysMsgRead = function (e) {
      var t = this;return new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a(function (n, r) {
        s.isArray(e) || (e = [e]);var i,
            o,
            a = [],
            c = [];e.forEach(function (e) {
          i = t.getSysMsgByIdServer(e.idServer).then(function (e) {
            e && !e.read && (o = t.updateSysMsg({ idServer: e.idServer, read: !0 }), c.push(o));
          }, r), a.push(i);
        }), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.all(a).then(function () {
          __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.all(c).then(function (e) {
            n(e);
          }, r);
        }, r);
      });
    }, r.deleteSysMsg = function (e) {
      var t,
          n = this,
          r = [];return s.isArray(e) || (e = [e]), e.forEach(function (e) {
        e = "" + e, t = n.getOne("sysMsg", "idServer", e, { remove: !0 }), r.push(t);
      }), 1 === r.length ? r[0] : __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.all(r);
    }, r.deleteAllSysMsgs = function () {
      var e = this.clearTable("sysMsg"),
          t = this.clearTable("sysMsgUnread");return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.all([e, t]);
    }, r.getSysMsgUnread = function () {
      return this.getAll("sysMsgUnread").then(function (e) {
        var t = {};return e.forEach(function (e) {
          t[e.type] = e.num;
        }), t;
      });
    }, r.updateSysMsgUnread = function (e) {
      var t = this;e = s.copy(e);var n = [];return __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_keys___default()(e).forEach(function (t) {
        n.push({ type: t, num: e[t] });
      }), this.put("sysMsgUnread", n).then(function () {
        return t.logger.log("db::updateSysMsgUnread: ", e), e;
      });
    };
  }, function (e, t, n) {
    "use strict";
    var r = n(52).fn,
        s = n(0),
        i = n(2);r.putMsg = function (e) {
      return s.isArray(e) || (e = [e]), !e.length || e[0].filter ? __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve() : (e = e.filter(function (e) {
        return !e.ignore;
      }), this.put("msg1", e));
    }, r.updateMsg = function (e) {
      var t = this;if (!e.filter) {
        var n = e.idClient,
            r = s.filterObj(e, "resend status idServer time localCustom");return t.getOne("msg1", null, n, { modifyObj: r }).then(function (e) {
          return e ? t.logger.log("db::updateMsg: " + n, r) : t.logger.warn("db::updateMsg: no record " + n), e;
        });
      }
    }, r.getMsgs = function (e) {
      return i.isBrowser ? this.getMsgsIndexedDB(e) : i.isRN ? this.getMsgsRN(e) : __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve();
    }, r.getMsgsRN = function (e) {
      var t = {};return "number" == typeof e.start && (t.lowerBound = ["time", e.start]), "number" == typeof e.end && e.end !== 1 / 0 && (t.upperBound = ["time", e.end]), t.desc = !1, t.sortIndex = "time", "boolean" == typeof e.desc && (t.desc = e.desc), "number" == typeof e.limit && (t.limit = e.limit), t.searchIndex = [], e.sessionId && t.searchIndex.push(["sessionId", e.sessionId]), "string" == typeof e.type && t.searchIndex.push(["type", e.type]), this.getAll("msg1", t);
    }, r.getMsgsIndexedDB = function (e) {
      this.checkDB();var t = "time",
          n = !1,
          r = !1,
          i = (e = e || {}).sessionId || [],
          o = e.sessionIds || [];s.isString(i) ? i = [i] : Array.isArray(i) || (i = []), s.isString(o) ? o = [o] : Array.isArray(o) || (o = []);var a = i.concat(o);1 === a.length ? (n = !0, t = "sessionTime", i = a[0]) : a.length > 1 && (n = !0, r = !0, o = a);var c = e.start || 0,
          u = e.end || 1 / 0,
          l = c,
          m = u;n && !r && (l = [i, c], m = [i, u]);var d = !1 !== e.desc,
          f = e.limit || 100,
          p = !1,
          g = !1,
          h = e.type || [],
          y = e.types || [];s.isString(h) ? h = [h] : Array.isArray(h) || (h = []), s.isString(y) ? y = [y] : Array.isArray(y) || (y = []);var v = h.concat(y);1 === v.length ? (p = !0, h = v[0]) : v.length > 1 && (p = !0, g = !0, y = v);var b = e.keyword || "",
          M = e.filterFunc,
          T = void 0;return (r || p || b || s.isFunction(M)) && (T = function T(e) {
        if (r && -1 === o.indexOf(e.sessionId)) return !1;if (p) if (g) {
          if (-1 === y.indexOf(e.type)) return !1;
        } else if (h !== e.type) return !1;if (b && -1 === (e.text || e.tip || "").indexOf(b)) return !1;return !M || M(e);
      }), this.server.query("msg1", t).bound(l, m, !0, !0).desc(d).limit(f).filter(T).execute();
    }, r.getMsgCountAfterAck = function (e) {
      return i.isBrowser ? this.getMsgCountAfterAckIndexedDB(e) : i.isRN ? this.getMsgCountAfterAckRN(e) : __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve();
    }, r.getMsgCountAfterAckRN = function (e) {
      var t = e = e || {},
          n = t.sessionId,
          r = t.ack;return this.checkDB(), this.getAll("msg1", { searchIndex: ["sessionId", n], lowerBound: ["time", r] }).then(function (t) {
        var n = t.filter(function (t) {
          return "out" !== t.flow && ("notification" !== t.type || !!e.shouldCountNotifyUnread(t));
        });return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve(n.length);
      });
    }, r.getMsgCountAfterAckIndexedDB = function (e) {
      var t = (e = e || {}).sessionId;return this.checkDB(), this.server.query("msg1", "sessionTime").bound([t, e.ack], [t, 1 / 0], !0, !0).execute().then(function (t) {
        var n = t.filter(function (t) {
          return "out" !== t.flow && ("notification" !== t.type || !!e.shouldCountNotifyUnread(t));
        });return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve(n.length);
      });
    }, r.amendMsg = function (e) {
      return e ? (s.notexist(e.text) && (e.text = ""), e) : null;
    }, r.getMsgByIdClient = function (e) {
      var t = this;return t.getOne("msg1", null, e).then(function (e) {
        return t.amendMsg(e);
      });
    }, r.getMsgsByIdClients = function (e) {
      var t,
          n = this,
          r = [];return e.forEach(function (e) {
        t = n.getMsgByIdClient(e), r.push(t);
      }), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.all(r);
    }, r.clearSendingMsgs = function () {
      var e = this;return e.getOnly("msg1", "status", "sending", { modifyObj: { status: "fail" } }).then(function (t) {
        e.logger.log("db::clearSendingMsgs: msgs send failed", t);
      });
    }, r.deleteMsg = function (e) {
      var t,
          n = this,
          r = [];return s.isArray(e) || (e = [e]), e.forEach(function (e) {
        t = n.getOne("msg1", null, e, { remove: !0 }).then(function (e) {
          return n.logger.log("db::deleteMsg:", e), e;
        }), r.push(t);
      }), 1 === r.length ? r[0] : __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.all(r);
    }, r.deleteMsgsBySessionId = function (e) {
      return this.getOnly("msg1", "sessionId", e, { remove: !0 });
    }, r.deleteAllMsgs = function () {
      var e = this.clearTable("msg1"),
          t = this.clearTable("session");return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.all([e, t]);
    };
  }, function (e, t, n) {
    "use strict";
    var r = n(52).fn,
        s = n(0);r.mergeMyInfo = function (e, t) {
      var n = this;return n.put("user", e).then(function () {
        return t ? n.updateMyInfoTimetag(e.updateTime) : e;
      });
    }, r.mergeFriendUsers = function (e, t) {
      var n = this;return n.putUsers(e).then(function () {
        n.updateFriendUserTimetag(t);
      });
    }, r.putUsers = function (e) {
      return this.put("user", e);
    }, r.putUser = function (e) {
      return this.put("user", e);
    }, r.updateUser = function (e) {
      var t = this,
          n = (e = s.copy(e)).account;return this.getOne("user", null, n, { modifyObj: e }).then(function (r) {
        return r ? t.logger.log("db::updateUser: " + n, e) : t.logger.warn("db::updateUser: no record " + n), r;
      });
    }, r.putUsersIfIsFriend = function (e) {
      var t,
          n = this,
          r = [],
          s = [];return e.forEach(function (e) {
        t = n.getFriend(e.account).then(function (r) {
          return r && (t = n.putUser(e), s.push(t)), r;
        }), r.push(t);
      }), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.all(r).then(function () {
        return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.all(s).then(function (e) {
          return e;
        });
      });
    }, r.deleteUser = function (e) {
      return this.remove("user", e);
    }, r.getUser = function (e) {
      return this.getOne("user", null, e);
    }, r.getUsers = function (e) {
      return this.getAll("user", { filter: function filter(t) {
          return -1 !== e.indexOf(t.account);
        } });
    }, r.getAllUsers = function () {
      return this.getAll("user");
    };
  }, function (e, t, n) {
    "use strict";
    var r = n(52).fn,
        s = n(0),
        i = n(26),
        o = n(119),
        a = n(86);function c(e) {
      return e.valid && e.validToCurrentUser;
    }function u(e) {
      return e && e.valid;
    }function l(e) {
      return e && s.fillUndef(e, { mute: !1, custom: "" }), e;
    }r.mergeTeams = function (e, t, n) {
      var r = this,
          s = r.put("team", e),
          i = r.leaveTeams(t, n);return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.all([s, i]).then(function () {
        return r.logger.log("db::mergeTeams:"), r.updateTeamTimetag(n), [e, t, n];
      });
    }, r.putTeam = function (e) {
      if (e) return s.isArray(e) || (e = [e]), e.forEach(function (e) {
        e.validToCurrentUser = !0;
      }), this.put("team", e);
    }, r.updateTeam = function (e) {
      var t = this,
          n = (e = s.copy(e)).teamId;return t.getOne("team", null, n, { modifyObj: e }).then(function (r) {
        return r ? (t.logger.log("db::updateTeam: " + n, e), r) : (t.logger.warn("db::updateTeam: no record " + n), t.putTeam(e));
      });
    }, r.transferTeam = function (e, t, n) {
      var r = this,
          s = e.teamId,
          i = e.memberUpdateTime,
          o = { teamId: s, account: t, type: "normal", updateTime: i },
          a = { teamId: s, account: n, type: "owner", updateTime: i };return r.updateTeamMembers([o, a]).then(function () {
        return r.putTeam(e).then(function () {
          return r.logger.log("db::transferTeam: " + e.teamId + " " + t + " -> " + n), [e, t, n];
        });
      });
    }, r.leaveTeam = function (e) {
      var t = this;return t.updateTeam({ teamId: e, validToCurrentUser: !1 }).then(function () {
        return t.removeAllTeamMembers(e);
      });
    }, r.dismissTeam = function (e, t) {
      var n = this,
          r = { teamId: e, valid: !1, validToCurrentUser: !1, updateTime: t };return n.updateTeam(r).then(function () {
        return n.removeAllTeamMembers(e);
      });
    }, r.leaveTeams = function (e, t) {
      var n,
          r = this,
          s = [];return e.forEach(function (e) {
        n = r.leaveTeam(e.teamId, t), s.push(n);
      }), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.all(s);
    }, r.getTeamsByTeamIds = function (e) {
      var t,
          n = this,
          r = [];return e.forEach(function (e) {
        t = n.getTeam(e), r.push(t);
      }), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.all(r);
    }, r.getTeam = function (e) {
      e = "" + e;var t = this;return t.getOne("team", null, e).then(function (e) {
        return e ? (t.updateTeamProperties([e]), e) : null;
      });
    }, r.getTeams = function () {
      var e = this;return e.getAll("team", { filter: c }).then(function (t) {
        return e.updateTeamProperties(t), t;
      });
    }, r.updateTeamProperties = function (e) {
      e.forEach(function (e) {
        e && o.fillProperties(e);
      });
    }, r.mergeTeamMembers = function (e, t, n, r) {
      var s = this,
          i = s.putTeamMembers(t),
          o = s.updateTeamMembers(n);return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.all([i, o]).then(function () {
        return s.logger.log("db::mergeTeamMembers: " + e), s.updateTeamMemberTimetag(e, r);
      });
    }, r.putTeamMembers = function (e) {
      return this.put("teamMember", e);
    }, r.getTeamMembersByAccount = function (e) {
      return this.getOnly("teamMember", "account", e, { filter: u, mapper: l }).then();
    }, r.getTeamMembers = function (e) {
      var t = this;e = "" + e;return t.getOnly("teamMember", "teamId", e, { filter: function filter(e) {
          return e.valid;
        }, mapper: l }).then(function (e) {
        return t.updateTeamMemberProperties(e).then(function () {
          return e;
        });
      });
    }, r.updateTeamMemberProperties = function (e) {
      var t,
          n = this,
          r = [];return e.forEach(function (e) {
        a.fillProperties(e) && (t = n.updateTeamMember(e), r.push(t));
      }), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.all(r);
    }, r.getInvalidTeamMembers = function (e, t) {
      var n = this;e = "" + e;var r,
          s = [];return t.forEach(function (t) {
        r = n.getOne("teamMember", null, a.genId(e, t)).then(function (e) {
          return l(e);
        }), s.push(r);
      }), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.all(s);
    }, r.updateTeamMember = function (e) {
      var t = this,
          n = e.teamId,
          r = e.account,
          i = a.genId(n, r),
          o = s.filterObj(e, "nickInTeam muteTeam mute custom updateTime type valid");return this.getOne("teamMember", null, i, { modifyObj: o, mapper: l }).then(function (e) {
        return e ? t.logger.log("db::updateTeamMember: " + n + " " + r, o) : t.logger.warn("db::updateTeam: no record " + n + " " + r), e;
      });
    }, r.updateTeamMembers = function (e) {
      var t = this;if (!e.length) return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve();var n,
          r = [];return e.forEach(function (e) {
        n = t.updateTeamMember(e), r.push(n);
      }), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.all(r);
    }, r.updateTeamManagers = function (e, t, n, r) {
      var s = t.map(function (t) {
        return { teamId: e, account: t, type: n ? "manager" : "normal", updateTime: r };
      });return this.updateTeamMembers(s);
    }, r.removeTeamMembersByAccounts = function (e, t) {
      var n = t.map(function (t) {
        return { teamId: e, account: t, valid: !1 };
      });return this.updateTeamMembers(n);
    }, r.removeAllTeamMembers = function (e) {
      var t = this;return t.getOnly("teamMember", "teamId", e, { modifyObj: { valid: !1 } }).then(function () {
        return t.logger.warn("db::removeAllTeamMembers: " + e), t.deleteTeamMemberTimetag(e);
      });
    }, r.deleteTeamMembers = function (e) {
      var t = this;return t.getOnly("teamMember", "teamId", e, { remove: !0 }).then(function () {
        t.logger.warn("db::deleteTeamMembers: " + e), t.deleteTeamMemberTimetag(e);
      });
    }, r.deleteTeam = function (e) {
      var t,
          n = this,
          r = [];return s.isArray(e) || (e = [e]), e.forEach(function (e) {
        e = "" + e, t = n.get("team", e).then(function (t) {
          if (t && c(t)) throw i.stillInTeamError({ callFunc: "team::deleteTeam", team: t });var r = n.remove("team", e),
              s = n.deleteTeamMembers(e);return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.all([r, s]);
        }), r.push(t);
      }), 1 === r.length ? r[0] : __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.all(r);
    };
  }, function (e, t, n) {
    "use strict";
    var r = n(52).fn,
        s = n(0);r.mergeFriends = function (e, t, n) {
      var r = this;return r.updateAndDelete("friend", e, t).then(function () {
        return r.logger.log("db::mergeFriends: updateAndDelete done", e), n && r.updateFriendTimetag(n), [e, t, n];
      });
    }, r.putFriend = function (e) {
      return this.put("friend", e);
    }, r.updateFriend = function (e) {
      var t = this,
          n = (e = s.copy(e)).account;return this.getOne("friend", null, n, { modifyObj: e }).then(function (r) {
        return r ? t.logger.log("db::updateFriend: " + n, e) : t.logger.warn("db::updateFriend: no record " + n), r;
      });
    }, r.deleteFriend = function (e) {
      var t = this.remove("friend", e),
          n = this.deleteUser(e);return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.all([t, n]);
    }, r.getFriends = function () {
      return this.getAll("friend", { filter: function filter(e) {
          return e.valid;
        } });
    }, r.getFriend = function (e) {
      return this.getOne("friend", null, e);
    };
  }, function (e, t, n) {
    "use strict";
    var r = n(52).fn,
        s = n(0);r.mergeRelations = function (e, t, n, r, s) {
      var i = this,
          o = i.updateAndDelete("blacklist", e, t),
          a = i.updateAndDelete("mutelist", n, r);return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.all([o, a]).then(function () {
        return i.logger.log("db::mergeRelations: timetag " + s), i.updateRelationTimetag(s), [e, t, n, r, s];
      });
    }, r.getRelations = function () {
      var e = this.getAll("blacklist"),
          t = this.getAll("mutelist");return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.all([e, t]);
    }, r.markInBlacklist = function (e) {
      if ((e = s.copy(e)).isAdd) {
        var t = e.record;return this.put("blacklist", t);
      }var n = e.account;return this.remove("blacklist", n);
    }, r.markInMutelist = function (e) {
      if ((e = s.copy(e)).isAdd) {
        var t = e.record;return this.put("mutelist", t);
      }var n = e.account;return this.remove("mutelist", n);
    };
  }, function (e, t, n) {
    "use strict";
    var r = n(52).fn;r.getTimetags = function (e) {
      var t = {};return this.getAll("timetag", { filter: e, mapper: function mapper(e) {
          return -1 !== e.name.indexOf("team-") ? t[e.name] = 0 : t[e.name] = e.value, e;
        } }).then(function () {
        return t;
      });
    }, r.getTeamMemberTimetags = function () {
      return this.getTimetags(function (e) {
        return -1 !== e.name.indexOf("team-");
      });
    }, r.getTimetag = function (e) {
      return this.getOne("timetag", null, e).then(function (e) {
        return (e = e || { value: 0 }).value;
      });
    }, r.getTeamMemberTimetag = function (e) {
      return 0;
    }, r.updateTimetag = function (e, t) {
      var n = { name: e, value: t };return this.put("timetag", n);
    }, r.updateMyInfoTimetag = function (e) {
      return this.updateTimetag("myInfo", e);
    }, r.updateRelationTimetag = function (e) {
      return this.updateTimetag("relations", e);
    }, r.getRelationsTimetag = function () {
      return this.getTimetag("relations");
    }, r.updateFriendTimetag = function (e) {
      return this.updateTimetag("friends", e);
    }, r.getFriendsTimetag = function () {
      return this.getTimetag("friends");
    }, r.updateFriendUserTimetag = function (e) {
      return this.updateTimetag("friendUsers", e);
    }, r.updateTeamTimetag = function (e) {
      return this.updateTimetag("teams", e);
    }, r.getTeamsTimetag = function () {
      return this.getTimetag("teams");
    }, r.updateTeamMemberTimetag = function (e, t) {
      return this.updateTimetag("team-" + e, t);
    }, r.getTeamMembersTimetag = function (e) {
      return this.getTimetag("team-" + e);
    }, r.updateMyTeamMembersTimetag = function (e) {
      return this.updateTimetag("myTeamMembers", e);
    }, r.getBroadcastMsgTimetag = function (e) {
      return this.getTimetag("broadcastMsg");
    }, r.updateBroadcastMsgTimetag = function (e) {
      return this.updateTimetag("broadcastMsg", parseInt(e));
    }, r.updateRoamingMsgTimetag = function (e) {
      return this.updateTimetag("roamingMsgs", e);
    }, r.updateMsgReceiptsTimetag = function (e) {
      return this.updateTimetag("msgReceipts", e);
    }, r.updateDonnopTimetag = function (e) {
      return this.updateTimetag("donnop", e);
    }, r.updateDeleteMsgTimetag = function (e) {
      return this.updateTimetag("deleteMsg", e);
    }, r.updateSessionAck = function (e) {
      return this.updateTimetag("sessionAck", e);
    }, r.deleteTimetag = function (e) {
      return this.remove("timetag", e);
    }, r.deleteTeamMemberTimetag = function (e) {
      return this.deleteTimetag("team-" + e);
    };
  }, function (e, t, n) {
    "use strict";
    var r = n(52).fn;r.setKey = function (e, t) {
      return this.put("kv", { key: e, value: t });
    }, r.getKey = function (e) {
      return this.get("kv", e).then(function (e) {
        return e && e.value;
      });
    }, r.setDonnop = function (e) {
      return this.setKey("donnop", e);
    }, r.getDonnop = function () {
      return this.getKey("donnop");
    };
  }, function (e, t, n) {
    "use strict";
    var r = { version: 8 },
        s = { kv: { key: { keyPath: "key" } }, timetag: { key: { keyPath: "name" } }, blacklist: { key: { keyPath: "account" } }, mutelist: { key: { keyPath: "account" } }, friend: { key: { keyPath: "account" } }, user: { key: { keyPath: "account" } }, team: { key: { keyPath: "teamId" } }, teamMember: { key: { keyPath: "id" }, indexes: { teamId: { unique: !1 }, account: { unique: !1 } } }, msg: { key: { autoIncrement: !0 }, indexes: { idClient: { unique: !0 }, sessionId: { unique: !1 }, time: { unique: !1 }, type: { unique: !1 }, sessionType: { unique: !1 }, status: { unique: !1 }, sessionTime: { key: ["sessionId", "time"], unique: !1 } } }, msg1: { key: { keyPath: "idClient" }, indexes: { sessionId: { unique: !1 }, time: { unique: !1 }, status: { unique: !1 }, sessionTime: { key: ["sessionId", "time"], unique: !1 } } }, broadcastMsg: { key: { keyPath: "broadcastId" }, indexes: { time: { unique: !1 } } }, sysMsg: { key: { autoIncrement: !0 }, indexes: { idServer: { unique: !0 }, category: { unique: !1 }, type: { unique: !1 } } }, sysMsgUnread: { key: { keyPath: "type" } }, session: { key: { keyPath: "id" }, indexes: { updateTime: { unique: !1 } } } };r.keyPath = function (e) {
      return s[e].key.keyPath;
    }, r.schema = function () {
      return window._nimForceSyncIM = !0, s;
    }, e.exports = r;
  }, function (e, t, n) {
    "use strict";
    (function (r) {
      var s,
          i,
          o = n(9),
          a = (i = o) && i.__esModule ? i : { default: i };!function (i, o) {
        var c,
            u = (i = void 0 !== i ? i : "undefined" != typeof self ? self : void 0 !== r ? r : {}).IDBKeyRange || i.webkitIDBKeyRange,
            l = "readonly",
            m = "readwrite",
            d = Object.prototype.hasOwnProperty,
            f = function f() {
          if (!c && !(c = i.indexedDB || i.webkitIndexedDB || i.mozIndexedDB || i.oIndexedDB || i.msIndexedDB || (null === i.indexedDB && i.shimIndexedDB ? i.shimIndexedDB : void 0))) throw "IndexedDB required";return c;
        },
            p = function p(e) {
          return e;
        },
            g = function g(e) {
          return Object.prototype.toString.call(e).slice(8, -1).toLowerCase();
        },
            h = function h(e) {
          return "function" == typeof e;
        },
            y = function y(e) {
          return void 0 === e;
        },
            v = function v(e, t) {
          var n = this,
              r = !1;this.name = t, this.getIndexedDB = function () {
            return e;
          }, this.add = function (t) {
            if (r) throw "Database has been closed";for (var s = [], i = 0, o = 0; o < arguments.length - 1; o++) {
              if (Array.isArray(arguments[o + 1])) for (var a = 0; a < arguments[o + 1].length; a++) {
                s[i] = arguments[o + 1][a], i++;
              } else s[i] = arguments[o + 1], i++;
            }var c = e.transaction(t, m),
                u = c.objectStore(t);return new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a(function (e, t) {
              s.forEach(function (e) {
                var t;if (e.item && e.key) {
                  var n = e.key;e = e.item, t = u.add(e, n);
                } else t = u.add(e);t.onsuccess = function (t) {
                  var n = t.target,
                      r = n.source.keyPath;null === r && (r = "__id__"), __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_define_property___default()(e, r, { value: n.result, enumerable: !0 });
                };
              }), c.oncomplete = function () {
                e(s, n);
              }, c.onerror = function (e) {
                e.preventDefault(), t(e);
              }, c.onabort = function (e) {
                t(e);
              };
            });
          }, this.updateAndDelete = function (t, n, s) {
            if (r) throw "Database has been closed";var i = e.transaction(t, m),
                o = i.objectStore(t),
                a = o.keyPath;return new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a(function (e, t) {
              n.forEach(function (e) {
                if (e.item && e.key) {
                  var t = e.key;e = e.item, o.put(e, t);
                } else o.put(e);
              }), s.forEach(function (e) {
                o["delete"](e[a]);
              }), i.oncomplete = function () {
                e([n, s]);
              }, i.onerror = function (e) {
                t(e);
              };
            });
          }, this.update = function (t) {
            if (r) throw "Database has been closed";for (var s, i = [], o = 1; o < arguments.length; o++) {
              s = arguments[o], Array.isArray(s) ? i = i.concat(s) : i.push(s);
            }var a = e.transaction(t, m),
                c = a.objectStore(t);c.keyPath;return new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a(function (e, t) {
              i.forEach(function (e) {
                var t;if (e.item && e.key) {
                  var n = e.key;e = e.item, t = c.put(e, n);
                } else t = c.put(e);t.onsuccess = function (e) {}, t.onerror = function (e) {};
              }), a.oncomplete = function () {
                e(i, n);
              }, a.onerror = function (e) {
                t(e);
              }, a.onabort = function (e) {
                t(e);
              };
            });
          }, this.remove = function (t, n) {
            if (r) throw "Database has been closed";var s = e.transaction(t, m),
                i = s.objectStore(t);return new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a(function (e, t) {
              Array.isArray(n) || (n = [n]), n.forEach(function (e) {
                i["delete"](e);
              }), s.oncomplete = function () {
                e(n);
              }, s.onerror = function (e) {
                t(e);
              }, s.onabort = function (e) {
                t(e);
              };
            });
          }, this.clear = function (t) {
            if (r) throw "Database has been closed";var n = e.transaction(t, m);n.objectStore(t).clear();return new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a(function (e, t) {
              n.oncomplete = function () {
                e();
              }, n.onerror = function (e) {
                t(e);
              };
            });
          }, this.close = function () {
            r || (e.close(), r = !0, delete T[t]);
          }, this.get = function (t, n) {
            if (r) throw "Database has been closed";var s = e.transaction(t),
                i = s.objectStore(t).get(n);return new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a(function (e, t) {
              i.onsuccess = function (t) {
                e(t.target.result);
              }, s.onerror = function (e) {
                t(e);
              };
            });
          }, this.query = function (t, n) {
            if (r) throw "Database has been closed";return new b(t, e, n);
          }, this.count = function (t, n) {
            if (r) throw "Database has been closed";e.transaction(t).objectStore(t);
          };for (var s = 0, i = e.objectStoreNames.length; s < i; s++) {
            !function (e) {
              for (var t in n[e] = {}, n) {
                d.call(n, t) && "close" !== t && (n[e][t] = function (t) {
                  return function () {
                    var r = [e].concat([].slice.call(arguments, 0));return n[t].apply(n, r);
                  };
                }(t));
              }
            }(e.objectStoreNames[s]);
          }
        },
            b = function b(e, t, n) {
          var r = this,
              s = !1,
              i = !1,
              o = function o(r, _o, c, d, f, p, g) {
            return new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a(function (y, v) {
              var b = s || i ? m : l,
                  M = t.transaction(e, b),
                  T = M.objectStore(e),
                  S = n ? T.index(n) : T,
                  k = r ? u[r].apply(null, _o) : null,
                  P = [],
                  I = [k],
                  C = 0;f = f || null, p = p || [], "count" !== c && I.push(d || "next");var O = !!s && __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_keys___default()(s);S[c].apply(S, I).onsuccess = function (e) {
                var t = e.target.result;if ((void 0 === t ? "undefined" : (0, a["default"])(t)) === (0, a["default"])(0)) P = t;else if (t) if (null !== f && f[0] > C) C = f[0], t.advance(f[0]);else if (null !== f && C >= f[0] + f[1]) ;else {
                  var n = !0,
                      r = "value" in t ? t.value : t.key;p.forEach(function (e) {
                    e && e.length && (2 === e.length ? n = n && r[e[0]] === e[1] : h(e[0]) && (n = n && e[0].apply(void 0, [r])));
                  }), n && (C++, P.push(g(r)), i ? t["delete"]() : s && (r = function (e) {
                    for (var t = 0; t < O.length; t++) {
                      var n = O[t],
                          r = s[n];r instanceof Function && (r = r(e)), e[n] = r;
                    }return e;
                  }(r), t.update(r))), t["continue"]();
                }
              }, M.oncomplete = function () {
                y(P);
              }, M.onerror = function (e) {
                v(e);
              }, M.onabort = function (e) {
                v(e);
              };
            });
          },
              c = function c(e, t) {
            var n = "next",
                r = "openCursor",
                a = [],
                c = null,
                u = p,
                l = !1,
                m = function m() {
              return o(e, t, r, l ? n + "unique" : n, c, a, u);
            },
                d = function d() {
              return n = null, r = "count", { execute: m };
            },
                f = function e() {
              var t;return t = arguments[0], 1 == (c = "array" === g(t) ? arguments[0] : Array.prototype.slice.call(arguments, 0, 2)).length && c.unshift(0), function (e) {
                return "number" === g(e);
              }(c[1]) || (c = null), { execute: m, count: d, keys: v, filter: b, asc: M, desc: T, distinct: S, modify: k, limit: e, map: P, remove: I };
            },
                v = function e(t) {
              return (t = !!y(t) || !!t) && (r = "openKeyCursor"), { execute: m, keys: e, filter: b, asc: M, desc: T, distinct: S, modify: k, limit: f, map: P, remove: I };
            },
                b = function e() {
              return a.push(Array.prototype.slice.call(arguments, 0, 2)), { execute: m, count: d, keys: v, filter: e, asc: M, desc: T, distinct: S, modify: k, limit: f, map: P, remove: I };
            },
                M = function e(t) {
              return t = !!y(t) || !!t, n = t ? "next" : "prev", { execute: m, count: d, keys: v, filter: b, asc: e, desc: T, distinct: S, modify: k, limit: f, map: P, remove: I };
            },
                T = function e(t) {
              return t = !!y(t) || !!t, n = t ? "prev" : "next", { execute: m, count: d, keys: v, filter: b, asc: M, desc: e, distinct: S, modify: k, limit: f, map: P, remove: I };
            },
                S = function e(t) {
              return t = !!y(t) || !!t, l = t, { execute: m, count: d, keys: v, filter: b, asc: M, desc: T, distinct: e, modify: k, limit: f, map: P, remove: I };
            },
                k = function e(t) {
              return s = t, { execute: m, count: d, keys: v, filter: b, asc: M, desc: T, distinct: S, modify: e, limit: f, map: P, remove: I };
            },
                P = function e(t) {
              return h(t) && (u = t), { execute: m, count: d, keys: v, filter: b, asc: M, desc: T, distinct: S, modify: k, limit: f, map: e, remove: I };
            },
                I = function e(t) {
              return t = !!y(t) || !!t, i = t, { execute: m, count: d, keys: v, filter: b, asc: M, desc: T, distinct: S, modify: k, limit: f, map: P, remove: e };
            };return { execute: m, count: d, keys: v, filter: b, asc: M, desc: T, distinct: S, modify: k, limit: f, map: P, remove: I };
          };"only bound upperBound lowerBound".split(" ").forEach(function (e) {
            r[e] = function () {
              return new c(e, arguments);
            };
          }), this.filter = function () {
            var e = new c(null, null);return e.filter.apply(e, arguments);
          }, this.all = function () {
            return this.filter();
          };
        },
            M = function M(e, t, n, r) {
          var s = e.target.result,
              i = new v(s, t);return T[t] = s, __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve(i);
        },
            T = {},
            S = { version: "0.10.2", open: function open(e) {
            var t;return new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a(function (n, r) {
              if (T[e.server]) M({ target: { result: T[e.server] } }, e.server, e.version, e.schema).then(n, r);else {
                try {
                  t = f().open(e.server, e.version);
                } catch (e) {
                  r(e);
                }t.onsuccess = function (t) {
                  M(t, e.server, e.version, e.schema).then(n, r);
                }, t.onupgradeneeded = function (t) {
                  !function (e, t, n) {
                    for (var r in "function" == typeof t && (t = t()), t) {
                      var s,
                          i = t[r];for (var o in s = !d.call(t, r) || n.objectStoreNames.contains(r) ? e.currentTarget.transaction.objectStore(r) : n.createObjectStore(r, i.key), i.indexes) {
                        var a = i.indexes[o];try {
                          s.index(o);
                        } catch (e) {
                          s.createIndex(o, a.key || o, __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_keys___default()(a).length ? a : { unique: !1 });
                        }
                      }
                    }
                  }(t, e.schema, t.target.result);
                }, t.onerror = function (e) {
                  r(e);
                };
              }
            });
          }, remove: function remove(e) {
            return new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a(function (t, n) {
              if (!e) return t();var r, s;(void 0 === e ? "undefined" : (0, a["default"])(e)) === v && (e = e.name), "string" == typeof e && (r = T[e]), r && "function" == typeof r.close && r.close();try {
                s = f().deleteDatabase(e);
              } catch (e) {
                n(e);
              }s.onsuccess = function (n) {
                delete T[e], t(e);
              }, s.onerror = function (e) {
                n(e);
              }, s.onblocked = function (e) {
                n(e);
              };
            });
          } };void 0 !== e && void 0 !== e.exports ? e.exports = S : void 0 === (s = function () {
          return S;
        }.call(t, n, t, e)) || (e.exports = s);
      }(window);
    }).call(this, n(31));
  }, function (e, t, n) {
    "use strict";
    var r = n(22),
        s = n(68),
        i = n(447),
        o = n(446),
        a = n(0),
        c = n(172),
        u = n(26),
        l = u.newSupportDBError,
        m = u.noDBError,
        d = !1;function f(e) {
      d = e, c.set("db", e, i);
    }if (f(!!a.getGlobal().indexedDB), "IE" === r.name && f(!1), "Microsoft Edge" === r.name && f(!1), "Safari" === r.name) {
      try {
        parseInt(r.version.split(".")[0], 10) < 10 && f(!1);
      } catch (e) {}f(!1);
    }function p(e) {
      this.concurrency = 0, this.pendingTasks = [], this.queue = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve(), this.logger = e.logger;
    }var g = p.prototype;g.reset = a.emptyFunc, d && (g.reset = function (e) {
      this.enable = !1 !== e;
    }), g.addTask = function (e) {
      var t = this;return new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a(function (n, r) {
        function s(e) {
          t.concurrency--;var n = t.pendingTasks.shift();n && t.addTask(n), e();
        }if (t.concurrency < 100) return t.concurrency++, e().then(function (t) {
          s(function () {
            n(t), e.resolve && e.resolve(t);
          });
        }, function (t) {
          s(function () {
            var n = { event: (t = t || {}).event || t, callFunc: t.callFunc || "db::addTask" };r(n), e.reject && e.reject(n);
          });
        });e.resolve || (e.resolve = n, e.reject = r), t.pendingTasks.push(e);
      });
    }, g.init = function (e) {
      var t = this;return t.addTask(function () {
        return t.enable ? t.server ? __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve() : (t.name = "nim-" + e, i.open({ server: t.name, version: o.version, schema: o.schema }).then(function (e) {
          t.logger.log("db::init: " + t.name), t.server = e;
        }, function (e) {
          throw f(!1), t.server = null, t.name = null, e;
        })) : __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.reject(l({ callFunc: "db::init" }));
      });
    }, g.destroy = function () {
      var e = this;return e.addTask(function () {
        return e.enable ? e.server ? i.remove(e.name).then(function () {
          e.logger.log("db::destroy: " + e.name), e.server = null, e.name = null;
        }) : __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve() : __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.reject(l({ callFunc: "db::destroy" }));
      });
    }, g.clear = function () {
      var e = this;return e.addTask(function () {
        return e.enable ? e.server ? e.server.clear("timetag").then(function () {
          var t = [].slice.call(e.server.getIndexedDB().objectStoreNames),
              n = [];if (t.forEach(function (t) {
            n.push(e.server.clear(t));
          }), n.length) return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.all(n).then(function () {
            e.logger.log("db::clear: " + e.name);
          })["catch"](function (t) {
            return e.logger.error("db::clear: ", t), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.reject(t);
          });
        }) : __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.resolve() : __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.reject(l({ callFunc: "db::clear" }));
      });
    }, g.close = function () {
      this.server && (this.server.close(), this.server = null, this.name = null);
    }, g.remove = function (e, t) {
      var n = this;return n.addTask(function () {
        return n.checkDB(), a.isArray(t) || (t = [t]), n.server.remove(e, t).then(function () {
          n.logger.log("db::delete: " + e + " " + (1 === t.length ? t[0] : t));
        });
      });
    }, g.put = function (e, t) {
      var n = this;return n.addTask(function () {
        return n.checkDB(), a.isArray(t) || (t = [t]), n.server.update(e, t).then(function (t) {
          var r = ["put", e],
              i = o.keyPath(e),
              a = [];return i && (t.forEach(function (e) {
            a.push(s(e, i));
          }), r.push(1 === a.length ? a[0] : a)), r.push(1 === t.length ? t[0] : t), r.unshift("db::put:"), n.logger.log.apply(n.logger.log, r), t;
        });
      });
    }, g.get = function (e, t) {
      var n = this;return n.addTask(function () {
        return n.checkDB(), n.server.get(e, t);
      });
    }, g.modifyOrPut = function (e) {
      var t = this,
          n = e.table,
          r = a.copy(e.obj),
          s = e.key,
          i = e.modifyObjWhenPut,
          o = a.copy(r);return delete o[s], t.getOne(n, null, r[s], { modifyObj: o }).then(function (e) {
        return e ? (t.logger.log("db::modifyOrPut: update table " + n, r), e) : (r = a.merge(r, i), t.put(n, r).then(function (e) {
          return e[0];
        }));
      });
    }, g.updateAndDelete = function (e, t, n) {
      var r = this;return r.addTask(function () {
        return r.checkDB(), r.server.updateAndDelete(e, t, n);
      });
    }, g.getAll = function (e, t) {
      var n = this;return n.addTask(function () {
        return n.checkDB(), (t = t || {}).keys = !0 === t.keys, t.desc = !0 === t.desc, t.distinct = !0 === t.distinct, n.server.query(e, t.index).filter(t.filter).keys(t.keys).desc(t.desc).limit(t.limit).distinct(t.distinct).map(t.mapper).modify(t.modifyObj).execute();
      });
    }, g.getOnly = function (e, t, n, r) {
      var s = this;return s.addTask(function () {
        return s.checkDB(), (r = r || {}).keys = !0 === r.keys, r.desc = !0 === r.desc, r.distinct = !0 === r.distinct, r.remove = !0 === r.remove, s.server.query(e, t).only(n).filter(r.filter).keys(r.keys).desc(r.desc).limit(r.limit).distinct(r.distinct).map(r.mapper).modify(r.modifyObj).remove(r.remove).execute();
      });
    }, g.getOne = function () {
      return this.getOnly.apply(this, arguments).then(function (e) {
        return e[0];
      });
    }, g.clearTable = function (e) {
      var t = this;return t.addTask(function () {
        return t.checkDB(), t.server.clear(e);
      });
    }, g.checkDB = function () {
      if (!this.enable) throw l({ callFunc: "db::checkDB" });if (!this.server) throw m({ callFunc: "db::checkDB" });
    }, e.exports = p;
  }, function (e, t, n) {
    "use strict";
    n(140);var r = n(32);n(168)(r), e.exports = r;
  }]);
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(454)(module)))

/***/ }),

/***/ 19:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getUserInfo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_ua__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__comm_utils__ = __webpack_require__(73);






function getUserInfo() {
  if (__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('MT_USER_INFO') !== undefined) {
    return {};
  }

  var userInfo = __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('userInfo') ? JSON.parse(__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('userInfo')) : null;
  if (!userInfo) {
    var mtCode = Number(__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('mtcode') || -1);
    if (mtCode !== -1) {
      userInfo = {
        encUserId: __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('mtencUserId'),
        isHaveMobile: __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('mtisHaveMobile'),
        name: __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('mtname'),
        token: __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('mttoken')
      };
    }
  }
  if (!userInfo && window.localStorage && !__WEBPACK_IMPORTED_MODULE_3__lib_ua__["a" /* browser */].wx) {
    var userInfoStr = window.localStorage.getItem('userinfo');
    userInfo = userInfoStr ? JSON.parse(userInfoStr) : null;
  }
  if (userInfo) {
    __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set('userInfo', userInfo);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__comm_utils__["a" /* updateLoginInfo */])({ token: userInfo.token, userInfo: userInfo });
  }
  return userInfo;
}

var auth = {
  check: function check(type) {
    if (type === 'expert') {
      var expertInfo = __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('expertInfo') ? JSON.parse(__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('expertInfo')) : null;
      return expertInfo && expertInfo.token !== null;
    }

    var userInfo = __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('userInfo') ? JSON.parse(__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('userInfo')) : null;
    if (userInfo) {
      var userSource = userInfo.userSource;
      var weixinUserInfo = userInfo.weixinUserInfo ? userInfo.weixinUserInfo : null;
      if (userSource === 0) {
        if (weixinUserInfo) {
          return true;
        }
        return false;
      }
      return userInfo.token !== null;
    }

    var mtCode = Number(__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('mtcode') || -1);
    var mtTokenStr = __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('mttoken') ? __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('mttoken') : null;
    var appEncUserId = null;
    if (!mtTokenStr && __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('MT_USER_INFO')) {
      var fck = __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('MT_USER_INFO').split(',');
      mtTokenStr = __WEBPACK_IMPORTED_MODULE_1__lib_utils__["a" /* util */].base64Decode(fck[3]);
      appEncUserId = __WEBPACK_IMPORTED_MODULE_1__lib_utils__["a" /* util */].base64Decode(fck[5]);
    }
    return !__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('MT_USER_INFO') ? mtTokenStr && mtCode === 0 : !!mtTokenStr && !!appEncUserId;
  },
  login: function login(type, code, next, isMsgList) {
    if (type === 'expert' && !code) {
      if (isMsgList) {
        location.href = __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].babytreeAjaxPrefix + '/app/dayima/expert/user/login?source=msglist';
        return;
      }
      location.href = __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].babytreeAjaxPrefix + '/app/dayima/expert/user/login?source=meitun';
    } else if (type === 'user' && __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('MT_USER_INFO')) {
      location.href = '//m.meitun.com/live/?mtoapp=5';
    } else if (type === 'user' && !code && __WEBPACK_IMPORTED_MODULE_3__lib_ua__["a" /* browser */].wx) {
      location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx5699bb5297ae3984&redirect_uri=' + encodeURIComponent(document.URL) + '&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect';
    } else if (type === 'dayima' && !code && __WEBPACK_IMPORTED_MODULE_3__lib_ua__["a" /* browser */].wx) {
      location.href = __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].babytreeAjaxPrefix + '/app/dayima/expert/user/login?source=mtverify';
    } else if (type === 'user' && !__WEBPACK_IMPORTED_MODULE_3__lib_ua__["a" /* browser */].wx) {
      location.href = __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].babytreeLoginPrefix + '/reg/signin.php?url=' + encodeURIComponent(location.protocol + '//m.meitun.com/mobile/system/bbtUnionLogin.htm?redirect_url=' + encodeURIComponent(encodeURIComponent(document.URL)));
    } else if (next) {
      next();
    } else {
      location.href = '//m.meitun.com/live/';
    }
  },
  clear: function clear() {
    __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set('userInfo', '', { expires: -1 });
    __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set('expertInfo', '', { expires: -1 });
    if (window.localStorage) {
      window.localStorage.removeItem('userinfo');
      window.localStorage.removeItem('token');
    }
  },
  get: function get() {
    var userInfo = __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('userInfo') ? JSON.parse(__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('userInfo')) : null;

    var mtTokenStr = userInfo ? userInfo.token : null;
    var mtEncUserIdStr = userInfo ? userInfo.encUserId : null;
    var allCookies = __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get();
    var mtcookit = allCookies.MT_USER_INFO;
    if (mtTokenStr && mtcookit) {
      var fck = mtcookit.split(',');
      var appTokenStr = __WEBPACK_IMPORTED_MODULE_1__lib_utils__["a" /* util */].base64Decode(fck[3]);
      var appEncUserId = __WEBPACK_IMPORTED_MODULE_1__lib_utils__["a" /* util */].base64Decode(fck[5]);
      if (mtTokenStr !== appTokenStr || mtEncUserIdStr !== appEncUserId) {
        userInfo = {
          token: appTokenStr,
          encUserId: appEncUserId,
          avatar: null,
          nickName: '宝宝树用户',
          isHaveMobile: __WEBPACK_IMPORTED_MODULE_1__lib_utils__["a" /* util */].base64Decode(fck[4]) ? 1 : 0
        };
      }
    }
    return userInfo;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (auth);

/***/ }),

/***/ 190:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_backo2__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_backo2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_backo2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_emitter__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_emitter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_component_emitter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_component_bind__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_component_bind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_component_bind__);






function on(obj, ev, fn) {
  obj.on(ev, fn);
  return {
    destroy: function destroy() {
      obj.removeListener(ev, fn);
    }
  };
}

/* harmony default export */ __webpack_exports__["a"] = (WS);

__WEBPACK_IMPORTED_MODULE_2_component_emitter___default()(WS.prototype);
__WEBPACK_IMPORTED_MODULE_2_component_emitter___default()(WebSocket.prototype);

function WS(uri, opts) {
  if (uri && 'object' === (typeof uri === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(uri))) {
    opts = uri;
    uri = opts.uri;
  }
  opts = opts || {};

  opts.path = opts.path || '/';
  this.subs = [];
  this.opts = opts;

  this.connected = false;

  this.readyState = 'closed';
  this.uri = uri;
  this.connecting = [];
  this.lastPing = null;

  this.autoConnect = opts.autoConnect !== false;
  this.debug = opts.debug || true;
  this.handleError = null;
  this.handleMessage = null;
  this.intervalId = null;
  this.reconnecting = false;
  this.skipReconnect = false;
  this.engine = null;

  this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
  this.reconnection(opts.reconnection !== false);
  this.reconnectionDelay(opts.reconnectionDelay || 1000);
  this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
  this.randomizationFactor(opts.randomizationFactor || 0.5);

  this.backoff = new __WEBPACK_IMPORTED_MODULE_1_backo2___default.a({
    min: this.reconnectionDelay(),
    max: this.reconnectionDelayMax(),
    jitter: this.randomizationFactor()
  });

  this.timeout(null == opts.timeout ? 10000 : opts.timeout);

  if (this.autoConnect) this.open();
  if (this.debug) console.log('%c[socket]', 'color: #49c9c9;', '创建 socket 实例');
}

WS.prototype.open = function (fn, opts) {
  var self = this;

  if (this.debug) console.log('%c[socket]', 'color: #49c9c9;', 'open 开始状态:', this.readyState, '连接地址:', this.uri);

  if (~this.readyState.indexOf('open')) return this;

  try {
    this.engine = new WebSocket(this.uri);
  } catch (err) {
    if (this.debug) {
      console.error('[socket]创建实例发生错误', err);
    }
    return this.onError(err);
  }

  var socket = this.engine;
  this.readyState = 'opening';
  this.skipReconnect = false;

  var openSub = on(socket, 'onopen', function () {
    if (self.debug) console.log('%c[socket]', 'color: #49c9c9;', 'openSub 执行');
    self.onOpen();
    fn && fn();
  });

  var errorSub = on(socket, 'onerror', function (data) {
    if (self.debug) console.log('%c[socket]', 'color: #49c9c9;', 'errorSub 执行');

    self.clearUp();
    self.readyState = 'closed';

    self.emit('connect_error', data);

    if (fn) {
      var err = new Error('Connection error');
      err.data = data;
      fn(err);
    } else {
      self.maybeReconnectOnOpen();
    }
  });

  if (false !== this._timeout) {
    var timeout = this._timeout;
    if (this.debug) console.log('%c[socket]', 'color: #49c9c9;', '超时将在开始重连', timeout);

    var timer = setTimeout(function () {
      socket.emit('onerror', 'timeout');
      self.emit('connect_timeout', timeout);
    }, timeout);

    this.subs.push({
      destroy: function destroy() {
        clearTimeout(timer);
      }
    });
  }

  this.subs.push(openSub);
  this.subs.push(errorSub);
  this.addEventListeners();
  return this;
};

WS.prototype.onOpen = function () {
  if (this.debug) console.log('%c[socket]', 'color: #49c9c9;', 'WS prototype onOpen 执行');

  this.setPing();
  this.clearUp();

  this.readyState = 'open';
  this.emit('open');

  this.onConnect();

  var socket = this.engine;
  this.subs.push(on(socket, 'onmessage', __WEBPACK_IMPORTED_MODULE_3_component_bind___default()(this, 'onMessage')));
  this.subs.push(on(socket, 'onping', __WEBPACK_IMPORTED_MODULE_3_component_bind___default()(this, 'onPing')));
  this.subs.push(on(socket, 'onpong', __WEBPACK_IMPORTED_MODULE_3_component_bind___default()(this, 'onPong')));

  this.subs.push(on(socket, 'onclose', __WEBPACK_IMPORTED_MODULE_3_component_bind___default()(this, 'close')));
};

WS.prototype.onConnect = function () {
  if (this.debug) console.log('%c[socket]', 'color: #49c9c9;', 'WS prototype onConnect 执行');

  this.connected = true;
  this.disconnected = false;
  this.emit('connect');
};

WS.prototype.onMessage = function (data) {
  if (this.debug) console.log('%c[socket]', 'color: #49c9c9;', 'WS prototype onMessage 执行');

  this.emit('message', data);
};

WS.prototype.close = function (reason) {
  if (this.debug) console.log('%c[socket]', 'color: #49c9c9;', 'WS prototype close 执行:', reason);

  this.reconnecting = false;

  if ('opening' === this.readyState) {
    this.clearUp();
  }

  this.backoff.reset();
  this.readyState = 'closed';

  window.clearInterval(this.pingIntervalTimer);

  if (this.connected) {
    this.onClose(reason || 'io client disconnect');
  }

  return this;
};

WS.prototype.onClose = function (reason) {
  if (this.debug) console.log('%c[socket]', 'color: #49c9c9;', 'WS prototype onClose 执行:', reason);

  this.clearUp();
  this.backoff.reset();
  this.readyState = 'closed';
  this.emit('close', reason);

  switch (reason) {
    case 1000:
      this.skipReconnect = true;
      if (this.debug) console.log('%c[socket]', 'color: #49c9c9;', '用户主动关闭', reason);
    default:
      if (this._reconnection && !this.skipReconnect) {
        this.reconnect();
      }
  }
};

WS.prototype.reconnect = function () {
  var _this = this;

  if (this.debug) console.log('%c[socket]', 'color: #49c9c9;', 'WS prototype reconnect 执行:');

  if (this.reconnecting || this.skipReconnect) {
    return this;
  }

  if (this.backoff.attempts > this._reconnectionAttempts) {
    if (this.debug) console.error('[socket]超过最大重连次数, 重连彻底失败');

    window.clearInterval(this.pingIntervalTimer);
    this.clearUp();
    this.backoff.reset();
    this.emit('reconnect_failed');
    this.reconnecting = false;
  } else {
    var delay = this.backoff.duration();
    if (this.debug) console.log('%c[socket]', 'color: #49c9c9;', '第几次重连：', this.backoff.attempts, '等待 %dms 开始发起重连：', delay);

    this.reconnecting = true;

    var timer = setTimeout(function () {
      if (_this.skipReconnect) return;

      _this.emit('reconnect_attempt', _this.backoff.attempts);
      _this.emit('reconnecting', _this.backoff.attempts);
      if (_this.skipReconnect) return;

      _this.open(function (err) {
        if (_this.debug) console.log('%c[socket]', 'color: #49c9c9;', '打开重连 open');
        _this.reconnecting = false;

        if (err) {
          err.attempts = _this.backoff.attempts;

          if (_this.debug) console.log('[socket]重连 open 失败', err);

          _this.emit('reconnect_error', err);
          _this.reconnect();
        } else {
          if (_this.debug) console.log('%c[socket]', 'color: #49c9c9;', '重连成功');
          _this.onReconnect();
        }
      });
    }, delay);

    this.subs.push({
      destroy: function destroy() {
        clearTimeout(timer);
      }
    });
  }
};

WS.prototype.onReconnect = function () {
  if (this.debug) console.log('%c[socket]', 'color: #49c9c9;', 'WS prototype onReconnect 执行:');

  var attempt = this.backoff.attempts;
  this.reconnecting = false;
  this.backoff.reset();
  this.emit('reconnect_success', attempt);
};

WS.prototype.onPing = function () {
  this.lastPing = new Date();
  this.emit('onping');
};

WS.prototype.onPong = function () {
  this.emit('onpong', new Date() - this.lastPing);
};

WS.prototype.reconnection = function (v) {
  if (!arguments.length) return this._reconnection;
  this._reconnection = !!v;
  return this;
};

WS.prototype.reconnectionAttempts = function (v) {
  if (!arguments.length) return this._reconnectionAttempts;
  this._reconnectionAttempts = v;
  return this;
};

WS.prototype.reconnectionDelay = function (v) {
  if (!arguments.length) return this._reconnectionDelay;
  this._reconnectionDelay = v;
  this.backoff && this.backoff.setMin(v);
  return this;
};

WS.prototype.randomizationFactor = function (v) {
  if (!arguments.length) return this._randomizationFactor;
  this._randomizationFactor = v;
  this.backoff && this.backoff.setJitter(v);
  return this;
};

WS.prototype.reconnectionDelayMax = function (v) {
  if (!arguments.length) return this._reconnectionDelayMax;
  this._reconnectionDelayMax = v;
  this.backoff && this.backoff.setMax(v);
  return this;
};

WS.prototype.timeout = function (v) {
  if (!arguments.length) return this._timeout;
  this._timeout = v;
  return this;
};

WS.prototype.maybeReconnectOnOpen = function () {
  if (!this.reconnecting && this._reconnection && this.backoff.attempts === 0) {
    this.reconnect();
  }
};

WS.prototype.setPing = function () {
  var self = this;
  window.clearInterval(self.pingIntervalTimer);
  self.pingIntervalTimer = setInterval(function () {
    self.ping();
  }, 10000);
};

WS.prototype.ping = function () {
  var self = this;
  this.engine.send('PING');
};

WS.prototype.destroy = function (socket) {
  var index = indexOf(this.connecting, socket);
  if (~index) this.connecting.splice(index, 1);
  if (this.connecting.length) return;
  this.close();
};

WS.prototype.clearUp = function () {
  if (this.debug) console.log('ws-->clearUp');

  var subsLength = this.subs.length;
  for (var i = 0; i < subsLength; i++) {
    var sub = this.subs.shift();
    sub.destroy();
  }

  this.lastPing = null;
};

WS.prototype.send = function (msg) {
  this.engine.send(msg);
};

WS.prototype.addEventListeners = function () {
  var self = this;

  this.engine.onopen = function () {
    self.engine.emit('onopen');
  };

  this.engine.onclose = function () {
    self.skipReconnect = false;
    self.engine.emit('onclose', 'connet close');
  };

  this.engine.onmessage = function (ev) {
    if (ev.data !== 'PONG') {
      self.engine.emit('onmessage', ev.data);
    }
  };

  this.engine.onerror = function (e) {
    self.engine.emit('onerror', e);
  };
};

/***/ }),

/***/ 191:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return expertAuth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCourseList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getPictureList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getMaterialPPTList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return movePictureList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getAudioList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getVideoList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return clearMateriallist; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return deletePicture; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return startRecord; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return insertAudio; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return stopRecordControl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return reRecord; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return uploadImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return chooseImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return replyMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return livePopupVisible; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return liveBarActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return getIssues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return getSlidesList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return getCourseMsgList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return getCourseGuestbook; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return delMsgReply; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return replyMsg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return addReplyToList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return updateMessageRefStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return lookHistoryMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return getMediaId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return bindUpdateVideo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return weeks; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_async_mapSeries__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_async_mapSeries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_async_mapSeries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_mutation_types__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_action_util__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__comm_middleware_reportLog__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__comm_middleware_callApi__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__comm_api_apis__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__comm_api__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_auth__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__expertAnswer_actions_expertAnswer__ = __webpack_require__(192);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_10__expertAnswer_actions_expertAnswer__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_10__expertAnswer_actions_expertAnswer__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_10__expertAnswer_actions_expertAnswer__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_10__expertAnswer_actions_expertAnswer__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_10__expertAnswer_actions_expertAnswer__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_10__expertAnswer_actions_expertAnswer__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_10__expertAnswer_actions_expertAnswer__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_10__expertAnswer_actions_expertAnswer__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_10__expertAnswer_actions_expertAnswer__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_10__expertAnswer_actions_expertAnswer__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_10__expertAnswer_actions_expertAnswer__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_10__expertAnswer_actions_expertAnswer__["l"]; });














var expertAuth = function expertAuth(store, _ref) {
  var _ref$accessToken = _ref.accessToken,
      accessToken = _ref$accessToken === undefined ? null : _ref$accessToken,
      _ref$expertInfo = _ref.expertInfo,
      expertInfo = _ref$expertInfo === undefined ? null : _ref$expertInfo,
      _ref$successFn = _ref.successFn,
      successFn = _ref$successFn === undefined ? function () {} : _ref$successFn;

  if (accessToken) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__comm_middleware_callApi__["a" /* getApi */])({ commit: store.commit }, __WEBPACK_IMPORTED_MODULE_7__comm_api_apis__["a" /* default */].expertAuth, { accessToken: accessToken }).then(function (info) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__comm_api__["b" /* updateAjaxHeaderConfig */])({ token: info.token });
      __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.set('expertInfo', info);
      store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["_12" /* AJAX_GET_EXPERTAUTH */], {
        info: info
      });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__store_action_util__["a" /* healthSign */])(store, {});
      successFn();
    })['catch'](function (e) {
      var msg = {
        name: '专家授权失败',
        protocol: document.location.protocol === 'https:' ? 'https' : 'http',
        info: e,
        time: Date.parse(new Date())
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__comm_middleware_reportLog__["a" /* default */])(msg).then(function () {
        console.log('日志-专家授权失败');
      });
    });
  } else if (expertInfo) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__comm_api__["b" /* updateAjaxHeaderConfig */])({ token: expertInfo.token });
    store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["_12" /* AJAX_GET_EXPERTAUTH */], {
      info: expertInfo
    });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__store_action_util__["a" /* healthSign */])(store, {});
  }
};

var getCourseList = function getCourseList(_ref2, _ref3) {
  var commit = _ref2.commit;
  var _ref3$status = _ref3.status,
      status = _ref3$status === undefined ? [0, 1] : _ref3$status,
      _ref3$pageNo = _ref3.pageNo,
      pageNo = _ref3$pageNo === undefined ? 1 : _ref3$pageNo,
      _ref3$pageSize = _ref3.pageSize,
      pageSize = _ref3$pageSize === undefined ? 20 : _ref3$pageSize;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_7__comm_api_apis__["a" /* default */].courseList, { startstatus: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(status), pageNo: pageNo, pageSize: pageSize }).then(function (body) {
    var courseList = body.data;
    commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["_13" /* AJAX_GET_COURSELIST */], {
      courseList: courseList,
      pageNo: pageNo
    });
  });
};

var getPictureList = function getPictureList(_ref4, _ref5) {
  var commit = _ref4.commit,
      state = _ref4.state;
  var lastId = _ref5.lastId,
      _ref5$type = _ref5.type,
      type = _ref5$type === undefined ? 0 : _ref5$type,
      _ref5$source = _ref5.source,
      source = _ref5$source === undefined ? 1 : _ref5$source,
      _ref5$courseId = _ref5.courseId,
      courseId = _ref5$courseId === undefined ? state.courseInfo.id : _ref5$courseId,
      _ref5$pagesize = _ref5.pagesize,
      pagesize = _ref5$pagesize === undefined ? 20 : _ref5$pagesize,
      naxtPage = _ref5.naxtPage;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_7__comm_api_apis__["a" /* default */].pictureList, { lastid: lastId, type: type, source: source, courseid: courseId, pagesize: pagesize }).then(function (body) {
    var pictureList = body.data.list;
    var hasPictures = body.data.hasNextPage;
    commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["_14" /* AJAX_GET_MATERIAL_PICTURELIST */], {
      pictureList: pictureList,
      naxtPage: naxtPage,
      hasPictures: hasPictures
    });
  });
};

var getMaterialPPTList = function getMaterialPPTList(_ref6, _ref7) {
  var commit = _ref6.commit,
      state = _ref6.state;
  var lastId = _ref7.lastId,
      _ref7$type = _ref7.type,
      type = _ref7$type === undefined ? 0 : _ref7$type,
      _ref7$source = _ref7.source,
      source = _ref7$source === undefined ? 0 : _ref7$source,
      _ref7$courseId = _ref7.courseId,
      courseId = _ref7$courseId === undefined ? state.courseInfo.id : _ref7$courseId,
      _ref7$pagesize = _ref7.pagesize,
      pagesize = _ref7$pagesize === undefined ? 20 : _ref7$pagesize,
      naxtPage = _ref7.naxtPage;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_7__comm_api_apis__["a" /* default */].pictureList, { lastid: lastId, type: type, source: source, courseid: courseId, pagesize: pagesize }).then(function (body) {
    var PPTList = body.data.list;
    var hasPPTs = body.data.hasNextPage;
    commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["_15" /* AJAX_GET_MATERIAL_PPTLIST */], {
      PPTList: PPTList,
      naxtPage: naxtPage,
      hasPPTs: hasPPTs
    });
  });
};

var movePictureList = function movePictureList(_ref8, _ref9) {
  var commit = _ref8.commit;
  var materialid = _ref9.materialid,
      replaceid = _ref9.replaceid;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_7__comm_api_apis__["a" /* default */].movePicture, { materialid: materialid, replaceid: replaceid }).then(function () {
    console.info('排序成功');
  });
};

var getAudioList = function getAudioList(_ref10, _ref11) {
  var commit = _ref10.commit;
  var lastId = _ref11.lastId,
      _ref11$type = _ref11.type,
      type = _ref11$type === undefined ? 1 : _ref11$type,
      _ref11$source = _ref11.source,
      source = _ref11$source === undefined ? 1 : _ref11$source,
      courseId = _ref11.courseId,
      _ref11$pagesize = _ref11.pagesize,
      pagesize = _ref11$pagesize === undefined ? 20 : _ref11$pagesize,
      naxtPage = _ref11.naxtPage;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_7__comm_api_apis__["a" /* default */].pictureList, { lastid: lastId, type: type, source: source, courseid: courseId, pagesize: pagesize }).then(function (body) {
    var audioList = body.data.list;
    var hasNextPage = body.data.hasNextPage;
    commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["_16" /* AJAX_GET_MATERIAL_AUDIOLIST */], {
      audioList: audioList,
      naxtPage: naxtPage,
      hasNextPage: hasNextPage
    });
  });
};

var getVideoList = function getVideoList(_ref12, _ref13) {
  var commit = _ref12.commit;
  var lastId = _ref13.lastId,
      _ref13$type = _ref13.type,
      type = _ref13$type === undefined ? 2 : _ref13$type,
      _ref13$source = _ref13.source,
      source = _ref13$source === undefined ? 1 : _ref13$source,
      courseId = _ref13.courseId,
      _ref13$pagesize = _ref13.pagesize,
      pagesize = _ref13$pagesize === undefined ? 20 : _ref13$pagesize,
      naxtPage = _ref13.naxtPage;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_7__comm_api_apis__["a" /* default */].pictureList, { lastid: lastId, type: type, source: source, courseid: courseId, pagesize: pagesize }).then(function (body) {
    var videoList = body.data.list;
    var hasNextPage = body.data.hasNextPage;
    commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["_17" /* AJAX_GET_MATERIAL_VIDEOLIST */], {
      videoList: videoList,
      naxtPage: naxtPage,
      hasNextPage: hasNextPage
    });
  });
};

var clearMateriallist = function clearMateriallist(_ref14) {
  var commit = _ref14.commit,
      state = _ref14.state;

  commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["_18" /* CLEAR_MATERIALLIST_LOCAL */], state);
};

var deletePicture = function deletePicture(_ref15, _ref16) {
  var commit = _ref15.commit,
      state = _ref15.state;
  var _ref16$token = _ref16.token,
      token = _ref16$token === undefined ? state.expertInfo.token : _ref16$token,
      pictureList = _ref16.pictureList,
      pictureIds = _ref16.pictureIds;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_7__comm_api_apis__["a" /* default */].deletePicture, { token: token, materialidlist: pictureList }).then(function () {
    commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["_19" /* DELETEIMAGEONLOCAL */], { imageIds: pictureIds });
  });
};

var F_TIME = 200;

var isStartRecord = false;
var sTime = void 0;
var startRecord = function startRecord(store) {
  window.wx.startRecord({
    success: function success() {
      console.log('cost time ===> ' + (new Date() - sTime));
      store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["_20" /* AJAX_WX_STARTRECORD */]);
      isStartRecord = true;
    },
    fail: function fail() {
      var expertInfo = __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.get('expertInfo');
      var msg = '[WX_JSSDK_ERROR] [expertInfo:' + expertInfo + '][ua:' + navigator.userAgent + ']startRecord fail...isDoing:' + stopRecord.isDoing + '...isStartRecord:' + isStartRecord + '...wxSignStatus:' + store.state.wxSignStatus;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__comm_middleware_reportLog__["a" /* default */])(msg).then(function () {
        console.log('发送日志成功', msg);
      });
      stopRecord.isDoing = false;
      window.wx.stopRecord({
        success: function success() {
          console.log('startRecord re try');
          startRecord(store);
        },
        fail: function fail() {
          console.log('record is stop');
          startRecord(store);
        }
      });
      isStartRecord = false;
    }
  });
};

var insertAudio = function insertAudio(store, audioMessage) {
  store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["l" /* SOCKET_RECEIVE_MESSAGE */], { messages: [audioMessage] });
};

var frequencyTime = void 0;
function controlFrequency(fun, time) {
  var _this = this;

  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    console.log('controlFrequency ===> ' + fun.isDoing + ' , ' + isStartRecord);
    if (!fun.isDoing && isStartRecord) {
      fun.apply(_this, args);
      fun.isDoing = true;
      console.log('stopRecord start');

      clearTimeout(frequencyTime);
      var over = function over() {
        console.log('stopRecord end');
        fun.isDoing = false;
        clearTimeout(frequencyTime);
        frequencyTime = null;
      };

      frequencyTime = setTimeout(over, time);
    }
  };
}

var stopRecord = function stopRecord(store) {
  var _ref17 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      isContinue = _ref17.isContinue,
      _ref17$time = _ref17.time,
      time = _ref17$time === undefined ? 2 : _ref17$time,
      flag = _ref17.flag;

  console.log('stopRecord ing...');
  var stopRecordTime = new Date();
  if (stopRecord.isDoing) {
    console.log('stopRecord is doing');
    return;
  }

  if (!store.state.startRecordTime) {
    console.log('startRecordTime is null');
    clearTimeout(frequencyTime);
    stopRecord.isDoing = false;
    return;
  }

  console.log('window.wx.stopRecord start');
  window.wx.stopRecord({
    success: function success(res) {
      console.log('stopRecord success');
      sTime = new Date();
      clearTimeout(frequencyTime);
      isStartRecord = false;
      stopRecord.isDoing = false;

      if (flag) {
        return;
      }

      var speech = Math.ceil((stopRecordTime - store.state.startRecordTime) / 1000);
      var localId = res.localId;

      if (isContinue) {
        store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["_21" /* AJAX_WX_STOPRECORD */], {
          localId: localId
        });
        startRecord(store);
      }
      store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["_22" /* AJAX_WX_UPLOADRECORD */]);
      window.wx.uploadVoice({
        localId: localId,
        isShowProgressTips: isContinue ? 0 : 1,
        success: function success(uploadRes) {
          var serverId = uploadRes.serverId;
          var audio = {
            localId: localId,
            mediaId: serverId,
            speech: speech,
            isUpload: false
          };
          console.log('upload audio----------- ===> ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(audio));

          if (isContinue) {
            store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["_23" /* AJAX_WX_UPDATERECORD */], audio);
          } else {
            store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["_21" /* AJAX_WX_STOPRECORD */], audio);
          }
        },
        fail: function fail(res) {
          var expertInfo = __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.get('expertInfo');
          var msg = '[WX_JSSDK_ERROR] [expertInfo:' + expertInfo + '][ua:' + navigator.userAgent + '] upload error...' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res);

          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__comm_middleware_reportLog__["a" /* default */])(msg).then(function () {
            console.log('发送日志成功', msg);
          });
        }
      });
    },
    fail: function fail(res) {
      var expertInfo = __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.get('expertInfo');
      var msg = '[WX_JSSDK_ERROR] [expertInfo:' + expertInfo + '][ua:' + navigator.userAgent + '] stopRecord error...isDoing:' + stopRecord.isDoing + ' ...isStartRecord:' + isStartRecord + '...time:' + time + '...isContinue:' + isContinue;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__comm_middleware_reportLog__["a" /* default */])(msg).then(function () {
        console.log('发送日志成功', msg);
      });

      var delayTime = setTimeout(function () {
        stopRecord.isDoing = false;
        clearTimeout(frequencyTime);
        frequencyTime = null;
        if (time === 0) {
          store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["a" /* AJAX_ERROR */], new Error(res.errMsg));
        } else {
          time -= 1;
          stopRecord(store, { isContinue: isContinue, time: time });
        }
        clearTimeout(delayTime);
        delayTime = null;
      }, F_TIME * 5);
    }
  });
  console.log('window.wx.stopRecord end');
};

var stopRecordControl = controlFrequency(stopRecord, F_TIME * 3);

var reRecord = function reRecord(store) {
  store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["_24" /* AJAX_WX_RERECORD */]);
};

var uploadImage = function uploadImage(store, _ref18) {
  var imageLocalIds = _ref18.imageLocalIds,
      _ref18$action = _ref18.action,
      action = _ref18$action === undefined ? 'sendMessage' : _ref18$action;

  var commit = store.commit;
  var state = store.state;
  commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["t" /* AJAX_LOADING */], { loadingStatus: true });
  __WEBPACK_IMPORTED_MODULE_1_async_mapSeries___default()(imageLocalIds, function (imageLocalId, callback) {
    console.log(imageLocalId);
    window.wx.uploadImage({
      localId: imageLocalId,
      isShowProgressTips: 1,
      success: function success(res) {
        var serverId = res.serverId;
        callback(null, serverId);
      },
      fail: function fail(res) {
        commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["a" /* AJAX_ERROR */], new Error(res.errMsg));
      }
    });
  }, function (err, imageServerIds) {
    commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["t" /* AJAX_LOADING */], { loadingStatus: false });
    if (!err) {
      if (action === 'sendMessage') {
        commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["_25" /* AJAX_WX_CHOOSESENDIMAGE */], { imageServerIds: imageServerIds });
      } else if (action === 'uploadImage') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_7__comm_api_apis__["a" /* default */].uploadImage, { mediaIdList: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(imageServerIds), type: 0, courseId: state.courseInfo.id }).then(function () {
          getPictureList(store, {});
        });
      }
    } else {
      commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["a" /* AJAX_ERROR */], err);
    }
  });
};

var chooseImage = function chooseImage(store, _ref19) {
  var _ref19$action = _ref19.action,
      action = _ref19$action === undefined ? 'sendMessage' : _ref19$action;

  window.wx.chooseImage({
    count: 9,
    sizeType: ['original', 'compressed'],
    sourceType: ['album', 'camera'],
    success: function success(res) {
      var imageLocalIds = res.localIds;
      uploadImage(store, { imageLocalIds: imageLocalIds, action: action });
    },
    fail: function fail(res) {
      store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["a" /* AJAX_ERROR */], new Error(res.errMsg));
    }
  });
};

var replyMessage = function replyMessage(store, payload) {
  store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["_26" /* COMPONENTS_CURRENTMESSAGE */], {
    replyMessage: payload.replyMessage
  });
};

var livePopupVisible = function livePopupVisible(store, payload) {
  store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["_27" /* COMPONENTS_POPUPVISIBLE */], {
    livePopupVisible: payload
  });
};

var liveBarActive = function liveBarActive(store, payload) {
  store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["_28" /* COMPONENTS_LIVEBARACTIVE */], {
    isActive: payload
  });
};

var getIssues = function getIssues(_ref20, _ref21) {
  var commit = _ref20.commit;
  var courseId = _ref21.courseId,
      condition = _ref21.condition,
      direction = _ref21.direction,
      isFilter = _ref21.isFilter,
      lastId = _ref21.lastId;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_7__comm_api_apis__["a" /* default */].issues, { courseId: courseId, condition: condition, direction: direction, ishideanswered: isFilter, lastId: lastId }).then(function (body) {
    var issues = body.data;
    commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["_29" /* AJAX_GET_ISSUES */], {
      issues: issues,
      lastId: lastId
    });
  });
};

var getSlidesList = function getSlidesList(_ref22, _ref23) {
  var commit = _ref22.commit;
  var courseId = _ref23.courseId,
      width = _ref23.width,
      height = _ref23.height;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_7__comm_api_apis__["a" /* default */].expertSlides, { courseid: courseId, width: width, height: height }).then(function (body) {
    var slides = body.data;
    commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["_30" /* AJAX_GET_SLIDES */], {
      slides: slides
    });
  })['catch'](function (e) {
    if (e.rtn_code === '0000002') {
      __WEBPACK_IMPORTED_MODULE_9__lib_auth__["a" /* default */].clear();
      __WEBPACK_IMPORTED_MODULE_9__lib_auth__["a" /* default */].login('expert', null);
    }
  });
};

var getCourseMsgList = function getCourseMsgList(_ref24, _ref25) {
  var commit = _ref24.commit;
  var _ref25$curpage = _ref25.curpage,
      curpage = _ref25$curpage === undefined ? 1 : _ref25$curpage,
      _ref25$pagesize = _ref25.pagesize,
      pagesize = _ref25$pagesize === undefined ? 20 : _ref25$pagesize;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_7__comm_api_apis__["a" /* default */].expertCourseList, { curpage: curpage, pagesize: pagesize }).then(function (body) {
    var courseMsgList = body.data;
    commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["_31" /* AJAX_GET_COURSE_MSG_LIST */], courseMsgList);
  });
};

var getCourseGuestbook = function getCourseGuestbook(_ref26, _ref27) {
  var commit = _ref26.commit,
      state = _ref26.state;
  var _ref27$curpage = _ref27.curpage,
      curpage = _ref27$curpage === undefined ? 1 : _ref27$curpage,
      _ref27$pagesize = _ref27.pagesize,
      pagesize = _ref27$pagesize === undefined ? 20 : _ref27$pagesize,
      id = _ref27.id,
      type = _ref27.type;

  var protocol = location.protocol.replace(':', '');
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_7__comm_api_apis__["a" /* default */].messageList, { curpage: curpage, pagesize: pagesize, id: id, protocol: protocol, type: type }).then(function (body) {
    var GuestbookList = body.data;
    commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["_32" /* AJAX_GET_GUESTBOOK_LIST */], GuestbookList);
  });
};

var delMsgReply = function delMsgReply(_ref28, _ref29) {
  var commit = _ref28.commit;
  var replyid = _ref29.replyid;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_7__comm_api_apis__["a" /* default */].delMsgReply, { replyid: replyid }).then(function (body) {
    commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["_33" /* DEL_REPLY_TO_LIST */], { id: replyid });
  });
};

var replyMsg = function replyMsg(_ref30, _ref31) {
  var commit = _ref30.commit;
  var guestbookid = _ref31.guestbookid,
      type = _ref31.type,
      content = _ref31.content;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_7__comm_api_apis__["a" /* default */].replyMsg, { guestbookid: guestbookid, type: type, content: content }).then(function (body) {
    return body.data;
  });
};

var addReplyToList = function addReplyToList(store, payload) {
  store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["_34" /* ADD_REPLY_TO_LIST */], payload);
};

var updateMessageRefStatus = function updateMessageRefStatus(store, _ref32) {
  var refMsgId = _ref32.refMsgId;

  store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["_35" /* UPDATE_MESSAGE_REF_STATUS */], { refMsgId: refMsgId });
};

var lookHistoryMessage = function lookHistoryMessage(_ref33, _ref34) {
  var commit = _ref33.commit;
  var status = _ref34.status;

  commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["_36" /* LOOK_HISTORY_MESSAGE */], { status: status });
};
var getMediaId = function getMediaId(_ref35, mediaId) {
  var state = _ref35.state;

  state.mediaId = mediaId;
};
var bindUpdateVideo = function bindUpdateVideo(_ref36, isUpdateVideo) {
  var state = _ref36.state;

  state.isUpdateVideo = isUpdateVideo;
};

var weeks = function weeks(_ref37, _weeks) {
  var state = _ref37.state;

  state.weeks = _weeks;
};

/***/ }),

/***/ 192:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getQuestionList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getExpertJobSetting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return updateExpertModify; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getQusetionDialog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getQuestionInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return bindDialog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return saveQuestionStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getExpertInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getSettleInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getYearParam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getSettleList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getOrderDetail; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__comm_model___ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__comm_middleware_callApi__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__comm_api_apis__ = __webpack_require__(14);





var getQuestionList = function getQuestionList(_ref, _ref2) {
  var commit = _ref.commit;
  var expertid = _ref2.expertid,
      type = _ref2.type,
      curpage = _ref2.curpage,
      pagesize = _ref2.pagesize;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_3__comm_api_apis__["a" /* default */].getQuestionList, { expertid: expertid, type: type, curpage: curpage, pagesize: pagesize }).then(function (body) {
    return body.data;
  });
};

var getExpertJobSetting = function getExpertJobSetting(_ref3, _ref4) {
  var commit = _ref3.commit;
  var expertids = _ref4.expertids,
      hascount = _ref4.hascount,
      hasexpertsetting = _ref4.hasexpertsetting;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_3__comm_api_apis__["a" /* default */].expertJobSetting, { expertids: expertids, hascount: hascount, hasexpertsetting: hasexpertsetting }).then(function (body) {
    return body.data;
  });
};

var updateExpertModify = function updateExpertModify(_ref5, _ref6) {
  var commit = _ref5.commit;
  var servicecount = _ref6.servicecount,
      servicetime = _ref6.servicetime,
      jobsetting = _ref6.jobsetting;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_3__comm_api_apis__["a" /* default */].updateExpertModify, { servicecount: servicecount, servicetime: servicetime, jobsetting: jobsetting }).then(function (body) {
    return body.data;
  });
};

var getQusetionDialog = function getQusetionDialog(_ref7, _ref8) {
  var commit = _ref7.commit;
  var questionId = _ref8.questionId,
      expertId = _ref8.expertId,
      userType = _ref8.userType,
      pageNo = _ref8.pageNo,
      pageSize = _ref8.pageSize;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_3__comm_api_apis__["a" /* default */].qusetionDialog, { questionId: questionId, expertId: expertId, userType: userType, pageNo: pageNo, pageSize: pageSize }).then(function (body) {
    var imMsgInfo = __WEBPACK_IMPORTED_MODULE_1__comm_model___["c" /* IMMsg */](body.data);
    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["_37" /* AJAX_GET_IMMESGINFO */], { imMsgInfo: imMsgInfo });
    return imMsgInfo;
  });
};

var getQuestionInfo = function getQuestionInfo(_ref9, _ref10) {
  var commit = _ref9.commit;
  var questionId = _ref10.questionId,
      expertId = _ref10.expertId;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_3__comm_api_apis__["a" /* default */].questionInfo, { questionId: questionId, expertId: expertId }).then(function (body) {
    return body.data;
  });
};

var bindDialog = function bindDialog(_ref11, _ref12) {
  var commit = _ref11.commit;
  var questionId = _ref12.questionId,
      expertId = _ref12.expertId,
      msgType = _ref12.msgType;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_3__comm_api_apis__["a" /* default */].bindDialog, { questionId: questionId, expertId: expertId, msgType: msgType }).then(function (body) {
    return body.data;
  });
};

var saveQuestionStatus = function saveQuestionStatus(_ref13, _ref14) {
  var commit = _ref13.commit;
  var questionId = _ref14.questionId,
      expertId = _ref14.expertId,
      userType = _ref14.userType,
      status = _ref14.status,
      remark = _ref14.remark;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_3__comm_api_apis__["a" /* default */].saveQuestionStatus, { questionId: questionId, expertId: expertId, userType: userType, status: status, remark: remark }).then(function (body) {
    return body.data;
  });
};

var getExpertInfo = function getExpertInfo(_ref15, _ref16) {
  var commit = _ref15.commit;
  var expertid = _ref16.expertid;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_3__comm_api_apis__["a" /* default */].expertInfo, { expertid: expertid }).then(function (body) {
    return body.data;
  });
};

var getSettleInfo = function getSettleInfo(_ref17, _ref18) {
  var commit = _ref17.commit;
  var expertid = _ref18.expertid;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_3__comm_api_apis__["a" /* default */].settleInfo, { expertid: expertid }).then(function (body) {
    return body.data;
  });
};

var getYearParam = function getYearParam(_ref19) {
  var commit = _ref19.commit;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_3__comm_api_apis__["a" /* default */].yearParam).then(function (body) {
    return body.data;
  });
};

var getSettleList = function getSettleList(_ref20, _ref21) {
  var commit = _ref20.commit;
  var supplierid = _ref21.supplierid,
      expertid = _ref21.expertid,
      infotype = _ref21.infotype,
      year = _ref21.year;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_3__comm_api_apis__["a" /* default */].settleList, { supplierid: supplierid, expertid: expertid, infotype: infotype, year: year }).then(function (body) {
    return body.data;
  });
};

var getOrderDetail = function getOrderDetail(_ref22, _ref23) {
  var commit = _ref22.commit;
  var supplierid = _ref23.supplierid,
      expertid = _ref23.expertid,
      billmonth = _ref23.billmonth,
      settlecode = _ref23.settlecode,
      email = _ref23.email;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_3__comm_api_apis__["a" /* default */].orderDetail, { supplierid: supplierid, expertid: expertid, billmonth: billmonth, settlecode: settlecode, email: email }).then(function (body) {
    return body.data;
  });
};

/***/ }),

/***/ 193:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return courseList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return currentPictures; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasPictures; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return hasPPTs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return currentAudios; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return currentVideos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return materialPPTList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return replyMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return audio; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return livePopupVisible; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return expertInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return liveBarActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return issues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return sendImageLocalIds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return courseUpCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return firstAjaxStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return slides; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return courseRecommends; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return replayMessageIds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return mediaId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return isUpdateVideo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return courseMsgList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return guestbookList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return weeks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return imMsgInfo; });

var courseList = function courseList(state) {
  return state.courseList;
};
var currentPictures = function currentPictures(state) {
  return state.materialPictureList;
};
var hasPictures = function hasPictures(state) {
  return state.hasPictures;
};
var hasPPTs = function hasPPTs(state) {
  return state.hasPPTs;
};
var currentAudios = function currentAudios(state) {
  return state.materialaAudioList;
};
var currentVideos = function currentVideos(state) {
  return state.materialaVideoList;
};
var materialPPTList = function materialPPTList(state) {
  return state.materialPPTList;
};

var replyMessage = function replyMessage(state) {
  return state.replyMessage;
};
var audio = function audio(state) {
  return state.audio;
};
var livePopupVisible = function livePopupVisible(state) {
  return state.livePopupVisible;
};
var expertInfo = function expertInfo(state) {
  return state.expertInfo;
};
var liveBarActive = function liveBarActive(state) {
  return state.isActive;
};
var issues = function issues(state) {
  return state.issues;
};
var sendImageLocalIds = function sendImageLocalIds(state) {
  return state.sendImageLocalIds;
};
var courseUpCount = function courseUpCount(state) {
  return state.courseUpCount;
};
var firstAjaxStatus = function firstAjaxStatus(state) {
  return state.firstAjaxStatus;
};
var slides = function slides(state) {
  return state.slides;
};
var courseRecommends = function courseRecommends(state) {
  return state.courseRecommends;
};
var replayMessageIds = function replayMessageIds(state) {
  return state.replayMessageIds;
};
var mediaId = function mediaId(state) {
  return state.mediaId;
};
var isUpdateVideo = function isUpdateVideo(state) {
  return state.isUpdateVideo;
};
var courseMsgList = function courseMsgList(state) {
  return state.courseMsgList;
};
var guestbookList = function guestbookList(state) {
  return state.guestbookList;
};
var weeks = function weeks(state) {
  return state.weeks;
};
var imMsgInfo = function imMsgInfo(state) {
  return state.imMsgInfo;
};

/***/ }),

/***/ 194:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AJAX_GET_MESSAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return AJAX_GET_COURSELIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AJAX_GET_COURSEINFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AJAX_GET_COURSE_RECOMMEND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return AJAX_GET_MATERIAL_PICTURELIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return AJAX_GET_MATERIAL_AUDIOLIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return AJAX_GET_MATERIAL_VIDEOLIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return AJAX_GET_MATERIAL_PPTLIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CLEAR_MATERIALLIST_LOCAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return AJAX_WX_STARTRECORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return AJAX_WX_STOPRECORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return AJAX_WX_UPDATERECORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return AJAX_WX_RERECORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return AJAX_WX_ONVOICERECORDEND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return AJAX_WX_UPLOADVOICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return AJAX_WX_UPLOADRECORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return AJAX_WX_GETNETWORKTYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return AJAX_WX_CHOOSEIMAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return AJAX_WX_CHOOSESENDIMAGE; });
/* unused harmony export AJAX_WX_UPLOADIMAGE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return DELETEIMAGEONLOCAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return AJAX_GET_EXPERTAUTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return AJAX_GET_ISSUES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return AJAX_GET_SLIDES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return AJAX_GET_COURSE_MSG_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return AJAX_GET_GUESTBOOK_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return ADD_REPLY_TO_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return DEL_REPLY_TO_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return COMPONENTS_CURRENTMESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return COMPONENTS_POPUPVISIBLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return COMPONENTS_LIVEBARACTIVE; });
/* unused harmony export STATE_ONLYSELF */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return UPDATE_MESSAGE_REF_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return LOOK_HISTORY_MESSAGE; });
/* unused harmony export GET_MEDIAID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return AJAX_GET_IMMESGINFO; });


var AJAX_GET_MESSAGES = 'AJAX_GET_MESSAGES';
var AJAX_GET_COURSELIST = 'AJAX_GET_COURSELIST';
var AJAX_GET_COURSEINFO = 'AJAX_GET_COURSEINFO';
var AJAX_GET_COURSE_RECOMMEND = 'AJAX_GET_COURSE_RECOMMEND';
var AJAX_GET_MATERIAL_PICTURELIST = 'AJAX_GET_MATERIAL_PICTURELIST';
var AJAX_GET_MATERIAL_AUDIOLIST = 'AJAX_GET_MATERIAL_AUDIOLIST';
var AJAX_GET_MATERIAL_VIDEOLIST = 'AJAX_GET_MATERIAL_VIDEOLIST';
var AJAX_GET_MATERIAL_PPTLIST = 'AJAX_GET_MATERIAL_PPTLIST';
var CLEAR_MATERIALLIST_LOCAL = 'CLEAR_MATERIALLIST_LOCAL';
var AJAX_WX_STARTRECORD = 'AJAX_WX_STARTRECORD';
var AJAX_WX_STOPRECORD = 'AJAX_WX_STOPRECORD';
var AJAX_WX_UPDATERECORD = 'AJAX_WX_UPDATERECORD';
var AJAX_WX_RERECORD = 'AJAX_WX_RERECORD';
var AJAX_WX_ONVOICERECORDEND = 'AJAX_WX_ONVOICERECORDEND';
var AJAX_WX_UPLOADVOICE = 'AJAX_WX_UPLOADVOICE';
var AJAX_WX_UPLOADRECORD = 'AJAX_WX_UPLOADRECORD';
var AJAX_WX_GETNETWORKTYPE = 'AJAX_WX_GETNETWORKTYPE';
var AJAX_WX_CHOOSEIMAGE = 'AJAX_WX_CHOOSEIMAGE';
var AJAX_WX_CHOOSESENDIMAGE = 'AJAX_WX_CHOOSESENDIMAGE';
var AJAX_WX_UPLOADIMAGE = 'AJAX_WX_UPLOADIMAGE';
var DELETEIMAGEONLOCAL = 'DELETEIMAGEONLOCAL';
var AJAX_GET_EXPERTAUTH = 'AJAX_GET_EXPERTAUTH';
var AJAX_GET_ISSUES = 'AJAX_GET_ISSUES';
var AJAX_GET_SLIDES = 'AJAX_GET_SLIDES';
var AJAX_GET_COURSE_MSG_LIST = 'AJAX_GET_COURSE_MSG_LIST';
var AJAX_GET_GUESTBOOK_LIST = 'AJAX_GET_GUESTBOOK_LIST';
var ADD_REPLY_TO_LIST = 'ADD_REPLY_TO_LIST';
var DEL_REPLY_TO_LIST = 'DEL_REPLY_TO_LIST';
var COMPONENTS_CURRENTMESSAGE = 'COMPONENTS_CURRENTMESSAGE';

var COMPONENTS_POPUPVISIBLE = 'COMPONENTS_POPUPVISIBLE';

var COMPONENTS_LIVEBARACTIVE = 'COMPONENTS_LIVEBARACTIVE';

var STATE_ONLYSELF = 'STATE_ONLYSELF';

var UPDATE_MESSAGE_REF_STATUS = 'UPDATE_MESSAGE_REF_STATUS';

var LOOK_HISTORY_MESSAGE = 'LOOK_HISTORY_MESSAGE';
var GET_MEDIAID = 'GET_MEDIAID';
var AJAX_GET_IMMESGINFO = 'AJAX_GET_IMMESGINFO';

/***/ }),

/***/ 195:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  expertInfo: {
    avatar: null,
    id: null,
    introduction: null,
    name: null,
    title: null,
    token: null },
  audio: {
    serverId: null,
    speech: null,
    isUpload: false },
  replyMessage: null,
  livePopupVisible: false,
  isActive: false,
  issues: {
    hasNextPage: false,
    list: []
  },
  startRecordTime: null,
  imageLocalIds: [],
  sendImageLocalIds: [],
  materialPictureList: [],
  hasPictures: true,
  hasPPTs: true,
  materialaAudioList: [],
  materialaVideoList: [],
  materialPPTList: [],
  replayMessageIds: [],
  slides: {
    hasSlides: false,
    list: [] },
  mediaId: null,
  isUpdateVideo: false,
  courseMsgList: {
    curpage: 0,
    list: [],
    hasNextPage: false
  },
  weeks: [0, 0, 0, 0, 0, 0, 0],
  guestbookList: {
    curpage: 1,
    dataList: [],
    hasNextPage: false,
    totalCount: 0
  },
  imMsgInfo: {} });

/***/ }),

/***/ 196:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "connectStatus", function() { return connectStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "error", function() { return error; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "socket", function() { return socket; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "signData", function() { return signData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "wxSignStatus", function() { return wxSignStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isLoading", function() { return isLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "courseInfo", function() { return courseInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "courseCloseState", function() { return courseCloseState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentMessages", function() { return currentMessages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "latestMessage", function() { return latestMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "firstMessage", function() { return firstMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sendMessages", function() { return sendMessages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "audioList", function() { return audioList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lastPlayAudio", function() { return lastPlayAudio; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "serialList", function() { return serialList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cashierPayStatus", function() { return cashierPayStatus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__expert_getters_expert__ = __webpack_require__(193);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "courseList", function() { return __WEBPACK_IMPORTED_MODULE_0__expert_getters_expert__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "currentPictures", function() { return __WEBPACK_IMPORTED_MODULE_0__expert_getters_expert__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "hasPictures", function() { return __WEBPACK_IMPORTED_MODULE_0__expert_getters_expert__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "hasPPTs", function() { return __WEBPACK_IMPORTED_MODULE_0__expert_getters_expert__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "currentAudios", function() { return __WEBPACK_IMPORTED_MODULE_0__expert_getters_expert__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "currentVideos", function() { return __WEBPACK_IMPORTED_MODULE_0__expert_getters_expert__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "materialPPTList", function() { return __WEBPACK_IMPORTED_MODULE_0__expert_getters_expert__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "replyMessage", function() { return __WEBPACK_IMPORTED_MODULE_0__expert_getters_expert__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "audio", function() { return __WEBPACK_IMPORTED_MODULE_0__expert_getters_expert__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "livePopupVisible", function() { return __WEBPACK_IMPORTED_MODULE_0__expert_getters_expert__["j"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "expertInfo", function() { return __WEBPACK_IMPORTED_MODULE_0__expert_getters_expert__["k"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "liveBarActive", function() { return __WEBPACK_IMPORTED_MODULE_0__expert_getters_expert__["l"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "issues", function() { return __WEBPACK_IMPORTED_MODULE_0__expert_getters_expert__["m"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "sendImageLocalIds", function() { return __WEBPACK_IMPORTED_MODULE_0__expert_getters_expert__["n"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "courseUpCount", function() { return __WEBPACK_IMPORTED_MODULE_0__expert_getters_expert__["o"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "firstAjaxStatus", function() { return __WEBPACK_IMPORTED_MODULE_0__expert_getters_expert__["p"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "slides", function() { return __WEBPACK_IMPORTED_MODULE_0__expert_getters_expert__["q"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "courseRecommends", function() { return __WEBPACK_IMPORTED_MODULE_0__expert_getters_expert__["r"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "replayMessageIds", function() { return __WEBPACK_IMPORTED_MODULE_0__expert_getters_expert__["s"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "mediaId", function() { return __WEBPACK_IMPORTED_MODULE_0__expert_getters_expert__["t"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isUpdateVideo", function() { return __WEBPACK_IMPORTED_MODULE_0__expert_getters_expert__["u"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "courseMsgList", function() { return __WEBPACK_IMPORTED_MODULE_0__expert_getters_expert__["v"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "guestbookList", function() { return __WEBPACK_IMPORTED_MODULE_0__expert_getters_expert__["w"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "weeks", function() { return __WEBPACK_IMPORTED_MODULE_0__expert_getters_expert__["x"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "imMsgInfo", function() { return __WEBPACK_IMPORTED_MODULE_0__expert_getters_expert__["y"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__user_getters_user__ = __webpack_require__(207);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "userInfo", function() { return __WEBPACK_IMPORTED_MODULE_1__user_getters_user__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "buyInfo", function() { return __WEBPACK_IMPORTED_MODULE_1__user_getters_user__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "payInfo", function() { return __WEBPACK_IMPORTED_MODULE_1__user_getters_user__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "preOrderInfo", function() { return __WEBPACK_IMPORTED_MODULE_1__user_getters_user__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "payStatus", function() { return __WEBPACK_IMPORTED_MODULE_1__user_getters_user__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "catagoryList", function() { return __WEBPACK_IMPORTED_MODULE_1__user_getters_user__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "advertList", function() { return __WEBPACK_IMPORTED_MODULE_1__user_getters_user__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "indexCourseList", function() { return __WEBPACK_IMPORTED_MODULE_1__user_getters_user__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "indexCourseObj", function() { return __WEBPACK_IMPORTED_MODULE_1__user_getters_user__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "userIssues", function() { return __WEBPACK_IMPORTED_MODULE_1__user_getters_user__["j"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "userCourse", function() { return __WEBPACK_IMPORTED_MODULE_1__user_getters_user__["k"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "combineCourse", function() { return __WEBPACK_IMPORTED_MODULE_1__user_getters_user__["l"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "userSerialCourse", function() { return __WEBPACK_IMPORTED_MODULE_1__user_getters_user__["m"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "sedCodeInfo", function() { return __WEBPACK_IMPORTED_MODULE_1__user_getters_user__["n"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "bindMobileInfo", function() { return __WEBPACK_IMPORTED_MODULE_1__user_getters_user__["o"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "treeCoinInfo", function() { return __WEBPACK_IMPORTED_MODULE_1__user_getters_user__["p"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "hotLabelList", function() { return __WEBPACK_IMPORTED_MODULE_1__user_getters_user__["q"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "lamaRecommends", function() { return __WEBPACK_IMPORTED_MODULE_1__user_getters_user__["r"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "freeTinyCourse", function() { return __WEBPACK_IMPORTED_MODULE_1__user_getters_user__["s"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "groupAlbum", function() { return __WEBPACK_IMPORTED_MODULE_1__user_getters_user__["t"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "myCourse", function() { return __WEBPACK_IMPORTED_MODULE_1__user_getters_user__["u"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "myTinyAudio", function() { return __WEBPACK_IMPORTED_MODULE_1__user_getters_user__["v"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "myTinyVideo", function() { return __WEBPACK_IMPORTED_MODULE_1__user_getters_user__["w"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "myTinyAlbum", function() { return __WEBPACK_IMPORTED_MODULE_1__user_getters_user__["x"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "myTinyVideoAlbum", function() { return __WEBPACK_IMPORTED_MODULE_1__user_getters_user__["y"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "audio5", function() { return __WEBPACK_IMPORTED_MODULE_1__user_getters_user__["z"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "indexInfo", function() { return __WEBPACK_IMPORTED_MODULE_1__user_getters_user__["A"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isSort", function() { return __WEBPACK_IMPORTED_MODULE_1__user_getters_user__["B"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "columnList", function() { return __WEBPACK_IMPORTED_MODULE_1__user_getters_user__["C"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "leaveMessageList", function() { return __WEBPACK_IMPORTED_MODULE_1__user_getters_user__["D"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "newCourseInfo", function() { return __WEBPACK_IMPORTED_MODULE_1__user_getters_user__["E"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "myIncome", function() { return __WEBPACK_IMPORTED_MODULE_1__user_getters_user__["F"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "constantData", function() { return __WEBPACK_IMPORTED_MODULE_1__user_getters_user__["G"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "vipInfo", function() { return __WEBPACK_IMPORTED_MODULE_1__user_getters_user__["H"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "memberFreeCourse", function() { return __WEBPACK_IMPORTED_MODULE_1__user_getters_user__["I"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "indexModuleList", function() { return __WEBPACK_IMPORTED_MODULE_1__user_getters_user__["J"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "freeAnsCount", function() { return __WEBPACK_IMPORTED_MODULE_1__user_getters_user__["K"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nim_getters__ = __webpack_require__(199);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "currSessionFormatMsgs", function() { return __WEBPACK_IMPORTED_MODULE_2__nim_getters__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "currSessionMsgs", function() { return __WEBPACK_IMPORTED_MODULE_2__nim_getters__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "noMoreHistoryMsgs", function() { return __WEBPACK_IMPORTED_MODULE_2__nim_getters__["c"]; });





var connectStatus = function connectStatus(state) {
  return state.connectStatus;
};
var error = function error(state) {
  return state.error;
};
var socket = function socket(state) {
  return state.socket;
};
var signData = function signData(state) {
  return state.signData;
};
var wxSignStatus = function wxSignStatus(state) {
  return state.wxSignStatus;
};

var isLoading = function isLoading(state) {
  return state.isLoading;
};
var courseInfo = function courseInfo(state) {
  return state.courseInfo;
};
var courseCloseState = function courseCloseState(state) {
  return state.courseCloseState;
};

var currentMessages = function currentMessages(state) {
  return state.messages;
};
var latestMessage = function latestMessage(state) {
  return state.latestMessage;
};
var firstMessage = function firstMessage(state) {
  return state.firstMessage;
};
var sendMessages = function sendMessages(state) {
  return state.sendMessages;
};
var audioList = function audioList(state) {
  return state.audioList;
};

var lastPlayAudio = function lastPlayAudio(state) {
  return state.lastPlayAudio;
};
var serialList = function serialList(state) {
  return state.serialList;
};

var cashierPayStatus = function cashierPayStatus(state) {
  return state.cashierPayStatus;
};

/***/ }),

/***/ 197:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_findIndex__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_uniqBy__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_uniqBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_uniqBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_find__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_js_cookie__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_auth__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__comm_model___ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mutation_types__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__comm_utils__ = __webpack_require__(73);









var _types$AJAX_LOADING$t;








function resetSocketState(state, type) {
  if (type === 6) {
    state.audio = {
      serverId: null,
      speech: null
    };
  }
}

/* harmony default export */ __webpack_exports__["a"] = (_types$AJAX_LOADING$t = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["t" /* AJAX_LOADING */], function (state, _ref) {
  var loadingStatus = _ref.loadingStatus;

  state.isLoading = loadingStatus;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["z" /* AJAX_HOT_LABEL_LIST */], function (state, hotLabelList) {
  state.hotLabelList = hotLabelList;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["h" /* TREE_COIN_INFO */], function (state, treeCoinInfo) {
  state.treeCoinInfo.balance = treeCoinInfo.balance;
  state.treeCoinInfo.accountList = treeCoinInfo.data || [];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["f" /* SERIAL_LIST */], function (state, _ref2) {
  var info = _ref2.info,
      curpage = _ref2.curpage,
      curType = _ref2.curType;
  var _state$serialList = state.serialList,
      type = _state$serialList.type,
      list = _state$serialList.list;

  var newList = [];
  if (type !== curType) {
    state.serialList = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, {
      type: curType,
      list: info.list,
      curpage: curpage,
      hasNextPage: info.hasNextPage || false
    });
  } else {
    newList = newList.concat(list);
    newList = newList.concat(info.list);
    state.serialList = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, state.serialList, {
      list: newList,
      curpage: curpage,
      hasNextPage: info.hasNextPage || false
    });
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["g" /* TREE_COIN_INFO_MORE */], function (state, treeCoinInfo) {
  if (treeCoinInfo.pageNo === 1) {
    state.treeCoinInfo.list = treeCoinInfo.list;
  } else {
    state.treeCoinInfo.list = state.treeCoinInfo.list.concat(treeCoinInfo.list);
  }
  state.treeCoinInfo.hasNextPage = treeCoinInfo.hasNextPage;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["w" /* AJAX_GET_COURSE_RECOMMEND */], function (state, courseRecommends) {
  state.courseRecommends = courseRecommends.rs;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["V" /* AJAX_GET_LAMA_RECOMMEND */], function (state, lamaRecommends) {
  state.lamaRecommends = lamaRecommends.rs;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["e" /* COURSE_CLOSED */], function (state, _ref3) {
  var status = _ref3.status;

  state.courseCloseState = status;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["k" /* SOCKET_CONNECT */], function (state, _ref4) {
  var socket = _ref4.socket;

  state.socket = socket;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["j" /* SOCKET_CONNECT_STATUS */], function (state, _ref5) {
  var status = _ref5.status;

  if (!status) {
    window.clearInterval(window.messageInterval);
  }
  state.connectStatus = status;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["b" /* SOCKET_SEND_MESSAGE */], function (state, _ref6) {
  var message = _ref6.message;

  state.sendMessages[message.clientSeqId] = message;
  if (message.type === 7 || message.type === 8) {
    state.replayMessageIds.push(message.refMsgId);
  }
  resetSocketState(state, message.type);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["m" /* SOCKET_RECEIVE_MESSAGE_UP */], function (state, _ref7) {
  var courseUpCount = _ref7.courseUpCount;

  state.courseUpCount = courseUpCount;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["n" /* SOCKET_RECEIVE_MESSAGE_LIKE_COUNT */], function (state, _ref8) {
  var msgId = _ref8.msgId,
      count = _ref8.count,
      likeType = _ref8.likeType;

  if (likeType === 'message') {
    var message = __WEBPACK_IMPORTED_MODULE_7_lodash_find___default()(state.messages, function (messageItem) {
      return messageItem.id === msgId;
    });
    message.interestCount = count;
    message.like = true;
  } else if (likeType === 'question') {
    var userIssues = __WEBPACK_IMPORTED_MODULE_7_lodash_find___default()(state.userIssues.list, function (issuesItem) {
      return issuesItem.id === msgId;
    });
    console.log(count);
    userIssues.sender.like = true;
    userIssues.interestCount += 1;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["l" /* SOCKET_RECEIVE_MESSAGE */], function (state, _ref9) {
  var messages = _ref9.messages,
      clientSeqId = _ref9.clientSeqId;

  var newMessages = [];
  if (messages) {
    var latestMessage = state.latestMessage;

    var _loop = function _loop(message) {
      var messageModel = __WEBPACK_IMPORTED_MODULE_10__comm_model___["d" /* message */](message);

      var result = __WEBPACK_IMPORTED_MODULE_7_lodash_find___default()(state.messages, function (messageItem) {
        return messageItem.id === messageModel.id;
      });

      if (!result || messageModel.quickInsert) {
        if (!latestMessage || messageModel.createTime > latestMessage.createTime) {
          latestMessage = messageModel;
        }

        if (messageModel.type === 3) {
          var refFlag = __WEBPACK_IMPORTED_MODULE_7_lodash_find___default()(state.replayMessageIds, function (refId) {
            return refId === messageModel.id;
          });

          if (refFlag) {
            messageModel.refMessage = true;
          }
        }
        if ((messageModel.type === 6 || messageModel.type === 7) && !messageModel.deleted) {
          messageModel.mediaId = messages[0].mediaId;
          messageModel.playStatus = false;

          if (!messageModel.quickInsert) {
            var isQuickInsert = false;
            console.log('message ' + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(message));
            console.log('audioList ' + state.audioList.length);
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(state.audioList), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var _audio = _step2.value;

                if (_audio.quickInsert && _audio.clientSeqId === clientSeqId) {
                  isQuickInsert = true;
                  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()(_audio, messageModel);
                  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()(_audio.messageModel, messageModel);

                  _audio.quickInsert = false;
                  break;
                }
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2['return']) {
                  _iterator2['return']();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }

            if (isQuickInsert) {
              return 'continue';
            }
          } else {
            messageModel.contentCopy = messageModel.content;
          }

          var audio = {
            id: messageModel.id,
            src: messageModel.content,
            speech: messageModel.speech,
            playStatus: messageModel.playStatus
          };

          if (messageModel.quickInsert) {
            __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()(audio, {
              clientSeqId: messageModel.clientSeqId,
              quickInsert: messageModel.quickInsert,
              messageModel: messageModel
            });
          }
          state.audioList.push(audio);
        }
        newMessages.push(messageModel);

        console.log('pushmessageModel', messageModel);
      }
    };

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(messages), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var message = _step.value;

        var _ret = _loop(message);

        if (_ret === 'continue') continue;
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator['return']) {
          _iterator['return']();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    if (newMessages.length) {
      console.log('newMessages ===> ' + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(newMessages));
      var concatMessages = state.messages.concat(newMessages);
      if (concatMessages.length > 50 && !state.isLookHistoryMessage) {
        concatMessages.splice(0, concatMessages.length - 50);
      }
      state.messages = concatMessages;
      state.latestMessage = latestMessage;
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["o" /* SOCKET_RECEIVE_MESSAGE_DELETE */], function (state, _ref10) {
  var msgId = _ref10.msgId;

  state.messages.forEach(function (message, i, array) {
    if (message.id === msgId) {
      array.splice(i, 1);
    }
  });
  state.audioList.forEach(function (item, i, array) {
    if (item.id === msgId) {
      array.splice(i, 1);
    }
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["a" /* AJAX_ERROR */], function (state, err) {
  if (err.message.indexOf('已过期') > 0) {
    __WEBPACK_IMPORTED_MODULE_9__lib_auth__["a" /* default */].clear();
  }
  state.error = err;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["s" /* RESET_MESSAGES */], function (state) {
  state.messages = [];
  state.messageStore = [];
  state.audioList = [];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["c" /* RESET_MESSAGE_STORE */], function (state) {
  state.messageStore = [];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["i" /* AJAX_GET_MESSAGES */], function (state, _ref11) {
  var messages = _ref11.messages;

  var newMessages = [];
  var firstMessage = null;
  var latestMessage = null;

  if (messages.length) {
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(messages), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var message = _step3.value;

        var _messageModel = __WEBPACK_IMPORTED_MODULE_10__comm_model___["d" /* message */](message);

        if (!latestMessage || _messageModel.createTime > latestMessage.createTime) {
          latestMessage = _messageModel;
        }

        if (!firstMessage || _messageModel.createTime < firstMessage.createTime) {
          firstMessage = _messageModel;
        }

        if (_messageModel.type === 6 || _messageModel.type === 7) {
          _messageModel.playStatus = false;
          state.audioList.push({
            id: _messageModel.id,
            src: _messageModel.content,
            speech: _messageModel.speech,
            playStatus: _messageModel.playStatus
          });
        }

        newMessages.push(_messageModel);
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3['return']) {
          _iterator3['return']();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }

    state.messages = __WEBPACK_IMPORTED_MODULE_6_lodash_uniqBy___default()(newMessages.concat(state.messages), 'id');

    if (latestMessage) {
      state.latestMessage = latestMessage;
    }

    state.firstMessage = firstMessage;
  }

  if (state.firstAjaxStatus === 0) {
    state.firstAjaxStatus = 1;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["_13" /* AJAX_GET_COURSELIST */], function (state, _ref12) {
  var courseList = _ref12.courseList,
      pageNo = _ref12.pageNo;

  var courseTemp = void 0;
  var courseListTemp = [];
  courseList.list.forEach(function (course) {
    courseTemp = __WEBPACK_IMPORTED_MODULE_10__comm_model___["e" /* course */](course);
    courseListTemp.push(courseTemp);
  });
  if (pageNo === 1 || pageNo === '1' || pageNo === '') {
    state.courseList = {
      hasNextPage: courseList.hasNextPage,
      data: courseListTemp,
      pageNo: pageNo
    };
  } else {
    var _state$courseList$dat;

    (_state$courseList$dat = state.courseList.data).push.apply(_state$courseList$dat, courseListTemp);
    state.courseList = {
      hasNextPage: courseList.hasNextPage,
      data: state.courseList.data,
      pageNo: pageNo
    };
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["u" /* AJAX_GET_COURSEINFO */], function (state, _ref13) {
  var courseInfo = _ref13.courseInfo,
      _ref13$filter = _ref13.filter,
      filter = _ref13$filter === undefined ? false : _ref13$filter;

  state.courseInfo = filter ? __WEBPACK_IMPORTED_MODULE_10__comm_model___["e" /* course */](courseInfo) : courseInfo;
  state.courseUpCount = state.courseInfo.likeNum;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["_7" /* AJAX_GET_NEWCOURSEINFO */], function (state, _ref14) {
  var newCourseInfo = _ref14.newCourseInfo,
      _ref14$filter = _ref14.filter,
      filter = _ref14$filter === undefined ? false : _ref14$filter;

  state.newCourseInfo = newCourseInfo;
  state.courseInfo = newCourseInfo;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["v" /* AJAX_GET_SERIALCOURSEINFO */], function (state, _ref15) {
  var courseInfo = _ref15.courseInfo,
      _ref15$filter = _ref15.filter,
      filter = _ref15$filter === undefined ? true : _ref15$filter;

  state.courseInfo = filter ? __WEBPACK_IMPORTED_MODULE_10__comm_model___["e" /* course */](courseInfo) : courseInfo;
  state.courseUpCount = state.courseInfo.likeNum;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["_14" /* AJAX_GET_MATERIAL_PICTURELIST */], function (state, _ref16) {
  var pictureList = _ref16.pictureList,
      naxtPage = _ref16.naxtPage,
      hasPictures = _ref16.hasPictures;

  var pictureTemp = void 0;
  var pictureListTemp = [];

  state.hasPictures = hasPictures;

  pictureList.forEach(function (picture) {
    pictureTemp = __WEBPACK_IMPORTED_MODULE_10__comm_model___["f" /* picture */](picture);
    pictureListTemp.push(pictureTemp);
  });
  console.log('AJAX_GET_MATERIAL_PICTURELIST', naxtPage);
  if (naxtPage) {
    if (pictureListTemp.length > 0) {
      state.materialPictureList = state.materialPictureList.concat(pictureListTemp);
    }
  } else {
    state.materialPictureList = pictureListTemp;
  }
  console.log('materialPictureList', state.materialPictureList);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["_15" /* AJAX_GET_MATERIAL_PPTLIST */], function (state, _ref17) {
  var PPTList = _ref17.PPTList,
      naxtPage = _ref17.naxtPage,
      hasPPTs = _ref17.hasPPTs;

  var pictureTemp = void 0;
  var pictureListTemp = [];

  state.hasPPTs = hasPPTs;

  PPTList.forEach(function (picture) {
    pictureTemp = __WEBPACK_IMPORTED_MODULE_10__comm_model___["f" /* picture */](picture);
    pictureListTemp.push(pictureTemp);
  });
  if (naxtPage) {
    if (pictureListTemp.length > 0) {
      state.materialPPTList = state.materialPPTList.concat(pictureListTemp);
    }
  } else {
    state.materialPPTList = pictureListTemp;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["_16" /* AJAX_GET_MATERIAL_AUDIOLIST */], function (state, _ref18) {
  var audioList = _ref18.audioList,
      naxtPage = _ref18.naxtPage,
      hasNextPage = _ref18.hasNextPage;

  var audioTemp = void 0;
  var audioListTemp = [];
  audioList.forEach(function (audio) {
    audioTemp = __WEBPACK_IMPORTED_MODULE_10__comm_model___["g" /* audio */](audio);
    audioListTemp.push(audioTemp);
  });
  console.log('AJAX_GET_MATERIAL_AUDIOLIST', naxtPage, hasNextPage);
  if (naxtPage) {
    if (audioListTemp.length > 0) {
      state.materialaAudioList = state.materialaAudioList.concat(audioListTemp);
      if (state.materialaAudioList.length > 0 && !hasNextPage) {
        state.materialaAudioList[state.materialaAudioList.length - 1].last = true;
      }
    }
  } else {
    state.materialaAudioList = audioListTemp;
    if (state.materialaAudioList.length > 0 && !hasNextPage) {
      state.materialaAudioList[state.materialaAudioList.length - 1].last = true;
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["_17" /* AJAX_GET_MATERIAL_VIDEOLIST */], function (state, _ref19) {
  var videoList = _ref19.videoList,
      naxtPage = _ref19.naxtPage,
      hasNextPage = _ref19.hasNextPage;

  var videoTemp = void 0;
  var videoListTemp = [];
  videoList.forEach(function (video) {
    videoTemp = __WEBPACK_IMPORTED_MODULE_10__comm_model___["h" /* video */](video);
    videoListTemp.push(videoTemp);
  });

  if (naxtPage) {
    if (videoListTemp.length > 0) {
      state.materialaVideoList = state.materialaVideoList.concat(videoListTemp);
      if (state.materialaVideoList.length > 0 && !hasNextPage) {
        state.materialaVideoList[state.materialaVideoList.length - 1].last = true;
      }
    }
  } else {
    state.materialaVideoList = videoListTemp;
    if (state.materialaVideoList.length > 0 && !hasNextPage) {
      state.materialaVideoList[state.materialaVideoList.length - 1].last = true;
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["d" /* AJAX_WX_SIGN_STATUS */], function (state, _ref20) {
  var _ref20$status = _ref20.status,
      status = _ref20$status === undefined ? 0 : _ref20$status;

  state.wxSignStatus = status;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["_20" /* AJAX_WX_STARTRECORD */], function (state) {
  console.log('AJAX_WX_STARTRECORD');
  state.startRecordTime = new Date();
  state.audio.isUpload = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["_21" /* AJAX_WX_STOPRECORD */], function (state, payload) {
  console.log('AJAX_WX_STOPRECORD');
  state.startRecordTime = null;
  state.audio = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["_23" /* AJAX_WX_UPDATERECORD */], function (state, payload) {
  console.log('AJAX_WX_UPDATERECORD');
  payload.audioState = 'update';
  state.audio = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["_24" /* AJAX_WX_RERECORD */], function (state) {
  console.log('AJAX_WX_RERECORD');
  state.startRecordTime = null;
  state.audio = {
    serverId: null,
    speech: null,
    isUpload: false
  };
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["_22" /* AJAX_WX_UPLOADRECORD */], function (state) {
  state.audio.isUpload = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["_38" /* AJAX_WX_ONVOICERECORDEND */], function () {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["_39" /* AJAX_WX_UPLOADVOICE */], function () {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["_40" /* AJAX_WX_GETNETWORKTYPE */], function () {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["_41" /* AJAX_WX_CHOOSEIMAGE */], function (state, _ref21) {
  var imageLocalIds = _ref21.imageLocalIds;

  state.imageLocalIds = imageLocalIds;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["_25" /* AJAX_WX_CHOOSESENDIMAGE */], function (state, _ref22) {
  var imageServerIds = _ref22.imageServerIds;

  state.sendImageLocalIds = imageServerIds;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["_19" /* DELETEIMAGEONLOCAL */], function (state, _ref23) {
  var imageIds = _ref23.imageIds;

  imageIds.forEach(function (value) {
    return state.materialPictureList.forEach(function (_v, _i) {
      if (value === _v.id) {
        state.materialPictureList.splice(_i, 1);
      }
    });
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["_18" /* CLEAR_MATERIALLIST_LOCAL */], function (state) {
  state.materialPictureList = [];
  state.materialaAudioList = [];
  state.materialaVideoList = [];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["_12" /* AJAX_GET_EXPERTAUTH */], function (state, _ref24) {
  var info = _ref24.info;

  state.expertInfo = __WEBPACK_IMPORTED_MODULE_10__comm_model___["i" /* expertInfo */](info);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["_26" /* COMPONENTS_CURRENTMESSAGE */], function (state, _ref25) {
  var replyMessage = _ref25.replyMessage;

  state.replyMessage = replyMessage;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["_27" /* COMPONENTS_POPUPVISIBLE */], function (state, payload) {
  state.livePopupVisible = payload.livePopupVisible;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["_28" /* COMPONENTS_LIVEBARACTIVE */], function (state, payload) {
  state.isActive = payload.isActive;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["_29" /* AJAX_GET_ISSUES */], function (state, _ref26) {
  var issues = _ref26.issues,
      lastId = _ref26.lastId;

  if (lastId) {
    var _state$issues$list;

    (_state$issues$list = state.issues.list).push.apply(_state$issues$list, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(issues.list));
    state.issues = {
      hasNextPage: issues.hasNextPage,
      list: state.issues.list
    };
  } else {
    state.issues = issues;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["y" /* AJAX_GET_USERINFO */], function (state, _ref27) {
  var userInfo = _ref27.userInfo;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_utils__["a" /* updateLoginInfo */])({ token: userInfo.token, userInfo: userInfo });
  state.userInfo = userInfo;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["A" /* AJAX_BUY_INFO */], function (state, _ref28) {
  var buyInfo = _ref28.buyInfo;

  state.buyInfo = buyInfo;
  var courseInfo = state.courseInfo;
  if (buyInfo.amount === 0) {
    courseInfo.join = true;
  }
  state.courseInfo = courseInfo;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["B" /* AJAX_PAY_INFO */], function (state, _ref29) {
  var payInfo = _ref29.payInfo;

  state.payInfo = payInfo;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["C" /* AJAX_ORDER_INFO */], function (state, _ref30) {
  var preOrderInfo = _ref30.preOrderInfo;

  state.preOrderInfo = preOrderInfo;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["_35" /* UPDATE_MESSAGE_REF_STATUS */], function (state, _ref31) {
  var refMsgId = _ref31.refMsgId;

  state.messages.forEach(function (message) {
    if (Number(message.id) === Number(refMsgId)) {
      message.refMessage = true;
    }
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["_11" /* AJAX_GET_SIGNDATA */], function (state, _ref32) {
  var signData = _ref32.signData;

  state.signData = __WEBPACK_IMPORTED_MODULE_10__comm_model___["j" /* sign */](signData);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["_36" /* LOOK_HISTORY_MESSAGE */], function (state, _ref33) {
  var _ref33$status = _ref33.status,
      status = _ref33$status === undefined ? 0 : _ref33$status;

  state.isLookHistoryMessage = status;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["G" /* AJAX_POST_ADDCOMMENT */], function (state, _ref34) {
  var commentId = _ref34.commentId;

  var courseInfo = state.courseInfo;
  var newCourseInfo = state.newCourseInfo;
  console.log('mutation-courseInfo', commentId, courseInfo.id);
  if (commentId === courseInfo.id) {
    courseInfo.canComment = false;
  }
  state.courseInfo = courseInfo;
  if (commentId === newCourseInfo.id) {
    newCourseInfo.canComment = false;
  }
  state.newCourseInfo = newCourseInfo;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["H" /* AJAX_GET_CATAGORY */], function (state, _ref35) {
  var list = _ref35.list;

  state.catagoryList = list;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["I" /* AJAX_GET_INDEXLIST */], function (state, _ref36) {
  var indexData = _ref36.indexData,
      newPage = _ref36.newPage;

  console.log('newPage', newPage);
  if (newPage) {
    var indexDataTemp = [];
    indexData.courseList.forEach(function (courseClassify) {
      var courseTemp = {};
      var courseListTemp = [];
      courseClassify.list.forEach(function (course) {
        courseTemp = __WEBPACK_IMPORTED_MODULE_10__comm_model___["e" /* course */](course);
        courseListTemp.push(courseTemp);
      });
      if (courseClassify.startStatus === 1) {
        if (!indexDataTemp[0]) {
          indexDataTemp[0] = courseClassify;
        }
        indexDataTemp[0].list = courseListTemp;
      } else if (courseClassify.startStatus === 0) {
        if (!indexDataTemp[1]) {
          indexDataTemp[1] = courseClassify;
        }
        indexDataTemp[1].list = courseListTemp;
      } else if (courseClassify.startStatus === 2) {
        if (!indexDataTemp[2]) {
          indexDataTemp[2] = courseClassify;
        }
        indexDataTemp[2].list = courseListTemp;
      }
    });
    state.advertList = indexData.advertList;
    state.indexCourseList = indexDataTemp;
    state.indexCourseObj = {
      startStatus: indexData.startStatus,
      nextPageNum: indexData.nextPageNum
    };
  } else {
    var tmpArray = state.indexCourseList;
    indexData.courseList.forEach(function (newList) {
      if (newList.startStatus === 1) {
        if (tmpArray[0]) {
          tmpArray[0].list = tmpArray[0].list.concat(newList.list);
        } else {
          tmpArray[0] = newList;
        }
      }
      if (newList.startStatus === 0) {
        if (tmpArray[1]) {
          tmpArray[1].list = tmpArray[1].list.concat(newList.list);
        } else {
          tmpArray[1] = newList;
        }
      }
      if (newList.startStatus === 2) {
        if (tmpArray[2]) {
          tmpArray[2].list = tmpArray[2].list.concat(newList.list);
        } else {
          tmpArray[2] = newList;
        }
      }
    });
    tmpArray.forEach(function (courseClassify, i) {
      var courseTemp = {};
      var courseListTemp = [];
      courseClassify.list.forEach(function (course) {
        courseTemp = __WEBPACK_IMPORTED_MODULE_10__comm_model___["e" /* course */](course);
        courseListTemp.push(courseTemp);
      });
      tmpArray[i].list = courseListTemp;
    });
    state.indexCourseList = tmpArray;
    state.indexCourseObj = {
      startStatus: indexData.startStatus,
      nextPageNum: indexData.nextPageNum
    };
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["p" /* AUDIO_LOADSTART */], function (state, _ref37) {
  var msgId = _ref37.msgId;

  var message = __WEBPACK_IMPORTED_MODULE_7_lodash_find___default()(state.messages, function (messageItem) {
    return messageItem.id === msgId;
  });
  message.loadstartStatus = true;
  message.playingStatus = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["q" /* AUDIO_PLAYING */], function (state, _ref38) {
  var msgId = _ref38.msgId;

  var message = __WEBPACK_IMPORTED_MODULE_7_lodash_find___default()(state.messages, function (messageItem) {
    return messageItem.id === msgId;
  });
  message.playingStatus = true;
  message.loadstartStatus = false;
  if (state.lastPlayAudio) {
    state.lastPlayAudio.playingStatus = true;
  }
  state.lastPlayAudio = message;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["r" /* AUDIO_STOP */], function (state, _ref39) {
  var msgId = _ref39.msgId;

  var message = __WEBPACK_IMPORTED_MODULE_7_lodash_find___default()(state.messages, function (messageItem) {
    return messageItem.id === msgId;
  });
  if (message) {
    message.loadstartStatus = false;
    message.playingStatus = false;
    if (state.lastPlayAudio) {
      state.lastPlayAudio.playingStatus = false;
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["D" /* MY_PAY */], function (state, _ref40) {
  var payInfo = _ref40.payInfo,
      _ref40$status = _ref40.status,
      status = _ref40$status === undefined ? 0 : _ref40$status;

  state.payStatus = {
    ordernum: payInfo.ordernum,
    courseId: payInfo.courseId,
    status: status,
    type: 'MY_PAY'
  };
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["E" /* WX_PAY */], function (state, _ref41) {
  var payInfo = _ref41.payInfo,
      _ref41$status = _ref41.status,
      status = _ref41$status === undefined ? 0 : _ref41$status;

  state.payStatus = {
    ordernum: payInfo.ordernum,
    courseId: payInfo.courseId,
    status: status,
    type: 'WX_PAY'
  };
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["F" /* CLEAR_PAY_STATUS */], function (state) {
  state.payStatus = {
    courseId: null,
    ordernum: null,
    status: 0 };
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["J" /* AJAX_GET_USER_ISSUES */], function (state, _ref42) {
  var issues = _ref42.issues,
      lastId = _ref42.lastId;

  var issuesTemp = [];
  issues.list.forEach(function (item) {
    issuesTemp.push(__WEBPACK_IMPORTED_MODULE_10__comm_model___["k" /* userIssues */](item));
  });
  if (lastId) {
    var _state$userIssues$lis;

    (_state$userIssues$lis = state.userIssues.list).push.apply(_state$userIssues$lis, issuesTemp);
    state.userIssues = {
      hasNextPage: issues.hasNextPage,
      list: state.userIssues.list
    };
  } else {
    state.userIssues = {
      hasNextPage: issues.hasNextPage,
      list: issuesTemp
    };
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["K" /* AJAX_GET_USERCOURSE */], function (state, _ref43) {
  var courseData = _ref43.courseData,
      newPage = _ref43.newPage,
      coursetype = _ref43.coursetype;

  if (!coursetype) {
    var userCourseList = courseData.list;
    if (!newPage) {
      userCourseList = state.userCourse.list.concat(courseData.list);
    }
    state.userCourse = {
      list: userCourseList,
      hasNextPage: courseData.hasNextPage
    };
  } else if (coursetype === 1) {
    var userSerialCourseList = courseData.list;
    if (!newPage) {
      userSerialCourseList = state.userSerialCourse.list.concat(courseData.list);
    }
    state.userSerialCourse = {
      list: userSerialCourseList,
      hasNextPage: courseData.hasNextPage
    };
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["L" /* AJAX_GET_COMBINECOURSE */], function (state, _ref44) {
  var courseData = _ref44.courseData,
      newPage = _ref44.newPage;

  var userCourseList = courseData.list;
  if (!newPage) {
    userCourseList = state.combineCourse.list.concat(courseData.list);
  }
  state.combineCourse = {
    list: userCourseList,
    hasNextPage: courseData.hasNextPage
  };
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["M" /* AJAX_POST_USERSENDCODE */], function (state, _ref45) {
  var sedCodeInfo = _ref45.sedCodeInfo;

  state.sedCodeInfo = sedCodeInfo.rescode;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["N" /* AJAX_POST_USERBINDING */], function (state, _ref46) {
  var bindMobileInfo = _ref46.bindMobileInfo;

  state.bindMobileInfo = bindMobileInfo;

  state.userInfo.isHaveMobile = 1;
  state.userInfo.token = bindMobileInfo.user[0].token;
  __WEBPACK_IMPORTED_MODULE_8_js_cookie___default.a.set('userInfo', state.userInfo);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_utils__["a" /* updateLoginInfo */])({ token: state.userInfo.token, userInfo: state.userInfo });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["_30" /* AJAX_GET_SLIDES */], function (state, _ref47) {
  var slides = _ref47.slides;

  state.slides = {
    list: slides,
    hasSlides: slides.length > 0
  };
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["O" /* AJAX_GET_MYTINYAUDIO */], function (state, _ref48) {
  var myTinyAudio = _ref48.myTinyAudio,
      curpage = _ref48.curpage;

  var list = [];
  if (curpage === 1) {
    list = myTinyAudio.list;
  } else {
    list = state.myTinyAudio.myTinyAudioList.concat(myTinyAudio.list);
  }
  state.myTinyAudio = {
    myTinyAudioList: list,
    hasNextPage: myTinyAudio.hasNextPage
  };
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["S" /* AJAX_UPDATE_AUDIO5 */], function (state, _ref49) {
  var audio5 = _ref49.audio5,
      audioObj = _ref49.audioObj;

  audio5.src = audioObj.url;
  audio5.playId = audioObj.id;
  state.audio5 = audio5;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["P" /* AJAX_GET_MYTINYALBUM */], function (state, _ref50) {
  var myTinyAlbum = _ref50.myTinyAlbum,
      curpage = _ref50.curpage;

  var list = [];
  if (curpage === 1) {
    list = myTinyAlbum.list;
  } else {
    list = state.myTinyAlbum.myTinyAlbumList.concat(myTinyAlbum.list);
  }
  state.myTinyAlbum = {
    myTinyAlbumList: list,
    hasNextPage: myTinyAlbum.hasNextPage
  };
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["Q" /* AJAX_GET_MYTINYVIDEO */], function (state, _ref51) {
  var myTinyVideo = _ref51.myTinyVideo,
      curpage = _ref51.curpage;

  var list = [];
  if (curpage === 1) {
    list = myTinyVideo.list;
  } else {
    list = state.myTinyVideo.myTinyVideoList.concat(myTinyVideo.list);
  }
  state.myTinyVideo = {
    myTinyVideoList: list,
    hasNextPage: myTinyVideo.hasNextPage
  };
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["R" /* AJAX_GET_MYTINYVIDEOALBUM */], function (state, _ref52) {
  var myTinyVideoAlbum = _ref52.myTinyVideoAlbum,
      curpage = _ref52.curpage;

  var list = [];
  if (curpage === 1) {
    list = myTinyVideoAlbum.list;
  } else {
    list = state.myTinyVideoAlbum.myTinyVideoAlbumList.concat(myTinyVideoAlbum.list);
  }
  state.myTinyVideoAlbum = {
    myTinyVideoAlbumList: list,
    hasNextPage: myTinyVideoAlbum.hasNextPage
  };
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["T" /* AJAX_GET_GROUPALBUM */], function (state, _ref53) {
  var groupAlbum = _ref53.groupAlbum,
      curpage = _ref53.curpage;

  console.log(groupAlbum);
  var list = [];

  if (curpage === 1) {
    list = groupAlbum.list;
  } else {
    list = state.groupAlbum.groupAlbumList.concat(groupAlbum.list);
  }

  state.groupAlbum = {
    groupAlbumList: list,
    hasNextPage: groupAlbum.hasNextPage
  };

  console.log(state.groupAlbum);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["U" /* CASHIER_PAY */], function (state, _ref54) {
  var _ref54$status = _ref54.status,
      status = _ref54$status === undefined ? 0 : _ref54$status;

  state.cashierPayStatus = status;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["W" /* AJAX_GET_FREETINYAUDIO */], function (state, _ref55) {
  var freeTinyCourseList = _ref55.freeTinyCourseList,
      curpage = _ref55.curpage;

  var list = [];
  if (curpage === 1) {
    list = freeTinyCourseList.list;
  } else {
    list = state.freeTinyCourse.list.concat(freeTinyCourseList.list);
  }
  state.freeTinyCourse = {
    list: list,
    hasNextPage: freeTinyCourseList.hasNextPage
  };
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["X" /* COURSE_REMIND */], function (state, _ref56) {
  var courseRemind = _ref56.courseRemind;

  state.indexInfo.courseRemind = courseRemind;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["_0" /* REMIND_CLOSE */], function (state, _ref57) {
  var closeStatus = _ref57.closeStatus;

  state.indexInfo.closeStatus = closeStatus;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["Y" /* HOME_INFO */], function (state, _ref58) {
  var pageInfo = _ref58.pageInfo;

  state.indexInfo.pageInfo = pageInfo;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["Z" /* RECOMMEND_LIST */], function (state, _ref59) {
  var recommendList = _ref59.recommendList;

  var list = state.indexInfo.recommendList.concat(recommendList.list);
  state.indexInfo.recommendList = list;
  state.indexInfo.hasNextPage = recommendList.hasNextPage;
  state.indexInfo.nextPageNum = recommendList.curpage + 1;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["_1" /* CHANGE_HOTCOURSE */], function (state, _ref60) {
  var hotCourse = _ref60.hotCourse;

  state.indexInfo.hotCourse = hotCourse;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["_2" /* INDEX_MODULE_LIST */], function (state, _ref61) {
  var indexModuleList = _ref61.indexModuleList;

  state.indexInfo.indexModuleList = indexModuleList;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["_3" /* AJAX_GET_MYCOURSE */], function (state, _ref62) {
  var courseList = _ref62.courseList;

  var myCourseList = state.myCourse.list.concat(courseList.dataList);
  state.myCourse = {
    list: myCourseList,
    hasNextPage: courseList.hasNextPage,
    isquerynostart: courseList.isquerynostart,
    indexstart: courseList.indexstart,
    nextPageNum: courseList.nextPageNum,
    curpage: courseList.curpage
  };
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["_4" /* IS_SORT */], function (state, _ref63) {
  var isSort = _ref63.isSort;

  state.isSort = isSort;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["_6" /* AJAX_GET_COLUMNLIST */], function (state, _ref64) {
  var courseList = _ref64.courseList,
      curpage = _ref64.curpage;

  var columnList = state.columnList.list.concat(courseList.list);
  state.columnList = {
    list: curpage === 1 ? courseList.list : columnList,
    hasNextPage: courseList.hasNextPage
  };
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["_5" /* MESSAGE_LIST */], function (state, _ref65) {
  var dataList = _ref65.dataList;

  var messageList = state.leaveMessageList.dataList.concat(dataList.dataList);
  state.leaveMessageList = {
    dataList: dataList.curpage === 1 ? dataList.dataList : messageList,
    hasNextPage: dataList.hasNextPage,
    curpage: dataList.curpage + 1,
    buyRemind: dataList.buyRemind,
    totalCount: dataList.totalCount
  };
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["_8" /* AJAX_GET_MY_INCOME */], function (state, _ref66) {
  var curpage = _ref66.curpage,
      myIncome = _ref66.myIncome;

  var list = [];
  if (curpage === 1) {
    list = myIncome.list;
  } else {
    list = state.myIncome.list.concat(myIncome.list);
  }
  state.myIncome = {
    list: list,
    hasNextPage: myIncome.hasNextPage,
    sumAmount: myIncome.sumAmount,
    counts: myIncome.counts
  };
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["_31" /* AJAX_GET_COURSE_MSG_LIST */], function (state, payload) {
  if (state.courseMsgList.curpage === 0) {
    state.courseMsgList = payload;
  } else {
    var newList = state.courseMsgList.list.concat(payload.list);
    state.courseMsgList = {
      curpage: payload.curpage,
      hasNextPage: payload.hasNextPage,
      list: newList
    };
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["_32" /* AJAX_GET_GUESTBOOK_LIST */], function (state, payload) {
  if (payload.curpage === 1) {
    state.guestbookList = payload;
  } else {
    var newList = state.guestbookList.dataList.concat(payload.dataList);
    state.guestbookList = {
      curpage: payload.curpage,
      hasNextPage: payload.hasNextPage,
      dataList: newList
    };
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["_34" /* ADD_REPLY_TO_LIST */], function (state, payload) {
  console.log(payload);

  var id = payload.id;
  if (!id) {
    return;
  }
  var dataList = state.guestbookList.dataList;
  var i = __WEBPACK_IMPORTED_MODULE_5_lodash_findIndex___default()(dataList, { id: id });
  dataList[i] = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["_33" /* DEL_REPLY_TO_LIST */], function (state, _ref67) {
  var id = _ref67.id;

  var dataList = state.guestbookList.dataList;
  var i = __WEBPACK_IMPORTED_MODULE_5_lodash_findIndex___default()(dataList, { replayGuestbook: { id: id } });
  if (i !== -1) {
    dataList[i] = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, dataList[i], {
      isReply: 0,
      replayGuestbook: {}
    });
    state.guestbookList = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, state.guestbookList, {
      dataList: dataList
    });
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["x" /* AJAX_GET_CONSTANT_DATA */], function (state, _ref68) {
  var constantData = _ref68.constantData;

  state.constantData = constantData;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["_10" /* VIP_INFO */], function (state, _ref69) {
  var vipInfo = _ref69.vipInfo;

  state.vipInfo = vipInfo;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["_9" /* AJAX_GET_MEMBER_FREE_COURSE */], function (state, _ref70) {
  var catagoryid = _ref70.catagoryid,
      memberFreeCourse = _ref70.memberFreeCourse;

  var tmpList = memberFreeCourse.list;
  if (memberFreeCourse.curpage !== 1) {
    tmpList = state.memberFreeCourse.list.concat(memberFreeCourse.list);
  }
  state.memberFreeCourse = {
    catagorys: memberFreeCourse.catagorys,
    catagoryid: catagoryid,
    list: tmpList,
    hasNextPage: memberFreeCourse.hasNextPage,
    courseNum: memberFreeCourse.courseNum,
    curpage: memberFreeCourse.curpage
  };
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$AJAX_LOADING$t, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["_42" /* FREE_ANS_COUNT */], function (state, freeAnsCount) {
  state.freeAnsCount = freeAnsCount;
}), _types$AJAX_LOADING$t);

/***/ }),

/***/ 198:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return connect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getRecord; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_auth__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__comm_middleware_callApi__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__comm_api_apis__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__initNimSDK__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__msgs__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__session__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__team__ = __webpack_require__(204);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_5__initNimSDK__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_6__msgs__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_6__msgs__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_6__msgs__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_6__msgs__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_6__msgs__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_6__msgs__["i"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_6__msgs__["j"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_7__session__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_7__session__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_7__session__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_8__team__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_8__team__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_8__team__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_8__team__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_8__team__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_8__team__["f"]; });











function connectNim(_ref, obj) {
    var state = _ref.state,
        commit = _ref.commit,
        dispatch = _ref.dispatch;

    var _Object$assign = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, obj),
        force = _Object$assign.force;

    var expertInfo = state.expertInfo;

    if (!expertInfo || !expertInfo.id) {
        __WEBPACK_IMPORTED_MODULE_1__lib_auth__["a" /* default */].login('expert', null);
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_4__comm_api_apis__["a" /* default */].getNimToken, { expertid: expertInfo.id }).then(function (data) {
        var expert = data.data;
        var accId = expert.accId;
        var accToken = expert.accToken;

        if (!state.nim || force) {
            var loginInfo = {
                uid: accId,
                sdktoken: accToken
            };

            if (!loginInfo.uid) {
                __WEBPACK_IMPORTED_MODULE_1__lib_auth__["a" /* default */].login('expert', null);
            } else {
                dispatch('initNimSDK', loginInfo);
            }
        }
    });
}

var connect = function connect(store, obj) {
    var _Object$assign3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, obj),
        type = _Object$assign3.type;

    type = type || 'nim';
    switch (type) {
        case 'nim':
            connectNim(store, obj);
            break;
        case 'chatroom':
            break;
    }
};

var getRecord = function getRecord(_ref2, _ref3) {
    var commit = _ref2.commit;
    var media_id = _ref3.media_id,
        _ref3$media_type = _ref3.media_type,
        media_type = _ref3$media_type === undefined ? 2 : _ref3$media_type;

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_4__comm_api_apis__["a" /* default */].getRecord, { media_id: media_id, media_type: media_type }).then(function (body) {
        return body.data;
    });
};



/***/ }),

/***/ 199:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return currSessionFormatMsgs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return currSessionMsgs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return noMoreHistoryMsgs; });

var currSessionFormatMsgs = function currSessionFormatMsgs(state) {
  return state.currSessionFormatMsgs;
};
var currSessionMsgs = function currSessionMsgs(state) {
  return state.currSessionMsgs;
};
var noMoreHistoryMsgs = function noMoreHistoryMsgs(state) {
  return state.noMoreHistoryMsgs;
};

/***/ }),

/***/ 200:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initNimSDK;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_NIM_Web_NIM_v6_2_0__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__msgs__ = __webpack_require__(113);




function initNimSDK(_ref, loginInfo) {
  var state = _ref.state,
      commit = _ref.commit,
      dispatch = _ref.dispatch;

  if (state.nim) {
    state.nim.disconnect();
  }

  window.nim = state.nim = NIM.getInstance({
    debug: __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].debug,
    appKey: __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].IMappKey,
    account: loginInfo.uid,
    token: loginInfo.sdktoken,
    db: false,
    needReconnect: true,
    syncSessionUnread: true,
    syncRobots: true,
    autoMarkRead: true,
    onconnect: function onConnect(event) {
      if (loginInfo) {
        commit('updateUserUID', loginInfo);
      }
    },

    onerror: function onError(event) {
      debugger;
      alert('网络连接状态异常');
    },

    onwillreconnect: function onWillReconnect(obj) {
      console.log(obj);
    },
    ondisconnect: function onDisconnect(error) {
      switch (error.code) {
        case 302:
          alert('帐号或密码错误');
          break;

        case 'kicked':
          alert('您的账号被踢下线');
          break;
        default:
          break;
      }
    },
    onloginportschange: function onLoginPortsChange(loginPorts) {
      console.log('当前登录帐号在其它端的状态发生改变了', loginPorts);
    },

    onroamingmsgs: __WEBPACK_IMPORTED_MODULE_2__msgs__["a" /* onRoamingMsgs */],
    onofflinemsgs: __WEBPACK_IMPORTED_MODULE_2__msgs__["b" /* onOfflineMsgs */],
    onmsg: __WEBPACK_IMPORTED_MODULE_2__msgs__["c" /* onMsg */] });
}

/***/ }),

/***/ 201:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3____ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_cookie__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(28);









/* harmony default export */ __webpack_exports__["a"] = ({
  updateRefreshState: function updateRefreshState(state) {
    state.isRefresh = false;
  },
  updateLoading: function updateLoading(state, status) {
    clearTimeout(state.loadingTimer);
    state.loadingTimer = setTimeout(function () {
      state.isLoading = status;
    }, 20);
  },
  updateFullscreenImage: function updateFullscreenImage(state, obj) {
    obj = obj || {};
    if (obj.src && obj.type === 'show') {
      state.fullscreenImgSrc = obj.src;
      state.isFullscreenImgShow = true;
    } else if (obj.type === 'hide') {
      state.fullscreenImgSrc = ' ';
      state.isFullscreenImgShow = false;
    }
  },
  updateUserUID: function updateUserUID(state, loginInfo) {
    state.userUID = loginInfo.uid;
    state.sdktoken = loginInfo.sdktoken;
    var time = new Date().getTime() + 24 * 60 * 60 * 1000;
    __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.set('uid', loginInfo.uid, { expires: time, path: '/' });
    __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.set('sdktoken', loginInfo.sdktoken, { expires: time, path: '/' });
  },
  updateMyInfo: function updateMyInfo(state, myInfo) {
    state.myInfo = __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].mergeObject(state.myInfo, myInfo);
  },
  updateUserInfo: function updateUserInfo(state, users) {
    var userInfos = state.userInfos;
    users.forEach(function (user) {
      var account = user.account;
      if (account) {
        userInfos[account] = __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].mergeObject(userInfos[account], user);
      }
    });
    state.userInfos = __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].mergeObject(state.userInfos, userInfos);
  },
  updateFriends: function updateFriends(state, friends) {
    var cutFriends = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

    var nim = state.nim;
    state.friendslist = nim.mergeFriends(state.friendslist, friends);

    state.friendslist = nim.cutFriends(state.friendslist, friends.invalid);
  },
  updateRobots: function updateRobots(state, robots) {
    var nim = state.nim;
    robots = robots.map(function (item) {
      if (item.avatar) {
        item.originAvatar = item.avatar;
        item.avatar = nim.viewImageSync({
          url: item.avatar,
          thumbnail: {
            width: 40,
            height: 40,
            mode: 'cover'
          }
        });
      } else {
        item.avatar = __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].defaultUserIcon;
      }
      return item;
    });
    state.robotslist = robots;
    state.robotInfos = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default()(null);
    robots.forEach(function (robot) {
      state.robotInfos[robot.account] = robot;
      state.robotInfosByNick[robot.nick] = robot;
    });
  },
  updateBlacklist: function updateBlacklist(state, blacks) {
    var nim = state.nim;
    state.blacklist = nim.cutFriends(state.blacklist, blacks.invalid);
    var addBlacks = blacks.filter(function (item) {
      return item.isBlack === true;
    });
    var remBlacks = blacks.filter(function (item) {
      return item.isBlack === false;
    });

    state.blacklist = nim.mergeFriends(state.blacklist, addBlacks);

    state.blacklist = nim.cutFriends(state.blacklist, remBlacks);
  },
  updateSearchlist: function updateSearchlist(state, obj) {
    var type = obj.type;
    switch (type) {
      case 'user':
        if (obj.list.length !== 0 || state.searchedUsers.length !== 0) {
          state.searchedUsers = obj.list;
        } else {
          state.searchedUsers = [];
        }
        break;
      case 'team':
        if (obj.list.length !== 0 || state.searchedTeams.length !== 0) {
          state.searchedTeams = obj.list;
        } else {
          state.searchedTeams = [];
        }
        break;
    }
  },
  updateSessions: function updateSessions(state, sessions) {
    var nim = state.nim;
    state.sessionlist = nim.mergeSessions(state.sessionlist, sessions);
    state.sessionlist.sort(function (a, b) {
      return b.updateTime - a.updateTime;
    });
    state.sessionlist.forEach(function (item) {
      state.sessionMap[item.id] = item;
    });
  },
  deleteSessions: function deleteSessions(state, sessionIds) {
    var nim = state.nim;
    state.sessionlist = nim.cutSessionsByIds(state.sessionlist, sessionIds);
  },
  updateMsgs: function updateMsgs(state, msgs) {
    var nim = state.nim;
    var tempSessionMap = {};
    msgs.forEach(function (msg) {
      var sessionId = msg.sessionId;
      tempSessionMap[sessionId] = true;
      if (!state.msgs[sessionId]) {
        state.msgs[sessionId] = [];
      }

      state.msgs[sessionId] = nim.mergeMsgs(state.msgs[sessionId], [msg]);
    });
    __WEBPACK_IMPORTED_MODULE_3____["a" /* default */].commit('updateMsgByIdClient', msgs);
    for (var sessionId in tempSessionMap) {
      state.msgs[sessionId].sort(function (a, b) {
        if (a.time === b.time) {
          if (a.type === 'robot' && b.type === 'robot') {
            if (a.content && a.content.msgOut) {
              return 1;
            }
            if (b.content && b.content.msgOut) {
              return -1;
            }
          }
        }
        return a.time - b.time;
      });
      if (sessionId === state.currSessionId) {
        __WEBPACK_IMPORTED_MODULE_3____["a" /* default */].commit('updateCurrSessionMsgs', {
          type: 'init'
        });
      }
    }
  },
  putMsg: function putMsg(state, msg) {
    var sessionId = msg.sessionId;
    if (!state.msgs[sessionId]) {
      state.msgs[sessionId] = [];
    }
    __WEBPACK_IMPORTED_MODULE_3____["a" /* default */].commit('updateMsgByIdClient', msg);
    var tempMsgs = state.msgs[sessionId];
    var lastMsgIndex = tempMsgs.length - 1;
    if (tempMsgs.length === 0 || msg.time >= tempMsgs[lastMsgIndex].time) {
      tempMsgs.push(msg);
    } else {
      for (var i = lastMsgIndex; i >= 0; i--) {
        var currMsg = tempMsgs[i];
        if (msg.time >= currMsg.time) {
          state.msgs[sessionId].splice(i, 0, msg);
          break;
        }
      }
    }
  },
  deleteMsg: function deleteMsg(state, msg) {
    var sessionId = msg.sessionId;
    var tempMsgs = state.msgs[sessionId];
    if (!tempMsgs || tempMsgs.length === 0) {
      return;
    }
    var lastMsgIndex = tempMsgs.length - 1;
    for (var i = lastMsgIndex; i >= 0; i--) {
      var currMsg = tempMsgs[i];
      if (msg.idClient === currMsg.idClient) {
        state.msgs[sessionId].splice(i, 1);
        break;
      }
    }
  },
  replaceMsg: function replaceMsg(state, obj) {
    var sessionId = obj.sessionId,
        idClient = obj.idClient,
        msg = obj.msg;

    var tempMsgs = state.msgs[sessionId];
    if (!tempMsgs || tempMsgs.length === 0) {
      return;
    }
    var lastMsgIndex = tempMsgs.length - 1;
    for (var i = lastMsgIndex; i >= 0; i--) {
      var currMsg = tempMsgs[i];
      console.log(idClient, currMsg.idClient, currMsg.text);
      if (idClient === currMsg.idClient) {
        state.msgs[sessionId].splice(i, 1, msg);
        break;
      }
    }
  },
  updateMsgByIdClient: function updateMsgByIdClient(state, msgs) {
    if (!Array.isArray(msgs)) {
      msgs = [msgs];
    }
    var tempTime = new Date().getTime();
    msgs.forEach(function (msg) {
      if (msg.idClient && tempTime - msg.time < 1000 * 300) {
        state.msgsMap[msg.idClient] = msg;
      }
    });
  },
  updateCurrSessionId: function updateCurrSessionId(state, obj) {
    var type = obj.type || '';
    if (type === 'destroy') {
      state.currSessionId = null;
    } else if (type === 'init') {
      if (obj.sessionId && obj.sessionId !== state.currSessionId) {
        state.currSessionId = obj.sessionId;
      }
    }
  },
  updateCurrSessionMsgs: function updateCurrSessionMsgs(state, obj) {
    var type = obj.type || '';
    if (type === 'destroy') {
      state.currSessionMsgs = [];
      state.currSessionFormatMsgs = [];
      state.currSessionLastMsg = null;
      __WEBPACK_IMPORTED_MODULE_3____["a" /* default */].commit('updateCurrSessionId', {
        type: 'destroy'
      });
    } else if (type === 'init') {
      if (state.currSessionId) {
        var sessionId = state.currSessionId;
        var currSessionMsgs = [].concat(state.msgs[sessionId] || []);

        var limit = __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].localMsglimit;
        var msgLen = currSessionMsgs.length;
        if (msgLen - limit > 0) {
          state.currSessionLastMsg = currSessionMsgs[msgLen - limit];
          currSessionMsgs = currSessionMsgs.slice(msgLen - limit, msgLen);
        } else if (msgLen > 0) {
          state.currSessionLastMsg = currSessionMsgs[0];
        } else {
          state.currSessionLastMsg = null;
        }
        state.currSessionMsgs = [];
        state.currSessionFormatMsgs = [];
        var lastMsgTime = 0;
        currSessionMsgs.forEach(function (msg) {
          if (msg.time - lastMsgTime > 1000 * 60 * 5) {
            lastMsgTime = msg.time;
            var timeMsg = {
              type: 'timeTag',
              text: __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].formatDate(msg.time, false)
            };
            state.currSessionMsgs.push(timeMsg);
            state.currSessionFormatMsgs.push(__WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].transNimMsg(timeMsg));
          }
          state.currSessionMsgs.push(msg);
          state.currSessionFormatMsgs.push(__WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].transNimMsg(msg));
        });
        __WEBPACK_IMPORTED_MODULE_3____["a" /* default */].dispatch('checkTeamMsgReceipt', state.currSessionMsgs);
      }
    } else if (type === 'put') {
      var newMsg = obj.msg;
      var _lastMsgTime = 0;
      var lenCurrMsgs = state.currSessionMsgs.length;
      if (lenCurrMsgs > 0) {
        _lastMsgTime = state.currSessionMsgs[lenCurrMsgs - 1].time;
      }
      if (newMsg) {
        if (newMsg.time - _lastMsgTime > 1000 * 60 * 5) {
          var timeMsg = {
            type: 'timeTag',
            text: __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].formatDate(newMsg.time, false)
          };
          state.currSessionMsgs.push(timeMsg);
          state.currSessionFormatMsgs.push(__WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].transNimMsg(timeMsg));
        }
        state.currSessionMsgs.push(newMsg);
        state.currSessionFormatMsgs.push(__WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].transNimMsg(newMsg));
        __WEBPACK_IMPORTED_MODULE_3____["a" /* default */].dispatch('checkTeamMsgReceipt', [newMsg]);
      }
    } else if (type === 'concat') {
      var _currSessionMsgs = [];
      var _lastMsgTime2 = 0;
      obj.msgs.forEach(function (msg) {
        if (msg.time - _lastMsgTime2 > 1000 * 60 * 5) {
          _lastMsgTime2 = msg.time;
          var _timeMsg = {
            type: 'timeTag',
            text: __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].formatDate(msg.time, false)
          };
          _currSessionMsgs.push(_timeMsg);
        }
        _currSessionMsgs.push(msg);
      });
      _currSessionMsgs.reverse();
      _currSessionMsgs.forEach(function (msg) {
        state.currSessionMsgs.unshift(msg);
        state.currSessionFormatMsgs.unshift(__WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].transNimMsg(msg));
      });
      if (obj.msgs[0]) {
        state.currSessionLastMsg = obj.msgs[0];
      }
      __WEBPACK_IMPORTED_MODULE_3____["a" /* default */].dispatch('checkTeamMsgReceipt', _currSessionMsgs);
    } else if (type === 'replace') {
      var _msgLen = state.currSessionMsgs.length;
      var lastMsgIndex = _msgLen - 1;
      if (_msgLen > 0) {
        for (var i = lastMsgIndex; i >= 0; i--) {
          if (state.currSessionMsgs[i].idClient === obj.idClient) {
            state.currSessionMsgs.splice(i, 1, obj.msg);
            state.currSessionFormatMsgs.splice(i, 1, __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].transNimMsg(obj.msg));
            break;
          }
        }
      }
    }
  },
  updateSysMsgs: function updateSysMsgs(state, sysMsgs) {
    var nim = state.nim;
    if (!Array.isArray(sysMsgs)) {
      sysMsgs = [sysMsgs];
    }
    sysMsgs = sysMsgs.map(function (msg) {
      msg.showTime = __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].formatDate(msg.time, false);
      return msg;
    });

    state.sysMsgs = [].concat(nim.mergeSysMsgs(state.sysMsgs, sysMsgs));
    __WEBPACK_IMPORTED_MODULE_7_vue__["default"].set(state, sysMsgs, state.sysMsgs);
  },
  updateSysMsgState: function updateSysMsgState(state, sysMsg) {
    var exitMsg = state.sysMsgs.find(function (msg) {
      return msg.idServer === sysMsg.idServer;
    });
    if (exitMsg) {
      exitMsg.state = sysMsg.state;
    }
  },
  updateSysMsgUnread: function updateSysMsgUnread(state, obj) {
    state.sysMsgUnread = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, obj);
  },
  updateCustomSysMsgs: function updateCustomSysMsgs(state, sysMsgs) {
    var nim = state.nim;
    if (!Array.isArray(sysMsgs)) {
      sysMsgs = [sysMsgs];
    }
    sysMsgs = sysMsgs.map(function (msg) {
      msg.showTime = __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].formatDate(msg.time, false);
      return msg;
    });

    state.customSysMsgs = state.customSysMsgs.concat(sysMsgs);
    __WEBPACK_IMPORTED_MODULE_7_vue__["default"].set(state, sysMsgs, state.customSysMsgs);
    __WEBPACK_IMPORTED_MODULE_3____["a" /* default */].commit('updateCustomSysMsgUnread', {
      type: 'add',
      unread: sysMsgs.length
    });
  },
  updateCustomSysMsgUnread: function updateCustomSysMsgUnread(state, obj) {
    var type = obj.type,
        unread = obj.unread;

    switch (type) {
      case 'reset':
        state.customSysMsgUnread = unread || 0;
        break;
      case 'add':
        state.customSysMsgUnread += unread;
        break;
    }
  },
  resetSysMsgs: function resetSysMsgs(state, obj) {
    var type = obj.type;
    switch (type) {
      case 0:
        state.sysMsgs = [];
        break;
      case 1:
        state.customSysMsgs = [];
        __WEBPACK_IMPORTED_MODULE_3____["a" /* default */].commit('updateCustomSysMsgUnread', {
          type: 'reset'
        });
        break;
    }
  },
  deleteSysMsgs: function deleteSysMsgs(state, obj) {
    var type = obj.type;
    var idServer = obj.idServer;
    var arr = type === 0 ? state.sysMsgs : state.customSysMsgs;
    arr = arr.filter(function (msg) {
      return msg.idServer !== idServer;
    });
    __WEBPACK_IMPORTED_MODULE_7_vue__["default"].set(state, 'sysMsgs', arr);
  },
  setNoMoreHistoryMsgs: function setNoMoreHistoryMsgs(state) {
    state.noMoreHistoryMsgs = true;
  },
  resetNoMoreHistoryMsgs: function resetNoMoreHistoryMsgs(state) {
    state.noMoreHistoryMsgs = false;
  },
  continueRobotMsg: function continueRobotMsg(state, robotAccid) {
    state.continueRobotAccid = robotAccid;
  },
  initChatroomInfos: function initChatroomInfos(state, obj) {
    state.chatroomInfos = obj;
  },
  setCurrChatroom: function setCurrChatroom(state, chatroomId) {
    state.currChatroomId = chatroomId;
    state.currChatroom = state.chatroomInsts[chatroomId];
    state.currChatroomMsgs = [];
    state.currChatroomInfo = {};
    state.currChatroomMembers = [];
  },
  resetCurrChatroom: function resetCurrChatroom(state) {
    state.currChatroomId = null;
    state.currChatroom = null;
    state.currChatroomMsgs = [];
    state.currChatroomInfo = {};
    state.currChatroomMembers = [];
  },
  updateChatroomInfo: function updateChatroomInfo(state, obj) {
    state.currChatroomInfo = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(state.currChatroomInfo, obj);
  },
  updateCurrChatroomMsgs: function updateCurrChatroomMsgs(state, obj) {
    var _Object$assign2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, obj),
        type = _Object$assign2.type,
        msgs = _Object$assign2.msgs;

    if (type === 'put') {
      msgs.forEach(function (msg) {
        var chatroomId = msg.chatroomId;
        if (chatroomId === state.currChatroomId) {
          msgs.forEach(function (msg) {
            state.currChatroomMsgs.push(msg);
          });
        }
      });
    } else if (type === 'concat') {
      var currSessionMsgs = obj.msgs;
      currSessionMsgs.reverse();
      currSessionMsgs.forEach(function (msg) {
        state.currSessionMsgs.unshift(msg);
      });
      if (obj.msgs[0]) {
        state.currSessionLastMsg = obj.msgs[0];
      }
    }
  },
  getChatroomInfo: function getChatroomInfo(state, obj) {
    state.currChatroomInfo = obj;
  },
  updateChatroomMembers: function updateChatroomMembers(state, obj) {
    var type = obj.type,
        members = obj.members;

    if (type === 'destroy') {
      state.currChatroomMembers = [];
    } else if (type === 'put') {
      members.forEach(function (member) {
        if (member.online) {
          state.currChatroomMembers.push(member);
        }
      });
    }
  },
  updateTeamList: function updateTeamList(state, teams) {
    var nim = state.nim;
    __WEBPACK_IMPORTED_MODULE_3____["a" /* default */].state.teamlist = nim.mergeTeams(__WEBPACK_IMPORTED_MODULE_3____["a" /* default */].state.teamlist, teams);
    __WEBPACK_IMPORTED_MODULE_3____["a" /* default */].state.teamlist = nim.cutTeams(__WEBPACK_IMPORTED_MODULE_3____["a" /* default */].state.teamlist, teams.invalid);
  },
  updateTeamMembers: function updateTeamMembers(state, obj) {
    var nim = state.nim;
    var teamId = obj.teamId;
    var members = obj.members;
    state.teamMembers = state.teamMembers || {};
    state.teamMembers[teamId] = nim.mergeTeamMembers(state.teamMembers[teamId], members);
    state.teamMembers[teamId] = nim.cutTeamMembers(state.teamMembers[teamId], members.invalid);
    state.teamMembers[teamId].sort(function (a, b) {
      if (a.type === 'owner' || b.type === 'owner') {
        return a.type === 'owner' ? -1 : 1;
      }
      if (a.type === 'manager' || b.type === 'manager') {
        return a.type === 'manager' ? -1 : b.type === 'manager' ? 1 : 0;
      }
      return -1;
    });
    state.teamMembers = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, state.teamMembers);
  },
  removeTeamMembersByAccounts: function removeTeamMembersByAccounts(state, obj) {
    var teamId = obj.teamId;
    var invalidAccounts = obj.accounts;
    if (state.teamMembers[teamId] === undefined) return;
    state.teamMembers[teamId] = state.teamMembers[teamId].filter(function (member, index) {
      return invalidAccounts.indexOf(member.account) === -1;
    });
    state.teamMembers = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, state.teamMembers);
  },
  updateTeamInfo: function updateTeamInfo(state, team) {
    var index = state.teamlist.findIndex(function (item) {
      return item.teamId === team.teamId;
    });
    if (index === -1) return;
    for (var key in team) {
      if (key !== 'teamId' && team.hasOwnProperty(key) && team[key]) {
        state.teamlist[index][key] = team[key];
      }
    }
  },
  updateTeamSettingConfig: function updateTeamSettingConfig(state, obj) {
    state.teamSettingConfig = obj;
  },
  updateSentReceipedMap: function updateSentReceipedMap(state, obj) {
    var _state$sentReceipedMa;

    if (!obj || obj.length < 1) {
      return;
    }
    var teamId = obj[0].teamId;
    if (!state.sentReceipedMap[teamId]) {
      state.sentReceipedMap[teamId] = [];
    }
    (_state$sentReceipedMa = state.sentReceipedMap[teamId]).push.apply(_state$sentReceipedMa, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(obj.map(function (msg) {
      return msg.idServer;
    })));
  },
  updateReceiptQueryList: function updateReceiptQueryList(state, obj) {
    if (state.currReceiptQueryTeamId !== obj.teamId) {
      state.receiptQueryList = [];
      state.teamMsgReads = [];
      state.currReceiptQueryTeamId = obj.teamId;
    }
    var needQuery = obj.msgs.filter(function (msg) {
      return msg.needMsgReceipt && msg.from === state.myInfo.account && !state.receiptQueryList.find(function (item) {
        return item.idServer === msg.idServer;
      });
    }).map(function (msg) {
      return {
        teamId: obj.teamId,
        idServer: msg.idServer
      };
    });
    if (needQuery.length > 0) {
      var _state$receiptQueryLi;

      (_state$receiptQueryLi = state.receiptQueryList).push.apply(_state$receiptQueryLi, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(needQuery));
    }
    if (needQuery.length > 0) {
      __WEBPACK_IMPORTED_MODULE_3____["a" /* default */].dispatch('getTeamMsgReads', needQuery);
    }
  },
  updateTeamMsgReads: function updateTeamMsgReads(state, obj) {
    var _state$teamMsgReads;

    (_state$teamMsgReads = state.teamMsgReads).push.apply(_state$teamMsgReads, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(obj.teamMsgReceipts));
  },
  updateSingleTeamMsgReads: function updateSingleTeamMsgReads(state, obj) {
    state.teamMsgReads.forEach(function (item) {
      if (item.idServer === obj.idServer) {
        item.unread = obj.unread;
        item.read = obj.read;
      }
    });

    var unreadAccounts = state.teamMsgReadsDetail.unreadAccounts;
    var findIndex = unreadAccounts.findIndex(function (account) {
      return account === obj.account;
    });
    if (findIndex >= 0) {
      unreadAccounts.splice(findIndex, 1);
      state.teamMsgReadsDetail.readAccounts.push(obj.account);
    }
  },
  initMsgReceiptDetail: function initMsgReceiptDetail(state, obj) {
    state.teamMsgReadsDetail.readAccounts = obj.readAccounts;
    state.teamMsgReadsDetail.unreadAccounts = obj.unreadAccounts;
  }
});

/***/ }),

/***/ 202:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export onSessions */
/* unused harmony export onUpdateSession */
/* harmony export (immutable) */ __webpack_exports__["a"] = deleteSession;
/* harmony export (immutable) */ __webpack_exports__["b"] = setCurrSession;
/* harmony export (immutable) */ __webpack_exports__["c"] = resetCurrSession;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0____ = __webpack_require__(27);


function updateSessionAccount(sessions) {
  var accountsNeedSearch = [];
  sessions.forEach(function (item) {
    if (item.scene === 'p2p') {
      if (!__WEBPACK_IMPORTED_MODULE_0____["a" /* default */].state.userInfos[item.to]) {
        accountsNeedSearch.push(item.to);
      }
    }
  });
  if (accountsNeedSearch.length > 0) {
    __WEBPACK_IMPORTED_MODULE_0____["a" /* default */].dispatch('searchUsers', {
      accounts: accountsNeedSearch
    });
  }
}

function onSessions(sessions) {
  updateSessionAccount(sessions);
  __WEBPACK_IMPORTED_MODULE_0____["a" /* default */].commit('updateSessions', sessions);
}

function onUpdateSession(session) {
  var sessions = [session];
  updateSessionAccount(sessions);
  __WEBPACK_IMPORTED_MODULE_0____["a" /* default */].commit('updateSessions', sessions);
}

function deleteSession(_ref, sessionId) {
  var state = _ref.state,
      commit = _ref.commit;

  var nim = state.nim;
  sessionId = sessionId || '';
  var scene = null;
  var account = null;
  if (/^p2p-/.test(sessionId)) {
    scene = 'p2p';
    account = sessionId.replace(/^p2p-/, '');
  } else if (/^team-/.test(sessionId)) {
    scene = 'team';
    account = sessionId.replace(/^team-/, '');
  }
  if (account && scene) {
    nim.deleteSession({
      scene: scene,
      to: account,
      done: function deleteServerSessionDone(error, obj) {
        if (error) {
          alert(error);
          return;
        }
        nim.deleteLocalSession({
          id: sessionId,
          done: function deleteLocalSessionDone(error, obj) {
            if (error) {
              alert(error);
              return;
            }
            commit('deleteSessions', [sessionId]);
          }
        });
      }
    });
  }
}

function setCurrSession(_ref2, sessionId) {
  var state = _ref2.state,
      commit = _ref2.commit,
      dispatch = _ref2.dispatch;

  var nim = state.nim;
  if (sessionId) {
    commit('updateCurrSessionId', {
      type: 'init',
      sessionId: sessionId
    });
    if (nim) {
      nim.setCurrSession(sessionId);
      commit('updateCurrSessionMsgs', {
        type: 'init',
        sessionId: sessionId
      });

      dispatch('sendMsgReceipt');
    }
  }
}

function resetCurrSession(_ref3) {
  var state = _ref3.state,
      commit = _ref3.commit;

  var nim = state.nim;
  nim.resetCurrSession();
  commit('updateCurrSessionMsgs', {
    type: 'destroy'
  });
}

/***/ }),

/***/ 203:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  isLoading: false,

  isRefresh: true,

  isFullscreenImgShow: false,
  fullscreenImgSrc: '',

  transitionName: 'forward',

  nim: null,

  userUID: null,

  myInfo: {},

  userInfos: {},

  userSubscribes: {},

  friendslist: [],

  robotslist: [],

  robotInfos: {},
  robotInfosByNick: {},

  blacklist: [],


  teamlist: [],

  teamMembers: {},

  muteTeamIds: [],

  teamSettingConfig: {},

  sentReceipedMap: {},

  currReceiptQueryTeamId: null,

  receiptQueryList: [],

  teamMsgReads: [],

  teamMsgReadsDetail: {
    readAccounts: [],
    unreadAccounts: []
  },

  msgs: {},
  msgsMap: {},
  sessionlist: [],
  sessionMap: {},

  currSessionId: null,
  currSessionMsgs: [],
  currSessionFormatMsgs: [],

  noMoreHistoryMsgs: false,

  continueRobotAccid: '',

  sysMsgs: [],
  customSysMsgs: [],
  sysMsgUnread: {
    total: 0
  },
  customSysMsgUnread: 0,

  searchedUsers: [],

  searchedTeams: [],

  chatroomInsts: {},
  chatroomInfos: {},

  chatroomMsgs: {},

  currChatroom: null,
  currChatroomId: null,
  currChatroomMsgs: [],
  currChatroomInfo: {},

  currChatroomMembers: []

});

/***/ }),

/***/ 204:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export onTeams */
/* unused harmony export onTeamMembers */
/* unused harmony export onCreateTeam */
/* unused harmony export onSynCreateTeam */
/* unused harmony export onDismissTeam */
/* unused harmony export onUpdateTeam */
/* harmony export (immutable) */ __webpack_exports__["b"] = onTeamNotificationMsg;
/* unused harmony export onAddTeamMembers */
/* unused harmony export onRemoveTeamMembers */
/* unused harmony export onUpdateTeamMember */
/* unused harmony export onUpdateTeamMembersMute */
/* unused harmony export onUpdateTeamManagers */
/* unused harmony export onTeamMsgReceipt */
/* harmony export (immutable) */ __webpack_exports__["c"] = enterSettingPage;
/* harmony export (immutable) */ __webpack_exports__["a"] = delegateTeamFunction;
/* harmony export (immutable) */ __webpack_exports__["d"] = getTeamMembers;
/* harmony export (immutable) */ __webpack_exports__["e"] = checkTeamMsgReceipt;
/* harmony export (immutable) */ __webpack_exports__["f"] = getTeamMsgReads;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0____ = __webpack_require__(27);


function onTeams(teams) {
  if (!Array.isArray(teams)) {
    teams = [teams];
  }
  teams = teams.filter(function (item) {
    return !!item;
  });
  teams.forEach(function (team) {
    if (team.validToCurrentUser === undefined) {
      team.validToCurrentUser = true;
    }
    if (team.avatar && team.avatar.indexOf('nim.nosdn.127') > 0 && team.avatar.indexOf('?imageView') === -1) {
      team.avatar = team.avatar + '?imageView&thumbnail=300y300';
    }
  });
  __WEBPACK_IMPORTED_MODULE_0____["a" /* default */].commit('updateTeamList', teams);
}

function onTeamMembers(obj) {
  __WEBPACK_IMPORTED_MODULE_0____["a" /* default */].commit('updateTeamMembers', obj);
}

function onCreateTeam(team) {
  onTeams(team);
  onTeamMembers({
    teamId: team.teamId,
    members: []
  });
}

function onSynCreateTeam(team) {
  onTeams(team);
}

function onDismissTeam(obj) {
  __WEBPACK_IMPORTED_MODULE_0____["a" /* default */].commit('updateTeamList', {
    invalid: { teamId: obj.teamId }
  });
}

function onUpdateTeam(team) {
  onTeams(team);
}

function onTeamNotificationMsg(_ref, msg) {
  var state = _ref.state,
      commit = _ref.commit;

  if (msg.attach.type === 'updateTeam' && msg.attach.team) {
    __WEBPACK_IMPORTED_MODULE_0____["a" /* default */].commit('updateTeamInfo', msg.attach.team);
  }
  if (msg.attach.type === 'transferTeam') {
    onTeamMembers({
      teamId: msg.attach.team.teamId,
      members: msg.attach.members
    });
  }
}

function onAddTeamMembers(obj) {
  obj.accounts.forEach(function (account) {
    if (account === __WEBPACK_IMPORTED_MODULE_0____["a" /* default */].state.userUID) {
      var team = [obj.team];
      onTeams(team);
    }
  });
  onTeamMembers({
    teamId: obj.team.teamId,
    members: obj.members
  });
}

function onRemoveTeamMembers(obj) {
  obj.accounts.forEach(function (account) {
    if (account === __WEBPACK_IMPORTED_MODULE_0____["a" /* default */].state.userUID) {
      obj.team.validToCurrentUser = false;
      var team = [obj.team];
      onTeams(team);
    }
  });
  __WEBPACK_IMPORTED_MODULE_0____["a" /* default */].commit('removeTeamMembersByAccounts', {
    teamId: obj.team.teamId,
    accounts: obj.accounts
  });
}

function onUpdateTeamMember(teamMember) {
  onTeamMembers({
    teamId: teamMember.teamId,
    members: teamMember
  });
}

function onUpdateTeamMembersMute(obj) {
  onTeamMembers({
    teamId: obj.team.teamId,
    members: obj.members
  });
}

function onUpdateTeamManagers(obj) {
  onTeamMembers({
    teamId: obj.team.teamId,
    members: obj.members
  });
}

function onTeamMsgReceipt(obj) {
  obj.teamMsgReceipts.forEach(function (item) {
    if (item.teamId === __WEBPACK_IMPORTED_MODULE_0____["a" /* default */].state.currReceiptQueryTeamId) {
      __WEBPACK_IMPORTED_MODULE_0____["a" /* default */].commit('updateSingleTeamMsgReads', item);
    }
  });
  console.log('群消息回执通知' + obj);
}

function enterSettingPage(_ref2, obj) {
  var commit = _ref2.commit;

  commit('updateTeamSettingConfig', obj);
  setTimeout(function () {
    location.href = '#/teamsetting';
  }, 20);
}

function delegateTeamFunction(_ref3, _ref4) {
  var state = _ref3.state;
  var functionName = _ref4.functionName,
      options = _ref4.options;

  var nim = state.nim;
  if (functionName && nim[functionName] && typeof nim[functionName] === 'function') {
    nim[functionName](options);
  } else {
    throw 'There is not property of \'' + functionName + '\' in nim or \'' + functionName + '\' is not a function';
  }
}

function getTeamMembers(_ref5, teamId) {
  var state = _ref5.state;

  var nim = state.nim;
  if (!nim) {
    setTimeout(function () {
      getTeamMembers(__WEBPACK_IMPORTED_MODULE_0____["a" /* default */], teamId);
    }, 200);
    return;
  }
  nim.getTeamMembers({
    teamId: teamId,
    done: function done(err, obj) {
      if (obj.members) {
        onTeamMembers({
          teamId: obj.teamId,
          members: obj.members
        });
      } else {
        setTimeout(function () {
          getTeamMembers(__WEBPACK_IMPORTED_MODULE_0____["a" /* default */], teamId);
        }, 200);
      }
    }
  });
}

function checkTeamMsgReceipt(_ref6, msgs) {
  var state = _ref6.state;

  var result = /team-(\d+)/.exec(state.currSessionId);
  if (!result) {
    return null;
  }
  var teamId = result[1];

  var needToPeceiptList = getMsgNeedToReceipt(state, teamId, msgs);
  if (needToPeceiptList && needToPeceiptList.length > 0) {
    nim.sendTeamMsgReceipt({
      teamMsgReceipts: needToPeceiptList,
      done: function done(err, obj, content) {
        console.log('标记群组消息已读' + (!err ? '成功' : '失败'));
        if (!err) {
          __WEBPACK_IMPORTED_MODULE_0____["a" /* default */].commit('updateSentReceipedMap', needToPeceiptList);
        }
      }
    });
  }

  __WEBPACK_IMPORTED_MODULE_0____["a" /* default */].commit('updateReceiptQueryList', {
    teamId: teamId,
    msgs: msgs
  });
}

function getMsgNeedToReceipt(state, teamId, msgs) {
  var sentReceipedList = state.sentReceipedMap[teamId] || [];
  var needToReceipt = msgs.filter(function (msg) {
    return msg.needMsgReceipt && msg.from !== state.myInfo.account && !sentReceipedList.find(function (id) {
      return id === msg.idServer;
    });
  }).map(function (msg) {
    return {
      teamId: teamId,
      idServer: msg.idServer
    };
  });
  return needToReceipt;
}

function getTeamMsgReads(_ref7, needQuery) {
  var state = _ref7.state;

  nim.getTeamMsgReads({
    teamMsgReceipts: needQuery,
    done: function done(error, obj, content) {
      if (error) {
        console.log('获取群组消息已读' + error);
      } else {
        console.log('获取群组消息已读：', content);
        __WEBPACK_IMPORTED_MODULE_0____["a" /* default */].commit('updateTeamMsgReads', content);
      }
    }
  });
}

/***/ }),

/***/ 205:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getConstantData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getUserLoginStr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getMemberInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return userAuth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getHotLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return courseBuy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return coursePay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getPreOrderInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return courseMaYiPay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getMaYiPayStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return courseWxPay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return clearPayStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return addComment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getCatagory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getIndexList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return courseLike; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return xwCourseLike; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return messageLike; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return getUserIssues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return getUserCourses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return getCombineCourses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return getTheCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return getBindMobile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return getMyTinyAudio; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return getMyTinyAlbum; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return getMyTinyVideo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return getMyTinyVideoAlbum; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return initAudio; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return getGroupAlbum; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return cashierPay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return getLamaRecommends; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return getFreeTinyCourseList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return getQueryByCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return getStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return getFreeList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return getCourseRemind; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return getHomePageData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return getRecommend; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return setRemindStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return changeHotCourse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return getIndexModuleList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return getCourseAudioUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return getMyCourses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return getAudition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return getSubCourseList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return setSort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return getChildDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return getMessageList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return getColumnList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return setLeaveMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return getMyGuestBooks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return bindDelGuest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return bindGiveThumbsup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return getNewCourseInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return getCourseExperts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return getClassifyLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return getExpertsLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return getShareImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return getMyIncome; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return getMemberFreeCourse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return getMemberAd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return setVipInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return getjxjDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return updateRemind; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return getAdvertsGeneral; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return getScholarshipsList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return getCertificate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return getVerifySend; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return getVerifyValid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return getVerified; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return getMyListJxjActivity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return getUserPhone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return getIconList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return getJxjCollectLikes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return getJxjStartLikes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return getJxjDoLikes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return getPunchCardShare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return sendPlayDuration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return getPunchCard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return getIndexInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return getFreeClinicExpert; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return getVoteRankInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return getUserActivityInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return canFreeAuditQues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return getConsultDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return getBabayTreeUploadImg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return getBabayTreeUploadImgbase64; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return getBaseInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return vote; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return getMyConsultList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return questionSubmit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return secretToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return getQueryCertificateType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return getCommentTags; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return getCourseComments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return getChannelModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return getChannelRecommend; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return getCategoryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return getAdByCodes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return getCourseRankList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return getWyethCourse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return bindWyethLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return queryShubi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return queryShubiDetail; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_cookie__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_audio5__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_audio5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_audio5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_crypto__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_crypto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_crypto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mint_ui__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_mutation_types__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_action_util__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_ua__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_utils__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__comm_api__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__comm_model___ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__comm_utils__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__comm_middleware_reportLog__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__dayima_actions_dayima__ = __webpack_require__(206);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return __WEBPACK_IMPORTED_MODULE_18__dayima_actions_dayima__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return __WEBPACK_IMPORTED_MODULE_18__dayima_actions_dayima__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return __WEBPACK_IMPORTED_MODULE_18__dayima_actions_dayima__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return __WEBPACK_IMPORTED_MODULE_18__dayima_actions_dayima__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return __WEBPACK_IMPORTED_MODULE_18__dayima_actions_dayima__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return __WEBPACK_IMPORTED_MODULE_18__dayima_actions_dayima__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return __WEBPACK_IMPORTED_MODULE_18__dayima_actions_dayima__["g"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__knowing_actions_knowing__ = __webpack_require__(208);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return __WEBPACK_IMPORTED_MODULE_19__knowing_actions_knowing__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return __WEBPACK_IMPORTED_MODULE_19__knowing_actions_knowing__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return __WEBPACK_IMPORTED_MODULE_19__knowing_actions_knowing__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return __WEBPACK_IMPORTED_MODULE_19__knowing_actions_knowing__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_63", function() { return __WEBPACK_IMPORTED_MODULE_19__knowing_actions_knowing__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_64", function() { return __WEBPACK_IMPORTED_MODULE_19__knowing_actions_knowing__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_65", function() { return __WEBPACK_IMPORTED_MODULE_19__knowing_actions_knowing__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_66", function() { return __WEBPACK_IMPORTED_MODULE_19__knowing_actions_knowing__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_67", function() { return __WEBPACK_IMPORTED_MODULE_19__knowing_actions_knowing__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_68", function() { return __WEBPACK_IMPORTED_MODULE_19__knowing_actions_knowing__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_69", function() { return __WEBPACK_IMPORTED_MODULE_19__knowing_actions_knowing__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_70", function() { return __WEBPACK_IMPORTED_MODULE_19__knowing_actions_knowing__["l"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_71", function() { return __WEBPACK_IMPORTED_MODULE_19__knowing_actions_knowing__["m"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_72", function() { return __WEBPACK_IMPORTED_MODULE_19__knowing_actions_knowing__["n"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_73", function() { return __WEBPACK_IMPORTED_MODULE_19__knowing_actions_knowing__["o"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_74", function() { return __WEBPACK_IMPORTED_MODULE_19__knowing_actions_knowing__["p"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_75", function() { return __WEBPACK_IMPORTED_MODULE_19__knowing_actions_knowing__["q"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__lighthouse_actions_lighthouse__ = __webpack_require__(209);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_76", function() { return __WEBPACK_IMPORTED_MODULE_20__lighthouse_actions_lighthouse__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_77", function() { return __WEBPACK_IMPORTED_MODULE_20__lighthouse_actions_lighthouse__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_78", function() { return __WEBPACK_IMPORTED_MODULE_20__lighthouse_actions_lighthouse__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_79", function() { return __WEBPACK_IMPORTED_MODULE_20__lighthouse_actions_lighthouse__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_80", function() { return __WEBPACK_IMPORTED_MODULE_20__lighthouse_actions_lighthouse__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_81", function() { return __WEBPACK_IMPORTED_MODULE_20__lighthouse_actions_lighthouse__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_82", function() { return __WEBPACK_IMPORTED_MODULE_20__lighthouse_actions_lighthouse__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_83", function() { return __WEBPACK_IMPORTED_MODULE_20__lighthouse_actions_lighthouse__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_84", function() { return __WEBPACK_IMPORTED_MODULE_20__lighthouse_actions_lighthouse__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_85", function() { return __WEBPACK_IMPORTED_MODULE_20__lighthouse_actions_lighthouse__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_86", function() { return __WEBPACK_IMPORTED_MODULE_20__lighthouse_actions_lighthouse__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_87", function() { return __WEBPACK_IMPORTED_MODULE_20__lighthouse_actions_lighthouse__["l"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_88", function() { return __WEBPACK_IMPORTED_MODULE_20__lighthouse_actions_lighthouse__["m"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_89", function() { return __WEBPACK_IMPORTED_MODULE_20__lighthouse_actions_lighthouse__["n"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_90", function() { return __WEBPACK_IMPORTED_MODULE_20__lighthouse_actions_lighthouse__["o"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_91", function() { return __WEBPACK_IMPORTED_MODULE_20__lighthouse_actions_lighthouse__["p"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_92", function() { return __WEBPACK_IMPORTED_MODULE_20__lighthouse_actions_lighthouse__["q"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_93", function() { return __WEBPACK_IMPORTED_MODULE_20__lighthouse_actions_lighthouse__["r"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_94", function() { return __WEBPACK_IMPORTED_MODULE_20__lighthouse_actions_lighthouse__["s"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_95", function() { return __WEBPACK_IMPORTED_MODULE_20__lighthouse_actions_lighthouse__["t"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_96", function() { return __WEBPACK_IMPORTED_MODULE_20__lighthouse_actions_lighthouse__["u"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_97", function() { return __WEBPACK_IMPORTED_MODULE_20__lighthouse_actions_lighthouse__["v"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_98", function() { return __WEBPACK_IMPORTED_MODULE_20__lighthouse_actions_lighthouse__["w"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_99", function() { return __WEBPACK_IMPORTED_MODULE_20__lighthouse_actions_lighthouse__["x"]; });
























var hasFish = false;
var getConstantData = function getConstantData(_ref, _ref2) {
  var commit = _ref.commit,
      state = _ref.state;
  var typesNum = _ref2.typesNum,
      version = _ref2.version;

  if (hasFish) {
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.resolve();
  }
  hasFish = true;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].constantData, { types: typesNum, version: version }).then(function (body) {
    var constantData = body.data;
    commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["x" /* AJAX_GET_CONSTANT_DATA */], {
      constantData: constantData
    });
    return body.data;
  })['catch'](function () {
    hasFish = false;
  });
};

var getUserLoginStr = function getUserLoginStr(_ref3, _ref4) {
  var commit = _ref3.commit;
  var encuserid = _ref4.encuserid;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].getUserLoginStr, { encuserid: encuserid }).then(function (data) {
    return data.data;
  });
};

var getMemberInfo = function getMemberInfo(_ref5, userInfo) {
  var commit = _ref5.commit,
      state = _ref5.state;
  var updateMember = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__comm_utils__["a" /* updateLoginInfo */])({ token: userInfo.token, userInfo: userInfo });

  var afterUserInfo = __WEBPACK_IMPORTED_MODULE_15__comm_model___["a" /* userInfo */](userInfo);
  commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["y" /* AJAX_GET_USERINFO */], { userInfo: afterUserInfo });
  __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.set('userInfo', afterUserInfo);

  if (updateMember || !userInfo.member) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].queryUserMemberInfo).then(function (info) {
      userInfo.nickName = info.data.name;
      userInfo.avatar = info.data.headImgUrl;
      var formatUserInfo = __WEBPACK_IMPORTED_MODULE_15__comm_model___["a" /* userInfo */](userInfo, info.data);
      commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["y" /* AJAX_GET_USERINFO */], { userInfo: formatUserInfo });
      __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.set('userInfo', formatUserInfo);
    });
  } else {
    var formatUserInfo = __WEBPACK_IMPORTED_MODULE_15__comm_model___["a" /* userInfo */](userInfo, userInfo.member);
    commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["y" /* AJAX_GET_USERINFO */], { userInfo: formatUserInfo });
    __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.set('userInfo', afterUserInfo);
  }
  if (state.constantData.length === 0) {
    getConstantData({ commit: commit }, {
      typesNum: '5',
      version: '1'
    });
  }
};

var userAuth = function userAuth(store, _ref6) {
  var code = _ref6.code,
      _ref6$userInfo = _ref6.userInfo,
      userInfo = _ref6$userInfo === undefined ? null : _ref6$userInfo,
      _ref6$platformType = _ref6.platformType,
      platformType = _ref6$platformType === undefined ? 5 : _ref6$platformType;

  var commit = store.commit;
  commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["t" /* AJAX_LOADING */], { loadingStatus: true });
  if (__WEBPACK_IMPORTED_MODULE_10__lib_ua__["a" /* browser */].wx) {
    if (code) {
      var fxUserInfo = __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.get('userInfo') ? JSON.parse(__WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.get('userInfo')) : null;
      var userSource = 1;
      if (fxUserInfo) {
        userSource = fxUserInfo.userSource;
      }
      if (userSource === 0) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].wxAuthFx, { platformType: platformType, code: code }).then(function (info) {
          fxUserInfo.weixinUserInfo = info;
          getMemberInfo(store, fxUserInfo);
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__store_action_util__["a" /* healthSign */])(store, { userType: 'user', token: info.token });
        });
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].wxAuth, { code: code, platformType: platformType }, {}, false, true).then(function (body) {
          var info = body.user[0];
          info.weixinUserInfo = body.weixinUserInfo;
          getMemberInfo(store, info);
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__store_action_util__["a" /* healthSign */])(store, { userType: 'user', token: info.token });
        });
      }
    } else if (userInfo) {

      var _userSource = userInfo.userSource;
      var hasOpenId = userInfo.weixinUserInfo ? userInfo.weixinUserInfo.openid : 0;
      if (_userSource === 0) {
        if (hasOpenId) {
          getMemberInfo(store, userInfo);
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__store_action_util__["a" /* healthSign */])(store, { userType: 'user', token: userInfo.token });
        }
      } else {
        getMemberInfo(store, userInfo);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__store_action_util__["a" /* healthSign */])(store, { userType: 'user', token: userInfo.token });
      }
    }
  } else {
    var mtTokenStr = __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.get('mttoken') ? __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.get('mttoken') : null;

    commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["t" /* AJAX_LOADING */], { loadingStatus: false });

    if (userInfo && !__WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.get('MT_USER_INFO')) {
      getMemberInfo(store, userInfo);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__store_action_util__["a" /* healthSign */])(store, { userType: 'user', token: userInfo.token });
    } else if (mtTokenStr && !__WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.get('MT_USER_INFO')) {
      var info = {
        token: mtTokenStr,
        encUserId: __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.get('mtencUserId') ? __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.get('mtencUserId') : null,
        avatar: __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.get('mtavatar') ? __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.get('mtavatar') : null,
        nickName: __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.get('mtname') ? __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.get('mtname') : null,
        isHaveMobile: __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.get('mtisHaveMobile') ? __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.get('mtisHaveMobile') : null
      };
      getMemberInfo(store, info);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__store_action_util__["a" /* healthSign */])(store, { userType: 'user', token: info.token });
    } else if (__WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.get('MT_USER_INFO')) {
      var allCookies = __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.get();
      var fck = allCookies.MT_USER_INFO.split(',');
      mtTokenStr = __WEBPACK_IMPORTED_MODULE_11__lib_utils__["a" /* util */].base64Decode(fck[3]);
      var _info = {
        token: mtTokenStr,
        encUserId: __WEBPACK_IMPORTED_MODULE_11__lib_utils__["a" /* util */].base64Decode(fck[5]),
        avatar: null,
        nickName: '',
        isHaveMobile: __WEBPACK_IMPORTED_MODULE_11__lib_utils__["a" /* util */].base64Decode(fck[4]) ? 1 : 0
      };
      if (mtTokenStr) {
        getMemberInfo(store, _info);
      } else {
        __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.set('userInfo', '', { expires: -1 });
        window.localStorage.removeItem('userinfo');
      }
    }
  }
};

var getHotLabel = function getHotLabel(_ref7, labeltype) {
  var commit = _ref7.commit;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].hotLabel, { labeltype: labeltype }).then(function (body) {
    commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["z" /* AJAX_HOT_LABEL_LIST */], body.data.hotLabelList);
  });
};

var courseBuy = function courseBuy(_ref8, _ref9) {
  var commit = _ref8.commit;
  var courseId = _ref9.courseId,
      _ref9$type = _ref9.type,
      type = _ref9$type === undefined ? '1' : _ref9$type,
      _ref9$paywayid = _ref9.paywayid,
      paywayid = _ref9$paywayid === undefined ? '4' : _ref9$paywayid,
      pointpromid = _ref9.pointpromid,
      distributionuserid = _ref9.distributionuserid,
      postuserid = _ref9.postuserid,
      postid = _ref9.postid,
      activityid = _ref9.activityid;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].buy, {
    courseid: courseId,
    type: type,
    paywayid: paywayid,
    pointpromid: pointpromid,
    distributionuserid: distributionuserid,
    postuserid: postuserid,
    postid: postid,
    activityid: activityid
  }).then(function (body) {
    var buyInfo = body.data;
    commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["A" /* AJAX_BUY_INFO */], { buyInfo: buyInfo });
    return buyInfo;
  });
};

var coursePay = function coursePay(_ref10, _ref11) {
  var commit = _ref10.commit;
  var orderCode = _ref11.orderCode,
      _ref11$type = _ref11.type,
      type = _ref11$type === undefined ? '1' : _ref11$type,
      _ref11$paywayid = _ref11.paywayid,
      paywayid = _ref11$paywayid === undefined ? '4' : _ref11$paywayid,
      openid = _ref11.openid,
      wappayresultpage = _ref11.wappayresultpage,
      quiturl = _ref11.quiturl;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].pay, {
    ordercode: orderCode,
    type: type,
    paywayid: paywayid,
    openid: openid,
    wappayresultpage: wappayresultpage,
    quiturl: quiturl,
    weixinappcode: 'wx5699bb5297ae3984'
  }).then(function (body) {
    commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["B" /* AJAX_PAY_INFO */], { payInfo: body.data });
    return paywayid === 16 ? body : body.data;
  });
};

var getPreOrderInfo = function getPreOrderInfo(_ref12, _ref13) {
  var commit = _ref12.commit;
  var courseId = _ref13.courseId,
      _ref13$type = _ref13.type,
      type = _ref13$type === undefined ? '1' : _ref13$type,
      parentcourseid = _ref13.parentcourseid,
      pointpromid = _ref13.pointpromid,
      activityid = _ref13.activityid;

  if (activityid) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].jxjOrder, { courseid: courseId, type: type, parentcourseid: parentcourseid, pointpromid: pointpromid, activityid: activityid }).then(function (body) {
      commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["C" /* AJAX_ORDER_INFO */], {
        preOrderInfo: body.data
      });
      return body.data;
    });
  }
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].order, { courseid: courseId, type: type, parentcourseid: parentcourseid, pointpromid: pointpromid }).then(function (body) {
    commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["C" /* AJAX_ORDER_INFO */], {
      preOrderInfo: body.data
    });
    return body.data;
  });
};

function submitForm(action, params) {
  if (action && action.startsWith('http:')) {
    action = action.replace('http:', 'https:');
  }

  var formEl = document.querySelector('form[name=to-pay-form]');
  if (formEl) {
    var parentNode = formEl.parentNode;
    parentNode.removeChild(formEl);
  }
  var aliForm = document.createElement('form');
  aliForm.name = 'to-pay-form';
  aliForm.action = action;
  aliForm.method = 'get';
  aliForm.target = '_self';
  document.body.appendChild(aliForm);

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(params).forEach(function (key) {
    var aliInput = document.createElement('input');
    aliInput.type = 'hidden';
    aliInput.name = key;
    aliInput.value = params[key];
    aliForm.appendChild(aliInput);
  });
  aliForm.style.display = 'none';
  aliForm.submit();
}

var courseMaYiPay = function courseMaYiPay(_ref14, _ref15) {
  var commit = _ref14.commit;
  var payInfo = _ref15.payInfo,
      type = _ref15.type;

  var payParams = {
    sign: payInfo.sign,
    sec_id: payInfo.secId || payInfo.sec_id,
    v: payInfo.v,
    req_data: payInfo.reqData || payInfo.req_data,
    service: payInfo.service,
    partner: payInfo.partner,
    format: payInfo.format
  };
  var actionUrl = type === 2 ? payInfo.actionurl : payInfo.actionUrl;
  submitForm(actionUrl, payParams);
};

var getMaYiPayStatus = function getMaYiPayStatus(_ref16, _ref17) {
  var commit = _ref16.commit;
  var payInfo = _ref17.payInfo,
      status = _ref17.status;

  commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["D" /* MY_PAY */], { payInfo: payInfo, status: status });
};

var courseWxPay = function courseWxPay(_ref18, _ref19) {
  var commit = _ref18.commit;
  var payInfo = _ref19.payInfo;

  function onBridgeReady() {
    window.WeixinJSBridge.invoke('getBrandWCPayRequest', {
      appId: payInfo.appid,
      timeStamp: payInfo.timeStamp,
      nonceStr: payInfo.noncestr,
      package: payInfo.wxPackage,
      signType: payInfo.signType,
      paySign: payInfo.signedinfo }, function (res) {
      console.log('courseWxPay', res);
      if (res.err_msg === 'get_brand_wcpay_request:ok') {
        commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["E" /* WX_PAY */], { payInfo: payInfo, status: 1 });
      }

      if (res.err_msg === 'get_brand_wcpay_request:cancel') {
        commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["a" /* AJAX_ERROR */], new Error('支付失败，已取消'));
      }

      if (res.err_msg === 'get_brand_wcpay_request:fail') {
        commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["a" /* AJAX_ERROR */], new Error('微信支付失败，请重试'));
        commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["E" /* WX_PAY */], { payInfo: payInfo, status: 0 });
        res.time = new Date().toString();
        window.localStorage.setItem('wxPayError', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(res));
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__comm_middleware_reportLog__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(res, payInfo)).then(function () {
          console.log('日志-微信支付失败');
        });
      }
      if (res.errMsg) {
        commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["a" /* AJAX_ERROR */], new Error(res.errMsg));
      }
    });
  }
  if (typeof window.WeixinJSBridge === 'undefined') {
    if (document.addEventListener) {
      document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
    } else if (document.attachEvent) {
      document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
      document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
    }
  } else {
    onBridgeReady();
  }
};

var clearPayStatus = function clearPayStatus(_ref20) {
  var commit = _ref20.commit;

  commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["F" /* CLEAR_PAY_STATUS */]);
};

var addComment = function addComment(_ref21, _ref22) {
  var commit = _ref21.commit;
  var courseId = _ref22.courseId,
      professionalDegree = _ref22.professionalDegree,
      informationDegree = _ref22.informationDegree,
      experienceDegree = _ref22.experienceDegree,
      recommend = _ref22.recommend,
      content = _ref22.content;

  var params = {
    courseid: courseId,
    professionaldegree: professionalDegree,
    informationdegree: informationDegree,
    experiencedegree: experienceDegree,
    recommend: recommend,
    content: content
  };
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].addComment, params).then(function (body) {
    commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["G" /* AJAX_POST_ADDCOMMENT */], { commentId: body.data.courseId });
    return body;
  });
};

var getCatagory = function getCatagory(_ref23) {
  var commit = _ref23.commit;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].getCatagoryUrl).then(function (body) {
    commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["H" /* AJAX_GET_CATAGORY */], { list: body.data });
  });
};

var getIndexList = function getIndexList(_ref24, _ref25) {
  var commit = _ref24.commit;
  var _ref25$pagesize = _ref25.pagesize,
      pagesize = _ref25$pagesize === undefined ? 10 : _ref25$pagesize,
      catagoryId = _ref25.catagoryId,
      curpage = _ref25.curpage,
      startStatus = _ref25.startStatus,
      newPage = _ref25.newPage;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].indexListUrl, { catagoryId: catagoryId, pagesize: pagesize, curpage: curpage, startStatus: startStatus }).then(function (body) {
    commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["I" /* AJAX_GET_INDEXLIST */], { indexData: body.data, newPage: newPage });
  });
};

var courseLike = function courseLike(_ref26, _ref27) {
  var commit = _ref26.commit,
      state = _ref26.state;
  var _ref27$like = _ref27.like,
      like = _ref27$like === undefined ? true : _ref27$like,
      courseId = _ref27.courseId;

  commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["m" /* SOCKET_RECEIVE_MESSAGE_UP */], {
    courseUpCount: Number(state.courseUpCount) + 1
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].courseLike, { courseId: courseId, like: like }, { headers: { 'Content-type': 'application/x-www-form-urlencoded' } });
};

var xwCourseLike = function xwCourseLike(_ref28, _ref29) {
  var commit = _ref28.commit,
      state = _ref28.state;
  var courseId = _ref29.courseId,
      _ref29$isLoading = _ref29.isLoading,
      isLoading = _ref29$isLoading === undefined ? true : _ref29$isLoading;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].xwCourseLike, { courseId: courseId }, { headers: { 'Content-type': 'application/x-www-form-urlencoded' } }, isLoading);
};

var messageLike = function messageLike(_ref30, _ref31) {
  var commit = _ref30.commit;
  var courseId = _ref31.courseId,
      msgId = _ref31.msgId,
      count = _ref31.count,
      _ref31$likeType = _ref31.likeType,
      likeType = _ref31$likeType === undefined ? 'message' : _ref31$likeType;

  commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["n" /* SOCKET_RECEIVE_MESSAGE_LIKE_COUNT */], {
    msgId: msgId,
    count: count,
    likeType: likeType
  });

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].messageLike, { messageId: msgId, courseId: courseId }, { headers: { 'Content-type': 'application/x-www-form-urlencoded' } }).then(function () {
    commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["n" /* SOCKET_RECEIVE_MESSAGE_LIKE_COUNT */], {
      msgId: msgId,
      count: count,
      likeType: likeType
    });
  });
};

var getUserIssues = function getUserIssues(_ref32, _ref33) {
  var commit = _ref32.commit;
  var _ref33$condition = _ref33.condition,
      condition = _ref33$condition === undefined ? 1 : _ref33$condition,
      courseId = _ref33.courseId,
      lastId = _ref33.lastId;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].userIssues, { courseId: courseId, condition: condition, lastId: lastId }).then(function (body) {
    commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["J" /* AJAX_GET_USER_ISSUES */], { issues: body.data, lastId: lastId });
  });
};

var getUserCourses = function getUserCourses(_ref34, _ref35) {
  var commit = _ref34.commit;
  var _ref35$pagesize = _ref35.pagesize,
      pagesize = _ref35$pagesize === undefined ? 10 : _ref35$pagesize,
      _ref35$curpage = _ref35.curpage,
      curpage = _ref35$curpage === undefined ? 1 : _ref35$curpage,
      coursetype = _ref35.coursetype,
      newPage = _ref35.newPage;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].UserCourses, { pagesize: pagesize, curpage: curpage, coursetype: coursetype }).then(function (body) {
    commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["K" /* AJAX_GET_USERCOURSE */], { courseData: body.data, newPage: newPage, coursetype: coursetype });
  });
};

var getCombineCourses = function getCombineCourses(_ref36, _ref37) {
  var commit = _ref36.commit;
  var _ref37$pagesize = _ref37.pagesize,
      pagesize = _ref37$pagesize === undefined ? 10 : _ref37$pagesize,
      _ref37$curpage = _ref37.curpage,
      curpage = _ref37$curpage === undefined ? 1 : _ref37$curpage,
      newPage = _ref37.newPage;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].combinecourses, { pagesize: pagesize, curpage: curpage }).then(function (body) {
    commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["L" /* AJAX_GET_COMBINECOURSE */], { courseData: body.data, newPage: newPage });
  });
};

var getTheCode = function getTheCode(_ref38, _ref39) {
  var commit = _ref38.commit;
  var _ref39$type = _ref39.type,
      type = _ref39$type === undefined ? 2 : _ref39$type,
      telephone = _ref39.telephone;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["b" /* postApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].verifycode, { telephone: telephone, type: type }).then(function (body) {
    commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["M" /* AJAX_POST_USERSENDCODE */], { sedCodeInfo: body });
  });
};

var getBindMobile = function getBindMobile(_ref40, _ref41) {
  var commit = _ref40.commit;
  var _ref41$token = _ref41.token,
      token = _ref41$token === undefined ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__comm_utils__["b" /* throwIfMissing */])('token 参数不能为空') : _ref41$token,
      _ref41$telephone = _ref41.telephone,
      telephone = _ref41$telephone === undefined ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__comm_utils__["b" /* throwIfMissing */])('telNum 参数不能为空') : _ref41$telephone,
      _ref41$captcha = _ref41.captcha,
      captcha = _ref41$captcha === undefined ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__comm_utils__["b" /* throwIfMissing */])('captcha 参数不能为空') : _ref41$captcha,
      _ref41$unionid = _ref41.unionid,
      unionid = _ref41$unionid === undefined ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__comm_utils__["b" /* throwIfMissing */])('unionid 参数不能为空') : _ref41$unionid;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].bindMobile, { token: token, mobile: telephone, smsCode: captcha, unionid: unionid }).then(function (body) {
    commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["N" /* AJAX_POST_USERBINDING */], { bindMobileInfo: body });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__comm_api__["b" /* updateAjaxHeaderConfig */])({ token: body.user[0].token });
    return body;
  });
};

function getMyTinyCourses(_ref42, _ref43) {
  var commit = _ref42.commit;
  var _ref43$coursetype = _ref43.coursetype,
      coursetype = _ref43$coursetype === undefined ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__comm_utils__["b" /* throwIfMissing */])('coursetype 参数不能为空') : _ref43$coursetype,
      _ref43$pagesize = _ref43.pagesize,
      pagesize = _ref43$pagesize === undefined ? 10 : _ref43$pagesize,
      _ref43$curpage = _ref43.curpage,
      curpage = _ref43$curpage === undefined ? 1 : _ref43$curpage;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].myTinyCourses, { coursetype: coursetype, pagesize: pagesize, curpage: curpage }).then(function (body) {
    return body.data;
  });
}

var getMyTinyAudio = function getMyTinyAudio(_ref44, _ref45) {
  var commit = _ref44.commit;
  var pagesize = _ref45.pagesize,
      curpage = _ref45.curpage;

  getMyTinyCourses({ commit: commit }, { coursetype: 3, pagesize: pagesize, curpage: curpage }).then(function (data) {
    commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["O" /* AJAX_GET_MYTINYAUDIO */], { myTinyAudio: data, curpage: curpage });
  });
};

var getMyTinyAlbum = function getMyTinyAlbum(_ref46, _ref47) {
  var commit = _ref46.commit;
  var pagesize = _ref47.pagesize,
      curpage = _ref47.curpage;

  getMyTinyCourses({ commit: commit }, { coursetype: 4, pagesize: pagesize, curpage: curpage }).then(function (data) {
    commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["P" /* AJAX_GET_MYTINYALBUM */], { myTinyAlbum: data, curpage: curpage });
  });
};

var getMyTinyVideo = function getMyTinyVideo(_ref48, _ref49) {
  var commit = _ref48.commit;
  var pagesize = _ref49.pagesize,
      curpage = _ref49.curpage;

  getMyTinyCourses({ commit: commit }, { coursetype: 9, pagesize: pagesize, curpage: curpage }).then(function (data) {
    commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["Q" /* AJAX_GET_MYTINYVIDEO */], { myTinyVideo: data, curpage: curpage });
  });
};

var getMyTinyVideoAlbum = function getMyTinyVideoAlbum(_ref50, _ref51) {
  var commit = _ref50.commit;
  var pagesize = _ref51.pagesize,
      curpage = _ref51.curpage;

  getMyTinyCourses({ commit: commit }, { coursetype: 10, pagesize: pagesize, curpage: curpage }).then(function (data) {
    commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["R" /* AJAX_GET_MYTINYVIDEOALBUM */], { myTinyVideoAlbum: data, curpage: curpage });
  });
};

var initAudio = function initAudio(_ref52, audioObj) {
  var commit = _ref52.commit,
      state = _ref52.state;

  var oldAudio5 = state.audio5;
  if (oldAudio5) {
    oldAudio5.destroy();
  }
  var audio5 = new __WEBPACK_IMPORTED_MODULE_5_audio5___default.a({
    throw_errors: false,
    format_time: true,
    ready: function ready() {
      this.load(audioObj.url);
      this.one('canplay', function () {
        commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["S" /* AJAX_UPDATE_AUDIO5 */], { audio5: audio5, audioObj: audioObj });
        audioObj.canplay(audio5);
      }, this);
      this.one('ended', function () {
        audioObj.ended();
      }, this);
      this.one('error', function (error) {
        commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["a" /* AJAX_ERROR */], error);
        audioObj.error();
      }, this);
    }
  });
};

var getGroupAlbum = function getGroupAlbum(_ref53, _ref54) {
  var commit = _ref53.commit;
  var _ref54$pagesize = _ref54.pagesize,
      pagesize = _ref54$pagesize === undefined ? 10 : _ref54$pagesize,
      _ref54$curpage = _ref54.curpage,
      curpage = _ref54$curpage === undefined ? 1 : _ref54$curpage;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].combineList, { pagesize: pagesize, curpage: curpage }).then(function (body) {
    var groupAlbum = body.data;
    commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["T" /* AJAX_GET_GROUPALBUM */], { groupAlbum: groupAlbum, curpage: curpage });
  });
};

var cashierPay = function cashierPay(_ref55, _ref56) {
  var commit = _ref55.commit;
  var payInfo = _ref56.payInfo;

  function onBridgeReady() {
    window.WeixinJSBridge.invoke('getBrandWCPayRequest', {
      appId: payInfo.appid,
      timeStamp: payInfo.timeStamp,
      nonceStr: payInfo.noncestr,
      package: payInfo.wxPackage,
      signType: payInfo.signType,
      paySign: payInfo.signedinfo }, function (res) {
      console.log('courseWxPay', res);
      if (res.err_msg === 'get_brand_wcpay_request:ok') {
        commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["U" /* CASHIER_PAY */], { status: 1 });
      }

      if (res.err_msg === 'get_brand_wcpay_request:cancel') {
        commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["U" /* CASHIER_PAY */], { status: 2 });
      }

      if (res.err_msg === 'get_brand_wcpay_request:fail') {
        commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["U" /* CASHIER_PAY */], { status: 0 });
      }
      if (res.errMsg) {
        commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["U" /* CASHIER_PAY */], { status: 0 });
      }
    });
  }
  if (typeof window.WeixinJSBridge === 'undefined') {
    if (document.addEventListener) {
      document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
    } else if (document.attachEvent) {
      document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
      document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
    }
  } else {
    onBridgeReady();
  }
};

var getLamaRecommends = function getLamaRecommends(_ref57, _ref58) {
  var commit = _ref57.commit,
      state = _ref57.state;
  var _ref58$courseid = _ref58.courseid,
      courseid = _ref58$courseid === undefined ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__comm_utils__["b" /* throwIfMissing */])('课程 id 参数不能为空') : _ref58$courseid,
      pagesize = _ref58.pagesize;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].recommendFree, { courseid: courseid, pagesize: pagesize }).then(function (body) {
    commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["V" /* AJAX_GET_LAMA_RECOMMEND */], { rs: body.data });
  });
};

var getFreeTinyCourseList = function getFreeTinyCourseList(_ref59, _ref60) {
  var commit = _ref59.commit;
  var _ref60$pagesize = _ref60.pagesize,
      pagesize = _ref60$pagesize === undefined ? 10 : _ref60$pagesize,
      _ref60$curpage = _ref60.curpage,
      curpage = _ref60$curpage === undefined ? 1 : _ref60$curpage,
      protocol = _ref60.protocol;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].freeTinyCourseList, { protocol: protocol, pagesize: pagesize, curpage: curpage }).then(function (body) {
    var freeTinyCourseList = body.data;
    commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["W" /* AJAX_GET_FREETINYAUDIO */], { freeTinyCourseList: freeTinyCourseList, curpage: curpage });
  });
};

var getQueryByCode = function getQueryByCode(_ref61, _ref62) {
  var commit = _ref61.commit;
  var code = _ref62.code;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].querybycode, { code: code }, {}, true, false).then(function (body) {
    var data = body.data;
    if (data.status) {
      getMaYiPayStatus({ commit: commit }, {
        payInfo: {
          ordernum: code,
          courseId: data.courseId
        },
        status: data.status
      });
    } else {
      console.log('getQueryByCode: 返回数据异常');
    }
  });
};

var getStatus = function getStatus(_ref63, _ref64) {
  var commit = _ref63.commit;
  var _ref64$paymentid = _ref64.paymentid,
      paymentid = _ref64$paymentid === undefined ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__comm_utils__["b" /* throwIfMissing */])('paymentid 参数不能为空') : _ref64$paymentid;

  var params = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
    oem: window.navigator.userAgent,
    osversion: '9.0',
    screenwidth: window.screen.width,
    screenheight: window.screen.height,
    apptype: '1',
    appversion: '2.0.0',
    nettype: 'unknown',
    regcode: '250',
    provcode: '264',
    partner: 'babytree',
    isHttps: document.location.protocol === 'https:' ? '1' : '0',
    token: window.ajaxHeader.token,
    paymentid: paymentid
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["b" /* postApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].getStatus, params, { headers: { 'Content-Type': 'application/json' } }).then(function (data) {
    var code = data.bizCode;
    if (code) {
      getQueryByCode({ commit: commit }, { code: code });
    }
  })['catch'](function (e) {
    return console.log('getStatus: ', e);
  });
};

var getFreeList = function getFreeList(_ref65, _ref66) {
  var commit = _ref65.commit;
  var _ref66$pagesize = _ref66.pagesize,
      pagesize = _ref66$pagesize === undefined ? 10 : _ref66$pagesize,
      _ref66$curpage = _ref66.curpage,
      curpage = _ref66$curpage === undefined ? 1 : _ref66$curpage,
      catagoryid = _ref66.catagoryid;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].freeList, { pagesize: pagesize, curpage: curpage, catagoryid: catagoryid }).then(function (data) {
    return data;
  });
};

var getCourseRemind = function getCourseRemind(_ref67) {
  var commit = _ref67.commit;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].courseRemind).then(function (body) {
    var courseRemind = body.data;
    commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["X" /* COURSE_REMIND */], { courseRemind: courseRemind });
    return courseRemind;
  });
};

var getHomePageData = function getHomePageData(_ref68) {
  var commit = _ref68.commit;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].homePage).then(function (body) {
    var pageInfo = body.data;
    commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["Y" /* HOME_INFO */], { pageInfo: pageInfo });
    return pageInfo;
  });
};

var getRecommend = function getRecommend(_ref69, _ref70) {
  var commit = _ref69.commit;
  var curpage = _ref70.curpage,
      pagesize = _ref70.pagesize;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].recommend, { curpage: curpage, pagesize: pagesize }).then(function (body) {
    commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["Z" /* RECOMMEND_LIST */], { recommendList: body.data });
    return body.data;
  });
};

var setRemindStatus = function setRemindStatus(_ref71, _ref72) {
  var commit = _ref71.commit;
  var state = _ref72.state;

  commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["_0" /* REMIND_CLOSE */], { closeStatus: state });
};

var changeHotCourse = function changeHotCourse(_ref73, _ref74) {
  var commit = _ref73.commit;
  var state = _ref74.state;

  commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["_1" /* CHANGE_HOTCOURSE */], { hotCourse: state });
};

var getIndexModuleList = function getIndexModuleList(_ref75, _ref76) {
  var commit = _ref75.commit;
  var pagesize = _ref76.pagesize,
      curpage = _ref76.curpage,
      age_type = _ref76.age_type,
      age_time = _ref76.age_time,
      platform = _ref76.platform;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].indexModuleList, { pagesize: pagesize, curpage: curpage, age_type: age_type, age_time: age_time, platform: platform }).then(function (body) {
    commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["_2" /* INDEX_MODULE_LIST */], { indexModuleList: body.data.list });
  });
};

var getCourseAudioUrl = function getCourseAudioUrl(_ref77, _ref78) {
  var commit = _ref77.commit;
  var courseid = _ref78.courseid;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].getCourseAudioUrl, { courseid: courseid }).then(function (body) {
    return body.data;
  });
};

var getMyCourses = function getMyCourses(_ref79, _ref80) {
  var commit = _ref79.commit;
  var _ref80$pagesize = _ref80.pagesize,
      pagesize = _ref80$pagesize === undefined ? 10 : _ref80$pagesize,
      _ref80$curpage = _ref80.curpage,
      curpage = _ref80$curpage === undefined ? 1 : _ref80$curpage,
      isquerynostart = _ref80.isquerynostart,
      indexstart = _ref80.indexstart;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].myCourse, { pagesize: pagesize, curpage: curpage, isquerynostart: isquerynostart, indexstart: indexstart }).then(function (body) {
    commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["_3" /* AJAX_GET_MYCOURSE */], { courseList: body.data });
  });
};

var getAudition = function getAudition(_ref81, _ref82) {
  var commit = _ref81.commit;
  var id = _ref82.id,
      protocol = _ref82.protocol,
      biztype = _ref82.biztype,
      type = _ref82.type,
      curpage = _ref82.curpage,
      pagesize = _ref82.pagesize;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].auditionList, { id: id, protocol: protocol, biztype: biztype, curpage: curpage, pagesize: pagesize, type: type }).then(function (body) {
    return body.data;
  });
};

var getSubCourseList = function getSubCourseList(_ref83, _ref84) {
  var commit = _ref83.commit;
  var id = _ref84.id,
      pagesize = _ref84.pagesize,
      curpage = _ref84.curpage,
      type = _ref84.type,
      sort = _ref84.sort,
      protocol = _ref84.protocol,
      expertid = _ref84.expertid,
      labelid = _ref84.labelid,
      activeid = _ref84.activeid;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].subCourseList, { id: id, pagesize: pagesize, curpage: curpage, type: type, sort: sort, protocol: protocol, expertid: expertid, labelid: labelid, activeid: activeid }).then(function (body) {
    return body.data;
  });
};

var setSort = function setSort(_ref85, _ref86) {
  var commit = _ref85.commit;
  var state = _ref86.state;

  commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["_4" /* IS_SORT */], { isSort: state });
};

var getChildDetail = function getChildDetail(_ref87, _ref88) {
  var commit = _ref87.commit;
  var id = _ref88.id,
      protocol = _ref88.protocol,
      code = _ref88.code,
      isLoading = _ref88.isLoading;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].childDetail, { id: id, protocol: protocol, code: code }, isLoading).then(function (body) {
    var courseInfo = body.data;
    commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["u" /* AJAX_GET_COURSEINFO */], { courseInfo: courseInfo });
    return courseInfo;
  });
};

var getMessageList = function getMessageList(_ref89, _ref90) {
  var commit = _ref89.commit;
  var id = _ref90.id,
      protocol = _ref90.protocol,
      curpage = _ref90.curpage,
      pagesize = _ref90.pagesize,
      parentcourseid = _ref90.parentcourseid,
      type = _ref90.type;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].messageList, { id: id, protocol: protocol, curpage: curpage, pagesize: pagesize, parentcourseid: parentcourseid, type: type }).then(function (body) {
    var dataList = body.data;
    commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["_5" /* MESSAGE_LIST */], { dataList: dataList });
    return dataList;
  });
};

var getColumnList = function getColumnList(_ref91, _ref92) {
  var commit = _ref91.commit;
  var _ref92$pagesize = _ref92.pagesize,
      pagesize = _ref92$pagesize === undefined ? 10 : _ref92$pagesize,
      _ref92$curpage = _ref92.curpage,
      curpage = _ref92$curpage === undefined ? 1 : _ref92$curpage,
      _ref92$type = _ref92.type,
      type = _ref92$type === undefined ? 15 : _ref92$type;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].columnList, { pagesize: pagesize, curpage: curpage, type: type }).then(function (body) {
    var courseList = body.data;
    commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["_6" /* AJAX_GET_COLUMNLIST */], { courseList: courseList, curpage: curpage });

    return courseList;
  });
};

var setLeaveMessage = function setLeaveMessage(_ref93, _ref94) {
  var commit = _ref93.commit;
  var id = _ref94.id,
      content = _ref94.content;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].setLeaveMessage, { id: id, content: content }).then(function (body) {
    return body.data;
  });
};

var getMyGuestBooks = function getMyGuestBooks(_ref95, _ref96) {
  var commit = _ref95.commit;
  var id = _ref96.id,
      protocol = _ref96.protocol,
      pagesize = _ref96.pagesize,
      curpage = _ref96.curpage;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].myGuestBooks, { id: id, protocol: protocol, pagesize: pagesize, curpage: curpage }).then(function (body) {
    return body.data;
  });
};

var bindDelGuest = function bindDelGuest(_ref97, _ref98) {
  var commit = _ref97.commit;
  var id = _ref98.id;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].delGuest, { id: id }).then(function (body) {
    return body.data;
  });
};

var bindGiveThumbsup = function bindGiveThumbsup(_ref99, _ref100) {
  var commit = _ref99.commit;
  var bizid = _ref100.bizid,
      sourcetype = _ref100.sourcetype,
      type = _ref100.type;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].myGuestBooks, { bizid: bizid, sourcetype: sourcetype, type: type }).then(function (body) {
    return body.data;
  });
};

var getNewCourseInfo = function getNewCourseInfo(_ref101, _ref102) {
  var commit = _ref101.commit;
  var id = _ref102.id,
      parentcourseid = _ref102.parentcourseid,
      protocol = _ref102.protocol,
      code = _ref102.code,
      activeid = _ref102.activeid;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].newCourseInfo, {
    id: id,
    parentcourseid: parentcourseid,
    protocol: protocol,
    code: code,
    activeid: activeid
  }).then(function (body) {
    var newCourseInfo = __WEBPACK_IMPORTED_MODULE_15__comm_model___["b" /* newCourse */](body.data);
    commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["_7" /* AJAX_GET_NEWCOURSEINFO */], { newCourseInfo: newCourseInfo });
    return newCourseInfo;
  });
};

var getCourseExperts = function getCourseExperts(_ref103, _ref104) {
  var commit = _ref103.commit;
  var curpage = _ref104.curpage,
      pagesize = _ref104.pagesize,
      id = _ref104.id;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].courseExperts, { curpage: curpage, pagesize: pagesize, id: id }).then(function (body) {
    return body.data;
  });
};

var getClassifyLabel = function getClassifyLabel(_ref105, _ref106) {
  var commit = _ref105.commit;
  var curpage = _ref106.curpage,
      pagesize = _ref106.pagesize,
      courseid = _ref106.courseid;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].classifyLabel, { curpage: curpage, pagesize: pagesize, courseid: courseid }).then(function (body) {
    return body.data;
  });
};

var getExpertsLabel = function getExpertsLabel(_ref107, _ref108) {
  var commit = _ref107.commit;
  var curpage = _ref108.curpage,
      pagesize = _ref108.pagesize,
      id = _ref108.id,
      type = _ref108.type;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].expertsLabel, { curpage: curpage, pagesize: pagesize, id: id, type: type }).then(function (body) {
    return body.data;
  });
};

var getShareImage = function getShareImage(_ref109, _ref110) {
  var commit = _ref109.commit;
  var id = _ref110.id,
      pid = _ref110.pid;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].courseShareImage, { id: id, pid: pid }).then(function (body) {
    return body.data;
  });
};

var getMyIncome = function getMyIncome(_ref111, _ref112) {
  var commit = _ref111.commit;
  var curpage = _ref112.curpage,
      pagesize = _ref112.pagesize;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].myIncome, { curpage: curpage, pagesize: pagesize }).then(function (body) {
    commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["_8" /* AJAX_GET_MY_INCOME */], {
      curpage: curpage,
      myIncome: body.data
    });
  });
};

var getMemberFreeCourse = function getMemberFreeCourse(_ref113, _ref114) {
  var commit = _ref113.commit;
  var catagoryid = _ref114.catagoryid,
      pagesize = _ref114.pagesize,
      curpage = _ref114.curpage;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].memberFreeCourse, { catagoryid: catagoryid, pagesize: pagesize, curpage: curpage }).then(function (body) {
    commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["_9" /* AJAX_GET_MEMBER_FREE_COURSE */], {
      catagoryid: catagoryid,
      memberFreeCourse: body.data
    });
  });
};

var getMemberAd = function getMemberAd(_ref115, _ref116) {
  var commit = _ref115.commit;
  var keys = _ref116.keys,
      protocol = _ref116.protocol;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].getAdverts, { keys: keys, protocol: protocol }, {}, true, false).then(function (body) {
    return body.data;
  });
};

var setVipInfo = function setVipInfo(_ref117, _ref118) {
  var commit = _ref117.commit;
  var state = _ref118.state;

  commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["_10" /* VIP_INFO */], { vipInfo: state });
};

var getjxjDetails = function getjxjDetails(_ref119, _ref120) {
  var commit = _ref119.commit;
  var jxjactivityid = _ref120.jxjactivityid,
      curstudytime = _ref120.curstudytime,
      protocol = _ref120.protocol;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].getScholarshipDetail, { jxjactivityid: jxjactivityid, curstudytime: curstudytime, protocol: protocol }).then(function (body) {
    return body.data;
  });
};

var updateRemind = function updateRemind(_ref121, _ref122) {
  var commit = _ref121.commit;
  var jxjactivityid = _ref122.jxjactivityid,
      remindtype = _ref122.remindtype,
      todaycourseid = _ref122.todaycourseid;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].updateRemind, { jxjactivityid: jxjactivityid, remindtype: remindtype, todaycourseid: todaycourseid }).then(function (body) {
    return body.data;
  });
};

var getAdvertsGeneral = function getAdvertsGeneral(_ref123, _ref124) {
  var commit = _ref123.commit;
  var adkeys = _ref124.adkeys,
      protocol = _ref124.protocol;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].getAdvertsGeneral, { adkeys: adkeys, protocol: protocol }).then(function (body) {
    return body.data;
  });
};

var getScholarshipsList = function getScholarshipsList(_ref125, _ref126) {
  var commit = _ref125.commit;
  var pagenum = _ref126.pagenum,
      pagesize = _ref126.pagesize,
      protocol = _ref126.protocol;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].getScholarshipsList, { pagenum: pagenum, pagesize: pagesize, protocol: protocol }).then(function (body) {
    return body.data;
  });
};

var getCertificate = function getCertificate(_ref127) {
  var commit = _ref127.commit;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].getcertificate).then(function (body) {
    return body.data;
  });
};

var getVerifySend = function getVerifySend(_ref128, _ref129) {
  var commit = _ref128.commit;
  var _ref129$verifytype = _ref129.verifytype,
      verifytype = _ref129$verifytype === undefined ? 1 : _ref129$verifytype;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].getVerifySend, { verifytype: verifytype }).then(function (body) {
    return body.data;
  });
};

var getVerifyValid = function getVerifyValid(_ref130, _ref131) {
  var commit = _ref130.commit;
  var _ref131$verifytype = _ref131.verifytype,
      verifytype = _ref131$verifytype === undefined ? 1 : _ref131$verifytype,
      verifycode = _ref131.verifycode;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].getVerifyValid, { verifytype: verifytype, verifycode: verifycode }).then(function (body) {
    return body.data;
  });
};

var getVerified = function getVerified(_ref132, _ref133) {
  var commit = _ref132.commit;
  var vcode = _ref133.vcode,
      scene = _ref133.scene,
      certificatetype = _ref133.certificatetype,
      certificatemode = _ref133.certificatemode,
      mobile = _ref133.mobile,
      bankcard = _ref133.bankcard,
      certificatename = _ref133.certificatename,
      certificatenumber = _ref133.certificatenumber,
      certificateindate = _ref133.certificateindate,
      certificatephoto = _ref133.certificatephoto;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].getVerified, { vcode: vcode, scene: scene, certificatetype: certificatetype, certificatemode: certificatemode, mobile: mobile, bankcard: bankcard, certificatename: certificatename, certificatenumber: certificatenumber, certificateindate: certificateindate, certificatephoto: certificatephoto }).then(function (body) {
    return body.data;
  });
};

var getMyListJxjActivity = function getMyListJxjActivity(_ref134, _ref135) {
  var commit = _ref134.commit;
  var pagenum = _ref135.pagenum,
      pagesize = _ref135.pagesize,
      protocol = _ref135.protocol;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].getMyListJxjActivity, { pagenum: pagenum, pagesize: pagesize, protocol: protocol }).then(function (body) {
    return body.data;
  });
};

var getUserPhone = function getUserPhone(_ref136) {
  var commit = _ref136.commit;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].getUserPhone).then(function (body) {
    return body.data;
  });
};

var getIconList = function getIconList(_ref137, _ref138) {
  var commit = _ref137.commit;
  var activityid = _ref138.activityid;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].getIconList, { activityid: activityid }).then(function (body) {
    return body.data || {};
  });
};

var getJxjCollectLikes = function getJxjCollectLikes(_ref139, _ref140) {
  var commit = _ref139.commit;
  var id = _ref140.id,
      openid = _ref140.openid;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].getJxjCollectLikes, { id: id, openid: openid }).then(function (body) {
    return body.data || {};
  });
};

var getJxjStartLikes = function getJxjStartLikes(_ref141, _ref142) {
  var commit = _ref141.commit;
  var actid = _ref142.actid;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].getJxjStartLikes, { actid: actid }).then(function (body) {
    return body.data || {};
  });
};

var getJxjDoLikes = function getJxjDoLikes(_ref143, _ref144) {
  var commit = _ref143.commit;
  var taskid = _ref144.taskid,
      openid = _ref144.openid,
      wxap = _ref144.wxap,
      wxnk = _ref144.wxnk;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].getJxjDoLikes, { taskid: taskid, openid: openid, wxap: wxap, wxnk: wxnk }).then(function (body) {
    return body.data || {};
  });
};

var getPunchCardShare = function getPunchCardShare(_ref145, _ref146) {
  var commit = _ref145.commit;
  var activityid = _ref146.activityid,
      courseId = _ref146.courseId;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].getPunchCardShare, { activityid: activityid, courseId: courseId }).then(function (body) {
    return body.data || {};
  });
};

var sendPlayDuration = function sendPlayDuration(_ref147, _ref148) {
  var commit = _ref147.commit;
  var courseid = _ref148.courseid,
      parentcourseid = _ref148.parentcourseid,
      audiourl = _ref148.audiourl,
      _ref148$finish = _ref148.finish,
      finish = _ref148$finish === undefined ? false : _ref148$finish,
      playManyTime = _ref148.playManyTime;

  var time = Math.ceil(playManyTime);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].sendPlayDuration, {
    courseid: courseid,
    parentcourseid: parentcourseid || '',
    audiourl: audiourl,
    finish: finish,
    playManyTime: time
  }, {}, false).then(function (body) {
    return body.data || {};
  });
};

var getPunchCard = function getPunchCard(_ref149, _ref150) {
  var commit = _ref149.commit;
  var activityid = _ref150.activityid,
      courseId = _ref150.courseId;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].getPunchCard, { activityid: activityid, courseId: courseId }).then(function (body) {
    return body.data || {};
  });
};

var getIndexInfo = function getIndexInfo(_ref151, _ref152) {
  var commit = _ref151.commit;
  var activityid = _ref152.activityid;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].getIndexInfo, { activityid: activityid }).then(function (body) {
    return body.data || {};
  });
};

var getFreeClinicExpert = function getFreeClinicExpert(_ref153, _ref154) {
  var commit = _ref153.commit;
  var activityid = _ref154.activityid;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].getFreeClinicExpert, { activityid: activityid }).then(function (body) {
    return body.data || {};
  });
};

var getVoteRankInfo = function getVoteRankInfo(_ref155, _ref156) {
  var commit = _ref155.commit;
  var activityid = _ref156.activityid,
      pagesize = _ref156.pagesize,
      pageno = _ref156.pageno,
      onlymyquestion = _ref156.onlymyquestion;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].getVoteRankInfo, { activityid: activityid, pagesize: pagesize, pageno: pageno, onlymyquestion: onlymyquestion }).then(function (body) {
    return body.data || {};
  });
};

var getUserActivityInfo = function getUserActivityInfo(_ref157, _ref158) {
  var commit = _ref157.commit;
  var activityid = _ref158.activityid;

  var enc_user_id = __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.get('mtencUserId');
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].getUserActivityInfo, { activityid: activityid, enc_user_id: enc_user_id }).then(function (body) {
    return body.data || {};
  });
};

var canFreeAuditQues = function canFreeAuditQues(_ref159, _ref160) {
  var commit = _ref159.commit;
  var activityid = _ref160.activityid,
      pagesize = _ref160.pagesize,
      currentpage = _ref160.currentpage;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].canFreeAuditQues, { activityid: activityid, pagesize: pagesize, currentpage: currentpage }).then(function (body) {
    return body.data || {};
  });
};

var getConsultDetail = function getConsultDetail(_ref161, _ref162) {
  var commit = _ref161.commit;
  var activityid = _ref162.activityid,
      questionid = _ref162.questionid,
      userencodeid = _ref162.userencodeid;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].getConsultDetail, { activityid: activityid, questionid: questionid, userencodeid: userencodeid }).then(function (_ref163) {
    var _ref163$data = _ref163.data,
        data = _ref163$data === undefined ? {} : _ref163$data;

    return data;
  });
};

var getBabayTreeUploadImg = function getBabayTreeUploadImg(_ref164, _ref165) {
  var commit = _ref164.commit;
  var formData = _ref165.formData,
      token = _ref165.token;

  var localTs = Date.parse(new Date());
  var signature = 'app_id=wapislog=1login_string=' + token + 'timestamp=' + localTs;
  var key = '0Qh2hy+z[7ZIv9uvvDJs}gav7BeJ+n50=qNPy9NCunzCaNuns2sq[82]udgPPq=lZ9MEOEUNtmPGkBbPYw+}}NYnNbeMhoHYbwgckMrerp20Gjs24p9506RUiglCFR=y';
  console.log('' + signature + key);
  var secret = __WEBPACK_IMPORTED_MODULE_6_crypto___default.a.createHash('md5').update('' + signature + key).digest('hex');
  var params = 'app_id=wap&signature=' + secret + '&timestamp=' + localTs + '&login_string=' + token + '&islog=1';
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["b" /* postApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].babayTreeUploadImg + '?' + params, formData, { headers: { 'Content-type': 'multipart/form-data; boundary=Boundary+DE582FBEF6CBC031', timestamp: localTs, signature: secret } }).then(function (data) {
    if (data.status === true) {
      return data.data;
    }
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_mint_ui__["Toast"])(data.message);
    return {};
  });
};

var getBabayTreeUploadImgbase64 = function getBabayTreeUploadImgbase64(_ref166, _ref167) {
  var commit = _ref166.commit;
  var formData = _ref167.formData,
      token = _ref167.token,
      base64 = _ref167.base64;

  var localTs = Date.parse(new Date());
  var base64Str = 'data:image/png;base64,' + base64;
  formData.append('fileArr', base64Str);
  var signature = 'app_id=wapislog=1login_string=' + token + 'timestamp=' + localTs;
  var key = '0Qh2hy+z[7ZIv9uvvDJs}gav7BeJ+n50=qNPy9NCunzCaNuns2sq[82]udgPPq=lZ9MEOEUNtmPGkBbPYw+}}NYnNbeMhoHYbwgckMrerp20Gjs24p9506RUiglCFR=y';
  console.log('' + signature + key);
  var secret = __WEBPACK_IMPORTED_MODULE_6_crypto___default.a.createHash('md5').update('' + signature + key).digest('hex');
  var params = 'app_id=wap&signature=' + secret + '&timestamp=' + localTs + '&login_string=' + token + '&islog=1';
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["b" /* postApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].babayTreeUploadImgbase64 + '?' + params, formData, { headers: { 'Content-type': 'multipart/form-data; boundary=Boundary+DE582FBEF6CBC031', timestamp: localTs, signature: secret } }).then(function (data) {
    return data.data;
  });
};

var getBaseInfo = function getBaseInfo(_ref168, _ref169) {
  var commit = _ref168.commit;
  var expertid = _ref169.expertid;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].getBaseInfo, { expertid: expertid }).then(function (data) {
    return data.data;
  });
};

var vote = function vote(_ref170, _ref171) {
  var commit = _ref170.commit;
  var activityid = _ref171.activityid,
      questionid = _ref171.questionid,
      sourceid = _ref171.sourceid,
      uid = _ref171.uid;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].vote, { activityid: activityid, questionid: questionid, sourceid: sourceid, uid: uid }).then(function (_ref172) {
    var rtnCode = _ref172.rtn_code,
        _ref172$data = _ref172.data,
        message = _ref172$data === undefined ? '投票失败，请尝试刷新' : _ref172$data;

    return { status: +rtnCode, message: message };
  });
};

var getMyConsultList = function getMyConsultList(_ref173, _ref174) {
  var commit = _ref173.commit;
  var _ref174$pagesize = _ref174.pagesize,
      pagesize = _ref174$pagesize === undefined ? 10 : _ref174$pagesize,
      pageno = _ref174.pageno;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].myConsultList, { pagesize: pagesize, pageno: pageno }).then(function (_ref175) {
    var _ref175$data = _ref175.data,
        data = _ref175$data === undefined ? [] : _ref175$data,
        _ref175$hasNextPage = _ref175.hasNextPage,
        hasNextPage = _ref175$hasNextPage === undefined ? true : _ref175$hasNextPage;

    return {
      list: data,
      hasNextPage: hasNextPage
    };
  });
};

var questionSubmit = function questionSubmit(_ref176, _ref177) {
  var commit = _ref176.commit;
  var activityid = _ref177.activityid,
      content = _ref177.content,
      photourls = _ref177.photourls,
      photoids = _ref177.photoids,
      expertid = _ref177.expertid,
      categoryid = _ref177.categoryid,
      isanonymous = _ref177.isanonymous;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["b" /* postApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].questionSubmit, { activityid: activityid, content: content, photourls: photourls, photoids: photoids, expertid: expertid, categoryid: categoryid, isanonymous: isanonymous }).then(function (data) {
    return data.data;
  });
};

var secretToken = function secretToken(store, _ref178) {
  var _ref178$type = _ref178.type,
      type = _ref178$type === undefined ? 'get' : _ref178$type,
      usertoken = _ref178.usertoken,
      encUserId = _ref178.encUserId;
  var commit = store.commit;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].secretToken, { type: type, usertoken: usertoken, encUserId: encUserId }).then(function (body) {
    if (type === 'get') {
      var userInfo = {
        token: body.data.token,
        encUserId: body.data.encUserId
      };
      getMemberInfo(store, userInfo);
    }
    return body.data;
  });
};

var getQueryCertificateType = function getQueryCertificateType(_ref179) {
  var commit = _ref179.commit;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].queryCertificateType).then(function (data) {
    return data.data;
  });
};

var getCommentTags = function getCommentTags(_ref180, _ref181) {
  var commit = _ref180.commit;
  var courseid = _ref181.courseid;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].commentTags, { courseid: courseid }).then(function (data) {
    return data.data;
  });
};

var getCourseComments = function getCourseComments(_ref182, _ref183) {
  var commit = _ref182.commit;
  var courseid = _ref183.courseid,
      tagid = _ref183.tagid,
      curpage = _ref183.curpage,
      pagesize = _ref183.pagesize;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].getCourseComments, { courseid: courseid, tagid: tagid, curpage: curpage, pagesize: pagesize }).then(function (data) {
    return data.data;
  });
};

var getChannelModule = function getChannelModule(_ref184, _ref185) {
  var commit = _ref184.commit;
  var age_type = _ref185.age_type,
      age_time = _ref185.age_time,
      channel_page = _ref185.channel_page,
      protocol = _ref185.protocol,
      platform = _ref185.platform;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].channelModule, { age_type: age_type, age_time: age_time, channel_page: channel_page, protocol: protocol, platform: platform }).then(function (data) {
    return data.data;
  });
};

var getChannelRecommend = function getChannelRecommend(_ref186, _ref187) {
  var commit = _ref186.commit;
  var age_type = _ref187.age_type,
      age_time = _ref187.age_time,
      module_id = _ref187.module_id,
      channel_page = _ref187.channel_page,
      protocol = _ref187.protocol,
      curpage = _ref187.curpage,
      pagesize = _ref187.pagesize,
      category_id = _ref187.category_id;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].channelRecommend, { age_type: age_type, age_time: age_time, module_id: module_id, channel_page: channel_page, protocol: protocol, curpage: curpage, pagesize: pagesize, category_id: category_id }).then(function (data) {
    return data.data;
  });
};

var getCategoryList = function getCategoryList(_ref188, _ref189) {
  var commit = _ref188.commit;
  var module_id = _ref189.module_id;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].getCategoryList, { module_id: module_id }).then(function (data) {
    return data.data;
  });
};

var getAdByCodes = function getAdByCodes(_ref190, _ref191) {
  var commit = _ref190.commit;
  var advcode = _ref191.advcode,
      protocol = _ref191.protocol;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].adByCodes, { advcode: advcode, protocol: protocol }, {}, true, false).then(function (body) {
    return body.data;
  });
};

var getCourseRankList = function getCourseRankList(_ref192, _ref193) {
  var commit = _ref192.commit;
  var curpage = _ref193.curpage,
      pagesize = _ref193.pagesize,
      ranktype = _ref193.ranktype,
      agetype = _ref193.agetype,
      agetime = _ref193.agetime,
      protocol = _ref193.protocol;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].courseRankList, { curpage: curpage, pagesize: pagesize, ranktype: ranktype, agetype: agetype, agetime: agetime, protocol: protocol }).then(function (body) {
    return body.data;
  });
};

var getWyethCourse = function getWyethCourse(_ref194, _ref195) {
  var commit = _ref194.commit;
  var curpage = _ref195.curpage,
      membertype = _ref195.membertype,
      protocol = _ref195.protocol;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].wyethCourse, { curpage: curpage, membertype: membertype, protocol: protocol }).then(function (body) {
    return body.data;
  });
};

var bindWyethLogin = function bindWyethLogin(_ref196, _ref197) {
  var commit = _ref196.commit;
  var name = _ref197.name,
      userId = _ref197.userId,
      mobile = _ref197.mobile,
      birthday = _ref197.birthday,
      sex = _ref197.sex,
      headImgUrl = _ref197.headImgUrl,
      userExternalType = _ref197.userExternalType;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].wyethLogin, { name: name, userId: userId, mobile: mobile, birthday: birthday, sex: sex, headImgUrl: headImgUrl, userExternalType: userExternalType }).then(function (body) {
    return body.data;
  });
};

var queryShubi = function queryShubi(_ref198, _ref199) {
  var commit = _ref198.commit;
  var companyId = _ref199.companyId,
      encUserId = _ref199.encUserId;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, '' + __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].queryBalance, { companyId: companyId, encUserId: encUserId }).then(function (data) {
    commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["h" /* TREE_COIN_INFO */], data.data);
    return data.data;
  });
};

var queryShubiDetail = function queryShubiDetail(_ref200, _ref201) {
  var commit = _ref200.commit;
  var pageno = _ref201.pageno,
      companyId = _ref201.companyId,
      encuid = _ref201.encuid,
      acttype = _ref201.acttype;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, '' + __WEBPACK_IMPORTED_MODULE_13__comm_api_apis__["a" /* default */].queryBalanceDetail, { pageno: pageno, companyId: companyId, encuid: encuid, acttype: acttype }).then(function (data) {
    commit(__WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["g" /* TREE_COIN_INFO_MORE */], data.data);
    return data.data;
  });
};

/***/ }),

/***/ 206:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bindExpert; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return checkExpert; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return bindAuthentication; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getProvinceList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getAreaList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return bindMtUploadPic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getCountryInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__comm_middleware_callApi__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__comm_api_apis__ = __webpack_require__(14);



var bindExpert = function bindExpert(_ref, _ref2) {
  var commit = _ref.commit;
  var dyml = _ref2.dyml,
      expertid = _ref2.expertid;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_1__comm_api_apis__["a" /* default */].bindExpert, { dyml: dyml, expertid: expertid }).then(function (body) {
    return body.data;
  });
};

var checkExpert = function checkExpert(_ref3, _ref4) {
  var commit = _ref3.commit;
  var dyml = _ref4.dyml,
      expertid = _ref4.expertid;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_1__comm_api_apis__["a" /* default */].checkExpert, { dyml: dyml, expertid: expertid }).then(function (body) {
    return body.data;
  });
};

var bindAuthentication = function bindAuthentication(_ref5, params) {
  var commit = _ref5.commit;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_1__comm_api_apis__["a" /* default */].authentication, params).then(function (body) {
    return body.data;
  });
};

var getProvinceList = function getProvinceList(_ref6) {
  var commit = _ref6.commit;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_1__comm_api_apis__["a" /* default */].proList, {}, { headers: { 'Content-type': 'application/x-www-form-urlencoded' } }, false).then(function (body) {
    return body;
  });
};

var getAreaList = function getAreaList(_ref7, _ref8) {
  var commit = _ref7.commit;
  var id = _ref8.id;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_1__comm_api_apis__["a" /* default */].areaList, { id: id }, { headers: { 'Content-type': 'application/x-www-form-urlencoded' } }, false).then(function (body) {
    return body;
  });
};

var bindMtUploadPic = function bindMtUploadPic(_ref9, _ref10) {
  var commit = _ref9.commit;
  var formData = _ref10.formData,
      token = _ref10.token,
      isHttps = _ref10.isHttps,
      isPrivateImage = _ref10.isPrivateImage;

  formData.append('token', token);
  formData.append('isPrivateImage', 1);
  formData.append('isHttps', isHttps);
  formData.append('isPrivateImage', isPrivateImage);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__comm_middleware_callApi__["b" /* postApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_1__comm_api_apis__["a" /* default */].mtUploadPic, formData, { headers: { 'Content-type': 'application/x-www-form-urlencoded' } }).then(function (data) {
    return data.data;
  });
};

var getCountryInfo = function getCountryInfo(_ref11) {
  var commit = _ref11.commit;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_1__comm_api_apis__["a" /* default */].getCountryInfo).then(function (body) {
    return body;
  });
};

/***/ }),

/***/ 207:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return userInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return buyInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return payInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return preOrderInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return payStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return catagoryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return advertList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return indexCourseList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return indexCourseObj; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return userIssues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return userCourse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return combineCourse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return userSerialCourse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return sedCodeInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return bindMobileInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return treeCoinInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return hotLabelList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return lamaRecommends; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return freeTinyCourse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return groupAlbum; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return myCourse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return myTinyAudio; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return myTinyVideo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return myTinyAlbum; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return myTinyVideoAlbum; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return audio5; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return indexInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return isSort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return columnList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return leaveMessageList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return newCourseInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return myIncome; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return constantData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return vipInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return memberFreeCourse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return indexModuleList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return freeAnsCount; });

var userInfo = function userInfo(state) {
  return state.userInfo;
};
var buyInfo = function buyInfo(state) {
  return state.buyInfo;
};
var payInfo = function payInfo(state) {
  return state.payInfo;
};
var preOrderInfo = function preOrderInfo(state) {
  return state.preOrderInfo;
};
var payStatus = function payStatus(state) {
  return state.payStatus;
};

var catagoryList = function catagoryList(state) {
  return state.catagoryList;
};
var advertList = function advertList(state) {
  return state.advertList;
};
var indexCourseList = function indexCourseList(state) {
  return state.indexCourseList;
};
var indexCourseObj = function indexCourseObj(state) {
  return state.indexCourseObj;
};
var userIssues = function userIssues(state) {
  return state.userIssues;
};
var userCourse = function userCourse(state) {
  return state.userCourse;
};
var combineCourse = function combineCourse(state) {
  return state.combineCourse;
};
var userSerialCourse = function userSerialCourse(state) {
  return state.userSerialCourse;
};
var sedCodeInfo = function sedCodeInfo(state) {
  return state.sedCodeInfo;
};
var bindMobileInfo = function bindMobileInfo(state) {
  return state.bindMobileInfo;
};
var treeCoinInfo = function treeCoinInfo(state) {
  return state.treeCoinInfo;
};
var hotLabelList = function hotLabelList(state) {
  return state.hotLabelList;
};
var lamaRecommends = function lamaRecommends(state) {
  return state.lamaRecommends;
};
var freeTinyCourse = function freeTinyCourse(state) {
  return state.freeTinyCourse;
};

var groupAlbum = function groupAlbum(state) {
  return state.groupAlbum;
};
var myCourse = function myCourse(state) {
  return state.myCourse;
};

var myTinyAudio = function myTinyAudio(state) {
  return state.myTinyAudio;
};
var myTinyVideo = function myTinyVideo(state) {
  return state.myTinyVideo;
};
var myTinyAlbum = function myTinyAlbum(state) {
  return state.myTinyAlbum;
};
var myTinyVideoAlbum = function myTinyVideoAlbum(state) {
  return state.myTinyVideoAlbum;
};
var audio5 = function audio5(state) {
  return state.audio5;
};

var indexInfo = function indexInfo(state) {
  return state.indexInfo;
};
var isSort = function isSort(state) {
  return state.isSort;
};
var columnList = function columnList(state) {
  return state.columnList;
};
var leaveMessageList = function leaveMessageList(state) {
  return state.leaveMessageList;
};
var newCourseInfo = function newCourseInfo(state) {
  return state.newCourseInfo;
};
var myIncome = function myIncome(state) {
  return state.myIncome;
};
var constantData = function constantData(state) {
  return state.constantData;
};
var vipInfo = function vipInfo(state) {
  return state.vipInfo;
};
var memberFreeCourse = function memberFreeCourse(state) {
  return state.memberFreeCourse;
};
var indexModuleList = function indexModuleList(state) {
  return state.indexModuleList;
};
var freeAnsCount = function freeAnsCount(state) {
  return state.freeAnsCount;
};

/***/ }),

/***/ 208:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getWeeklyDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getWeeklyList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getShareDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getShareWeekly; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getWeeklyAudioUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getUpdateMediaPlayLog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getWeeklyCombos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return buyNow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getSDKInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return detail4payment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getCanBuyList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getItemMsg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getWeeklyRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getKnowingIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getSignInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return confirmExchange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getPrePayWayList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__comm_middleware_callApi__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__comm_api_apis__ = __webpack_require__(14);




var getWeeklyDetail = function getWeeklyDetail(_ref, params) {
  var commit = _ref.commit;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_1__comm_api_apis__["a" /* default */].weeklyDetail, params).then(function (body) {
    return body.data;
  });
};

var getWeeklyList = function getWeeklyList(_ref2, params) {
  var commit = _ref2.commit;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_1__comm_api_apis__["a" /* default */].weeklyList, params).then(function (body) {
    return body.data;
  });
};

var getShareDetail = function getShareDetail(_ref3, params) {
  var commit = _ref3.commit;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_1__comm_api_apis__["a" /* default */].shareDetail, params).then(function (body) {
    return body.data;
  });
};

var getShareWeekly = function getShareWeekly(_ref4, params) {
  var commit = _ref4.commit;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_1__comm_api_apis__["a" /* default */].getShareWeekly, params).then(function (body) {
    return body.data;
  });
};

var getWeeklyAudioUrl = function getWeeklyAudioUrl(_ref5, params) {
  var commit = _ref5.commit;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_1__comm_api_apis__["a" /* default */].getWeeklyAudioUrl, params).then(function (body) {
    return body.data;
  });
};

var getUpdateMediaPlayLog = function getUpdateMediaPlayLog(_ref6, params) {
  var commit = _ref6.commit;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_1__comm_api_apis__["a" /* default */].updateMediaPlayLog, params).then(function (body) {
    return body.data;
  });
};

var getWeeklyCombos = function getWeeklyCombos(_ref7, params) {
  var commit = _ref7.commit;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_1__comm_api_apis__["a" /* default */].getWeeklyCombos, params, false).then(function (body) {
    return body.data;
  });
};

var buyNow = function buyNow(_ref8, params) {
  var commit = _ref8.commit;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_1__comm_api_apis__["a" /* default */].buyNow, params, false).then(function (data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_1__comm_api_apis__["a" /* default */].submitorder, {
      areaid: 250,
      isnewsdk: 1,
      orderType: 7,
      supportaddpricebuy: 1,
      uuid: data.data
    }, false).then(function (body) {
      return body.data;
    })['catch'](function () {});
  });
};

var getSDKInfo = function getSDKInfo(_ref9, params) {
  var commit = _ref9.commit;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_1__comm_api_apis__["a" /* default */].getSDKInfo, params, false).then(function (body) {
    return body.data;
  });
};

var detail4payment = function detail4payment(_ref10, params) {
  var commit = _ref10.commit;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_1__comm_api_apis__["a" /* default */].detail4payment, params, false).then(function (order) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_1__comm_api_apis__["a" /* default */].getPayWayList, {
      encrypteddata: order.data.encrypteddata,
      sign: order.data.sign,
      signtime: order.data.signtime,
      businessno: order.data.businessno
    }, false).then(function (body) {
      var data = {
        order: order.data,
        paywaylist: body.data
      };
      return data;
    });
  });
};

var getCanBuyList = function getCanBuyList(_ref11, params) {
  var commit = _ref11.commit;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_1__comm_api_apis__["a" /* default */].getCanBuyList, params, false).then(function (body) {
    return body.data;
  });
};

var getItemMsg = function getItemMsg(_ref12, params) {
  var commit = _ref12.commit;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_1__comm_api_apis__["a" /* default */].getItemMsg, params, false).then(function (body) {
    return body.data;
  });
};

var getWeeklyRight = function getWeeklyRight(_ref13, params) {
  var commit = _ref13.commit;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_1__comm_api_apis__["a" /* default */].getWeeklyRight, params, false).then(function (body) {
    return body.data;
  });
};

var getKnowingIndex = function getKnowingIndex(_ref14, params) {
  var commit = _ref14.commit;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_1__comm_api_apis__["a" /* default */].geIndexInfo, params, false).then(function (body) {
    return body.data;
  });
};

var getSignInfo = function getSignInfo(_ref15, params) {
  var commit = _ref15.commit;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_1__comm_api_apis__["a" /* default */].sign, params, false).then(function (body) {
    return body.data;
  });
};

var confirmExchange = function confirmExchange(_ref16, params) {
  var commit = _ref16.commit;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_1__comm_api_apis__["a" /* default */].confirmExchange, params, {}, false, false).then(function (body) {
    return body;
  })['catch'](function (e) {
    return e;
  });
};

var getPrePayWayList = function getPrePayWayList(_ref17, params) {
  var commit = _ref17.commit;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_1__comm_api_apis__["a" /* default */].prePayWayList, params, {}, false, false).then(function (body) {
    return body;
  })['catch'](function (e) {
    return e;
  });
};

/***/ }),

/***/ 209:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getIncome; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getMyLightIncome; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getExamInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return submitExam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getAdvert; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getHomePage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getMyCourse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getHomeCoupon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getShareMaterial; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getLighthouseCourseDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getLighthouseCourseList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getInvite; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getCourseDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getSimpleSubCourse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getTopicCountInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getTopicGroupInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return lightForPreOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return lightSubmitOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return bindSaveOpenId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return getOrderTipList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return getCoursePrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return getMyCoupon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return getSkuList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return getMyOrders; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__comm_middleware_callApi__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__comm_api_apis__ = __webpack_require__(14);



var getIncome = function getIncome(_ref, _ref2) {
  var commit = _ref.commit;
  var _ref2$curpage = _ref2.curpage,
      curpage = _ref2$curpage === undefined ? 1 : _ref2$curpage;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_1__comm_api_apis__["a" /* default */].getIncome, { curpage: curpage }).then(function (body) {
    return body.data;
  });
};

var getMyLightIncome = function getMyLightIncome(_ref3, params) {
  var commit = _ref3.commit;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_1__comm_api_apis__["a" /* default */].getMyIncome, params).then(function (body) {
    return body.data;
  });
};

var getExamInfo = function getExamInfo(_ref4, _ref5) {
  var commit = _ref4.commit;
  var courseid = _ref5.courseid;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_1__comm_api_apis__["a" /* default */].getExamInfo, { courseid: courseid }).then(function (body) {
    return body.data;
  });
};

var submitExam = function submitExam(_ref6, _ref7) {
  var commit = _ref6.commit;
  var examsyllabusid = _ref7.examsyllabusid,
      exercises = _ref7.exercises;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_1__comm_api_apis__["a" /* default */].submitExam, { examsyllabusid: examsyllabusid, exercises: exercises }).then(function (body) {
    return body.data;
  });
};

var getAdvert = function getAdvert(_ref8, _ref9) {
  var commit = _ref8.commit;
  var advcode = _ref9.advcode,
      protocol = _ref9.protocol;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_1__comm_api_apis__["a" /* default */].adByCodes, { advcode: advcode, protocol: protocol }).then(function (body) {
    return body.data;
  });
};

var getHomePage = function getHomePage(_ref10, _ref11) {
  var commit = _ref10.commit;
  var openid = _ref11.openid;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_1__comm_api_apis__["a" /* default */].getHomePage, { openid: openid }).then(function (body) {
    return body.data;
  });
};

var getMyCourse = function getMyCourse(_ref12, _ref13) {
  var commit = _ref12.commit;
  var pageno = _ref13.pageno,
      pagesize = _ref13.pagesize,
      protocol = _ref13.protocol;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_1__comm_api_apis__["a" /* default */].getMyCourse, { pageno: pageno, pagesize: pagesize, protocol: protocol }).then(function (body) {
    return body.data;
  });
};

var getHomeCoupon = function getHomeCoupon(_ref14) {
  var commit = _ref14.commit;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_1__comm_api_apis__["a" /* default */].getHomeCoupon).then(function (body) {
    return body.data;
  });
};

var getShareMaterial = function getShareMaterial(_ref15, _ref16) {
  var commit = _ref15.commit;
  var protocol = _ref16.protocol,
      bizid = _ref16.bizid,
      biztype = _ref16.biztype,
      groupId = _ref16.groupId,
      activityId = _ref16.activityId;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_1__comm_api_apis__["a" /* default */].getShareMaterial, { protocol: protocol, bizid: bizid, biztype: biztype, groupId: groupId, activityId: activityId }).then(function (body) {
    return body.data;
  });
};

var getLighthouseCourseDetail = function getLighthouseCourseDetail(_ref17, _ref18) {
  var commit = _ref17.commit;
  var protocol = _ref18.protocol,
      courseid = _ref18.courseid;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_1__comm_api_apis__["a" /* default */].getLighthouseCourseDetail, { protocol: protocol, courseid: courseid }).then(function (body) {
    return body.data;
  });
};

var getLighthouseCourseList = function getLighthouseCourseList(_ref19, _ref20) {
  var commit = _ref19.commit;
  var parentcourseid = _ref20.parentcourseid,
      curpage = _ref20.curpage,
      pagesize = _ref20.pagesize,
      protocol = _ref20.protocol;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_1__comm_api_apis__["a" /* default */].getLighthouseCourseList, { parentcourseid: parentcourseid, curpage: curpage, pagesize: pagesize, protocol: protocol }).then(function (body) {
    return body.data;
  });
};

var getInvite = function getInvite(_ref21, _ref22) {
  var commit = _ref21.commit;
  var _ref22$page = _ref22.page,
      page = _ref22$page === undefined ? 1 : _ref22$page;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_1__comm_api_apis__["a" /* default */].getInvite, { page: page }).then(function (body) {
    return body.data;
  });
};

var getCourseDetail = function getCourseDetail(_ref23, _ref24) {
  var commit = _ref23.commit;
  var courseid = _ref24.courseid,
      protocol = _ref24.protocol;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_1__comm_api_apis__["a" /* default */].lightCourseDetail, { courseid: courseid, protocol: protocol }).then(function (body) {
    return body.data;
  });
};

var getSimpleSubCourse = function getSimpleSubCourse(_ref25, _ref26) {
  var commit = _ref25.commit;
  var id = _ref26.id,
      pid = _ref26.pid,
      protocol = _ref26.protocol;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_1__comm_api_apis__["a" /* default */].simpleSubCourse, { id: id, pid: pid, protocol: protocol }).then(function (body) {
    return body.data;
  });
};

var getTopicCountInfo = function getTopicCountInfo(_ref27, _ref28) {
  var commit = _ref27.commit;
  var courseid = _ref28.courseid,
      sku = _ref28.sku,
      activityid = _ref28.activityid,
      protocol = _ref28.protocol;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_1__comm_api_apis__["a" /* default */].topicCountInfo, { courseid: courseid, sku: sku, activityid: activityid, protocol: protocol }).then(function (body) {
    return body.data;
  });
};

var getTopicGroupInfo = function getTopicGroupInfo(_ref29, _ref30) {
  var commit = _ref29.commit;
  var courseid = _ref30.courseid,
      sku = _ref30.sku,
      activityid = _ref30.activityid,
      activityinstanceid = _ref30.activityinstanceid,
      protocol = _ref30.protocol;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_1__comm_api_apis__["a" /* default */].topicGroupInfo, { courseid: courseid, sku: sku, activityid: activityid, activityinstanceid: activityinstanceid, protocol: protocol }).then(function (body) {
    return body.data;
  });
};

var lightForPreOrder = function lightForPreOrder(_ref31, params) {
  var commit = _ref31.commit;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_1__comm_api_apis__["a" /* default */].lightForPreOrder, params).then(function (body) {
    return body.data;
  });
};

var lightSubmitOrder = function lightSubmitOrder(_ref32, params) {
  var commit = _ref32.commit;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_1__comm_api_apis__["a" /* default */].lightSubmitOrder, params).then(function (body) {
    return body.data;
  });
};

var bindSaveOpenId = function bindSaveOpenId(_ref33) {
  var commit = _ref33.commit,
      state = _ref33.state;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_1__comm_api_apis__["a" /* default */].saveOpenId, { openid: state.userInfo.weixinUserInfo && state.userInfo.weixinUserInfo.openid });
};

var getOrderTipList = function getOrderTipList(_ref34, _ref35) {
  var commit = _ref34.commit;
  var sku = _ref35.sku;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_1__comm_api_apis__["a" /* default */].orderTipList, { sku: sku }).then(function (body) {
    return body.data;
  });
};

var getCoursePrice = function getCoursePrice(_ref36, _ref37) {
  var commit = _ref36.commit;
  var courseid = _ref37.courseid,
      protocol = _ref37.protocol;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_1__comm_api_apis__["a" /* default */].coursePrice, { courseid: courseid, protocol: protocol }).then(function (body) {
    return body.data;
  });
};

var getMyCoupon = function getMyCoupon(_ref38, params) {
  var commit = _ref38.commit;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_1__comm_api_apis__["a" /* default */].myCoupon, params).then(function (body) {
    return body.data;
  });
};

var getSkuList = function getSkuList(_ref39, _ref40) {
  var commit = _ref39.commit;
  var couponId = _ref40.couponId;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_1__comm_api_apis__["a" /* default */].skuList, { couponId: couponId }).then(function (body) {
    return body.data;
  });
};

var getMyOrders = function getMyOrders(_ref41, params) {
  var commit = _ref41.commit;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_1__comm_api_apis__["a" /* default */].getMyOrders, params).then(function (body) {
    return body.data;
  });
};

/***/ }),

/***/ 210:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return AJAX_GET_USERINFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return AJAX_BUY_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return AJAX_PAY_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return AJAX_ORDER_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return WX_PAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return MY_PAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CLEAR_PAY_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TREE_COIN_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TREE_COIN_INFO_MORE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return AJAX_HOT_LABEL_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return AJAX_GET_CATAGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return AJAX_GET_INDEXLIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return AJAX_POST_ADDCOMMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return AJAX_GET_USER_ISSUES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return AJAX_GET_USERCOURSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return AJAX_GET_COMBINECOURSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return AJAX_POST_USERSENDCODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return AJAX_POST_USERBINDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return AJAX_GET_MYTINYAUDIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return AJAX_GET_MYTINYVIDEO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return AJAX_GET_MYTINYALBUM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return AJAX_GET_MYTINYVIDEOALBUM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AJAX_GET_SERIALCOURSEINFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return AJAX_GET_LAMA_RECOMMEND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return AJAX_GET_FREETINYAUDIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return AJAX_GET_GROUPALBUM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return AJAX_GET_MYCOURSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return AJAX_GET_COLUMNLIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return AJAX_UPDATE_AUDIO5; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return CASHIER_PAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return HOME_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return RECOMMEND_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return COURSE_REMIND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return REMIND_CLOSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return CHANGE_HOTCOURSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return IS_SORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return MESSAGE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return AJAX_GET_NEWCOURSEINFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return AJAX_GET_MY_INCOME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return AJAX_GET_CONSTANT_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return VIP_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return AJAX_GET_MEMBER_FREE_COURSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return INDEX_MODULE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return FREE_ANS_COUNT; });


var AJAX_GET_USERINFO = 'AJAX_GET_USERINFO';
var AJAX_BUY_INFO = 'AJAX_BUY_INFO';
var AJAX_PAY_INFO = 'AJAX_PAY_INFO';
var AJAX_ORDER_INFO = 'AJAX_ORDER_INFO';
var WX_PAY = 'WX_PAY';
var MY_PAY = 'MY_PAY';
var CLEAR_PAY_STATUS = 'CLEAR_PAY_STATUS';
var TREE_COIN_INFO = 'TREE_COIN_INFO';
var TREE_COIN_INFO_MORE = 'TREE_COIN_INFO_MORE';
var AJAX_HOT_LABEL_LIST = 'AJAX_HOT_LABEL_LIST';

var AJAX_GET_CATAGORY = 'AJAX_GET_CATAGORY';
var AJAX_GET_INDEXLIST = 'AJAX_GET_INDEXLIST';
var AJAX_POST_ADDCOMMENT = 'AJAX_POST_ADDCOMMENT';
var AJAX_GET_USER_ISSUES = 'AJAX_GET_USER_ISSUES';
var AJAX_GET_USERCOURSE = 'AJAX_GET_USERCOURSE';
var AJAX_GET_COMBINECOURSE = 'AJAX_GET_COMBINECOURSE';
var AJAX_POST_USERSENDCODE = 'AJAX_POST_USERSENDCODE';
var AJAX_POST_USERBINDING = 'AJAX_POST_USERBINDING';
var AJAX_GET_MYTINYAUDIO = 'AJAX_GET_MYTINYAUDIO';
var AJAX_GET_MYTINYVIDEO = 'AJAX_GET_MYTINYVIDEO';
var AJAX_GET_MYTINYALBUM = 'AJAX_GET_MYTINYALBUM';
var AJAX_GET_MYTINYVIDEOALBUM = 'AJAX_GET_MYTINYVIDEOALBUM';
var AJAX_GET_SERIALCOURSEINFO = 'AJAX_GET_SERIALCOURSEINFO';
var AJAX_GET_LAMA_RECOMMEND = 'AJAX_GET_LAMA_RECOMMEND';
var AJAX_GET_FREETINYAUDIO = 'AJAX_GET_FREETINYAUDIO';
var AJAX_GET_GROUPALBUM = 'AJAX_GET_GROUPALBUM';
var AJAX_GET_MYCOURSE = 'AJAX_GET_MYCOURSE';
var AJAX_GET_COLUMNLIST = 'AJAX_GET_COLUMNLIST';
var AJAX_UPDATE_AUDIO5 = 'AJAX_UPDATE_AUDIO5';
var CASHIER_PAY = 'CASHIER_PAY';

var HOME_INFO = 'HOME_INFO';
var RECOMMEND_LIST = 'RECOMMEND_LIST';
var COURSE_REMIND = 'COURSE_REMIND';
var REMIND_CLOSE = 'REMIND_CLOSE';
var CHANGE_HOTCOURSE = 'CHANGE_HOTCOURSE';

var IS_SORT = 'IS_SORT';
var MESSAGE_LIST = 'MESSAGE_LIST';
var AJAX_GET_NEWCOURSEINFO = 'AJAX_GET_NEWCOURSEINFO';
var AJAX_GET_MY_INCOME = 'AJAX_GET_MY_INCOME';
var AJAX_GET_CONSTANT_DATA = 'AJAX_GET_CONSTANT_DATA';
var VIP_INFO = 'VIP_INFO';

var AJAX_GET_MEMBER_FREE_COURSE = 'AJAX_GET_MEMBER_FREE_COURSE';
var INDEX_MODULE_LIST = 'INDEX_MODULE_LIST';
var FREE_ANS_COUNT = 'FREE_ANS_COUNT';

/***/ }),

/***/ 211:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var freeClinicState = {
  freeAnsCount: 50 };

/* harmony default export */ __webpack_exports__["a"] = (freeClinicState);

/***/ }),

/***/ 212:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  catagoryList: [],
  advertList: [],
  indexCourseList: [],
  indexCourseObj: {} });

/***/ }),

/***/ 213:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_home__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_auth__ = __webpack_require__(19);






var initUserInfo = {
  id: null,
  encUserId: null,
  name: null,
  avatar: null,
  token: null,
  isHaveMobile: null
};
var nowUserInfo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_auth__["b" /* getUserInfo */])();
var userInfo = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, initUserInfo, nowUserInfo);

var userState = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
  userInfo: userInfo,
  userCourse: {
    list: [],
    hasNextPage: true
  },
  userSerialCourse: {
    list: [],
    hasNextPage: true
  },
  combineCourse: {
    list: [],
    hasNextPage: true
  },
  courseRecommends: [],
  hotLabelList: [],
  serialList: {
    type: null,
    list: [],
    hasNextPage: false,
    curpage: 0
  },
  sedCodeInfo: null,
  bindMobileInfo: null,
  payStatus: {
    courseId: null,
    ordernum: null,
    status: 0 },
  treeCoinInfo: {
    balance: 0,
    accountList: [],
    list: [],
    hasNextPage: true
  },
  userIssues: {},
  myTinyAudio: {
    myTinyAudioList: [],
    hasNextPage: true
  },
  myTinyAlbum: {
    myTinyAlbumList: [],
    hasNextPage: true
  },
  myTinyVideo: {
    myTinyVideoList: [],
    hasNextPage: true
  },
  myTinyVideoAlbum: {
    myTinyVideoAlbumList: [],
    hasNextPage: true
  },
  groupAlbum: {
    groupAlbumList: [],
    hasNextPage: true
  },
  audio5: null,
  lamaRecommends: [],
  freeTinyCourse: {
    list: [],
    hasNextPage: true
  },
  myCourse: {
    list: [],
    hasNextPage: true,
    isquerynostart: null,
    indexstart: null,
    nextPageNum: null,
    curpage: null
  },
  indexInfo: {
    pageInfo: '',
    courseRemind: {
      url: { name: 'MyCourse' }
    },
    hotCourse: {
      index: 1,
      course: {}
    },
    recommendList: [],
    hasNextPage: true,
    nextPageNum: 1,
    closeStatus: true,
    indexModuleList: {} },
  isSort: false,
  columnList: {
    list: [],
    hasNextPage: true
  },
  leaveMessageList: {
    dataList: [],
    curpage: 1,
    hasNextPage: false,
    buyRemind: null,
    totalCount: 0
  },
  newCourseInfo: {},
  myIncome: {
    list: [],
    hasNextPage: true,
    counts: 0,
    sumAmount: 0
  },
  constantData: [],
  vipInfo: {
    vipLogo: null,
    vipFreeLogo: null,
    vipFreeText: null,
    vipBindLink: null,
    vipBindText: null },
  memberFreeCourse: {
    catagorys: [],
    catagoryid: 0,
    list: [],
    hasNextPage: true,
    courseNum: 0,
    curpage: 0
  }
}, __WEBPACK_IMPORTED_MODULE_1__state_home__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (userState);

/***/ }),

/***/ 214:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Loading',
  data: function data() {
    return {};
  },

  props: {
    isLoading: Boolean
  },
  watch: {
    isLoading: {
      handler: function handler(value) {
        var _this = this;

        if (value) {
          setTimeout(function () {
            _this.$store.dispatch('setLoading', { state: false });
          }, 6000);
        }
      }
    }
  }
});

/***/ }),

/***/ 219:
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),

/***/ 221:
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),

/***/ 222:
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),

/***/ 23:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SOCKET_CONNECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SOCKET_CONNECT_STATUS; });
/* unused harmony export SOCKET_DISCONNECT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SOCKET_SEND_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SOCKET_RECEIVE_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SOCKET_RECEIVE_MESSAGE_UP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SOCKET_RECEIVE_MESSAGE_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SOCKET_RECEIVE_MESSAGE_LIKE_COUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return COURSE_CLOSED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return AJAX_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AJAX_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return AJAX_WX_SIGN_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return AJAX_GET_SIGNDATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return RESET_MESSAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RESET_MESSAGE_STORE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return AUDIO_LOADSTART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return AUDIO_PLAYING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return AUDIO_STOP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SERIAL_LIST; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__expert_mutation_types_expert__ = __webpack_require__(194);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_0__expert_mutation_types_expert__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_0__expert_mutation_types_expert__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_0__expert_mutation_types_expert__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return __WEBPACK_IMPORTED_MODULE_0__expert_mutation_types_expert__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return __WEBPACK_IMPORTED_MODULE_0__expert_mutation_types_expert__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return __WEBPACK_IMPORTED_MODULE_0__expert_mutation_types_expert__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return __WEBPACK_IMPORTED_MODULE_0__expert_mutation_types_expert__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return __WEBPACK_IMPORTED_MODULE_0__expert_mutation_types_expert__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return __WEBPACK_IMPORTED_MODULE_0__expert_mutation_types_expert__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return __WEBPACK_IMPORTED_MODULE_0__expert_mutation_types_expert__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return __WEBPACK_IMPORTED_MODULE_0__expert_mutation_types_expert__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return __WEBPACK_IMPORTED_MODULE_0__expert_mutation_types_expert__["l"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return __WEBPACK_IMPORTED_MODULE_0__expert_mutation_types_expert__["m"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return __WEBPACK_IMPORTED_MODULE_0__expert_mutation_types_expert__["n"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return __WEBPACK_IMPORTED_MODULE_0__expert_mutation_types_expert__["o"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return __WEBPACK_IMPORTED_MODULE_0__expert_mutation_types_expert__["p"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return __WEBPACK_IMPORTED_MODULE_0__expert_mutation_types_expert__["q"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return __WEBPACK_IMPORTED_MODULE_0__expert_mutation_types_expert__["r"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return __WEBPACK_IMPORTED_MODULE_0__expert_mutation_types_expert__["s"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return __WEBPACK_IMPORTED_MODULE_0__expert_mutation_types_expert__["t"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return __WEBPACK_IMPORTED_MODULE_0__expert_mutation_types_expert__["u"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return __WEBPACK_IMPORTED_MODULE_0__expert_mutation_types_expert__["v"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return __WEBPACK_IMPORTED_MODULE_0__expert_mutation_types_expert__["w"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return __WEBPACK_IMPORTED_MODULE_0__expert_mutation_types_expert__["x"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return __WEBPACK_IMPORTED_MODULE_0__expert_mutation_types_expert__["y"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return __WEBPACK_IMPORTED_MODULE_0__expert_mutation_types_expert__["z"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return __WEBPACK_IMPORTED_MODULE_0__expert_mutation_types_expert__["A"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return __WEBPACK_IMPORTED_MODULE_0__expert_mutation_types_expert__["B"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return __WEBPACK_IMPORTED_MODULE_0__expert_mutation_types_expert__["C"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return __WEBPACK_IMPORTED_MODULE_0__expert_mutation_types_expert__["D"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return __WEBPACK_IMPORTED_MODULE_0__expert_mutation_types_expert__["E"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return __WEBPACK_IMPORTED_MODULE_0__expert_mutation_types_expert__["F"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return __WEBPACK_IMPORTED_MODULE_0__expert_mutation_types_expert__["G"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__user_mutation_types_user__ = __webpack_require__(210);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_1__user_mutation_types_user__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_1__user_mutation_types_user__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_1__user_mutation_types_user__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_1__user_mutation_types_user__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_1__user_mutation_types_user__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_1__user_mutation_types_user__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_1__user_mutation_types_user__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_1__user_mutation_types_user__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_1__user_mutation_types_user__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_1__user_mutation_types_user__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_1__user_mutation_types_user__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_1__user_mutation_types_user__["l"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_1__user_mutation_types_user__["m"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_1__user_mutation_types_user__["n"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_1__user_mutation_types_user__["o"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_1__user_mutation_types_user__["p"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_1__user_mutation_types_user__["q"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_1__user_mutation_types_user__["r"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_1__user_mutation_types_user__["s"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_1__user_mutation_types_user__["t"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_1__user_mutation_types_user__["u"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_1__user_mutation_types_user__["v"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return __WEBPACK_IMPORTED_MODULE_1__user_mutation_types_user__["w"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "R", function() { return __WEBPACK_IMPORTED_MODULE_1__user_mutation_types_user__["x"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "S", function() { return __WEBPACK_IMPORTED_MODULE_1__user_mutation_types_user__["y"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "T", function() { return __WEBPACK_IMPORTED_MODULE_1__user_mutation_types_user__["z"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "U", function() { return __WEBPACK_IMPORTED_MODULE_1__user_mutation_types_user__["A"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "V", function() { return __WEBPACK_IMPORTED_MODULE_1__user_mutation_types_user__["B"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "W", function() { return __WEBPACK_IMPORTED_MODULE_1__user_mutation_types_user__["C"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "X", function() { return __WEBPACK_IMPORTED_MODULE_1__user_mutation_types_user__["D"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return __WEBPACK_IMPORTED_MODULE_1__user_mutation_types_user__["E"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return __WEBPACK_IMPORTED_MODULE_1__user_mutation_types_user__["F"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return __WEBPACK_IMPORTED_MODULE_1__user_mutation_types_user__["G"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return __WEBPACK_IMPORTED_MODULE_1__user_mutation_types_user__["H"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return __WEBPACK_IMPORTED_MODULE_1__user_mutation_types_user__["I"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return __WEBPACK_IMPORTED_MODULE_1__user_mutation_types_user__["J"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return __WEBPACK_IMPORTED_MODULE_1__user_mutation_types_user__["K"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return __WEBPACK_IMPORTED_MODULE_1__user_mutation_types_user__["L"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return __WEBPACK_IMPORTED_MODULE_1__user_mutation_types_user__["M"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return __WEBPACK_IMPORTED_MODULE_1__user_mutation_types_user__["N"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return __WEBPACK_IMPORTED_MODULE_1__user_mutation_types_user__["O"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return __WEBPACK_IMPORTED_MODULE_1__user_mutation_types_user__["P"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return __WEBPACK_IMPORTED_MODULE_1__user_mutation_types_user__["Q"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return __WEBPACK_IMPORTED_MODULE_1__user_mutation_types_user__["R"]; });





var SOCKET_CONNECT = 'SOCKET_CONNECT';
var SOCKET_CONNECT_STATUS = 'SOCKET_CONNECT_STATUS';
var SOCKET_DISCONNECT = 'SOCKET_DISCONNECT';
var SOCKET_SEND_MESSAGE = 'SOCKET_SEND_MESSAGE';
var SOCKET_RECEIVE_MESSAGE = 'SOCKET_RECEIVE_MESSAGE';
var SOCKET_RECEIVE_MESSAGE_UP = 'SOCKET_RECEIVE_MESSAGE_UP';
var SOCKET_RECEIVE_MESSAGE_DELETE = 'SOCKET_RECEIVE_MESSAGE_DELETE';
var SOCKET_RECEIVE_MESSAGE_LIKE_COUNT = 'SOCKET_RECEIVE_MESSAGE_LIKE_COUNT';
var COURSE_CLOSED = 'COURSE_CLOSED';
var AJAX_LOADING = 'AJAX_LOADING';
var AJAX_ERROR = 'AJAX_ERROR';
var AJAX_WX_SIGN_STATUS = 'AJAX_WX_SIGN_STATUS';
var AJAX_GET_SIGNDATA = 'AJAX_GET_SIGNDATA';

var RESET_MESSAGES = 'RESET_MESSAGES';
var RESET_MESSAGE_STORE = 'RESET_MESSAGE_STORE';
var AUDIO_LOADSTART = 'AUDIO_LOADSTART';
var AUDIO_PLAYING = 'AUDIO_PLAYING';
var AUDIO_STOP = 'AUDIO_STOP';

var SERIAL_LIST = 'SERIAL_LIST';

/***/ }),

/***/ 265:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 27:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_user_state_user__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_user_state_freeClinic__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_expert_state_expert__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_nim_state_nim__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__getters__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mutations__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__nim_mutations__ = __webpack_require__(201);















__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);

var state = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({
  isLoading: false,
  firstAjaxStatus: 0,
  connectStatus: 0,
  socket: null,
  reconnectErrorCount: 0,
  sendMessages: {},
  firstMessage: null,
  latestMessage: null,
  latestMessageTime: null,
  courseCloseState: -1,
  messages: [],
  audioList: [],
  lastPlayAudio: null,
  messageStore: [],
  isLookHistoryMessage: 0,
  courseList: {
    data: [],
    hasNextPage: false
  },
  courseInfo: {},
  courseUpCount: 0,
  buyInfo: {},
  payInfo: {},
  preOrderInfo: {},
  signData: {
    sign: null,
    timeStamp: null,
    userId: null,
    userType: null
  },
  wxSignStatus: 0,
  currentCourseInfo: {
    id: 123123123
  },
  error: null,
  cashierPayStatus: 0 }, __WEBPACK_IMPORTED_MODULE_6__store_expert_state_expert__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__store_user_state_user__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__store_user_state_freeClinic__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__store_nim_state_nim__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */].Store({
  state: state,
  getters: __WEBPACK_IMPORTED_MODULE_8__getters__,
  actions: __WEBPACK_IMPORTED_MODULE_9__actions__,
  mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_10__mutations__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__nim_mutations__["a" /* default */]),
  plugins:  false ? [] : []
}));

/***/ }),

/***/ 287:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isLoading) ? _c('div', {
    staticClass: "loading-mask"
  }) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 32:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return os; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return browser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils__ = __webpack_require__(58);




var os = {};

var browser = {};
var ua = navigator.userAgent;
var webkit = ua.match(/Web[kK]it[/]{0,1}([\d.]+)/);
var android = ua.match(/(Android);?[\s/]+([\d.]+)?/);

var xiaomi = ua.match(/XiaoMi/);

var xiaomiBrowser = ua.match(/MiuiBrowser\/([\d.]+)/);
var osx = !!ua.match(/\(Macintosh; Intel /);
var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
var iphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/);
var webos = ua.match(/(webOS|hpwOS)[\s/]([\d.]+)/);
var touchpad = webos && ua.match(/TouchPad/);

var uc = ua.match(/UCBrowser\/([\d.]+)/);

var wx = ua.match(/MicroMessenger\/([\d.]+)/);
var kindle = ua.match(/Kindle\/([\d.]+)/);
var silk = ua.match(/Silk\/([\d._]+)/);
var blackberry = ua.match(/(BlackBerry).*Version\/([\d.]+)/);
var bb10 = ua.match(/(BB10).*Version\/([\d.]+)/);
var rimtabletos = ua.match(/(RIM\sTablet\sOS)\s([\d.]+)/);
var playbook = ua.match(/PlayBook/);
var chrome = ua.match(/Chrome\/([\d.]+)/) || ua.match(/CriOS\/([\d.]+)/);
var firefox = ua.match(/Firefox\/([\d.]+)/);
var ie = ua.match(/MSIE\s([\d.]+)/) || ua.match(/Trident\/[\d](?=[^?]+).*rv:([0-9.].)/);
var webview = !chrome && ua.match(/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/);
var safari = webview || ua.match(/Version\/([\d.]+)([^S](Safari)|[^M]*(Mobile)[^S]*(Safari))/);

var qq = ua.match(/\sQQ/i);
var app = __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('MT_USER_INFO') !== undefined;

if (browser.webkit === !!webkit) {
  browser.version = webkit[1];
}

if (android) {
  os.android = true;
  os.type = 'AM';
  os.version = android[2];
}
if (iphone && !ipod) {
  os.ios = true;
  os.iphone = true;
  os.type = 'IOS';
  os.version = iphone[2].replace(/_/g, '.');
}

if (xiaomi) {
  os.xiaomi = true;
}
if (ipad) {
  os.ios = true;
  os.ipad = true;
  os.version = ipad[2].replace(/_/g, '.');
}
if (ipod) {
  os.ios = true;
  os.ipod = true;
  os.version = ipod[3] ? ipod[3].replace(/_/g, '.') : null;
}
if (webos) {
  os.webos = true;
  os.version = webos[2];
}
if (touchpad) {
  os.touchpad = true;
}
if (blackberry) {
  os.blackberry = true;
  os.version = blackberry[2];
}
if (bb10) {
  os.bb10 = true;
  os.version = bb10[2];
}
if (rimtabletos) {
  os.rimtabletos = true;
  os.version = rimtabletos[2];
}
if (playbook) {
  browser.playbook = true;
}
if (kindle) {
  os.kindle = true;
  os.version = kindle[1];
}
if (silk) {
  browser.silk = true;
  browser.version = silk[1];
}
if (!silk && os.android && ua.match(/Kindle Fire/)) {
  browser.silk = true;
}
if (chrome) {
  browser.chrome = true;
  browser.version = chrome[1];
}
if (firefox) {
  browser.firefox = true;
  browser.version = firefox[1];
}

if (uc) {
  browser.uc = true;
  browser.version = uc[1];
}

if (os.xiaomi && xiaomiBrowser) {
  browser.xiaomiBrowser = true;
  browser.version = xiaomiBrowser[1];
}

if (wx) {
  browser.wx = true;
  browser.version = wx[1];
}

if (ie) {
  browser.ie = true;
  browser.version = ie[1];
}
if (safari && (osx || os.ios)) {
  browser.safari = true;
  if (osx) browser.version = safari[1];
}
if (webview) {
  browser.webview = true;
}
if (qq) {
  browser.qq = true;
}
if (app) {
  var allCookies = __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get();
  var fck = allCookies.MT_USER_INFO.split(',');

  var curserVersion = __WEBPACK_IMPORTED_MODULE_1__lib_utils__["a" /* util */].base64Decode(fck[1]);
  browser.app = true;
  browser.version = curserVersion;
}

os.tablet = !!(ipad || playbook || android && !ua.match(/Mobile/) || firefox && ua.match(/Tablet/) || ie && !ua.match(/Phone/) && ua.match(/Touch/));
os.phone = !!(!os.tablet && !os.ipod && (android || iphone || webos || blackberry || bb10 || chrome && ua.match(/Android/) || chrome && ua.match(/CriOS\/([\d.]+)/) || firefox && ua.match(/Mobile/) || ie && ua.match(/Touch/)));

/***/ }),

/***/ 388:
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),

/***/ 389:
/***/ (function(module, exports) {

module.exports = {"name":"elliptic","version":"6.4.0","description":"EC cryptography","main":"lib/elliptic.js","files":["lib"],"scripts":{"jscs":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","jshint":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","lint":"npm run jscs && npm run jshint","unit":"istanbul test _mocha --reporter=spec test/index.js","test":"npm run lint && npm run unit","version":"grunt dist && git add dist/"},"repository":{"type":"git","url":"git@github.com:indutny/elliptic"},"keywords":["EC","Elliptic","curve","Cryptography"],"author":"Fedor Indutny <fedor@indutny.com>","license":"MIT","bugs":{"url":"https://github.com/indutny/elliptic/issues"},"homepage":"https://github.com/indutny/elliptic","devDependencies":{"brfs":"^1.4.3","coveralls":"^2.11.3","grunt":"^0.4.5","grunt-browserify":"^5.0.0","grunt-cli":"^1.2.0","grunt-contrib-connect":"^1.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^1.0.1","grunt-mocha-istanbul":"^3.0.1","grunt-saucelabs":"^8.6.2","istanbul":"^0.4.2","jscs":"^2.9.0","jshint":"^2.6.0","mocha":"^2.1.0"},"dependencies":{"bn.js":"^4.4.0","brorand":"^1.0.1","hash.js":"^1.0.0","hmac-drbg":"^1.0.0","inherits":"^2.0.1","minimalistic-assert":"^1.0.0","minimalistic-crypto-utils":"^1.0.0"}}

/***/ }),

/***/ 415:
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),

/***/ 440:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(886)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(550),
  /* template */
  __webpack_require__(1085),
  /* scopeId */
  "data-v-4db49b9c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 45:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dev_config__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dev_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__dev_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__prod_config__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__prod_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__prod_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__test_config__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__test_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__test_config__);




var config = void 0;
if (true) {
  config = __WEBPACK_IMPORTED_MODULE_1__prod_config___default.a;
} else if (process.env.PROJECT_BUILD_ENV === 'test') {
  config = configTest;
} else {
  config = configDev;
}

var conf = config;

/* harmony default export */ __webpack_exports__["a"] = (conf);

/***/ }),

/***/ 451:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(882)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(577),
  /* template */
  __webpack_require__(1081),
  /* scopeId */
  "data-v-39167b1f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 455:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 456:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 457:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 458:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 459:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__preview__ = __webpack_require__(1063);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__preview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__preview__);


var $vm = void 0;
/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue) {
    var Preview = Vue.extend(__WEBPACK_IMPORTED_MODULE_0__preview___default.a);

    if (!$vm) {
      $vm = new Preview({ el: document.createElement('div') });
      document.body.appendChild($vm.$el);
    }
    var preview = {
      open: function open(index, list, params) {
        $vm.open(index, list, params);
      },
      close: function close() {
        $vm.close();
      }
    };
    Vue.$preview = preview;
    Vue.mixin({
      created: function created() {
        this.$preview = Vue.$preview;
      }
    });
  }
});

/***/ }),

/***/ 46:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getToken */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return instance; });
/* harmony export (immutable) */ __webpack_exports__["b"] = updateAjaxHeaderConfig;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_apisauce__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_apisauce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_apisauce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(45);





var mtClientInfoStr = __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.get('MT_CLIENT_INFO');
var mtClientInfo = mtClientInfoStr ? JSON.parse(mtClientInfoStr) : '';
var devicekey = mtClientInfo ? mtClientInfo.devicekey : '0UDbKMpP91HqSN2rc7aXFyWEhGmk6Y8i';

window.ajaxHeader = {
  token: null
};

function getToken() {
  if (window.ajaxHeader && window.ajaxHeader.token) {
    return window.ajaxHeader.token;
  } else if (window.localStorage) {
    return window.localStorage.getItem('token');
  }
  return null;
}

var instance = __WEBPACK_IMPORTED_MODULE_1_apisauce___default.a.create({
  baseURL: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].otherAjaxPrefix.indexOf(location.hostname) > -1 ? __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].ajaxPrefix : '/',
  timeout: 20000,
  headers: {
    Accept: '*/*',
    clientInfo: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
      clientAppVersion: '1.9.8',
      clientYunyuVersion: '',
      clientSystem: window.navigator.userAgent,
      clientVersion: '',
      deviceCode: devicekey,
      latitude: '',
      longitude: '',
      traderName: '',
      partner: 'babytree',
      nettype: 'unknown',
      clientip: '',
      screenwidth: '',
      screenheight: '' }),
    platform: '1',
    birthday: '',
    timestamp: Date.parse(new Date()),
    signature: '350F163035D51E8D400114BE70EDFBFA',
    protocol: document.location.protocol === 'https:' ? 'https' : 'http',
    token: getToken() }
});

function updateAjaxHeaderConfig(_ref) {
  var _ref$token = _ref.token,
      token = _ref$token === undefined ? null : _ref$token,
      userInfo = _ref.userInfo;

  if (token) {
    window.ajaxHeader.token = token;
  }
  if (window.localStorage) {
    window.localStorage.setItem('token', token);
    if (userInfo) {
      window.localStorage.setItem('userinfo', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(userInfo));
    }
  }
}

var buildEnv = "production";
instance.addRequestTransform(function (request) {
  var url = request.url;

  if (/^\/mapi/.test(url) && buildEnv !== 'localhost') {
    var prefix = '//newmapi.babytree-test.com';
    if (buildEnv === 'production') {
      prefix = '//newmapi.babytree.com';
    }
    if (buildEnv === 'preproduction') {
      prefix = '//newmapi.pre.fpm.babytree.com';
    }
    request.url = '' + prefix + url;
  } else if (/^\/mobile\/up/.test(url) && buildEnv !== 'localhost') {
    request.url = '' + (buildEnv === 'production' ? '//fileupload.babytree.com' : '//fileupload.babytree-test.com') + url;
  } else if (/^\/account\/login/.test(url) && buildEnv !== 'localhost') {
    request.url = '//openapi.meitun.com' + url;
  } else if (/^\/openapi\/getTokenByLoginString/.test(url) && buildEnv !== 'localhost') {
    request.url = '//h5proxy.meitun.com/newapi/router' + url;
  }
});

/* unused harmony default export */ var _unused_webpack_default_export = (instance);

/***/ }),

/***/ 460:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
(function (scope) {
  var startOffset = Date.now ? Date.now() : +new Date(),
      performance = scope.performance || {},
      _entries = [],
      _marksIndex = {},
      _filterEntries = function _filterEntries(key, value) {
    var i = 0,
        n = _entries.length,
        result = [];
    for (; i < n; i++) {
      if (_entries[i][key] == value) {
        result.push(_entries[i]);
      }
    }
    return result;
  },
      _clearEntries = function _clearEntries(type, name) {
    var i = _entries.length,
        entry;
    while (i--) {
      entry = _entries[i];
      if (entry.entryType == type && (name === void 0 || entry.name == name)) {
        _entries.splice(i, 1);
      }
    }
  };

  if (!performance.now) {
    performance.now = performance.webkitNow || performance.mozNow || performance.msNow || function () {
      return (Date.now ? Date.now() : +new Date()) - startOffset;
    };
  }

  if (!performance.mark) {
    performance.mark = performance.webkitMark || function (name) {
      var mark = {
        name: name,
        entryType: 'mark',
        startTime: performance.now(),
        duration: 0
      };
      _entries.push(mark);
      _marksIndex[name] = mark;
    };
  }

  if (!performance.measure) {
    performance.measure = performance.webkitMeasure || function (name, startMark, endMark) {
      startMark = _marksIndex[startMark].startTime;
      endMark = _marksIndex[endMark].startTime;

      _entries.push({
        name: name,
        entryType: 'measure',
        startTime: startMark,
        duration: endMark - startMark
      });
    };
  }

  if (!performance.getEntriesByType) {
    performance.getEntriesByType = performance.webkitGetEntriesByType || function (type) {
      return _filterEntries('entryType', type);
    };
  }

  if (!performance.getEntriesByName) {
    performance.getEntriesByName = performance.webkitGetEntriesByName || function (name) {
      return _filterEntries('name', name);
    };
  }

  if (!performance.clearMarks) {
    performance.clearMarks = performance.webkitClearMarks || function (name) {
      _clearEntries('mark', name);
    };
  }

  if (!performance.clearMeasures) {
    performance.clearMeasures = performance.webkitClearMeasures || function (name) {
      _clearEntries('measure', name);
    };
  }

  scope.performance = performance;

  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
      return performance;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
})(self);

/***/ }),

/***/ 462:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__page_Home_page__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__page_Home_page___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__page_Home_page__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__entry__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__course__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__class__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__other__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__scholarships__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__freeClinic__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dayima__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__knowing__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lighthouse__ = __webpack_require__(547);























var UserLive = function UserLive() {
  return __webpack_require__.e/* import() */(60).then(__webpack_require__.bind(null, 1131));
};
var UserCourse = function UserCourse() {
  return __webpack_require__.e/* import() */(67).then(__webpack_require__.bind(null, 1133));
};
var MyCourse = function MyCourse() {
  return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, 1187));
};
var MyTinyCourse = function MyTinyCourse() {
  return __webpack_require__.e/* import() */(65).then(__webpack_require__.bind(null, 1122));
};
var MyVideo = function MyVideo() {
  return __webpack_require__.e/* import() */(64).then(__webpack_require__.bind(null, 1123));
};
var UserBinding = function UserBinding() {
  return __webpack_require__.e/* import() */(69).then(__webpack_require__.bind(null, 1132));
};
var MyIncome = function MyIncome() {
  return __webpack_require__.e/* import() */(59).then(__webpack_require__.bind(null, 1121));
};
var testPage = function testPage() {
  return __webpack_require__.e/* import() */(81).then(__webpack_require__.bind(null, 1186));
};

var WebviewDebug = function WebviewDebug() {
  return __webpack_require__.e/* import() */(44).then(__webpack_require__.bind(null, 1188));
};

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  mode: 'history',
  base: '/live',
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  routes: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_4__entry__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_5__course__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_6__class__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_7__other__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_8__scholarships__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_9__freeClinic__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_10__dayima__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_11__knowing__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_12__lighthouse__["a" /* default */]), [{
    path: '/user',
    name: 'UserLive',
    component: UserLive,
    meta: {
      pageTitle: '个人信息',
      requiresAuth: true,
      authType: 'user'
    },
    children: [{
      path: 'profile',
      component: __WEBPACK_IMPORTED_MODULE_3__page_Home_page___default.a
    }, {
      path: 'live',
      component: __WEBPACK_IMPORTED_MODULE_3__page_Home_page___default.a
    }]
  }, {
    path: '/user/courseList/',
    name: 'UserCourse',
    component: UserCourse,
    meta: {
      pageTitle: '我的开讲',
      requiresAuth: true,
      authType: 'user'
    }
  }, {
    path: '/user/myCourse/',
    name: 'MyCourse',
    component: MyCourse,
    meta: {
      pageTitle: '我的课程',
      requiresAuth: true,
      authType: 'user'
    }
  }, {
    path: '/user/myTinyCourse',
    name: 'MyTinyCourse',
    component: MyTinyCourse,
    meta: {
      pageTitle: '我的音频',
      requiresAuth: true,
      authType: 'user'
    }
  }, {
    path: '/user/myVideo',
    name: 'MyVideo',
    component: MyVideo,
    meta: {
      pageTitle: '我的视频',
      requiresAuth: true,
      authType: 'user'
    }
  }, {
    path: '/user/myIncome',
    name: 'myIncome',
    component: MyIncome,
    meta: {
      pageTitle: '分享收益',
      requiresAuth: true,
      authType: 'user'
    }
  }, {
    path: '/test',
    name: 'testPage',
    component: testPage,
    meta: {
      pageTitle: 'test'
    }
  }, {
    path: '/user/binding/',
    name: 'UserBinding',
    component: UserBinding,
    meta: {
      pageTitle: '完善资料',
      requiresAuth: true,
      authType: 'user'
    }
  }, {
    path: '/webviewDebug',
    name: 'webviewDebug',
    component: WebviewDebug,
    meta: {
      pageTitle: 'Webview Actions',
      requiresAuth: false
    }
  }, { path: '*', component: function component() {
      return __webpack_require__.e/* import() */(79).then(__webpack_require__.bind(null, 1110));
    } }])
}));

/***/ }),

/***/ 464:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(897)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(553),
  /* template */
  __webpack_require__(1096),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 466:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(901)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(576),
  /* template */
  __webpack_require__(1100),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 468:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__comm_utils_reportTiming__ = __webpack_require__(535);


/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {
    if (typeof this.DOREPORT === 'undefined') {
      console.log('mounted reporting', document.title);
      this.doReport();
    }
  },

  methods: {
    doReport: function doReport() {
      var pageType = 1;
      if (this.$route.meta.authType === 'expert') {
        pageType = 2;
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__comm_utils_reportTiming__["a" /* default */])({ pageValue: document.title, pageType: pageType });
    }
  },
  watch: {
    DOREPORT: {
      handler: function handler(nextValue, oldValue) {
        if (nextValue && !oldValue) {
          console.log('watch reporting');
          this.doReport();
        }
      }
    }
  }
});

/***/ }),

/***/ 469:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(893)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(552),
  /* template */
  __webpack_require__(1092),
  /* scopeId */
  "data-v-86c1167a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 474:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(888)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(551),
  /* template */
  __webpack_require__(1087),
  /* scopeId */
  "data-v-58ab64f2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 475:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 476:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAABMCAMAAAAoRQUTAAAAOVBMVEUAAABERERERERFRUVGRkZGRkZHR0dMTExERERERERERERFRUVERERERERFRUVFRUVISEhERERERERILJyjAAAAEnRSTlMA5ofCSTQaDpz079rReWpcJrHMTYQaAAAAuElEQVRIx+3Wyw6FIAxFUYsvfAv//7H3GurIxN2kDul4JQQ4bdp8WEEkWFzK/zLImK8So2MYisOjN3UtuP1247s71K3gOnXLYHMCrp/UneDm4ub+3Z1S3ARuUJc7cIvNjau6A1yrboePu90GLhkDE9VFl3sGNdWg1qByUO2TrREIIEA42n0Zfh5+cP5Cfyg4ZhxcbgV3c3G78gDgkeIeUjz2eJD6ZapBrkH+NsjBvrqyBAjrNS/sXD+kxSdhaVhBZQAAAABJRU5ErkJggg=="

/***/ }),

/***/ 477:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAF0AAABsCAMAAAA/iU75AAAAOVBMVEUAAABFRUVFRUVERERERERERERERERKSkpERERERERFRUVGRkZERERERERERERISEhERERERERERETrSPGfAAAAEnRSTlMAPmC96vNvE+GrUS7NmdcdfopnxhLYAAADP0lEQVRo3t1Z27arIAw0AoLcVP7/Y8/aqwq2tuYiT2eeYYTJJEIYaAhTUlmbYnRWaQpDR4yzKe8w89iHGg7qywfgObcqv6Ge8S9zuce8PNDbFAxGrH86s6jVh+VvO8Gv6vzVJOK2qlGnT4Ehmaa+5ZMHV7m3b9PtVvldYJPXuWn5FfKqnGHSL3qfGO8mhriP0jzrHNNmZNzh2EinbpNWdOR6WQZ5ih9w+LoQIsI+YSKNnvbRgSd64iVdHDiLUQMVirNV9zKZpWf1y76OVLrOK2HtllLQ8mUh1O1mfCBc1kHfLxAdkAceMtFluqnOVl4TM4lbsi0to6bqdR4UacvzpWhwStNMCg+w2YFkhiq7THjkn4TEHvPaQrBMFLBHgmmgWkZmGvhv2Z/rjnvGCdgdwTMDxbbyie5mg7ikTl6N5NUPr0bk6odb0rDZDa363Zzx8PMecYtKlEszdRXAIgfyjrUgXSO5cK985T39kG0N+0STX0azlLFbPWDzjtgb50hbRt4xT1vW8AIcv5SReSnTgVK+NPtaFnd6wFe+k0fJZXjCSqPoOgy0DkYqSIiQyBY3/h7jSouokL5E/z1BYxGQt3g1/vHTy3Zs3BpETbFYGtQK9mCGVZWGiAQU8X2D+UN5xzyI4V25h/PDE2zmhttsj7hHVe6hRjH3pAsOPYm4V11o0OvjeGqVpgNJaSS2nP6vS/6STT45vB+M93/1Fn5V9k1L+sHp5Al/r5/i9oOXyOmvg2KVhFC3m4n/1VxFDOjYKvnKbl8WA4gRD/IcBjpCJtFDdZi0mgKiufBmgzbLF4f2f/F+sLP3pxgjq9n+vlm+VelkgLu08vgPXn7+tLraXIz152l4FliRTAJIxGmw7rs2EYkoL7LxazJsw1Ns36zheH0Z/G3g4iW5GRGqXNV6jvh5IfWE8iK/1av6uR7I730Mi6guU96ijX8c+PNDRE4MMs+rN2GgGzucpfFIJvHhTnFMPYW5MGbE7Hz45nBbVeqGpVGCJJXIbzMj8k+S/6PG6s6tI3fjbN/piaZHRHJJnk+xRiB0ZQ/VKfVJQQD8gcN0tnvLIYM8WEjRSN2+iZ5opFMt9R3RSEel+rqdSSrHP3p0es4NtX1FAAAAAElFTkSuQmCC"

/***/ }),

/***/ 478:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/loading.5666801.gif";

/***/ }),

/***/ 535:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_query_string__);




function report(bizType, pageType, pageValue, data) {
  var url = '//m.meitun.com/h5/monitor/performance.gif';
  var paramsObj = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, data, {
    bt: bizType,
    pt: pageType,
    pv: pageValue,
    biztype: bizType
  });
  var params = __WEBPACK_IMPORTED_MODULE_2_query_string___default.a.stringify(paramsObj);
  var img = new Image(1, 1);
  img.src = url + '?' + params;
}

function getTimingObj(performance, now) {
  var timing = performance.timing;
  var navigation = performance.navigation;
  var markArr = performance.getEntriesByName('router');
  var markCount = markArr.length;
  var newStartTime = void 0;
  var time = void 0;
  var isSPR = false;
  if (markCount > 0) {
    newStartTime = markArr[markCount - 1].startTime;
    isSPR = true;
  }
  var timingData = {
    RDTT: isSPR ? 0 : navigation.redirectCount,
    RDTM: isSPR ? 0 : timing.redirectEnd - timing.redirectStart,
    DMLKT: isSPR ? 0 : timing.domainLookupEnd - timing.domainLookupStart,
    CONTT: isSPR ? 0 : timing.connectEnd - timing.connectStart,
    REQT: isSPR ? 0 : timing.responseStart - timing.requestStart,
    RSPT: isSPR ? 0 : timing.responseEnd - timing.responseStart,
    DMPT: isSPR ? 0 : timing.domInteractive - timing.domLoading,
    DMLT: isSPR ? 0 : timing.domComplete - timing.domInteractive,
    ONLOADT: isSPR ? 0 : timing.loadEventEnd - timing.loadEventStart,
    PAGET: isSPR ? 0 : timing.domComplete - timing.fetchStart,
    ALLT: isSPR ? 0 : timing.domComplete - timing.navigationStart,
    BEFDMLT: isSPR ? 0 : timing.domLoading - timing.navigationStart,
    RESLOADT: isSPR ? 0 : timing.loadEventStart - timing.domLoading,
    SCRIPTT: isSPR ? 0 : timing.loadEventStart - timing.domContentLoadedEventStart,

    INTT: timing.domContentLoadedEventStart - timing.navigationStart
  };
  if (newStartTime) {
    time = now - newStartTime;
  }
  if (isSPR) {
    timingData.INTT = time;
  }
  if (time) {
    timingData.CINTT = isSPR ? time : time - timing.navigationStart;
  }
  timingData.FST = timingData.CINTT;
  return timingData;
}

var getTiming = function getTiming() {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var performance = window.performance || window.webkitPerformance || window.msPerformance || window.mozPerformance;
    if (typeof performance === 'undefined') {
      reject();
      return;
    }
    if (!performance.getEntriesByName || !performance.mark) {
      reject();
      return;
    }
    var now = performance.now();
    if (performance.timing.loadEventEnd) {
      var timingData = getTimingObj(performance, now);
      resolve(timingData);
      console.log('1:', timingData);
      return;
    }
    window.addEventListener('load', function onLoad() {
      window.removeEventListener('load', onLoad, false);
      if (requestAnimationFrame) {
        requestAnimationFrame(function () {
          var timingData = getTimingObj(performance, now);
          resolve(timingData);
          console.log('2:', timingData);
        });
      } else {
        setTimeout(function () {
          var timingData = getTimingObj(performance, now);
          resolve(timingData);
          console.log('2:', timingData);
        });
      }
    }, false);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var _ref$bizType = _ref.bizType,
      bizType = _ref$bizType === undefined ? 2 : _ref$bizType,
      _ref$pageType = _ref.pageType,
      pageType = _ref$pageType === undefined ? 1 : _ref$pageType,
      _ref$pageValue = _ref.pageValue,
      pageValue = _ref$pageValue === undefined ? document.title : _ref$pageValue;

  return getTiming().then(function (data) {
    report(bizType, pageType, pageValue, data);
  })['catch'](function (e) {
    console.log(e);
  });
});

/***/ }),

/***/ 540:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_es6_promise_auto__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_style_css__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_base_less__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_base_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_base_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_preview_index__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ScoreLabel__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ScoreLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_ScoreLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mint_ui__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_touch__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_touch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_fastclick__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_fastclick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_fastclick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_js_cookie__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__bbt_mt_utils_tracking__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib_ua__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lib_auth__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__App__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__router__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__store__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__store_actions__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__lib_performance_polyfill__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__lib_performance_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__lib_performance_polyfill__);






























__WEBPACK_IMPORTED_MODULE_5_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].config.errorHandler = function (err, vm) {
  console.error(err, vm);
};

__WEBPACK_IMPORTED_MODULE_12__bbt_mt_utils_tracking__["a" /* TrackLisener */].addClickListenner();
window.Track = __WEBPACK_IMPORTED_MODULE_12__bbt_mt_utils_tracking__["b" /* Track */];
window.Tracking = {
  initTrackUrl: function initTrackUrl(logEvent, trackCode, toHref, orderNo, tCode) {
    __WEBPACK_IMPORTED_MODULE_12__bbt_mt_utils_tracking__["b" /* Track */].doTracker(logEvent, trackCode, toHref, orderNo, tCode);
  }
};

__WEBPACK_IMPORTED_MODULE_10_fastclick___default.a.attach(document.body);

if (__WEBPACK_IMPORTED_MODULE_13__lib_ua__["a" /* browser */].wx) {
  var wx = __webpack_require__(173);
  window.wx = wx;
}

__WEBPACK_IMPORTED_MODULE_16__router__["a" /* default */].beforeEach(function (to, from, next) {
  document.title = to.query && decodeURIComponent(to.query.pageTitle || '') || to.meta && to.meta.pageTitle || '开讲';
  var type = 'user';
  var code = to.query.code;

  if (!from.name) {
    var fxCode = to.query.code;
    var userInfo = __WEBPACK_IMPORTED_MODULE_14__lib_auth__["a" /* default */].get();
    if (userInfo) {
      var userSource = 1;
      var hasOpenId = userInfo.weixinUserInfo ? userInfo.weixinUserInfo.openid : 0;
      if (userInfo.userSource === 0) {
        userSource = 0;
      }
      if (userSource === 0 && fxCode && __WEBPACK_IMPORTED_MODULE_13__lib_ua__["a" /* browser */].wx && !hasOpenId) {
        __WEBPACK_IMPORTED_MODULE_17__store__["a" /* default */].dispatch('userAuth', {
          code: to.query.code
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_17__store__["a" /* default */].dispatch('userAuth', { userInfo: userInfo });
      }
    } else if (fxCode) {
      var platformType = 5;
      if (to.name === 'dayimaVerify' && !/huawei/i.test(navigator.userAgent)) {
        platformType =  true ? 13 : 12;
      }
      __WEBPACK_IMPORTED_MODULE_17__store__["a" /* default */].dispatch('userAuth', {
        code: fxCode,
        platformType: platformType
      });
    } else {
      __WEBPACK_IMPORTED_MODULE_17__store__["a" /* default */].dispatch('userAuth', {});
    }
  }

  if (to.meta.requiresAuth) {
    if (!__WEBPACK_IMPORTED_MODULE_14__lib_auth__["a" /* default */].check('user')) {
      if (to.name === 'dayimaVerify' && !/huawei/i.test(navigator.userAgent)) {
        __WEBPACK_IMPORTED_MODULE_14__lib_auth__["a" /* default */].login('dayima', code, next);
      } else {
        __WEBPACK_IMPORTED_MODULE_14__lib_auth__["a" /* default */].login(type, code, next);
      }
      return;
    }

    var _userInfo = __WEBPACK_IMPORTED_MODULE_14__lib_auth__["a" /* default */].get();
    if (to.name === 'UserBinding' && _userInfo) {
      if (Number(_userInfo.isHaveMobile) === 1) {
        next('/');
      }
    }

    if (_userInfo && __WEBPACK_IMPORTED_MODULE_11_js_cookie___default.a.get('userInfo') && (_userInfo.token !== __WEBPACK_IMPORTED_MODULE_11_js_cookie___default.a.get('userInfo').token || _userInfo.encUserId !== __WEBPACK_IMPORTED_MODULE_11_js_cookie___default.a.get('userInfo').encUserId)) {
      __WEBPACK_IMPORTED_MODULE_17__store__["a" /* default */].dispatch('userAuth', { userInfo: _userInfo });
    }
  }

  if (from.query.hideHeaderHome) {
    to.query.hideHeaderHome = from.query.hideHeaderHome;
  }
  if (from.query.hideHeaderRight) {
    to.query.hideHeaderRight = from.query.hideHeaderRight;
  }
  if (from.query.hideDesc) {
    to.query.hideDesc = from.query.hideDesc;
  }
  if (from.query.hideVip) {
    to.query.hideVip = from.query.hideVip;
  }

  next();
});

var courseReg = new RegExp('/info/');
__WEBPACK_IMPORTED_MODULE_16__router__["a" /* default */].afterEach(function (route) {
  if (__WEBPACK_IMPORTED_MODULE_13__lib_ua__["a" /* browser */].wx) {
    if (route.meta.isCourse && !courseReg.test(location.href)) {
      location.href = location.origin + '/live' + route.fullPath;
    } else {
      var type = route.meta.authType;

      if (window.__wxjs_is_wkwebview) {
        if (window.entryUrl === '' || window.entryUrl === undefined) {
          var url = location.origin + '/live' + route.fullPath;
          window.entryUrl = url;
        }
        __WEBPACK_IMPORTED_MODULE_18__store_actions__["wxSign"](__WEBPACK_IMPORTED_MODULE_17__store__["a" /* default */], {
          url: window.entryUrl,
          debug: false,
          type: type
        });
      } else {
        setTimeout(function () {
          __WEBPACK_IMPORTED_MODULE_18__store_actions__["wxSign"](__WEBPACK_IMPORTED_MODULE_17__store__["a" /* default */], {
            url: location.origin + '/live' + route.fullPath,
            debug: false,
            type: type
          });
        }, 500);
      }
    }
  }
});

var Toast = __WEBPACK_IMPORTED_MODULE_8_mint_ui___default.a.Toast;
var Timer = null;
var toastObj = {
  toasting: false,
  lastDuration: 0
};
function toast(toastInfo) {
  var message = '';
  var duration = 3000;
  var position = 'middle';
  if ((typeof toastInfo === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(toastInfo)) === 'object') {
    message = toastInfo.message;
    duration = toastInfo.duration || duration;
    position = toastInfo.position || position;
  } else {
    message = String(toastInfo);
  }
  if (toastObj.toasting) {
    if (Timer) {
      return;
    }
    Timer = setTimeout(function () {
      Toast({ message: message, duration: duration, position: position });
      Timer = null;
    }, toastObj.lastDuration);
  } else {
    Toast({ message: message, duration: duration, position: position });
    toastObj.toasting = true;
    toastObj.lastDuration = duration;
    setTimeout(function () {
      toastObj.toasting = false;
      toastObj.lastDuration = 0;
    }, duration);
  }
}
window.toast = toast;

__WEBPACK_IMPORTED_MODULE_5_vue__["default"].filter('time', function (timestamp) {
  return new Date(timestamp).toLocaleTimeString();
});

__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_mint_ui___default.a);
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_touch___default.a, { name: 'v-touch' });
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6__components_preview_index__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].component('ScoreLabel', __WEBPACK_IMPORTED_MODULE_7__components_ScoreLabel___default.a);

document.documentElement.style.fontSize = document.documentElement.clientWidth / 18.75 + 'px';

window.app = new __WEBPACK_IMPORTED_MODULE_5_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_16__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_17__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_15__App___default.a }
});

/***/ }),

/***/ 541:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var liveMessages = function liveMessages() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1120));
};
var LiveComments = function LiveComments() {
  return __webpack_require__.e/* import() */(75).then(__webpack_require__.bind(null, 1119));
};

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/info/:liveId/messages',
  name: 'liveMessages',
  component: liveMessages,
  meta: {
    pageTitle: '课堂',
    requiresAuth: true,
    authType: 'user'
  }
}, {
  path: '/info/:liveId/comments',
  name: 'LiveComments',
  component: LiveComments,
  meta: {
    pageTitle: '评价页',
    requiresAuth: true,
    authType: 'user'
  }
}]);

/***/ }),

/***/ 542:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var NormalCourse = function NormalCourse() {
  return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 1147));
};

var SerialDetail = function SerialDetail() {
  return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 1148));
};
var SerialSubInfo = function SerialSubInfo() {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 1126));
};
var XwDetail = function XwDetail() {
  return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 1139));
};
var XwAlbum = function XwAlbum() {
  return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 1138));
};
var XwDetailSub = function XwDetailSub() {
  return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 1140));
};
var VideoDetail = function VideoDetail() {
  return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 1135));
};
var VideoAlbum = function VideoAlbum() {
  return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 1134));
};
var VideoDetailSub = function VideoDetailSub() {
  return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 1136));
};
var FitnessDetail = function FitnessDetail() {
  return __webpack_require__.e/* import() */(49).then(__webpack_require__.bind(null, 1113));
};

var GroupDetail = function GroupDetail() {
  return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 1146));
};
var ColumnDetail = function ColumnDetail() {
  return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 1143));
};
var ChildDetail = function ChildDetail() {
  return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 1157));
};
var ExcelentChild = function ExcelentChild() {
  return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 1144));
};
var FineClassDetail = function FineClassDetail() {
  return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 1145));
};

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/info/:liveId(\\d+)',
  name: 'LiveInfo',
  component: NormalCourse,
  meta: {
    pageTitle: '课程详情',
    isCourse: true,
    requiresAuth: false,
    authType: 'user'
  }
}, {
  path: '/info/:liveId(serial-\\d+)',
  name: 'SerialDetail',
  component: SerialDetail,
  meta: {
    pageTitle: '系列课',
    isCourse: true,
    requiresAuth: false,
    authType: 'user'
  }
}, {
  path: '/info/:liveId(serialsub-\\d+)',
  name: 'SerialSubInfo',
  component: SerialSubInfo,
  meta: {
    pageTitle: '系列课',
    isCourse: true,
    requiresAuth: false,
    authType: 'user'
  }
}, {
  path: '/info/:liveId(xwdetail-\\d+)',
  name: 'XwDetail',
  component: XwDetail,
  meta: {
    pageTitle: '小微课堂',
    isCourse: true,
    requiresAuth: false,
    authType: 'user'
  }
}, {
  path: '/info/:liveId(xwalbum-\\d+)',
  name: 'XwAlbum',
  component: XwAlbum,
  meta: {
    pageTitle: '小微课堂',
    isCourse: true,
    requiresAuth: false,
    authType: 'user'
  }
}, {
  path: '/info/:liveId(xwsub-\\d+)',
  name: 'XwDetailSub',
  component: XwDetailSub,
  meta: {
    pageTitle: '小微课堂',
    isCourse: true,
    requiresAuth: false,
    authType: 'user'
  }
}, {
  path: '/info/:liveId(group-\\d+)',

  name: 'GroupDetail',
  component: GroupDetail,
  meta: {
    pageTitle: '组合课详情',
    isCourse: true,
    requiresAuth: false,
    authType: 'user'
  }
}, {
  path: '/info/:liveId(video-\\d+)',
  name: 'VideoDetail',
  component: VideoDetail,
  meta: {
    pageTitle: '视频课堂',
    isCourse: true,
    requiresAuth: false,
    authType: 'user'
  }
}, {
  path: '/info/:liveId(videoalbum-\\d+)',
  name: 'VideoAlbum',
  component: VideoAlbum,
  meta: {
    pageTitle: '视频课堂',
    isCourse: true,
    requiresAuth: false,
    authType: 'user'
  }
}, {
  path: '/info/:liveId(videosub-\\d+)',
  name: 'VideoDetailSub',
  component: VideoDetailSub,
  meta: {
    pageTitle: '视频课堂',
    isCourse: true,
    requiresAuth: false,
    authType: 'user'
  }
}, {
  path: '/info/:liveId(fit-\\d+)',
  name: 'FitnessDetail',
  component: FitnessDetail,
  meta: {
    pageTitle: '健身课程',
    isCourse: true,
    requiresAuth: false,
    authType: 'user'
  }
}, {
  path: '/info/:liveId(column-\\d+)',
  name: 'ColumnDetail',
  component: ColumnDetail,
  meta: {
    pageTitle: '订阅专栏',
    isCourse: true,
    requiresAuth: false,
    authType: 'user'
  }
}, {
  path: '/info/:liveId(dykdetail-\\d+)',
  name: 'ChildDetail',
  component: ChildDetail,
  meta: {
    pageTitle: '课程详情',
    isCourse: true,
    requiresAuth: false,
    authType: 'user'
  }
}, {
  path: '/info/:liveId(finedetail-\\d+)',

  name: 'FineClassDetail',
  component: FineClassDetail,
  meta: {
    pageTitle: '课程详情',
    isCourse: true,
    requiresAuth: false,
    authType: 'user'
  }
}, {
  path: '/info/:liveId(jpkdetail-\\d+)',
  name: 'ExcelentChild',
  component: ExcelentChild,
  meta: {
    pageTitle: '课程详情',
    isCourse: true,
    requiresAuth: false,
    authType: 'user'
  }
}]);

/***/ }),

/***/ 543:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var Verify = function Verify() {
  return __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, 1149));
};

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/dayimaVerify',
  name: 'dayimaVerify',
  component: Verify,
  meta: {
    pageTitle: '实名认证',
    requiresAuth: true,
    authType: 'user'
  }
}, {
  path: '/dayimaVerify/success',
  name: 'dayimaVerifySuccess',
  component: function component() {
    return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 481));
  },
  meta: {
    pageTitle: '实名认证',
    requiresAuth: false,
    authType: 'user'
  }
}]);

/***/ }),

/***/ 544:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var Home = function Home() {
  return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 1155));
};
var Index = function Index() {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 451));
};
var GroupAlbum = function GroupAlbum() {
  return __webpack_require__.e/* import() */(52).then(__webpack_require__.bind(null, 1115));
};
var SerialList = function SerialList() {
  return __webpack_require__.e/* import() */(58).then(__webpack_require__.bind(null, 1125));
};
var TagsSubjectPage = function TagsSubjectPage() {
  return __webpack_require__.e/* import() */(53).then(__webpack_require__.bind(null, 1127));
};
var FreeClass = function FreeClass() {
  return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 1159));
};
var LamaList = function LamaList() {
  return __webpack_require__.e/* import() */(66).then(__webpack_require__.bind(null, 1118));
};
var HqClass = function HqClass() {
  return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, 1116));
};
var SubscriptionList = function SubscriptionList() {
  return __webpack_require__.e/* import() */(55).then(__webpack_require__.bind(null, 1160));
};
var AuditionList = function AuditionList() {
  return __webpack_require__.e/* import() */(43).then(__webpack_require__.bind(null, 1156));
};
var ColumnList = function ColumnList() {
  return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, 1158));
};
var MemberFreeCourse = function MemberFreeCourse() {
  return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, 1175));
};

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/',
  name: 'home',
  component: Home,
  meta: {
    pageTitle: '精品课',
    requiresAuth: false,
    authType: 'user'
  }
}, {
  path: '/index',
  name: 'index',
  component: Index,
  meta: {
    pageTitle: '开讲',
    requiresAuth: false,
    authType: 'user'
  }
}, {
  path: '/groupalbum',
  name: 'GroupAlbum',
  component: GroupAlbum,
  meta: {
    pageTitle: '组合课',
    requiresAuth: false,
    authType: 'user'
  }
}, {
  path: '/serial/list',
  name: 'SerialList',
  component: SerialList,
  meta: {
    pageTitle: '系列课列表页',
    requiresAuth: false,
    authType: 'user'
  }
}, {
  path: '/tagsSubject/:tagId/:name/:subject',
  name: 'TagsSubjectPage',
  component: TagsSubjectPage,
  meta: {
    pageTitle: '标签聚合页',
    requiresAuth: false
  }
}, {
  path: '/freeClass',
  name: 'FreeClass',
  component: FreeClass,
  meta: {
    pageTitle: '服务',
    requiresAuth: false,
    authType: 'user'
  }
}, {
  path: '/lamaList',
  name: 'lamaList',
  component: LamaList,
  meta: {
    pageTitle: '音频',
    requiresAuth: false,
    authType: 'user'
  }
}, {
  path: '/subscription/list/:liveId',
  name: 'SubscriptionList',
  component: SubscriptionList,
  meta: {
    pageTitle: '订阅专栏',
    requiresAuth: true,
    authType: 'user'
  }
}, {
  path: '/hqClass',
  name: 'hqClass',
  component: HqClass,
  meta: {
    pageTitle: '精品课',
    requiresAuth: false,
    authType: 'user'
  }
}, {
  path: '/columnList',
  name: 'ColumnList',
  component: ColumnList,
  meta: {
    pageTitle: '订阅专栏',
    requiresAuth: false,
    authType: 'user'
  }
}, {
  path: '/auditionList/:liveId',
  name: 'AuditionList',
  component: AuditionList,
  meta: {
    pageTitle: '订阅专栏',
    requiresAuth: false,
    authType: 'user'
  }
}, {
  path: '/member/listen',
  name: 'MemberFreeCourse',
  component: MemberFreeCourse,
  meta: {
    pageTitle: '会员免费听',
    requiresAuth: false,
    authType: 'user'
  }
}]);

/***/ }),

/***/ 545:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var FreeClinicIndex = function FreeClinicIndex() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 1153));
};
var ConsultDetail = function ConsultDetail() {
  return __webpack_require__.e/* import() */(56).then(__webpack_require__.bind(null, 1151));
};
var MyConsult = function MyConsult() {
  return __webpack_require__.e/* import() */(48).then(__webpack_require__.bind(null, 1154));
};
var FreeQuestion = function FreeQuestion() {
  return __webpack_require__.e/* import() */(50).then(__webpack_require__.bind(null, 1152));
};

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/freeClinic/index',
  name: 'FreeClinicIndex',
  meta: {
    pageTitle: '专家答',
    requiresAuth: false },
  component: FreeClinicIndex
}, {
  path: '/freeClinic/consultDetail',
  name: 'consultDetail',
  meta: {
    pageTitle: '专家答',
    requiresAuth: false },
  component: ConsultDetail
}, {
  path: '/freeClinic/freeQuestion/:expertId/:actId',
  name: 'FreeQuestion',
  meta: {
    pageTitle: '问题描述',
    requiresAuth: true,
    authType: 'user' },
  component: FreeQuestion
}, {
  path: '/freeClinic/myRequestion',
  name: 'myRequestion',
  meta: {
    pageTitle: '我的提问',
    requiresAuth: false
  },
  component: MyConsult
}]);

/***/ }),

/***/ 546:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var KnowingIndex = function KnowingIndex() {
  return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, 1163));
};
var KnowingReceive = function KnowingReceive() {
  return __webpack_require__.e/* import() */(61).then(__webpack_require__.bind(null, 1164));
};
var KnowingDetail = function KnowingDetail() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 1162));
};

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/knowing/receive/:weeklyId(weeklyId-\\d+)/:shareCode(shareCode-\\S+)',
  name: 'knowingReceive',
  meta: {
    pageTitle: '孕育周知',
    requiresAuth: false },
  component: KnowingReceive
}, {
  path: '/knowing/detail/:weeklyId(weeklyId-\\d+)',
  name: 'knowingDetail',
  meta: {
    pageTitle: '孕育周知',
    requiresAuth: false },
  component: KnowingDetail
}, {
  path: '/knowing/rights',
  name: 'knowingRights',
  meta: {
    pageTitle: '孕育周知',
    desc: '免费领取',
    requiresAuth: true },
  component: function component() {
    return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 480));
  }
}, {
  path: '/knowing/coupon',
  name: 'knowingCoupon',
  meta: {
    pageTitle: '孕育周知',
    desc: '我要兑换',
    requiresAuth: true },
  component: function component() {
    return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 480));
  }
}, {
  path: '/knowing/index',
  name: 'knowingIndex',
  meta: {
    pageTitle: '孕育周知',
    requiresAuth: false },
  component: KnowingIndex
}]);

/***/ }),

/***/ 547:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/lighthouse',
  name: 'lighthouse',
  meta: {
    pageTitle: '树学院',
    requiresAuth: true },
  component: function component() {
    return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, 1169));
  }
}, {
  path: '/lighthouse/income',
  name: 'lighthouseIncome',
  meta: {
    pageTitle: '我的收益',
    requiresAuth: true },
  component: function component() {
    return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 1170));
  }
}, {
  path: '/lighthouse/detail/:courseId(\\d+)',
  name: 'lightDetail',
  meta: {
    pageTitle: '课程详情',
    requiresAuth: true },
  component: function component() {
    return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 1168));
  }
}, {
  path: '/lighthouse/classRoom',
  name: 'lighthouseClassRoom',
  meta: {
    pageTitle: '我的课堂',
    requiresAuth: true },
  component: function component() {
    return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 1166));
  }
}, {
  path: '/lighthouse/listenIndex/:courseId(\\d+)',
  name: 'listenIndex',
  meta: {
    pageTitle: '听课首页',
    requiresAuth: true },
  component: function component() {
    return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 1171));
  }
}, {
  path: '/lighthouse/selection/:courseId(\\d+)',
  name: 'lighthouseSelection',
  meta: {
    pageTitle: '课程选集',
    requiresAuth: true },
  component: function component() {
    return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 1173));
  }
}, {
  path: '/lighthouse/coupon',
  name: 'lighthouseCoupon',
  meta: {
    pageTitle: '优惠券',
    requiresAuth: true },
  component: function component() {
    return __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, 1167));
  }
}, {
  path: '/lighthouse/uc',
  name: 'lighthouseUc',
  meta: {
    pageTitle: '个人中心',
    requiresAuth: true },
  component: function component() {
    return __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, 1174));
  }
}, {
  path: '/lighthouse/my',
  name: 'lighthouseMy',
  meta: {
    pageTitle: '我的订单',
    requiresAuth: true },
  component: function component() {
    return __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, 1172));
  }
}]);

/***/ }),

/***/ 548:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var AboutLive = function AboutLive() {
  return __webpack_require__.e/* import() */(80).then(__webpack_require__.bind(null, 1109));
};
var Tags = function Tags() {
  return __webpack_require__.e/* import() */(54).then(__webpack_require__.bind(null, 1111));
};
var CouponsRule = function CouponsRule() {
  return __webpack_require__.e/* import() */(78).then(__webpack_require__.bind(null, 1112));
};
var GlutesRule = function GlutesRule() {
  return __webpack_require__.e/* import() */(77).then(__webpack_require__.bind(null, 1114));
};
var Cashier = function Cashier() {
  return __webpack_require__.e/* import() */(82).then(__webpack_require__.bind(null, 1141));
};
var UpdateTip = function UpdateTip() {
  return __webpack_require__.e/* import() */(71).then(__webpack_require__.bind(null, 1130));
};
var TreeCoin = function TreeCoin() {
  return __webpack_require__.e/* import() */(63).then(__webpack_require__.bind(null, 1129));
};
var TreeBalance = function TreeBalance() {
  return __webpack_require__.e/* import() */(73).then(__webpack_require__.bind(null, 1128));
};
var Questions = function Questions() {
  return __webpack_require__.e/* import() */(74).then(__webpack_require__.bind(null, 1124));
};
var WxError = function WxError() {
  return __webpack_require__.e/* import() */(72).then(__webpack_require__.bind(null, 1137));
};
var WriteMessage = function WriteMessage() {
  return __webpack_require__.e/* import() */(47).then(__webpack_require__.bind(null, 1161));
};
var InviteRule = function InviteRule() {
  return __webpack_require__.e/* import() */(76).then(__webpack_require__.bind(null, 1117));
};
var EvaluationList = function EvaluationList() {
  return __webpack_require__.e/* import() */(46).then(__webpack_require__.bind(null, 1150));
};
var Channel = function Channel() {
  return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 1142));
};
var Leaderboard = function Leaderboard() {
  return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, 1165));
};
var WyethCourse = function WyethCourse() {
  return __webpack_require__.e/* import() */(57).then(__webpack_require__.bind(null, 1189));
};

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/aboutLive',
  name: 'aboutLive',
  meta: {
    pageTitle: '关于开讲',
    requiresAuth: false },
  component: AboutLive
}, {
  path: '/couponsRule',
  name: 'couponsRule',
  meta: {
    pageTitle: '规则说明',
    requiresAuth: false },
  component: CouponsRule
}, {
  path: '/glutesRule',
  name: 'glutesRule',
  meta: {
    pageTitle: '规则说明',
    requiresAuth: false },
  component: GlutesRule
}, {
  path: '/inviteRule',
  name: 'InviteRule',
  meta: {
    pageTitle: '课程邀请规则',
    requiresAuth: false },
  component: InviteRule
}, {
  path: '/info/:payType(weixin)',
  name: 'cashier',
  component: Cashier,
  meta: {
    pageTitle: '收银台',
    requiresAuth: false,
    authType: 'user',
    isCourse: true }
}, {
  path: '/extra/updatetip',
  name: 'UpdateTip',
  meta: {
    pageTitle: '升级提醒',
    requiresAuth: false },
  component: UpdateTip
}, {
  path: '/treeCoin',
  name: 'TreeCoin',
  component: TreeCoin,
  meta: {
    pageTitle: '树币',
    requiresAuth: true,
    authType: 'user'
  }
}, {
  path: '/treeBalance',
  name: 'TreeBalance',
  component: TreeBalance,
  meta: {
    pageTitle: '树币余额',
    requiresAuth: true,
    authType: 'user'
  }
}, {
  path: '/treeCoin/list',
  name: 'TreeCoinList',
  component: TreeCoin,
  meta: {
    pageTitle: '树币',
    requiresAuth: true,
    authType: 'user'
  }
}, {
  path: '/normalQuestions',
  name: 'questionsPage',
  component: Questions
}, {
  path: '/tags/:tagId/:name',
  name: 'TagsPage',
  component: Tags,
  meta: {
    pageTitle: '标签页',
    requiresAuth: false
  }
}, {
  path: '/getWxError',
  name: 'errorPage',
  component: WxError
}, {
  path: '/writeMessage/:liveId',
  name: 'WriteMessage',
  component: WriteMessage,
  meta: {
    pageTitle: '写留言',
    requiresAuth: true,
    authType: 'user'
  }
}, {
  path: '/evaluation/list',
  name: 'EvaluationList',
  component: EvaluationList,
  meta: {
    pageTitle: '课程评价',
    requiresAuth: false
  }
}, {
  path: '/channel/:channelId',
  name: 'Channel',
  component: Channel,
  meta: {
    pageTitle: '频道页',
    requiresAuth: false
  }
}, {
  path: '/leaderboard',
  name: 'Leaderboard',
  component: Leaderboard,
  meta: {
    pageTitle: '宝妈都在学',
    requiresAuth: false
  }
}, {
  path: '/wyethCourse',
  name: 'WyethCourse',
  component: WyethCourse,
  meta: {
    pageTitle: '精品课程',
    requiresAuth: false
  }
}]);

/***/ }),

/***/ 549:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var SeriesCourse = function SeriesCourse() {
  return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 1183));
};
var ClockCalender = function ClockCalender() {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 1176));
};
var Detail = function Detail() {
  return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 1177));
};
var Success = function Success() {
  return __webpack_require__.e/* import() */(68).then(__webpack_require__.bind(null, 1182));
};
var ScholarshipsIndex = function ScholarshipsIndex() {
  return __webpack_require__.e/* import() */(42).then(__webpack_require__.bind(null, 1178));
};
var MyScholarships = function MyScholarships() {
  return __webpack_require__.e/* import() */(62).then(__webpack_require__.bind(null, 1181));
};
var VerifiedStatus = function VerifiedStatus() {
  return __webpack_require__.e/* import() */(70).then(__webpack_require__.bind(null, 1185));
};
var Verified = function Verified() {
  return __webpack_require__.e/* import() */(45).then(__webpack_require__.bind(null, 1184));
};
var VerifiedSuccess = function VerifiedSuccess() {
  return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 481));
};
var Like = function Like() {
  return __webpack_require__.e/* import() */(51).then(__webpack_require__.bind(null, 1179));
};
var MediaCourse = function MediaCourse() {
  return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 1180));
};

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/scholarships/index',
  name: 'ScholarshipsIndex',
  meta: {
    pageTitle: '奖学金计划',
    requiresAuth: false },
  component: ScholarshipsIndex
}, {
  path: '/scholarships/myScholarships',
  name: 'MyScholarships',
  meta: {
    pageTitle: '我的奖学金计划',
    requiresAuth: true,
    authType: 'user' },
  component: MyScholarships
}, {
  path: '/scholarships/verifiedStatus',
  name: 'VerifiedStatus',
  meta: {
    pageTitle: '实名认证',
    requiresAuth: true,
    authType: 'user' },
  component: VerifiedStatus
}, {
  path: '/scholarships/verified',
  name: 'Verified',
  meta: {
    pageTitle: '实名认证',
    requiresAuth: true,
    authType: 'user' },
  component: Verified
}, {
  path: '/scholarships/verifiedSuccess',
  name: 'VerifiedSuccess',
  meta: {
    pageTitle: '实名认证',
    requiresAuth: false,
    authType: 'user' },
  component: VerifiedSuccess
}, {
  path: '/scholarships/series/:planId(planId-\\d+)/:liveId(courseId-\\d+)',
  name: 'seriesCourse',
  meta: {
    pageTitle: '奖学金系列课',
    requiresAuth: false
  },
  component: SeriesCourse
}, {
  path: '/scholarships/clockCalender/:activityid',
  name: 'clockCalender',
  meta: {
    pageTitle: '打卡日历',
    requiresAuth: false
  },
  component: ClockCalender
}, {
  path: '/scholarships/detail/:id',
  name: 'detail',
  meta: {
    pageTitle: '奖学金',
    requiresAuth: false },
  component: Detail
}, {
  path: '/scholarships/success',
  name: 'success',
  meta: {
    pageTitle: '支付成功',
    requiresAuth: false },
  component: Success
}, {
  path: '/scholarships/like/:planId(\\d+)/:recordId(\\d+)',
  name: 'like',
  meta: {
    pageTitle: '解锁复活卡',
    requiresAuth: true,
    authType: 'user' },
  component: Like
}, {
  path: '/scholarships/course/:liveId',
  name: 'MediaCourse',
  meta: {
    pageTitle: '课程详情',
    requiresAuth: false },
  redirect: function redirect(to) {
    return { name: 'MediaCourseNew', params: { activityId: to.query.activityId, liveId: to.params.liveId }, query: { parentid: to.query.parentid } };
  }
}, {
  path: '/scholarships/course/:activityId/:liveId',
  name: 'MediaCourseNew',
  meta: {
    pageTitle: '课程详情',
    requiresAuth: false },
  component: MediaCourse
}]);

/***/ }),

/***/ 550:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AdTip',
  data: function data() {
    return {
      show: true,
      isExpert: this.$route.name === 'ExpertLiveInfo'
    };
  },

  computed: {
    showAd: function showAd() {
      return this.$route.query.channel_from === 'zibizheng';
    },
    msg: function msg() {
      return this.showAd ? '90%的妈妈正在使用' : '下载APP 享受更好的听课体验';
    },
    down: function down() {
      return this.showAd ? 'http://r.babytree.com/huDqwSn' : 'https://m.babytree.com/community/intro.php?refcode=app_dajingkang_170410';
    }
  },
  methods: {
    close: function close() {
      this.show = false;
    },
    download: function download() {
      var _this = this;

      setTimeout(function () {
        location.href = _this.down;
      }, 200);
    }
  }
});

/***/ }),

/***/ 551:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'GoTop',
  data: function data() {
    return {
      show: false
    };
  },

  props: ['trackInfo'],
  watch: {
    show: function show() {}
  },
  mounted: function mounted() {
    var _this = this;

    var scrolltop = document.documentElement.scrollTop || document.body.scrollTop;
    this.show = scrolltop > document.body.clientHeight;
    window.onscroll = function () {
      scrolltop = document.documentElement.scrollTop || document.body.scrollTop;
      if (scrolltop > document.body.clientHeight) {
        _this.show = true;
      } else {
        _this.show = false;
      }
    };
  },

  methods: {
    goTop: function goTop() {
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      this.show = false;
      if (this.trackInfo) {
        window.Track.doPublicTracker(2, {
          url: this.trackInfo.url,
          trackerCode: this.trackInfo.trackerCode,
          href: this.trackInfo.be
        });
      }
    }
  }
});

/***/ }),

/***/ 552:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AdTip__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AdTip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_AdTip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_auth__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_cookie__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_ua__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mint_ui__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_mint_ui__);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Header',
  components: { AdTip: __WEBPACK_IMPORTED_MODULE_1__components_AdTip___default.a },
  props: {
    title: {
      type: String
    },
    backTrack: {
      type: String
    },
    homeTrack: {
      type: String
    },
    showHomeBtn: {
      type: Boolean
    },
    showUserBtn: {
      default: null
    },
    showBrokerBtn: {
      type: Boolean,
      default: false
    },
    showSubmitBtn: {
      type: Boolean,
      default: false
    },
    page: {
      type: String
    },
    backUrl: String,
    showBack: {
      type: Boolean,
      default: true
    },
    showShare: {
      type: Boolean,
      default: false
    },
    shareTrack: {
      type: String
    }
  },
  data: function data() {
    return {
      uid: null,
      canScroll: false,
      shareMask: null,
      showMask: false,
      showPrice: true,
      currentTrack: {},
      track: [{
        type: 15,
        dsp: 'djk-dy-lessons_Share_dsp',
        click: 'djk-dy-lessons_Share_click',
        source: 'djk-dy-lessons_UserSource'
      }, {
        type: 17,
        dsp: 'djk-jp-lessons_Share_dsp',
        click: 'djk-jp-lessons_Share_click',
        source: 'djk-jp-lessons_UserSource'
      }, {
        type: 6,
        dsp: 'djk-kj-combined-new_Share_dsp',
        click: 'djk-kj-combined-new_Share_click',
        source: 'djk-kj-combined-new_UserSource'
      }, {
        type: 7,
        dsp: 'djk-kj-combined-new_Share_dsp',
        click: 'djk-kj-combined-new_Share_click',
        source: 'djk-kj-combined-new_Share_click'
      }, {
        type: 8,
        dsp: 'djk-kj-combined-new_Share_dsp',
        click: 'djk-kj-combined-new_Share_click',
        source: 'djk-kj-combined-new_Share_click'
      }, {
        type: 0,
        dsp: 'djk-kj-lessons-new_Share_dsp',
        click: 'djk-kj-lessons-new_Share_click',
        source: 'djk-kj-lessons-new_UserSource'
      }, {
        type: 1,
        dsp: 'djk-kj-serieslesson-new_Share_dsp',
        click: 'djk-kj-serieslesson-new_Share_click',
        source: 'djk-kj-serieslesson-new_UserSource'
      }, {
        type: 10,
        dsp: 'djk-sp-lessons_Share_dsp',
        click: 'djk-sp-lessons_Share_click',
        source: 'djk-sp-lessons_UserSource'
      }, {
        type: 9,
        dsp: 'djk-sp-medias_Share_dsp',
        click: 'djk-sp-medias_Share_click',
        source: 'djk-sp-medias_UserSource'
      }, {
        type: 4,
        dsp: 'djk-wk-lessons_Share_dsp',
        click: 'djk-wk-lessons_Share_click',
        source: 'djk-wk-lessons_UserSource'
      }, {
        type: 3,
        dsp: 'djk-wk-medias_Share_dsp',
        click: 'djk-wk-medias_Share_click',
        source: 'djk-wk-medias_UserSource'
      }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])({
    courseInfo: 'courseInfo',
    newCourseInfo: 'newCourseInfo',
    userInfo: 'userInfo'
  }), {
    getLiveId: function getLiveId() {
      return this.$route.params.liveId ? parseInt(this.$route.params.liveId.toString().substring(String(this.$route.params.liveId).indexOf('-') + 1), 10) : 0;
    },
    course: function course() {
      if (this.newCourseInfo && this.newCourseInfo.id === this.getLiveId) {
        return this.newCourseInfo;
      }
      return this.courseInfo;
    },
    isFenXiao: function isFenXiao() {
      if (this.$route.query.hideHeaderRight) {
        return false;
      }
      return this.showBrokerBtn && this.course && this.course.distribution === 1;
    },
    showUser: function showUser() {
      if (this.$route.query.hideHeaderRight) {
        return false;
      }
      if (typeof this.showUserBtn === 'boolean') {
        return this.showUserBtn;
      } else if (!this.showUserBtn) {
        return !this.isFenXiao;
      }
      return Boolean(this.showUserBtn);
    },
    showHome: function showHome() {
      if (this.$route.query.hideHeaderHome) {
        return false;
      }
      return this.showHomeBtn;
    },
    nowTrack: function nowTrack() {
      var _this = this;

      var obj = void 0;
      if (this.course.type >= 0) {
        this.track.map(function (item) {
          if (_this.course.type === item.type) {
            obj = item;
          }
          return null;
        });
      }
      return obj;
    }
  }),
  created: function created() {
    var _this2 = this;

    this.uid = this.$route.query.uid;
    window.addEventListener('scroll', function () {
      _this2.showPrice = false;
    });
    this.controlPrice();
    setTimeout(function () {
      if (_this2.nowTrack) {
        console.log(_this2.nowTrack);
        window.Tracking.initTrackUrl(2, _this2.nowTrack.dsp, 'lessons_id=' + _this2.course.id);
        if (__WEBPACK_IMPORTED_MODULE_5__lib_ua__["a" /* browser */].qq) {
          window.Tracking.initTrackUrl(2, _this2.nowTrack.source, 'SharingChannel=0');
        }
        if (__WEBPACK_IMPORTED_MODULE_5__lib_ua__["a" /* browser */].wx) {
          window.Tracking.initTrackUrl(2, _this2.nowTrack.source, 'SharingChannel=1');
        }
      }
    }, 1000);
  },

  methods: {
    back: function back() {
      if (this.page === 'xwdetail' || this.page === 'xwsub') {
        this.$emit('headerPauseAudio');
      }
      this.$emit('backTrackFunc');
      this.$emit('trackFunc', 'back');
      if (this.backUrl) {
        location.href = this.backUrl;
      } else {
        var isApp = __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.get('MT_USER_INFO') ? Boolean(__WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.get('MT_USER_INFO')) : false;
        if (isApp) {
          if (window.MT) {
            window.MT.tryBackToNativePage();
          } else {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_mint_ui__["MessageBox"])({
              message: '网页未加载完毕，是否刷新重试',
              showCancelButton: true,
              confirmButtonText: '刷新',
              cancelButtonText: '取消'
            }).then(function (action) {
              if (action === 'confirm') {
                location.reload();
              }
            });
          }
        } else {
          this.$router.go(-1);
        }
      }
    },
    goMy: function goMy() {
      if (this.page === 'xwdetail' || this.page === 'xwsub') {
        this.$emit('headerPauseAudio');
      }

      this.$router.push({ name: 'UserLive' });
    },
    goHome: function goHome() {
      if (this.page === 'xwdetail' || this.page === 'xwsub') {
        this.$emit('headerPauseAudio');
      }
      if (this.$route.name === 'MediaCourseNew') {
        this.$router.push({ name: 'detail', params: { id: this.$route.params.activityId } });
        return;
      }

      this.$router.push({ name: 'home' });
    },
    bindSubmit: function bindSubmit() {
      this.$emit('bindSubmit');
    },
    goBroker: function goBroker() {
      var _this3 = this;

      if (!__WEBPACK_IMPORTED_MODULE_3__lib_auth__["a" /* default */].check('user')) {
        __WEBPACK_IMPORTED_MODULE_3__lib_auth__["a" /* default */].login('user', this.$route.query.code);
        return;
      }

      if (this.userInfo && Number(this.userInfo.isHaveMobile) === 0) {
        this.$router.push({ name: 'UserBinding' });
        return;
      }
      if (!this.shareMask) {
        window.Tracking.initTrackUrl(2, this.nowTrack.click, 'lessons_id=' + this.course.id);
        this.$store.dispatch('getShareImage', {
          id: this.course.id,
          pid: this.course.serialCourse ? this.course.serialCourse.id : null
        }).then(function (shareData) {
          _this3.shareMask = shareData.shareUrl;
          _this3.showMask = true;
        });
      } else {
        this.showMask = true;
      }
    },
    hideMask: function hideMask(e) {
      if (e.target.className !== 'fenxiao-image') {
        this.showMask = false;
      }
    },
    controlPrice: function controlPrice() {
      var _this4 = this;

      document.onclick = function (e) {
        if (e.target.className !== 'explain') {
          _this4.showPrice = false;
        }
      };
    },
    bindShare: function bindShare() {
      this.$emit('bindShare', 'header');
    }
  }
});

/***/ }),

/***/ 553:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ScoreLabel',
  data: function data() {
    return {};
  },

  computed: {
    desc: function desc() {
      return this.type === 'detail' ? this.data.zhDetailDesc : this.data.zhListDesc;
    }
  },
  props: ['data', 'type'],
  methods: {},
  create: function create() {
    if (this.type === 'detail') {
      document.querySelector('.price del').style.display = 'inline-block';
    }
  },
  mounted: function mounted() {
    if (document.querySelector('.price del') && this.data) {
      if (this.type === 'detail' && this.data) {
        document.querySelector('.price del').style.display = 'none';
      } else {
        document.querySelector('.price del').style.display = 'inline-block';
      }
    }
  },

  watch: {
    data: function data() {
      if (document.querySelector('.price del') && this.data) {
        if (this.type === 'detail' && this.data) {
          document.querySelector('.price del').style.display = 'none';
        } else {
          document.querySelector('.price del').style.display = 'inline-block';
        }
      }
    }
  }
});

/***/ }),

/***/ 554:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_photoswipe_dist_photoswipe__ = __webpack_require__(978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_photoswipe_dist_photoswipe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_photoswipe_dist_photoswipe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_photoswipe_dist_photoswipe_ui_default__ = __webpack_require__(977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_photoswipe_dist_photoswipe_ui_default___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_photoswipe_dist_photoswipe_ui_default__);






/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {
    open: function open(index, list) {
      var _this = this;

      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        captionEl: false,
        fullscreenEl: false,
        history: false,
        shareEl: false,
        tapToClose: true
      };

      var options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
        index: index,
        getThumbBoundsFn: function getThumbBoundsFn(index1) {
          var thumbnail = document.querySelectorAll('.preview-img')[index1];
          var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
          var rect = thumbnail.getBoundingClientRect();
          console.log(rect);
          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        }
      }, params);

      this.photoswipe = new __WEBPACK_IMPORTED_MODULE_1_photoswipe_dist_photoswipe___default.a(this.$el, __WEBPACK_IMPORTED_MODULE_2_photoswipe_dist_photoswipe_ui_default___default.a, list, options);

      this.photoswipe.listen('gettingData', function (index2, item) {
        if (item.w < 1 || item.h < 1) {
          var self = _this;
          var img = new Image();
          img.onload = function onload() {
            item.w = this.width;
            item.h = this.height;
            self.photoswipe.invalidateCurrItems();
            self.photoswipe.updateSize(true);
          };
          img.src = item.src;
        }
      });
      this.photoswipe.init();
    },
    close: function close() {
      this.photoswipe.close();
    }
  }
});

/***/ }),

/***/ 576:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_ua__ = __webpack_require__(32);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    error: 'error'
  })),
  watch: {
    $route: function $route() {
      if (window.performance.mark) {
        window.performance.mark('router');
      }
      if (this.$route.meta.authType === 'user' && __WEBPACK_IMPORTED_MODULE_2__lib_ua__["a" /* browser */].wx) {
        this.$store.dispatch('wxSign', {
          url: encodeURI(location.origin + '/live' + this.$route.fullPath)
        });
      }
    }
  }

});

/***/ }),

/***/ 577:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Loading__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_GoTop__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_GoTop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_GoTop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_AdTip__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_AdTip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_AdTip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mint_ui__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Header__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_report__ = __webpack_require__(468);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'HomePage',
  components: { Loading: __WEBPACK_IMPORTED_MODULE_2__components_Loading___default.a, Swipe: __WEBPACK_IMPORTED_MODULE_5_mint_ui__["Swipe"], SwipeItem: __WEBPACK_IMPORTED_MODULE_5_mint_ui__["SwipeItem"], HeaderTpl: __WEBPACK_IMPORTED_MODULE_6__components_Header___default.a, GoTop: __WEBPACK_IMPORTED_MODULE_3__components_GoTop___default.a, AdTip: __WEBPACK_IMPORTED_MODULE_4__components_AdTip___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_report__["a" /* default */]],
  data: function data() {
    return {
      currentCatagoryId: null,
      canScroll: false,
      startStatus: null,
      nextPageNum: null,
      timer: null,
      delay: 0,
      showNavBox: false,
      error: false,
      DOREPORT: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    isLoading: 'isLoading',
    catagoryList: 'catagoryList',
    advertList: 'advertList',
    courseList: 'indexCourseList',
    indexCourseObj: 'indexCourseObj',
    userInfo: 'userInfo',
    errors: 'error',
    isLoading1: 'isLoading'
  }), {
    isBottom: function isBottom() {
      return typeof this.startStatus === 'undefined';
    },
    canBack: function canBack() {
      return window.history.length > 0;
    }
  }),
  created: function created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  mounted: function mounted() {
    this.initPage(true);
  },
  destroyed: function destroyed() {
    this.clearIntervals();
    window.removeEventListener('scroll', this.handleScroll);
  },

  watch: {
    currentCatagoryId: function currentCatagoryId() {
      if (this.currentCatagoryId !== null) {
        this.$store.dispatch('getIndexList', {
          catagoryId: this.currentCatagoryId,
          newPage: true
        });
      }
    },

    catagoryList: {
      handler: function handler() {
        var _this = this;

        this.DOREPORT = true;
        this.$nextTick(function () {
          if (_this.$route.query.category) {
            _this.catagoryList.forEach(function (item, index) {
              if (Number(item.id) === Number(_this.$route.query.category)) {
                _this.switchTab(item, index);
              }
            });
          } else if (!_this.currentCatagoryId) {
            _this.currentCatagoryId = _this.catagoryList[0].id;
          }
        });
      }
    },
    indexCourseObj: function indexCourseObj() {
      this.updateData();
      this.startStatus = this.indexCourseObj.startStatus;
      this.nextPageNum = this.indexCourseObj.nextPageNum;
    },

    userInfo: {
      handler: function handler() {
        this.initPage(true);
        location.hash = location.hash.split('?')[0];
      },

      deep: true
    }
  },
  methods: {
    initPage: function initPage(reload) {
      if (this.courseList && this.courseList.length < 1 || reload) {
        this.currentCatagoryId = null;
        this.$store.dispatch('getCatagory');
      }
      this.updateData();
      this.startStatus = this.indexCourseObj.startStatus;
      this.nextPageNum = this.indexCourseObj.nextPageNum;
    },
    handleScroll: function handleScroll() {
      var _this2 = this;

      if (this.canScroll) {
        return;
      }
      this.canScroll = true;
      setTimeout(function () {
        _this2.canScroll = false;
        var scrollTop = document.body.scrollTop + document.documentElement.scrollTop;
        var scrollHeight = document.body.scrollHeight;
        var clientHeight = document.documentElement.clientHeight;
        if (scrollHeight - scrollTop < clientHeight * 1.5) {
          _this2.getNextPage();
        }
      }, 800);
    },
    getNextPage: function getNextPage() {
      console.log(this.startStatus, this.nextPageNum, this.indexCourseObj);
      if (typeof this.startStatus !== 'undefined') {
        this.$store.dispatch('getIndexList', {
          catagoryId: this.currentCatagoryId,
          startStatus: this.startStatus,
          curpage: this.nextPageNum,
          newPage: false
        });
      }
    },
    switchTab: function switchTab(item, index) {
      this.currentCatagoryId = item.id;
      this.showNavBox = false;
      var target = document.querySelectorAll('.nav-item')[index];
      var offset = target.offsetLeft - document.querySelector('.nav-list').scrollLeft;
      console.log(offset);
      if (offset > 190 || offset < 0) {
        document.querySelector('.nav-list').scrollLeft = target.offsetLeft - 50;
      }
    },
    clearIntervals: function clearIntervals() {
      if (this.timer) {
        clearInterval(this.timer);
      }
    },
    showTime: function showTime(index, course, i) {
      var startDate = new Date(course.startTime);
      this.courseList[index].list[i].start = startDate.getHours() + ':' + startDate.getMinutes();

      if (course.startTime - course.currentTime <= 86400 * 1000) {} else if (course.startTime - course.currentTime > 86400 * 1000) {
        this.courseList[index].list[i].time = this.formatTime(course);
      }
    },
    renderTime: function renderTime(timestamp) {
      var h = 0,
          m = 0,
          s = 0;

      s = parseInt(timestamp % 60, 10);
      m = parseInt(timestamp / 60, 10);
      if (m > 60) {
        h = parseInt(m / 60, 10);
        m %= 60;
      }
      return this.toZero(h) + ':' + this.toZero(m) + ':' + this.toZero(s);
    },
    formatTime: function formatTime(course) {
      var month = this.toZero(new Date(course.startTime).getMonth() + 1);
      var date = this.toZero(new Date(course.startTime).getDate());
      var hour = this.toZero(new Date(course.startTime).getHours());
      var minte = this.toZero(new Date(course.startTime).getMinutes());
      return month + '\u6708' + date + '\u65E5 ' + hour + ':' + minte;
    },
    toZero: function toZero(num) {
      if (num < 10) {
        num = '0' + num;
      }
      return num;
    },
    updateData: function updateData() {
      var _this3 = this;

      this.clearIntervals();
      this.courseList.forEach(function (list, index) {
        if (list.startStatus === 0 && list.list.length > 0) {
          list.list.forEach(function (course, i) {
            _this3.showTime(index, course, i);
          });
          _this3.countdown(list.list, index);
        }
      });
    },
    countdown: function countdown(list, index) {
      var _this4 = this;

      if (list.length > 0) {
        this.delay = Date.parse(new Date()) - list[0].currentTime;
      }
      this.timer = setInterval(function () {
        var now = Date.parse(new Date());
        list.forEach(function (course, i) {
          var text = '00:00:00';
          if (course.startTime - now <= 86400 * 1000) {
            if (now - _this4.delay < course.startTime) {
              text = _this4.renderTime((course.startTime - now + _this4.delay) / 1000);
            }
          }
          _this4.$set(_this4.courseList[index].list[i], 'countTime', text);
        });
      }, 1000);
    },
    goToClass: function goToClass(item) {
      if (item.price > 0 && this.userInfo.token) {
        if (!item.join) {
          this.$router.push({ name: 'LiveInfo', params: { liveId: item.id } });
        } else if (item.join && item.startStatus === 1) {
          this.$router.push({ name: 'liveMessages', params: { liveId: item.id } });
        } else if (item.join && (item.startStatus === 0 || item.startStatus === 2)) {
          this.$router.push({ name: 'LiveInfo', params: { liveId: item.id } });
        }
      } else if (item.price === 0 && this.userInfo.token) {
        if (!item.join) {
          this.$router.push({ name: 'LiveInfo', params: { liveId: item.id } });
        } else if (item.join && item.startStatus === 1) {
          this.$router.push({ name: 'liveMessages', params: { liveId: item.id } });
        } else if (item.join && (item.startStatus === 0 || item.startStatus === 2)) {
          this.$router.push({ name: 'LiveInfo', params: { liveId: item.id } });
        }
      } else {
        this.$router.push({ name: 'LiveInfo', params: { liveId: item.id } });
      }

      if (item.startStatus === 2) {
        window.Tracking.initTrackUrl(2, 'djk-kj-home_lessons_over_click', '');
      } else if (item.startStatus === 1) {
        window.Tracking.initTrackUrl(2, 'djk-kj-home_lessons_ing_click', '');
      } else if (item.startStatus === 0) {
        window.Tracking.initTrackUrl(2, 'djk-kj-home_lessons_ready_click', '');
      }
    }
  }
});

/***/ }),

/***/ 58:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return os; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return util; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_ua__ = __webpack_require__(32);




var os = {
  isInWx: function isInWx() {
    return navigator.userAgent.toLowerCase().match(/MicroMessenger/i) !== null;
  },
  isWeiBo: function isWeiBo() {
    return navigator.userAgent.toLowerCase().match(/Weibo/i) !== null;
  },
  isInAPP: function isInAPP() {
    return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('MT_USER_INFO') !== undefined;
  },
  isInH5: function isInH5() {
    return !this.isInAPP() && !this.isInWx();
  }
};

var util = {
  secondFormat: function secondFormat(second, type) {
    var seconds = util.fillNumber(second % 60);
    var minutes = util.fillNumber(parseInt(second / 60, 10));
    var result = '';
    switch (type) {
      case 'MM:SS':
        result = minutes + ':' + seconds;
        break;
    }
    return result;
  },
  dateFormat: function dateFormat(numbers, type) {
    if (!numbers) {
      numbers = new Date().getTime();
    }
    var date = new Date(Number(numbers));
    var year = date.getFullYear();
    var month = util.fillNumber(date.getMonth() + 1);
    var day = util.fillNumber(date.getDate());
    var hours = util.fillNumber(date.getHours());
    var minutes = util.fillNumber(date.getMinutes());
    var seconds = util.fillNumber(date.getSeconds());
    var result = '';
    switch (type) {
      case 'YYYY年MM月DD日':
        result = year + '\u5E74' + month + '\u6708' + day + '\u65E5';
        break;
      case 'MM月DD日 HH:MM':
        result = month + '\u6708' + day + ' ' + hours + ':' + minutes;
        break;
      case 'HH:MM':
        result = hours + ':' + minutes;
        break;
      case 'YYYY/MM/DD':
        result = year + '/' + month + '/' + day;
        break;
      default:
        result = month + '\u6708' + day + ' ' + hours + ':' + minutes;
        break;
    }
    return result;
  },
  fillNumber: function fillNumber(number) {
    if (number < 0) {
      number = 0;
    }
    return number > 9 ? number : '0' + number;
  },
  base64Decode: function base64Decode(str) {
    var c1, c2, c3, c4;
    var base64DecodeChars = new Array(-1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 62, -1, -1, -1, 63, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, -1, -1, -1, -1, -1, -1, -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, -1, -1, -1, -1, -1, -1, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, -1, -1, -1, -1, -1);
    var i = 0,
        len = str.length,
        string = '';

    while (i < len) {
      do {
        c1 = base64DecodeChars[str.charCodeAt(i++) & 0xff];
      } while (i < len && c1 == -1);

      if (c1 == -1) break;

      do {
        c2 = base64DecodeChars[str.charCodeAt(i++) & 0xff];
      } while (i < len && c2 == -1);

      if (c2 == -1) break;

      string += String.fromCharCode(c1 << 2 | (c2 & 0x30) >> 4);

      do {
        c3 = str.charCodeAt(i++) & 0xff;
        if (c3 == 61) return string;

        c3 = base64DecodeChars[c3];
      } while (i < len && c3 == -1);

      if (c3 == -1) break;

      string += String.fromCharCode((c2 & 0XF) << 4 | (c3 & 0x3C) >> 2);

      do {
        c4 = str.charCodeAt(i++) & 0xff;
        if (c4 == 61) return string;
        c4 = base64DecodeChars[c4];
      } while (i < len && c4 == -1);

      if (c4 == -1) break;

      string += String.fromCharCode((c3 & 0x03) << 6 | c4);
    }
    return string;
  },
  fomartDuration: function fomartDuration(second) {
    if (second > 60) {
      var s = second % 60;
      var m = parseInt(second / 60, 10);

      if (m > 60) {
        var h = parseInt(m / 60, 10);
        m = parseInt(second / 60, 10) % 60;
        if (h < 10) {
          h = '0' + m;
        }
        if (m < 10) {
          m = '0' + m;
        }
        if (s < 10) {
          s = '0' + s;
        }
        return h + ' : ' + m + ' : ' + s;
      }
      if (m < 10) {
        m = '0' + m;
      }
      if (s < 10) {
        s = '0' + s;
      }
      return m + ':' + s;
    }
    return second + 's';
  },
  getMTVersion: function getMTVersion() {
    var mtui = __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('MT_USER_INFO') || '';
    var fck = mtui.split(',');
    if (fck.length > 2) {
      return this.base64Decode(fck[1]);
    }
    return '';
  },
  getClientInfo: function getClientInfo() {
    var clientInfo = decodeURIComponent(__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('MT_CLIENT_INFO'));
    if (!clientInfo || clientInfo === 'null' || clientInfo === 'undefined') {
      return {};
    }
    return JSON.parse(clientInfo) || {};
  },
  latestVersion: function latestVersion(currentVer, version) {
    var curVer = currentVer.split('.');
    var specVer = version.split('.');

    for (var i = 0, len = curVer.length; i < len; i++) {
      if (curVer[i] !== specVer[i]) {
        return curVer[i] - specVer[i] > 0 ? true : false;
      }
      if (i >= len - 1) {
        return false;
      }
    }

    return false;
  },
  supportSticky: function supportSticky() {
    var testEle = document.createElement('div');
    var props = '-webkit-sticky';
    testEle.style.position = props;
    if (testEle.style.position) {
      return testEle.style.position === props;
    }
    props = 'sticky';
    testEle.style.position = props;
    return testEle.style.position === props;
  },
  getOpenWay: function getOpenWay() {
    if (!__WEBPACK_IMPORTED_MODULE_1__lib_ua__["a" /* browser */]) {
      return 3;
    }
    if (__WEBPACK_IMPORTED_MODULE_1__lib_ua__["a" /* browser */].wx) {
      return 0;
    } else if (__WEBPACK_IMPORTED_MODULE_1__lib_ua__["a" /* browser */].qq) {
      return 1;
    } else if (__WEBPACK_IMPORTED_MODULE_1__lib_ua__["a" /* browser */].app) {
      return 2;
    }
    return 3;
  }
};



/***/ }),

/***/ 62:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_apis__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_index__ = __webpack_require__(46);





/* harmony default export */ __webpack_exports__["a"] = (function (msg) {
  if (true) {
    msg.location = window.location.href;
    msg.deviceinfo = window.navigator.userAgent;
    var param = {
      msg: encodeURIComponent(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(msg)),
      appname: 'kaijiang',
      platform: 'h5'
    };
    return __WEBPACK_IMPORTED_MODULE_3__api_index__["a" /* instance */].get(__WEBPACK_IMPORTED_MODULE_2__api_apis__["a" /* default */].postLog, param);
  }
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
});

/***/ }),

/***/ 73:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = throwIfMissing;
/* harmony export (immutable) */ __webpack_exports__["a"] = updateLoginInfo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__middleware_callApi__ = __webpack_require__(15);



function throwIfMissing() {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '关键字不能为空';

  console.log(message);
}

function updateLoginInfo(_ref) {
  var _ref$token = _ref.token,
      token = _ref$token === undefined ? null : _ref$token,
      userInfo = _ref.userInfo;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__middleware_callApi__["c" /* updateLoginInfo2 */])({ token: token, userInfo: userInfo });
}


/* unused harmony default export */ var _unused_webpack_default_export = ({
  throwIfMissing: throwIfMissing
});

/***/ }),

/***/ 74:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return userInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return expertInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return course; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return newCourse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return picture; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return audio; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return video; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return message; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return sign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return userIssues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return IMMsg; });

var userInfo = function userInfo(data) {
  var member = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!data.token || !data.encUserId) {
    console.error('值不能为空');
  }

  var avatar = 'http://img02.meituncdn.com/group1/M00/50/91/6d8d62509178446f8d20910ab801c53a.png';

  if (data.avatar) {
    avatar = data.avatar;
  } else if (data.avatarUrl) {
    avatar = data.avatarUrl;
  } else if (data.weixinUserInfo && data.weixinUserInfo.headimgurl) {
    avatar = data.weixinUserInfo.headimgurl;
  }
  return {
    encUserId: data.encUserId,
    token: data.token,
    avatar: avatar,
    name: data.name || data.nickName,
    isHaveMobile: data.isHaveMobile,
    weixinUserInfo: data.weixinUserInfo,
    member: member
  };
};

var expertInfo = function expertInfo(data) {
  if (!data.token || !data.expertName || !data.expertTitle || !data.introduction) {
    console.error('值不能为空');
  }
  return {
    id: data.id,
    token: data.token,
    avatar: data.avatarPic,
    name: data.expertName,
    title: data.expertTitle,
    introduction: data.introduction
  };
};

var course = function course(data) {
  if (!data.id || !data.name || !data.picture || !data.startTime) {
    console.error('值不能为空');
  }
  return {
    id: data.id,
    name: data.name,
    price: data.price,
    lastPrice: typeof data.lastPrice === 'undefined' ? data.listPrice : data.lastPrice,
    endPrice: data.afterPrice,
    picture: data.picture,
    detailPicture: data.detailPicture,
    star: data.hot || 0,
    startTime: data.startTime,
    endTime: data.endTime,
    currentTime: data.currentTime,
    joinNum: data.joinNum || 0,
    joinNumDes: data.joinNumDes || '0',
    likeNum: data.likeNum || 0,
    hot: data.hot || 0,
    hasEndCourse: data.hasEndCourse,
    startStatus: data.startStatus,
    status: data.status,
    serialBuyType: data.serialBuyType,
    join: data.join,
    canJoin: data.canJoin,
    canComment: data.canComment,
    canRecord: data.canRecord,
    expertName: data.expertName,
    expertTitle: data.expertTitle,
    expertDesc: data.expertDesc,
    avatarPic: data.avatarPic,
    courseDesc: data.courseDesc,
    courseFeatures: data.courseFeatures,
    maxJoinNum: data.maxJoinNum,
    wsHost: data.wsHost,
    wsPort: data.wsPort,
    wssPort: data.wssPort,
    canWsConn: data.canWsConn,
    isMultiExpert: data.isMultiExpert,
    isManager: data.isManager,
    multiExpertDesc: data.multiExpertDesc,
    hasBuy: data.hasBuy,
    auditionStatus: data.auditionStatus,
    labelDTOList: data.labelDTOList,
    type: data.type,
    expectCourseNum: data.expectCourseNum,
    auditionUri: data.auditionUri || '',
    auditionUrl: data.auditionUrl || '',
    audioTime: data.audioTime || 0,
    audioTimeStr: data.audioTimeStr || '',
    auditionDuration: data.auditionDuration || 0,
    tinyCourseList: data.tinyCourseList || '',
    playNum: data.playNum || 0,
    featureLinks: data.featureLinks || [],
    featureModules: data.courseFeatureDTO && data.courseFeatureDTO.featureModules || data.featureModules || [],
    serialCourse: data.serialCourse || null,
    courseList: data.courseList,
    pointDTO: data.pointDTO,
    timeTag: data.timeTag,
    calories: data.calories || 0,
    supportAudition: data.supportAudition,
    playNumStr: data.playNumStr || '0',
    actualCourseNum: data.actualCourseNum,
    distribution: data.distribution,
    distributionPrice: data.distributionPrice,
    skuBenefitType: data.skuBenefitType,
    otherPrice: data.otherPrice,
    vipLevel: data.vipLevel,
    jxjActiveDto: data.jxjActiveDto,
    materialType: data.materialType,
    fileSize: data.fileSize,
    fileSizeStr: data.fileSizeStr
  };
};

var newCourse = function newCourse(data) {
  if (!data.id || !data.name || !data.picture || !data.startTime) {
    console.error('值不能为空');
  }
  return {
    id: data.id,
    name: data.name,
    price: data.price,
    lastPrice: typeof data.lastPrice === 'undefined' ? data.listPrice : data.lastPrice,
    endPrice: data.afterPrice,
    picture: data.picture,
    detailPicture: data.detailPicture,
    star: data.hot || 0,
    startTime: data.startTime,
    endTime: data.endTime,
    currentTime: data.currentTime,
    joinNum: data.joinNum || 0,
    joinNumDes: data.joinNumDes || '0',
    likeNum: data.likeNum || 0,
    hot: data.hot || 0,
    hasEndCourse: data.hasEndCourse,
    startStatus: data.startStatus,
    status: data.status,
    serialBuyType: data.serialBuyType,
    join: data.join,
    canJoin: data.canJoin,
    canComment: data.canComment,
    canRecord: data.canRecord,
    expertName: data.expertName,
    expertTitle: data.expertTitle,
    expertDesc: data.expertDesc,
    avatarPic: data.avatarPic,
    courseDesc: data.courseDesc,
    courseFeatures: data.courseFeatures || data.courseFeatureDTO,
    maxJoinNum: data.maxJoinNum,
    wsHost: data.wsHost,
    wsPort: data.wsPort,
    wssPort: data.wssPort,
    canWsConn: data.canWsConn,
    isMultiExpert: data.isMultiExpert,
    isManager: data.isManager,
    multiExpertDesc: data.multiExpertDesc,
    hasBuy: data.hasBuy,
    auditionStatus: data.materials,
    labelDTOList: data.labelDTOList,
    type: data.type,
    expectCourseNum: data.expectCourseNum,
    auditionUri: data.auditionUri || '',
    auditionUrl: data.auditionUrl || '',
    auditionDuration: data.auditionDuration || 0,
    tinyCourseList: data.tinyCourseList || '',
    playNum: data.playNum || 0,
    featureLinks: data.featureLinks || [],

    featureModules: data.courseFeatureDTO.featureModules || [],
    serialCourse: data.serialCourse || null,
    courseList: data.courseList,
    pointDTO: data.pointDTO,
    timeTag: data.timeTag,
    calories: data.calories || 0,
    supportAudition: data.supportAudition,
    playNumStr: data.playNumStr || '0',
    actualCourseNum: data.actualCourseNum,
    detailTabs: data.detailTabs || [],
    canUseNumStr: data.canUseNumStr,
    distribution: data.distribution,
    distributionPrice: data.distributionPrice,
    skuBenefitType: data.skuBenefitType,
    otherPrice: data.otherPrice,
    vipLevel: data.vipLevel,
    subStatus: data.subStatus,
    subMaterialType: data.subMaterialType,
    subMaterialTypeDesc: data.subMaterialTypeDesc,
    materialType: data.materialType,
    courseNotice: data.courseNotice,
    jxjActiveDto: data.jxjActiveDto,
    fileSize: data.fileSize,
    fileSizeStr: data.fileSizeStr
  };
};

var picture = function picture(data) {
  if (!data.id || !data.picUrl || !data.createTime) {
    console.error('值不能为空');
  }
  return {
    index: data.sortIndex,
    id: data.id,
    url: data.picUrl,
    createTime: data.createTime
  };
};

var audio = function audio(data) {
  if (!data.id || !data.picUrl || !data.createTime || !data.materialName) {
    console.error('值不能为空');
  }
  return {
    index: data.sortIndex,
    id: data.id,
    url: data.picUrl,
    createTime: data.createTime,
    name: data.materialName,
    fileSize: data.fileSize,
    duration: data.duration
  };
};

var video = function video(data) {
  if (!data.id || !data.picUrl || !data.createTime || !data.materialName) {
    console.error('值不能为空');
  }
  return {
    index: data.sortIndex,
    id: data.id,
    url: data.picUrl,
    img: data.thumbnail,
    createTime: data.createTime,
    name: data.materialName,
    fileSize: data.fileSize,
    duration: data.duration,
    width: data.width,
    height: data.height
  };
};

var message = function message(data) {
  if (!data.id || !data.courseId || !data.senderName || !data.senderId || !data.avatarPic || !data.content || !data.createTime) {
    console.error('值不能为空');
  }
  var refMessage = null;
  if (data.refMessage) {
    refMessage = {
      content: data.refMessage.content
    };
  }
  return {
    id: data.id,
    courseId: data.courseId,
    sender: {
      id: data.senderId,
      encUserId: data.encUserId,
      name: data.senderName,
      avatar: data.avatarPic,
      userType: data.senderType
    },
    quickInsert: data.quickInsert,
    clientSeqId: data.clientSeqId,
    type: data.type,
    content: data.content,
    thumbNail: data.thumbnail,
    interestCount: data.interestCount,
    speech: data.speech,
    createTime: data.createTime,
    refMessage: refMessage,
    loadstartStatus: false,
    playingStatus: false,
    like: data.like || false,
    deleted: data.deleted || false,
    uploadStatus: 1,
    mediaId: null };
};

var sign = function sign(data) {
  if (!data.sign) {
    console.error('sign值不能为空');
  }
  return {
    sign: data.sign,
    timeStamp: data.timeStamp,
    userId: data.userId,
    userType: data.userType
  };
};

var userIssues = function userIssues(data) {
  if (!data.courseId || !data.id) {
    console.error('值不能为空');
  }
  return {
    id: data.id,
    cursorId: data.cursorId,
    courseId: data.courseId,
    type: data.type,
    interestCount: data.interestCount,
    createTime: data.createTime,
    content: data.content,
    deleted: data.deleted,
    sender: {
      id: data.senderId,
      avatarPic: data.avatarPic,
      name: data.senderName,
      type: data.senderType,
      like: data.like,
      encUserId: data.encUserId },
    refMsg: {
      id: data.refMsgId,
      content: data.refMessage }
  };
};

var IMMsg = function IMMsg(data) {
  var list = data.list;
  var newList = [];
  list.forEach(function (item) {
    var msgType = item.msgType;
    var newMsgType = null;
    if (msgType === 1) {
      newMsgType = 5;
    } else if (msgType === 2) {
      newMsgType = 1;
    } else if (msgType === 3 || msgType === 4 || msgType === 26) {
      newMsgType = 2;
    } else if (msgType === 20) {
      newMsgType = 6;
    } else {
      newMsgType = 0;
    }
    var bodyJson = JSON.parse(item.bodyJson);
    var picUrls = [];
    if (bodyJson && bodyJson.attach && bodyJson.attach.attachments) {
      bodyJson.attach.attachments.forEach(function (urlItem) {
        picUrls.push(urlItem.url);
      });
    }
    var msgInfo = {
      msgType: newMsgType,
      from: bodyJson.fromAccount,
      to: item.uid,
      text: bodyJson && bodyJson.attach ? bodyJson.attach.content || bodyJson.attach.msg : bodyJson.body,
      url: bodyJson && bodyJson.attach ? bodyJson.attach.url : '',
      urls: picUrls,
      dur: bodyJson && bodyJson.attach ? bodyJson.attach.dur : '',
      questionId: item.id,
      roleType: item.roleType,
      expertId: item.expertId,
      uid: item.uid,
      visibleType: bodyJson.ext.visibleType
    };
    newList.push(msgInfo);
  });
  return {
    list: newList,
    hasNextPage: data.hasNextPage
  };
};

/***/ }),

/***/ 882:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 886:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 888:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 893:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 894:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 897:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 90:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "socketSendMessage", function() { return socketSendMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "wxSign", function() { return wxSign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "closeCourse", function() { return closeCourse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "closeCourseRest", function() { return closeCourseRest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSerialList", function() { return getSerialList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTreeCoinInfo", function() { return getTreeCoinInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMessages", function() { return getMessages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "connectServer", function() { return connectServer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "disConnectServe", function() { return disConnectServe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "audioLoadstart", function() { return audioLoadstart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "audioPlaying", function() { return audioPlaying; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "audioStop", function() { return audioStop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetMessage", function() { return resetMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLoading", function() { return setLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCourseInfo", function() { return getCourseInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSerialCourselInfo", function() { return getSerialCourselInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCourseRecommends", function() { return getCourseRecommends; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTagsPage", function() { return getTagsPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTagsSubject", function() { return getTagsSubject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sendLog", function() { return sendLog; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shortid__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shortid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_shortid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_find__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_ws_io__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mutation_types__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__comm_middleware_callApi__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__comm_api_apis__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__comm_middleware_reportLog__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_expert_actions_expert__ = __webpack_require__(191);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "expertAuth", function() { return __WEBPACK_IMPORTED_MODULE_11__store_expert_actions_expert__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getCourseList", function() { return __WEBPACK_IMPORTED_MODULE_11__store_expert_actions_expert__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getPictureList", function() { return __WEBPACK_IMPORTED_MODULE_11__store_expert_actions_expert__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getMaterialPPTList", function() { return __WEBPACK_IMPORTED_MODULE_11__store_expert_actions_expert__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "movePictureList", function() { return __WEBPACK_IMPORTED_MODULE_11__store_expert_actions_expert__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getAudioList", function() { return __WEBPACK_IMPORTED_MODULE_11__store_expert_actions_expert__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getVideoList", function() { return __WEBPACK_IMPORTED_MODULE_11__store_expert_actions_expert__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "clearMateriallist", function() { return __WEBPACK_IMPORTED_MODULE_11__store_expert_actions_expert__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "deletePicture", function() { return __WEBPACK_IMPORTED_MODULE_11__store_expert_actions_expert__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "startRecord", function() { return __WEBPACK_IMPORTED_MODULE_11__store_expert_actions_expert__["j"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "insertAudio", function() { return __WEBPACK_IMPORTED_MODULE_11__store_expert_actions_expert__["k"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "stopRecordControl", function() { return __WEBPACK_IMPORTED_MODULE_11__store_expert_actions_expert__["l"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "reRecord", function() { return __WEBPACK_IMPORTED_MODULE_11__store_expert_actions_expert__["m"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "uploadImage", function() { return __WEBPACK_IMPORTED_MODULE_11__store_expert_actions_expert__["n"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "chooseImage", function() { return __WEBPACK_IMPORTED_MODULE_11__store_expert_actions_expert__["o"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "replyMessage", function() { return __WEBPACK_IMPORTED_MODULE_11__store_expert_actions_expert__["p"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "livePopupVisible", function() { return __WEBPACK_IMPORTED_MODULE_11__store_expert_actions_expert__["q"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "liveBarActive", function() { return __WEBPACK_IMPORTED_MODULE_11__store_expert_actions_expert__["r"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getIssues", function() { return __WEBPACK_IMPORTED_MODULE_11__store_expert_actions_expert__["s"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getSlidesList", function() { return __WEBPACK_IMPORTED_MODULE_11__store_expert_actions_expert__["t"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getCourseMsgList", function() { return __WEBPACK_IMPORTED_MODULE_11__store_expert_actions_expert__["u"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getCourseGuestbook", function() { return __WEBPACK_IMPORTED_MODULE_11__store_expert_actions_expert__["v"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "delMsgReply", function() { return __WEBPACK_IMPORTED_MODULE_11__store_expert_actions_expert__["w"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "replyMsg", function() { return __WEBPACK_IMPORTED_MODULE_11__store_expert_actions_expert__["x"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "addReplyToList", function() { return __WEBPACK_IMPORTED_MODULE_11__store_expert_actions_expert__["y"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "updateMessageRefStatus", function() { return __WEBPACK_IMPORTED_MODULE_11__store_expert_actions_expert__["z"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "lookHistoryMessage", function() { return __WEBPACK_IMPORTED_MODULE_11__store_expert_actions_expert__["A"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getMediaId", function() { return __WEBPACK_IMPORTED_MODULE_11__store_expert_actions_expert__["B"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "bindUpdateVideo", function() { return __WEBPACK_IMPORTED_MODULE_11__store_expert_actions_expert__["C"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "weeks", function() { return __WEBPACK_IMPORTED_MODULE_11__store_expert_actions_expert__["D"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getQuestionList", function() { return __WEBPACK_IMPORTED_MODULE_11__store_expert_actions_expert__["E"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getExpertJobSetting", function() { return __WEBPACK_IMPORTED_MODULE_11__store_expert_actions_expert__["F"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "updateExpertModify", function() { return __WEBPACK_IMPORTED_MODULE_11__store_expert_actions_expert__["G"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getQusetionDialog", function() { return __WEBPACK_IMPORTED_MODULE_11__store_expert_actions_expert__["H"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getQuestionInfo", function() { return __WEBPACK_IMPORTED_MODULE_11__store_expert_actions_expert__["I"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "bindDialog", function() { return __WEBPACK_IMPORTED_MODULE_11__store_expert_actions_expert__["J"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "saveQuestionStatus", function() { return __WEBPACK_IMPORTED_MODULE_11__store_expert_actions_expert__["K"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getExpertInfo", function() { return __WEBPACK_IMPORTED_MODULE_11__store_expert_actions_expert__["L"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getSettleInfo", function() { return __WEBPACK_IMPORTED_MODULE_11__store_expert_actions_expert__["M"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getYearParam", function() { return __WEBPACK_IMPORTED_MODULE_11__store_expert_actions_expert__["N"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getSettleList", function() { return __WEBPACK_IMPORTED_MODULE_11__store_expert_actions_expert__["O"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getOrderDetail", function() { return __WEBPACK_IMPORTED_MODULE_11__store_expert_actions_expert__["P"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__ = __webpack_require__(205);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getConstantData", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getUserLoginStr", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getMemberInfo", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "userAuth", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getHotLabel", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "courseBuy", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "coursePay", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getPreOrderInfo", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "courseMaYiPay", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getMaYiPayStatus", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["j"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "courseWxPay", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["k"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "clearPayStatus", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["l"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "addComment", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["m"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getCatagory", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["n"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getIndexList", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["o"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "courseLike", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["p"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "xwCourseLike", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["q"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "messageLike", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["r"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getUserIssues", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["s"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getUserCourses", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["t"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getCombineCourses", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["u"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getTheCode", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["v"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getBindMobile", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["w"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getMyTinyAudio", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["x"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getMyTinyAlbum", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["y"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getMyTinyVideo", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["z"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getMyTinyVideoAlbum", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["A"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "initAudio", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["B"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getGroupAlbum", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["C"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "cashierPay", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["D"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getLamaRecommends", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["E"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getFreeTinyCourseList", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["F"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getQueryByCode", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["G"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getStatus", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["H"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getFreeList", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["I"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getCourseRemind", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["J"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getHomePageData", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["K"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getRecommend", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["L"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "setRemindStatus", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["M"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "changeHotCourse", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["N"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getIndexModuleList", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["O"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getCourseAudioUrl", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["P"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getMyCourses", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["Q"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getAudition", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["R"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getSubCourseList", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["S"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "setSort", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["T"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getChildDetail", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["U"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getMessageList", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["V"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getColumnList", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["W"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "setLeaveMessage", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["X"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getMyGuestBooks", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["Y"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "bindDelGuest", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["Z"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "bindGiveThumbsup", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_0"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getNewCourseInfo", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_1"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getCourseExperts", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_2"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getClassifyLabel", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_3"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getExpertsLabel", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_4"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getShareImage", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_5"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getMyIncome", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_6"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getMemberFreeCourse", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_7"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getMemberAd", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_8"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "setVipInfo", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_9"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getjxjDetails", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_10"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "updateRemind", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_11"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getAdvertsGeneral", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_12"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getScholarshipsList", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_13"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getCertificate", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_14"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getVerifySend", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_15"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getVerifyValid", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_16"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getVerified", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_17"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getMyListJxjActivity", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_18"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getUserPhone", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_19"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getIconList", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_20"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getJxjCollectLikes", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_21"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getJxjStartLikes", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_22"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getJxjDoLikes", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_23"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getPunchCardShare", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_24"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "sendPlayDuration", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_25"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getPunchCard", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_26"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getIndexInfo", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_27"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getFreeClinicExpert", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_28"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getVoteRankInfo", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_29"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getUserActivityInfo", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_30"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "canFreeAuditQues", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_31"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getConsultDetail", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_32"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getBabayTreeUploadImg", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_33"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getBabayTreeUploadImgbase64", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_34"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getBaseInfo", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_35"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "vote", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_36"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getMyConsultList", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_37"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "questionSubmit", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_38"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "secretToken", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_39"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getQueryCertificateType", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_40"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getCommentTags", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_41"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getCourseComments", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_42"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getChannelModule", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_43"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getChannelRecommend", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_44"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getCategoryList", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_45"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getAdByCodes", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_46"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getCourseRankList", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_47"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getWyethCourse", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_48"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "bindWyethLogin", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_49"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "queryShubi", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_50"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "queryShubiDetail", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_51"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "bindExpert", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_52"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "checkExpert", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_53"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "bindAuthentication", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_54"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getProvinceList", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_55"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getAreaList", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_56"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "bindMtUploadPic", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_57"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getCountryInfo", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_58"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getWeeklyDetail", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_59"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getWeeklyList", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_60"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getShareDetail", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_61"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getShareWeekly", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_62"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getWeeklyAudioUrl", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_63"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getUpdateMediaPlayLog", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_64"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getWeeklyCombos", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_65"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "buyNow", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_66"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getSDKInfo", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_67"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "detail4payment", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_68"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getCanBuyList", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_69"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getItemMsg", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_70"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getWeeklyRight", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_71"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getKnowingIndex", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_72"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getSignInfo", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_73"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "confirmExchange", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_74"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getPrePayWayList", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_75"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getIncome", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_76"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getMyLightIncome", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_77"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getExamInfo", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_78"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "submitExam", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_79"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getAdvert", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_80"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getHomePage", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_81"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getMyCourse", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_82"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getHomeCoupon", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_83"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getShareMaterial", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_84"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getLighthouseCourseDetail", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_85"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getLighthouseCourseList", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_86"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getInvite", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_87"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getCourseDetail", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_88"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getSimpleSubCourse", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_89"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getTopicCountInfo", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_90"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getTopicGroupInfo", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_91"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "lightForPreOrder", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_92"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "lightSubmitOrder", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_93"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "bindSaveOpenId", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_94"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getOrderTipList", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_95"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getCoursePrice", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_96"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getMyCoupon", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_97"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getSkuList", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_98"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getMyOrders", function() { return __WEBPACK_IMPORTED_MODULE_12__store_user_actions_user__["_99"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store_nim_actions_nim__ = __webpack_require__(198);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "connect", function() { return __WEBPACK_IMPORTED_MODULE_13__store_nim_actions_nim__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getRecord", function() { return __WEBPACK_IMPORTED_MODULE_13__store_nim_actions_nim__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "initNimSDK", function() { return __WEBPACK_IMPORTED_MODULE_13__store_nim_actions_nim__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "sendMsg", function() { return __WEBPACK_IMPORTED_MODULE_13__store_nim_actions_nim__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "sendFileMsg", function() { return __WEBPACK_IMPORTED_MODULE_13__store_nim_actions_nim__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "sendFormatMsg", function() { return __WEBPACK_IMPORTED_MODULE_13__store_nim_actions_nim__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "sendMsgReceipt", function() { return __WEBPACK_IMPORTED_MODULE_13__store_nim_actions_nim__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "revocateMsg", function() { return __WEBPACK_IMPORTED_MODULE_13__store_nim_actions_nim__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "updateLocalMsg", function() { return __WEBPACK_IMPORTED_MODULE_13__store_nim_actions_nim__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getHistoryMsgs", function() { return __WEBPACK_IMPORTED_MODULE_13__store_nim_actions_nim__["j"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "deleteSession", function() { return __WEBPACK_IMPORTED_MODULE_13__store_nim_actions_nim__["k"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "setCurrSession", function() { return __WEBPACK_IMPORTED_MODULE_13__store_nim_actions_nim__["l"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "resetCurrSession", function() { return __WEBPACK_IMPORTED_MODULE_13__store_nim_actions_nim__["m"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "delegateTeamFunction", function() { return __WEBPACK_IMPORTED_MODULE_13__store_nim_actions_nim__["n"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "onTeamNotificationMsg", function() { return __WEBPACK_IMPORTED_MODULE_13__store_nim_actions_nim__["o"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "enterSettingPage", function() { return __WEBPACK_IMPORTED_MODULE_13__store_nim_actions_nim__["p"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getTeamMembers", function() { return __WEBPACK_IMPORTED_MODULE_13__store_nim_actions_nim__["q"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "checkTeamMsgReceipt", function() { return __WEBPACK_IMPORTED_MODULE_13__store_nim_actions_nim__["r"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getTeamMsgReads", function() { return __WEBPACK_IMPORTED_MODULE_13__store_nim_actions_nim__["s"]; });





var _this = this;















var socketSendMessage = function socketSendMessage(_ref, payload) {
  var commit = _ref.commit,
      state = _ref.state;

  if (!payload.type) {
    commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["a" /* AJAX_ERROR */], new Error('消息类型不能为空'));
  }
  if ((payload.type === 1 || payload.type === 3 || payload.type === 8) && !payload.content) {
    commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["a" /* AJAX_ERROR */], new Error('消息内容不能为空'));
  }
  if ((payload.type === 7 || payload.type === 8) && !payload.refMsgId) {
    commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["a" /* AJAX_ERROR */], new Error('回答消息refMsgId不能为空'));
  }
  if (payload.type === 7 || payload.type === 6) {
    console.log('payload ===> ' + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(payload));
    if (payload.record === 1 && !payload.sucaiPicId) {
      commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["a" /* AJAX_ERROR */], new Error('录播多媒体消息，sucaiPicId 不能为空'));
    }
    if (!payload.record && !payload.mediaId) {
      commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["a" /* AJAX_ERROR */], new Error('多媒体消息，mediaId 不能为空'));
    }
  }

  var message = {
    type: payload.type,
    content: payload.content,
    mediaId: payload.mediaId || null,
    speech: payload.speech || null,
    refMsgId: payload.refMsgId || null,
    clientSeqId: payload.clientSeqId || __WEBPACK_IMPORTED_MODULE_4_shortid___default.a.generate(),
    sucaiPicId: payload.sucaiPicId || null
  };

  if (state.socket) {
    state.socket.send(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(message));
    console.log('state.connectStatus', state.connectStatus);
    if (!state.connectStatus) {
      var errormesg = '发送失败';
      commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["a" /* AJAX_ERROR */], new Error(errormesg));
      message.uploadStatus = 0;
      _this.sendLog({ commit: commit, state: state }, {
        name: '消息发送失败',
        protocol: document.location.protocol === 'https:' ? 'https' : 'http',
        time: Date.parse(new Date()),
        socket: state.socket,
        url: location.href,
        msg: message,
        user: state.userInfo && state.userInfo.token ? state.userInfo : state.expertInfo,
        userType: state.userInfo && state.userInfo.token ? '用户端' : '专家端'
      });
    }
    commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["b" /* SOCKET_SEND_MESSAGE */], {
      message: message
    });

    if (message.type === 11) {
      commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["c" /* RESET_MESSAGE_STORE */]);
    }
  } else {
    commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["a" /* AJAX_ERROR */], new Error('消息服务连接失败, 请退出或者刷新页面进行重连'));

    var msg = {
      name: '消息服务连接失败-socket失败',
      protocol: document.location.protocol === 'https:' ? 'https' : 'http',
      time: Date.parse(new Date()),
      socket: state.socket,
      url: location.href,
      msg: message,
      user: state.userInfo && state.userInfo.token ? state.userInfo : state.expertInfo,
      userType: state.userInfo && state.userInfo.token ? '用户端' : '专家端'
    };

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__comm_middleware_reportLog__["a" /* default */])(msg).then(function () {
      console.log('消息服务连接失败');
    });
  }
};

var wxSign = function wxSign(_ref2, _ref3) {
  var commit = _ref2.commit,
      state = _ref2.state;
  var url = _ref3.url,
      debug = _ref3.debug,
      _ref3$sign = _ref3.sign,
      sign = _ref3$sign === undefined ? true : _ref3$sign,
      type = _ref3.type;

  var status = 0;
  commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["d" /* AJAX_WX_SIGN_STATUS */], { status: 0 });
  console.log('微信签名地址：', url);
  var location = window.location.href;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_9__comm_api_apis__["a" /* default */].wxSign, { url: url }).then(function (body) {
    if (!body.signTO) {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ err: new Error('微信签名失败') }, body));
    }
    if (sign) {
      var _body$signTO = body.signTO,
          appid = _body$signTO.appid,
          timestamp = _body$signTO.timestamp,
          nonceStr = _body$signTO.nonceStr,
          signature = _body$signTO.signature;

      window.wx.config({
        debug: Boolean(debug),
        appId: appid,
        timestamp: timestamp,
        nonceStr: nonceStr,
        signature: signature,
        jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'startRecord', 'stopRecord', 'onVoiceRecordEnd', 'playVoice', 'pauseVoice', 'stopVoice', 'onVoicePlayEnd', 'uploadVoice', 'downloadVoice', 'chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'getNetworkType', 'hideOptionMenu', 'showOptionMenu', 'hideMenuItems', 'showMenuItems', 'hideAllNonBaseMenuItem', 'showAllNonBaseMenuItem', 'chooseWXPay', 'getLocation']
      });
      window.wx.ready(function () {
        console.log('微信签名成功-readey');
        status = 1;
        commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["d" /* AJAX_WX_SIGN_STATUS */], { status: status });
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(status);
      });
      window.wx.error(function (res) {
        console.log('微信签名失败-error');
        var signatureMsg = { appid: appid, timestamp: timestamp, nonceStr: nonceStr, signature: signature, type: type, location: location };
        if (type === 'user') {
          signatureMsg.userInfo = state.userInfo;
        } else if (type === 'expert') {
          signatureMsg.expertInfo = state.expertInfo;
        }
        var msg = {
          name: (type === 'expert' ? '专家端' : '用户端') + '\u5FAE\u4FE1\u7B7E\u540Djssdk\u5931\u8D25',
          protocol: document.location.protocol === 'https:' ? 'https' : 'http',
          info: res,
          time: Date.parse(new Date()),
          url: url,
          signature: signatureMsg,
          userType: type === 'expert' ? '\u4E13\u5BB6\u7AEF-' + type : '\u7528\u6237\u7AEF-' + type
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__comm_middleware_reportLog__["a" /* default */])(msg).then(function () {
          console.log('日志-微信签名接口失败');
        });
        status = 0;
        commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["d" /* AJAX_WX_SIGN_STATUS */], { status: status });
      });
    }
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(status);
  })['catch'](function (value) {
    var reportMsg = value.reportMsg;
    if (reportMsg) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__comm_middleware_reportLog__["a" /* default */])(reportMsg).then(function () {
        console.log('日志-微信签名失败');
      });
    } else {
      var err = value;
      var _value$appId = value.appId,
          appId = _value$appId === undefined ? null : _value$appId,
          _value$timeStamp = value.timeStamp,
          timeStamp = _value$timeStamp === undefined ? null : _value$timeStamp,
          _value$nonceStr = value.nonceStr,
          nonceStr = _value$nonceStr === undefined ? null : _value$nonceStr,
          _value$signature = value.signature,
          signature = _value$signature === undefined ? null : _value$signature;

      if (value.err) {
        err = value.err;
      }
      reportMsg = {
        name: '微信签名接口失败',
        protocol: document.location.protocol === 'https:' ? 'https' : 'http',
        info: err,
        time: Date.parse(new Date()),
        url: url,
        signature: { appId: appId, timeStamp: timeStamp, nonceStr: nonceStr, signature: signature, type: type, location: location },
        userType: type === 'expert' ? '\u4E13\u5BB6\u7AEF-' + type : '\u7528\u6237\u7AEF-' + type
      };
    }
    commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["a" /* AJAX_ERROR */], new Error('微信签名失败'));
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(0);

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__comm_middleware_reportLog__["a" /* default */])(reportMsg).then(function () {
      console.log('日志-微信签名接口失败');
    });
  });
};

var closeCourse = function closeCourse(_ref4, id) {
  var commit = _ref4.commit;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_9__comm_api_apis__["a" /* default */].courseClose, id, { headers: { 'Content-type': 'application/x-www-form-urlencoded' } }).then(function () {
    commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["e" /* COURSE_CLOSED */], { status: 1 });
  });
};

var closeCourseRest = function closeCourseRest(_ref5) {
  var commit = _ref5.commit;

  commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["e" /* COURSE_CLOSED */], { status: -1 });
};

var serialListFetching = false;
var getSerialList = function getSerialList(_ref6, _ref7) {
  var commit = _ref6.commit,
      state = _ref6.state;
  var _ref7$curpage = _ref7.curpage,
      curpage = _ref7$curpage === undefined ? 1 : _ref7$curpage,
      _ref7$pageSize = _ref7.pageSize,
      pageSize = _ref7$pageSize === undefined ? 20 : _ref7$pageSize,
      _ref7$type = _ref7.type,
      type = _ref7$type === undefined ? 1 : _ref7$type;

  if (serialListFetching) {
    return;
  }
  serialListFetching = true;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_9__comm_api_apis__["a" /* default */].serialList, { curpage: curpage, pageSize: pageSize, type: type }).then(function (body) {
    serialListFetching = false;
    var data = body.data;
    commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["f" /* SERIAL_LIST */], { info: data, curpage: curpage, curType: type });
  }, function () {
    serialListFetching = false;
  });
};

var getTreeCoinInfo = function getTreeCoinInfo(_ref8, _ref9) {
  var commit = _ref8.commit;
  var _ref9$type = _ref9.type,
      type = _ref9$type === undefined ? 'index' : _ref9$type,
      curpage = _ref9.curpage,
      _ref9$pageSize = _ref9.pageSize,
      pageSize = _ref9$pageSize === undefined ? 20 : _ref9$pageSize;

  var apisUrl = type === 'index' ? __WEBPACK_IMPORTED_MODULE_9__comm_api_apis__["a" /* default */].treeCoin : __WEBPACK_IMPORTED_MODULE_9__comm_api_apis__["a" /* default */].treeCoinList;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, apisUrl, { type: type, curpage: curpage, pageSize: pageSize }).then(function (body) {
    var dataInfo = body.data;
    if (dataInfo.list && dataInfo.pageNo !== 1) {
      commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["g" /* TREE_COIN_INFO_MORE */], dataInfo);
    } else {
      commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["h" /* TREE_COIN_INFO */], dataInfo);
    }
  });
};

var getMessages = function getMessages(_ref10, _ref11) {
  var commit = _ref10.commit;
  var courseId = _ref11.courseId,
      lastId = _ref11.lastId,
      _ref11$direction = _ref11.direction,
      direction = _ref11$direction === undefined ? 0 : _ref11$direction,
      _ref11$onlyExpertMsg = _ref11.onlyExpertMsg,
      onlyExpertMsg = _ref11$onlyExpertMsg === undefined ? true : _ref11$onlyExpertMsg;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_9__comm_api_apis__["a" /* default */].historyMessage, { courseId: courseId, lastId: lastId, direction: direction, onlyExpertMsg: onlyExpertMsg }).then(function (body) {
    var messages = body.data.list;
    commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["i" /* AJAX_GET_MESSAGES */], {
      lastId: lastId,
      messages: messages
    });
    return messages;
  });
};

var connectServer = function connectServer(store, _ref12) {
  var liveId = _ref12.liveId,
      _ref12$userType = _ref12.userType,
      userType = _ref12$userType === undefined ? 'expert' : _ref12$userType,
      _ref12$onlyExpertMsg = _ref12.onlyExpertMsg,
      onlyExpertMsg = _ref12$onlyExpertMsg === undefined ? 'false' : _ref12$onlyExpertMsg;

  var commit = store.commit;
  var state = store.state;
  var SERVER_ADDRESS = void 0;
  var protocol = document.location.protocol === 'https:' ? 'wss' : 'ws';
  var socketPort = document.location.protocol === 'https:' ? state.courseInfo.wssPort : state.courseInfo.wsPort;
  var timeStamp = state.signData.timeStamp;

  if (userType === 'expert') {
    SERVER_ADDRESS = protocol + '://' + state.courseInfo.wsHost + ':' + socketPort + '?userType=2&userId=' + state.expertInfo.id + '&userName=' + state.expertInfo.name + '&timestamp=' + timeStamp + '&token=' + encodeURIComponent(state.expertInfo.token) + '&courseId=' + liveId + '&onlyExpertMsg=' + onlyExpertMsg + '&sign=' + state.signData.sign + '&avatarPic=' + encodeURIComponent(state.expertInfo.avatar) + '&platform=h5';
  } else if (userType === 'user') {
    SERVER_ADDRESS = protocol + '://' + state.courseInfo.wsHost + ':' + socketPort + '?userType=1&encUserId=' + state.userInfo.encUserId + '&userName=' + (state.userInfo.name ? state.userInfo.name : '宝宝树用户') + '&timestamp=' + timeStamp + '&token=' + encodeURIComponent(state.userInfo.token) + '&courseId=' + liveId + '&onlyExpertMsg=' + onlyExpertMsg + '&sign=' + state.signData.sign + '&avatarPic=' + encodeURIComponent(state.userInfo.avatar) + '&platform=h5';
  }

  var socket = new __WEBPACK_IMPORTED_MODULE_6__lib_ws_io__["a" /* default */](SERVER_ADDRESS, {
    reconnectionAttempts: 10,
    reconnectionDelay: 2500,
    timeout: 6000
  });

  socket.on('connect', function () {
    commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["j" /* SOCKET_CONNECT_STATUS */], {
      status: 1
    });

    commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["k" /* SOCKET_CONNECT */], {
      socket: socket
    });

    window.clearInterval(window.messageInterval);
    window.messageInterval = setInterval(function () {
      var messages = void 0;
      if (state.messages.length === 0) {
        messages = state.messageStore.splice(0, state.messageStore.length);
      } else {
        messages = state.messageStore.splice(0, 1);
      }
      if (messages.length) {
        commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["l" /* SOCKET_RECEIVE_MESSAGE */], {
          messages: messages
        });
      }
    }, 1000);
  });

  socket.on('message', function (message) {
    var data = JSON.parse(message);
    console.log('message type ===> ' + data.type);
    console.log('message ===> ' + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(data));
    console.log('%c[socket]', 'color: #49c9c9;', '实例监听 message', data.type);

    if (data.code !== 0 && data.code !== undefined) {
      if (data.code === 7 || data.code === 99) {
        var clientSeqId = data.data.clientSeqId;
        if (clientSeqId !== null) {
          var retryMessage = state.sendMessages[clientSeqId];
          if (retryMessage.retryCount === undefined) {
            retryMessage.retryCount = 0;
          }

          if (retryMessage && retryMessage.retryCount < 3) {
            var errMsgStr = '\u6D88\u606F\u53D1\u9001\u5931\u8D25\uFF0C\u5DF2\u91CD\u65B0\u53D1\u9001[' + (retryMessage.retryCount + 1) + '/3]';
            commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["a" /* AJAX_ERROR */], new Error(errMsgStr));
            state.socket.send(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(retryMessage));
            retryMessage.retryCount += 1;

            var messageAry = state.messages;
            var messageLen = messageAry.length;
            var newFailMessage = messageAry[messageLen - 1];
            console.log('newFailMessage', newFailMessage);
            newFailMessage.uploadStatus = 0;
          } else {
            commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["a" /* AJAX_ERROR */], new Error(data.errorMsg));

            _this.sendLog(store, {
              name: '消息发送失败',
              protocol: document.location.protocol === 'https:' ? 'https' : 'http',
              info: message,
              time: Date.parse(new Date()),
              retryMessage: retryMessage,
              url: SERVER_ADDRESS,
              user: userType === 'expert' ? state.expertInfo : state.userInfo,
              userType: userType === 'expert' ? '专家端' : '用户端'
            });
          }
        }
      } else if (data.code === 2) {
        commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["a" /* AJAX_ERROR */], new Error(data.errorMsg));
      } else {
        commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["a" /* AJAX_ERROR */], new Error(data.errorMsg));
      }
    } else {
      var _messageAry = state.messages;
      var _messageLen = _messageAry.length;
      var newMessage = _messageAry[_messageLen - 1];

      console.log('newMessage-upload', newMessage);
      switch (data.type) {
        case 1:
          {
            state.messageStore = state.messageStore.concat(data.data.list);
            break;
          }
        case 15:
          commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["e" /* COURSE_CLOSED */], { status: 1 });
          break;
        case 19:
          commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["e" /* COURSE_CLOSED */], { status: 0 });
          break;
        case 17:
          commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["m" /* SOCKET_RECEIVE_MESSAGE_UP */], {
            courseUpCount: data.data.count || 0
          });
          break;
        case 2:
          {
            if (data.data.msg) {
              var messages = [data.data.msg];

              if (data.errorMsg) {
                commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["a" /* AJAX_ERROR */], new Error(data.errorMsg));
              }
              commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["l" /* SOCKET_RECEIVE_MESSAGE */], {
                messages: messages,
                clientSeqId: data.data.clientSeqId
              });
            }

            if (data.errorMsg && Number(data.data.msg.type) === 3) {
              commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["a" /* AJAX_ERROR */], new Error(data.errorMsg));
            }
            break;
          }
        case 4:
          {
            if (data.data.refMsgId) {
              commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["n" /* SOCKET_RECEIVE_MESSAGE_LIKE_COUNT */], {
                msgId: data.data.refMsgId,
                count: data.data.count
              });
            }
            break;
          }
        case 14:
          {
            if (data.data.refMsgId) {
              commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["o" /* SOCKET_RECEIVE_MESSAGE_DELETE */], {
                msgId: data.data.refMsgId
              });
            }
            break;
          }
        default:
          break;
      }
    }
  });

  socket.on('close', function (reason) {
    commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["j" /* SOCKET_CONNECT_STATUS */], {
      status: 0
    });

    commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["k" /* SOCKET_CONNECT */], {
      socket: null
    });

    console.log('%c[socket]', 'color: #49c9c9;', '实例监听 close', reason);

    if (userType === 'expert') {
      socket.uri = SERVER_ADDRESS + '&lastId=' + state.latestMessage.id;
    } else if (userType === 'user') {
      socket.uri = SERVER_ADDRESS + '&lastId=' + state.latestMessage.id;
    }

    var msg = {
      name: 'socket关闭',
      protocol: document.location.protocol === 'https:' ? 'https' : 'http',
      info: reason,
      time: Date.parse(new Date()),
      url: socket.uri,
      user: userType === 'expert' ? state.expertInfo : state.userInfo,
      userType: userType === 'expert' ? '专家端' : '用户端'
    };

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__comm_middleware_reportLog__["a" /* default */])(msg).then(function () {
      console.log('日志-socket 关闭');
    });
  });

  socket.on('error', function (error) {
    commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["j" /* SOCKET_CONNECT_STATUS */], {
      status: 0
    });

    console.log('%c[socket]', 'color: #49c9c9;', '实例监听 error', error);
    console.error('[socket]', error);

    var msg = {
      name: 'socket出错',
      protocol: document.location.protocol === 'https:' ? 'https' : 'http',
      info: error,
      time: Date.parse(new Date()),
      url: SERVER_ADDRESS,
      user: userType === 'expert' ? state.expertInfo : state.userInfo,
      userType: userType === 'expert' ? '专家端' : '用户端'
    };

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__comm_middleware_reportLog__["a" /* default */])(msg).then(function () {
      console.log('日志-socket 出错');
    });
  });

  socket.on('reconnect_success', function (attempt) {
    console.log('%c[socket]', 'color: #49c9c9;', '实例监听 reconnect，重连成功，重新拉取消息', attempt);
    console.log('%c[socket]', 'color: #49c9c9;', '最后一条id:', state.latestMessage.id);
    console.log('%c[socket]', 'color: #49c9c9;', '是否只看主讲人:', userType === 'expert' ? window.VM.stateOnlyself : window.VM.isOnlyShowMaster);
  });

  socket.on('reconnect_error', function (error) {
    console.log('%c[socket]', 'color: #49c9c9;', '实例监听 reconnect_error, 重连失败');
    commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["a" /* AJAX_ERROR */], new Error('\u91CD\u8FDE\u5931\u8D25\uFF0C\u5DF2\u91CD\u8BD5 [' + error.attempts + '/10]'));

    var msg = {
      name: 'socket重连出错',
      protocol: document.location.protocol === 'https:' ? 'https' : 'http',
      info: error,
      time: Date.parse(new Date()),
      url: SERVER_ADDRESS,
      user: userType === 'expert' ? state.expertInfo : state.userInfo,
      userType: userType === 'expert' ? '专家端' : '用户端'
    };

    if (error.attempts > 9) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__comm_middleware_reportLog__["a" /* default */])(msg).then(function () {
        console.log('日志-socket重连出错');
      });
    }
  });

  socket.on('reconnect_failed', function () {
    console.log('%c[socket]', 'color: #49c9c9;', '重连彻底失败');
    commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["a" /* AJAX_ERROR */], new Error('重连失败，请退出或者刷新重试！'));
  });

  return true;
};

var disConnectServe = function disConnectServe(_ref13) {
  var state = _ref13.state;

  if (state.socket) {
    state.socket.close(1000);
  }
};

var audioLoadstart = function audioLoadstart(_ref14, _ref15) {
  var commit = _ref14.commit;
  var msgId = _ref15.msgId;

  commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["p" /* AUDIO_LOADSTART */], { msgId: msgId });
};

var audioPlaying = function audioPlaying(_ref16, _ref17) {
  var commit = _ref16.commit;
  var msgId = _ref17.msgId;

  commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["q" /* AUDIO_PLAYING */], { msgId: msgId });
};

var audioStop = function audioStop(_ref18, _ref19) {
  var commit = _ref18.commit;
  var msgId = _ref19.msgId;

  commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["r" /* AUDIO_STOP */], { msgId: msgId });
};

var resetMessage = function resetMessage(store) {
  store.commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["s" /* RESET_MESSAGES */]);
};

var setLoading = function setLoading(store, _ref20) {
  var state = _ref20.state,
      time = _ref20.time;

  if (time) {
    var loadingState = store.state.isLoading;
    setTimeout(function () {
      store.commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["t" /* AJAX_LOADING */], { loadingStatus: loadingState });
    }, time);
  }
  store.commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["t" /* AJAX_LOADING */], { loadingStatus: state });
};

var getCourseInfo = function getCourseInfo(_ref21, _ref22) {
  var commit = _ref21.commit,
      state = _ref21.state;
  var id = _ref22.id,
      _ref22$needfeatures = _ref22.needfeatures,
      needfeatures = _ref22$needfeatures === undefined ? 0 : _ref22$needfeatures,
      _ref22$code = _ref22.code,
      code = _ref22$code === undefined ? '' : _ref22$code,
      parentcourseid = _ref22.parentcourseid,
      activeid = _ref22.activeid;

  var courseList = state.courseList;
  var courseInfo = void 0;
  if (courseList.data.length && !needfeatures) {
    courseInfo = __WEBPACK_IMPORTED_MODULE_5_lodash_find___default()(courseList.data, function (item) {
      return item.id === id;
    });
    commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["u" /* AJAX_GET_COURSEINFO */], {
      courseInfo: courseInfo
    });
  } else {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_9__comm_api_apis__["a" /* default */].courseDetail, { id: id, needfeatures: needfeatures, code: code, parentcourseid: parentcourseid, activeid: activeid }).then(function (body) {
      courseInfo = body.data;
      commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["u" /* AJAX_GET_COURSEINFO */], {
        courseInfo: courseInfo,
        filter: true
      });
      return courseInfo;
    });
  }
  return courseInfo;
};

var getSerialCourselInfo = function getSerialCourselInfo(_ref23, _ref24) {
  var commit = _ref23.commit;
  var id = _ref24.id,
      protocol = _ref24.protocol,
      retry = _ref24.retry,
      code = _ref24.code,
      newApi = _ref24.newApi;

  var apiUrl = __WEBPACK_IMPORTED_MODULE_9__comm_api_apis__["a" /* default */].serialdetail;
  if (newApi) {
    apiUrl = __WEBPACK_IMPORTED_MODULE_9__comm_api_apis__["a" /* default */].columndetail;
  }
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, apiUrl, { id: id, protocol: protocol, code: code }).then(function (body) {
    if (!retry) {
      commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["t" /* AJAX_LOADING */], { loadingStatus: false });
    }
    var courseInfo = body.data;
    commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["v" /* AJAX_GET_SERIALCOURSEINFO */], {
      courseInfo: courseInfo
    });
  });
};

var getCourseRecommends = function getCourseRecommends(_ref25, _ref26) {
  var commit = _ref25.commit;
  var courseid = _ref26.courseid,
      type = _ref26.type,
      subserial = _ref26.subserial,
      parentcourseid = _ref26.parentcourseid,
      pagesize = _ref26.pagesize;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_9__comm_api_apis__["a" /* default */].courseRecommend, { courseid: courseid, type: type, subserial: subserial, parentcourseid: parentcourseid, pagesize: pagesize }).then(function (body) {
    var rs = body.data;
    commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["w" /* AJAX_GET_COURSE_RECOMMEND */], {
      rs: rs
    });
  });
};

var locationProtocol = document.location.protocol === 'https:' ? 'https' : 'http';
var getTagsPage = function getTagsPage(_ref27, _ref28) {
  var commit = _ref27.commit;
  var labelid = _ref28.labelid,
      sourse = _ref28.sourse,
      _ref28$protocol = _ref28.protocol,
      protocol = _ref28$protocol === undefined ? locationProtocol : _ref28$protocol;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_9__comm_api_apis__["a" /* default */].tags, { labelid: labelid, sourse: sourse, protocol: protocol }).then(function (body) {
    var tagsInfo = body.data;
    return tagsInfo;
  });
};

var getTagsSubject = function getTagsSubject(_ref29, _ref30) {
  var commit = _ref29.commit;
  var labelid = _ref30.labelid,
      subjecttype = _ref30.subjecttype,
      pagesize = _ref30.pagesize,
      curpage = _ref30.curpage,
      _ref30$protocol = _ref30.protocol,
      protocol = _ref30$protocol === undefined ? locationProtocol : _ref30$protocol;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__comm_middleware_callApi__["a" /* getApi */])({ commit: commit }, __WEBPACK_IMPORTED_MODULE_9__comm_api_apis__["a" /* default */].tagsSubject, { labelid: labelid, subjecttype: subjecttype, pagesize: pagesize, curpage: curpage, protocol: protocol }).then(function (body) {
    var tagsSubjectInfo = body.data;
    return tagsSubjectInfo;
  });
};

var sendLog = function sendLog(_ref31, payload) {
  var state = _ref31.state;

  var initData = {
    name: '前端报错',
    protocol: document.location.protocol === 'https:' ? 'https' : 'http',
    info: '',
    time: Date.parse(new Date()),
    url: '',
    userType: state.userInfo && state.userInfo.token ? '用户端' : '专家端'
  };

  var msg = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, initData, payload);

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__comm_middleware_reportLog__["a" /* default */])(msg).then(function () {
    console.log('发送日志成功');
  })['catch'](function (e) {
    console.log('发送日志成功', e);
  });
};

/***/ }),

/***/ 901:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[540]);


// WEBPACK FOOTER //
// static/js/user.11ac034330b9067c8a02.js